const lang = {
    "WanJu": "Игрушки",
    "RiYongPing": "Потребительские товары",
    "NinHao": "Здравствуйте!",
    "ZhuCe": "Регистрация",
    "DengLu": "Войти",
    "TuiChu": "Выйти",
    "XinYongHuZhiYin": "Рекомендации для новых пользователей",
    "BangZhuZhongXin": "Центр помощи",
    "ShangPinFenLei": "Категории",
    "QuanBu": "Все",
    "SouSuo": "Поиск",
    "GouWuChe": "Корзина",
    "NinDe": "Мой",
    "ZhangHuZhongXin": "Аккаунт",
    "DaiChuLiDingDan": "Заказ в ожидании",
    "XuYaoQueRenCaiGou": "Необходимо утвердить заказ",
    "XuYaoZhiFuDingJin": "Необходимо провести оплату депозита",
    "XuYaoZhiFuHuoKuan": "Необходимо внести оплату",
    "XuYaoChuLiYiChang": "Необходимо исправить некоторые несоответствия",
    "BuHuoWeiWanCheng": "Дозаказ неокончен",
    "NinDangQianMeiYouDaiChuLiDeDanJu": "Нет необработанных заказов",
    "ShouYe": "Главная ",
    "YouHui": "Скидки и акции",
    "JiDan": "Предпродажи новинок",
    "PinPaiQu": "Бренды",
    "ZuiXinShangPin": "Рекомендации",
    "GengDuo": "Больше",
    "NTianChuHuo": "{0} дней до отгрузки",
    "ShengYu": "Осталось",
    "TianS": "дней",
    "XiaoShi": "часов",
    "Xiang": "кор.",
    "Kuan": "модель",
    "QingTianXieN": "Пожалуйста впишите  {0}",
    "QingXuanZeN": "Пожалуйста выберите {0}",
    "BuYunXuChaoGuoNGeZiFu": "Не может превышать {0} знаков",
    "NGeShiBuZhengQue": " Форматы неверные {0} шт.",
    "DaXiaoBuNengChaoGuoN": "Размер не может превышать {0}",
    "GeShiBuZhengQue": "Неверный формат",
    "XiaDanLiuCheng": "Процеcc размещения заказа",
    "ZhaoShangPin": "Поиск товара",
    "XianShangHeJia": "Корзина",
    "XianShangXiaDan": "Размещение заказа в режиме онлайн",
    "ZaiXianDingDanGenZongChuLi": "Отслеживание товара в режиме онлайн",
    "FaHuoFuKuan": "Логистика/склад",
    "SouSuoShangPin": "Набрать запрос в поисковике",
    "XuanZeYiXiangShangPin": "Выбрать нужный товар",
    "ChaZhaoXiangSiKuan": "Найти похожие артикулы",
    "JinXingDuiBi": "Сравнить, выбрать самый оптимальный вариант",
    "JiaRuGouWuCheZhong": "В корзину",
    "GouWuCheXuanZeShangPinTiJiaoHeJia": "Ознакомиться с автоматически просчитанными ценами",
    "ZaiShangPinChiChaKanHeJiaHouDeJieGuo": "Проработать артикулы",
    "ChuLiShangPinXinXiFanKui": "Ознакомиться с разницей в цене, если она имеется",
    "ZaiShangPinChiZuHePODan": "Создать РО в корзине",
    "SheZhiChuHuoShiJian": "Установить дату отгрузки",
    "SheZhiTieZhiHeMaiTou": "Настроить стикеры и маркировку",
    "QueDingDingDanXinXiJiYaoQiu": "Указать все требования по заказу",
    "TiJiaoPODan": "Отправить PO",
    "ZhiFuPODanDingJin": "Оплатить депозит по заказу",
    "ChaKanPODanShengChanJinDu": "Проверить производственный график PO",
    "ChanShengShangPinYiChangShi": "При возникновении вопросов в производстве войти в систему для их решения",
    "TiJiaoHeDuiChuanWuXinXi": "Проверить информацию об отгрузке",
    "ChaKanZhiJianTuPian": "Посмотреть фото проверки качества ",
    "ChaKanYuChuHuoQingDan": "Получить упаковочный лист",
    "JieShouChuHuoTongZhi": "Получить уведомление об отгрузке",
    "XiaZaiGeNeiDanZheng": "Скачать документы (упаковочный лист, квитанции, акты сверки)",
    "DengDaiShouHuo": "Ожидать приход товара",
    "ZhiFuPODanHuoKuan": "Оплатить заказ",
    "ShouHuoBingJianYanShangPin": "Получить товар и проверить качество",
    "RuHeZhuCe": "Эксклюзивные товары, эффективные цены",
    "YongYouYiGeEssaCnZhangHao": "Создать аккаунт essa.cn",
    "RuHeZhaoShangPin": "Как найти нужный товар?",
    "ShaiXuanXuYaoCaiGouDeShangPin": "Фильтр товаров",
    "RuHeTiJiaoDingDan": "Как отправить заказ?",
    "ZaiXianTiJiaoCaiGouDingDan": "Отправить заказ в режиме онлайн",
    "RuHeZhiFu": "Что такое план закупок?",
    "DingDanHuoKuanZhiFuJiJieSuan": "Оплата заказа и расчёты",
    "ZuiXinLaiFangYongHu": "Для новых клиентов",
    "AnFenLeiChaZhaoShangPin": "Искать товар  по группам",
    "SouSuoLiShi": "История поиска",
    "QueDing": "OK",
    "QuXiao": "Отмена",
    "ShangJiaShiJian": "По дате",
    "NTianNei": "в течение {0} дней",
    "YiYueNei": "в течении месяца",
    "BanNianNei": "в течении полугода",
    "NinZhengZaiLiuLan": "Вы просматриваете ",
    "ZhanKai": "Развернуть",
    "ShouQi": "Свернуть",
    "QingChu": "Удалить",
    "QingChuQuanBu": "Удалить всё",
    "DaTu": "Большая картинка",
    "LieBiao": "Список",
    "MoRen": "По умолчанию",
    "HuoQi": "Срок производства (дней)",
    "QiDingLiang": "Мин. заказ",
    "JiaGe": "Цена",
    "KuanKeXuan": "Можно выбрать {0} арт.",
    "XiangShiDe": "Похожие ",
    "XiangShiShangPin": "Похожие",
    "JiaRuShouCang": "В избранное",
    "YiShouCang": "Следовать",
    "ShouCangChengGong": "Ориентируйтесь на успех",
    "KeNengYouBanQuanJiuFen": "Может быть спор по авторским правам",
    "WeiZhaoDaoFuHeTiaoJianDeJiLu": "Соответствующие заданным параметрам записи не найдены",
    "SouSuoZhong": "Идёт поиск",
    "JiaGeJiBuFenXinPinXuYaoDengLuHouChaKan": "Чтобы посмотреть цены и новинки, необходимо войти в систему",
    "DengLuHouChaKanJiaGe": "Пожалуйста, войдите в систему, чтобы увидеть цены",
    "JiaGeJiBuFenXinPinXuYaoTiShengDengJiHouChaKan": "Цены и некоторые новые товары доступны только для пользователей с успешными сделками.",
    "XuYaoTiShengDengJiHouCaiNengChaKanJiaGe": "Для просмотра цен необходимо повысить уровень.",
    "SSShangPinJiaGeZhiYouVIPYongHuCaiNengChaKan": "Цены на бренды S+S, Decora видны только для Premium клиентов",
    "ShenMeShiVIPYongHu": "Что такое Premium клиент",
    "DengJiShuoMing": "Статус клиента",
    "HuoDongJieShuJinShengNTian": "До конца акции {0} дней",
    "ZhiChi": "поддерживать ",
    "ShuLiang": "Количество",
    "DanJia": "Цена",
    "ShangPinBianHao": "№ Арт.",
    "XuanZe": "Выбрать",
    "YiXuanZe": "Выбрано",
    "GongNKuan": "Всего {0} арт. ",
    "YiXuanZeNKuan": "Выбрано {0} арт.",
    "ZongJi": "Всего",
    "TiJi": "Объём",
    "MaoJingZhong": "Брутто / нетто",
    "JiaRuGouWuChe": "Добавить в корзину",
    "NKuanShangPinYiJiaRuGouWuChe": "{0} арт. добавлены в корзину",
    "YiJiaRuGouWuChe": "Перейти к корзине",
    "TianJiaChengGong": "Успешно добавлен",
    "ShangPinMiaoShu": "Описание товара",
    "GongYingShangXinXi": "Информация о поставщике",
    "ZhengShu": "сертификаты",
    "ChangJianWenTi": "Часто задаваемые вопросы",
    "JiaoYiShuoMing": "Описание процесса сделки",
    "JiBenXinXi": "Основная информация",
    "ZhuYingChanPin": "Основная продукция",
    "QiYeZhengShu": "Сертификаты",
    "HeZuoNianXian": "Годы сотрудничества ",
    "ShuJuPingGu": "Статистика",
    "JiYuQianNNianShuJu": "Данные в течение {0} лет",
    "FaHuoZhunShiLv": "Сроки доставки",
    "ZhiLiangTouSuLv": "Претензии по качеству товара",
    "XinYongZhiShu": "Степень доверия",
    "XinPinYanFaNengLi": "Разработка новых позиций",
    "MOQPingJunZhi": "Средние миним. кол-ва",
    "BaoJiaPingJunYongShi": "Среднее кол-во времени для расчёту прайса",
    "WenTiFanKuiPingJunYongShi": "Среднее кол-во времени на обратную связь по решению вопросов",
    "JieDanPingJunYongShi": "Среднее кол-во времени обработки заказа",
    "ShuJuPingGuJiSuanGuiZe": "Правила расчёта данных",
    "FaHuoZhunShiLvN": "Скорость отгрузки товара: 1- Кол-во задержанных отгрузок / Общее кол-во отгрузок",
    "ZhiLiangTouSuLvN": "Статистика претензий по качеству: 1-Кол-во притензий/ Общее кол-во отгрузок",
    "XinYongZhiShuN": "Индекс кредитов: 1-Кол-во отклонённых запросов / Общее кол-во запросов",
    "XinPinYanFaNengLiN": "Возможность разработки нового ассортимента: Новые позиции, разработанные в прошлом году",
    "MOQPingJunZhiN": "Средние MOQ:  Общее кол-во MOQ / Кол-во арт.",
    "BaoJiaPingJunYongShiN": "Время просчёта прайса: Общее время / Кол-во раз",
    "WenTiFanKuiPingJunYongShiN": "Среднее кол-во времени на ответы фабрик: Общее время / Общее кол-во ответов",
    "JieDanPingJunYongShiN": "Время обработки заказа: Общее время/ Кол-во закаов",
    "JinNNianChuHuoLiang": "Отгруженный товар за последние {0} лет",
    "ZhangHao": "аккаунт",
    "YongHuMingYouXiang2": "Логин/ электронная почта",
    "ZhangHaoBuCunZai": "Учетная запись не существует",
    "WangJiMiMa2": "Забыли пароль?",
    "MiMa": "Пароль",
    "ZhangHaoHuoMiMaCuoWu": "Неверное имя пользователя или пароль",
    "YongYouYiGeESSAZhangHao": "Пожалуйста используйте учётную запись ESSA",
    "KaiShi": "Начать",
    "HuanYing": "Добро пожаловать!",
    "MeiYouMaoYiGongSi": "Нет трейдинговой компании, есть только фабрики! Прозрачные цены, бесплатный сервис помощи квалифицированных клиент-менеджеров. Онлайн торговля - просто, высокоэффективно, безопасно.",
    "ZheLiShiDiYiBu": "Шаг первый",
    "ZhangHaoYuMiMa": "Имя пользователя и пароль",
    "DianZiYouXiangBiXuZhenShiYouXiao": "Email должен быть обязательно действующим, так как после регистрации на него будет отпарвлено письмо для подтверждения",
    "YouXiang": "э-почта",
    "SheZhiMiMa": "Создать Пароль",
    "ZaiCiShuRuMiMa": "Введите пароль еще раз",
    "LianXiXinXi": "Контактная информация",
    "JiaoYiBiZhong": "Валюта",
    "JianYiXuanZeRenMinBiZuoWeiJiaoYiJieSuanHuoBi": "Советуем Вам выбрать китайский юань, потому что цены в юанях менее подвержены колебаниям обменных курсов.",
    "GongSiMingCheng": "Компания",
    "GuoJiaDiQu": "Страна/Регион",
    "DaZhou": "Континент",
    "GuoJia": "Страна",
    "LianXiRen": "Имя",
    "GuoJiaDaiMa": "Код страны",
    "GuDingDianHua": "Стационарный телефон",
    "YiXiangCaiGouShangPin": "Интересующие товары",
    "QingXuanZe": "Пожалуйста, выберите",
    "XuanTian": "Рекомендуется к заполнению",
    "YiXiaXinXiWeiXuanTianXinXi": "Данная информация не является обязательной для заполнения, однако Ваш ответ поможет нам в улучшении предоставляемого Вам сервиса",
    "HeZuomoshi": "Способы сотрудничества",
    "XiaoShoufangshi": "Каналы сбыта ",
    "NianDuCaiGouLiang": "Объём закупок по игрушкам",
    "DanKuanCaiGouLiang": "Объём закупок по позициям",
    "MuBiaoShiChang": "Основной рынок",
    "LiJiZhuCe": "Зарегистрироваться сейчас",
    "DianZiYouXiangBuNengWeiKong": "Поле ввода email не может быть пустым",
    "QingTianXieZhengQueDeDianZiYouXiang": "Пожалуйста, укажите верный электронный адрес",
    "ZhangHaoYiCunZai": "Данное имя пользователя уже существует",
    "ZhiShao6GeZiFu": "Пароль должен быть не менее 6 символов, состоять из букв и цифр, содержать комбинацию заглавных и строчных букв",
    "QingZaiCiShuRuMiMa": "Пожалуйста, введите пароль ещё раз",
    "LiangCiMiMaBuYiZhi": "Пароль введён неверно два раза",
    "QingTianXieGongSiMingCheng": "Введите название компании",
    "GongSiYiCunZai": "Такая компания уже существует",
    "QingXuanZeGuoJiaDiQu": "Выберите Вашу страну",
    "QingTianXieGongSiGuHua": "Укажите номер телефона",
    "GuHuaBiXuWeiShuZi": "Телефон должен состоять из цифр",
    "GuHuaYiCunZai": "Такой номер уже существует, введите другой",
    "QingTianXieLianXiRen": "Пожалуйста укажите контактное лицо",
    "QingXuanZeZhuYaoCaiGouDeShangPinLeiXing": "Пожалуйста выберите основные группы товаров",
    "ZhiDuoXuanZeNXiang": "Выбрать более {0} стр.",
    "NinYiChengGongZhuCe": "Регистрация завершена!",
    "NinDeZhangHao": "Ваша учётная запись",
    "JiXu": "Продолжить",
    "XiangChaKanReXiaoHeCuXiaoShangPinDeJiaGe": "Хотите просматривать распродажи и акции? На Ваш email отправлено письмо, действуйте в соответствие с инструкциями, указанными в письме",
    "ChongXinFaSong": " отправить письмо ещё раз",
    "NMiaoHouChongXinFaSong": "Повторная отправка через {0} секунд.",
    "XuanZeYiWeiZhuanShuKeHuJingLiWeiNinFuWu": "Выберите персонального менеджера для обслуживания.",
    "NinZaiTiaoXuanShangPinDingDanChuLiYuDaoWenTiShi": "Если у Вас возникнут какие-либо вопросы, пожалуйста, обратитесь к Вашему клиент-менеджеру, он поможет решить любую проблему. Услуга предоставляется бесплатно.",
    "ChaKanQuanBuKeHuJingLi": "Просмотреть всех консультантов по продажам.",
    "JingYan": "Опыт",
    "KeYongNJiaoLiu": "Можно использовать {0} видов коммуникаций",
    "ShuXiNHangYe": "Знаком с отраслью {0}.",
    "QueDingXuanZeGaiKeHuJingLi": "Вы подтверждаете выбор данного консультанта?",
    "QingXianQianWangNinDeDianZiYouXiangChaShouYouJian": "На Ваш email было отправлено письмо. Пожалуйста проверьте почту, и завершите процесс в соответствие с инструкциями, прописанными в письме.  После этого наш клиент-менеджер свяжется с Вами",
    "WoMenDeGongZuoRenYuanJiangZai1GeGongZuoRi": "Наши сотрудники свяжутся с вами в течение одного рабочего дня, чтобы помочь завершить проверку. После подтверждения вы сможете просматривать цены и оформлять заказы.",
    "YouXiangYanZheng": "Подтверждение электронной почты",
    "YiTongGuoYanZheng": "Подтверждено",
    "QuanBuKeHuJingLi": "Все клиент-менеджеры",
    "XingMing": "Имя",
    "WeiZhaoDaoFuHeTiaoJianDeKeHuJingLi": "Клиент-менеджер, соответствующий заданный параметрам, не был найден",
    "ZhaoHuiMiMa": "Восстановить пароль",
    "YanZhengMa": "Код подтверждения",
    "HuanYiZhang": "Поменять",
    "TiJiao": "Отправить",
    "YiFengZhongSheMiMaDeYouJianHuiFaWangNin": "Письмо об изменении пароля было отправлено на Ваш email. Для настройки нового пароля пройдите по ссылке, указанной в письме",
    "ChongSheMiMa": "Восстановление пароля",
    "XinMiMa": "Новый пароль",
    "TiJiaoChengGong": "Отправка завершена",
    "MiMaChongSheChengGong": "Пароль успешно изменен",
    "XiTongWeiHuZhong": "На сайте проводятся тех. работы, пожалуйста повторите запрос чуть позже ",
    "WeiHuShiJian": "Время тех. работ",
    "XiTongWeiHuQiJian": "Если у Вас возникнут вопросы в период проведения технических работ в системе, пожалуйста, свяжитесь: {0}",
    "ZhiKanQiTaGongYingShang": "Смотреть только других поставщиков",
    "DuiBi": "Сравнить",
    "ShangPinDuiBi": "Сравнение товаров",
    "GaoLiangXianShiBuTongXiang": "Выделить различающиеся элементы.",
    "YinCangXiangTongXiang": "Скрыть одинаковые параметры",
    "ShangPinMingChen": "Название",
    "ReMenPinPai": "Популярные торговые марки",
    "PinPaiLieBiao": "Список брендов",
    "GengDuoPinPai": "Больше брендов",
    "QuanBuPinPai": "Все бренды",
    "DaoChu": "Выгрузить заказ в excel",
    "HaiChaNXiang": "Не хватает {0} кор.",
    "YiManZuCaiGouTiaoJian": "Соответствует требованиям",
    "LiJiCaiGou": "Заказать",
    "JiJiangZhunBeiShengChan": "Заказ в скором времени будет направлен на производство, после утверждения нельзя ничего менять",
    "YuJiDaoHuoRiQi": "Ожидаемая дата прибытия.",
    "CaiGou": "Купить",
    "ShangPinChi": "План закупок.",
    "NingDePODan": "Ваш PO",
    "NinHaiMeiYouTiJiaoRenHePODan": "Вы ещё не отправили PO",
    "PinGui": "Совместная загрузка контейнера.",
    "HaiMeiYouKeYiYongYuPinGuiDeShangPin": "Пока нет товаров для совместной загрузки контейнера.",
    "ZiChan": "Финансы",
    "ZiJinGuanLi": "Платежный аккаунт",
    "HuiKuanMingXi": "Сведения об оплатах",
    "HaiWeiShouDaoNinDeHuiKuan": "Ваша оплата ещё не получена",
    "QianKuanMingXi": "Сведения о задолженности",
    "NinMeiYouWeiZhiFuDeQianKuan": "У Вас нет задолжности по оплате",
    "ShouXinGuanLi": "Управление кредитами",
    "NingDeDuiZhangDan": "Ваши акты сверки",
    "HaiMeiYouDuiZhangShuJu": "Еще нет сверки данных",
    "GuanLi": "Управление",
    "JiaoYiSheZhi": "Настройка процесса",
    "MaiTouHeTieZhi": "Стикеры и маркировка",
    "HaiMeiYouTiJiaoMaiTouYangBan": "Маркировка ещё не отправлена",
    "HaiMeiYouTiJiaoTieZhiYangBan": "Стикеры ещё не отправлены",
    "DingDanYaoQiu": "Требования по заказу",
    "ShangPinFuWu": "Услуги по товару",
    "ZhunShuShangPin": "Эксклюзив",
    "DaiLiShangPin": "Товары для дистрибуции",
    "ShouCangJia": "Избранное",
    "ShouCangDeShangPin": "Избранные товары ",
    "ShouCangDePinPai": "Избранные бренды",
    "QiTa": "Другие",
    "TuiJianShangPin": "Рекомендации",
    "HaiMeiYouTuiJianDeShangPin": "Пока нет рекомендуемых товаров",
    "LiuLanLiShi": "История",
    "NinZuiJinWeiChaKanGuoRenHeShangPin": "За последнее время Вы не просматривали никакие товары",
    "LiuLan": "Просмотр",
    "NinGouWuCheZhongDiShangPin": "Товары в корзине",
    "NinGouWuCheZhongHaiMeiYouShangPin": "В корзине нет товаров",
    "DaoRu": "Импорт",
    "XianXiaZaiMuBan": "Сначала скачайте шаблон, заполните его, затем загрузите",
    "XlsXlsxGeShi": "Файлы xls, xlsx не могут превышать 10 MB",
    "ShangChuan": "Добавить",
    "ShangChuanZhong": "Загружается",
    "XiaZaiMuBan": "Скачать шаблон",
    "ChengGongDaoRuNKuanShangPin": "Импортировано {0} арт.",
    "XiTongCuoWu": "Ошибка в системе, пожалуйста попробуйте ещё раз",
    "ChengGongTiJiaoNKuanShangPin": "Успешно выгружено {0} позиций",
    "NinHaiWeiTongGuoRenZheng": "Вы ещё не являетесь активированным пользователем, поэтому не можете просматривать цены на сайте",
    "TianJiaShiJian": "Время добавления",
    "XiaYiBuShiShenMe": "Что далее?",
    "GongYingShang": "Поставщик",
    "QuYu": "Место",
    "QuanBuQuYu": "Все регионы",
    "QuanBuFenLei": "Все категории",
    "QuanBuBaoZhuang": "Все виды упаковок",
    "QuanBuZhuangTai": "Статус",
    "QuanBuShiJian": "Всё время",
    "ShangPinBianHaoHuoMingCheng": "Наименование товара или арт.",
    "FanHui": "возвращаться",
    "QiSongLiang": "Минимальное количество для поставки/кор.",
    "GongYingShangYaoQiuDaDaoCiDingGouLiang": "Только достигнув требований по MOQ, данный поставщик может отправить товар",
    "QuanBuXuan": "Всё не выбирать ",
    "QuanXuan": "Всё",
    "ShanChu": "Удалить",
    "QueDingShanChuGaiShangPin": "Удалить данный товар?",
    "ShanChuChengGong": "Успешно удалено ",
    "NKuanShangPinYiShanChu": "Удалено  {0} арт.",
    "TiWen": "Задать вопрос ",
    "DengNGeWenTi": "{0} вопросов в ожидании",
    "ChengGongTiJiaoLeNGeWenTi": "Успешно отправлено {0} вопросов",
    "DangQianShuLiangXiaoYuMOQ": "На данный момент кол-ва меньше чем MOQ, мы попробуем договориться с поставщиком, но не гарантируем, что получится ",
    "YiRuShouCang": "Избранное",
    "QueDingJiangGaiShangPinYiRuShouCangJia": "Подтверждаете перемещение  в избранное?",
    "DingGouLiang": "заказ",
    "GaiJiaGeWeiBaoKuoDanJiaXianShiWei": "Эта цена не включает товары, которые находятся на этапе проверки стоимости.",
    "TiJiaoHouWoMenJiangDuiZheXieShangPin": "После отправки нам понадобится  примерно 2 дня для утверждения цен на каждый арт, с поставщиками (на большие кол-ва арт. времени понадобится больше). Вы можете проверить сдвиг процесса в накопителе подтверждённых арт.",
    "ZanWuShangPin": "Нет товара",
    "HaiMeiYouDingDan": "Ещё нет заказа",
    "JiaGeBaoHuQiShengYuNTian": "Цены действительны в течение {0} дней",
    "QiTaWenTi": "Другой вопрос",
    "JiangZheXieWenTiYingYong": "Добавить эти вопросы ко всем выбранным",
    "XuanZeMuBan": "Сначала выберите шаблон",
    "ZanWeiHuiFu": "Нет ответа",
    "NinShangPinChiZhongDiShangPin": "Товары в Накопителе подтвердённых арт.",
    "HaiMeiYouShangPinNinKeYiCong": "Пока нет товаров. Вы можете добавить их из корзины",
    "ZhiKanGeXingHuaBianGengDeShangPin": "Смотреть только товары, которые можно изменить индивидуально под клиента",
    "GeXingHuaBianGengDeShangPin": "Индивидуальные разработки клиентов",
    "ChuLiHeJiaHouYouBianHuaDeShangPin": "Товары, изменившиеся в цене после просчёта",
    "QuPinGui": "Сформировать контейнер",
    "HeJiaZhong": "Просчёт цены",
    "HeJiaWanCheng": "Просчёт цены завершён",
    "HeJiaHouQueRenWuWuDeShangPin": "После утверждения цен товар можно отправить в РО для формирования контейнера. Внимание: товары, находящиеся на просчёте цен, либо не утверждённые после изменения цен, не могут быть переданы для формирования контейнера",
    "YiChangLeiXing": "Необычные категории",
    "XuYaoChuLiWanXiaLieShangPinHouCaiNengJiXu": "Нужно разобраться с данными товарами, только после этого можно продолжить",
    "NinCanYuJiDanDeXiaLieShangPin": "Условия заказов нижеперечисленных товаров, которые были в предпродаже новинок, достигнуты, пожалуйста, утвердите покупку и товар будет запущен в производство.",
    "QingZhuYiQueRenCaiGouZhiHou": "Внимание: после утверждения заказа товар размещается в производство, и нельзя будет внести никакие измения",
    "QueRenCaiGou": "Подтвердить заказ ",
    "QuXiaoCaiGou": "Отменить закупку",
    "BuNengShaoYuNXiang": "Не может быть менее {0} коробов",
    "YiJingKeYiAnPaiShengChan": "Товар может уже размещаться. Подтвердить отмену?",
    "HuoDongYiGuoQi": "Акция завершена",
    "JieShou": "Принять",
    "XiaCiCaiGou": "Закупить только полное количество",
    "YuanJiaGe": "Старая цена",
    "XinJiaGe": "Новая цена",
    "YuanHuoQi": "Старые сроки производства",
    "XinHuoQi": "Новые сроки производства",
    "YuanYuZhuangGuiRiQi": "Предварительная дата отгрузки",
    "XinYuZhuangGuiRiQi": "Новая дата отгрузки ",
    "YuanMOQ": "Старые MOQ",
    "XinMOQ": "Новые MOQ",
    "WeiNinTuiJianYiXiaXiangSiDeShangPin": "Похожие товары",
    "KeXiaDanDeShangPin": "Товары, возможные для заказа ",
    "ZhiKanWeiHuoShangPin": "Остаток товара",
    "ZhiKanJiDanShangPin": "Просмотреть только новинки предпродаж",
    "KeXiaDanDeJiDanShangPin": "По товарам, которые участвовали в предпродаже новинок, уже доступны для заказа",
    "KeXiaDanDeWeiHuoShangPin": "Остатки, возможные для заказа",
    "WeiHuo": "Остатки товаров",
    "NinDeZhangHaoYouQiTaRenZhengZaiCaoZuo": "В Вашу учётную запись вошли с другого компьютера",
    "ShuaXin": "Обновить",
    "YuFuWuQiLianJieShiBai": "Соединение с сервером неудалось",
    "QingNTianNeiChuHuo": "Пожалуйста отгрузите товар в течение {0} дней",
    "WeiShenMeYaoXianQiQueRenLinShiPO": "Почему нужно отправить РО в ограниченные сроки?",
    "ZheShiYinWei": "Потому что ",
    "NinKeXiaDanDeShangPinZhongRuGuoCunZai": "Во время заказа могут возникнуть следующие вопросы:",
    "RuKuManNTianDeWeiHuo": "Остаток товара, который находится на складе {0} и более дней",
    "JiDanChengGongManNTianDeShangPin": "Товары из предпродаж новинок, которые были успешно завершены в течение {0} дней.",
    "ZheXieShangPinDeJiYa": "Данные товары перегружают наши склады, пожалуйста, отправьте РО в течение {0}.",
    "XianChuHuoGui": "Контейнеры кот. нужно сфор-ть в первую очередь  ",
    "QiTaHuoGui": "Другие контейнеры",
    "ShenMeShiXianChuHuoGui": "Что такое первоочерёдный контейнер к отпарвке?",
    "WeiZaiYueDingShiJianNeiTiJiaoPODeWeiHuo": "Если заказ по остаточному товару был передан в работу не вовремя, позиции, по которым условия предпродаж были достигнуты, мы сможем сконсолидировать в один контейнер. В следующий раз, когда Вы будете передавать заказ в работу, сначала оформите остаточный товар, для того, чтобы не копить его на складе и не увеличивать себестоимость складского хранения.",
    "BiXuXianAnPaiCiHuoGuiQueRenLinShiPO": "Вам необходимо сначала отправить РО данного контейнера, только после этого Вы сможете оформить другие PO.",
    "WeiShenMe": "Почему? ",
    "DangNinDeHuoYuanShangPinZhongCunZaiYiXiaLeiBieShangPinShi": "Среди доступных для заказа товаров имеются следующие:",
    "WeiJianQingESSADeKuCunYaLi": "Во избежание перенасыщения складов система будет автоматически формировать контейнеры. Товары не могут удаляться автоматически, только после Вашей заявки мы можем удалить арт.",
    "QingFangXin": "Вы можете быть уверены, что этот контейнер ничем не отличается от других, но ограничивает товары в соответствие с указанными выше условиями",
    "HuoGuiBuManShi": "Контейнер заполнен не до конца. Вы можете продолжить добавлять артикулы в контейнер",
    "ShenQingYanQi": "Заявка на отсрочку",
    "WoMenShenHeTongGuoZhiHou": "Этот контейнер будет отправлен после того, как мы произведём проверку",
    "JiHuaChuHuoRiQi": "План отгрузки",
    "YanQiYuanYin": "Причина отсрочки",
    "ChengGongTiJiaoYanQiShenQing": "Заявка на отсрочку отправлена",
    "YanQiShenQingChuLiZhong": "Заявка на рассрочку в процессе рассмотрения",
    "TianJia": "Добавить",
    "YiChu": "Перенести обратно в корзину",
    "TianJiaHouShengYuShuLiangShaoYuMOQ": "После добавления остаток - меньше чем Мин.заказ ({0} коробов), возможно повторно нельзя будет заказать этот артикул. Подтвердить добавление?",
    "TianJiaHouGaiGongYingShangShengYuShuLiang": "После добавления у поставщика на остатке меньше  чем Мин.заказ ({0} коробов), возможно ещё раз нельзя будет заказать этот арт. Подтвердить добавление?",
    "HuoGuiNZhongDiShangPin": "№ {0} Товары в контейнере",
    "ChaoChuHuoGuiKeZhuangTiJi": "Превышает объем контейнера ",
    "SuoXuanZeDeHuoGuiTiJiTaiXiao": "Объём выбранных контейнеров слишком мал",
    "YuJiZhuangGuiRiQi": "План. дата отгрузки ",
    "YiXiangZhuangGuiRiQi": "Желаемая дата отгрузки ",
    "YuJiShouHuoRiQi": "План. дата получения заказа",
    "ShouHuoRiQi": "Дата получения товара",
    "ZhuangGuiRiQi": "Дата отгрузки контейнера",
    "ZhuangGuiWanChengRiQi": "Дата  завершения отгрузки контейнера",
    "YuJiDaoGangRiQi": "План. дата прихода в порт",
    "DaoGangRiQi": "Дата прихода в порт",
    "DuanTuYunFei": "Доп. логистика",
    "YinShangPinChanDiYuChuHuoQuYuBuYiZhi": "Так как место изготовления товара и отгрузка находятся в разных местах,расходы на транспортировку будут добавлены в закупочную стоимость",
    "NinZaiGaiGongYingShangDeDingGouLiang": "Заказанные Вами позиции по количеству меньше, чем Мин.заказ, невозможно сделать заказ",
    "BuFenGongYingShangDeDingGouLiangWei": "Часть заказанных Вами позиций по количеству меньше, чем Мин.заказ поставщика, невозможно сделать заказ",
    "ManJianDiKou": "Сумма для вычета ",
    "SheZhiMaiTouHeTieZhi": "Установить стикеры и маркировку",
    "BaoCunQuanBuHuoGui": "Сохранить все контейнеры",
    "GaiRiQiZaoYuZhengChangJiaoHuoRiQi": "Эта дата, раньше фиксир. даты поставки, возможно не будет исполнено.",
    "YinBuFenShangPinChuHuoQuYuTiaoZheng": "Некоторые позиции в заказе производятся в другой местности, соответственно расходы на транспортировку будут включены в прайс",
    "ESSAShangPinTiaoMa": "Штрихкод ESSA",
    "TieZhiYangBan": "Шаблон стикеров",
    "MaiTouYangBan": "Шаблон маркировки",
    "TieZhi": "Стикера",
    "MaiTou": "Маркировка",
    "ShiYongShuoMing": "Инструкция по использованию",
    "TiJiaoDingDanZhiQian": "Перед отправкой заказа предоставьте пожалуйста стикеры и маркировку",
    "MeiKuanShangPinKeYiShiYongYiZhongMaiTou": "1. Одному артикулу может соответствовать один вид маркировки и несколько видов стикеров; нажмите \"+\"чтобы добавить нужные стикеры или маркировку",
    "KeYiZaiXianBianJi": "Можно настроить в системе. Впишите информацию по маркировке и стикерам в соответствующие ячейки",
    "ShangPinBuXuYaoShiYongDeTieZhiHuoMaiTou": "Поставьте знак “-” в ячейках, которые соответствуют товарам без маркировки и стикеров. Если все товары без маркировки и стикеров, проставьте знак “-” в каждой ячейке соответственно, затем удалите их",
    "RuoZaiXianBianJiBuFangBianShi": "Если возникли какие-либо неудобства, то скачайте шаблон, заполните информацию по маркировке и стикерам и загрузите снова",
    "GaiMaiTouYiCunZai": "Маркировка уже имеестя",
    "GaiTieZhiYiCunZai": "Стикеры уже имеются",
    "BuFenShangPinYiSheZhiNeiRong": "Часть товара уже настраивается, невозможно удалить",
    "TieZhiPaiBanTu": "Фото верстки стикеров",
    "YiBaoCun": "Сохранено",
    "FuZhi": "Скопировать",
    "ZhanTie": "Вставить",
    "QingShuRu": "Пожалуйста, введите",
    "ShangChuanShiBai": "Скачивание неудалось, попробуйте ещё раз",
    "XiaZai": "Скачать",
    "BaoCunBingFanHui": "Сохранить и вернуться",
    "QingZaiCiQueRen": "Пожалуйста, подтвердите ещё раз",
    "BuHuoShangPinDeMaiTouHeTieZhiXinXiWuWu": "Стикеры и маркировки для дозаказа без ошибок? После утверждения заказ отправляется в производство",
    "NKuanShangPinYiBuHuoChengGong": "Дозаказ {0} арт. завершён",
    "NinBenCiBianJiDeMaiTouHeTieZhiXinXi": "Редактирование маркировки и стикеров не удалось сохранить",
    "QueDingQuXiao": "Подтвердить отмену?",
    "JiJiangShengChengPODan": "Создать РО",
    "XiaDanRen": "Клиент",
    "HuoGuiLeiXing": "Тип конт-ра",
    "XiaShuiGang": "Порт отгрузки",
    "ChuHuoCang": "Склад отгрузки",
    "KuanShu": "Кол-во позиций",
    "TeShuYaoQiu": "Особые условия",
    "JieSuanFangShi": "Способы оплаты",
    "YingFuDingJin": "Депозит к оплате",
    "TiJiaoPO": "Отправить PO",
    "YiXiaXinXiZhongYao": "Важная информация",
    "QingHeDuiMaiTouHeTieZhiXinXiHouZaiTiJiaoPO": "Пожалуйста, проверьте маркировку и стикеры перед отправкой PO, так как заказ будет произведён в соответствие с предоставленным содержанием",
    "ZhuYiTianXieNBiaoShi": "Важно! Символ \"-\" означает, что для данного товара не нужна маркировка и стикеры",
    "XiuGai": "Изменить",
    "BuNengWeiKong": "Не может быть пустым",
    "RuDuiDingDanYouEWaiYaoQiu": "Пожалуйста укажите дополнительные требования к контейнеру, если таковые имеются",
    "HuoGuiBuMan": "Контейнер заполнен не до конца, продолжите формирование",
    "ShenQingTiJiao": "Заявка отправлена.",
    "ShenQingLiYou": "Основания заявления",
    "ShenQingYiTiJiao": "Заявление отправлено",
    "GaiHuoGuiTiJiaoPODeShenQingZhengZaiChuLiZhong": "Отправка PO в процессе, временно невозможно ничего выполнить",
    "ZhuYiShangPinDeMaiTouHeTieZhi": "Пожалуйста, проверьте содержание маркировки и стикеров!",
    "QueDingTiJiaoPO": "Подтвердить отправку PO?",
    "ChengGongTiJiaoPO": "PO успешно отправлено",
    "QiTaShuoMing": "Имеет ли право компания ESSA принять решение о перекомплектации товара в контейнере",
    "ShouQuanESSADiaoHuo": "Я согласен(на)",
    "DangHuoWuShengChanGuoChengZhong": "После оформления заказа, товар запускается в процесс производства, в ходе которого могут возникнуть ситуации, когда готовность некоторых позиций происходит с задержками, поэтому, во избежание отсрочки отгрузки основного количества товара, имеет ли право компания ESSA, исходя из данных о ходе производства всех позиций, самостоятельно перекомплектовать товар? Пожалуйста, известите нас об этом.  (Необходимость в перекомплектации возникает в случае, когда из-за некоторых товаров может произойти отсрочка времени отгрузки всего контейнера, ESSA поможет Вам перекомплектовать товары из другого контейнера, гарантируя его выпуск в установленные сроки).",
    "XianJin": "Наличные деньги",
    "HuoKuan": "Сумма за товар.",
    "FuWuFei": "Комиссия за услуги",
    "TieZhiFei": "Стоимость стикеров",
    "XiuGaiMingCheng": "Изменить название",
    "XiuGaiChengGong": "Изменения завершены",
    "MingCheng": "Название",
    "GuiGe": "Стандарты",
    "QueRenShiYong": "Подтвердить использование",
    "TuiHuiXiuGai": "Отменить изменения",
    "TianXieXiuGaiYiJian": "Впишите изменения",
    "YiTuiHui": "Отменено",
    "QueDingShanChuGaiTieZhi": "Подтвердить удаление стикеров?",
    "QueDingShanChuGaiMaiTou": "Подтвердить удаление маркировки?",
    "ChiCun": "Размер",
    "YanSe": "Цвет",
    "WenDangTuPianTuZhi": "Файлы / Фото / Drawings",
    "YiTiJiaoZhiZuoShenQing": "Заявление уже отправлено",
    "TiJiaoHouWoMenHuiJinXingZhiZuo": "Мы обработаем информацию, затем можно будет проверить список. После утверждения эти маркировки и стикеры будут использованы в заказе ",
    "DingDanZhuangTai": "Статус запроса",
    "ZhiFuDingJinHouWoMenHuiKaiShiAnPaiShengChan": "Мы отправим заказ в производство сразу после получения депозита. Обращаем Ваше внимание: предварительная дата загрузки напрямую зависит от времени получения депозита",
    "ZhunBeiShengChanXiangGuanDeAnPaiShiYi": "Вопросы, касающиеся запуска производства",
    "JinXingShengChan": "Товар запущен в производство. Если по каким-либо причинам срок производства изменится, мы сразу же сообщим Вам об этом",
    "DuiShengChanWanChengDeShangPinJinXingZhiJian": "Контроль качества произведённых товаров",
    "JiangShengChanWanChengDeShangPinShouRu": "Произведённые товары находятся на складе компании ESSA",
    "JiangShangPinJinXingZhuangGui": "Товар идёт в контейнер",
    "WanChengZhuangGui": "Загрузка контейнера завершена. В настоящее время можно скачать упаковочный лист и инвойс",
    "WanChengBaoGuanShiYi": "Прохождение таможни завершено",
    "HuoGuiYiKaiShiYunShu": "Контейнер находится в пути. Пожалуйста, вовремя произведите оплату",
    "BenCiJiaoYiWanCheng": "Данная сделка завершена",
    "ZhiKanZuiJinYiZhou": "Смотреть за последнюю неделю",
    "ZhiKanZuiJinYiYue": "Смотреть за последний месяц",
    "ZhiKanYiYueYiQian": "Смотреть за прошлый месяц",
    "NinZuiJinYiZhouDePODan": "Ваши PO за эту неделю",
    "NinZuiJinYiYueDePODan": "Ваши PO за этот месяц",
    "NinYiYueQianDePODan": "Ваши РО за прошлый месяц",
    "ChaKanXiangXi": "Просмотреть детально",
    "DingDanGenZong": "Отслеживание заказа",
    "ShangPinShengChanZhongChuXianYiChang": "Во время производства товара возникли некоторые вопросы, пожалуйста решите их как можно быстрее",
    "NinYiTiJiaoBuHuo": "Ваш дозаказ был отпарвлен, компания ESSA им занимается. Сейчас Вы можете {0} предосавить маркировку и стикеры {1}",
    "BuHuoShangPinYiHeJiaWanCheng": "Чтобы как можно скорее отправить на завод для производства, пожалуйста, своевременно подтвердите информацию о наклейках и отгрузочных отметках о пополнении запасов. {0} маркировку и стикеры  {1}",
    "DingDanShuLiang": "Количество заказов",
    "QingZaiNTianNeiZhiFuDingJin": "Пожалуйста, как можно скорее оплатите депозит, так как ориентировочная дата загрузки зависит от фактической даты получения суммы",
    "QingJinKuaiZhiFuDingJin": "Пожалуйста, как можно скорее оплатите депозит. Время получения депозита влияет на дату отгрузки товара",
    "BianGengJieSuanFangShi": "Изменить способ оплаты",
    "DangQianJieSuanFangShiWei": "Текущий способ оплаты",
    "BianGengJieSuanFangShiWei": "Поменять способ оплаты на ",
    "NinPODanZhongDiShangPin": "Товары в Вашем PO",
    "ZhiJianTuPian": "Фотографии контроля качества",
    "ZhuangXiangDan": "Упаковочный лист",
    "ZhuangXiangTuPian": "Фотографии погрузки",
    "YiZhuangXiangDeShangPinQingDan": "Предварительный упаковочный лист",
    "XiaZaiDanZheng": "Скачать документы",
    "XiaZaiShangPinTuPian": "Скачать фото товара",
    "XiangShu": "Кол-во кор.",
    "NeiHeShu": "Минибокс",
    "WaiXiangZhuangLiang": "Шт. /кор.",
    "ZhuangLiang": "Кол-во в кор.",
    "ZongGeShu": "Kол-во（шт.)",
    "ZongMaoZhong": "Вес брутто",
    "ZongJingZhong": "Вес нетто",
    "ZongTiJi": "Общий объём",
    "WaiXiangChiCun": "Размер упаковки (длина х ширина х высота)",
    "FaPiao": "Инвойс",
    "HuoHao": "Артикул.",
    "TiaoXingMa": "штрихкод",
    "ChengJiaoJia": "Сделочная цена",
    "XiaoJi": "Итого",
    "HeJi": "Итого",
    "FaPiaoJinE": "Сумма инвойса",
    "YongLiang": "Объем использования",
    "FuWuFeiLv": "Ставка за обслуживание.",
    "JieSuanDan": "Расчеты",
    "BenDanFeiYongMingXi": "Подробности расходов по данному заказу",
    "FeiYongXiang": "Наименование затрат",
    "HaiYunFei": "Морской фрахт",
    "DaiFuFOBFei": "Оплата FOB",
    "BiZhong": "Валюта",
    "YingFuJinE": "Сумма к оплате",
    "YiZhiFu": "Оплачено",
    "HaiXuZhiFu": "К оплате",
    "LiShiFeiYongMingXi": "История расходов",
    "JinE": "Сумма",
    "JieZhiN": "Крайний срок: {0}",
    "JieZhiXNinHaiXuZhiFu": "Крайний срок: {0}, Вы должны оплатить",
    "FeiYongHeJi": "Общая стоимость",
    "QiTaDanZheng": "Другие документы",
    "ShangPinChuXianYiChang": "Есть вопросы по некоторым позициям,пожалуйста вовремя решите их",
    "YiXiaShangPinYingXiangShengChanHuoChuHuo": "Эти позиции влияют на производство и отгрузку товара, пожалуйста решите вопросы вовремя",
    "ZhiJianBuHeGe": "Проверка качества не соответствует требованиям",
    "ShangPinGuiGeBianHua": "Изменение размера товара",
    "AnMOQCaiGou": "Купить согласно MOQ",
    "CheXiao": "Отменить",
    "YiJieShou": "Принято",
    "YiShanChu": "Удалено",
    "AnYuanYuZhuangGuiRiQi": "К предварительной дате отгрузки {0} будет готово только {1} коробов",
    "AnYuanDingGouLiangNXiang": "Согласно заказанному кол-ву {0} кор., предварительная дата загрузки контейнера переносится на {1}",
    "YiRuQiTaPODan": "Перейти в другие РО",
    "XuanZePODan": "Выбрать РО",
    "YouESSAGenJuShiJiShengChanQingKuangDiaoPei": "Позволить ESSA разобраться с возникшим вопросом в производстве",
    "BaoCun": "сохранять",
    "BuManGui": "Контейнер неполный, можно сделать дозаказ",
    "DiaoRuShangPin": "переместить арт. из",
    "XuanZeXuYaoDiaoRuShangPinDePODan": "Выберите требующие перераспределения PO.Мы проверим фактическую стадию производства и уведомим Вас",
    "TiaoRu": "Перенести",
    "CongNGePOZhongXuanZeShangPinDiaoRu": "Выбрать товары для дозаказа из РО {0}",
    "YunXuDiaoRuBiYuZhuangGuiRiQiWan": "Разрешаю перенести товары, изготовление которых позднее на {0} дней, чем предварительная дата загрузки",
    "NinYiShenQingCongQiTaPODanDiaoRuShangPin": "Вы уже сделали запрос на добавление товаров из других РО, мы работаем над этим",
    "BuHuo": "Дозаказ",
    "QuanBuLaiYuan": "Источники добавления",
    "YiXuanZeNKuanShangPin": "Уже выбрано {0} арт.",
    "NKuanShangPinTiJiaoZhiHou": "После отпарвки {0} арт. в ближайшее время мы утвердим цены с поставщиком",
    "FuHeYuZhuangGuiRiQiDe": "Соответствует предварительной дате отгрузки",
    "XiuGaiMiMa": "Изменить пароль",
    "FaSongYanZhengYouJian": "Запросить письмо для подтверждения",
    "NinZaiXiuGaiMiMaQianXuYaoYanZhengZhangHao": "Для того, чтобы поменять пароль, войдите в Вашу учётную запись. Нажмите  кнопку \"Отправить письмо\". Проверьте почту и действуйте в соответствие с содержанием письма",
    "YouJianYiFaSong": "Письмо отправлено",
    "YuanMiMa": "Старый пароль",
    "MiMaXiuGaiChengGong": "Пароль успешно изменен",
    "XiuGaiYouXiang": "Изменить email",
    "NinZaiXiuGaiYouXiangQianXuYaoYanZheng": "пройти проверку убедиться что это вы",
    "YuanYouXiang": "Старый email",
    "XinDeYouXiang": "Новый email",
    "XinDeYouXiangXuYaoTongGuoJiHuo": "На Ваш email было отпарвлено письмо, активируйте новый email в соответствие с инструкцией, указанной в письме",
    "YouXiangXiuGaiChengGong": "Email успешно изменён",
    "GongSiXinXi": "Информация о компании",
    "BuFenShuYuGuanJianXinXi": "Основная информация",
    "WeiBaoZhangNinDeXinXiZhengQueXing": "Чтобы убедиться в правильности указанной информации, проверьте её, пожалуйста, после внесения изменений",
    "GuanJianXinXiXiangZaiNinTiJiaoBianGengShi": "При изменении основной информации мы сообщим Вам об этом",
    "NinBianGengLeGuanJianXinXi": "Вы изменили основную информацию",
    "GuanJianXinXi": "Основная информация",
    "GuanJianXinXiBianGengShi": "Внесённые изменения вступают в силу после нашего утверждения",
    "GongSiWangZhi": "Сайт компании",
    "GongSiLOGO": "Логотип компании",
    "JingYingXinXi": "Информация о предпринимательской деятельности",
    "ZhuYingChanPinFenLei": "Основные виды товаров",
    "JieSuanYaoQiu": "Требования к расчётам",
    "JiaoYiHuoBi": "Валюта расчётов",
    "NinXuYaoShiYongXinHuoBiLaiJieSuan": "Если Вам нужен расчёт в новой валюте, пожалуйста свяжитесь с Вашим клиент-менеджером и сообщите ему об этом",
    "NinYiTiJiaoShenQing": "Ваша заявка успешно отправлена, в ближайшие время сотрудники компании ESSA её обработают ",
    "BaoCunChengGong": "Успешно сохранено",
    "ZhengShuYaoQiu": "Требования к сертификатам",
    "QiYeZhengShuYaoQiu": "Требования к сертификатам о предпринимательской деятельности",
    "ChanPinZhengShuYaoQiu": "Требования к сертификатам на продукцию",
    "QiTaYaoQiu": "Другие требования",
    "ShiYiTu": "Схематический рисунок",
    "ZhangHaoXinXi": "Мои данные",
    "YongHuMing": "Логин или почта",
    "ZhiWu": "должность",
    "JiShiTongXunGongJu": "Мессенджеры",
    "GeXingHuaSheZhi": "Персональные настройки ",
    "YeMianLiuLanSheZhi": "Настройки просмотра страниц",
    "MoRenBaoJiaFangShi": "Прайс по умолчанию",
    "MeiYeShangPinShuLiang": "Количество арт. на странице",
    "JieGuoChaKanMoShi": "Результаты просмотра",
    "YeMianChaKanYuYan": "Язык просмотра",
    "YuanGongZhangHao": "Номер сотрудника",
    "SheWeiBOSSZhangHao": "Установить учётную запись BOSS",
    "TiShengGaiZhangHaoGuanLiGongSiZiLiao": "Хотите расширить Ваши возможности по управлению данными учётной записи? Если в будущем понизить эту возможность, то управлять данными Вы уже не сможете,  однако в любом случае это не влияет на размещение заказов.",
    "NinDeZiJin": "Ваши денежные средства",
    "ZiJinZongJi": "Общая сумма денежных средств",
    "KeYongZiJin": "Доступные средства",
    "BaoZhengJin": "Депозит",
    "NingDeYingFuKuan": "Ваша кредиторская задолженность",
    "LeiJiYingFu": "К оплате",
    "NingJinQiJiaoYiE": "Ваш оборот денежных средств за последнее время",
    "NNianDingHuoJinE": "Объем заказа за {0} год",
    "NNianChuHuoJinE": "Объем отгрузок за {0} год",
    "ZiJinFenPeiMingXi": "Детализация фин. расходов",
    "QuanBuYongTu": "Все применения",
    "ZhiFuHuoKuan": "Оплата за товар",
    "ZhiFuDingJin": "Оплатить депозит",
    "QiTaFeiYong": "Другие расходы",
    "FenPeiRiQi": "Дата",
    "JinNGeYue": "Ближайшие {0} месяцев",
    "JinNNian": "Ближайшие {0} лет",
    "JinSanGeYue": "Последние 3 месяца",
    "JinBanNian": "Последние полгода",
    "JinYiNian": "Последний год",
    "JinNian": "Текущий год",
    "YongTu": "Применение",
    "BenCiFenPeiJinE": "Распределение денежных средств",
    "HuiLv": "Обменный курс",
    "RuZhangRiQi": "Дата поступления",
    "ShouKuanJinE": "Полученная сумма",
    "ShouKuanBiZhong": "Валюта поступления",
    "RuZhangBiZhong": "Валюта зачисления",
    "RuZhangJinE": "Зачисленная сумма",
    "RiQi": "Дата",
    "ShuoMing": "инструкция",
    "BenYueZhangDan": "Счета за текущий месяц",
    "LiShiZhangDan": "История счетов",
    "DaiFang": "Кредитор",
    "JieFang": "Заёмщик",
    "ShangQiJieYu": "Остаток с прошлого заказа",
    "BenQiJieYu": "Остаток с нынешнего заказа",
    "YuE": "баланс",
    "HuiKuan": "Денежный перевод",
    "YiTongGuoRenZheng": "Подтверждено",
    "DaiRenZheng": "Ожидание подтверждения",
    "ShangCiDengLuShiJian": "Последняя авторизация",
    "WoShiN": "Я {0}, с радостью помогу Вам!",
    "NinHaoWoShiN": "Здравствуйте! Я - Ваш консультант по продажам{0}",
    "WoCongShiWaiMaoHangYeYiJingYouNNian": "Мой опыт в ВЭД насчитывает {0} лет, и я отлично{1} знаю рынок страны {2}",
    "CaiGouGuoChengZhongYouRenHeWenTi": "Если у Вас возникнут какие-либо вопросы, пожалуйста обращайтесь ко мне ({0})",
    "ChangYongGongNeng": "Популярные функции",
    "NinXuYaoChuLiDeShiXiang": "Вопросы, которые Вам нужно решить",
    "XiaDanQian": "Перед размещением заказа",
    "XiaDanHou": "После размещения заказа",
    "NKuanShangPinXuYaoQueRenCaiGou": "Нужно подтвердить {0} арт. ",
    "NZhangDingDanXuYaoZhiFuDingJin": "Необходимо внести депозит по заказу {0}",
    "NZhangDingDanXuYaoZhiFuHuoKuan": "Необходимо внести оплату по заказу {0}",
    "NZhangDingDanXuYaoChuLiYiChang": "Необходимо решить вопросы по заказу {0}",
    "NZhangDingDanBuHuoWeiWanCheng": "Дозаказ товара для PO {0} ещё не завершён",
    "ZhongYaoTiXing": "Важное напоминание",
    "WeiNinTuiJianDeShangPin": "Рекомендуемые для Вас товары ",
    "NinDaiLiDeShangPin": "Ваши товары для дистрибуции",
    "NinHaiMeiYouDaiLiRenHeShangPin": "У Вас еще нет товаров для дистрибуции.",
    "NinDeZhuanShuShangPin": "Ваши эксклюзивные товары",
    "HaiWeiKaiFaNinZhuanShuDeShangPin": "Ваши эксклюзивные товары еще не разработаны",
    "NinShouCangDeShangPin": "Ваши избранные товары",
    "NinHaiMeiYouShouCangRenHeShangPin": "У Вас пока нет избранных товаров",
    "NinShouCangDePinPai": "Ваши избранные бренды",
    "NinHaiMeiYouShouCangRenHePinPai": "У Вас пока нет избранных брендов",
    "JinRuZhuanQu": "Войти в раздел",
    "XiaoXiTiXing": "Оповещения",
    "JiaoYiTiXing": "Оповещения  о заказах",
    "HuoDongTiXing": "Оповещения об акциях",
    "XiTongXiaoXi": "Оповещения об изменениях в системе",
    "DaoChuMuBan": "Произвести пресс-форму",
    "BaoJiaDan": "Прайс",
    "PODan": "PO",
    "FaPiaoDan": "Invoice",
    "DuiZhangDan": "Акт сверки",
    "QiYongRiQi": "Дата запуска",
    "MuBanMingCheng": "Имя шаблона",
    "KeFuReXian": "Телефон клиентской поддержки ",
    "BeiJingShiJian": "пекинское время, пон. - пят.",
    "LianXiFangShi": "Номер телефона",
    "DianHua": "Телефон",
    "ShiJian": "Время",
    "BaoZhuangYuYan": "Язык упаковки",
    "CaiZhi": "Основной материал",
    "TuPian": "Фото",
    "ZhengZaiChuLiQingShaoHou": "Загрузка…",
    "YanZhengMaBuZhengQue": "Номер, указанный на картинке, неверный.",
    "BaoQianMeiYouSouSuoDaoShangPin": "Извините, ни одного товара не найдено",
    "QueDingYaoShanChuMa": "Подтвердить удаление?",
    "GongChangHuoHao": "Фабр. арт.",
    "WoYiYueDuBingTongYiESSAYongHuZhuCeXieYi": "Я прочитал(а) и принимаю {0}《пользовательское соглашение ESSA》{1}",
    "DingDanPeiKuan": "Компенсация",
    "TuiKuan": "Возврат товара",
    "ZengPin": "Бесплатный образец",
    "FengXiangJiaoDai": "Обклеить короб скотчем",
    "ChongDianQiChaTou": "Штепсель",
    "ChongDianQiDianYa": "Напряжение зарядного устройства",
    "YaoKongPinLv": "Частота радиоуправления",
    "WaiXiangMaTouYaoQiu": "Требования к маркировке (внешний короб)",
    "NeiXiangMaTouYaoQiu": "Требования к маркировке (внутренний короб)",
    "TieZhiYaoQiu": "Требования к стикерам",
    "ZhiXiangYaoQiu": "Требования к коробам",
    "TongYongMoBan": "Прессформа",
    "ShouJi": "Телефон",
    "XingBie": "пол",
    "JinZhiChiGeShi": "Поддерживаются только следующие форматы: JPG、GIF、PNG、JPEG、BMP",
    "HeJia": "Отправить запрос",
    "WeiHeJia": "Не конечная цена",
    "YouKe": "Посетители",
    "ZhuCeCaiGouShang": "Зарегистрированный покупатель",
    "RenZhengCaiGouShang": "Сертифицированный покупатель",
    "VipCaiGouShang": "Покупки VIP пользователя",
    "Zhang": "шт.",
    "WenJian": "Документы",
    "mingzi": "Имя",
    "XiuGaiMingZi": "Изменить имя",
    "Yuan": "Юань",
    "XiuGaiMingZiChengGong": "Имя успешно изменено",
    "ShangChuanChengGong": "Успешно загружено",
    "QingXuanZeGuiGe": "Пожалуйста, выберите спецификацию",
    "WeiShangChuanWenJian": "Файл не загрузился",
    "WangLuoGuZhangHuoZheXiTon": "Очень сожалеем, но в системе возникли неполадки. Чтобы решить проблему пожалуйста свяжитесь с службой поддержки площадки  или с вашим менеджером по сопровождению.",
    "CuoWuDaiMa": "Код ошибки",
    "RuGuoXuYaoBianGengJiaoYiB": "Если вам нужно изменить валюту, пожалуйста, обратитесь в службу обслуживания клиентов",
    "DangQianJiaoYiBiZhong": "Текущая валюта",
    "YouXiangYanZhengLianJieYi": "Не совпадает адрес электронной почты",
    "YuanMiMaBuZhengQue": "Пароль неверный",
    "LeiJiQianKuan": "Задолжность",
    "WeiTongGuoYanZheng": "Не прошло проверку",
    "BianGengJiaoYiBiZhongWei": "Поменять валюту на",
    "QingTongYiXieYi": "Пожалуйста, подтвердите соглашение",
    "QingTianXieQuHao": "Пожалуйста, введите код региона",
    "Nian": "лет",
    "DianZiYouXiangBiXuYouXiao": "Электронный ящик должен быть действительным, так как после регистрации Вам на почту будет отправлено письмо, с помощью которого нужно будет активировать регистрацию",
    "ZaiShuWanGongYingShangFaB": "Десятки тысяч поставщиков, более 1 млн наименований на любой выбор, онлайн запросы, сборные грузы, онлайн-отслеживание заказов, удобные онлайн-операции, значительная экономия времени покупателей. Помощь при возникновении различных проблем при транзакциях.",
    "QingDengLu": "Пожалуйста, войдите в систему",
    "XianZaiXuanZeYiWeiZhuanSh": "Теперь выберите специальную службу поддержки",
    "DangNinChengWeiWoMenDeRen": "При отборке товара или при возникновении каких-либо вопросов сервис для помощи",
    "XiaoShiNeiWoMenGongZuoRen": "В течение 24-х часов наши сотрудники свяжутся с Вами для уточнения информации",
    "ZhiNengXuanZeYiGe": "Можно выбрать только одно",
    "KanKanZhengZaiJinXingDeYo": "Посмотреть текущие акции",
    "YanZhengMaWuXiao": "Код подтверждения неверный",
    "ZhuYaoCaiGouLeiXingBuNeng": "Основные виды закупок  не должны превышать 5 видов",
    "QiTaXinXi": "Информация к заполнению",
    "ZhuYaoCaiGouLeiXing": "<b>Основной регион и основные виды закупок</b>（Заполнив эту информацию,Вы будете первым получать новинки по этим категориям）",
    "XuanZeCaiGouLeiXingYouZhu": "Выбор типа покупки поможет нам предоставить для Вас более точный сервис",
    "XuanTianZheiXieXinXiYouZh.": "Заполнив эту информацию, Вы поможете нам предоставить для Вас более точный сервис",
    "QuanQiuWanJuYuLiPinDeMaoY": "ESSA - Прямая закупка игрушек из Китая",
    "DengLu1": "Войти.",
    "ZhuCe1": "Плюсы регистрации",
    "ZhaoHuiMiMa1": "Получить пароль",
    "SouSuoLieBiao": "Поиск",
    "KaiXinFangXin": "Надежность и качество",
    "TeJiaWanJu": "Игрушки по акции",
    "JiDanTuanGou": "Предпродажи новинок/Групповые заказы",
    "WanJuPinPaiDaQuan": "ТОП игрушечных брендов",
    "JingXuanWanJuChanPin": "Избранные игрушки",
    "BangZhuZhongXin1": "Помощь",
    "XiTongWeiHu": "Тех. обслуживание системы",
    "WoDeZhangHu": "Мой аккаунт",
    "WoDeXiaoXi": "Мои сообщения",
    "WoDeGouWuChe": "Ваша корзина",
    "WoDeCaiGouJiHua": "Ваш план закупок",
    "WoDeHuoGui": "Мои контейнеры",
    "SheZhiTieZhiMaTou": "Настройка стикеров и маркировки",
    "TiJiaoDingDan": "Отправить заказ",
    "WoDeDingDan": "Мои заказы",
    "WoDeZiChan": "Платежный аккаунт",
    "ZhangHuSheZhi": "Настройки учетной записи",
    "JiaoYiSheZhi1": "Настройки транзакций",
    "JieSuanYaoQiu1": "Требования",
    "CaiGouYaoQiu": "Требования по закупке",
    "HuoDaiLianXiRen": "Контактные данные перевозчика",
    "TieZhiYuMaTou": "МАркировка и стикеры",
    "MoBanGuanLi": "Управление шаблонами",
    "ShangPinFuWu1": "Товары и услуги",
    "WoDeZhuanShuShangPin": "Мои эксклюзивные товары",
    "WoDeDaiLiShangPin": "Мои товары",
    "GongSiXinXi1": "Информация о компании",
    "WoDeYuanGong": "Мои сотрудники",
    "ZhangHaoXinXi1": "Информацию об учетной записи",
    "JiBenZiLiao": "Основная информация",
    "XiuGaiYouXiang1": "Изменить электронную почту",
    "XiuGaiMiMa1": "Изменить пароль",
    "ShouZangJia": "Избранное",
    "ShouZangDeShangPin": "Коллекции товаров",
    "ShouZangDePinPai": "Фокус на брендах",
    "QiTa1": "Другие",
    "LiuLanLiShi1": "Просмотреть историю",
    "YeMianSheZhi": "Настройки страницы",
    "DangQianHuoJuShengYuKongJ": "Общий объем контейнера товаров может превышать максимальный объем контейнера может быть загружен: {0} m³",
    "ZuiDaXiangShuWeiXiang": "Максимальное кол-во коробов: {0}",
    "QingShuRuShuZi": "Пожалуйста, введите цифры",
    "GaiGongYingShangKeTianJiaDeShangPin": "Товары, которые можно добавить из этого поставщика",
    "GaiGongYingShangYiWuKeTianJiaShangPin": "Нельзя добавить товар этого поставщика",
    "BaoCunQuanBuHuoGuiChengGong": "Успешно сохранить все контейнеры",
    "ZhiDingShanChuHuoGuiYiBeiShanChu": "Контейнер, который Вы пытаетесь удалить, уже удалён из списка или не существует",
    "ZhiDingShanChuHuoGuiBiXuWeiKong": "Чтобы удалить контейнер {0}, он должен быть пустой!",
    "QingXuanZeYaoShanChuDeShangPin": "Пожалуйста, выберите товар, который нужно удалить!",
    "QueDingYaoShanChuXuanZhongDeShangPinMa": "Уверены, что хотите удалить выбранный товар?",
    "QueDingYaoShanChuCiShangPinMa": "Уверен, что вы хотите удалить этот товар?",
    "ShenQingWeiManGuiTiJiaoPODoing": "PO данного контейнера отправлен и находится в процессе рассмотрения",
    "QingXuanZeYaoTianJiaDeShangPin": "Пожалуйста, выберите продукт для добавления",
    "QingXuanZeYaoYiChuDeShangPin": "Пожалуйста, выберите товар, который вы хотите переместить!",
    "DangQianZhangHuYouQiTaRenZaiXiaDanLater": "Ваш заказ находится в процессе обработки, если у вас возникли вопросы, пожалуйста свяжитесь с консультантом по продажам.",
    "NinDeCaiGouJiHua": "Ваши товары из плана закупки",
    "DaoChuShangPin": "Скачать фото",
    "DangQianZhangHuYouQiTaRenZaiXiaDan": "C данной учетной записи производится заказ другим пользователем",
    "YiXuanZhongNKuan": "Выбрано {0} арт.",
    "WaiXiangMaoZhong": "Вес брутто",
    "JingZhong": "Вес Нетто",
    "WaiXiangTiJi": "Объем коробка",
    "DingGouLiangXiang": "Объём заказа：{0} кор.",
    "ZhuYiYouBuFenShangPinWeiM": "Внимание: есть некоторые товары, не соответствующие условиям заказа",
    "LiJiChuLi": "Обработать немедленно",
    "RiQiShenQingTiQianForPI": "Внимание! В контейнере есть товары, срок производства которых дольше выбранной Вами даты. Мы постараемся ускорить отгрузку контейнера. Пожалуйста, проверьте результат обработки.",
    "CaiGouLiang": "объём покупки у данного поставщика",
    "XiaoYuQiSongLiangBuNengXiaDan": "Объём Вашей покупки не соответствует MOQ доставки производителя, поставщик не сможет организовать транспортировку груза - размещение заказа невозможно.",
    "SheZhiTieZhiMaiTou": "Настроить стикеры и маркировку",
    "HuoGuiNWeiManZuXiaDanTiaoJian": "В контейнере под номером {0} следующие арт. не соответствуют условиям заказа",
    "QingCanKaoCuoWuTiShiHouTiJiaoPI": "Пожалуйста, обратите внимание на \"Доставку при кол-ве\" и \"Мин.заказ\", после повторно отправьте запрос",
    "MeiYouZhaoDaoXiangGuanDeS": "Соответствующие товары не найдены",
    "QingHeDuiMaTouTieZhiXinXi": "Пожалуйста, проверьте правильность стикеров и маркировок перед отправкой РО. После получения РО мы запустим это в производство в соответствие с предоставленным содержанием",
    "TianBiaoShiBuShiYongGaiTi": "Символ \"-\" означает отсутствие стикеров и маркировки",
    "ShangPinBianMa": "Арт. товара",
    "XuanZeTieZhiYangBan": "Выбрать шаблон для стикеров",
    "XuanZeMaTouYangBan": "Выбрать шаблон маркировки",
    "XiaZaiXinXi": "Скачать информацию",
    "WaiXiang": "Коробка",
    "ZhengMa": "Маркировка лицевой стороны",
    "CeMa": "Боковая маркировка",
    "NeiXiang": "Внутренний короб",
    "BuHuoShangPinDeTieZhiMaTo": "Стикеры и маркировка для дозаказа верные?",
    "QueRenHouWoMeJiangAnCiAnP": "Мы начнем производство после подтверждения",
    "NinBenCiBianJiDeMaTouTieZ": "Информация о стикерах и маркировке в этот раз не была сохранена",
    "QueDingQuXiaoMa": "Подтвердить отмену?",
    "CaiGouJiHua": "План закупок",
    "HuiYuanZhongXinShouYe": "Личный кабинет",
    "DaiQueRenFuKuan": "Подтвердить оплату",
    "DaiQueRenDingJin": "Ожидание подтверждение депозита",
    "DaiChuLiYiChang": "Обработка несоответствий",
    "WeiWanChengDeDiaoBuHuo": "Товары для дозаказа не выбраны",
    "NinMeiYouDaiChuLiDeDanJu": "Нет заказов",
    "BangZhu": "Помощь",
    "XinShouZhiNan": "Для начинающих",
    "XinShouShiPinJiaoCheng": "Центр помощи",
    "FenZhongLeJie": "Минуту на размышление",
    "MianFeiZhuCe": "Зарегистрироваться бесплатно",
    "DengLuShuoMing": "Как войти",
    "YongHuDengJiQuanXian": "Виды пользователей и ограничения",
    "CaiGouShuoMing": "Инструкция по покупке",
    "CaiGouShiPinJiaoCheng": "Преобрести обучающее видео",
    "JiaoYiLiuCheng": "Процесс сделки",
    "CaiGouJiHua1": "План закупок",
    "ShangPinPinJu": "Формирование контейнера",
    "PODan1": "РО",
    "ZhiFuHeYunShu": "Оплата и доставка",
    "BaoJiaFangShi": "Виды цены",
    "ZhiFuFangShi": "Как оплатить заказ",
    "DingHuoYaoQiu": "Требования по заказу",
    "HuoYunShuoMing": "Инструкция по доставке",
    "XiaShuiChengShi": "Место отправления товара",
    "GuanYuWoMen": "О нас",
    "GuanYu": "ESSA",
    "FuWuYuJiaZhi": "Услуги и стоимость",
    "SJieShao": "S+S",
    "DJieShao": "DECORA",
    "GongSiTuPian": "Фото компании",
    "KeJian": "видно только VIP пользователям",
    "SuoYouLeiMu": "Все виды",
    "1059ER10018": "Кол-во заказанного товара превышает один контейнер, дозаказ невозможен",
    "TiaoJianDaCheng": "Условия достигнуты",
    "ShengYuXiangShu": "Осталось",
    "KuaiSuChuHuo": "Скоростная доставка товара",
    "TuanGou": "Совместный заказ",
    "JianYiSouSuo": "Простой поиск",
    "RuHeXunJia": "Как отправить заказ?",
    "ShiShiXunJiaHeChaXunShang": "Бесплатный расчёт цен для любых товаров",
    "KeKaoDeFuKuanFangShi": "Удобная организация плана закупок",
    "FuWuYuBaoZhang": "Как оплатить заказ?",
    "ShouHouMaoYiBaoZhang": "Надёжные способы оплаты",
    "ShangPinWeiYiGaoXiaoBiJia": "Заказ в режиме реального времени, автономное управление",
    "ChaoDaZhanTingXianXiaHuDo": "Огромный шоурум, офлайн взаимодействие",
    "MaoYiBaoZhangJiangDiFengX": "Торговые гарантии,  минимальные риски",
    "JiaGeDi": "Эксклюзивные товары, эффективные цены",
    "DaFuLiPaiSongYuanChangJia": "Фабричные цены на товар",
    "ShangPinDuo": "Заказ в режиме реального времени, автономное управление",
    "HaiLiangChanPinXinXiQingS": "Быстрая сортировка товаров по разным параметрам",
    "ZaiXianJiaoYi": "Огромный шоурум, офлайн взаимодействие",
    "ZiZhuCaoZuoYiTiHuaShiShiD": "Возможность совершать заказы онлайн и просматривать заказы на сайте в любое удобное время",
    "ShiNianPinPai": "Торговые гарантии,  минимальные риски",
    "KeKaoDeHeZuoHuoBanGongJia": "Надёжный партнёр! 10-ти летний опыт выстраивания бренда",
    "WuTiaoJianTuiHuan": "Возврат без условий",
    "YiWaiQingKuangYouBaoZhang": "Другие случаи гарантий",
    "BaoXianMianFeiSong": "Бесплатная страховка",
    "ShuiZiXianPingAnXian": "ВПА/ФПА",
    "ZhiLiangYouPeiChang": "Компенсация по качеству",
    "DaoGangKanZhiLiangShouHou": "Наш сервис не заканчивается на получении товара в порту",
    "XinShouZhiYin": "Для начинающих",
    "ChaKanGengDuo": "Смотреть ещё",
    "ZhuYi": "Внимание!",
    "ShangPinHeJiaJieGuoYouYiC": "Есть неточности в утверждённой цене",
    "TiShi": "Советы",
    "GaiShangPinYiGuoJiaGeBaoH": "Прежняя цена на товар уже недействительна",
    "ZaiCiHeJia": "Еще раз утвердить цену",
    "YanZhengMaCuoWu": "Неверный пароль",
    "WangLuoGuZhangHuoZheXiTonCode": "Очень сожалеем, но в системе возникли неполадки. Чтобы решить проблему пожалуйста свяжитесь с службой поддержки площадки  или с вашим менеджером по сопровождению. Код ошибки {0}",
    "YongHuXinXiYiGuoQiQingZho": "Время нахождения в системе истекло, пожалуйста, авторизуйтесь заново. Через {0}  секунды будет совершен автоматический переход на страницу входа в систему.",
    "CunRu": "Внести",
    "ZhiChu": "Расходы",
    "XieYi": "Соглашение",
    "WoYiJingYueDuBingTongYi": "Я прочитал и согласен",
    "XiangQing": "Детали",
    "ChanPinZhengShu": "Сертификаты",
    "ZhuCaiZhi": "Основной материал",
    "ZhangHaoYiJinYong": "Аккаунт был отключен",
    "QingXianQianWangNinDeDian": "Пожалуйста, зайдите на свой email и проверьте письмо",
    "CuoWu": "Ошибка",
    "KeFuTuanDui": "служба поддержки ESSA",
    "NinQueDingXuanZeGaiKeFu": "Вы уверены, что хотите выбрать данного консультанта?",
    "JiYuQianSanNianShuJu": "Данные на основе трех предыдущих лет",
    "BaoZhuangFenLi": "Упаковку отдельно",
    "BaoZhuangNianLingBiaoQian": "Указывать возраст на упаковке",
    "JinNianChuHuoLiang": "Отгрузки за последние 3 года",
    "JiDanTuanGouShangPinJiaGe": "Предпродажи новинок/Товары в групповых заказах могут быть видны только активным клиентам",
    "ShanChuBuChengGong": "Удалить не удалось",
    "CaiGouShangZhangHaoXiaJin": "Когда остаеются толькоодин контейнер, удаление невозможно",
    "KongHuoJuCaiNengBeiShanCh": "Пустые контейнеры могут быть удалены",
    "GaiShangPinYiJingQueRenGo": "Покупка утверждена, в последствие можно только добавить кол-ва, но не уменьшить",
    "GengXinShiBai": "Обновление не удалось",
    "QuXiaoCaiGouShiBai": "Отмена покупки не удалась",
    "XunJiaZhongDeShangPinBuNe": "Запрос котировок товаров не может изменить заказанное количество",
    "FeiHuoDongShangPinDingGou": "При заказе кол-во неучавствующего в акции товара должно быть меньше, чем кол-во на складе, но больше фабричного MOQ",
    "FeiHuoDongShangPinDingGou1": "Заказ на не учавствующие в акции товары не может быть меньше по количеству чем 【MOQ】",
    "HuoDongShangPinZaiDiaoZhe": "Кол-во этого товара не может быть меньше 【MOQ】",
    "JiDanTuanGouHuoDongBuCunZ": "Предпродажи новинок/Акция по групповым заказам уже недействительна",
    "HuoDongZhuangTaiJiDanZhon": "Статус акции = Когда новинки уже в процессе предпродаж/в процессе групповых заказов, корректировать количество MOQ ниже нельзя",
    "QueRenCaiGouQianDiaoZheng": "Перед утверждением, пожалуйста, измените кол-во 【订购量】, не может быть ниже  【MOQ】",
    "QueRenCaiGouHouBuYunXuDia": "После подтверждения покупки нельзя вносить изменения в 【количества】",
    "JiDanChengGongHouBuYunXuD": "Если условия по предпродаже новинок были достигнуты, корректировка MOQ недопустима, удаление невозможно",
    "JiDanShiBaiHouZhiYunXuSha": "Если условия по предпродажам новинок не были достигнуты, разрешено только удаление",
    "ErCiHeJiaShiBai": "Не удалось повторно утвердить цену",
    "ShangPinBuFuHeYaoQiuWuFaT": "Продукт не может быть добавлен, так как не соответствует требованиям",
    "JiDanTuanGouZhiJieJiaRuSh": "Не удалось добавить сборную закупку в план",
    "JiDanTuanGouHuoDongBuZaiY": "Предпродажи новинок/Акция по групповым заказам уже недействительна",
    "XunJiaZhongDeShangPinBuYu": "Товары, цена которых в процессе утверждения, не могут быть удалены",
    "YiQueRenDeShangPinBuYunXu": "Утвержденные товары уже нельзя удалить",
    "HuoJuYiJingYouGeBuNengZai": "Уже есть 30 контейнеров.Нельзя добавить еще один",
    "YiXiangYuZhuangJuRiQiShou": "В ручную исправить дату отгрузки возможно максимум за 10 дней до даты отгрузки по умолчанию",
    "ShangPinShengYuShuLiangBu": "Кол-во товара ={0}, MOQ не может быть меньше {1}",
    "ShangPinBianHaoDeTieZhiMa": "Стикеры и маркировка на артикул {0} настроены неверно",
    "ShangPinBianHaoDingGouLia": "Объём по продукту под артикулом {0} не достиг MOQ",
    "GongYingShangBianHaoWeiDe": "Товар арт. {0} не достиг минимального количества, чтобы поставщик сделал доставку",
    "CaiGouShangMeiYouSheZhiJi": "Не выбрана валюта операции",
    "CaiGouShangZhangHaoXiaBuC": "Аккаунт не существует, контейнер можно удалить",
    "WeiHuoBuNengGaiBianXiangS": "Нельзя изменить количество коробов, можно только переместить товар",
    "ShouDongDiaoZhengDeRiQiYu": "Чтобы вручную настроить дату отгрузки, это возможно сделать максимум за 10 дней до даты по умолчинию и измененная дата отгрузки не может быть меньше чем 15 дней от текущей даты",
    "HaiCha": "Еще осталось",
    "ShuRuShangPinBianHaoGongC": "№ товара , ключевое слово , поиск по фото",
    "CaiGouJiHuaZhongShiKongDe": "План закупок пуст",
    "ChaKanCaiGouJiHua": "Посмотреть план закупок",
    "HeJiaShiBai": "Обновление цены не удалось",
    "ShangChuanXinXi": "Загрузить информацию",
    "CiDanYiJingShenQingLeDiao": "Доказак для этого PO уже выбран",
    "CiDanBuNengZaiGengGaiJieS": "Находясь в РО, нельзя изменить способы оплаты",
    "TianJiaGouWuCheChengGong": "Успешно добавлено",
    "GouWuCheShiKongDe": "Нет выбранных товаров",
    "HPBangZhuZhongXin": "Центр помощи",
    "BuCunZaiHeShiDeBaoBiaoMoB": "Нет соответствующего шаблона, пожалуйста, свяжитесь с Вашим консультантом",
    "QingXuanZeYaoDaoChuDeShuJ": "Пожалуйста, выберите артикулы для экспорта",
    "QingXuanZeMoBan": "Пожалуйста, выберите шаблон",
    "ShangPinTuPian": "Фото товара",
    "QingShuRuQuHao": "Пожалуйста, введите код города",
    "BuNengZhongFuXuanZe": "Невозможно выбрать заново",
    "Shi": "Да",
    "Fou": "Нет",
    "QingTianJiaShangPin": "Пожалуйста, добавьте товары",
    "LeiMu": "Категории",
    "QueShaoBaoBiaoZiYuanBianMaCanShu": "Данная информация отсутствует. Пожалуйста, свяжитесь с Вашим консультантом",
    "QingXianXiaZaiMoBanTianXi": "Сначала скачайте шаблон,заполните его, затем загрузите",
    "queren": "Подтвердить",
    "ShengChanYaoQiu": "Требования к производству",
    "BeiZhu": "Примечания",
    "BaoZhuangYaoQiu": "Требования к упаковке",
    "BuManJuLiYouWeiKong": "Контейнер заполнен неполностью",
    "NinZaiZhiFuDingJinHouEssaWeiNinTouChan": "Производство начнётся как только Вы оплатите депозит",
    "ZhengZaiZhunBeiShengChanXiangGuanDeAnPai": "Готовится запуск производства",
    "NinDeDingDanYiJingZaiShengChanZhong": "Ваш заказ запущен в производство. Производство занимает определенный период времени, в случае смещения сроков производства или остановки производства могут возникнуть неполадки с заказом, которые Вам нужно будет подтвердить",
    "ShengChanYiWanBiZhengZaiJinXinZhiJian": "Производство товара завершено, начат процесс проверки качества",
    "ShangPinYiZhiJianWanChengZhengZaiShouRuEssaCangKu": "Проверка качества завершена. Товар в процессе доставки на склад",
    "DingDanYiJingZhuangGuiWanCheng": "По данному заказу началась загрузка контейнера",
    "HuoWuYiJingZhuangGuiWanCheng": "Загрузка товара в контейнер завершена",
    "YiJingBaoGuanTongGuo": "Задекларировано",
    "NinDeHuoGuiYiZaiYunShuGuoChengZhongQingJiShiZhiFu": "Ваш контейнер в процессе перевозки. Пожалуйста, своевременно совершите оплату!",
    "TiDanYiJiaoFu": "Коносамент доставлен",
    "PoDanLieBiaoShiKongDe": "Список имеющихся РО пуст",
    "LieBiaoShiKongDe": "Список пуст",
    "XunJiaYiChangXuYaoChuLi": "Есть несоответствия в цене, нужно их решить",
    "YiChangChuLi": "Обработка несоответствий",
    "ChaKanShangPin": "Смотреть товары",
    "QiTaDanJu": "Другие документы",
    "FuWuFeiYouHuoGuiShangPinKuanShuJueDing": "Плата за услуги зависит от количества артикулов в контейнере",
    "GaiFeiYongBaoKuoHuoKuanTieZhiFeiFuWuFeiDaiFuFob": "Цена FOB включает в себя стоимость самого товара, изготовление стикеров и предоставление услуг",
    "YiXuanZhong": "Выбрано",
    "Jian": "шт.",
    "YiXiaShangPinYiGuoJiaGeBaoHuQi": "Цена на этот товар уже недействительна",
    "YiXiaJia": "Товар вышел из производства",
    "YiJieSouCiMoq": "Соответствует MOQ",
    "ShangPinXinXiYiChang": "Информация о продукте неточная",
    "ZhiJianYiChang": "Возникли вопросы при проверке качества",
    "YiDongDaoN": "Перейти к {0}",
    "ZanShiMeiPoDan": "В настоящий момент нет никаких РО",
    "QingChaKan": "Проверить",
    "GouWuCheZhongShiKongDe": "В корзине нет товаров",
    "JiBenGouWuLiuChen": "Процесс совершения сделки",
    "ChaZhaoShangPinJiaRuGouWuChe": "Найти товары и добавить в корзину",
    "TiJiaoBingQueRenPI": "Отправить и подтвердить план закупок",
    "PIPinGuiBingTiJiaoPO": "Отправить заказ на совместную загрузку контейнера согласно плану закупок.",
    "QueRenPO": "Производство",
    "ChuHuoJiaoYiWanCheng": "Отгрузка",
    "QueRenXinMiMa": "Подтвердить пароль",
    "KeHuFuWu": "Обслуживание клиентов",
    "YiChangYuanYin": "Причина несоответствия",
    "JiaGeYiChang": "Несоответствия в цене",
    "HuoQiYiChang": "Несоответствия в сроке отгрузки",
    "MOQYiChang": "Несоответствия в MOQ",
    "WuLiaoKeYongLiangBuZu": "Нехватка сырья",
    "TingChanXiaJia": "Товар вышел из производства",
    "HeZuoFangShi": "Виды сотрудничества",
    "XiaoShouQuDao": "Каналы сбыта",
    "BaoZhuangChiCun": "Размер упаковки",
    "SuoYouXunJiaWanChengHouHe": "Все цены, если не возникло каких-либо несоответствий, после просчета можно най ти в разделе \"Создать контейнер\"",
    "QingHuaDongYanZhengMa": "Пожалуйста, воспроизведите проверочный код",
    "TuoDongHuaKuaiDaoZuiYou": "Перетащите ползунок вправо",
    "ZhongXinTianXie": "Впишите заново",
    "TianXieShangMianDeYouXian": "Вписав адрес электронной почты, на Ваш ящик будет отправлено письмо. Пожалуйста, проверьте почту и завершите регистрацию в соответствие с указаниями",
    "JiXuJiJiangWanChengZhuCe": "Продолжить, чтобы завершить регистрацию",
    "SheZhiMiMa1": "Установить пароль",
    "QianWangNinDeYouXiangChaS": "Остался всего один шаг! Пожалуйста, подтвердите Вашу электронную почту (в течение 24 часов)",
    "YanZhengYouXiang": "Подтверждение электронной почты",
    "QianWangNinDeDianZiYouXia": "Остался всего один шаг! Пожалуйста, подтвердите Вашу электронную почту (в течение 24 часов)",
    "XinPinTuiJian": "Новинки",
    "HaiYouYiChangWeiChuLi": "Есть нерешённые вопросы. Подтвердите, пожалуйста.",
    "CaiGouShuLiang": "ctn",
    "JiDanZhong": "Новинки в процессе предпродаж",
    "TuanGouZhong": "Группа",
    "QingQueRen": "Пожалуйста, подтвердите",
    "ZhuJiMa": "Арт. фабрики",
    "HongShengJiuBianHao": "Номер Hongsheng.",
    "XuanZeZhou": "Выберите материк",
    "XuanZeSheng": "Выберите провинцию",
    "XuanZeGuoJia": "Выберите страну или регион",
    "XiaYiBu": "Следующий шаг",
    "YnV5ZXJfY29uZmlybV9lbWFpbF9jb2Rl": "Условия закупки совместных заказов выполнены",
    "cHJvX2xvYWRfZGF0ZV9jaGFuZ2VkX2VtYWls": "Изменения в сроке отгрузки",
    "cG9fYWJub3JtYWxfZW1haWw=": "Заказ (РО) требует подтверждения",
    "cmVwbGVuaXNoX2lucXVpcnlfZW1haWxfY29kZQ==": "Обработка цен на дозаказ завершена",
    "YnV5ZXJfc3RpbWFya19lbWFpbF9jb2Rl": "Производство стикеров и маркировки завершено",
    "cG9fYmlsbF9vZl9sYW5kaW5nX2VtYWls": "Коносамент выпущен",
    "c3VibWl0X3BvX2J5X3NhbGVzX2VtYWls": "Отправить РО",
    "QnV5ZXJfU3RhdGVtZW50cw==": "Сверка за каждый месяц",
    "UmVtYWluX0JhbGFuY2VfUGF5bWVudF9lbWFpbA==": "Товар прибыл в порт",
    "YnV5ZXJfZ29vZHNfcmVjb21tZW5kX2VtYWlsX2NvZGU=": "Рекомендации",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA==": "Упаковка товара завершена",
    "cGF5bWVudGRfZXBvc2l0X2VtYWls": "Оплата депозита",
    "BulkMaterialConfirmBuyTemplate": "Уведомления об отправке",
    "YouJianTuiDing": "Отменить подписку",
    "YouJianDingYue": "Почтовая рассылка",
    "MeiYouGouXuanDeXiangMuWoM": "Это функция оповещения по электронной почте: если Вы не выбрали ни одну категорию, то мы не будем отправлять Вам рассылку.  Вы можете настроить почтовые уведомления в соответствие с Вашими требованиями",
    "NinXiangYaoTuiDingDeFuWu": "Вы хотите отказаться от этой услуги",
    "QingBuYaoFaJiWoDeYouJianT": "Пожалуйста, не отправляйте мне \"{0}\" уведомления по электронной почте, спасибо!",
    "XiangXiDeYouJianFuWuSheZh": "Чтобы узнать подробности настройки почты,",
    "YouJianFuWu": "Почтовый сервис",
    "QuXiaoDingYue": "Отменить подписку:",
    "DianJiZheiLi": "нажмите здесь",
    "TuiDingChengGong": "Отписка подтверждена",
    "DanJuDingJinBiLi": "Соотношение контейнеров и депозитов",
    "DanJuGuDingDingJin": "Фиксированный депозит на контейнер",
    "BaoZhengJinEDu": "Категория Вашего гарантийного депозита",
    "YnV5ZXJfY29uZmlybV9lbWFpbF9jb2Rl_remark": "Как только условия по предпродажам новинок будут достигнуты, Вам будет отправлено электронное письмо.",
    "c3VibWl0X3BvX2J5X3NhbGVzX2VtYWls_remark": "Электронное письмо, отправленное вашим менеджером при оформлении PO за вас.",
    "cHJvX2xvYWRfZGF0ZV9jaGFuZ2VkX2VtYWls_remark": "Электронное письмо, отправленное при изменении ожидаемой даты загрузки контейнера.",
    "cG9fYWJub3JtYWxfZW1haWw=_remark": "Если по заказу (РО) возникнут изменения, Вам будет выслано письмо для подтверждения.",
    "cmVwbGVuaXNoX2lucXVpcnlfZW1haWxfY29kZQ==_remark": "Электронное письмо, отправленное при завершении проверки стоимости пополняемых товаров.",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA==_remark": "Электронное письмо, отправленное при завершении загрузки товаров в контейнер.",
    "cG9fYmlsbF9vZl9sYW5kaW5nX2VtYWls_remark": "Электронное письмо, отправленное при завершении создания коносамента на товар.",
    "UmVtYWluX0JhbGFuY2VfUGF5bWVudF9lbWFpbA==_remark": "Электронное письмо, отправленное при прибытии контейнера в порт.",
    "YnV5ZXJfc3RpbWFya19lbWFpbF9jb2Rl_remark": "Электронное письмо, отправленное при завершении изготовления этикеток и маркировки.",
    "YnV5ZXJfZ29vZHNfcmVjb21tZW5kX2VtYWlsX2NvZGU=_remark": "На Вашу электронную почту будут приходить письма с новинками",
    "QnV5ZXJfU3RhdGVtZW50cw==_remark": "Письмо с ежемесячной сверкой будет отправлено Вам на почту",
    "GengXinZhong1": "Обновляется",
    "DaiQueRen1": "В процессе подтверждения",
    "ZhongTu": "Средняя картинка",
    "XiaoTu": "Маленькая картинка",
    "FenBianLv": "Разрешение",
    "QingXuanZeTuPianGeShi": "Пожалуйста, выберите формат фото",
    "QingXuanZeShangPin": "Пожалуйста, выберите товары",
    "WaiBuDingDanHao": "Номер заказа",
    "JinNengXuanZeNGe": "Можно выбрать только  {0} товаров",
    "JieXiChuCuoQingChangShiZh": "Формат не соответствует требованиям, пожалуйста, повторно скачайте шаблон и загрузите ещё раз",
    "1007S0019": "Отсутствуют стикеры и маркировка {0}",
    "ShangChuanChengGongNKuan": "Успешно импортированные {0} товары",
    "ShangChuanShiBaiCunZaiBuYiZhiDeNeiRong": "Загрузка не удалась из-за наличия несоответствий в содержимом.",
    "MeiKuanShangPinZuiDuoZhiY": "На один артикул может быть только один образец маркировки",
    "TieMa": "Стикеры, маркировка",
    "ZiDuanZhiBuWanZheng": "Содержание полей недействительно",
    "ShangPin": "Товары",
    "De": "Информация по стикерам и маркировке",
    "CunZaiBuYiZhiDeNeiRong": "Информация содержит противоречия",
    "DingGouLiangWuXiao": "Общее количество на артикул {0} недействительно",
    "GaiShangPinYuJiZhuangGuiR": "Изменить дату отгрузки",
    "RuGuoMOQBuManZuQingJiangQ": "Если количества не соответствуют MOQ, пожалуйста, увеличьте их или добавьте артикулы из левой колонки",
    "RuGuoQiSongLiangBuManZuQ": "Если количества для доставки не достаточны, пожалуйста, увеличьте их или добавьте другие артикулы у этого поставщика",
    "RuGuoYuJiZhuangGuiRiQiBuM": "Если не получается установить нужную дату загрузки контейнера, пожалуйста, измените её",
    "MaiTouShuLiangBuNengChaoGuoShangPinShuL": "Количество маркировок не может превышать количество товара",
    "YangBanLieBiaoWeiK": "Список шаблонов пуст",
    "QingQingKongLieBiaoHouZaiShanC": "Пожалуйста, удалите всю информацию, затем удалите таблицу",
    "BaoCunTieZhiHeMaiTouYiC": "Сохранить изменения в стикерах и маркировке",
    "QingJiangTieZhiMaiTouXinXiTianXieWanZ": "Пожалуйста, предоставьте информацию по стикерам и маркировке",
    "BaoCunTieZhiHeMaiTouChengG": "Изменения успешно сохранены",
    "TieZhiYiJingYingShuaWanBiXuZhiFuFanGongFeiY": "Стикеры уже произведены. Чтобы изменить информацию для {0} понадобятся дополнительные расходы",
    "ShenQingXiuGai": "Заявка для изменения информации",
    "LeiBie": "Категории",
    "ShouFeiFangShi": "Способы оплаты",
    "ShouFeiBiaoZhun": "Виды оплат",
    "AnZhang": "По кол-ву стикеров",
    "AnXiang": "По кол-ву коробов",
    "ShenQingXiuGaiTieZhiChengG": "Заявка на изменение информации по стикерам успешно отпарвлена",
    "BuHuoShangPinShangWeiJinRuPODan": "Дозаказ не был добавлен в PO!",
    "CaoZuoChengGong": "Успешно совершено",
    "CaoZuoShiBai": "Не удалось совершить",
    "PaiBanTu": "Макет",
    "XiaZaiShiBai": "Не удалось загрузить",
    "JiaoHuoQi": "Срок отгрузки",
    "KeHuDingDanHao": "Номер заказа",
    "KuaiJieJian": "Горячие клавиши",
    "QiYong": "Начать работу",
    "YiQiYong": "Уже в работе",
    "XiangTongZiDuanZhiBiXuYiZhiQingHeDui": "Одинаковые ячейки должны быть идиентичны, пожалуйста, проверьте информацию по стикерам и маркировке",
    "GuDingTieZhi": "Фиксированные стикеры",
    "GuDingMaTou": "Фиксированная маркировка",
    "ShiYong": "Использовать",
    "BuShiYong": "Не используется",
    "YiShiYong": "Уже используется",
    "TiJiaoHeJia": "Отправить запрос",
    "ZanWuWenJianXuXiaZai": "Нет файлов для загрузки",
    "ChengGongTiJiaoBuManGuiXiaDanShenQing": "Заявка на неполный контейнер успешно подана.",
    "YaSuoBao": "архив",
    "ZuiZaoJiaoHuoRiQiWeiQingD": "Самая ранняя дата отгрузки {0}, пожалуйста, настройте дату загрузки",
    "CiMaiTouZanWuTuPianXinXi": "Нет фото для этой маркировки",
    "CiTieZhiZanWuTuPianXinXi": "Нет фото для этого стикера",
    "Huo": "или",
    "CiMaTouWuXuTianXieNeiRongQingXuanZe": "Выберите этот ярлык, если не требуется заполнять содержимое.",
    "JiWuLiaoDeHuoDongShangPinG": "Количество товаров, находящихся в контейнере  {0}, должно соответствовать MOQ {1}",
    "JiWuLiaoDeHuoDongShangPinC": "Количества товаров, учавствующих в акции {0}, должны соответствовать MOQ {1}",
    "HuoJuZhuangTaiChuYuBuManJ": "Заявка на отправку неполного контейнера находится в обработке.  Нельзя отправить",
    "SanHuoYiXiangZhuangJuRiQi": "Дата доставки дозаказа позже, чем отправка контейнера. Если Вы хотите отправить этот товар, то нужно указать дату отгрузки на {0} дней больше. Пожалуйста, исправьте дату отгрузки",
    "FeiSanHuoYiXiangZhuangJuR": "Дата доставки дозаказа позже, чем отправка контейнера. Если Вы хотите отправить этот товар, то нужно указать дату отгрузки на {0} дней больше. Пожалуйста, исправьте дату отгрузки",
    "HuoJuCunZaiHuoQiYiChangSh": "В контейнере находятся товары, по которым есть вопросы. Пожалуйста, решите их своевременно",
    "ShangPinDeTieZhiMaTouMeiY": "Стикеры и маркировка для артикулов {0} неверно настроены",
    "HuoDongShangPinXuYaoManZu": "Количество по товарам, участвующим в акции, должно соответствовать MOQ",
    "GongYingShangDingGouLiang": "Количества не соответствуют минимуму, при которых поставщик {0} сделает доставку",
    "TieZhiYiJingYingShuaWanBiCode": "Стикеры уже напечатаны",
    "TieZhiShengChanZhongCode": "Стикеры в процессе производства",
    "TieZhiMaTouMingChengZhong": "Впишите заново названия стикеров и маркировки",
    "YiKuanShangPinZhiNengLuRuYiFenMaiTouQingHeDui": "Одному артикулу может соответствовать только одна маркировка, пожалуйста, исправьте количество",
    "ShangPinBianHaoWuXiao": "Данный артикул не существует",
    "YiChangChuLiBaoCunChengGong": "Результаты успешно сохранены",
    "MeiYouBianGeng": "Нет изменений",
    "BaoZhuang": "{0} упаковок",
    "XuanZeQiTaBaoZhuangYuYan": "Упаковки на русском языке",
    "YuGaiShangPinXiangSiDe": "И подобные товары",
    "QingXuanZeShangPinShuLiang": "Пожалуйста, выберите количество",
    "ZhongZhi": "Обновить",
    "MeiZhaoDaoFuHeTiaoJianJiL": "Соответствующие записи не найдены. Пожалуйста,измените критерии фильтра",
    "GeShuHuiAnZhaoZhuangLiang": "Кол-во будет автоматически преобразовано в кол-во ящиков в зависимости от кол-ва товара",
    "ZuiXinShangPin1": "Новые продукты",
    "1059B10002": "Цена для доп. заказа ещё не утверждены",
    "BianJiGouWuChe": "Редактировать корзину",
    "Ge": "шт.",
    "GeShu": "Количество",
    "KeHuZiDingYiWenTi": "Вопросы Клиента",
    "DanWei": "Ед-ца измерения:",
    "BaoCunGouWuCheShuJuYiC": "При сохранении возникли несоответствия",
    "ShuJuChuLiYiChangQingShuaX": "Возникли несоответствия при обработке данных, пожалуйста, обновите страницу",
    "TianJiaYiHang": "Добавить строку",
    "ShangPinBianMaLuRuYouWuQingHeDui": "Ошибка в артикуле, пожалуйста проверьте и исправьте",
    "QingJiangShangPinXinXiTianXieWanZ": "Пожалуйста, заполните информацию о продукте",
    "ZhuangLiangBuYunXuBianJi": "Объём товара нельзя отредактировать",
    "BianHaoHuoMingCheng": "Пожалуйста, введите номер заказа",
    "ChengGongQuXiaoCaiGou": "Успешная отмена закупки",
    "PiLiangTianJiaShangPin": "Массовое добавление товаров.",
    "TianXieShangPinXinXi": "Заполните инфо о продукте",
    "BianHaoHuoZheMingChen": "Номер или имя",
    "DanYuanGeBiXuShiWenBenGeS": "Ячейки таблицы должны быть в текстовом формате",
    "XiangQingYeWuQuanXianTiShi": "Этот товар - новинка. Для его просмотра необходимо войти в учётную запись. Активация учётной записи займёт от 1 до 3-х рабочих дней. Пожалуйста, убедитесь, что предоставленные Вами контактные данные являются верными. Мы очень скоро свяжемся с Вами!",
    "XuanZeShangPin": "Выбрать товары",
    "Wu": "Нет",
    "JiXuPinGui": "Продолжить формирование контейнера",
    "HeDuiXinXi": "Проверить информацию",
    "ShangPinSuoZaiLeiMu": "Товар относится к категории",
    "DengLuXinLai": "Впервые на сайте?",
    "ZaiTuWeiHuoDeShouHuoRiQiC": "Дата получения товара, находящегося в пути {0} выходит за рамки планируемой даты отгрузки контейнера",
    "TuanGouShangPinDeShouHuoR": "Дата получения товара {0} выходит за рамки планируемой даты отгрузки контейнера",
    "DuoXuan": "Выбрать ещё",
    "ZhaoBuDaoGaiYeMian": "К сожалению, страница не найдена",
    "NiKeNengXuYaoHuiDao": "Возможно, Вам придется вернуться к",
    "HuoZheQu": "Или перейти",
    "YiChangShangPinYiBeiChuLi": "Несоответствия решены. Пожалуйста, обновите страницу для просмотра",
    "NinHaiYouShuXingMeiYouXuanZe": "Вы не выбрали характеристики",
    "NKuanShangPing": "{0} арт.",
    "DingGouLiangDanWeiXiang": "Объём заказа (Коробка)",
    "GeShuDanWeiGe": "Кол-во (шт.)",
    "ChengGongTiJiao{0}KuanDaoChu{1}BuNengDaoChu": "Успешно экспортировано {0} арт.  Нельзя экспортировать {1}",
    "ChengGongTiJiao{0}KuanTiWen{1}BuNengTiWen": "Успешно отправлено {0} арт. Среди них  к {1} нельзя задать вопросы",
    "ChengGongTiJiao{0}KuanShanChu{1}BuNengShanChu": "Успешно удалено {0} арт.  Товар {1} не может быть удалён",
    "ShouCangShangPin": "Избранные товары",
    "TianJiaGouWuCheChengGongHuoDongYiDaCheng": "Товар добавлен, условия достигнуты. Пожалуйста, подтвердите покупку в корзине",
    "GouWuCheYiYou{0}{1}": "Сейчас в корзине имеется  {0} шт. {1} арт. Заменить количество на прежнее?",
    "CiKuanHuoDongShangPinHuoDongYiDaCheng": "Эти акционные товары достигли условий, войдите в корзину, чтобы своевременно подтвердить покупку",
    "CiKuanHuoDongShangPinNinYiQueRenGouMai": "Необходимо утвердить покупку этих товаров. Пожалуйста. просмотрите количества в корзине",
    "YiChuHuoDongWeiDaChengSha": "Внимание: Данные товары по контейнеру артикулом {0} либо уже сняты с продаж, либо не прошли по результатам проведённой акции. По данным позициям невозможен сборный контейнер.",
    "HuoDongXiaoShouMOQBuNengXiaoYu": "Количество не может быть меньше MOQ",
    "ZiDingYiWenTiZiShuBuNengC": "Вопросы не могут превышать {0},{1}",
    "QingWenNinSanChuDeYuanYinShi": "Пожалуйста, укажите причину удаления",
    "DaiHuiFu": "Ответ",
    "YouHuiFu": "Есть ответ",
    "QingRenZhenTianXieYiXiaZiLiaoBaoZhengNeiRongZhenShi": "Пожалуйста, заполните эту информацию. Электронный ящик должен быть действительным, так как без него невозможно успешное завершение активизации",
    "WoMenJiangHuiTongGuoNinDeXinXiHuoZheDianHua": "Мы свяжемся с Вами по телефону или емэйлу, чтобы подтвердить заявку. Если Вы не закупаете игрушку или товары повседневного пользования, то регистрацию придётся отменить",
    "HuanYingLaiDaoEssa": "Добро пожаловать на WWW.ESSA.CN !",
    "NinKeYiChaKanChanPinDeJiaGe": "1. Вы можете просматривать <b>цены на товар</b>",
    "NinKeYiHuoQuDaoZuiXinDeChanPinXinXi": "2. Вы будете получать <b>всю информацию о продукте</b>",
    "WoMenJiangBuDingQiGeiNinTuiSongZuiXinDeYouHuiHuoDong": "3. Мы будем уведомлять Вас о <b>новых акциях и высылать специальные предложения</b>",
    "ZhuCeChengWeiEssaHuiYuanNinJiangKeHuoDe": "Зарегистрировавшись на нашем сайте, Вы будете иметь следующие преимущества:",
    "GongXiNinYiTiJiaoChengGong": "Поздравляем! Всё успешно отправлено",
    "JiDanShangPinMeiYouZaiJiD": "Товары, участвующие в предпродажах новинок {0} не в акции предпродаж новинок",
    "HuoDongShangPinXuYaoManZuH": "Необходимый MOQ товаров по акции{0}",
    "MiaoHou": "Через {0} сек.",
    "NinDeZhangHou": "Ваш логин",
    "1059PR10019": "Данный электронный ящик уже зарагистрирован",
    "WeiDengLuHuoWeiRenZhengQingRenZhengHouChaKan": "Незарегистрированные или неполучившие подтверждение пользователи, пожалуйста, подождите или пройдите регистрацию. Только после получения подтверждения, Вы сможете произвести калькуляцию цен на товар.",
    "WoDe": "Мой",
    "DingDan": "Заказ",
    "RenZhengHuoYongHuCaiKeCan": "Только зарегистрированные и VIP - пользователи могут принимать участие в акциях на товары, пожалуйста, своевременно обратитесь к Вашему оператору для подтверждения.",
    "YiTiWen": "Вопрос уже задан",
    "YiQueRenCaiGouDeHuoDongSh": "Подтверждённые на покупку товары по акции не могут быть повторно добавлены в корзину",
    "GaiBanWenTi": "Редакционные вопросы",
    "BuZhiChi": "Не поддерживает",
    "WoMenDeHeZuoHuoBan": "Наши партнёры",
    "100AnQuan": "100% безопасность",
    "GongChangJia": "Фабричные цены",
    "GaoXiaoBianJie": "Высокоэффективно и быстро",
    "ShiPinJieShao": "Видеопрезентация",
    "QingXuanZeNinSuoZaiDeGuoJ": "Пожалуйста, выберите Вашу страну",
    "DingWeiGuoJia": "Местонахождение/страна",
    "DingWeiShiBaiQingShouDong": "Ошибка в установлении местонахождения, пожалуйста, выберите в списке Вашу страну вручную или обновите страницу",
    "ZhengZaiDingWeiZhong": "В процессе определения местонахождения",
    "QingXuanZeGuoJia": "Пожалуйста, выберите страну или регион",
    "NinHaoNinShiGuoJiaCaiGouS": "Здравствуйте, Вы покупатель из страны {0}, мы уже помогли определить Ваше местонахождение {1}",
    "HuanYiPi": "Сменить партию.",
    "ZuiJinFangWenGuoJia": "Страны, которые недавно посещали сайт",
    "HuiYuanQuanYi": "Преимущества каждого уровня",
    "MianFeiChaKanJiHeDuiShangPinJiaGe": "Бесплатный просмотр и сопоставление цен на товары",
    "ChaKanZuiXinChanPin": "Возможность просмотра новейшей продукции",
    "DingQiHuoQuYouZhiShangPinTuiJian": "Регулярное получение предложений по товарам высокого качества",
    "ChaZhaoShangPin": "Поиск товаров",
    "ShangPinGuanLi": "Товары",
    "ZuZhiChuHuoJiHua": "Организовать план отгрузок",
    "ChaKanDingDanShengChanGuoCheng": "Просмотр процесса производства по заказу",
    "FuKuanShouHuo": "Оплата и получение товара",
    "YiZhanTiaoXuanShangPin": "Выбор товаров",
    "FenLeiChaZhao": "Поиск по категориям",
    "XiangSiKuanDuiBi": "Возможность сопоставления сходных товаров (по цене, материалам изготовления, функциям и т.д)",
    "RuHeChaZhaoShangPin": "Как искать товар?",
    "ShangPinZiZhuGuanLi": "Самоуправление товаром",
    "ZiDongHeJia": "Автоматическая калькуляция",
    "GuanLiShangPin": "Управление товаром",
    "GouWuCheGuanLi": "Управление \"Корзиной\"",
    "ShouGeZaiXianPinGuiDeJiaoYiPingTai": "Первая торговая онлайн-площадка сборных заказов",
    "GenJuJiHuaZiWoZuZhuang": "Самосборка согласно плану",
    "SheZhiYiXiangZhuangGuiShiJian": "Установить время загрузки контейнера",
    "SheZhiTieZhiMaiTouXinXi": "Установить информацию по маркировке",
    "RuHeJinXingPinGui": "Как выполнить совместную загрузку контейнера.",
    "QueRenDingDanXinXi": "Подтвердите информацию по заказу",
    "ZhiDingShengChanYaoQiu": "Установить требования по производству",
    "LiaoJieDingHuoYaoQiu": "Понять требования к заказу товара",
    "ChaKanShengChanJinDu": "Просмотр этапов производства",
    "WeiNinLiuXiaFanKuiXinXi": "Вам сообщение",
    "24XiaoShiSuiYiChaKanZuiXinDongTai": "Возможность круглосуточного просмотра обновлений",
    "ChaKanZhiJianTuPianJiXinXi": "Просмотр фотографий с инспекций и комментариев",
    "NinDeDingDanYiJingShengChanWanCheng": "Производство Вашего заказа уже завершено",
    "HuoYunYiJingDaoGang": "Груз уже в порту",
    "TiDanDianFangZaiXianChaKan": "Онлайн-просмотр телекс-релиза",
    "DingDanLiuCheng": "Процесс заказа",
    "PoDanLieBiao": "Заказы",
    "GongSiShiLi": "Сила компании",
    "ZhengShuBaoZhang": "Гарантийные сертификаты",
    "BaoZhangTiXi": "Гарантийная система",
    "KuaiSu": "Скорость",
    "GaoXiao": "Высокоэффективность",
    "ZhuZhan": "Поисковик по игрушкам и оптовым закупкам|ESSA.CN - Ваш лучший эксперт по поиску игрушек",
    "ZhuZhanFuWuXiangQing": "Детальное описание услуг главной станции",
    "AnBianHaoJingZhunSouSuo": "Точный поиск",
    "CaiGouWanJu": "Покупка игрушек",
    "CaiGouRiYongPin": "Покупка потребительских товаров",
    "ReMenTuiJian": "Популярные товары",
    "TuiJianMa": "Промокод код",
    "TuiJianMaWuXiao": "Промокод код неактивен, пожалуйста, введите вновь",
    "YiZhuCeChengGong": "Регистрация прошла успешно",
    "QingShuRuTuiJianMa": "Пожалуйста, введите промокод код",
    "BuYingYongTieZhi": "Неиспользуемый стикер",
    "BuYingYongMaTou": "Неиспользуемая маркировка",
    "ZhongXinJiHuoQingLianXiNi": "Для повторной активации, свяжитесь с Вашим специалистом службы клиентской поддержки. Просмотр контактов для связи с оператором:",
    "DengLuXiTong": "Зарегистрироваться в системе",
    "ShuBiaoYiRuNinDeZhangHao": "Наведите мышку на раздел \"Ваш аккаунт\"",
    "JinRuHuiYuanZhongXinShouY": "Войти на главную страницу пользовательского центра",
    "ZhiJieQuHuiYuanZhongXinSh": "Перейти на главную страницу пользователя",
    "NinYiJiHuoChengGongQingBa": "Активация прошла успешно, пожалуйста, убедитесь, что телефон и электронная почта доступны, пока Вам не придёт подтверждение от essa. Благодарим.",
    "RuoMeiNengJiShiWeiNinRenZ": "Если Вы не получили подтверждения от essa, вероятно, временно Вы не сможете просматривать цены на товар, пожалуйста, продолжайте ждать подтверждения. Мы приносим свои извинения за доставленные неудобства.",
    "LiuLanShangPin": "Просмотр товаров",
    "NinShiYongZhuCeYiChengGon": "Ваша пробная регистрация успешно завершена и будет доступна в течение 7 дней, пожалуйста, зайдите на почту и заранее активируйте долговременный аккаунт.",
    "ZhuYiXiaoShiHouRuoBuJiHuo": "Внимание: Если не активировать аккаунт спустя 7 дней, просмотр цен и популярных товаров будет Вам недоступен.",
    "JiHuoChengGong": "Активация прошла успешно",
    "JiHuoShiBai": "Ошибка активации",
    "QingXianXuanZeTieZhi": "Для начала выберите стикеры",
    "QingXianXuanZeMaTou": "Для начала выберите маркировку",
    "QingXianSheZhiTieZhi": "Для начала установите стикеры",
    "QingXianSheZhiMaTou": "Для начала установите маркировку",
    "SheZhiMaTouXinXi": "Заполните информацию по маркировке",
    "SheZhiTieZhiXinXi": "Заполните информацию по  стикеру",
    "YuLanDingDan": "Превью заказа",
    "ShangYiBu": "Предыдущее действие",
    "ZanShiBaoCun": "Временно сохранить",
    "ZanShiBaoCunChengGong": "Временно сохранено",
    "ZhengZaiBaoCun": "В процессе сохранения",
    "BuZhouYiQueRenNinYaoShiYo": "Шаг первый: Утвердите образец маркировки, которую Вы будете использовать (если здесь Вы не нашли соответствующего образца, пожалуйста, свяжитесь с нашим специалистом для предоставления образца)",
    "TianJiaMaTouMoBan": "Добавить шаблон маркировки",
    "XuanZeMaTouYangShi": "Выберите образец маркировки",
    "NinDeMaTouYangBan": "Ваш шаблон по маркировке",
    "WuMaTouYangShi": "Нет образца маркировки!",
    "BuZhouErGouXuanNinYaoShiY": "Шаг второй: Поставьте галочки у соответствующих этой маркировке товаров.",
    "TieZhiBuZhouYiQueRenNinYaoShiYo": "Шаг первый: Утвердите образец стикера, который Вы будете использовать (если здесь Вы не нашли соответствующего образца, пожалуйста, свяжитесь с нашим специалистом для предоставления образца)",
    "TianJiaTieZhiMoBan": "Добавить шаблон по стикерам",
    "NinDeTieZhiYangBan": "Шаблон Вашего стикера",
    "WuTieZhiYangBan": "Нет образца стикера!",
    "TieZhiBuZhouErGouXuanNinYaoShiY": "Шаг второй: Поставьте галочки у соответствующих этому стикеру товаров.",
    "TiShiTongYiKuanShangPinZh": "Напоминание: На один и тот же товар можно установить только одну маркировку",
    "TieZhiYangBanYuLanRuXia": "Предварительный просмотр образца по стикерам {0}",
    "MaTouYangBanYuLanRuXia": "Предварительный просмотр шаблона маркировки {0} ниже:",
    "NinHaoZiZhuSheZhiTieZhiMa": "Здравствуйте, функция по автономной установке стикеров и маркировок временно недоступна, пожалуйста, свяжитесь с Вашим менеджером, спасибо.",
    "BaoCunTieZhiYiChang": "Сбой при сохранении стикера",
    "BaoCunMaTouYiChang": "Сбой при сохранении маркировки",
    "DingDanZongJiaWei": "Общая сумма заказа",
    "MaiTouXinXi": "Информация по маркировке",
    "TieZhiXinXi": "Информация по стикерам",
    "NinBenCiBianJiDeTieZhiMaT": "Отредактированные Вами данные по стикерам и маркировке не были сохранены, Вы уверены, что хотите вернуться?",
    "HaiMeiYouMaTouTieZhiYangB": "Ещё не получили образцы маркировок и стикеров, пожалуйста, свяжитесь с Вашим менеджером и предоставьте ему всю необходимую информацию",
    "QingShuRuMingCheng": "Пожалуйста, введите название",
    "YiChangLieBiao": "Список изменений",
    "ZhengZaiShenHeZhongBuKeXiuGai": "В процессе проверки",
    "WuMaTouYangBan": "Образец без маркировки",
    "TiShiTongYiKuanShangPinKe": "Напоминание: На одинаковые товары можно установить несколько образцов стикеров",
    "WoShiMaiJia": "Я-производитель",
    "ZhongYangBanYuYeMianBuYiZ": "Образцы в Excel и на веб-странице не совпадают, пожалуйста, попробуйте скачать образцы снова",
    "WeiChanShengFeiYongJiJiangFanHuiPO": "Оплата не требуется, перейдите к заказу за более детальной информацией",
    "QingXuanZeTieZhiYangShi": "Пожалуйста, выберите модель стикера",
    "QingXuanZeMaTouYangShi": "Пожалуйста, выберите модель маркировки",
    "MoBanYouWuQingZhongXinXia": "Шаблон неверный, пожалуйста, скачайте и загрузите правильный вариант ещё раз",
    "QingJiangTieZhiXinXiTianX": "Пожалуйста, впишите всю информацию по стикеру",
    "QingJiangMaTouXinXiTianXi": "Пожалуйста, впишите всю информацию по маркировке",
    "QuShouYe": "Перейти на главную страницу",
    "WeiRenZhengWuFaXiaPinGuiXiaDan24XiaoShiNeiHuiLianXiNin": "Извините, пока Ваш аккаунт не подтверждён, Вы не сможете сделать заказ и сформировать сборный контейнер, в течение 24 часов сотрудник Essa свяжется с Вами, пожалуйста, не отключайте телефон и обновляйте информацию на электронной почте. Дождитесь подтверждения.",
    "QingLianXiNinDeZhuanShuYeWuKeFuJinXingZiXun": "При необходимости, Вы можете связаться с Вашим эксклюзивным специалистом из службы клиентской поддержки для консультации.",
    "ShiYongCaiGouShang": "Пробный аккаунт",
    "YuZhuangJuRiQiYiChang": "Сбой по предварительным датам загрузки контейнера",
    "GongChangDingGouLiangBuZu": "Недостаточный обьём заказа на фабрике",
    "GongChangQuXiaoShengChan": "Фабрика отменила производство",
    "YinWuLiaoCaiGouYiChangQuX": "Аннулировано, так как при закупе сырья произошёл сбой",
    "ZhengZaiYiChu": "Импорт",
    "ZhengZaiTianJia": "В процессе добавления",
    "LiShiYiChangQuXiaoJiLu": "История всех ранее удаленных товаров",
    "YiChangQuXiaoJiLu": "История удалённых позиций",
    "QuXiaoYuanYin": "Причина отмены",
    "QuXiaoShiJian": "Время отмены",
    "ZongGeShuDanWeiGe": "Отмена общего количества",
    "WoShiNinDeZhuanShuKeFuKeYiYuWoLianXi": "Я - Ваш консультант по продажам, если в процессе покупок у Вас возникнут вопросы, свяжитесь со мной.",
    "CongYeJingYan": "Опыт работы",
    "ShuXiYuYan": "Знание языков",
    "ZhuGongShiChangQuYu": "Основные регионы",
    "CongYeHangYe": "Предыдущий опыт работы, деятельность",
    "GeRenYouShiJiFuWuBeiZhu": "Личные качества",
    "ZiWoMiaoShu": "О себе",
    "NNianGongZuoJingYan": "{0}лет",
    "DianJiChaKanGengDuoZiLiao": "Нажмите для просмотра более детальной информации",
    "XiaoShouGuWen": "Консультант",
    "ZhengZaiXiaZai": "В процессе скачивания",
    "ShuangJiKongBaiBiaoGeJinR": "1. Кликните в пустую колонку в таблице для редактирования; нельзя редактировать уже в заполненных колонках, а также, нельзя скопировать и вставить",
    "BiaoGeZhiChiJianPanFuZhiH": "2. Таблица поддерживает сочетание горячих клавиш Ctrl+C (скопировать) и Ctrl+V (вставить)",
    "BiaoGeZhiChiDuoXuanDanYua": "3. Таблица поддерживает функцию скопировать-вставить в нескольких колонках одновременно",
    "ZhiChiCongZhongDuoGeDanYu": "4. Поддерживает копирование информации из таблицы Exel, сочетанием клавиш Ctrl+C, с  переносом и вставкой в пустые колонки таблицы на сайте, сочетанием клавиш Ctrl+V",
    "YinWuLiaoCaiGouYiChangBuNengXiaDan": "Приносим свои извинения, произошёл сбой в закупке сырья, Вы не можете продолжить оформление заказа.",
    "GongChangYiQuXiaoShengChanBuNengXiaDan": "Приносим свои извинения, фабрика остановила производство, Вы не можете продолжить оформление заказа.",
    "ZuoTian": "Вчера",
    "YongHuFangWenLiang": "Количество пользователей, посетивших сайт",
    "GuoJiaFangWenLiang": "Количество стран, посетивших сайт",
    "WoZhiDaoLe": "Ознакомлен",
    "XiaoShouGuWenXiangQing": "Подробнее о консультанте по продажам",
    "MoSiKeFuWuBu": "Московский офис",
    "QuXiaoXiangShu": "Отмена 2 коробок",
    "ShengChanQuXiao": "Отмена производства",
    "DingDanBianHao": "Номер заказа",
    "CaoZuo": "Действие",
    "XiaDanShiJian": "Время заказа",
    "ShangPinLaiYuan": "Товарные ресурсы",
    "ShangPinLeiXing": "Тип товара",
    "KuaiSuBiJia": "Сравнить цены",
    "DeGongChangKuChanPinKuYiJ": "Фабричный склад essa платформы содержит информацию о 20 000 производителях игрушек в Китае",
    "QingShuRuGongYingShangMin": "Пожалуйста, введите наименование поставщика, название бренда, артикул товара фабрики или ключевое слово по товару",
    "RuHeBiJia": "Как сравнить цены?",
    "DiYiBuJingZhunSouXuanShan": "Точно отобрать товары",
    "DiErBuQuXunJia": "Запрос цен",
    "DiSanBuGouWuCheHuoQuGongY": "Перенесите товары в корзину для получения обновлённых цен от производителей",
    "DiSiBuDaoChuBaoJiaDanBiJi": "Экспортировать коммерческое предложение для сравнения цен",
    "DeWanJuKuanShiDouZaiZheiL": "Здесь Вы сможете найти более 80% моделей игрушек со всего мира",
    "DiYiBu": "Шаг 1:",
    "DiErBu": "Шаг 2:",
    "DiSanBu": "Шаг 3:",
    "DiSiBu": "Шаг 4:",
    "GuoQuYiTianWanGongChangZh": "Вчера, из 20 000 фабрик, {0} производителей добавили  {1} новинку на платформу.",
    "GuoQuYiZhouWanGongChangZh": "На прошлой неделе, из 20 000 фабрик, {0} производителей добавили {1} новинку на платформу.",
    "GuoQuYiGeYueWanGongChangZ": "В прошлом месяце, из 20 000 фабрик, {0} производителей добавили {1} новинку на платформу.",
    "ZhongTiJi": "Отмена общего объёма",
    "TiShiShangPinYouDuoKuanSh": "Напоминание: Вы можете добавить больше образцов маркировок, если моделей у товара несколько.",
    "TiShiKeXuanZeDuoGeTieZhiY": "Напоминание: можно выбрать несколько моделей стикеров",
    "ZhuYiZongGeShuHeDingGouLi": "Внимание: Внося данные из таблицы Excel, Вы можете выбрать либо графу с общим кол-ом шт товара, либо графу с общим кол-ом упаковок. Если Вы внесли две графы, подсчёт осуществится по графе - кол-во шт (общее кол-во = упаковка х вместимость)",
    "GongYingShangMingCheng": "Поставщик",
    "DengYu": "Равносильно",
    "DaYu": "Больше, чем",
    "KuanXiangSi": "{0}подобных моделей",
    "ChaKanQuanBuXinPin": "Просмотр всей продукции",
    "XinPinBaoHu": "Защита новых товаров.",
    "CiShangPinShuYuXinKuanBao": "Ваш аккаунт на рассмотрении сертификации, пожалуйста подождите!",
    "GongZuoShiJianNeiFenZhong": "В рабочее время, подтверждение поступит в течение 5 минут",
    "FeiGongZuoShiJianYuJiXuYa": "Запрос на подтверждение, полученный в нерабочее время, будет подтверждён в течение 2-х рабочих дней",
    "QingLianXiNinDeXiaoShouGu": "Свяжитесь с Вашим продавцом-консультантом {0}  для завершения сертификации",
    "GengDuoShaiXuanXiang": "Больше опций для отбора товара",
    "RenZhengYongHuKeJian": "Видно подтверждённым пользователям",
    "ChaKanJiaGeQingXianDengLu": "Для просмотра цен, сначала зарегистрируйтесь",
    "RenZhengHouKeJianJiaGe": "После подтверждения будут видны цены",
    "ZuiJinYiGeYue": "За последний месяц",
    "JiaGongChangShangXinLeKua": "{0} производителей добавили {1} новинку",
    "ZuiJinYiGeYuePinPaiShangX": "Новинки брендов за последний месяц",
    "ChuHuoQuYu": "Место отправки",
    "XinZeng": "Добавить",
    "BaoZhuangFangShi": "Способ упаковки",
    "XiaoYuDengYu": "Меньше или равно",
    "XinPinQingBao": "Новинки",
    "GongYouJiaGongChangKuanXi": "Всего {0} производителей добавили {1} новинку",
    "CunZaiBuFuHeTiaoJianDaoRu": "Товары, не соответствующие условиям, не могут быть перенесены в корзину",
    "NinZhangHaoDengJiBuNengCh": "Не удаётся найти товар по заданным условиям",
    "KuanXinPin": "{0}новинок",
    "PinPaiLeiXing": "Отборка брендов",
    "WoGuanZhuDePinPai": "Бренды, которые мне интересны",
    "TuiJianPinPai": "Рекомендуемые бренды",
    "XinPin": "Новинки",
    "XiangSiKuanShuLiang": "Количество подобных моделей",
    "ChanDiQuYu": "Место производства",
    "QuanBuShangPin": "Все товары",
    "KePinJu": "Готовы к заказу",
    "HuoDongShangPin": "Товары в совместных заказах",
    "QingYouXianChuLiYiXiaShan": "Сначала обработайте данные товары",
    "NinCanJiaDeJiDanHeTuanGou": "Вы участвовали в акциях \"Предпродажи новинок\" и \"Групповые покупки\", как только по данным товарам будут достигнуты условия, мы разместим заказ на производство, пожалуйста, подтвердите.",
    "SanTianNeiBuQueRenCaiGouX": "В течение 3 дней, если покупка не будет подтверждена, система автоматически её отменит.",
    "ZhuTi": "Тема",
    "ShiXiao": "Сбой",
    "GuoQi": "Истёк срок",
    "TianJiaJinGouWuCheShiJian": "Время добавления в корзину",
    "GuoQiShangPinQingJinKuaiP": "Срок действия товаров истек. Пожалуйста, запросите цену заново и оперативно добавьте их в совместную загрузку",
    "YiQueRenDeHuoDongBuNengSh": "Подтверждённую акцию удалить нельзя, пожалуйста, уберите галочки",
    "YiJiang": "Снизились",
    "YiSheng": "Повысились",
    "GaiKuanShangPinZhengZaiDe": "По данной позиции ожидается подтверждение от фабрики, ориентировочно, в течение 1-2 рабочих дней",
    "XinPinYuShou": "Предпродажа новинок",
    "YiQueRen": "Подтверждено",
    "TianHouZiDongShanChu": "Через {0} дней автоматическое удаление",
    "ShangPinXinXi": "Информация о товарах",
    "ZhongXinChuJia": "Переговоры",
    "NinDeGouWuCheMeiYouShangP": "В Вашей корзине нет товаров",
    "HuoDongZhuangTai": "Статус активности",
    "XunJiaZhuangTai": "Запрос о цене",
    "YiXiaShangPinWeiGouWuCheL": "Данные товары - это все товары из корзины",
    "YiXiaShangPinWeiHuoDongSh": "Данные товары участвуют в акции",
    "YiXiaShangPinYiManZuPinJu": "По данным товарам условия для LCL достигнуты",
    "YiXiaShangPinYiXunJiaWanC": "По данным товарам уже запрошены цены или условия акции достигнуты, перейдите в LCL для заказа",
    "XunJiaHouYiXiaShangPinYou": "После запроса цен по данным товарам есть изменения",
    "YiXiaShangPinKeNengShiJia": "По данным товарам в цене произошли изменения, пожалуйста, для начала возьмите в обработку, после получения обновлённой информации, Вы сможете оформить заказ.",
    "GongKuanDaiQueRenCaiGouDe": "Всего {0} товаров ожидает подтверждения",
    "PiLiangShanChu": "Удалить выделенное",
    "PiLiangTiWen": "Запрос по выбранным",
    "PiLiangDaoChu": "Скачать выделенное",
    "PiLiangDaoRu": "Загрузить из Еxcel",
    "QingChuShiXiaoShangPin": "Удалить снятые с производства",
    "ChaKanKePinJuShangPin": "Просмотреть возможные товары к LCL",
    "PiLiangJieShou": "Массовый приём",
    "KaiShiPinJu": "Начало LCL",
    "DaoChuBaoJiaDan": "Экспорт коммерческого предложения",
    "QueDingCongGouWuCheZhongS": "Удалить из корзины все выбранные модели?",
    "QueDingCongGouWuCheZhongQ": "Удалить из корзины все недействительные модели?",
    "NinKeYiDiaoZhengJiaGeHuoD": "Вы можете откорректировать цены или объём заказа и ещё раз отправить запрос поставщику для согласования цен",
    "TuanGouQiaTanZhong": "Групповая покупка в процессе обсуждения",
    "TuanGouShiBai": "Групповая покупка не выполнена",
    "TuanGouChengGong": "Групповая покупка прошла успешно",
    "XinPinYuShouZhong": "Предпродажи новинок",
    "XinPinYuShouQiaTanZhong": "Предпродажа новинок в процессе обсуждения",
    "XinPinYuShouShiBai": "Сбой в предпродаже новинок",
    "XinPinYuShouChengGong": "Успешная предпродажа новинок",
    "CanKaoJia": "Справочная цена",
    "MeiYouSheZhiZhuTiDeShangP": "Товары без тематики",
    "SheZhiZhuTi": "Установить тематику",
    "QuanBuShuXing": "Все свойства",
    "QueDingJieShouSuoYouXuanZ": "Принять все выбранные позиции? Подтвердите",
    "GongTiWenLeGeWenTi": "Всего задано {0} вопросов",
    "QiTaCaiGouShangDaiLiShang": "Товар под представительством другого покупателя",
    "QiTaCaiGouShangZhuanShuSh": "Эксклюзивный товар другого покупателя",
    "XiaJiaShangPin": "Товар снят с продажи",
    "XinPinYuShouShiBaiShangPi": "Товары, не прошедшие предпродажу.",
    "YiQueRenGouMaiDingGouLian": "Утвердив покупку, зайдите в корзину для корректировки количества заказа",
    "WuShangPinChaKanQuanXianQ": "Вы не можете просмотреть информацию по данному товару, свяжитесь с Вашим менеджером для консультации",
    "ZhuYiHeBingDaoXinZhuTiDeS": "Внимание: товары, добавленные для создания новой темы, будут перенесены из графы исходной темы",
    "ChuangJianXinZhuTi": "Создать новую тематику",
    "JiaRuYiYouZhuTi": "Добавить тематику из имеющихся",
    "QingShuRuZhuTi": "Введите тематику",
    "ZhengZhuang": "В собранном виде",
    "FenZhuang": "Фасовка",
    "WuZhuTi": "Без темы",
    "ShengYuQueRenShiJian": "Осталось{0}часов на подтверждение",
    "KaiShiShiJian": "Время начала",
    "JieShuShiJian": "Время окончания",
    "BaoZhuangLeiXing": "Виды упаковки",
    "YinHuoDongYiDaChengWeiJiS": "Условия акции уже были достигнуты, но покупка не была подтверждена вовремя",
    "ShangPinYiZhongXinFaQiYiJ": "Повторное согласование цен по данному товару",
    "ShangPinYiXiaJia": "Товар уже снят с продажи",
    "YinShangPinYiJingCanYuHuo": "Товары, участвующие в акции, нельзя напрямую добавить в LCL",
    "GongKuanShangPinKeYiPinJu": "Всего{0}моделей можно добавить в LCL",
    "QingJinKuaiZaiShangPinXia": "Пожалуйста, подтвердите информацию по товару в течение установленного времени, по истечению которого система автоматически удалит закупку",
    "HuiLvBianHua": "Колебания валютного курса",
    "JiaJiaLvBianHua": "Колебания процентной надбавки",
    "ShangPinTiJiBianHua": "Изменение объема товара",
    "ShangPinZhuangLiangBianHu": "Изменение вместимости упаковки",
    "ShangPinZhongLiangBianHua": "Изменения веса товара",
    "ChangGuiBaoJiaDan": "Стандартный прайслист",
    "ShangPinChuHuoCangMoRenWe": "Склад отгрузки, по умолчанию считается местом производства.",
    "ZhiDingShangPinBaoJiaFang": "Перенести в прайс-лист утверждённый способ просчёта цен на товар",
    "ShangPinChuHuoJiangAnSuoX": "Стоимость отгрузки товара рассчитывается в зависимости от выбранного склада отгрузки, порта отправки и типа контейнера, однако, могут возникнуть дополнительные расходы при перевозке товара на короткое расстояние, которые повлияют на FOB цену каждого товара в контейнере",
    "GaiShangPinYiGuoJiaGeBaoHuNC": "Срок действия цены на данный товар истекает, осталось  {0}  дней для принятия решения",
    "YuanWaiXiangZhuangLiang": "Изначальная вместимость",
    "ShangPinYiPinRuZaiHaoHuoJ": "Товар консолидирован в контейнере {0}, для начала переместите из контейнера, пожалуйста.",
    "ShangPinYiZaiDingDanZhong": "Товар уже в процессе восполнения и находится в бланке заказа {0}, пожалуйста, переместите его из раздела пополнения запаса товаров",
    "CunZaiShangPinBuNengShanC": "Данные товары удалить нельзя, пожалуйста, проверьте.",
    "FOBJunTan": "FOB за каждую позицию в контейнере",
    "ShangPinBaoJia": "Цена за товар",
    "ZanShiMeiYouShiXiaoBaoBei": "Временно нет недействительных товаров.",
    "JiaGeBiYuanJiaGeGaoShiFouYiJia": "Стоимость выше, чем изначальная, продолжить согласование по цене?",
    "WanJuCaiGouPiFaYiGeChiXuG": "Поиск игрушек и оптовые продажи|Только новинки на платформе",
    "HuoDongShangPinBuXiaoYuN": "Объём заказа по товарам, участвующим в акции, не должен быть менее, чем MOQ продаж: {0}.",
    "QingXuanZePinGuiDeZiYuan": "Пожалуйста, выберите товары для сборного контейнера",
    "ChanDi": "Место производства",
    "KePinLiang": "Количество",
    "GouWuCheShangPin": "Товары в корзине",
    "YiRu": "Перенести",
    "YiPinLiang": "Уже в LCL",
    "WeiManZuCaiGouTiaoJianShangPin": "Товары, по которым не достигнуты условия покупки",
    "BaoJiaGuiZe": "Что такое EWX / FOB",
    "BaoJiaGuiZe1": "Порядок объявления стандартной цены EXW",
    "BaoJiaGuiZe2": "Указанная стоимость – стоимость за товар на складе отгрузки (склад отгрузки, как место производства данного товара)",
    "BaoJiaGuiZe3": "Порядок объявления стандартной цены FOB",
    "BaoJiaGuiZe4": "Когда местом происхождения товара является Шаньтоу",
    "ShanTouZuHeBaoJia": "Шаньтоу (склад отгрузки) – Шаньтоу (порт отгрузки) – 40HQ (тип контейнера) – комплексная стоимость",
    "BaoJiaGuiZe5": "Когда местом происхождения товара является Гуанчжоу",
    "BaoJiaGuiZe6": "Когда местом происхождения товара является Иу",
    "GuangZhouZuHeBaoJia": "Гуанчжоу (склад отгрузки) – Гуанчжоу (порт отгрузки) – 40HQ (тип контейнера) – комплексная стоимость",
    "YiWuZuHeBaoJia": "Иу (склад отгрузки) – Нинбо (порт отгрузки) – 40HQ (тип контейнера) – комплексная стоимость",
    "BaoJiaGuiZeZhuYi": "Внимание: корректировки склада отгрузки, порта отправки, типа контейнера при заказе, могут повлиять на FOB стоимость каждой позиции в контейнере. (Возникает дополнительный расход доставки товара от фабрики до склада отгрузки)",
    "BuFenShangPinBuFuHePinGui": "Часть товаров не подходят для сборника, система автоматически удалит из контейнера",
    "BuYunXuPinGuiYuanYin": "Причина отказа в консолидации",
    "YiChuShiJian": "Время экспорта",
    "BuFuHePinGuiKuan": "Нижеследующие товары {0} не подходят для консолидации, система уже извлекла их из контейнера.",
    "YiXiangBangZhu1": "1.Целевое время загрузки контейнера: текущее время – время загрузки контейнера, начало отсчёта;",
    "YiXiangBangZhu2": "2. Для отгрузки товара необходимо создать стикеры и маркировку, забукировать место на судне, указать время транспортировки и т.д, поэтому самое короткое время для отгрузки – 15 дней, только в том случае, когда самое долгое время производства товара в контейнере + время подготовки более, чем 15 дней, можно корректировать целевое время загрузки;",
    "YiXiangBangZhu3": "Целевое время загрузки указано раньше, чем предполагаемое время загрузки, необходимо подтверждение от essa",
    "YuanJia": "Старая цена",
    "HuoGui": "Контейнер",
    "CartMeiYouPinGuiShangPin": "В Вашей корзине нет товаров, которые можно консолидировать.",
    "XiaYiBuSheZhiTieZhiMaiTou": "Далее, настройка стикеров и маркировок",
    "HuoDongShangPinBuZhiChiYiJia": "По товарам, которые участвуют в акции, пока нельзя согласовать стоимость.",
    "TiaoZhengJiaGeHuoDingGouLiang": "Отправьте запрос производителю для изменения цены. Укажите желаемое кол-во.",
    "WeiTongGuoRenZhen": "Аккаунт ещё не подтверждён, целевая, закупочная стоимость и объём заказа можно будет запросить у производителя сразу после того, как аккаунт пройдёт подтверждение. Пожалуйста, дождитесь",
    "WoDeZhuangGuiRiQi": "Целевая дата загрузки контейнера",
    "ShangPinZhuangGuiRiQi": "Изменить дату отгрузки",
    "ZuiDaKePinLiang": "Максимальное кол-во для LCL",
    "ShangPinGuoQiQingJinKuaiPinGui": "По данным товарам необходимо как можно скорее завершить консолидацию, через {0} дней они будут удалены",
    "QiDingLiangBuZuQingTiaoZheng": "Из-за недостаточного Мин.заказ, заказ невозможен, добавите количество заказа",
    "KePinRuLiangYiDaZuiDaJiXu": "Максимально возможное количество консолидации уже достигнуто, для продолжения консолидации, пожалуйста, перейдите в корзину и увеличьте объём заказа по товару",
    "QuGouWuChe": "В корзину",
    "YiXiaShangPinBuYunXuDaoRu": "Нижеследующие {0} товары не могут быть экспортированы",
    "QingShuRuZhengZhengShu": "Введите положительное целое число",
    "ShangPinBianHaoNYiCunZai": "Артикул товара {0} уже существует",
    "QingShuRuXiaoShuWeiNZhengShu": "Пожалуйста, введите десятичное, целое число, максимальное количество знаков{0}",
    "JiaZaiZhuTiShiBai": "Ошибка загрузки темы",
    "XuanZeYiYouZhuTi": "Выберите уже существующую тему",
    "XinZhuTi": "Новая тема",
    "QingShuRuBenCiTianJiaShangPinZhuTi": "Пожалуйста, введите тему товара, который был добавлен в этот раз",
    "BuYunXuDaoRuYuanYin": "Причина невозможной выгрузки",
    "JiaGeBaoJiaFangShi": "Цена (Способ расчёта цены: {0})",
    "YiChangShangPinBuNengTiWen": "Нельзя запрашивать информацию о необычных товарах, они не подлежат запросам или запросам на цены. Пожалуйста, сначала разберитесь с проблемой.",
    "GouWuCheNeiHaiMeiYouShang": "Корзина пуста, Вы можете выбрать необходимые товары на платформе и добавить их в корзину или перенести группу товаров.",
    "PiLiangDaoRuShangPin": "Импорт группы товаров",
    "QiSongLiangBuZu": "Недостаточное заказанное количество для поставки",
    "DangQianYiXiangZhuangJuRi": "Ожидаемая дата загрузки неправильна, исправьте",
    "WeiHuoGuoQiQingChuLi": "Производство товара достаточно долгое, исправьте ожидаемую дату отгрузки",
    "ZuiJinYiZhou": "За последнюю неделю",
    "ZuiJinSanGeYue": "За последние 3 месяца",
    "QingShuRuTuiJianZhuTi": "Введите рекомендуемую тему",
    "TuiJianMiaoShu": "Описание предложения",
    "TuiJianShiJian": "Время предложения",
    "ChaKanQuanBuShangPin": "Просмотр всех товаров",
    "ShiXiaoShangPinBuNengCanJiaCaiGou": "Закуп этих товаров невозможен",
    "CunZaiBuManZuXiaDanTiaoJi": "В контейнере есть товары, заказ которых невозможен, просмотреть контейнер можно по группам производителей, действуйте, как указано на странице.",
    "JiaBaoNeiBuYiJiaJiangBuFa": "Если при повторном запросе на согласование стоимости ни цены, ни кол-во заказа не были исправлены, предложение по цене не отправят",
    "GongYingShangZaiShou": "Товары в продаже",
    "WuYiChangTianJia": "Товары в корзине, запрос цен по которым прошел успешно, доступны для добавления",
    "GongYingShangWuKePin": "Товары данного производителя не для LCL, увеличьте количество товаров, уже добавленных в контейнер или выберите другие позиции и отправьте на запрос цен, а после добавьте в LCL.",
    "JingPinTuiJian": "Рекомендации лучших товаров",
    "HuoDongTuiJian": "Рекомендации по акциям",
    "JingZhunTuiJian": "Точнейшие рекомендации",
    "ReXiaoTuiJian": "Популярное",
    "DaoChuShangPin1": "Экспорт товаров.",
    "YiXiaJiaBuNengTianJiaGouW": "{0} Товар снят с продаж и в корзину добавлен быть не может",
    "CaoZuoShiJian": "Время обработки",
    "QingShuaXinYeMian": "Пожалуйста, обновите главную страницу",
    "QingXuanZeYuanYin": "Выберите причину",
    "QingXianXuanZePinJuShangP": "Сначала выберите товары для LCL",
    "QingXianXuanZeHuoJuZhongS": "Выберите товары в контейнере",
    "WuKePinJuShangPin": "Товары,которые не подходят для LCL",
    "WuJiaGeYiChangShangPin": "Товары по прежним ценам",
    "WuHuoDongShangPin": "Товары не по акции",
    "HuoDongShangPinShengYuDeD": "{0} Остаточный объём заказа товаров по акции или объём дозаказанного товара не соответствует MOQ продаж по акции, в данном случае, фабрика не примет заказ, пожалуйста, откорректируйте.",
    "GaiHuoDongShangPinShengYu": "Ваш объём заказа не соответствует требованиям MOQ, указанным в акции, необходимо откорректировать, иначе фабрика не примет заказ.",
    "ZhuYiHuoJuBaoJiaFangShiCh": "Внимание: изменения способа расчёта стоимости, склада отгрузки, порта отправки или типа контейнера могут повлиять на FOB цену каждой позиции в контейнере, вероятно, возникнет расход за транспортировку на близкое расстояние (если место производства и склад отгрузки находятся не на одной территории).",
    "GouWuCheNeiZanShiMeiYouSh": "На данный момент в корзине нет товаров, Вы можете внести несколько товаров одновременно или добавить по одному",
    "KeSheZhiNinDeYiXiangZhuan": "Установите ориентировочную дату загрузки, мы попробуем согласовать её с фабрикой",
    "DingGouLiangYiQueRenQieBu": "Количество активных товаров подтверждено и не может быть уменьшено, если у Вас есть вопросы, пожалуйста обратитесь в онлайн-службу поддержки клиентов",
    "DingGouLiangZengJiaHouBuN": "Добавленное количество к заказу уменьшить нельзя, продолжить?",
    "LiShiXiaDanHaiWeiZhuangJu": "Пожалуйста, оформите  товар, который не прошёл по предыдущему заказу",
    "WangJiMiMa": "Забыли пароль",
    "RiYongPinLeiMu": "Категории предметов ежедневного пользования",
    "WanJuLeiMu": "Категории игрушек",
    "FenLei": "Категории",
    "BianJiTieZhi": "Отредактировать стикер",
    "BianJiMaiTou": "Отредактировать маркировку",
    "ChaKanTieZhiMaTou": "Просмотреть маркировки, стикеры",
    "WaiXiangChiCun2": "Размеры короба",
    "ShouCangPinPai": "Фокус на брендах",
    "ShangPinXiangQing": "Детали о продукте",
    "ChanPinRenZhen": "Сертификация продукта",
    "CheJian": "Цех",
    "ZiYouZhanTing": "Фабричный выставочный стенд",
    "BanGongQuYu": "Офисные площади",
    "ShouQiGengDuoWenTi": "Не показывать все вопросы",
    "ZhanKaiGengDuoWenTi": "Просмотреть все вопросы",
    "HuoDongMuBiaoXiangShu": "Цель акции",
    "YiDaChengHuoDongMuBiaoXiangShu": "Достигнуты условия акции по количеству коробок",
    "HaiChaXiangShu": "Ещё осталось",
    "TuanGouTip2": "Достигнуты условия по товарам, участвующим в акции - групповые закупки, сейчас уточняются все вопросы с производителем, как можно скорее добавьте позиции в корзину и уточните количество коробок",
    "TuanGouTip1": "Товары участвуют в акции в групповых покупках, чем раньше Вы добавите данные позиции в корзину, тем больше будет выгода",
    "YuShouTip2": "Достигнуты условия по товарам, участвующим в акции по предпродажам новинок, сейчас уточняются все вопросы с производителем, как можно скорее добавьте позиции в корзину и уточните количество коробок",
    "YuShouTip1": "Товары участвуют в акции по предпродаже новинок. Формируйте заказы для снижения MOQ",
    "YiShouZangShangPin": "Товары, добавленные в избранное",
    "YiShouZangPinPai": "Вы уже подписаны",
    "PinPai": "Бренды",
    "HuoDongGuiZe": "Правила акции",
    "NinYiChengGongDengLuQingX": "Вы успешно вошли в систему. Пожалуйста, сначала выберите консультанта по продажам.",
    "NinZhiQianYiXuanZeLeXiaoS": "Ранее, Вы уже выбрали своего менеджера для консультаций, обновите страницу и перейдите на главную.",
    "KeCanGuan": "Можно посетить фабрику",
    "BaoZhuangXingShi": "Тип упаковки",
    "NeiRongWeiKong": "Поле ещё не заполнено, пожалуйста, свяжитесь с Вашим менеджером для предоставления образца к заполнению",
    "DangQianWuKeYongDeMaTouYa": "Если Вы не нашли подходящего образца маркировки, соответствующего требованиям Вашей компании, пожалуйста, отправьте образец Вашей маркировки на почту Вашего консультанта по продажам.",
    "DangQianWuKeYongDeTieZhiY": "Если Вы не нашли подходящего образца стикера, соответствующего требованиям Вашей компании, пожалуйста, отправьте образец стикера на почту Вашего консультанта по продажам.",
    "ZhuCeTiaoJian1": "Я согласен и принимаю условия",
    "ZhuCeTiaoJian2": "\"Платформа ESSA для регистрации покупателей и условий предоставления услуг\"",
    "ZhuCeTiaoJian3": "Пожалуйста, прочитайте и выберите, согласны ли вы с вышеуказанными условиями регистрации",
    "WeiZhaoDaoFuHeTiaoJianDeDingDan": "Если Вы не нашли номер заказа по заданным требованиям, пожалуйста, внесите номер заказа ещё раз",
    "PingTaiZhuCeJiFuWuTiaoKuan": "Регистрация покупателей на платформе ESSA и условия предоставления услуг",
    "YuanGongZhangHaoWeiKong": "Вы можете создать учётную запись для сотрудников компании и зарегистрироваться на платформе ESSA, далее, Вы сможете выбирать товары, запрашивать цены, выгружать из системы прайсы, формировать сборник, оформлять заказы и т.д.",
    "DianWoTianJia": "Нажмите, чтобы добавить",
    "WanShanZiliaoKeZengJiaXinYuDu": "Корректная информация повышает степень доверия",
    "QingXuanZeYiXiangCaiGouShangPin": "Пожалуйста, выберите категорию закупок",
    "QingXuanZeZhiWu": "Выберите должность",
    "DanPinShengChanYaoQiu": "Индивидуальные требования",
    "GongChangFanKuiJiLu": "Записи ответов фабрики",
    "ChaKanFanKuiJiLu": "Просмотр записей по ответам",
    "QingShuRuShengChanYaoQiu": "Пожалуйста, внесите индивидуальные требования по товару",
    "TeShuShangPinShengChanYaoQiu": "Индивидуальные требования по товару",
    "WeiHuoShangPinBuNengChongSheShengChanYaoQiu": "Внимание: по остаточному товару Вы не можете заново установить требования по производству, если у Вас есть дополнения, впишите их в графу \"неучтённые требования в производстве\". ESSA Вам ответит.",
    "GouWuCheZhongDeZiDingYiWenTi": "Вопросы в корзине покупок",
    "WenTi": "Вопросы",
    "HuiFu": "Ответить",
    "ZuiDuoShuRu1000GeZiAo": "Количество знаков по особым требованиям к производству не должно превышать 1000",
    "KeHuHuoHao": "Клиентский артикул товара",
    "QingShuRuShangPinBianHao": "Пожалуйста, введите артикул товара",
    "QingShuRuGongChangHuoHao": "Пожалуйста, введите заводской артикул товара",
    "QingShuRuKeHuHuoHao": "Пожалуйста, введите артикул клиентского товара",
    "ZanWuFanKuiJiLu": "На данный момент нет ответов",
    "GongChangFanKui": "Ответ фабрики",
    "ShouQuan": "Согласен",
    "BuShouQuan": "Нельзя, необходимо оповестить нас",
    "NinKeYiZhenDuiBenCiDingDa": "К примеру: характеристики батареек, требования к упаковке и т.д.",
    "ChangGuiShengChanYaoQiu": "Требования к производству",
    "QingXianSheZhiDingDanXian": "Пожалуйста, установите требования по заказу",
    "TieZhiMaTouXinXiHeDui": "Сверьте данные по маркировкам и стикерам",
    "QingXuanZeShouQuanFangShi": "Пожалуйста, выберите способ авторизации",
    "ShengYuKePinXiangShu": "Оставшееся количество можно в сборник",
    "YiPinXiangShu": "Сконсолидированное количество {0}",
    "ZuiDuoShuRuZi": "Максимальное количество знаков {0}",
    "RuGuoNinBenCiDingDanZhong": "Если по данному заказу у Вас есть определённые требования по производству конкретных позиций, пропишите их, ESSA возьмёт на контроль процесс производства",
    "NinYiJingShenQingBuHuoSha": "Вы уже сделали запрос на пополнение товара, в работе у Essa",
    "FeiShengChanYaoQiu": "Essa примечания",
    "YiXiaKuanShangPinGongChan": "По нижеследующим товарам {0} есть ответ от фабрики",
    "YouTiWenDeShangPin": "Товар, по которому был сделан запрос",
    "YouShengChanYaoQiuShangPi": "Товары, по которым есть особые требования",
    "ShangPinDeTiWen": "Запрос по товарам",
    "BuHuoJuTiJinEJiangYiZuiZh": "Конкретная стоимость по дополненному товару будет посчитана по факту успешно добавленных товаров к заказу",
    "BuHuoShangPinZongJia": "Общая стоимость по добавленным товарам",
    "DingDanYiChangYiBeiQiTaRe": "Сбои по заказу уже были устранены",
    "QueRenBuHuo": "Подтвердить пополнение товара",
    "QueRenBuHuoDingDan": "Подтвердить информацию о добавлении товара",
    "BuHuoTiJi": "Обьём добавленного товара",
    "ZongKuanShu": "Общее количество моделей",
    "BuHuoKuanShu": "Количество моделей по добавленному товару",
    "TianJiaNKuanBuHuoShangPin": "Всего {0} моделей по добавленному товару",
    "ChaoChuYuZhuangGuiRiQiShiFouBuHuo": "Дата окончания производства данного товара, возможно, будет позже, чем указана ожидаемая дата загрузки, подтвердите, добавлять ли данный товар?",
    "TianJiqQiTaBuHuoShangPinZhaoShangPin": "Если Вы хотите добавить товары, которые не в корзине, для начала перенесите эти позиции в корзину для запроса цен, а после добавьте к заказу",
    "LieBiaoKongXuanZeQiTaShangPinHuoXunJia": "Таблица пуста, нажмите на другие графы о добавлении товара, если среди представленных нет подходящих позиций, пожалуйста, отберите на платформе нужные товары и добавьте в корзину для запроса цен, после того, как цены будут известны, товар можно добавлять",
    "TiJiaoHouWoMenJiangXunJia": "После передачи файла, мы отправим его на запрос цен фабрике",
    "QingXuanZeXingBie": "Пожалуйста, выберите пол",
    "ZhouJin": "Узнать об",
    "NinMeiYouFeiShengChanYaoQiu": "Вы не имеете следующих непроизводственных требований: проверка качества продукции, укладка и компонирование груза в контейнерах (продукция, которая уже произведена).",
    "FanKuiShiJian": "Время обратной связи",
    "BuHuoChengGongJiangJinKua": "Товар добавлен успешно, можно начинать производство",
    "YiChangYiChuLiWanChengShe": "Все сбои устранены, до начала производства установите все стикеры и маркировки",
    "ShaoHou": "Подождите",
    "QuSheZhi": "Установить",
    "BingWuShangPinBuHuoChengG": "Обработка ошибок завершена",
    "KeKaoDeHeZuoHuoBanChengXinJiaoYi": "4. Надёжный партнёр. Честные сделки.",
    "LianXiWoMen": "Контакты",
    "MouXieShangPinXuYaoZh": "1. Данные товары необходимо загрузить в последний ряд в контейнере;",
    "ZhiJianTuPianXuYaoZhengMi": "2. Необходимо 3 фото с инспекции: лицевая сторона, обратная сторона, вид сбоку.",
    "GuanYuShangPinZaiShengCha": "Фабрика будет производить товар согласно Вашим требованиям.",
    "LiRu": "Например",
    "NinDeShangPinQuanBuWeiWei": "По остаточному товару уже нельзя установить индивидуальные требования, Вы можете их  внести в графе \"essa примечания\"",
    "ShangPinYiZhongXinFaQiYiJPI": "По  {0} позициям повторный запрос цен",
    "YuZhuangJuRiQiTuiChiTongZ": "Оповещение о переносе предварительной даты отгрузки",
    "ZhuYiLiShiBianGengQingZai": "Внимание:  Изменена предварительная дата отгрузки, пожалуйста, просмотрите детали в графе отслеживания заказа",
    "JiXuTuiChiYuZhuangJuRiQi": "Отложить  предварительную дату загрузки. Продолжить",
    "DanDaoRuYiXiaShangPinDaoZ": "Из-за перенесённых в заказ товаров, предварительная дата отгрузки откладывается",
    "YiXiaShangPinDaoZhiYuZhua": "Из-за товаров, представленных ниже, предварительная дата отгрузки была перенесена",
    "DiaoZhengShiJian": "Время внесения корректировок:  {0}",
    "TuiChiZhi": "Отложена до",
    "ZhuYiZuiWanZhiYunXuTuiChi": "Внимание: самое позднее время, до которого можно перенести {0}",
    "TuiChiYuZhuangJuRiQi": "Отложить предварительную дату загрузки",
    "QueRenYuZhuangJuRiQiTuiCh": "Предварительную дату отгрузки переносим до {0} ? Подтвердите",
    "QingXuanZeRiQi": "Пожалуйста, выберите дату",
    "XinYuJiZhuangJuRiQi": "Новая предполагаемая дата отгрузки",
    "CiRiQiZaoYuZhengChangJiao": "Указанная дата раньше, чем установлен срок окончания производства {0} фабрикой,  ждите подтверждение от фабрики о возможности окончания в эти сроки.",
    "YouYuWeiShouDaoQueRenDing": "По причине того, что депозит не был получен, данный заказ не может быть передан фабрике для начала производства, это повлияло на то, что предварительная дата отгрузки контейнера будет отложена до {0} числа, пожалуйста, в кратчайшие сроки внесите депозит (считается время поступления депозита на счёт)",
    "YouYuBangNinCongZhongDiao": "По причине того, что из {1} перенесли {2}  позиции, предварительная дата загрузки сместилась до {3} числа. Ознакомьтесь!",
    "YouYuShangPinShengChanGuo": "По причине того, что сбились изначальные планы по производству некоторых товаров, предварительная дата загрузки по данному заказу будет перенесена до {0} числа, приносим свои извинения за доставленные неудобства!",
    "YouYuWuFaDingDaoCangGuDin": "По причине того, что {0} , ориентировочная дата загрузки по заказу переносится до {1}  числа, приносим свои извинения за доставленные неудобства!",
    "PiLiangJieShouBingDiaoChu": "Массово принять и передать",
    "DiaoChu": "Передать",
    "DiaoJinN": "Внесено {0}",
    "QingXuanZeYaoDiaoJiDe": "Пожалуйста, выберите заказ, в который нужно перенести товары",
    "YiXuanZeShangPinDeTiJi": "Уже выбран обьем товара",
    "ZuiZhangYuZhuangJuRiQi": "Самая поздняя дата загрузки контейнера",
    "ShengYuTiJi": "Остаточный объём",
    "DiaoJin": "Внесено",
    "NinShenQingDiaoJinDeShang": "Объём перенесенных Вами товаров в контейнер уже превысил допустимый по заказу, мы не рекомендуем добавлять товары, если Вы считаете, что товар нужно добавить, essa свяжется с Вами и порекомендует как правильнее перекомплектовать товар. Продолжить добавление товара?",
    "GaiYuanZhuangJuRiQiDiaoRu": "Изначальная дата отгрузки по данному заказу: {0}; после того, как будут перенесены дополнительные товары к заказу, дата отгрузки сместится до {1}，продолжить перенос товаров в заказ?",
    "GaiYuanZhuangJuRiQiTongShi": "Предварительная дата отгрузки по данному заказу: {0}; после перекомплектования товаров самая поздняя дата загрузки перенесена до {1}. Но если объем в контейнере превысит допустимый, мы не рекомендуем добавлять товар, если Вы считаете, что товар нужно добавить, essa свяжется с Вами и порекомендует как правильнее перекомплектовать товар. Продолжить добавление товара?",
    "QueRenDiaoJin": "Подтвердить перенос товаров?",
    "NinDangQianWuKeDiaoJinDeD": "В настоящее время у Вас нет текущих заказов куда бы Вы могли перенести товары",
    "QingXianGouXuanShangPin": "Пожалуйста, выберите галочкой товары",
    "YuanShiYuJiZhuangGuiRiQi": "Исходная ориентировочная дата загрузки",
    "QueDingShanChuXunJiaShangPin": "Повторно запросить цены по выбранным товарам?",
    "PiLiangXunJia": "Запрос цен по выбранным",
    "SouDingDan": "Поиск заказа",
    "SouShangPin": "Поиск товара",
    "PoMoRenTiShi": "Поиск можно осуществлять по номеру артикула товара, фабричному артикулу, по артикулу клиента. Максимальное количество артикулов для одновременного  поиска - не более 10. При поиске, пожалуйста, ставьте пробел между артикулами.",
    "QingXianRenZhengNinDeCaiG": "Для начала идентифицируйте Ваш пользовательский статус",
    "FeiGongZuoShiJianYuJiXuYa1": "Если запрос был подан в нерабочие дни, подтверждение будет отправлено в течение 2 рабочих дней",
    "GuiSiXiaMianWuYuanGongZha": "Нет учётной записи для сотрудников Вашей компании",
    "NinDangQianDeCaiGouShangD": "Ваш текущий покупательский статус ещё не может поддерживать аккаунты сотрудников, для подтверждения свяжитесь с консультантом по продажам.",
    "LianXiXiaoShouGuWen": "Связаться с платформой по обслуживанию клиентов",
    "TiShengGuDingBaoZhengJinE": "Повысить уровень фиксированного гарантийного депозита",
    "DanBaoDingDan": "Гарантия по заказу",
    "QueRenDingDan": "Подтвердить заказ",
    "YongZhenShiDeXinXiWanShan": "Заполните поля корректной информацией и Вы получите наиболее точные рекомендации по искомой продукции, продуктивность поиска увеличивается на 40%",
    "GuiSiGuDingBaoZhengJinHai": "У Вашей компании остаток суммы фиксированного гарантийного депозита для кредитования суммы {0}, жанной суммы недостаточно для кредитования данного заказа.",
    "GuiSiGuDingBaoZhengJinHaiBu": "Суммы фиксированного гарантийного депозита Вашей компании {0}, достаточно для кредитования заказа.",
    "QingZaiChuHuoQianZhiFuDin": "Напоминание: Пожалуйста, внесите депозит перед отгрузкой",
    "GaiDingDanDingJinYiDaoZha": "Получен платёж по данному заказу, пожалуйста, как можно скорее подтвердите PO, чтобы не допустить задержек производства.",
    "QingJinKuaiZhiFuDingJinZh": "Требуется скорейшая оплата депозита: {0}；оплата проведена успешно, сумма депозита корректна, пожалуйста, по факту поступления на счёт, подтвердите заказ",
    "GuiSiDingDanDingJinJiDing": "Товары и депозит по Вашему заказу {0} уже подтверждены, можно подтвердить весь заказ?",
    "DanBaoCiDingDaoHouShengYu": "После того, как взят кредит по данному заказу, остаток для возможного кредита {0}",
    "QueRenDanBaoDingDan": "Подтвердить гарантию по заказу{0} ?",
    "BuHaoYiSiGuiSiDangQianYou": "Приносим свои извинения, так как данный заказ находится в процессе гарантии, изменение модели депозита невозможно, пожалуйста, для начала проведите оплату по товару.",
    "DingDanYiQueRenJiangJinKu": "Заказ подтверждён, ESSA в ближайшее время распорядится о начале производства!",
    "QueRenDanBaoChengGongJian": "Гарантийное подтверждение получено, в самое ближайшее время ESSA распорядится о начале производства!",
    "BuHaoYiSiDingDanYiJingBeiQueRen": "Извините, данный заказ уже был подтверждён{0}",
    "BuHaoYiSiDingDanYiJingBeiDanBao": "Извините, по данному заказу уже было получено {0} гарантийное подтверждение!",
    "GuDingBaoZhengJin": "Фиксированная гарантийная сумма",
    "ShenQingGengHuanDingJinMo": "Запрос на смену варианта депозита",
    "GuDingBaoZhengJinJinE": "Уровень фиксированного гарантийного депозита",
    "DanBaoHuoKuanJinE": "Кредит по товару",
    "HaiKeDanBaoHuoKuanJinE": "Лимит кредитования",
    "ShouXinEDu": "Сумма кредитной линии на платформе",
    "SheZhiBaoZhengJinJinE": "Изменить уровень гарантийного депозита",
    "WoXiangLeJieDingJinMoShi": "Узнать о способах оплаты депозита у ESSA",
    "BaoZhengJinJinE": "Категория гарантийного депозита",
    "TiXian": "Снятие наличных",
    "WeiShiYong": "Не использованы",
    "ShiYongZhong": "В работе",
    "BuHaoYiSiGuiSiHaiYouHuoKu": "У Вас есть {0} сумма для кредитования по товару, Вы не можете понизить уровень гарантийного депозита до {1}, (товар для кредитования {2}).",
    "QueRenJiangE": "Подтвердить понижение уровня?",
    "JiangEHouDuoYuDeBaoZhengJ": "После понижения уровня, оставшиеся деньги перейдут на сумму баланса",
    "BuHaoYiSiDangQianNinYouDu": "Приносим свои извинения, в настоящее время несколько PO в процессе кредитования, поэтому выгрузить сумму по депозиту нельзя, пожалуйста, завершите оплату по товару и после этого выгрузите сумму.",
    "QueDingTiQuGuDingBaoZheng": "Подтвердите выгрузку фиксированного гарантийного депозита в сумму к использованию",
    "QueRenBaoZhengEDuCongTiSh": "Подтвердить повышение гарантийного уровня с {0} до {1}; после повышения, соответствующий кредит увеличить с {2} до {3} ?",
    "GuDingBaoZhengJinTiShengC": "Уровень фиксированного гарантийного депозита повышен!",
    "GuiSiYouZhangDaiQueRenDan": "По заказу {0} ожидается подтверждение по кредитованию, имеющегося в настоящее время уровня гарантийного депозита достаточно для кредитования всех заказов, Essa запустит товары в производство в самое ближайшее время!",
    "NinYouZhangDaiDanBaoDeDin1": "По Вашему {0} заказу ожидается кредитование, исходя из текущего уровня гарантийного депозита, возможно кредитование только части заказов, подтвердить ли часть заказов для начала? Или продолжить повышение уровня до {1}, чтобы кредитовать все заказы?",
    "QuQueRenPO": "Утвердить PO",
    "JiXuTiShengEDu": "Продолжить увеличение суммы",
    "NinYouZhangDaiDanBaoDeDin": "По Вашему {0} заказу, ожидается кредитование, в настоящее время, уровня гарантийного депозита недостаточно для кредитования, уровень должен быть увеличен до {1}, только после этого Вы сможете кредитовать все заказы",
    "BuHaoYiSiGuiSiXiaKeYongZi": "Извините, на Вашем балансе недостаточно средств, повысить уровень гарантийного депозита невозможно, недостаток по сумме {0}, пожалуйста, свяжитесь с Вашим менеджером для повторного перераспределения сумм!",
    "DanJuBiLiDingJin": "пропорция оплаты депозита за 1 контейнер",
    "Qian": "Задолженность",
    "GongSiZhuZhangHaoCaiNengB": "Уровень гарантийного депозита можно изменить только с основного аккаунта компании",
    "ZhiSuoYouDingDanDaiZhiFuQ": "Окончательная сумма к оплате по всем заказам",
    "GuDingDingJin": "Фиксированный депозит",
    "DingJinZhiFuShiJian": "Время внесения депозита",
    "TiJiaoDingDanHouMeiZhangD": "После передачи заказа в работу, по каждому из них, в соответствии с типом контейнера, необходимо оплатить соответствующую сумму фиксированного депозита. После оплаты депозита, PO будет подтверждён и вто же время фабрика распорядится о начале производства.",
    "DingJinGuanLi": "Управление депозитом",
    "MianDingJin": "Без депозита",
    "WaiHui": "Иностранная валюта",
    "DaiQueRenDingJinDingDan": "Заказ, по которому ожидается подтверждение депозита",
    "YiChangDaiChuLiDingDan": "Неполадки по заказам",
    "DaiZhiFuHuoKuanDingDan": "Заказ, по которому ожидается оплата",
    "KeDiaoRuHuoBuHuoDingDan": "В заказ можно перенести или добавить",
    "BuHuoZhongDingDan": "Заказ в процессе пополнения товаров",
    "DiaoHuoZhongDingDan": "Товар в процессе перераспределения по заказу",
    "YiXiaXuYaoJinJiChuLi": "Необходимо срочно урегулировать",
    "GongSiDingJinMoShi": "Вид депозита Вашей компании",
    "DanBaoHuoKuanEDu": "Лимит по сумме кредита на товар",
    "HaiKeDanBaoHuoKuanEDu": "Гарантийная норма",
    "GouWuCheZhongKuanShangPin": "По товарам в корзине {0} уже возможен этап обсуждения условий с производителем, пожалуйста, как можно скорее подтвердите их закупку",
    "NinYouZhangDingDanBaoZhen": "По Вашему заказу {0} ожидается кредитование, для своевременного размещения заказа к производству на фабрику, как можно скорее повысьте уровень гарантийного депозита.",
    "TiShengBaoZhengJinEDu": "Повысить уровень фиксированного гарантийного депозита",
    "ChaKanQuanBu": "Смотреть всё",
    "BianGengDingJinMoShi": "Изменить способ оплаты депозита",
    "QueDingGengHuanGuiSiDingJinMoShi": "Подтвердите смену способа оплаты депозита от Вашей компании{0}",
    "GuiSiDingJinMoShiGengHuanChengGong": "Способ оплаты депозита от Вашей компании сменён успешно!",
    "GengHuanHouXinXiaDeDanJia": "После корректировок, модель депозита по новым PO будет изменена, но данная модель не распространится на уже размещённые заказы. Завершите сделку по уже сделанным заказам по старой модели депозита.",
    "QingXuanZeXinDeDingJinMoS": "Пожалуйста. выберите новую модель оплаты депозита",
    "NinDangQianShiYongDeDingJ": "Ваш текущий способ оплаты депозита",
    "ShiYongBaoZhengJinKeYiRan": "Используя гарантийный депозит, Вы сможете очень быстро подтвердить заказ и передать его в производство, нет необходимости ожидать оплату депозита, тем самым, сокращая время получения товара",
    "JiangTiGongBuTongCengJiDe": "ESSA предложит разные уровни гарантийных депозитов для Вашего удобства",
    "GaiDingJinMoShiHaoChu": "Преимущества данного способа оплаты депозита",
    "XuanZeBuTongBaoZhengJinJi": "Разный гарантийный депозит для разной суммы кредита",
    "ZhengDanManJuHuoSanHuoXia": "Заказ на полный контейнер или сборный?",
    "AnHuoKuanJinEShouQuBiLi": "Использовать сумму пропорционально сумме всего заказа",
    "ZhengDanBuManJuXiaDan": "Оформить заказ на неполный контейнер",
    "JuTiJuXingDeDingDanJiangA": "По нижеследующим параметрам будет снята сумма депозита, исходя из конкретного типа контейнера по заказу",
    "ZhengDanXiaDan": "Заказать полный контейнер",
    "SanHuoXiaDan": "Заказ сборника",
    "GengHuan": "Заменить",
    "QingSheZhiGuiSiBaoZhengJi": "Пожалуйста, установите уровень гарантийного депозита компании",
    "DanBaoZhongHuoKuanJinE": "Используемая сумма кредита",
    "FenPeiBaoZhengJinQianKuan": "Распределить разницу гарантийного депозита",
    "ZhuangTai": "Статус",
    "BaoZhengJinFenPeiChengGon": "Гарантийный депозит распределен",
    "QueDingFenPeiKeYongZiJinB": "Подтвердить перераспределение доступных сумм на баланс гарантийного депозита?",
    "DingJinTiQuHouZhongXinXia": "После снятия депозита, при оформлении нового заказа будет невозможно передать заказ в производство на фабрику, понадобится, чтобы Вы перераспределили сумму депозита, продолжить снятие депозита?",
    "GuDingBaoZhengJinTiXianCh": "Сумма фиксированного гарантийного депозита получена",
    "GuDingBaoZhengJinJiangECh": "Сумма фиксированного гарантийного депозита снижена!",
    "DuiGuiSiShouXinDeEDuYongY": "Открытие кредитных лимитов для компании от ESSA созданы для того, чтобы смягчить нестабильность банковских курсов при денежных переводах; Временно можно кредитовать часть суммы за товар.",
    "DangQianGuDingBaoZhengJin": "В настоящее время суммы фиксированного гарантийного депозита недостаточно, когда сумма будет восполнена, сразу же перераспределите сумму в гарантийный депозит, чтобы не повлиять на процесс кредитования по заказу.",
    "NinYouZhangDingDanDaiZhiF": "По Вашему заказу {0} ожидается оплата депозита, для того, чтобы не задерживать сроки производства, как можно скорее проведите оплату. Если у Вас возникнут вопросы, свяжитесь с консультантом по продажам.",
    "TongZhi": "Оповещение",
    "QingWanShanZiLiao": "Пожалуйста, отредактируйте материалы",
    "WeiZhaoDaoFuHeTiaoJianDeShangPin": "По Вашему запросу ничего не найдено",
    "ShiJiDaoGangRiQi": "Дата прихода в порт",
    "GongKuanZongTiJiDeShangPi": "Всего {0} моделей, общий объём по товарам {1}, возможен сборный контейнер",
    "BuHaoYiSiGuiSiXiaBaoZheng": "Суммы Вашего гарантийного депозита достаточно только для кредитования {0} товара; для того, чтобы Вы смогли добавить необходимый товар, повысьте уровень гарантийного депозита до {1}",
    "DingDanBeiChengGongTiJiao": "Заказ{0} был успешно передан в работу",
    "QingXuanZeWanJuCaiGouGuiM": "Пожалуйста, выберите объём закупок игрушек",
    "QingXuanZeWanJuDanKuanCai": "Пожалуйста, выберите объём закупок по одной модели",
    "ZhengJuShouQu": "Взимать с заказа в целом",
    "DanJiaJunTanShouQu": "Цена за единицу товара взимается в равной степени",
    "DaiZhiFuDingJinDingDan": "Ожидание оплаты депозита",
    "DaiQueRenDingDan": "Заказ ожидает подтверждения",
    "DaiZhiFuQianKuanDingDan": "Ожидание оплаты по заказу",
    "GuiSiDangQianBaoZhengJinQ": "В настоящее время у Вашей компании есть задолженность по сумме гарантийного депозита {0}, кредит по заказу невозможен",
    "HaiQingBaoZhengJinQianKua": "Повысить уровень гарантийного депозита",
    "GuiSiXiaYouZhangDingDanBa": "По данному заказу {0} ожидается кредитование, для того, чтобы своевременно передать заказ в производство на фабрику, как можно скорее повысьте уровень гарантийного депозита до {1}",
    "BaoJiaZuHe": "Формат прайс-листа",
    "YiXiaDanDanBuManGuiDeHuoGui": "Заказ оформлен, но контейнер не заполнен",
    "WeiTiJiaoDingDanDeHuoGui": "По данному контейнеру заказ не передан в работу",
    "QingXuanZeNinZhunBeiZuZhuangxxxDeChuHuoLeiXing": "Пожалуйста, выберите тип контейнера, в который Вы планируете сформировать заказ {0}",
    "ZhengDan": "FCL（Полный контейнер）",
    "SanHuo": "LCL（Сборный контейнер）",
    "XinHuoGuiDouShiYongGaiBaoJiaZuHe": "По всем новым контейнерам использовать данную форму прайс-листа",
    "LiShiChangYongBaoJiaZuHe": "Часто запрашиваемый формат прайс-листа",
    "FanHuiXiuGaiBaoJiaZuHe": "Вернуться для корректировки формата прайс-листа",
    "HuoGuiShangPinZongTiZhiBuYunXuChaoChuHuoGuiZuiDaZhi": "Общий объём по товарам не должен превышать допустимый для загрузки по контейнеру",
    "QueDingHuoGuiBaoJiaZuHeWuWu": "Более половины товаров в контейнере произведены не по месту отгрузки, соответственно и комплексный прайс тоже был посчитан исходя из этого фактора, подтвердите, что прайс по контейнеру без ошибок",
    "WeiBuYingXiangDingDanYuZhuangGuiRiQi": "Напоминание: чтобы не повлиять на предварительную дату загрузки по заказу, как можно скорее проведите оплату депозита, дата будет перенесена на то кол-во дней, пока деньги не поступят на счёт.",
    "QingZaiChuHuoQianZhiFuDingJin": "Напоминание: Проведите оплату депозита до отправки товара.",
    "QingQueRenYiXiaXinXiShiFouZhengQue": "Пожалуйста, проверьте верна ли нижеследующая информация?",
    "XiuGaiBaoJiaZuHe": "Откорректировать формат прайс-листа",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinE": "Ваша компания ещё не установила уровень фиксированного гарантийного депозита",
    "DingDanTiJiaoChengGong": "Заказ успешно передан в работу, ESSA в ближайшее время договорится о начале производства!",
    "DingDanTiJiaoChengGongQingJinKuaiZhiFuDingJin": "Заказ успешно передан в работу, как можно скорее проведите оплату депозита, чтобы не повлиять на сроки начала производства.",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinEQingXianSheZhi": "Компанией ещё не был установлен уровень фиксированного гарантийного депозита, пожалуйста, сначала установите уровень гарантийного депозита.",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinEQingLianXixxxXianSheZhi": "Ваша компания ещё не установила уровень фиксированного гарантийного депозита, пожалуйста, свяжитесь {0} для установки.",
    "TiShengGuDingBaoZhengJinJinE": "Повысить уровень фиксированного гарантийного депозита",
    "NinYiChengGongTiJiaoDingDanQingJinKuaiTiShengBaoZhengJin": "Заказ успешно передан в работу, как можно скорее повысьте уровень гарантийного депозита, для того, чтобы не было задержек по срокам производства по Вашему заказу.",
    "NinYiChengGongTiJiaoDingDanQingJinKuaiHuanQingBaoZhengJinQianKuan": "Суммы гарантийного депозита недостаточно для кредитования этого заказа. Необходимо повысить уровень гарантийного депозита, получить подтверждение и только после этого начнется производство.",
    "WeiNengShunLiQueRenDingDanNinDeBaoZhengJinJinEXuTiShengZhi": "Для успешного подтверждения Вашего заказа, уровень Вашего гарантийного депозита необходимо повысить до",
    "RuoNinZhangHaoZiJinBuZuQingLianXiNinDeXiaoShouGuWenXXX": "Напоминание: Суммы на Вашем счету недостаточно, пожалуйста, свяжитесь с Вашим продавцом-консультантом и увеличьте сумму. Если сумма находится в процессе гарантии, Вы можете оплатить часть остатка по заказу, для тго, чтобы выгрузить больше гарантийной суммы.",
    "NinDangQianShiYongDeShiXXXDeDingDanFuWu": "В настоящее время Вы используете услуги по заказу {0}",
    "BaoZhengJinQianKuanJinE": "Задолженность по гарантийному депозиту",
    "ZuiJinNGe": "За последнее время {0}",
    "DangQianKeYongZiJinBuZuQi": "В настоящее время доступной суммы недостаточно, для начала внесите на счёт ESSA, после того, как суммы будет достаточно, можно будет перераспределить суммы.",
    "GuanBi": "Закрыть",
    "BianGengBaoZhengJinEDu": "Изменить уровень фиксированного гарантийного депозита",
    "FuWuFeiJiangYiDingDanHuoK": "Стоимость за оказание услуг будет высчитана пропорционально позициям в заказе",
    "GuiSiXiaYouZhangDingDanDa": "У компании есть заказ {0}, по которому ожидается кредитование, пожалуйста, оплатите задолженность по фиксированному гарантийному депозиту",
    "NinDangQianDeCaiGouShangDD": "Ваш аккаунт на рассмотрении сертификации, в данный момент не возможно торговать на сайте. Узнать больше о процессе, связаться с платформой по обслуживанию клиентов.",
    "GuDingBaoZhengJinTiQuHouZ": "После снятия гарантийного депозита, все новые размещённые заказы будет невозможно передать в работу производителям, необходимо, чтобы Вы ещё раз перераспределили суммы депозита",
    "YiShuRuCuoWuCiShengYuCiJi": "Количество ошибок при вводе {0}, оставшееся количество попыток {1}",
    "CuoWuCiShuGuoDuoQingXiaoS": "Большое количество ошибок, пожалуйста, спустя {0} часов повторите попытку или попробуйте восстановить пароль, указанный при регистрации",
    "CuoWuCiShuGuoDuoQingFenZh": "Превышено допустимое количество ошибок, повторите попытку через {0} минут или попробуйте функцию нахождения пароля при регистрации для разблокировки",
    "MiMaCuoWuQingZhongXinShuR": "Пароль неверный, попробуйте ещё раз",
    "MiMaCuoWuLianXuCiShuRuCuo": "Пароль неверный, аккаунт будет заблокирован после 5 ошибочных попыток",
    "KeBuHuo": "Можно добавить товар",
    "ShenChangAnPaiZhong": "В процессе подготовки к производству",
    "YiChangDaiChuLi": "Ожидание устранения неполадок",
    "ShenQingTiaoRuZhong": "В процессе подтверждения о перекомплектации",
    "ShangPinSuoZaiXiLie": "Название линейки товара",
    "BuChongYiXiangCaiGouShangPin": "Пожалуйста, заполните информацию о интересующей Вас продукции",
    "BuHuoZhong": "Товар добавляется",
    "MoSiKeTuiGuangFuWuBanShiC": "Услуги московского офиса по продвижению и развитию",
    "JiaZaiGengDuo": "Загрузить больше",
    "PinPaiXiangQing": "Описание по марке",
    "CheMeiYouKePinGuiDeShangPin": "В Вашей корзине нет товаров для консолидации",
    "ShaiXuan": "Фильтр",
    "MeiYouGengDuoShuJu": "Больше нет данных",
    "YiXuan": "Выбрано",
    "ShangPinJieShao": "Описание по товару",
    "FaBuZhaoYang": "запрос на поиск товара",
    "FaBu": "Опубликовать",
    "FaBuMiaoShu": "Детальное описание товара для наиболее эффективного поиска. Например: название бренда, функции, наименование товара и т.д.",
    "ShangPinSuoShuFenLei": "Категории по товару",
    "ZyWenXinTiShi": "Внимание: на платформе Essa есть функция точного поиска товара, благодаря которой можно получить наиболее подробную информацию по товару",
    "ShiBai": "Ошибка",
    "TuPianShuoMing": "Описание фото",
    "TuPianShuoMing1": "Пожалуйста загрузите изображение образца",
    "TuPianShuoMing2": "Так как на загруженной вами изображении несколько позиций, система выберет одно из изображений для поиска",
    "TuPianShuoMing3": "Допустимые форматы изображений для загрузки: jpg/png, размером менее 5 М",
    "WoDeZhaoYang": "Результаты запроса",
    "FaBuChengGong": "Успешно опубликовано",
    "FaBuShiBai": "Сбой публикации",
    "ChaKanZhaoYangXiangQing": "Вы можете нажать \"мой поиск товаров\" для более детальной информации",
    "XuanZeShangPinSuoShuFenLei": "Выбрать категорию товара",
    "TianJiaBuChongXingShuoMing": "Продолжить добавление описания",
    "BuChongShuoMing": "Дополнить описание",
    "ZhanKaiQuanBu": "Открыть полностью",
    "YiDongDuanJinKeBianJiHeChaKan": "Заходя на платформу с переносного устройства, Вы сможете совершать простейшие действия редактирования или просмотра товаров в корзине; с компьютера Вы можете не только просматривать, но и формировать сборник или размещать заказы.",
    "ShangPinZanWeiYiJiaQingXianRenZheng": "По товарам пока не согласованы цены, сначала дождитесь подтверждения, а после, автоматического запроса цен",
    "YiYiJia": "Согласованная стоимость",
    "QingXuanZeWenTi": "Пожалуйста, выберите вопрос",
    "ChaKanHuiFu": "Просмотреть ответ",
    "NGeWenTi": "{0} вопрос",
    "QingXianDengLuNMiaoHouJiangTiaoZhuan": "Сначала зарегистрируйтесь, после 3S система автоматически переведет Вас на страницу регистрации",
    "BianJi": "Редактировать",
    "JiaGeQuJian": "Диапазон цен",
    "DengLuBingRenZhengHouJiaGeKeJian": "Цены будут видны после регистрации и ее подтверждения",
    "QingXianDengLu": "Зарегистрируйтесь",
    "WeiTongGuoRenZheng": "Ваш аккаунт не был подтверждён, целевая стоимость и объём Вашего заказа будут отправлены производителю на запрос цен после получения подтверждения. Пожалуйста, дождитесь",
    "TuXiangShiBieZhong": "Идет распознавание и обработка графического изображения",
    "ZhiShaoNGeZiFu": "Минимальное количество {0} знаков",
    "ZhuCeYouXiang": "Зарегистрируйте почту",
    "ZhiShaoShuRuNGeZiFu": "Минимальное количество символов для ввода {0}",
    "ZaiCiShuRu": "Повторите",
    "QueRenXiuGai": "Подтвердить исправления",
    "YiYouZhangHaoQuDengLu": "Уже зарегистрированы? Войти",
    "DianJiZhuCeJiTongYiZunShou": "Нажмите \"зарегистрироваться\" и принять условия essa платформы",
    "FanHuiDengLu": "Вернуться к регистрации",
    "NinDeZhangHaoTiJiaoChengGongQingQ": "Ваш аккаунт успешно создан, перейдите в электронную почту {0} для завершения процесса регистрации",
    "GongXiNinZhuCeChengGongNMiaoHou": "Поздравляем, регистрация успешно завершена! {0} система автоматически зарегистрирует и переведет на другую страницу",
    "DangNinChengWeiWoMenDeRenZhengYonghuJiangYou": "Внимание: как только Вы старите нашим зарегистрированным пользователем, за Вами будет закреплен индивидуальный менеджер-консультант",
    "NinXuanZheDeXiaoShouGuWenHuiZaiNXiaoShiNei": "Выбранный Вами консультант по продажам свяжется с Вами в течение {0} часов, для подтверждения Вашего статуса покупателя. Далее, Вы сможете просматривать все товары на платформе и цены. {1} после автоматической регистрации, Вы перейдете на главную страницу.",
    "NMiaoHouZiDongDengLu": "{0} после автоматической регистрации, переход на главную страницу",
    "GaiZhangHuShangWeiZhuCe": "Данный аккаунт не зарегистрирован, пожалуйста, сначала зарегистрируйтесь",
    "GaiYouXiangYiZhuCeQingGengHuan": "Данная почта уже зарегистрирована, пожалуйста, смените почту или зарегистрируйтесь",
    "ChongZhiMiMaChengGongFanHui": "Пароль изменен! {0} после система вернется на страницу регистрации",
    "WoDeShouCang": "Избранное",
    "QuanBuLeiMu": "Все категории",
    "QiHuo": "Время производства",
    "LieBiaoWeiKong": "Таблица не заполнена",
    "ChengGongJiaRuGouWuChe": "Успешно добавлены в корзину",
    "ChengGongShanChu": "Удалено",
    "YiGeYueYiNei": "В течение месяца",
    "SanGeYueYiNei": "В течение 3 месяцев",
    "SanGeYueZhiQian": "3 месяца назад",
    "SheZhi": "Войти",
    "ZhangHuXinXi": "Информация об учетной записи",
    "ZhangHuMing": "Логин",
    "WoDeXiaoShouGuWen": "Мой консультант по продажам",
    "GuanYuESSA": "Об ESSA",
    "TuiChuDengLu": "Выйти из регистрации",
    "QingXuanZeNiSuoZaiGuoJia": "Выберите страну",
    "YuYan": "Язык",
    "MingChengHeHuoHao": "Наименование, артикул",
    "ZiDingYi": "Самостоятельная настройка",
    "LiShiSouSuo": "Поиск по истории",
    "QingKongLiShiJiLu": "Очистить историю",
    "invalidPO": "Данный заказ уже недействителен",
    "ShangChuanDeTuPianXiangSuJinLiangQingXi": "Качество загружаемых фотографий должно быть четким",
    "TuPianBeiJingJinLiangShiYongChunSeBeiJing": "Фон картинки используйте однотонный",
    "KeShiYongCaiJianGongNengTuChuShangPinZhongDian": "Можно вырезать основную часть товара",
    "TuPianShangZhiBaoHanDanGeShangPin": "На фотографии имеется только один товар",
    "TuPianShiBieZhongMaShangJiuHao": "Распознавание и обработка фото скоро будет завершена",
    "TuoZhuaiTuPianDaoZheLi": "Переместить фотографии сюда",
    "BenDiShangChuanTuPian": "Загрузить фотографии",
    "XiangSiShangPin": "Подобные товары",
    "SouSuoJieGuoBuJingZhun": "Результаты поиска неточны",
    "DianJiZuoCeKeYiDuiYuanTuJinXingCaiJian": "Нажмите слева, вырезав основную часть или очистив фон для повторного поиска",
    "HuoDeSouTuJingZhunJieGuoDeXiaoJiQiao": "Способ для получения наиболее точного результата поиска по фото",
    "LiuLanShangPinGengBianJie": "Более удобный просмотр товаров",
    "CiKuanHuoDongShangPinNinYiQueQingChaKan": "Вы подтвердили покупку данного артикула по акции, просмотреть можно в корзине",
    "ZanWuTuiJianShuJu": "Нет рекомендуемых данных",
    "ZhangHaoWeiTongGuoRenZhengNew": "Аккаунт не прошел подтверждение, Ваша целевая стоимость и объемы по заказу, после получения подтверждения, будут отправлены производителю на запрос цен, пожалуйста, дождитесь.",
    "DengLuHouJiaGou": "После входа в систему можно добавить в корзину",
    "ShouJiBan": "С телефона",
    "QueDingYaoTuiChuDengLuMa": "Вы действительно хотите выйти из системы?",
    "RenZhengYuanLianXiFangShi": "Контакты оператора для получения подтверждения указаны ниже",
    "YiShouLuZhongGuoDeWanJuGo": "На нашей платформе собрано более 80% информации о производителях игрушек в Китае; сотни новинок ежедневно загружаются в нашу систему",
    "XiLie": "Серия",
    "LiangCiShuRuDeMiMaBuYiZhi": "Пароль был введен неправильно дважды",
    "ShangChuanTuPian": "Загрузить изображения",
    "QingShuRuNGeZiYiNei": "Пожалуйста, введите {0} количество символов",
    "XiangQingMiaoShu": "Подробное описание",
    "TianJiaBuChongShuoMing": "Добавить дополнительное описание",
    "ChaKanQuanBuBuChongShuoMing": "Просмотреть всю дополненную информацию",
    "ESSATiGongJinZhunZhaoYangTips": "Внимание: в настоящее время, ESSA предлагает услугу точного поиска по товару, клиент может опубликовать известный ему товар в системе в разделе поиска и получить более детальную информацию по товару.",
    "YiJieShu": "Завершено",
    "YiFanKui": "Есть обратная связь",
    "DaiFanKui": "Ожидается обратная связь",
    "YiQuXiao": "Отменено",
    "BianHao": "Артикул",
    "BenCiZhaoYangYiJieShu": "Данный поиск уже завершен",
    "ESSAWeiNiZhaoDaoXinAiDeBaoBei": "ESSA нашла искомый товар, нажмите для просмотра",
    "ESSAZanShiWeiZhaoDaoMinXinAiDeBaoBei": "На данный момент, ESSA еще не найден искомый товар, пожалуйста, подождите",
    "BenCiZhaoYangYiQuXiao": "Данный поиск отменен",
    "JieShuZhaoYang": "Конец образца",
    "JiXuZhaoYang": "Продолжить поиск товара",
    "MeiYouChaXunDaoZhaoYangShuJu": "Не найдены данные по поиску",
    "ChaKanXiangQing": "Просмотреть описание",
    "ShangPinFenLeiS": "Категории товаров",
    "BianJiZhaoYangXinXi": "Редактировать информацию по поиску",
    "ZhaoYangFuWu": "Услуги поиска товара",
    "LiShiZhaoYangJieGuo": "История результатов поиска",
    "ZhaoYangJieGuo": "Результаты поиска товара",
    "QingShangChuanDanKuanTuPianZhaoYang": "Пожалуйста загрузите изображение образца",
    "DuoKuanJiangSuiJiXuanZeYiKuanZhaoYang": "Так как на загруженной вами изображении несколько позиций, система выберет одно из изображений для поиска",
    "ZuiDuoChuanSiZhangTuPian": "Максимальное количество изображений для загрузки 4 шт. форматом jpg,png и размером не более 5M",
    "QuanBuBuChongShuoMing": "Добавить описание по всем",
    "ChongXinJiaZai": "Загрузить повторно",
    "HenBaoQianNinYaoFangWenDeYeMianMiShiZaiYuZhouZhongQingDianJiChongXinJiaZai": "Приносим свои извинения, запрашиваемая Вами страница не найдена, пожалуйста, нажмите для повторной прогрузки",
    "FaBuShiJian": "Время публикации",
    "ShouDaoFanKui": "Получена обратная связь",
    "CKXiangQing": "Просмотреть детали",
    "ZhaoYangMiaoShu": "Описание по поиску товара",
    "GongDuoShaoKuang": "Всего {0} моделей",
    "WeiZhaoDaoShangPin": "ESSA еще не нашла для Вас искомый товар, пожалуйста, подождите",
    "YiJingZhaoDaoShangPin": "ESSA нашла для Вас искомый товар",
    "ZhaoYangYiQuXiao": "Данный поиск товара отменен",
    "ZhaoYangYiJieShu": "Данный поиск товара завершен",
    "XuanZeShiJian": "Выберите время",
    "DengLuHouZaiFaQiZhaoYang": "Вы не зарегистрировались, пожалуйста, войдите в систему для запуска товара на поиск",
    "CMYKBuZhiChi": "Система не поддерживает CMYK формат фото, пожалуйста, сначала измените на формат RGB и загрузите изображение повторно!",
    "FanHuiShangYiYe": "Вернуться на предыдущую страницу",
    "FanHuiShouYe": "Вернуться на главную страницу",
    "YeMianNongDiuLe": "Извините, запрашиваемая Вами страница утеряна",
    "JiXuFangWen": "Вы можете получить доступ к странице, используя нижеследующие варианты",
    "MeiYouShuJu": "Нет данных",
    "YiShiXiao": "Недействительно",
    "TuiJianLeiXing": "Категории по рекомендации",
    "TuXiangShiBieShiBai": "Изображение не распознано",
    "QingShanChuXiaJiaChanPin": "Пожалуйста, удалите те товары, что уже не в продаже",
    "TuiJianZhuTi": "Тематика рекомендации",
    "originQuantityNotEqualQuantity": "Товары из корзины уже добавлены во временный контейнер или в раздел товаров к добавлению",
    "TuPianShuoMing4": "Пожалуйста загрузите изображение образца со всех сторон. Лицевая, задняя и боковые стороны.",
    "KaiFaZhong": "В процессе разработки",
    "ZongWenJianDaXiaoChaoChuXianZhi": "Общий размер файла превысил допустимый{0}",
    "ZuiDuoYunXuYiCiXingShangChuanShu": "Максимальное количество{0} файлов к загрузке",
    "WenJianChongFu": "Повторение документа",
    "XiTongBuZhiChiCMYK": "Система не поддерживаетCMYK формат изображения, переконвертируйте фото в RGB формат и загрузите повторно",
    "ShiFouQueRenShanChu": "Подтвердить удаление",
    "BangNingZhaoYang": "Мы поможем Вам найти товар",
    "WenXinTiShi": "Напоминание",
    "GaiBanShangPin": "СТМ клиента",
    "ShiChangShangPin": "Отборка с рынка",
    "dealing": "Скачивается файл по заказу",
    "GongXiNin_Yi": "Поздравляем Вас, РО успешно передан в работу, суммы фиксированного кредитного депозита не достаточно для кредитования данного заказа, чтобы не задерживать процесс начала производства, как можно скорее распределите сумму, восполнив недостающую разницу в гарантийный депозит.",
    "GongXiNin_Er": "Ваш текущий фиксированный гарантийный фонд не достаточен для оформления данного заказа, пож-та пополните денежное обеспечние как можно скорее, чтобы не задерживать производство на фабрике.",
    "GongXiNin_San": "Поздравляем, PO успешно передан в работу, в настоящее время, суммы фиксированного гарантийного депозита достаточно для кредитования по данному заказу, пожалуйста, нажмите \"подтвердить\" и система автоматически распределит сумму депозита",
    "GongXiNin_Si": "Поздравляем, PO успешно передан в работу, оплату депозита нужно провести перед отгрузкой",
    "GongXiNin_Wu": "Поздравляем, РО успешно передан в работу, суммы на балансе достаточно для оплаты депозита, нажмите \"подтвердить\", система автоматически распределит нужную сумму",
    "GongXiNin_Liu": "Поздравляем, Ваш заказ успешно передан в работу, суммы на балансе недостаточно для оплаты депозита по данному заказу, пожалуйста, пополните сумму баланса",
    "GongXiNin_Qi": "Поздравляем, PO успешно передан в работу, Ваш статус VIP клиента предполагает размещение заказа без оплаты депозита. Просто подтвердите PO",
    "DingDanXinXi": "Информация по заказу",
    "PODanHao": "Номер PO",
    "DingDanZongJinE": "Общая сумма заказа",
    "TieZhiFeiYong": "Расходы по стикерам",
    "FuWuFeiYong": "Оплата за услуги",
    "YuZhuangGuiShiJian": "Ориентировочная дата загрузки",
    "DingJinDanBaoFangShi": "Способ кредитного депозита",
    "ZiJinXinXi": "Информация о средствах",
    "ZhangHuBaoZhengJinDengJi": "Уровень гарантийного депозита на счету",
    "KeDanBaoHuoKuanEDu": "Кредитный лимит",
    "YiDanBaoHuoKuan": "Товар, взятый в кредит",
    "ShengYuKeDanBaoHuoKuanEDu": "Остаток суммы для кредита по товару",
    "HaiChaBaoZhengJin": "Недостаточно суммы гарантийного депозита",
    "GaiBiDingDanSuoXuHuoKuanDanBaoEDu": "Необходимая сумма для кредитования по данному заказу",
    "ZhangHuKeYongZiJin": "Доступная сумма на счету",
    "BenDanXuZhiFuDingJin": "По данному заказу требуется оплата депозита",
    "ChaKanZiJinMingXi": "Детальный просмотр информации по средствам",
    "GongXiNin_Er_Er": "Поздравляем, PO успешно передан в работу, пожалуйста, перейдите в основной аккаунт для повышения уровня фиксированного гарантийного депозита",
    "LiJiQueRen": "Немедленно подтвердить",
    "DingDanMianShouDingJin": "По данному заказу не требуется оплата депозита, подтвердите как можно скорее, после получения подтверждения ESSA распорядится о начале производства",
    "ZuGouDanBaoBenDan": "Суммы гарантийного депозита на счету достаточно для кредитования по данному заказу, пожалуйста, подтвердите заказ, ESSA, после получения подтверждения, распорядится о начале производства",
    "KeYongZiJinZuGouZhiFu": "Вашего баланса достаточно для оплаты депозита по данному заказу {0} юаней, как можно скорее утвердите РО, чтобы не задерживать сроки начала производства.",
    "KeYongZiJinBuZuZhiFu": "Баланса недостаточно для оплаты депозита по данному заказу {0}, юаней, свяжитесь с essa для увеличения суммы на балансе, после поступления суммы на счет, подтвердите РО",
    "ShiYongZhiFuGaiBiDingDanDingJin": "Использовать {0} для оплаты депозита по данному заказу",
    "NiDeZhangHuKeYongZiJinBuZuZhiFuBenDanDingJin": "Суммы на Вашем балансе {0} недостаточно для оплаты депозита по данному заказу {1}, но, благодаря, высокому доверию Вашей компании, essa возьмет на себя обязательство временно возместить сумму {2} депозита",
    "NinDangQianWeiMianDingJinKeHu": "Вы можете не вносить депозит, а сразу переходить к подтверждению заказа.",
    "DingDanYiTiJiao": "Заказ передан в работу",
    "BenDanYiZhiFu_QingLianXiESSA": "Напоминание: По данному заказу оплачено {0} в сумму депозита, пожалуйста, свяжитесь с essa для оплаты {1} остатка по депозиту",
    "DingDanYiQueRen": "Заказ подтвержден",
    "YeMianMiShiJiangChongXinQiHang": "Извините, запрашиваемую страницу найти не удалось, обновите страницу",
    "DengLuHouQieBaoJiaFangShi": "После входа в систему можно сменить способ расчета стоимости на сайте",
    "GenJuNinDeLiangHaoXinYong": "Благодаря хорошей репутации, essa сможет временно внести{0}необходимую сумму для оплаты депозита",
    "QueRenZhiFu": "Подтвердить оплату",
    "QueRenZhiFuJiangHuiCongZiJin": "Подтвердив оплату, сумма будет снята с доступного баланса{0} в счет депозита",
    "WeiKuanZhiFuQianZhiFu": "Описание: Депозит по данному заказу{0}, essa может по данному заказу{1}временно внести сумму, но полная сумма депозита{1}, должна быть внесена до оплаты остатка за товар",
    "DanBaoChengGong": "Гарантия успешно оформлена",
    "ZhiFuChengGong": "Оплачено",
    "ShiYongHuoKuanEDu": "Используйте сумму{0}кредита для этого заказа",
    "c3VibWl0X3BvX2VtYWls": "Передать заказ в работу",
    "c3VibWl0X3BvX2VtYWls_remark": "Письмо отправлено сразу после передачи заказа в работу",
    "cG9fY29uZmlybQ==": "Подтвердить заказ",
    "cG9fY29uZmlybQ==_remark": "Письмо отправлено сразу после подтверждения заказа",
    "BangDingChengGong": "Привязка к аккаунту прошла успешно, продолжайте далее",
    "BangDingShiBai": "Ошибка в привязке к аккаунту, попробуйте еще раз",
    "BaoCunShiBai": "Ошибка сохранения, попробуйте еще раз",
    "QingWanChengZhangHuZiLiaoWanChengZhuCe": "Пожалуйста, внесите всю информацию по аккаунту и завершите процесс регистрации",
    "YanZhengMaYiFaSong": "Вам был отправлен код подтверждения",
    "QingShuRuYanZhengMa": "Введите код для отправки SMS",
    "WanCheng": "Отправить SMS",
    "ShouJiZhuCe": "Регистрация по номеру мобильного",
    "QieHuanShouJiZhuCe": "Переключиться на регистрацию по номеру телефона",
    "QieHuanYouXiangZhuCe": "Зарегистрироваться по почте",
    "YanZhengMaYouWuQingChongXinShuRu": "Ошибка кода подтверждения, попробуйте ввести еще раз",
    "FaSongYanZhengMa": "Отправить код подтверждения",
    "BangDingShouJi": "Привязка к номеру телефона",
    "YanZhengShouJi": "Проверка номера телефона",
    "BangDingShouJiChengGong": "Мобильный телефон привязан к аккаунту",
    "YanZhengShouJiChengGong": "Номер проверен",
    "HaoMaoGeShiYouWu": "Формат номера неправилен",
    "ShouJiHaoMa": "Телефон",
    "YanZheng": "Подтверждение",
    "QuBangDing": "Привязать",
    "QinAiDe": "Уважаемый",
    "ShangWeiDengJiYouXiang": "Здравствуйте, В Вашем аккаунте еще нет информации по адресу электронной почты, для получения важных уведомлений от нас, пожалуйста, внесите данные почты",
    "YouXiangYanZhengHouKeDeng": "Напоминаем: После получения кода подтверждения на почту, Вы можете регистрироваться на essa платформе по адресу почты",
    "YangZhengMaFaSongYouXiang": "Код подтверждения был отправлен Вам на почту",
    "QingGouXuanCaiGouLeiXing": "Отметьте необходимые категории",
    "ShouJiDengLu": "По номеру телефона",
    "YouXiangDengLu": "По адресу электронной почты",
    "GengDuoYuZhong": "Многоязычный",
    "WoXiangYongDianZiYouXiangZhuCe": "Регистрация по электронной почте",
    "WoXiangYongShouJiHaoMaZhuCe": "Регистрация по номеру телефона",
    "YouXiangZhuCe": "регистрация по электронной почте",
    "HuoQuYanZhengMa": "Получить SMS",
    "YanZhengMaShuRuYouWuChongXin": "Код подтверждения введен неверно, пожалуйста, введите еще раз",
    "ShouJiHaoMaGeShiYouWuQingChongXin": "Формат номера телефона неверный, введите еще раз",
    "YanZhengMaFaSongShiBai": "Ошибка отправки кода подтверждения",
    "ZhuCeChengGongXuanYeWuYuan": "После регистрации, {0} система переведет Вас на страницу выбранного менеджера",
    "GaiZhangHuYiCunZaiQingQueRen": "Данный аккаунт уже существует, пожалуйста, подтвердите номер телефона",
    "GaiZhangHuBuCunZaiQingQueRen": "Данный аккаунт не существует, пожалуйста, подтвердите номер телефона",
    "GaiZhangHuYiJinYongQingQueRen": "Данный акаунт был заблокирован, подтвердите номер телефона",
    "WoXiangYongDianZiYouXiangZhaoHuiMiMa": "Найти пароль по электронной почте",
    "WoXiangYongShouJiZhaoHuiMiMa": "Я хочу найти пароль по номеру телефона",
    "ShangWeiDengJiShouJiHaoMa": "Ваш аккаунт зарегистрирован не по номеру телефона, пожалуйста привяжите телефон к аккаунту.",
    "KuaGuoCaiGouPingTai": "essa.cn - это международная онлайн-платформа по закупке игрушек",
    "JingXuanTuiJian": "Рекомендации",
    "QingTianXieZhenShiYouXiao": "Пожалуйста, впишите действительный номер телефона и дождитесь смс с кодом подтверждения. Успешно зарегистрировавшись, Вы можете использовать номер телефона, как имя пользователя",
    "yi_jing_bang_ding_shou_ji": "Телефон уже подвязан к аккаунту",
    "wu_xiao_yan_zheng_ma": "Код подтверждения недействителен",
    "yi_jing_bang_ding_email": "Почта уже подвязана к аккаунту",
    "shou_ji_yi_jing_bei_shi_yong": "Данный номер уже используется",
    "you_xiang_yi_jing_bei_shi_yong": "Данная почта уже используется",
    "LiJiBangDing": "Немедленно подвязать",
    "ShouJiHaoMaCunZai": "Данный номер уже существует",
    "ShuRuKuangBuNengWeiKong": "Область нельзя оставлять незаполненной",
    "ZhiShaoNGeZiFuZiMuYuShuZiZuHeQuFenDaXiaoXie": "Минимальное количество символов - 6, должно содержать как строчные, так и заглавные буквы с числами",
    "DianJiDengLu": "Перейти для регистрации",
    "QianWangBangDing": "Привязать к аккаунту",
    "NinHaiWeiBangDingShouJiHaoMa": "Ваш номер телефона еще не подвязан",
    "DianJiChaKanGengDuoYouZhi": "Нажмите для просмотра всей продукции на essa.cn - международной платформе по закупке игрушек",
    "ChongZhiMiMa": "Восстановить пароль",
    "QuYanZheng": "Проверить",
    "DiJiaReXiaoPinCuXiaoTuanG": "Распродажа хитовых позиций по низкой стоимости в Совместных заказах",
    "MeiYueGengXinPinPaiReXiao": "Ежемесячное обновление хитов продаж, формируйте Совместные заказы",
    "TuanGouShuoMing": "Совместные заказы",
    "HuoBaoTuanGou": "Хиты совместных заказов",
    "TuanGouShuoMing1": "Эксклюзивная продукция в совместных заказах!",
    "TuanGouShuoMing2": "Запуск 1-го числа каждого месяца, успейте оформить заказы в течение 30 дней!",
    "TuanGouShuoMing3": "Время акции: Начало: 1-го числа каждого месяца; Конец: последний день месяца.",
    "TuanGouShuoMing4": "Правила акции:",
    "TuanGouShuoMing5": "① Каждый товар имеет условия акции по количеству коробок. Данный заказ будет подтвержден, при условии достижения требований;",
    "TuanGouShuoMing6": "②В ходе акции, товары можно свободно как добавлять в корзину, так и удалять из нее;",
    "TuanGouShuoMing7": "③ Когда условия акции будут достигнуты, Вам на почту придет письмо для подтверждения данных о закупке. Пож-та, подтвердите покупку в течении 7 дней;",
    "TuanGouShuoMing8": "④ Подтвердив покупку, удалить товар уже будет нельзя. Если мы своевременно не получим Вашего подтверждения о покупке, система по умолчанию аннулирует добавленные в корзину позиции, участвующие в акции;",
    "TuanGouShuoMing9": "⑤ В процессе согласования результатов акции, Вы еще можете продолжать добавлять товары в корзину, но решение о их покупке нужно будет принять сразу;",
    "TuanGouShuoMing10": "⑥ После успешно завершенной акции, только по подтвержденным к покупке товарам можно сформировать сборный контейнер. Если условия не были достигнуты, тогда мы аннулируем добавленные товары к покупке. Но Вы можете приобрести их по фабричной изначальной стоимости и указанному МОК.",
    "GuiZe": "Правила",
    "BangNingZhaoYang2": "Нажмите на \"Поиск товара\" и сотрудники ESSA помогут сделать для Вас подборку",
    "BangNingZhaoYang1": "Как быть, если не удается найти искомый продукт?",
    "FangWenGuoJia": "Пользователей",
    "ReMenFenLei": "Категории хитов",
    "ShangPinBaoHu": "Защита товара",
    "ChaKanQuanBuTuiJianPinPai": "Просмотреть все бренды",
    "ZanWuPinPai": "Временно нет информации",
    "JinYiGeYuePinPaiGuanZhuDu": "Кол-во просмотренных брендов за посл.месяц",
    "JinYiGeYuePinPaiShangXin": "Новинки марки за последний месяц",
    "XinZengNGeKuanShi": "Добавлены<b>{0}</b>новые модели",
    "TuiJianPaiXu": "Рекомендуемый фильтр",
    "GuanZhuDuPaiXu": "Порядок кол-ва просмотров",
    "GengXinKuanShuPaiXu": "Сортировка моделей по новинкам",
    "ZhuYingLeiMu": "Основные категории",
    "ZhuYingShiChang": "Основной рынок",
    "Jin90TianXunJiaCiShu": "Кол-во запросов за 90 дней",
    "Jin90TianDingDanLiang": "Заказы за последние 90 дней",
    "RenZhengXinXi": "Подтверждающая информация",
    "GuanLianPinPai": "Альянс брендов",
    "GongChangZhanShi": "Шоурум производителя",
    "ESSAZhanTing": "Товар в шоуруме",
    "DianJiShu": "Кол-во кликов",
    "ShangPinZhengShu": "Сертификаты",
    "JiangXuanZhongShangPinJiaRuGouWuChe": "Добавить выбранный товар в корзину?",
    "ZhanTingXuanPin": "Отборка в шоуруме",
    "NinHaiMeiYouZhanTingXuanPin": "У Вас нет отборки в шоуруме",
    "NinHaiMeiYouShiChangShangPin": "У Вас нет отборки с рынка в Иу",
    "XuanPinShiJian": "Время отборки",
    "XiaoLiang": "Объем продаж",
    "LiShiJiaoYi": "История заказов",
    "PiLiangJiaRu": "Загрузить партией",
    "ReDu": "Клики",
    "NCiGuanZhu": "<b>{0}</b>кол-во просмотров",
    "QiZhongYouKuanXuYaoSheZhiMaiTou": "для данной {0} модели нужно установить информацию по маркировке",
    "QiZhongYouKuanXuYaoSheZhiTieZhi": "для данной {0} модели нужно установить информацию по стикеру",
    "DanKuanShangPinBuShiYongMaiTou": "Неиспользуемая маркировка для одной модели",
    "DanKuanShangPinBuShiYongTieZhi": "Неиспользуемый стикер для одной модели",
    "DengLuChaJia": "Цены видны после регистрации",
    "JiZhuMiMa": "Запомнить пароль",
    "QingXuanZeQuYuZhanDian": "Пожалуйста, выберите регион",
    "DengLuZhuanXiang": "Привилегии при регистрации на ESSA",
    "ChaKanChuChangJiaGe": "Просмотр<b>фактических</b>цен от фабрик",
    "SuiShiZhiJieYiJia": "Общение с производителем<b>о цене напрямую</b>",
    "KeJiShiChaKanXinPin": "Можно просматривать ежедневное обновление и <b>более 2000 новинок</b>",
    "ShiFouSuoYouShangPinBuShiMaiTou": "Для всех товаров не использовать маркировку?",
    "ShiFouSuoYouShangPinDouShiYongMaiTou": "Для всех товаров использовать{0}маркировку?",
    "ShiFouSuoYouShangPinBuShiYongTieZhi": "Для всех товаров не использовать стикер?",
    "ShiFouSuoYouShangPinDouShiYongTieZhi": "Для всех товаров использовать{0}стикер?",
    "Ci": "Раз",
    "XinPinXuDengLuHouFangKeChaKan": "Новинки доступны для просмотра после регистрации",
    "JinRuGongChang": "Перейти к производителю",
    "XinPinYuShouShuYuGongChang": "Новинки в предварительных заказах - это продукция, которая еще не в массовом производстве, войдите в систему для просмотра",
    "XinPinYuShouMeiYue": "Обновление новинок на сайте происходит 1 числа каждого месяца, не пропустите",
    "WoYaoDiJia": "Низкая цена",
    "DengLuHouKeJian": "Видны после регистрации",
    "QingTianXieZhenShiJiaGeWuEYiYaJia": "Пожалуйста, заполните реальное количество покупки и цену, слишком низкая цена приведет к тому, что фабрика не захочет принимать ваш заказ!",
    "ZhanShiXinXiHuoQuYouHuiJiaGe": "При заключении сделки мы покажем фабрике информацию о наиболее подходящей для Вас цене, с целью получения максимально выгодного варианта.",
    "GongChangBaoJia": "Фабричная цена",
    "YiXiangJiaGe": "Целевая стоимость",
    "CaiGouXiangShu": "Кол-во к закупке",
    "QuXiaoShouCang": "Отменить в избранном",
    "ChaKanQianKuanMingXi": "Просмотр деталей по задолженности",
    "JieSuanDanHao": "Акт-расчет",
    "JieSuanRiQi": "Дата расчета",
    "ChuHuoRiQi": "Дата отгрузки",
    "HuoGuiTiJi": "Объем контейнера",
    "ShangPinHeJi": "Всего товаров",
    "CaiGouShangBianHao": "Номер клиента",
    "POBiZhang": "Валюта PO",
    "BenDanYingShouFeiYongMingXi": "Детали по предстоящей оплате по данному заказу",
    "FeiYongRiQi": "Дата оплаты",
    "FeiYongXiangMu": "Перечень оплат",
    "FeiYongJinE": "Сумма платежа",
    "DaiZhiFu": "Ожидание оплаты",
    "CaiGouShangLeiJiDaiZhiFuFeiYongHeJi": "Сумма ожидаемых оплат от клиентов",
    "MeiYuanDaiZhiFu": "Ожидание оплаты в долларах",
    "RenMinBiDaiZhiFu": "Ожидание оплаты в юанях",
    "PODanShangPinMingXi": "Детали PO",
    "ShangPinID": "ID товара",
    "GongChangBianHao": "Артикул фабрики",
    "DingGouXiangShu": "Кол-во коробок в заказе",
    "ZongShu": "Всего",
    "DengJiRiQi": "Дата регистрации",
    "YiShouKuan": "Платеж получен",
    "QianKuanJinE": "Сумма долга",
    "YuJiFuKuanShiJian": "Ориентировочная дата оплаты",
    "YiBianDong": "Изменено",
    "BuHuoChiShangPinYouYiChang": "Сбой в разделе по добавлению товара",
    "POShangPinShengChanZhongYouYiChang": "Сбой в производстве товаров по заказу",
    "WoYaoBuHuo": "Добавить товар",
    "WoYaoDiaoRuShangPin": "Мне нужно перенести товары",
    "YouGongChangFanKuiShangPin": "Ответ от фабрики",
    "WoDeDingDanYaoQiu": "Требования к заказу",
    "ShouJiPaiWanJuZhaoGongChang": "Фото игрушки с телефона, поиск производителя",
    "LiJiTiYan": "Попробовать сейчас",
    "PaiTuZhaoYang": "Сделать фото для поиска товара",
    "ZhaoDaoWanJuYangPinZhaoPian": "Фотография образца с выставки",
    "SuiShiSuiDiShangChuanTuPianChaZhao": "В любое время, Вы можете ввести в браузере m.essa.cn, нажать поиск по картинке, загрузить фотографию для поиска",
    "ShangChuanHouTuiJianXiangSiKuan": "После загрузки, система автоматически найдет информацию о товаре или ESSA порекомендует подобные позиции",
    "HaiKeYiJingXingRenGongZhaoYang": "Если Вы видите, что по фотографии не получается найти искомый товар, передайте задание для поиска нашей команде профессионалов для помощи",
    "KeHuZongQianKuan": "Общая сумма задолженности по клиенту",
    "DaiZhiFuDingJin": "Ожидание оплаты депозита",
    "BuManGuiTxt": "Контейнер не заполнен",
    "HongSeDaiBiaoWeiDu": "Красным выделено непрочитанное",
    "MeiYouZhaoDaoFuHeTiaoJianSP": "Извините, товары по заданным требованиям не найдены, повторите свой поиск или измените регион поиска",
    "BaoHanDuanTuYunFei": "Включен расход за транспортировку на короткое расстояние",
    "WeiHuoZhongMeiYouZhaoDao": "В остатках не найдено{0}соответствующих товаров",
    "GouWuCheZhongMeiYouZhao": "В Вашей корзине не найдено{0}соответствующих товаров, если Вы хотите добавить данный товар к заказу, положите его в корзину, после запроса цены, он будет добавлен в заказ",
    "GouWuCheZanWuShangPin": "Пока корзина пуста, Вы можете начать с поиска товаров и после добавить в корзину для запроса цен",
    "ChongDanZhongMeiYouZhao": "В товарах, которые готовы к дате загрузки не найдены соответствующие{0}товары",
    "ChongDanZanWuShangPin": "В настоящий момент нет товаров, которые будут готовы к дате загрузки контейнера",
    "QiTeXinPin": "Специальные новинки",
    "WeiNinJingXuan": "Отобранные для Вас",
    "ShouFaMingYouPinPai": "Первая публикация фирменных марок",
    "DaoDiLaKanKanQiTaShangPin": "Больше информации нет, посмотрите другие товары",
    "GongNeng": "Функции",
    "BaoQianNinXuanZeDeShiJian": "Извините, за выбранный Вами период времени не найдено подходящих товаров",
    "WoMenWeiNinTuiJianZuiJinY": "Мы рекомендуем Вам новинки за последний месяц",
    "ZuiJinLiangGeYue": "За последние 2 месяца",
    "WoMenWeiNinTuiJianZuiJinYiZhou": "Мы рекомендуем Вам новинки за последнюю неделю",
    "GenJuShangMianDeShangPinJ": "Интересное для Вас",
    "ShangPinBianMaGongChangHu": "Поиск по серийному номеру",
    "XiaoShouDiQu": "Район сбыта",
    "DiYiShiJianTuiJianXinPinReXiaoPin": "Вы будете первым получать новинки и хиты-продаж, пользующиеся спросом в Вашем регионе",
    "NinDangQianHaiWeiYouErJiYongHu": "В настоящее время у Вас еще нет пользователей второго уровня",
    "YiChengGongFuZhiWoDeYaoQingLianJie": "Моя эксклюзивная ссылка приглашения успешно скопирована",
    "TuiGuangYaoQing": "Приглашение",
    "ChengNuoBuHuiDuiWaiGongKaiXinXi": "Выдача официальных накладных и других документов. Платформа ESSA обязуется не разглашать информацию и соблюдать положения соглашения о конфиденциальности.",
    "ShenFenZhengHaoHuoHuZhao": "Гражданами КНР вводится номер ID;  Иностранцами номер паспорта",
    "FenXiaoShangDengLu": "Вход для дистрибьютора",
    "Wo": "Я",
    "JiangYaoQingMaGaoZhiHaoYou": "Сообщите Вашим друзьям код приглашения",
    "ShangESSAZhuCeBingTianRuYaoQingMa": "Зарегистрируйтесь на essa и заполните код приглашения",
    "WeiBaoZhengZhangHaoYanZheng": "Для обеспечения безопасности Вашего аккаунта,сначала привяжите номер телефона",
    "SheZhiXinDeDengLuMiMa": "Создать новый пароль для входа",
    "WoDeFenXiaoZhongXin": "Мой кабинет",
    "LeiJiYiTiCheng": "Общая сумма",
    "LeiJiTiCheng": "Общий заработок с заказов",
    "WuFaYanZhouQingLianXi": "Если вы не можете использовать номер телефона для подтверждения, пожалуйста обратитесь в службу поддержки клиентов,я хочу<a id=\"udesk_container_btn\" class=\"a-link\" href=\"javascript:void(0);\">связаться со службой поддержки клиентов",
    "WoDeTiCheng": "Процент от продаж",
    "BenYueTiCheng": "За этот месяц",
    "WanChengZhuCeGuanXiBangDing": "Регистрация завершена, привязка отношений",
    "YaoQingHaoYouXinXiC": "3. После успешной регистрации друга-клиента, Вы можете просмотреть информацию о нем в списке \"Пользователи\", если информация о друге-клиенте все еще отсутствует, пожалуйста, свяжитесь со службой поддержки клиентов essaone.cn .(Только после успешной привязки,Вы сможете получить комиссионные от заказов друзей-клиентов）",
    "TiChengTongJi": "Процент от продаж",
    "TiChengJinE": "Сумма комиссии",
    "TiChengDianLv": "Коэффициент комиссии",
    "YuJiTiCheng": "Ожидаемая сумма",
    "DingDanHuoKuan": "Оплата заказа",
    "YuJiTiChengJinE": "Общая сумма отчислений по предварительным расчетам",
    "YongHuDengJi": "Уровень пользователя",
    "YuJiDingDanHuoKuan": "Стоимость заказа по предварительным расчетам",
    "HeJiFanTiJinE": "Общая сумма возращенных комиссионных",
    "WoDeTuiGuangYongHu": "Мои пользователи",
    "HiJiYuJiTiChengJinE": "Общая сумма ожидаемой комиссии",
    "YiJiYongHu": "Пользователь 1-го уровня",
    "ErJiYongHu": "Пользователь 2-го уровня",
    "ZhuYaoChuHuoFangShi": "Основной метод отгрузки",
    "WoDeTuiGuangYaoQingMa": "Мои приглашения",
    "GongShangZhiZhaoHao": "ОГРН",
    "ShuiWuHao": "ИНН",
    "WoDeZhuanShuYaoQingLianJie": "Моя эксклюзивная ссылка на приглашлашение",
    "QingTianXieShuiWuHao": "Пожалуйста, введите ИНН",
    "FuZhiWoDeZhuanShuYaoQingLJ": "Скопировать мою ссылку приглашения",
    "QingTianXieGongShangZhiZhaoHao": "Пожалуйста, введите номер бизнес-лицензии",
    "WoDeYaoQingMa": "Мой код приглашения",
    "YaoQingMaMoRenBangDingShouJi": "Код приглашения по умолчанию установлен на привязанный Вами номер телефона",
    "QingXuanZheZhuYaoChuHuoFangShi": "Пожалуйста выберите основной метод отгрузки",
    "GuoJiDiQu": "Страна/ Регион",
    "FenXiang": "Поделиться",
    "ShangPinXinXiJiLianJieYiJingFuZhi": "Информация о товаре и сслыка уже скопированы",
    "ZhengJianHaoMa": "Номер удостоверения",
    "NinKeYiZhanTieFaSongGeiPenYou": "Вы можете поделиться с друзьями в соц сетях или отправить по почте",
    "ZhengJianZhaoPian": "Фото удостоверения",
    "JinJiLianXiRenXinXi": "Информация о контакте в случае экстренной ситуации",
    "WoShiCaiGouShang": "Я-покупатель",
    "NinTiGongDeJinJiLianXiRenYaoQiuMiaoShu": "Контакт в случае экстренной ситуации должен быть лицом(родственник, друг)через которого мы в скором времени сможем связаться в Вами",
    "WoShiFenXiaoShang": "Я - дилер",
    "WoDeTuiGuangXinXi": "Моя информация о продвижении",
    "TuiGuangYaoQingJieShao": "Сведения о приглашение друзей-клиентов",
    "YaoQingHaoYouWoKeDe": "Пригласив друзей-клиентов, я получу",
    "WoDeSuoYouTuiGuangYongHu": "Все мои пользователи продвижения",
    "WoXiaJiaYaoQingHaoYouWoKeDe": "Мой друг-клиент пригласив друзей,получит",
    "DingDanWanJieFanYong": "Партнерская комиссия от завершенного заказа",
    "WoHaoYouKeDe": "Мой друг может получить",
    "NZheKou": "{0} скидка",
    "ShouDanZheKouQuan": "Скидочный купон на первый заказ",
    "LianXiDianHua": "Телефон",
    "YaoQingTiXing": "Напоминание о приглашении",
    "YaoQingHaoYouXinXiA": "1. Вы можете скопировать ссылку приглашения, и поделиться ей с друзьями в соц.сетях, или отправить по эл.почте.",
    "YaoQingHaoYouXinXiB": "2. Вам нужно сообщить своим друзьям-клиентам, что  при регистрации они должны ввести Ваш номер приглашения, таким образом он будет связан с вашим счетом. Вы будете получать комиссию за оформленный Вашим другом заказ на платформе essaone.",
    "EPLUSHuiYuan": "Пользователь E-PLUS",
    "YaoQingLiuCheng": "Процесс приглашения",
    "LeiJiXiaDanShu": "Кол-во заказов",
    "TongGuoLianJieYaoQingKeHuPengYou": "Пригласить друзей-клиентов, отправив ссылку",
    "LeiJiChengJiaoJinE": "Сумма сделки",
    "FuZhiYaoQingLianJie": "Копировать ссылку приглашения",
    "ZuiHouYiCiChengJiaoShiJian": "Время последней сделки",
    "TongGuoIMFenXiang": "Поделиться в соц сетях",
    "NinDangQianHaiWeiTuiGuangYao": "В настоящее время в Вашем списке нет пользователей по продвижению",
    "HuoTongGuoYouJianFenXiang": "Отправить по электр.почте",
    "HaoYou": "Хороший друг",
    "QuTuiGuang": "Продвигать",
    "DianJiLianJieWanChengZhuCe": "Нажмите на сслыку, для завершения регистрации",
    "NinDangQianHaiWeiYouTiCheng": "У вас еще не имеется комиссии",
    "GuanXiBangDing": "Привязка отношений",
    "FenXiaoZhongXinShouYe": "Моя учетная запись",
    "TongGuoYaoQingMaYaoQingKeHu": "Пригласить друзей-клиентов, отправив код приглашения",
    "TuiGuangYongHuChaXun": "Пользователи",
    "ContactQueryError": "Ошибка запроса контакта",
    "AccountQueryError": "Ошибка запроса учетной записи дистрибьютера",
    "DistributorQueryError": "Ошибка запроса информации о дистрибьютере",
    "BankAcountQueryError": "Ошибка получения информации о банковском счете",
    "ShouJiHaoMaBuNengXiangTong": "Номер телефона основного счета не может быть идентичным с номером телефона экстренного контакта",
    "ShouJiHaoMaError": "Неправильно введен номер телефона",
    "YanZhengShiBai": "Ошибка проверки, повторите попытку",
    "ChongXinHuoQuYanZhengMa": "Получить код",
    "YiJi": "1-й уровень",
    "ErJi": "2-й уровень",
    "SheZhiXinMiMa": "Установить новый пароль",
    "ShenFenYanzheng": "Проверка личности",
    "GenHuanXinDeShouJiHao": "Изменить номер телефона",
    "GenHuanChengGong": "Успешно изменен",
    "GengHuanBangDingShouJi": "Изменить привязанный номер",
    "ChongXinDengLu": "Повторный вход",
    "QingYongShouJiHaoChongXinDengLu": "Пожалуйста войдите в систему, используя новый номер телефона",
    "NinDeZhangHaoYiQieWeiXinShouJiHaoMa": "Ваш аккаунт изменил номер телефона",
    "BangDingDeShouJiGengHuanChengGong": "Привязанный номер успешно изменен",
    "DangQianYiBangDingShouJiHaoMa": "Текущий привязанный номер телефона",
    "TiJiaoRenZheng": "Передать для подтверждения",
    "DangQianShouJiHao": "Текущий номер телефона",
    "MiMaZuHeGuiZe": "6-20 символов, должно состоять из двух комбинаций: букв, цифр и символов",
    "KaiJuFaPiaoBingQieZunShouBaoMiXieYi": "Платформа essa обещает не разглашать сведения составляющие коммерческую тайну партнеров",
    "JinJiLianXiRenXingMing": "Ф.И.О  лица при экстренной  ситуации",
    "JinJiLianXiRenHaoMa": "Номер телефона лица при экстренной ситуации",
    "KaiHuHang": "Обслуживающий банк",
    "KaiHuMing": "Имя клиента",
    "YinHangZhangHao": "Банковский счет",
    "QingTianXieXingMing": "Пожалуйста введите Ф.И.О",
    "QingTianXieZhengJianHaoMao": "Пожалуйста введите номер удостоверения",
    "QingTianXieJinJiLianXiRenXingMing": "Пожалуйста введите Ф.И.О лица при экстренной ситуации",
    "QingTianXieJinJiLianXiRenHaoMa": "Пожалуйста введите номер телефона лица при экстр.ситуации",
    "MiaoHouZiDongTiaoZhuanDengluYeMian": "Через {0} секунд перейдет на страницу входа в систему",
    "QingBangDingShouJiHao": "Пожалуйста привяжите номер телефона",
    "TouXiang": "аватар",
    "YouHuiQuan": "Скидочный купон",
    "WeiShiYongYouHuiQuan": "Скидочный купон не использован",
    "YiShiYongYouHuiQuan": "Скидочный купон уже использован",
    "YiGuoQiYouHuiQuan": "Скидочный купон просрочен",
    "ZanWuWeiShiYongYouHuiQuan": "Скидочный купон еще не использован",
    "ZanWuYiShiYongYouHuiQuan": "Вы уже не можете использовать скидочный купон",
    "ZanWuYiGuoQiYouHuiQuan": "Срок использования скидочного купона уже истек",
    "ShouHuoRenXinXi": "Информация о грузополучателе",
    "MianDingJinXiaDan": "Разместить заказ без внесения депозита",
    "ReMaiShangPinTuiJian": "Рекомендуемые хиты продаж",
    "GenJuDaShuJuFenXiAnDiQuAn": "Согласно анализу данных, рекомендуйте топовые позиции участникам E-plus, ориентируясь на время по их часовому поясу",
    "ZhuanShuKeFu": "Эксклюзивный специалист службы клиентской поддержки",
    "ZaiFuWuGuoChengZhongYuDao": "В случае любых проблем, возникших во время обслуживания, ESSA в первую очередь решит проблемы участника E-plus",
    "XinZengShouHuoRen": "Добавить нового грузополучателя",
    "XinZengShouHuoRenXinXi": "Добавить информацию о новом грузополучателе",
    "BianJiShouHuoRenXinXi": "Изменить сведения о грузополучателе",
    "ShanChuShouHuoRenXinXi": "Удалить сведения о грузополучателе",
    "ShiFouShanChuShouHuoRenXi": "Удалить информацию о грузополучателе?",
    "GengDuoLianXiRen": "Еще контактные лица",
    "ZanWuShouHuoRenXinXiNinKe": "Информация о грузополучателе отсутствует, вы можете добавить",
    "ShouHuoRen": "Грузополучатель",
    "QingShuRuShouHuoRen": "Пожалуйста укажите грузополучателя",
    "QingShuRuShouJi": "Пожалуйста введите номер телефона",
    "MuDeDiChengShi": "Город пребывания груза",
    "QingXuanZeMuDeDiChengShi": "Пожалуйста выберите город пребывания груза",
    "XiangXiDiZhi": "Точный адрес",
    "QingShuRuXiangXiDiZhi": "Пожалуйста введите точный адрес",
    "WeiLeXiangHeXinKeHuTiGong": "Чтобы улучшить качество покупок для основных клиентов，ESSA разработала проект \"Участник E-plus\". Став участником категории E-plus, у Вас будет возможность размещать заказы без предоплаты, Вы будете получать эксклюзивные предложения и рекомендации о топовых позициях, обработка и решение Ваших вопросов будет в приоритете",
    "LaiYuanYongTu": "Источник / Применение",
    "HuoDeGengDuoQuanYi": "Получить больше преимуществ",
    "MaiJiaChengJiaoDingDan": "Покупатель уже совершил сделку LTD",
    "LianXiKeFu": "Онлайн-контакт",
    "WanChengYiXiaQiZhongYiGeT": "Выполните одно из следующих условий, чтобы стать участником E-plus",
    "YaoQingManRenZhuCeBingRen": "Пригласить {0} человек, зарегистрировать на платформе, или пригласить {1} друга, который готов заключить сделку, стать участником E-Plus и разместить заказ без предоплаты",
    "JiaRuXiangZhuanShuTeQuan": "Преимущества участника E-Plus",
    "QingShangChuanZhaoPinHeDuiXinXi": "Для подтверждения подлинности, просьба загрузить фото документов; Мы обязуемся защищать Вашу личную информацию согласно соглашению о конфиденциальности essa.",
    "YinHangKaXinXi": "Сведения о банковском счете",
    "FenXiaoShangYinHangZhangHaoYongYuFanLi": "Для последующей работы, убедитесь, что сведения о банковском счете партнера верные",
    "QueRenQiYeXinXi": "Подтвердить сведения о предприятии",
    "QueRenShouHuoDiZhi": "Подтвердить адрес доставки",
    "SheZhiDingDanYaoQing": "Установить требования к заказу",
    "ZhuCeZhengShuBianHao": "ОГРН",
    "QingTianXieZhuCeZhengShuBianHao": "Пож-та введите номер бизнес-лицензии",
    "TiGongZhengGuiDePiaoJu": "Заполненные Вами сведения должны быть максимально точными, так как они будут использоваться при составлении контракта, в инвойсе, также будут указываться в квитанциях. Мы предоставим вам официальный инвойс, квитанции таможенных служб и др квитанции.",
    "ZunXunPingTaiBaoMiXieYi": "ESSA обязуется защищать Вашу информацию в строгом соответствии с соглашением о конфиденциальности платформы ESSA.",
    "DDPFuWuGuoJia": "Страна обслуживания DDP",
    "YuJiDaoGangShiJian": "Ориентировочная дата доставки",
    "ShangPinHuoKuan": "Оплата товара",
    "WuLiuQingGuanFei": "Таможенные сборы",
    "WeiBuYingXiangDingDanYuJiDaoGangShiJian": "Примечание: Во избежание замедления получения заказа, оплатите депозит как можно скорее, ориентировочная дата доставки будет основываться на фактической дате оплаты депозита.",
    "Zhou/Sheng": "Область/ Район",
    "ChengShi": "Город",
    "GaiChengShiZanWuShouHuoDiZhi": "В данном городе не имеется адреса получателя, вы можете ввести новый адрес",
    "QiTaGuoJiaTuoZhanZhongHouXuKaiFang": "Мы работаем над расширением рынка, другие города и страны будут открыты в будующем",
    "GaiYouHuiQuanYiBeiQiTaZhangHaoXuanYong": "Купон уже выбран другим пользователем",
    "BuShiYongYouHuiQuan": "Не использовать скидочный купон",
    "ManN": "При заказе на сумму{0}",
    "YuJiDingJin": "Расчетный депозит",
    "ZongHuoKuan": "Общая сумма",
    "ShiYongYouHuiQuan": "Использовать скидочный купон",
    "ZanWuKeYongYouHuiQuan": "Данный купон нельзя использовать",
    "XuanZeYouHuiQuan": "Выбрать скидочный купон",
    "DDPBuZhiChiPinWeiHuo": "Доставка DDP временно не поддерживает складирование по остаточному товару, включенные элементы игрушек после корректировки повлияют на цены, Вы уверены изменить?",
    "ZanShiMeiYouChangYongBaoJiaFangShi": "На данный момент не имеется назначения цен в {0}",
    "SanDanJiChuJianJie": "Совместный заказ позволяет каждый день автоматически консолидировать малый заказ, каждую неделю осуществлять отправку, в короткие сроки доставлять товар на склад клиенту, кроме того, включает полное обслуживание таможенных затрат. Эта функция дает возможность оптовикам напрямую работать с китайскими производителями через платформу ESSA.",
    "WoYiYouZhangHaoDengLu": "У меня есть учет.запись, <a class=\"red\" href=\"/login\">войти</a>",
    "XiaYiBuQueRenShouHuoXinXi": "Шаг след-й, подтвердить сведения о получателе",
    "GengHuanMuDiDiZhiYingXiangJiaGe": "При изменении города пребывания груза, цены за логистику и ориентировочная дата доставки могут изменится!",
    "QingTianXieXiaDanRenXingMing": "Пож-та введите ФИО заказчика",
    "QingTianXieXiaDanRenShouJi": "Введите номер телефона заказчика",
    "QingXuanZeShouHuoRenXinXi": "Пожалуйста выберите сведения о получателе",
    "QingXinZengBingXuanZeShouHuoRen": "Добавьте и выберите сведения о получателе",
    "XiaDanRenXinXi": "Сведения о заказчике",
    "ShouJiHaoMao": "Номер телефона",
    "MuDiDiXinXi": "Сведения о городе пребывания груза",
    "JinZuoWeiShouHuoRenWuFaLianXiShi": "Если в последующем возникнут проблемы с заказом, пож-та свяжитесь с заказчиком и решите их, сначала заполните инф-ю о заказчике и подтвердите",
    "LiaoJieGengDuo": "Подробнее",
    "SanDanJiChuFuWuJianJie": "«LCL до дверей»: Прямая закупка с китайских фабрик по самым низким ценам.",
    "GenJuZhuXiaoShouDiQuPiPeiFuWuGuoJiaHeChengShi": "Для обеспечения более точной цены, выберите город получения  в соответствии с зарегистрированным регионом продаж вашей страны.",
    "QingZaiGongSiXinXiZhongXiuGaiDDPMuDiChengShi": "Выбранный Вами город получения будет использоваться в качестве основы для цен DDP, при необходимости войдите в центр клиентов и внесите необходимые поправки.",
    "GengDuoChengShiKaiTongDDPFuWu": "Мы постепенно расширяем список городов в которые будет доступна доставка",
    "BaoJiaGuiZe7": "Стандартная цена на условиях DDP:",
    "BaoJiaGuiZe8": "Стоимость товара+ таможенное оформление （Цены DDP не включают стоимость доставки по России, плата осущ-ся клиентом после прихода груза на склад клиента ）",
    "MetaMiaoshu": "ESSA это онлайн-платформа по поиску и продаже игрушек с более чем 20 000 фабриками и включающая в себя 1 миллион непересекающихся позиций.",
    "FuWuGuoJia": "Страна получатель",
    "BianJiMuDiDiXinXi": "Изменить сведения о получении товара",
    "QingXuanZeMuDiChengShi": "Пож-та выберите город доставки",
    "YuJiDaoGangShiJianTuiChiT": "Уведомление о задержании ориентировочной даты доставки товара",
    "ZhuYiLiShiYuJiDaoGangShiJ": "Внимание: историю изменения ориентировочной даты доставки, пож-та проверьте в отслеживании заказов",
    "XinYuJiDaoGangShiJian": "Новая ориентировочная дата доставки",
    "YuanShiYuJiDaoGangShiJian": "Изначальная ориентировочная дата доставки",
    "NiHaoWoShiNiDeFuWuGuWen": "Здравствуйте! Я-ваш личный консультант {0}",
    "ShouHuoXinXi": "Сведения о получении товара",
    "XinDingDanDouShiYongGaiBaoJiaZuHe": "Новые заказы используют данную комбинацию оф.установленных цен",
    "QingJinKuaiZhiFuDingJinYu": "Пож-та внесите депозит как можно скорее, т.к ориентировочная дата доставки будет меняться от того, когда мы получим депозит, что может привести к задержке",
    "YouYuWeiShouDaoDingJinDin": "По причине того, что депозит не был получен, данный заказ не может быть передан фабрике для начала производства, это повлияло на то, что предварительная дата отгрузки контейнера будет отложена до {0} числа（Предварительная дата {1}）, пожалуйста, в кратчайшие сроки внесите депозит (считается время поступления депозита на счёт)",
    "YouYuWeiShouDaoHuoKuanZao": "По причине того, что заказ не был оплачен , процесс производства товаров не был завершен в соответствии с первоначальным планом, это повлияло на то, что предварительная дата отгрузки контейнера будет отложена до {0} числа（Предварительная дата {1}）, пожалуйста, в кратчайшие сроки оплатите заказ (считается время поступления депозита на счёт)",
    "ShangPinShengChanGuoCheng": "По причине того, что процесс производства товаров не был завершен в соответствии с первоначальным планом, предварительная дата загрузки сместилась до {0} числа（Предварительная дата {1}) . Примите к ознакомлению!",
    "ShiHuo": "Сезонные товары",
    "NinDeDingJinYiShouDaoBing": "Ваш депозит был получен, подтвердите РО, после чего фабрика начнет производство",
    "NinDeDingDanYiTiJiaoQingZ": "Для начала производства заказа необходимо внести депозит",
    "QueRenPO2": "Подтвердить РО",
    "NinDeDingDanShangPinYiJin": "Производство Вашего заказа уже завершено, пож-та проведите оплату по товару, чтобы не задерживать сроки отправки груза",
    "NinDeDingDanYiJingZhuangJ": "Ваш товар уже отправлен, пож-та оплатите остаточную сумму, чтобы не повлиять на процесс получения товара",
    "FuKuanZhiYin": "Оплатить в соответствие с инструкциями",
    "YiZhiFuDingJin": "Заказ уже оплачен",
    "DanHaoFaSongDaoShouJi": "Отправить номер PO Вам на телефон",
    "DanHaoYiJingFuZhi": "Номер PO уже скопирован",
    "DanHaoYiJingFaSongDaoShou": "Номер PO уже отправлен Вам на телефон",
    "FaSongDaoShouJi": "Уже отправлено на телефон",
    "ZheHe": "Перевод валюты",
    "GongXiNin_Shi": "Поздравляем, РО успешно передан в работу, Ваш депозит был получен, нажмите на кнопку подтверждения «подтвердить», после чего фабрика начнет производство",
    "GongXiNin_ShiYi": "Поздравляем Вас, РО успешно передан в работу, наши сотрудники скоро свяжутся с Вами. Пож-та убедитесь в верности данных позиций, затем внесите депозит на банковский счет, указанный ниже и подтвердите заказ РО. Полная сумма заказа должна быть оплачена до прибытия груза в порт. За более подробной инф-й обратитесь к Вашему консультанту.",
    "ShouKuanRen": "Получатель",
    "YouHuiJinE": "Скидка",
    "ShouBiDingDanDingJinWei": "Депозит 1-го заказа по проекту DDP составляет {0}",
    "ShouBiDingDanQieDingDanZo": "Первый заказ по проекту DDP и общая сумма заказа {0}, депозит сос-т {1}",
    "QingZaiNTianNeiZhiFuDingJin2": "Пож-та внесите депозит как можно скорее, т.к ориентировочная дата доставки будет меняться от того, когда мы получим депозит, что может привести к задержке",
    "BuHaoYiSiGuiSiDangQianWeiTiJiaoDdp": "К сожалению, в наст. время у вас имеется DDP заказ не переданный в работу, поэтому Вы не можете изменить район сбыта, пож-та передайте заказ в работу, или переключите режим в НЕ DDP заказ.",
    "ChaKanShiLi": "Просмотреть образец",
    "FaSong": "Отправить",
    "HuiKuanZhongXieDanHao": "Чтобы подтвердить заказ и начать производство в сроки. введите верный номер РО в сведениях о переводе денег",
    "YiXiangKuaiChu": "Отгрузка от 1-й коробки!",
    "XianShangZhanTing": "Возможно вам понравится",
    "GuangYiGuang": "Просмотреть",
    "ShouDanYuFuZhiXuN": "Сумма предоплаты первого заказа сос-т всего <b>10%</b>",
    "XuanZeDDPKeYiXiangWiDing": "Выбрав “DDP” Вы можете заказывать от 1-й коробки , ESSAONE быстро доставит груз до Вашего склада с учетом офиц-го таможенного оформления",
    "NNianDiNQi": "{0} год {1} Май",
    "JuLiHuoDongJieShu": "До окончания",
    "WanJuGaiBan": "Услуги разработки CTM клиента",
    "NGeJieGuo": "{0} результатов",
    "BangNinZhaoYangRuKouYiDong": "Чтобы сотрудники Essa помогли Вам в поиске товара, перейдите сюда",
    "NinDeDingDanShuJuYiFaShengBian": "Данные Вашего заказа были изменены, обновите страницу и передайте заказ",
    "WeiNinTiGongZuiJiaDeDingZhiJieJueFangAn": "Предоставляем лучший сервис и решения по разработке СТМ клиента!",
    "ZhuanYeDeGaiBanTuanDui": "Команда специалистов по разработке СТМ клиента",
    "ChuSeDeChanPinTuanDuiNNianJingYan": "Мощная команда специалистов, 10-ти летний опыт работы по разработке собственных торговых марок клиентов, неисчислимое кол-во создания успешных торговых марок",
    "YouZhiDeGaiBanFuWu": "Высококачественная разработка СТМ клиента",
    "QiangDaDeGongYingLianZhiChi": "Профессиональная система обслуживания обеспечивает разработки высокого уровня и придерживается строгой политики",
    "GaiBanShangPinYanMiBoaHuQiTaKeHuBuKeJian": "конфиденциальности, чем гарантирует неразглашение информации по всем СТМ каждого клиента",
    "KuaiSuXiangYingNinDeXuQiu": "Быстрое реагирование и слаженная работа",
    "YiJianTiJiaoKuaiSuXiangYing": "Быстрые решения по Вашим требованиям уже через 24 часа",
    "YiXiangChuHuoDeShuoMingNeiRong": "Все товары категории \"Быстрая отгрузка от 1-й коробки\" соот-т требованиям: \"МОК-1 коробка\" и \"Время выполнения заказа ≤10 дней\". \"Быстрая отгрузка от 1-й коробки\" гарантирует МОК-1 коробку, и отгрузку через 10 дней.",
    "ZaiGouWuCheZhongTianJiaShangPin": "Добавить товар в корзину",
    "ChuHuoShiJian": "Быстрая отгрузка товара",
    "MeiGePoDanZuiDuoKeFa": "Отправка смс на телефон в течение 7 дней не может превысить 3-х раз",
    "ZhangHuMingCheng": "Название счета получателя",
    "ShouKuanRenDiZhi": "Адрес юридического лица",
    "YinHangMingCheng": "Полное наименование учреждения банка",
    "YinHangHaoMa": "SWIFT код",
    "YinHangDiZhi": "Адрес банка получателя",
    "KeHuYinHang": "Банк клиента",
    "DaiLiZhangHao": "Корреспондентский счет",
    "YinHangTongYiDaiMa": "БИК",
    "ShangPinBuZhiChiDDP": "Данный товар не поддерживает котировку цен DDP",
    "QingTianXieLianXiFangShi": "Пожалуйста введите контактные данные",
    "LianXiFangShiBiXuWeiShuZi": "Контактные данные должны состоять из цифр",
    "LianXiFangShiYiCunZai": "Данный номер телефона уже существует, пож-та введите новый",
    "DuanXinYiFaSong": "Сообщение отправлено",
    "ChaKanDingDanXiangQing": "Посмотреть информацию о заказе",
    "ShangPinKuanShu": "Кол-во позиций",
    "ShuLiangZongJi": "Общее количество",
    "DingDanSuoXuHuoKuanDanBaoEDu": "Сумма гарантийного счета необходимая для осуществления заказа",
    "PiLiangFuZhiPODanHao": "Скопировать номер заказа",
    "PiLiangFaSongPODanDaoShouJi": "Отправить номер заказа на телефон",
    "PiLiangFuZhiPoDanDeShuoMing": "Пожалуйста заполните номер заказа PO на платеже, который был скопирован или отправлен на ваш мобильный телефон",
    "XuZhiFuDingJinHeJi": "Необходимо оплатить депозит",
    "FuKuanXinXi": "Информация об оплате",
    "ChaKanGuDingBaoZhengJinDengJi": "Посмотреть гарантийный счет",
    "QueDingDingDan": "Подтвердить заказ",
    "DingDanYingFuZongJinE": "Итого к оплате заказа",
    "GongXiNinYiTiJiaoPOQingJiShiQueRenPO": "Поздравляем, ваш заказ РО передан в обработку. Чтобы вы максимально быстро получили ваш товар, мы разделили ваш заказ на {0} заказа в соответствии с выбранным вами временем доставки товара. В настоящий момент суммы вашего гарантийного взноса достаточно для оплаты, нажмите на “Подтвердить”.",
    "YiTiJiaoPOQingLinXiZhuZhangHaoTiShengDengJiChaiDan": "Поздравляем, ваш заказ РО передан в обработку. Чтобы вы максимально быстро получили ваш товар, мы разделили ваш заказ на {0} заказа в соответствии с выбранным вами временем доставки товара Но в настоящий момент сумма вашего гарантийного взноса недостаточна, пож-та  перейдите на основной счет и пополните его.",
    "YiTiJiaoPOQingTiShengDengJiYiMianYanWuShengChan": "Поздравляем, ваш заказ РО передан в обработку. Чтобы вы максимально быстро получили ваш товар, мы разделили ваш заказ на {0} заказа в соответствии с выбранным вами временем доставки товара. Но в настоящий момент сумма вашего гарантийного взноса недостаточна, пож-та пополните ваш счет.",
    "QingXuanZeKeDanBaoDeDingDanHuZeTiShenDengJi": "Поздравляем, ваш заказ РО передан в обработку. Чтобы вы максимально быстро получили ваш товар, мы разделили ваш заказ на {0} заказа в соответствии с выбранным вами временем доставки товара. Но в настоящий момент сумма вашего гарантийного взноса недостаточна для оплаты всех заказов, пож-та выберите заказы, которые можно оплатить, либо пополните ваш счет.",
    "QingBuQiBaoZhengJinEDuYiMianYanWuShengChanChaiDan": "Поздравляем, ваш заказ успешно передан в работу. Чтобы вы максимально быстро получили ваш товар, мы разделили ваш заказ на {0} заказа в соответствии с выбранным вами временем доставки товара. Но в настоящий момент сумма вашего гарантийного взноса недостаточна, пож-та пополните ваш счет и покройте сумму.",
    "YIBianNinJinKuaiShouDaoHuoWuQingJIShiZhiFuDingJin": "Поздравляем, ваш заказ РО передан в обработку. Чтобы вы максимально быстро получили ваш товар, мы разделили ваш заказ на {0} заказа в соответствии с выбранным вами временем доставки товара. Пож-та оплатите депозит.",
    "NinDanQianWeiVIPMianDingJinKeHuQingZhiJieQueRenPOChaiDan": "Поздравляем Вас, заказ РО передан в обработку. Чтобы вы максимально быстро получили ваш товар, мы разделили ваш заказ на {0} заказа в соответствии с выбранным вами временем доставки товара. Так как вы являетесь VIP-клиентом не оплачивающим депозит, пожалуйста кликните \"Подтвердить\" заказ.",
    "ShouYeGuanJianCi": "ESSA.CN, Игрушки и сувениры, Детские товары, В тренде, Новинки, Поставщики игрушек, Китайские фабрики",
    "SouSuoYeBiaoTi": "Прямые поставки из Китая . Игрушки, сувениры, товары для новорождённых",
    "PinPaiYeBiaoTi": "Бренд - Поиск топовых китайских фабрик, Производители, Поставщики",
    "PinPaiYeGuanJianCi": "ESSA.CN, Поставщики игрушек и сувениров, Китайские фабрики, Производители",
    "ShouYeBiaoTi": "Прямые поставки из Китая . ESSA.CN - Онлайн закупки . Игрушки и детские  товары",
    "ChaKanDaTu": "Посмотреть увеличенную картинку",
    "ShuRuPinPaiMingChengShaiX": "Введите название бренда",
    "QingKongSouSuo": "Очистить поиск",
    "ZhaoBuDaoFuHeTiaoJianDePi": "Не нахожу подходящих брендов",
    "NinKeNengHuiXiHuanDePinPa": "Бренды, которые могут вам понравится",
    "PingTaiRenZheng": "Проверка подлинности сайта",
    "GongChangRenZheng": "Сертификация завода",
    "SouSuoBenPinPaiShangPin": "Поиск этого бренда",
    "XiaZaiBaoJiaDan": "Скачать прайс лист",
    "LianXiGongChang": "Связаться с фабрикой",
    "DengLuHouChaKanGongChangL": "После регистрации проверьте контакты фабрик",
    "MingXingShangPin": "Знаменитые товары",
    "PinPaiShouZiMu": "Инициалы бренда",
    "GuoLvJieGuo": "Результат фильтрации",
    "ShaiXuanXiang": "Сортировать",
    "QingXuanZe2": "Пожалуйста выберите",
    "ChanPin": "Продукт",
    "XuanZeZhengShu": "Выбрать сертификат",
    "ChaKan": "Проверить",
    "NinYouZhangDaiDanBaoDeDinWuDengJiPiPei": "У вас есть(0) заказов, текущий уровень залога может гарантировать только часть заказа, подтвердить часть заказа? Или свяжитесь с консультантом по продажам,  чтобы  продолжить  весь заказ",
    "NinHaiKeYiLianXiPingTai": "Связаться с форумом{0}",
    "ZaiXianKeFu": "Онлайн обслуживание",
    "XinPinDengLuHouKeJian": "Просмотреть регистрации новых товаров",
    "ZhaoBuDaoFuHeTiaoJianDeSh": "Не могу найти подходящих товаров, вернуться обратно",
    "PinPaiQuanBuShangPin": "просмотреть все бредовые товары",
    "WuLiuShiJian": "Время логистики",
    "TuiGuangDeKeHuSuoYouYiWan": "Общая сумма комиссий за все выполненные заказы продвигаемых клиентов",
    "TuiGuangDeKeHuBenZiRanYue": "Процент от продаж после того, как клиент полностью оплатит заказ",
    "ZhiYaoYaoQingZhuCeDeKeHu": "Пригласить зарегистрированных клиентов",
    "XiaShuYongHuYaoQingZhuCeD": "Дистрибьютор приглашает зарегистрированных клиентов",
    "GaiKeHuWanChengDingDanDeH": "Клиент оплативший заказ, выполняется в соответствии с окончательным платежом. Закупочная цена относится к заводской цене и не включает в себя стоимость логистики.",
    "GaiKeHuWanChengDingDanKeY": "Сумма комиссии, которую клиент может получить после выполнения заказа и окончательного платежа",
    "GaiKeHuYiFuDingJinWeiFuWe": "Клиент не оплативший депозит за окончательный заказ, закупочная цена относится к заводской цене и не включает в себя стоимость логистики",
    "GaiKeHuYiFuDingJinWeiFuWe2": "Сумма комиссии, клиента оплатившего депозит за не оплаченный окончательный заказ",
    "GaiKeHuYiJingXiaDanDeDing": "Количество заказов, который совершил клиент",
    "GaiKeHuYiJingXiaDanDeHuoK": "Сумма оплаты заказа, не включает стоимость логистического оформления",
    "DiQuShiChang": "Район",
    "ShiPin": "Видео",
    "QingWuBiTianXieZhenShiDeD": "Пожалуйста введите ваш настоящий номер телефона, позже наш сотрудник свяжится с вами для подтверждения",
    "DDPBuZhiChiYiJia": "Не поддерживает торг",
    "YongHuBianHao": "Код пользователя",
    "ZhuCeShiJian": "Время регистрации",
    "DengLuTianShu": "Дни посещаемости",
    "ZuiHouDengLuShiJian": "Время последней регистрации",
    "XuanPinKuanShu": "Число выбранных моделей",
    "ZuiHouXuanPinShiJian": "Время последних выбранных товаров",
    "YongHuXiaDanXinXi": "Информация об активности клиентов",
    "KeHuXingWeiXinXi": "Информация заказа пользователя",
    "TuiGuangDeKeHuSuoYouYiJin": "Общая сумма комиссии по всем незавершенным заказам клиента, которые внесли депозит, но еще не оплатили окончательный платеж, окончательная комиссия будет зависеть от завершения заказа.",
    "ZhuCeFuWuShang": "Регистрационный сервис-провайдер",
    "TianXieZhangHaoXinXi": "Заполните информацию об учетной записи",
    "TianXieGongSiXinXi": "Заполните информацию о компании",
    "TiJiaoZhuCeRenZheng": "Отправить подтверждение регистрации",
    "ZiShaoNGeZiFuBuNengChunShuZi": "Не меньше 8 символов, пароль не может состоять исключительно из цифр",
    "ShangChuanGongSiMenTou": "Загрузить вывеску компании",
    "ShiLiTuPian": "Пример картинки",
    "ShangChuanGongSiYingYeZhiZhao": "Загрузить Бизнес-лицензию",
    "ZhiChiDeWenJianGeshi": "Формат jpg, png, размер файла ≤ 5м",
    "GongSiJianCheng": "Название компании",
    "GongSiDiZhi": "Адрес компании",
    "XiangXiDiZhiJieDaoMenPaiHao": "Точный адрес улицы и номер дома",
    "SuoZaiSheng": "Область",
    "SuoZaiShi": "Город",
    "SuoZaiQu": "Местожительство",
    "GongSiDianHua": "Номер телефона компании",
    "QuHao": "Код номера",
    "TongYiBingZhunShou": "Согласие о соблюдении правил",
    "ESSAPingTaiFuWuShangTiaoKuan": "Регистрация и обслуживание платформы ESSA",
    "ZhuCeZhangHao": "Регистрация",
    "QingZhuYi": "Внимание",
    "WeiQueBaoXinXiZhenShiXingPingTaiJiangDuiNinXXXX": "Для обеспечения подлинности информации, платформа проверит и аутентифицирует информацию о Вашей компании и завершает ее в течение 1 рабочего дня.",
    "RenZhengShenHeJieGuoHuiYiXXXX": "Результаты проверки подлинности сообщаются в виде SMS-оповещения. Пожалуйста, сохраните смс оповещение.",
    "ZhiYouRenZhengTongGuoXXXX": "Только после проверки подлинности, Ваша учетная запись будет активна. В противном случае    разрешения учетной записи будут ограничены",
    "RuYouYiWenKeYuPingTaiXXXX": "Если возникли вопросы, пожалуйста свяжитесь с отделом  обслуживания клиентов.",
    "ChaKanShangPinBaoJia": "Просмотреть цены на товар",
    "HuoQuGongChangXinXi": "Получить информацию о заводе",
    "XiangYongJiSuZhaoYanng": "Использовать быстрый поиск образцов",
    "DuoYuYanDaoBaoJia": "Многоязычный Прайс-лист",
    "GengDuoTeQuanTiYan": "Больше преимуществ",
    "FuWuShangDengLu": "Логин Сервис-Провайдера",
    "WoShiFuWuShang": "Я Сервис-Провайдер",
    "TuiJianChi": "Корзина образцов",
    "YiXiaShangPinWeiTuiJianChiL": "Ниже перечислены все товары в корзине образцов",
    "WoDeTuiJianChi": "Ваша корзина образцов",
    "JiaRuTuiJianChi": "Войти в корзину образцов",
    "NKuanShangPinYiJiaRuTuiJianChi": "Новые продукты уже добавлены в корзину образцов",
    "ChaKanTuiJianChi": "Просмотреть корзину образцов",
    "TuiJianChiZhongYiYouNKuanFuGai": "В корзине образцов уже имеется(0)продуктов, Вы уверенны что хотите добавить ещё",
    "CiKuanHuoDongShangPinNinYiQueRenGouMaiTuiJianChi": "Вы уже подтвердили этот аукционный товар, пожалуйста перейдите в корзину или отрегулируйте количество ящиков",
    "RenZhengYongHuCaiKe": "Только сертифицированные пользователи могут быть активными, если после сертификации у Вас возникли проблемы, пожалуйста свяжитесь с отделом по обслуживанию клиентов",
    "YuanGongDianHua": "Номер сотрудника",
    "YuanGongDengLuMiMa": "Пароль сотрудника",
    "QingTianXieYuanGongDengLu": "Пожалуйста, введите пароль для входа сотрудника",
    "YuanGongXingMing": "Имя Фамилия сотрудника",
    "QingTianXieYuanGongXingMi": "Пожалуйста, введите Имя и Фамилию сотрудника",
    "WaiYu": "Используемый язык",
    "ShuXiShiChang": "Знакомый рынок",
    "QingXuanZeWaiYu": "Пожалуйста, выберите удобный для Вас язык",
    "QingXuanZeShuXiShiChang": "Пожалуйста, выберите знакомый Вам рынок",
    "GongSiMenTou": "Вывеска компании",
    "QingShangChuanGongSiMenTo": "Пожалуйста, загрузите фото вывески компании",
    "YingYeZhiZhao": "ОГРН",
    "QingShangChuanYingYeZhiZh": "Пожалуйста, загрузите фото Бизнес-лицензии",
    "XiangXiDiZhiJieDaoMenPai": "Точный адрес улицы и дома",
    "QingTianXieGongSiSuoZaiDi": "Пожалуйста, укажите регион, город, район и  адрес компании",
    "QueRenTiJiao": "Подтвердить отправку",
    "DengDaiShenHe": "Ожидание проверки",
    "BianGengZhongYaoXinXiHouX": "Изменение важной информации требует проверки, прежде чем она вступит в силу",
    "YuanGongLieBiao": "Список сотрудников",
    "ChuangJianShiJian": "Время создания",
    "SheZhiBossZhangHao": "Создайте учетную запись для BOSS",
    "QingXuanZeShuXiShiChangZu": "Пожалуйста, выберите знакомый рынок, не более{0}",
    "QingXuanZeWaiYuZuiDuoGe": "Пожалуйста, выберите знакомый Вам язык, не более{0}",
    "BianJiYuanGongZhangHao": "Редактировать учетную запись сотрудника",
    "XinZengYuanGongZhangHao": "Добавление учетной записи сотрудника",
    "TiShengCiZhangHaoWeiZhang": "Если Вы обновите этот счет до учетной записи босса, Вы будете понижены и больше не сможете управлять информацией о компании и сотрудниках",
    "ShanChuZhangHaoJiangWuFaH": "Удаление учетной записи больше не будет восстановлено,  Вы действительно хотите удалить?",
    "FuWuShangGuanLi": "Управление Сервис-Провайдером",
    "QingTianXieYuanGongDianHua": "Пожалуйста, введите номер телефона сотрудника",
    "WeiDengLuHuoWeiRenZhengQingRenZhengHouChaKanJiaGe": "Для пользователей, которые не вошли в систему или не прошли аутентификацию, пожалуйста, войдите в систему или дождитесь аутентификации, чтобы видеть цены на товары",
    "QingXianYueDuBingTongYiXXXX": "Пожалуйста, перед регистрацией, прочтите внимательно и подтвердите соглашение о платформе",
    "TuiJianChiNeiZanShiMeiYouSh": "Корзина образцов пуста, Вы можете добавить продукты в корзину образцов",
    "QueDingCongTuiJianChiZhongS": "Вы уверены, что хотите удалить все выбранные продукты из корзины образцов ?",
    "QueDingCongTuiJianChiZhongQ": "Вы уверены, что хотите очистить корзину от устаревших товаров?",
    "QingTianXieZhengQueDeShouJi": "Пожалуйста заполните точный номер телефона",
    "QingTianXieZhengQueDeQQ": "Пожалуйста заполните точный номер QQ",
    "QingXuanZeMoBanYuYan": "Пожалуйста выберите  язык",
    "MeiZhongTuiJianDanMoBanDo": "Каждый рекомендуемый шаблон поддерживает китайский, английский и русский языки. Вы можете выбрать язык, соответствующий Вашим потребностям",
    "ShangPinChuChangJiaGeSuiShiChaXunXXXX": "Быстрый и удобный поиск заводской цены",
    "ChangJiaLianXiFangShiQuanBuKaiFangXXXX": "Полный доступ к контактам фабрик и заводов",
    "BaiWanShangPinKuZaiXianChaZhaoXXXX": "Онлайн поиск миллионной товарной библиотеки, а так же офлайн обслуживание",
    "ZhiChiDaoQuZhongYingEBaoJiaDanXXXX": "Для Вашего удобства , обслуживание на китайском , английском и русском языке",
    "GengDuoQuanYiLuXuKaiFangXXXX": "Возрастающие возможности и права , приоритеный опыт",
    "RenZhengTongGuoHouNinJiangHuoDe": "После сертификации Вы получаете такие преимущества , как",
    "KanGuoDeRenYeKan": "Все смотрят",
    "YiTuZhaoXiangSiKuan": "Искать продукт по картинке",
    "GaiGongYingShangDeChanPinLeiBie": "Другие товары этого производителя",
    "AnLeiBieChaZhaoChanPin": "Искать продукт по категории",
    "DaJiaDouZaiSou": "Также ищут :",
    "ChangJianZiXun": "Общие консультации",
    "XunJiaJiLu": "Добавления в корзину",
    "ZanWuChangJianZiXun": "Временно недоступны общие консультации",
    "ZanWuXunJiaJiLu": "Пользователи еще не добавляли товар в корзину",
    "YongHu": "Пользователь",
    "XunJiaShiJian": "Время запроса",
    "NGeChanPin": "{0} продуктов",
    "ChaKanDuiBiShangPin": "Просмотр сравнения продуктов",
    "ChaKanDuiBiJieGuo": "Результат сравнения",
    "CanShuChongFu": "Повторите параметры",
    "DuiBiShuJuYiJingDaDaoShangXian": "Сравнительные данные достигли верхнего предела 5 продуктов, пожалуйста, очистите корзину, после очистки Вы можете продолжить",
    "YiJiaRuDuiBi": "Добавлено к сравнению",
    "YuGongChangTanJia": "Обсудить цену с заводом",
    "HeZuoNian": "{0} год/лет сотрудничества",
    "GongChangZiZhi": "Заводская квалификация",
    "XunJiaHuiFuLv": "Ответ на запрос",
    "JiaRuDuiBi": "Добавить к сравнению",
    "ChaKanPinPai": "Смотреть бренд",
    "QiWangJiangJia": "Ожидать низкую цену",
    "JiangJiaHouJiaGe": "Цена после скидки",
    "KuanShiXuanZe": "Стиль",
    "BaoZhuangXinXi": "Информация об упаковке",
    "GaiBanXinXi": "Информация о корректировки продукта",
    "CiKuanZhiChiGaiBan": "Эта модель поддерживает корректировку",
    "ZanWuDuiBiShangPin": "Нет товаров для сравнения",
    "GongChangZaiPingTaiZhanSh": "Фабричная цена на платформе, ниже, чем у других каналов",
    "YiXiangKuaiChuChanPinJiMa": "Отгрузка от 1 коробки, соответствует определенным требованиям \"Мин.заказ=1\" в течении 10 дней",
    "ReXiaoChanPin": "Горящие товары",
    "XunJiaHuiFuShiJian": "Время ответа на запрос",
    "ShangPinChiCun": "Размер самого товара",
    "PingTaiXinPin": "Новинки",
    "WoDeBianHao": "Мой номер",
    "ZanWuGouWuZiXun": "Нет доступа к консультации покупки",
    "GouWuZiXun": "История запросов",
    "ChiCunBaoZhuang": "Упаковка и маркировка",
    "XunJia": "Добавить запрос",
    "QiDingLiang2": "Мин. заказ",
    "EYuZhuanQu": "Русская упаковка",
    "XiangYaoGengDiDeQingDianJ": "Если хотите более мин.заказ, пожалуйста нажмите кнопку ( Связаться с фабрикой )",
    "XiangYaoGengDiDeQingDianJ2": "Мин.заказ{0}",
    "MeiYouZhangHao": "Нет аккаунта",
    "ZhuCeFuWuShangZhangHao": "Cчет регистратора",
    "EWenBaoZhuang": "Русская упаковка",
    "ChaKanGongSiZiZhi": "квалификация",
    "BoFangShiPin": "Воспроизвести видео",
    "YiXiangQiDing": "Мин.заказ от 1-й коробки",
    "NTianFaHuoQi": "Отгрузка товара в течении 10 дней",
    "KuaiSuFaHuo": "Быстрая доставка",
    "MeiYueTuanGou": "Групповые закупки каждый месяц",
    "RenZheng": "Подтвердить",
    "MeiYouZhaoDaoXXPiPeiNinKeYi": "Подходящих товаров не найдено. Вы так же можете выбрать :",
    "JianChaPinXie": "Искать по названию",
    "ShiYongJiaoShaoDeGuanJianZi": "Используйте меньше ключевых слов",
    "ShiYongBuTongDeDeGuanJianZi": "Используйте разные ключевые слова",
    "TianXieCaiGouXuQiu": "Заполните требования к покупке",
    "HuoZheGaoSuWoMenGengDuoXX": "Дайте больше информации о продукте и в течении 24 часов вы получите предложение от поставщика",
    "MeiYouZhaoDaoPiPeiChanPinNinKeYi": "Соответствующих продуктов не найдено. Вы так же можете выбрать :",
    "ShiDangJianShaoShaiXuanTiaoJ": "Выбрать самые оптимальные варианты",
    "GengHuanQiTaGuanJianZi": "Заменить на другие ключевые слова",
    "FanHuiShangYiBu": "Вернуться назад",
    "MeiYouZhaoDaoPiPeiGongYingShangN": "Подходящих поставщиков не найдено. Вы так же можете выбрать :",
    "BangNiZhaoYang": "Поиск по вашему запросу",
    "GongYingShangTuiJianShangPin": "Рекомендуемые товары поставщиками",
    "WoDeZuJi": "Моя история поиска",
    "ChaKanSuoYouZuJi": "Просмотреть всю историю поиска",
    "MeiZhaoDaoXiangYaoDe": "Ничего не найдено по Вашему запросу",
    "HuoQuChanPinGongChangZiXu": "Получить информацию о продукте и фабрике",
    "GuanZhuWoMenSuiShiLeJieZu": "Следите за нашими новостями и будьте в курсе последних новинок и тенденций рынка",
    "JingZhunZhaoYang": "Точный поиск образца",
    "DengLuHouFaBuJingZhunZhao": "После регистрации и публикации желаемого продукта, наш специалист по закупкам ( с 5 летним стажем ) поможет с покупками",
    "FaBuZhaoYangXinXi": "Опубликовать информацию по запросу",
    "AnLeiBieLiuLan": "Обзор по поиску",
    "PaiXu": "Сортировать",
    "ZhaoDaoGeShangPin": "Найдено<b> {0} </b>товара( ов )",
    "GeGongYingShangZhaoDao": "Найдено<b> {0} </b> поставщика( ов )",
    "TuiJianGongYingShang": "Рекомендуемые поставщики",
    "BaoJia": "Метод котировки",
    "GaoJiShaiXuan": "Расширенная фильтрация",
    "GengDuoGuoLv": "Расширенная фильтрация",
    "ShengYuNTian": "Осталось {0} дней",
    "XianHuo": "В наличии",
    "DiQuBuZhiChiZhiJieXiaDanJ": "<b> {0} </b> Регион не поддерживает прямые транзакции заказа. Для доставки в {1} обратитесь в службу поддержки клиентов, чтобы обработать заказ.",
    "XiTongJianCeDaoYouWeiWanC": "Система обнаружила незавершенную сборку, перейти  на: <a>{0}</a> для продолжения.",
    "DangQianKaiTongBaoQingGua": "В настоящее время открыт пакет таможенного оформления логистических прямых стран: {0}.",
    "KaiTongDiQuZhiChiXiaDanBa": "Открытые регионы поддерживают оформление заказа, логистику, доставку товара на склад; так же вы можете самостоятельно забрать товар или оплатить дополнительные местные логистические расходы для доставки в назначенный пункт назначения.",
    "WeiKaiTongDeGuoJiaHeDiQu": "Недоступные страны и регионы",
    "TiJiaoDingDanShiQingLianX": "При отправке заказа, пожалуйста, свяжитесь со службой поддержки клиентов для обработки доставки в Китае или предоставьте относительную логистику.",
    "FaHuoDiQu": "Страна отгрузки",
    "JiaoHuoDiQu": "Страна доставки",
    "请选择城市": "Пожалуйста выберите город",
    "SuoXuanJiaoHuoDiQuBuZhiCh": "Если услуга недоступна в вашем городе, нажмите<a href=\"https://essa.cn\"  rel=\"nofollow\">сюда </a> для просмотра других вариантов",
    "ZhongGuo": "Китай",
    "ShipTo": "Отправить товар в",
    "XuanZeJiaoHuoDiQu": "Пожалуйста выберите страну доставки",
    "BaoQingGuanWuLiuZhiSongXi": "Смотреть ещё",
    "GengGaiJiaoHuoGuoJiaDiQu": "Изменить страну доставки",
    "GengHuanJiaoHuoGuoJiaDiQu": "После изменения страны доставки, цена товара, способ доставки и категория товара также меняется.",
    "JiaGeQueRenZhong": "Подтверждение фабрики",
    "JiaoHuoChengShi": "Страна доставки",
    "FanHuiDingBu": "Вернуться к началу",
    "XianShiTeHui": "Покупка от 1-го короба",
    "XiangShanGou": "Ограниченное предложение",
    "ZuiJinShangXin": "Новое поступление",
    "FaXianHaoHuo": "Топовые продукты",
    "XianDaoXianDe": "Отгрузка товара в течении 7-10 дней !",
    "PaiXingBang": "Топ-рейтинговые продукты",
    "RenQiShangPin": "Популярные продукты",
    "ReXiaoShangPin": "Горячие позиции",
    "DangDiWangDian": "Местные торговые точки",
    "NiShangWeiSheZhiJiaoHuoDi": "Вы не указали страну доставки.  Цены на товары, способы доставки и категории продуктов также различаются в зависимости от страны доставки.",
    "ChangJiaXianHuo": "Сейчас в наличии !",
    "TuanGouYouHui": "Групповые закупки каждый месяц",
    "ZhuanXiangYouHuiHuoYuan": "Эксклюзивные предложения",
    "ZaiShouJiChaKan": "Смотреть на смартфоне",
    "QieHuanGuoJiaDiQu": "Сменить страну",
    "DingGouYuJiaoHuo": "Заказ и доставка",
    "RuHeXiaDan": "Как сделать заказ",
    "FaHuoFangShi": "Способ доставки",
    "GenZongHuoWu": "Отследить груз",
    "GuanYuESSAONE": "Об ESSAONE",
    "FanHuiQuanBuShangPin": "Вернуться ко всем продуктам",
    "PinJuCaoZuoZhiYunXuXiuGai": "Операция \"сборка\" позволяет изменять только города доставки, если необходимо изменить страну доставки, {0} измените регион доставки, а затем выполните операцию \" сборка \"",
    "GuanZhuWoMen": "Подписывайтесь на нас",
    "HuanYingLaiDaoESSAONE": "С возвращением!",
    "DangQianJiaoHuoDiQuBuZhiC": "Текущая область доставки не поддерживает операции LCL или есть незавершенные LCL, пожалуйста, вернитесь в корзину для повторной операции.",
    "QingXuanZeChengShi": "Город",
    "ZhuCeTiaoJian2ONE": "вы подтверждаете своё согласие на обработку пользовательских данных и получение рекламной рассылки.",
    "DengLuXinLaiONE": "New To ESSAONE?",
    "ZhengDanCaiGou": "Контейнерные поставки",
    "NinYeKeYiZhuDongLianXiKeF": "Вы также можете связаться со службой поддержки, чтобы ускорить процесс сертификации",
    "SanDanCaiGou": "Мелкие партии",
    "PinGuiXiuGaiShouHuoGuoJia": "Если Вам нужно изменить страну доставки, пожалуйста вернитесь на страницу корзины покупок и продолжите редактирование",
    "FanHuiXiuGai": "Вернуться к редактированию",
    "ZhuCeESSAONE": "Зарегистрированные пользователи платформы ESSAONE, получают :",
    "ZhongGuoGCZhiCai": "Прямые поставки из Китая",
    "ZuiDiYiXiang": "Отгрузка от 1 коробки",
    "YouLiCaiGouJiaGe": "Цена \" под ключ \" ( с учётом НДС )",
    "QingGuanPeiSong": "Доставка от двери до двери",
    "Essaone_ShouYeGuanJianCi": "ESSAONE.CN, Игрушки и подарки, Детские товары, Горячие распродажи, Новинки, Поставщики игрушек, Китайские фабрики",
    "Essaone_MetaMiaoshu": "ESSAONE это онлайн-платформа по поиску и продаже игрушек с более чем 20 000 фабриками и включающая в себя 1 миллион непересекающихся позиций.",
    "QieHuanBuTongDeGuoJiaDiQu": "Поменять страну и район",
    "Essaone_ShouYeBiaoTi": "Прямые поставки из Китая . ESSAONE.CN - Онлайн закупки . Игрушки и детские товары",
    "SuiShiZhiJieYiJia2": "Прямые покупки с фабрик 24/7",
    "KeJiShiChaKanXinPin2": "Можно просматривать ежедневное обновление и <b>более 2000 новинок</b>",
    "ShouCiDengLuXuYaoXuanZeJiaoHuoDiQu": "При первом входе в систему необходимо выбрать регион доставки. Цены на товары, способы доставки и категории товаров зависят от выбора страны доставки.",
    "NinKeYiZaiShouYeYouShangJiao": "Вы можете изменить регион на главной странице в верхнем правом углу или в личном кабинете",
    "ZyWenXinTiShiONE": "Напоминание: В настоящее время essaone предоставляет услуги точного сопоставления образцов. Клиенты могут получить подробную информацию о продуктах через публикации образцов.",
    "Essaone_WeiZhaoDaoShangPin": "ESSAONE еще не нашла для Вас искомый товар, пожалуйста, подождите",
    "Essaone_YiJingZhaoDaoShangPin": "ESSAONE нашла для Вас искомый товар",
    "Essaone_KuaGuoCaiGouPingTai": "essaone.cn - это международная онлайн-платформа по закупке игрушек",
    "Essaone_DianJiChaKanGengDuoYouZhi": "Нажмите для просмотра всей продукции на essaone.cn - международной платформе по закупке игрушек",
    "Essaone_ChengNuoBuHuiDuiWaiGongKaiXinXi": "Платформа ESSAONE обещает не разглашать информацию и соблюдать соглашение о конфиденциальности",
    "Essaone_ZhuCeTiaoJian2": "Регистрация покупателя на ESSAONE и условия предоставленных услуг",
    "Essaone_PingTaiZhuCeJiFuWuTiaoKuan": "Регистрация покупателя на ESSAONE и условия предоставленных услуг",
    "ShouHuoDiZhi": "Адрес доставки",
    "ZiTiDianXinXi": "Место получения груза ( самовывоз )",
    "DaoHuoGangKouChengShi": "Город порта прибытия",
    "DingDanZongJiXinXi": "Общая информация о заказе",
    "YouYiWenLianXiKeFu": "Если у Вас возникли вопросы, Вы можете обратиться в службу поддержки клиентов",
    "XiaZaiHeTongFanBen": "Скачать образец договора",
    "FaSongFuKuanXinXiDaoShouJi": "Отправить платежную информацию на мобильный телефон",
    "ChaKanDingDanLieBiao": "Просмотр списка заказов",
    "YinHangHuiKuan": "Банковский перевод",
    "QueRenFuKuanXinXi": "Подтвердите информацию об оплате",
    "AnPaiShengChan": "Организация производства",
    "GongNDan": "Всего{0}заказов",
    "RuCaiGouShangPinSheJi": "Если продукты относятся к следующим функциям, вы можете указать стандарты производства. Если же не относятся, то они могут быть проигнорированы.",
    "QingGouXuanYaoXiaDanDeSha": "Пожалуйста, отметьте товары, которые Вы хотите разместить, затем нажмите \" Перейти к заказу \"",
    "YiXiaShangPinGongChangYiQ": "Следующие товары были подтвержены фабрикой",
    "QuXiaDan": "Перейти к заказу",
    "ZhangJiaShangPin": "Повышение цен на продукты",
    "PiLiangQueRen": "Повторный запрос цены",
    "QueRenShengChanYaoQiuZhon": "Завод подтверждает производственные требования",
    "YiQueRenKeXiaDan": "Можно оформить заказ",
    "ChaKanKeXiaDanShangPin": "Просмотреть доступные продукты для заказа",
    "ZiXun": "Задать вопрос",
    "PiLiangZiXun": "Задать вопрос",
    "YiRuShouZang": "Переместить в избранное",
    "DangQianJiaoHuoGuoJiaBuZh": "Текущая страна доставки не поддерживает прямые транзакции, пожалуйста измените страну. Если Вы хотите получить товар в текущей стране, обратитесь в службу поддержки клиентов.",
    "YiXuanKuanShangPinGongXia": "Выбрано <b>{0}</b> продуктов，всего <b>{1}</b> коробок，<b>{2}</b> штук",
    "YiXiaShangPinJiaGeYuNinJi": "Цены на следующие товары могут быть изменены при добавлении в корзину.",
    "YiXiaShangPinJiaGeYiZhang": "Следующие товары повысились в цене",
    "CaiGouShangPinQingDan": "Список купленных товаров",
    "FanHuiGouWuCheXiuGai": "Вернуться к изменению корзины",
    "ZongGongKuanShangPinZongJ": "Всего {0} штук, Общая сумма продуктов: {2}",
    "WenXinTiShiQieHuanBuTongD": "Внимание: Изменение адреса доставки, региона и страны приведет к изменению цены товара.  В городах некоторых стран сервисы прямых заказов не поддерживаются. Если у вас есть какие-либо вопросы, обратитесь в службу поддержки.",
    "GengDuoDiZhi": "Дополнительный адрес",
    "MoRenDiZhi": "Адрес по умолчанию",
    "XinZengShouHuoDiZhi": "Новый адрес доставки",
    "DingDanXinXiTongZhiRen": "Уведомление о заказе",
    "DingDanFaShengBianHuaYouY": "Если у Вас изменился заказ, произошла ошибка, поступила неверная информация и т.д., пожалуйста свяжитесь с",
    "JieSuanYe": "Страница оформления заказа",
    "ShangPinBianHaoHuoMingCheng2": "Артикул продукта, название продукта или заводской номер продукта",
    "XinXiYiGuoQi": "Информация устарела",
    "TianXieHeDuiDingDanXinXi": "Заполните и сверьте информацию о заказе",
    "SheWeiMoRenDiZhi": "Установить в качестве адреса по умолчанию",
    "QueRenZhong": "В процессе подтверждения",
    "ShouKGSi": "Название компании",
    "ShouKZHao": "Счет получателя",
    "ShouKDZi": "Адрес юридического лица",
    "YHanMC": "Обслуживающий банк",
    "YHangHMa": "Номер банка",
    "YHangDZ": "Адрес банка",
    "YHangDM": "№ корреспондентского счета",
    "ShuiWHao": "ИНН",
    "DaiLZHao": "Учётная запись дистрибьютора",
    "ShouHuoRenXinXiChuangJianShangXian": "Информация о грузополучателе, не больше 20 адресов",
    "ShouDanDingJinJinXuN": "Первый депозит составляет {0}",
    "WuKeXiaDanShangPin": "Невозможно заказать продукт",
    "GouWuCheNeiZanShiMeiYouSh2": "Ваша корзина пуста. Вы можете добавить продукты",
    "DangQianJiaoHuoGuoJiaXuYa": "Чтобы продолжить торговую сделку, текущая страна должна заполнить следующую информацию",
    "FuKuanTiXing": "Напоминание об оплате",
    "YouYuHuiLvBianDongPinFan": "Рекомендуем вносить депозит сразу же после оформления заказа! 1.До момента оплаты депозита, общая сумма Вашего заказа может меняться из-за колебания обменного курса ( увеличиться или уменьшиться ) 2.Чтобы избежать изменений общей суммы заказа, пожалуйста оплатите депозит как можно скорее. После оплаты депозита Ваш заказ будет подтвержден и общая стоимость заказа больше не изменится. 3.Если до поступления депозита на счет общая стоимость заказа изменилась из-за колебаний обменного курса, то общая сумма заказа будет изменена ( уменьшена или увеличена) в зависимости от даты поступления предоплаты. 4.Мы начинаем обработку Вашего заказа после получения платежа.",
    "GongChangYuJiXiaoShiNeiQu": "Фабрика подтвердит заявку в течении 24 часов",
    "QueDingShanChuXunJiaShangPinOne": "Подтвердить все выбранные продукты?",
    "XiangQingYeWuQuanXianTiShiOne": "Товар является новым. Для просмотра деталей, требуется аутентификация учетной записи. Сертификация будет завершена в течение 1-3 рабочих дней , пожалуйста будьте на связи, ESSAONE свяжется с Вами, как можно скорее для проверки сертификации.",
    "GuoQiShangPinQingJinKuaiPOne": "Товар с истекшим сроком, пожалуйста подтвердите заново и разместите заказ",
    "QingGouXuanXuYaoXiaDanDeS": "Пожалуйста проверьте продукты, которые необходимо заказать",
    "GuoJiaChengShi": "Страна / Город",
    "QingTianJiaShouHuoDiZhi": "Пожалуйста  добавьте адрес доставки",
    "BuZhou": "Шаг",
    "BuZhou1": "Шаг 1",
    "XunJiaZhuangTaiOne": "Cтатус",
    "NingDePODanOne": "Мой заказ",
    "NinYouZhangDingDanDaiZhiFOne": "У вас есть {0} заказов на оплату депозита. Чтобы отправить продукцию на производство, оплатите депозит как можно скорее. Если у Вас есть какие-либо вопросы, пожалуйста свяжитесь со службой поддержки.",
    "HuiLvTiXing1": "1. До момента оплаты депозита, общая сумма Вашего заказа может меняться из-за колебания обменного курса ( увеличиться или уменьшиться );",
    "HuiLvTiXing2": "2. Чтобы избежать изменений общей суммы заказа, пожалуйста оплатите депозит как можно скорее. После оплаты депозита Ваш заказ будет подтвержден и общая стоимость заказа больше не изменится；",
    "HuiLvTiXing3": "3. Если до поступления депозита на счет общая стоимость заказа изменилась из-за колебаний обменного курса, то общая сумма заказа будет изменена ( уменьшена или увеличена) в зависимости от даты поступления предоплаты;",
    "HuiLvTiXing4": "4. Мы начинаем обработку Вашего заказа после получения платежа.",
    "ZanWuQuanXian": "Временно нет полномочий",
    "NinDeZhangHaoZanShiMeiYou": "Ваш аккаунт временно не имеет доступа к товарам данного производителя. Пожалуйста, свяжитесь с производителем для получения доступа.",
    "YiGuoQi": "Время истекло",
    "SouSuoGuanJianZi": "Поиск по ключевым словам",
    "KaiShiRiQi": "Дата начала",
    "JieShuRiQi": "Дата окончания",
    "FaBuXinDeZhaoYang": "Разместить новый образец",
    "ZhaoYangXiangQing": "Искать более подробную информацию",
    "QuXiaoZhaoYang": "Конец образца",
    "ShengYuShiJian": "Оставшееся время",
    "BuJieShouXiangSiKuanYangP": "Мы не принимаем отзывы от подобных образцов. Если у вас плохое качество обратной связи, вы можете оставить отрицательный отзыв на образцы.",
    "QueRenYaoQuXiaoZhaoYangQu": "Вы уверены, что хотите отменить образец?  После отмены этот образец больше не будет получать обратную связь с завода.",
    "ZhaoYangZhuTi": "Поиск названия образца",
    "QingShuRuZhaoYangZhuTi": "Пожалуйста введите название образца",
    "QingShuRuZhaoYangZhuTiFan": "Пожалуйста введите название продукта",
    "TiGongGongChangHuoHaoKeJi": "Укажите заводской номер, чтобы найти точный образец",
    "ZuiDiJia": "Самая низкая цена",
    "ZuiGaoJia": "Самая высокая цена",
    "ZhaoYangShuoMing": "Поиск инструкций",
    "MiaoShuXuYaoZhaoDeShangPi": "Опишите товар, который нужно найти, например: внешний вид, функциональность,область продаж и т. д.",
    "ZhiJieShouGengJingZhunPiP": "Надеюсь продукт по запросу будет соответствовать с моей фотографией/заводским номером",
    "XuTiGongTuPianHuoGongChan": "Для точного соответствия, предоставьте фотографию или заводской номер",
    "GaoSuGongChangNiXuYaoShen": "Скажите фабрике, что вы ищете",
    "ZhaoYangYouXiaoQiFaBuHouX": "Срок действия образца: 48 часов после публикации.",
    "XinXiYueJuTiNiDeDaoDeJieG": "Чем конкретнее Вы заполните информацию, тем точнее вы получите результат",
    "XuRenZhengCaiNengFaBuZhaoYang": "Требуется сертификация для размещения образцов",
    "XuDengLuCaiNengFaBuZhaoYang": "Для размещения образцов необходимо войти в систему",
    "GongChangTuiJian": "Рекомендуемые фабриками",
    "PingTaiYiYouYangPin": "На платформе уже имеется образец",
    "GongChangXinZengYangPin": "Новые образцы с завода",
    "JiangGenJuSuoTiJiaoDeZhao": "essa.cn автоматически подбирает оптимальную фабрику в соответствии с представленными требованиями к поиску.  Как правило, результаты будут получены в течение 1-2 рабочих дней. Пожалуйста обратите внимание на соответствующую информацию обратной связи.",
    "ChaKanWoDeZhaoYang": "Результаты запроса",
    "JiXuFaBuZhaoYang": "Продолжить размещать образцы",
    "FanHuiHuiYuanZhongXinShou": "Вернуться на главную страницу Центра по обслуживанию клиентов",
    "WeiXinGuanZhuGongZhongHao": "微信关注公众号:【宜采有货】",
    "ShiShiHuoQuFanKuiTongZhi": "Получать уведомления в режиме реального времени",
    "ShangPinSuoShuLeiMu": "Категории продуктов",
    "QingXuanZeShangPinSuoShuL": "Пожалуйста, выберите категорию продукта",
    "YiBan": "Обычный",
    "Hao": "Хороший",
    "FeiChangHao": "Отличный",
    "ZhaoYangXuQiuPingFen": "Оценка спроса на выборку",
    "FenShuYueGaoNiDeDaoDeFanK": "Чем выше оценка, тем точнее вы получите обратную связь, оценка с низким баллом может привести к тому, что образец обратной связи будет слишком общим.",
    "KeDuoXuan": "Можно выбрать несколько вариантов",
    "TianXieGengDuoXinXi": "Заполните больше информации",
    "MoHuZhaoYang": "Нечеткий образец",
    "ShiYongFanYi": "Использовать Google переводчик",
    "ZheiGeZhaoYangMeiYouZhaoY": "Нет описания для этого образца",
    "ZhuCeTianXieXinXiWeiWanZheng": "Пожалуйста, заполните регистрационную информацию, а затем отправьте",
    "LiuXiaFanKui": "Оставить отзыв",
    "RuGuoNinZaiShiYongPingTai": "Если у вас есть положительные или отрицательные отзывы при использовании платформы essaone, пожалуйста сообщите нам об этом!  Мы будем постоянно оптимизировать продукт и предоставлять вам лучший сервис!",
    "HenManYi": "Хорошо",
    "FeiChangBuMan": "Очень плохо",
    "NinDuiPingTaiShouYeDeZhen": "Вы довольны нашей платформой?",
    "DuiNinDePeiHeHeZhiChiBiao": "Спасибо за сотрудничество и поддержку!",
    "WeiLeJiNinTiGongGengHaoDe": "Чтобы предоставить Вам лучший сервис, мы будем рады получить Ваши отзывы и предложения по использованию платформы essaone.",
    "YongHuTiYanFanKuiDiaoCha": "Обзор отзывов пользователей",
    "DengLuHouCaiNengTiJiaoFan": "Вы можете оставить отзыв только после входа в систему. Хотите войти сейчас?",
    "RuGuoNinYouTeDingYiWenQin": "Если у вас есть конкретные вопросы, пожалуйста, свяжитесь с {0} или посетите наш {1}",
    "KeHuFuWuTuanDui": "Команда обслуживания клиентов ESSAONE",
    "KaiShiLiaoTian": "Начать чат",
    "XuanGou": "В корзину",
    "XuanGouLe": "Куплено",
    "OneCartonFromChina": "Опт от 1-ого короба от китайских фабрик «под ключ»！Депозит первого заказа 10%!",
    "FanHShouY": "Вернуться на главную страницу ESSAONE",
    "GanXieFanK": "Спасибо за Ваше время.  Мы ценим каждый отзыв.",
    "YiGuanZhu": "Подписан(а)",
    "GuanZhu": "подписки",
    "GongChangShouYe": "Главная страница фабрик",
    "XinYong": "Рейтинг фабрики",
    "GongChangShangPinFenLei": "Категория продукции фабрики",
    "ShangPinGuiGeCanShu": "Параметры спецификации продукта",
    "ShouJiShangChaKanFenXiang": "Смотреть на телефоне",
    "GongChangHuoYuan": "100 % Проверенные фабрики",
    "ZhenShiKeKao": "Сертификация каждого производителя",
    "DingJinKeTuiChengNuo": "Гарантия депозита",
    "HeLiTuiDan": "Возврат в случае отмены заказа",
    "JiaoHuoShiXiaoBaoZhang": "Гарантия своевременной доставки",
    "DingDanQuanChengGenZong": "Компенсация за кадждый день задержки",
    "ZhiBaoTuiHuan": "15 дней гарантии на товар",
    "TiGongWanShanDe": "Возможность возврата или замены",
    "CongZhongGuoFaHuoJiaGeHan": "Доставка из Китая: таможенное оформление, логистические расходы и сертификаты соответствия ТР ТС включены в цену",
    "ZhongGuoFaHuo": "Отгрузка из Китая",
    "TongGuoHangYunDaoNiDeChen": "Доставка в",
    "TiGongSongHuoShangMenFuWu": "Логистическое время (время производства: {0} дней, время транспортировки: {1} дней), исключая ожидание на границе",
    "WuLiu": "Логистическая информация",
    "CanJiaJiaGe": "Цена \"под ключ\"",
    "JinGeYueYouRenXiHuan": "За последние {0} месяцев, оценили {1} человек",
    "ChuangJianZhangHao": "Создание учетной записи",
    "QingShuRuNiDeDian": "Пожалуйста, введите свой адрес электронной почты в качестве учетной записи",
    "GongSiSuoZaiChengShi": "Город компании",
    "GongSiXiangXiDiZhi": "Точный адрес компании",
    "XiaoShouQuDaoone": "Каналы продаж",
    "Essaone_ZhuCeTiaoKuanPrefix": "Нажимая кнопку “Регистрация”,",
    "Essaone_ZhuCeTiaoKuan": "Условия регистрации и обслуживания пользователей платформы ESSAONE",
    "GongXiNiYiChengGongZhuCe": "Поздравляем, Вы успешно зарегистрировались на площадке ESSAONE.COM！<br/>Наши менеджеры по работе с клиентами свяжутся с Вами в течение 48 часов в рабочие дни, чтобы помочь Вам найти нужные товары и лучшие предложения.",
    "NiDeZhangHao": "Ваш логин",
    "XianZaiQuGouWu": "Начать покупку",
    "DiYiCiDingDanKeXiangShou": "1-ый заказ доступен",
    "HuoQuESSAONEGengDuoXinXi": "Чтобы получить дополнительную информацию об ESSAONE, пожалуйста перейдите",
    "QingNinDengLuYouXiangJinXinYanZheng": "Пожалуйста, подтвердите свой почтовый адрес для завершения регистрации",
    "YanZhengYouJianYiFaSongDaoYouXiang": "Код подтверждения отправлен на почту",
    "QingDengLuYouXiangWanChengYanZheng": "В течение 24 часов вам необходимо подтвердить свой почтовый адрес.",
    "MeiShouDaoYouJian": "Не получили письмо?",
    "QingXianJianChaShiFouZaiLaJiXiangZhong": "Пожалуйста, проверьте папку \"Спам\".",
    "RuGuoHaiWeiShouDao": "Если письмо не приходит, пожалуйста попробуйте",
    "ChongXinFaSongYouJian": "Повторно отправить на почту",
    "YiZhiShouBuDao": "Постоянно не получает",
    "QingGengHuanQiTaYouXiang": "Зарегистрировать другой почтовый адрес",
    "XinYongHuZhuanShuLiPin": "Эксклюзивные подарки для новых пользователей",
    "XinYongHuDeReMenXuanZe": "Горячие выборки для нового пользователя",
    "GangGangJIaGou": "Недавно добавленные товары",
    "GangGangShouCang": "Недавно добавленные избраные продукты",
    "GangGangGuanZhu": "Недавно подписанные бренды",
    "GongChangWeiWanShan": "Не добавлено поставщиком",
    "GongXiNiYiChengGongZhuCe2": "Поздравляем! Вы успешно зарегистрировались.",
    "DiYiCiDingDanKeXiangShouD": "Депозит первого заказа <b>-10%</b>",
    "ZhongGuoZhiCai": "Прямые закупки из Китая",
    "QuanBaoJia": "Цена \"под ключ\"",
    "MenDaoMen": "От двери до двери",
    "JiaoYiBaoZhang": "Гарантии взаимодействия",
    "BaoHu": "100% Гарантии",
    "NinDeZhangHaoZanShiMeiYou2": "На данный момент у вас нет разрешения для просмотра этого товара, при наличии вопросов обратитесь в службу поддержки.",
    "QingXuanZeXiaoShouQuDao": "Тип продаж",
    "QingShuRuYingYeZhiZhaoHao": "Введите свидетельства о регистрации",
    "GaiLianXiDianHuaYiCunZai": "Этот номер уже зарегистрирован",
    "GeiNinZuiJingZhunDeTuiJian": "Интересующий тип товаров, для лучших рекомендаций",
    "QingShuRuChengSh": "Ваш город",
    "LingQuChengGong": "Успешно!",
    "XinShouLuoDiYe": "Специальная зона для новичков",
    "JingZhunZhaoYangXuYaoTian": "Чтобы найти более точный продукт, необходимо добавить фотографию или заводской номер",
    "QingShuRuDianZiYouXiangZu": "Пожалуйста, введите адрес электронной почты в качестве учетной записи",
    "QingShuRuShouJiHaoMaZuoWe": "Пожалуйста введите номер телефона",
    "LiuDaoErShiGeZiFu": "От 6 до 20 символов",
    "ZhiNengBaoHanZiMuShuZi": "Пароль может содержать только буквы, знаки и цифры",
    "ZiMuShuZiHeBiaoDianFuHaoZhiShao": "Пароль должен содержать комбинацию букв и цифр (или символов)",
    "EssaOneZhiShao6GeZiFu": "Пароль не соответствует требованиям",
    "RuGuoNinSouBuDao": "Не нашли нужный товар? Возможно он еще не размещен на нашей площадке. Предлагаем вам отправить прямой онлайн-запрос на фабрики.",
    "ZhiDaYuanChang": "Прямая связь с фабриками",
    "AnTiaoJianGuoLv": "Результат в течении 30 мин",
    "ShuBaiJiaZhiMingMaoYi": "Поиск согласно требованиям",
    "FaBuZhaoYangXuQiu": "Описать требования к товару",
    "XiTongZiDongPiPei": "Система автоматически сопоставляет заводы по соответствующим категориям и оповещает заводы через СМС и ВЧат.",
    "HeBeiCha": "Подтвердить запрос и ожидать ответа",
    "GongChangZaiShouDaoXinXiHou": "После получения информации заводы отвечают в течение 30 минут в лучшем случае.",
    "ChaKanFanKui": "Выбрать пододящий товар из списка",
    "TiaoXuanHeShiDeShangPin": "Выберите подходяющие товары, отобрать и напрямую связаться с заводом.",
    "NinTianDeXuanXiangYueDuo": "Чем больше требований к товару, тем точнее результат",
    "ZhaoYang": "Запрос",
    "RuGuoNinSouBuDaoShangPin": "Не получилось найти нужный товар? Отправьте запрос прямо на фабрики!",
    "YiCaiYouHuoJiangGenJuNinSuoTiJiaoDe": "Запрос будет отправлен на наиболее подходящие фабрики согласно указанным требованиям",
    "YiBan30FenZhongZuoYou": "Результат будет готов в течении 30 минут",
    "RangGongChangGeiNinHuiFu": "Результат будет готов в течении 30 минут",
    "TuiJianRenShouJi": "推荐人手机号",
    "ShouJiHaoMaGeShiBuZhengQu": "Формат мобильного номера неверный, пожалуйста, введите его еще раз.",
    "RuHeRangShiTu": "Как сделать поиск более точным?",
    "ShangChuanBeiJing": "Подберите изображение с простым, желательно однотонным фоном",
    "XuanZeQingXiDuJiaoGao": "Выберите чёткое изображение в высоком разрешении",
    "ChangShiCaiJianTuPian": "Попробуйте обрезать изображение так, чтобы на нем был только сам товар",
    "RuGuoFenBieYouDaiBaoZhuang": "Если поиск выдает картинки и с упаковкой и без упаковки, рекомендуем просмотреть оба варианта",
    "JiaRuGouWuChe2": "В корзину",
    "HuoDongGuiZe1": "1. Во время проведения акции, нужно сгенерировать пригласительную ссылку + индивидуальный пригласительный код и отправить тому, кого вы хотите пригласить. Пользователь должен перейти по отправленной вами ссылке или ввести пригласительный код при регистрации аккаунта. Участие будет считаться действительным после того, как новый пользователь оформит первый заказ.",
    "HuoDongGuiZe2": "2. Требования к приглашенным пользователям：",
    "HuoDongGuiZe201": "（1）Пользователи которые ранее не были зарегистрированы на площадке и никогда не оформляли заказ",
    "HuoDongGuiZe202": "（2）Приглашенный пользователь должен зарегистрироваться перейдя по отправленной вами ссылке или введя ваш индивидуальный пригласительный код",
    "HuoDongGuiZe3": "3. Во время проведения акции, за каждого приглашенного пользователя вы получаете 5000р, количество приглашаемых пользователей неограничено.",
    "HuoDongGuiZe4": "4. Вознаграждение будет получено в течении 3-х дней с момента внесения новым пользователем депозита первого заказа",
    "HuoDongGuiZe5": "5. Вы можете посмотреть статус приглашенных пользователей в своем личном кабинете перйдя во вкладку “Пригласить друзей”",
    "HuoDongGuiZe6": "6. Данная акция проводится согласно правил, установленных платформой essaone",
    "YaoQingDeJiangLi": "Вознаграждения при приглашении",
    "YaoQingFanLi": "Пригласить друзей",
    "YaoQingMingXi": "Детали приглашения",
    "FuZhiChengGong": "Скопировано",
    "WoDeYaoQing": "Мои приглашения",
    "ChaKanMingXi": "Детали",
    "JiangLiZongJinE": "Сумма вознаграждения",
    "YaoQingZongRenShu": "Количество приглашенных пользователей",
    "XiaDanRenShu": "Количество пользователей оформивших заказ",
    "ShengChengZhuanShuTuiJianMa": "Сгенерировать пригласительный код",
    "FenXiangTuiJianMaG": "Отправить ссылку",
    "HaoYouZhuCeBingXD": "Пользователь зарегистрировался и оформил заказ",
    "HuoDeJiangJin": "Получить вознаграждение",
    "WoDeYaoQingLianJie": "Пригласительная ссылка",
    "DianJiFuZhi": "Копировать",
    "WoKeHuoDe": "Вознаграждение для вас",
    "ShouDanChengJiaoKeDe": "После оформления первого заказа",
    "HaoYouKeHuoDe": "Вознаграждение для нового пользователя",
    "ShouDanDingJinYouHuiQ": "Депозит первого заказа",
    "WoDeXianJinJiangLi": "Мое вознаграждение",
    "ZhangHuBianHao": "Номер учетной записи",
    "HaoYouYouXiang": "Эл. почта пользователя",
    "HaoYouDianHua": "Номер телефона пользователя",
    "DiYiCiXiaDanSJ": "Время оформления первого заказа",
    "JiaGeBaoHuQiShengYuNTian1": "Цена подтверждена фабрикой, но может измениться из-за колебания курса валют.",
    "GaiShangPinYiGuoJiaGeBaoH1": "Срок действия цены истек, требуется повторное подтверждение",
    "GaiShangPinYiGuoJiaGeBaoHuNC1": "Срок действия цены истек, требуется повторное подтверждение",
    "QingXuanShuRuFOBFeiYong": "Пожалуйста, введите стоимость FOB",
    "QingXuanZeBiZhong": "请选择币种",
    "QingShuRuHuiLv": "请输入汇率",
    "QingXuanZeHuoGuiLeiXing": "请选择货柜类型",
    "QingXuanShuRuTiJi": "请选输入体积",
    "ShangChuanLogo": "报价单LOGO",
    "GongSiLogoJianYi": "公司logo建议尺寸80x80",
    "FOBFeiYong": "FOB费用",
    "JiaJiaLv": "加价率",
    "FanYi": "Перевести",
    "YiWen": "Перевод",
    "MeiYuanDuiHuanRenMinBi": "美元兑换人民币汇率",
    "HuoQiESSAONE": "Срок поставки",
    "FanYiXiaoGongJuJiangGongC": "Инструмент перевода для перевода контента Factory Circle",
    "XuanZeYuYan": "Выбрать язык",
    "ZuiJinShiYong": "Последние обновления",
    "ZhiYunXuPingLunYiCi": "Оставлять комментарий можно только один раз",
    "QingShuRuPingLunNeiRong": "Введите ваш комментарий",
    "ShanChuPingLun": "Удалить комментарий",
    "YiPingLun": "Комментарий отправлен",
    "PingLun": "Комментарий",
    "YiZan": "Понравилось",
    "Zan": "Лайк",
    "KuanChanPin": "{0}  товаров",
    "ChaKanShangPinXiangQing": "Подробнее о товаре",
    "GuanZhuChengGong": "Вы подписаны",
    "YiQuXiaoGuanZhu": "Подписка отменена",
    "NinHaiMeiYouGuanZhuGongChang": "Вы еще не подписаны ни на одну фабрику",
    "YouZhiGongChangTuiJian": "Лучшие производители",
    "GuanZhuChaKan": "Подписаться на обновления",
    "GuanZhuQuanBuTuiJian": "Подписаться на все рекомендации",
    "GuanZhuGongChangZuiXinDongTai": "Последняя активность",
    "NinGuanZhuDePinPaiZanWuDongTai": "На данный момент нет активности с фабрик, рекомендуем подписаться на других производителей",
    "GuanZhuGengDuoGongChangPinPai": "Другие бренды",
    "GongChangShangXinKuan": "Опубликовано{0}товаров",
    "GongChangJiangJiaKuan": "Фабрика снизила цену{0}товаров",
    "GongChangXinZengShiPinKuan": "Фабрика добавила{0}видео",
    "ChaKanShangXin": "Последние обновления",
    "ChaKanJiangJia": "Понижение цены",
    "ChaKanShiPin": "Смотреть видео",
    "QuXiaoGuanZhu": "Отменить подписку",
    "BenCiShangXinKuan": "Добавлено{0}товара(-ов)",
    "BenCiJiangJiaKuan": "Цена{0}товаров была снижена",
    "BenCiGengXinShiPinKuan": "Обновлено{0}товара(-ов)",
    "TuiJianGongChang": "Рекомендованные фабрики",
    "ZuiJinShangXinKuan": "За последнее время добавлено{0}товаров",
    "LiuLanGengDuoGongChang": "Другие фабрики",
    "XuanZeBaoJiaFangShi": "Выберете тип цены",
    "XuanZeBaoJiaMoBan": "Сначала выберите шаблон",
    "ZuiJinGengXin": "Последние обновления",
    "ShiPinQuan": "Видео с фабрик",
    "GongChangQuan": "Новости фабрик",
    "JuLiKaiBoHaiYou": "Эфир начнется через",
    "Fen": "минут",
    "Miao": "сек",
    "ZhiBoShangPin": "Товары в эфире",
    "HuiFang": "Повторить",
    "ZhiBo": "Прямая трансляция",
    "ZhaoBuDaoGaiShiPin": "Видео не найдено",
    "ZhiBoHuiFang": "Повторное воспроизведение",
    "ZhiBoZhong": "В прямом эфире",
    "KanHuiFang": "Повторное воспроизведение",
    "JiJiangKaiShi": "Скоро начнется",
    "Shi2": "часов",
    "LiJiLingQu": "Получить сейчас",
    "ShouDan3ZheKou": "Получите подарок на ₽35000！",
    "ZhiXianYuXinKeHu": "Только для новых клиентов!",
    "DeDaoYouHuiQuan": "Об ESSAONE",
    "LaXinGuiZe1": "<p>1. Только те пользователи, которые зарегистрировались в ESSAONE, но не сделали свой первый заказ, могут воспользоваться данной скидкой;</p> <p>Каждый новый пользователь может получить только один пакет купонов;</p>",
    "LaXinGuiZe2": "<p>Пакет купонов для новичков содержит 4 купона и получается 2 раза: 2 купона по после регистрации и еще 2 купона после оплаты депозита по первому заказу;</p> <p>4. Купоны нельзя совмещать и использовать вместе. На каждый заказ можно использовать только 1 купон. При оформлении заказа система по умолчанию предоставляет наибольшую скидку на основе доступных купонов. Вы также имеете право выбрать другой купон для использования;</p>",
    "LaXinGuiZe3": "<p>5. Если Ваш заказ был полностью отменен, то купон будет возвращен. Если заказ был отменен частично и скидка будет частично использована, купон не будет возвращен;</p> <p>6. Новые клиенты могут воспользоваться правом внести депозит 10%, но только на первый заказ.</p>",
    "XinYongHuTeBieCuXiao": "Cпециальное предложение для новых пользователей",
    "ZhiDiYiGeDingDan": "Только для первого заказа!",
    "EssaBanQuan": "Все права принадлежат ESSAONE",
    "YXV0b19tYXJrZXRpbmdfZW1haWw=": "Рекомендации и специальные предложения по товарам на площадке",
    "YXV0b19tYXJrZXRpbmdfZW1haWw=_remark": "Оставайтесь в курсе всех трендов: регулярные рекомендации новинок, популярные товаров, а также товары по специальным предложениям.",
    "cmVndWxhcl9tYXJrZXRpbmdfZW1haWw=": "Оповещения по заказам",
    "cmVndWxhcl9tYXJrZXRpbmdfZW1haWw=_remark": "Будем оповещать только о самом важном: последние обновления, новые функции, а также о промоакциях.",
    "Y29uX2NvbnRhaW5lcl9sb2FkX2RvbmVfZW1haWw=": "О загрузке контейнера",
    "Y29uX2NvbnRhaW5lcl9sb2FkX2RvbmVfZW1haWw=_remark": "Уведомление о том, что все товары загружены и готовы к отправке",
    "Y29uX2NvbnRhaW5lcl9iYWxhbmNlX2VtYWls": "О внесении полной оплаты",
    "Y29uX2NvbnRhaW5lcl9iYWxhbmNlX2VtYWls_remark": "Уведомление о прибытии товара в Россию и необходимости внесения полной оплаты.",
    "b2xkX2J1eWVyX3JlY29tbWVuZF9lbWFpbA==": "О завершении заказа",
    "b2xkX2J1eWVyX3JlY29tbWVuZF9lbWFpbA==_remark": "Уведомлениe о приеме груза и завершении заказа",
    "c3BsaXR0aW5nX25vdGljZV9lbWFpbA==": "Изменение сроков поставки",
    "c3BsaXR0aW5nX25vdGljZV9lbWFpbA==_remark": "Ваш заказ был разделён в связи с изменением сроков производства",
    "GengDuoLianXiXinXi": "更多联系信息",
    "GongSiGuHua": "Стационарный телефон компании",
    "TianJiaShangPinZhiXuanYan": "Добавить товары в корзину образцов, проверить контактную информацию",
    "YiJianJiaRuXuanYangChiCha": "Добавьте [Выбор продукта] одним щелчком мыши, сгенерируйте предложения для клиентов для более точного продвижения товара",
    "HuoQuBuDaoZhangHaoZiJinDeSuo": "Система занята в данный момент, пожалуйста, попробуйте позже",
    "WeiSheZhiZhiFuMiMa": "Для использования средств на счету необходимо установить платежный пароль",
    "ZhiFuMiMaBuZhengQue": "Неправильный пароль",
    "ChaXunBuDaoZhangHaoZiJinXinxi": "Не удалось найти информацию о балансе",
    "ZhangHaoZiJinBuZu": "Недостаточно средста на счету",
    "JiuZhiFuMiMaBuZhengQue": "Неправильный платежный пароль",
    "PoDanYiZhiFuQinWuChongFuZhiFu": "Заказ уже оплачен, пожалуйста не повторяйте платеж",
    "WoDeZiJin": "Мой баланс",
    "MingXi": "Подробности",
    "QuHuiKuan": "Перевод средств",
    "DaiFuKuan": "Ожидается оплата",
    "ShenMeShiESSAONE": "О депозите на платформе ESSAONE",
    "AnDingDanJinE": "Сумма депозита вычисляется в процентном соотношении с общей суммой заказа",
    "NianChuHuoJinE": "Сумма заказов за {0} год",
    "XinYongHuShouCiXiaDan": "Депозит первого заказа составляет всего 10% от общей суммы!",
    "DingDanEDuBuChaoGuo": "без ограничения суммы заказа.",
    "TiJiaoDingDanHouQingJiShi": "Пожалуйста, вовремя внесите депозит после оформления заказа. После подтверждения депозита, заказ будет обработан и передан в производство.",
    "XuYaoSheZhiZhiFu": "Для оплаты необходимо создать платежный пароль",
    "SheZhiZhiFuMiMa": "Создать платежный пароль",
    "XiuGaiZhiFuMiMa": "Изменить платежный пароль",
    "ZhaoHuiZhiFuMiMa": "Восстановить пароль",
    "ShiYongGuiZe": "Правила использования",
    "ZiJinMingXi": "Подробности счета",
    "GuanYuZhiFuZhangHu": "Информация об учетной записи",
    "RuHeHuiKuanChongZhi": "Как пополнить баланс?",
    "RuHeZhiFuDingJin": "Как внести депозит?",
    "RuHeZhiFuWeiKuan": "Как оплатить остаток？",
    "ShenMeShiZhiFu": "Что такое платежный аккаунт?",
    "ZheShiYongHuZaiESSAONE": "C помощью этого аккаунта вы сможете вносить депозит, оплачивать остаток стоимости заказа, запрашивать возврат средств, проверять информацию об оплате и все это - онлайн. Платежный аккаунт доступен для всех зарегистрированных пользователей платформы.",
    "ZhangHuDeGongNeng": "Функции учетной записи",
    "MuQianZhangHuZhiChi": "В настоящее время поддерживается пополнение счета ,оплата заказов, возврат средств при отмене заказа. Все денежные переводы и возврат средств, зачисляются на баланс вашего аккаунта.",
    "HuiKuanChongZhi": "Пополнение счета: переведите средства с банковской карты на счёт, указанный на платформе ESSAONE. Баланс будет пополнен в течении 2-х рабочих дней.",
    "DingDanZhiFu": "Оплата заказа: вы можете использовать средства на своем счету для оплаты депозита и полной стоимости заказа.",
    "QuXiaoTuiKuan": "Возврат средств при отмене заказа: в случае отмены заказа, средства будут возвращены непосредственно на счет вашего аккаунта.",
    "ZhiFuLiuCheng": "Процесс оплаты",
    "ZhangHuZhiFuShiYongHu": "Пополнение счета - это банковский перевод средств на баланс вашего аккаунта. После пополнения, эти средства могут быть использованы для оплаты заказов.",
    "ZhangHuDeShiYongGuiZe": "Правила пользования учетной записью",
    "WeiLeQueBaoYongHuZiJin": "Чтобы обеспечить безопасность использования средств, перед активацией личного счета нужно создать платежный пароль, в противном случае использование счета будет невозможным. Также, пароль нужно будет вводить при каждой оплате.",
    "DangNinShiYongZhangHu": "При оплате депозита/закрывающего платежа, пожалуйста внимательно проверяйте всю информацию. После завершения платежа средства не подлежат возврату.",
    "YongHuZhiFuZhangHuBuShe": "Баланс платежного счета не имеет ограничений. Пользователи могут просматривать текущее состояние счета, историю пополнения счета, историю переводов, информацию об использовании средств через раздел “Мой баланс\"",
    "RuoDuiZiJinShiYong": "Если у вас возникнут вопросы по использованию аккаунта, пожалуйста, обратитесь в онлайн службу поддержки",
    "DangNinDeZhangHuMeiYou": "Если на вашем счету недостаточно средств, вы можете пополнить баланс с помощью банковского перевода. Снизу можно посмотреть более подробную информацию о пополнении",
    "QingAnZhaoYiXia": "Пожалуйста, при переводе укажите Ваш клиентский номер и номер заказа, ставку НДС и сумму НДС, как указано в счете на оплату. Переводимая сумма должна быть строго идентична указанной в счете.",
    "HuiKuanHou": "Средства поступают в течение 1 рабочего дня. Зачисления производятся по будням, с 10-12 часов по МСК. В случае, если перевод совершен после 18:00, платеж может поступить в течение 2 рабочих дней.",
    "XianShiDaoZhangJinE": "【Мой баланс】Общая сумма на счету",
    "QueRenDaoKuanHou": "После совершения платежа, состояние баланса можно проверить во вкладке \"Мой баланс\"",
    "NinXuYaoXianJianCha": "Сначала нужно проверить, достаточно ли средств на вашем балансе.",
    "ZhiYouDangNinDeZhiFu": "Вы можете оплачивать депозита заказа только в том случае, если на вашем балансе достаточно средств. Далее перечислены 3 способа оплаты депозита",
    "DangNiChengGongTiJiao": "После размещения заказа, пожалуйста нажмите на кнопку {0}",
    "QuZhiFuDingJin": "Внести депозит",
    "XuanZeYaoZhiFu": "Перейдите в {0} чтобы выбрать заказ на который вы хотите внести депозит, затем нажмите кнопку {1}",
    "QuZhiFu": "Ожидание оплаты",
    "DaiZhiFuMingXi": "Детали оплаты",
    "DangNinDeDingDanYiDao": "Когда заказ уже доставлен, нужно сначала внести остаток стоимости и после этого принять груз",
    "TongYangZhiYouDang": "Также, если на вашем балансе достаточно средств, вы можете использовать их для оплаты полной стоимости заказа. Ниже приведены два способа оплаты:",
    "ZhiFuWeiKuanDe": "Перейдите в {0}, чтобы выбрать на какой заказ вы хотите внести депозит, затем нажмите кнопку  {1}.",
    "ZhiFuZhangHuDeShiYong": "Инструкции по использованию аккаунта",
    "DanJuHao": "Номер документа",
    "ShouRu": "Получено",
    "JinNTian": "За последние {0} дней",
    "QuanBuJiaoYiLeiXing": "Все транзакции",
    "DaiZhiFuJinE": "Ожидание оплаты",
    "ZuiChiFuKuanShiJian": "Крайний срок оплаты",
    "FanShiZaiESSAONEPingTai": "Каждый успешно зарегистрированный пользователь платформы имеет свой личный счет для оплаты. На данный момент поддерживается пополнение счета, оплата заказа и возврат средств на счет.",
    "HuiKuanChongZhi2": "Пополнение счета: переведите средства с банковской карты на счёт, указанный на платформе ESSAONE. Баланс будет пополнен в течении 2-х рабочих дней.",
    "DingDanZhiFu2": "Оплата заказа: вы можете использовать средства на счету для оплаты депозита и полной стоимости заказа.",
    "QuXiaoTuiKuan2": "Возврат средств при отмене заказа:  после отмены заказа средства будут возвращены непосредственно на баланс вашего аккаунта",
    "WeiLeQueBaoYongHuZiJin2": "В целях безопастности пользователей, перед оплатой необходимо установить платежный пароль",
    "YongHuZiJinZhangHuBuSheXianE": "Баланс платежного счета не имеет ограничений. Пользователи могут просматривать текущее состояние баланса, историю пополнений и переводов, информацию об использовании средств и другое во вкладке “Мой баланс\".",
    "ZhiFuMiMa": "Платежный пароль",
    "ZhiFuMiMaWei6WeiShuZi": "Пароль должен содержать  6 цифр",
    "QueRenZhiFuMiMa": "Подтвердите пароль",
    "ShuRuZhiFuMiMaQueRenZhiFu": "Введите платежный пароль, для того чтобы подтвердить оплату",
    "QingXianShuRuYuanZhiFuMiMaYiYanZhengShenFen": "Пожалуйста, введите платежный пароль для подтверждения личности.",
    "WoDeDianZiYouXiang": "Моя электронная почта",
    "JiuZhiFuMiMa": "Старый платежный пароль",
    "HeJiDaiZhiFu": "Ожидаемая сумма оплаты",
    "ZhangHaoZiJinChongZu": "Достаточно средств для оплаты",
    "BuZuYiZhiFu": "Недостаточно средств для оплаты",
    "DingDanYiShengXiaoZanBuZhiChiQuXiao": "Заказ уже подтвержден, невозможно отменить",
    "WoZaiXiangXiang": "Возможно позже",
    "QingXuanZeQuXiaoYuanYin": "Пожалуйста, укажите причину отмены",
    "QuXiaoShangPin": "Удалить товар",
    "QueRenQuXiaoHouGaiDingDanDuiYing": "После отмены заказа, общая стоимость и депозит могут измениться",
    "DingDanYiChaiFenBenDingDanJinE": "Заказ был разделен, сумма данного заказа",
    "BenDingDanJinE": "Сумма заказа",
    "DingDanZhengZaiJiaZaiZhong": "Загружается...",
    "ZhanShiGengDuo": "Показать больше",
    "ShouQiGengDuo": "Свернуть",
    "ZiDingDan": "Подзаказ",
    "BenDingDanDeGeZiDingDanYiDaoHuo": "Заказ {0} скоро прибудет на склад, пожалуйста оптатите остаток стоимости заказа. Также вы можете оплатить остаток стоимости по другим заказам",
    "YiXiaDingDanYuJiDaoGang": "Ожидается прибытие заказа <i>{0}</i>, общая сумма закрывающего платежа: {1}",
    "ZhiFu": "Оплатить",
    "DingJin": "Депозит",
    "GeXingYaoQiu": "Особенные требования",
    "YiQuXiaoShangPin": "Товар удален",
    "BenChaiFenDingDanShangPinQingDan": "Список товаров после разделения заказа",
    "ZongGongKuanXiangShangPinZongJia": "Всего {0} товаров，{1} коробок, Цена товара: {2}",
    "QueRenQuXiaoHouWuFaHuiFu": "После отмены, восстановление будет невозможно",
    "QuXiaoDingDan": "Отменить заказ",
    "ZaiCiCaiGou": "Повторный заказ",
    "ChaKanZongDingDan": "Все заказы",
    "ZuiJinNTian": "За последние {0} дней",
    "ZuiJinNNian": "За последние {0} лет",
    "DingDanZhengZaiChuLiZhongQing": "Заказ обрабатывается, пожалуйста ожидайте",
    "YouYuShangPinDeHuoQiBuTong": "В связи с разными сроками доставки товаров, ваш заказ будет разделен на {0} подзаказов для скорейшей отгрузки",
    "DaiZhiFuTiHuo": "Ожидается закрывающий платеж",
    "YouDingDanDaiZhiFuTiHuo": "Ожидается закрывающий платеж",
    "QingJinKuaiZhiFuYiMianYingXiangTiHuo": "Пожалуйста, оплатите как можно быстрее для успешного получения груза",
    "YouYuWeiShouDaoDingJinDingDanHaiWuFa": "Из-за отсутствия депозита заказ не был передан в производство, в результате чего дата отгрузки переносится на <i>{0}< / i> (изначальная дата{1}), пожалуйста, оплатите депозит как можно скорее.",
    "JinXingZhong": "В процессе",
    "DaiZhiFuWeiKuan": "Ожидается оплата полной стоимости",
    "YiWanCheng": "Готово",
    "DingJinDaiZhiFu": "Ожидается внесение депозита",
    "DingDanYouYiChangXuChuLi": "Заказ подлежит редактированию",
    "BenDingDanShuYuChaiFenDingDanDeYiXiang": "Если заказ был разбит на подзаказы, то депозит вносится за все подзаказы одновременно.",
    "QingJinKuaiFuKuan": "Пожалуйста, заплатите как можно скорее, для успешного получения груза",
    "DingJinJiaoYiMoShi": "Депозит вносится в качестве гарантии оформления заказа, после чего заказ передается в производство. Внимательно проверяйте всю информацию, так как возврат депозита без весомой причины невозможен. В случае невозможности выполнить заказ, депозит будет полностью возвращен. Закрывающий платеж вносится перед получением товара.",
    "ZheShiZhiYongHuJiCun": "C помощью этого аккаунта, вы можете распоряжаться средствами на счету, а именно: пополнять баланс, оплачивать заказы и запрашивать возврат средств.",
    "yanZhengMaBuNengWeiKong": "Введите код подтверждения",
    "QingXianSheZhiZhiFuMiMa": "Пожалуйста, создайте платежный пароль",
    "ZhiFuMiMaYuQueRenZhiFuMiMaBuYiZhi": "Пароли не совпадают",
    "QueRenZhiFuMiMaBuNengWeiKong": "Поле платежного пароля не может быть пустым",
    "ZhiFuMiMaBuNengWeiKong": "Поле \"платежный пароль\" не может быть пустым",
    "JiuMiMaBuNengWeiKong": "Поле \"старый пароль\" не может быть пустым",
    "JiuMiMaBuZhengQue": "Введен неправильный старый пароль",
    "BenDingDanBaoHanNGeZiDingDanDingJin": "Этот заказ содержит {0} подзаказов, депозит должен быть оплачен совместно",
    "ShangPinYiJingChongXinTianJiaDaoGouWuChe": "Товар был повторно добавлен в корзину",
    "ZhaoXiangSi": "Искать похожие",
    "ZaiCiJiaRuGouWuChe": "Повторно добавить в корзину",
    "QuXiaoShuoMing": "Инструкция по отмене",
    "ShangPinShengChanZhongChuXianYiChang2": "Возникла проблема с производством товаров",
    "ZhiFuMiMaSheZhi": "Создать платежный пароль",
    "SheZhiNinDeZhiFuMiMaBaoZhangZiJinAnQuan": "В целях безопасности необходимо создать платежный пароль. Этот пароль будет использован при каждой оплате.",
    "QingNinZaiNTianNeiJiShiZhiFuDingJin": "Пожалуйста, оплатите депозит в течение <i>{0} дней<i>.",
    "DangNinDeDingDanTiJiaoWanGongHouWoMen": "1. После подтверждения заказа, мы свяжемся с Вами для заключения контракта поставки",
    "TiJiaoHouNinDeDingDanJiaGeJiangShouDaoJiaGeBaoHuYu": "2. После размещения заказа, общая стоимость гарантирована на период {0} дней. В течение этого периода стоимость заказа не изменится. В случае истечения срока гарантии, общая стоимость и депозит могут измениться.",
    "WoMenJiangZaiShouDaoNinDeDingJinHouCaiKaiShiChuLiNinDeDingDan": "4. Заказ будет обработан после поступления депозита",
    "JiaoYiBiZhongYuZhangHaoZiJinBiZhongBuYiZhi": "Валюта транзакции не соответствует валюте средств на счету",
    "QingJinKuaiZhiFuDingJinYuJiDao": "Пожалуйста, оплатите депозит как можно скорее, чтобы избежать изменения цены заказа.",
    "BenDingDanDeGeZiDingDanYiDaoHuo2": "{0} заказов будут доставлены в ближайшее время, пожалуйста оплатите полную стоимость",
    "DaoESSAPingTai": "Произвести оплату заказов",
    "DangQianNinDeZhangHuYouZuGouDeKeYongZiJin": "В настоящее время у вас достаточно свободных средств на счету, нажмите кнопку Оплатить, чтобы оплатить депозит заказа. После того как депозит оплачен, заказ немедленно будет подтвержден в вступит в силу",
    "DangQianNinDeZhangHuMeiYouZuGouDeKeYongZiJin": "В настоящее время на вашем счете недостаточно средств, пожалуйста пополните баланс",
    "XinZhiFuMiMa": "Новый пароль",
    "LianXiGongChangKaiFang": "联系工厂开放权限",
    "DaiChuLiYiChangLieBiao": "Исключения, ожидающие обработки",
    "WeiBiMianDingDanJinDu": "Чтобы избежать задержки заказа, пожалуйста, исправьте проблему как можно скорее",
    "JieShouBianDong": "Принять изменения",
    "QuanBuJieShouBianDong": "Подтвердить измения в заказах",
    "TiJiaoChuLi": "Применить",
    "BenCiZhiFuHeJi": "Общая сумма к оплате",
    "FanHuiDingDanLieBiao": "Назад к списку заказов",
    "GongNDanDanYouYiChangDaiChuLi": "{0} из <i>{1}</i> не подтвержденных заказов",
    "QingWuChongFuTiJiao": "Внимание, повтор операции!",
    "DingJinMoShi": "Режим депозита",
    "AnQuan": "Информация об оплате полностью защищена",
    "ShangPinYiTingShou": "Товар снят с продажи",
    "ShangPinYiTingShou1": "Извините, товара нет в продаже",
    "HenYiHanYouKuanShangPinYi": "К сожалению, {0} артикулов сняты с продажи, остальные {1} артикулов уже добавили в Вашу корзину.",
    "DaoChuShuJu": "Скачать информацию платежа",
    "ZhangHaoZiJinBuZu1": "Вашей оплаты не достаточно",
    "TongJi": "Статистика",
    "c3VibWl0X3BvX2RlcG9zaXRfZGRwX3NwbGl0": "О размещении заказа",
    "c3VibWl0X3BvX2RlcG9zaXRfZGRwX3NwbGl0_remark": "Уведомления об успешном размещении и обработке заказа.",
    "ZGRwX2RlcG9zaXRfb3ZlcmR1ZQ==": "Напоминания о внесении депозита",
    "ZGRwX2RlcG9zaXRfb3ZlcmR1ZQ==_remark": "Напоминание в том случае, если истек срок внесения депозита.",
    "cG9fcGF5X2RlcG9zaXRfZGRw": "О подтверждении депозита и обработке заказа",
    "ZGRwX3BvX2NhbmNlbA==_remark": "В том случае, если заказ был автоматически отменен из-за неоплаты депозита.",
    "cG9fcGF5X2RlcG9zaXRfZGRw_remark": "Уведомление о том, что депозит был принят и заказ готов для передчи в производство.",
    "ZGRwX3BvX2NhbmNlbA==": "Уведомление об отмене заказа",
    "GaiShangPingBuYunXuJiaGou": "此商品暂无权限加购",
    "QingShuRu6WeiShuZiDeZhiFuMiMa": "Введите как минимум 6 цифр.",
    "1006ARG1000000": "Извините, на этой странице произошла ошибка!",
    "WeiKuan": "Окончательный платеж",
    "TuPianChaoGuo4M": "Извините, размер загружаемого Вами изображения превысило 4М！Пожалуйста, уменьшите размер изображения и попробуйте снова!",
    "QingXuanZeNinDingDanDeFaHuoFangShi": "Пожалуйста выберите тип отгрузки",
    "ChaiDanTiShi": "Уведомление о разделении заказа",
    "DingDanChaiFenFaHuo": "Разделить заказ",
    "WoMenJiangGenJuNiDingDanZhongBuTong": "Ваш заказ может быть разделен на подзаказы, согласно срокам производства каждого артикула.  Отгрузки из Китая так же могут осуществляться частями, что позволит ускорить процесс прохождения таможенного контроля и доставки. Но по прибытию подзаказов на склад расконсолидации, их необходимо будет забирать так же частями.",
    "BenCiDingDanGenJuShangPinHuoQi": "Данный заказ можно разделить на {0} под-заказа.",
    "DingDanGongNKuanYuJiDaoGangShiJi": "Заказ {0}, всего {1} позиций, <i>Ориентировочная дата доставки:{3}</i>",
    "DingDanTongYiFaHuo": "Объединить в один заказ",
    "DingDanBuChaiFenDengDingDanZhongSuo": "После того как производство всех позиций будет завершено, они будут объедены и отгружены одной партией.",
    "JiaGeBaoHuQiShengYuNTian2": "Защита цены товара продолжается еще {0} дней, в течение этого периода цена не изменится.",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA2==": "Все заказы завершены",
    "MeiZhouTeHui": "Еженедельные акции",
    "RuGuoChaoGuoNTian": "3. Если по истечению {0} д. депозит не будет оплачен, то заказ станет не действителен и будет автоматически отменен.",
    "DingYue": "Подписка",
    "RenQi": "Популярные",
    "KuanShi": "Позиции",
    "ChuangXinJingXuan": "Подборка новинок",
    "ReXiaoPaiHangBang": "Хитовые продукты",
    "QuanBuXinPin": "Все новинки ",
    "YiXiangKeMai": "MOQ-1 коробка с отгрузкой через 10 дней. Не пропусти！",
    "YXV0b19tYXJrZXRpbmdfZW1haWw1": "Рекомендованные товары/Скидки на товары/Информация об акциях ",
    "QueDingTiJiao": "Подтвердить ",
    "NinQueDingYaoTuiDing": "Вы уверенны, что хотите отписаться от рассылки? ",
    "WoBuXiangZaiJieShou": "Я больше не хочу получать рассылку о {0}, спасибо!",
    "TeHuiShangPin": "Товары из акции",
    "YouXiangDingYueZuiXin": "Введите адрес эл. почты, чтобы подписаться на обновления",
    "Zhe": "Скидка",
    "ManShiYong": "На заказы от {0}",
    "LingQu": "Получить",
    "YiLingQu": "Получено",
    "XiangXi": "Просмотреть детально",
    "LiJiChaKan": "Посмотреть",
    "GongXiHuoDeYouHuiQuan": "Поздравляем, Вы получили скидочный купон!",
    "YiJiangLi": "Получено!",
    "WeiJiangLi": "Вознаграждение еще не получено",
    "ZhiDaoLe": "Ознакомлен",
    "DingDanManKeYongZuiDuoZheKou": "На заказы от {0}, макс. скидка {1}",
    "DingDanManKeYongZheKouJinEBuXian": "На заказы от {0}",
    "ManKeYong": "На заказы от {0}",
    "ZengSongNiYouHuiQuanKeYongYuXiaCiXiaoFei": "Подарочный купон для следующих заказов",
    "GaiPinPaiQuanBu": "Действует на все товары конкретного бренда",
    "YaoQingYouLi": "Пригласи друга - получи скидку!",
    "MeiYaoQing1WeiHaoYouZhuCeJiKeHuo": "Каждый пользователь, пригласивший 1 друга для регистрации, получит награду первого уровня. Если Ваш друг разместит первый заказ, то Вы получите денежный купон, и Ваш друг также получит подарочный купон для новых клиентов на сумму не выше ₽ 20000.",
    "YaoQingJiangLi": "Награды за приглашение",
    "ZhiJieDianJiNinYaoFenXiangDeSheJiaoMeiTi": "Вариант 1: Поделиться через социальные сети.",
    "FuZhiLianJieFaSongHaoYou": "Вариант 2: Скопировать ссылку и отправить напрямую другу .",
    "FaXianYiGeHaoWangZhanessaone": "Рекомендую отличный сайт по закупкам из Китая, минимальный заказ - всего 1 коробка! Перейдите по ссылке для регистрации и получите специальное предложение для новых пользователей!  {0}",
    "FenXiangHuoDongGeiHaoYou": "Поделиться акцией с другом",
    "HaoYouZhuCeWanChengShouDan": "При регистрации пользователь получит специальное предложение для первого заказа",
    "JiangLiLiQuanDaoZhang": "Приглашенный пользователь также получит вознаграждение при первом заказе",
    "WoDeJiangLi": "Мои купоны",
    "ChaKanWoDeYouHuiQuan": "Посмотреть мои купоны",
    "ZhuCeJiangLi": "Награды за регистрацию",
    "XiaDanJiangLi": "Награды за первый заказ",
    "WoDeYouHuiQuan": "Мои купоны",
    "YaoQingJiLu": "История приглашений",
    "YouHui2": "C учетом скидки",
    "XinRenYouHuiQuan": "Купоны для новичков",
    "LiJiShiYong": "Применить сейчас",
    "BaoHanShuiFei": "Включая НДС",
    "DaoChuDingDanShangPin": "Выгрузка товаров",
    "PODanDaoChu": "Скачать список товаров",
    "BaoHanDingDanShangPinXiangQingXinXi": "Включая подробную информацию о товаре",
    "DaoChuShangPinTuPian": "Скачать фото",
    "JinBaoHanDingDanDeShangPinTuPian": "Только изображение товаров",
    "NZengZhiShuiE": "Сумма НДС по ставке {0}%",
    "WeiShiYongYouHuiQuan2": "Применимые купоны",
    "ZanWuWeiShiYongYouHuiQuan2": "Нет применимых купонов",
    "XinDaoZhang": "Последние добавления",
    "JiJiangGuoQi": "Истекает в ближайшее время",
    "GuiZeShuoMing": "Правила пользования",
    "YouHuiQuanLieBiaoShuoMin11": "Основные правила применения скидочного купона:",
    "YouHuiQuanLieBiaoShuoMin12": "1. На платформе ESSAONE проводятся специальные акции в которых можно получить скидочные купоны,  такие купоны можно будет использовать только на платформе ESSAONE.",
    "YouHuiQuanLieBiaoShuoMin13": "2.На данный момент существуют два вида купонов: Скидочный купон и денежный купон.",
    "YouHuiQuanLieBiaoShuoMin14": "3. Как получить купон: 1) После регистрации на платформе, 2) После авторизации на платформе, 3) После оформления заказа 4) За участие в акциях;",
    "YouHuiQuanLieBiaoShuoMin15": "4. Для каждого заказа можно использовать только один купон, каждый из купонов можно использовать только один раз. Внимательно ознакомьтесь с инструкцией по применению купона во время проведения акции.",
    "YouHuiQuanLieBiaoShuoMin16": "5.  Если Ваш заказ был полностью отменен, то купон будет возвращен. Если заказ был отменен частично и скидка будет частично использована, купон не будет возвращен.",
    "YouHuiQuanLieBiaoShuoMin17": "6. Купоны нельзя обменять, продать или передать другому пользователю.",
    "YouHuiQuanLieBiaoShuoMin21": "Правила использования купона:",
    "YouHuiQuanLieBiaoShuoMin22": "1.Купон на все товары: Купоны можно использовать на все товары предоставленные на платформе без каких-либо пользовательских, товарных и территориальных ограничений. Купон можно использовать, если стоимость заказа соответсвует требованиям купона.  На каждый заказ можно использовать только один купон, сумма скидки будет вычтена из общей стоимости заказа.",
    "YouHuiQuanLieBiaoShuoMin23": "2. Купон на определеную категорию: данный купон можно использовать только на покупку товара из определенной категории. На каждый заказ можно использовать только один купон, сумма скидки будет вычтена из общей стоимости заказа.",
    "YouHuiQuanLieBiaoShuoMin24": "Например: На категорию «Детские игрушки» есть скидка 5%, значит купон можно \tиспользовать только если в Вашем заказе присутствует товар из категории «Детские игрушки» и общая стоимость этого товара соответсвует требованиям купона.",
    "YouHuiQuanLieBiaoShuoMin25": "3. Купон на товар из «ограниченного предложения»: Данный купон можно использовать только на покупку товара из  определенного списка. На каждый заказ можно использовать только один купон, сумма скидки будет вычтена из общей стоимости товара из «ограниченного предложения» в заказе.",
    "YouHuiQuanLieBiaoShuoMin26": "Например: скидку на покупку товара из «ограниченного предложения» на 1000$ можно использовать только в том случае, если в Вашем заказе присутствует товар из «ограниченного предложения» и общая стоимость этого товара соответсвует требованиям купона.",
    "YouHuiQuanLieBiaoShuoMin27": "4. Подарочный купон нового клиента: Данный купон могут использовать только новые клиенты платформы ESSAONE. Новые клиенты это те клиенты, которые еще не оформляли заказ на платформе. Купон можно использовать, если стоимость заказа соответсвует требованиям купона.",
    "HaoYouKeDeZuiGaoYouHui": "Что Вы получите: большой пакет скидочных купонов на общую сумму ₽40 000! Максимальная скидка за один заказ ₽20 000.",
    "YaoQingYeGuiZeShuoMing1": "1. Время проведения акции: с 9 апреля 2021 года.",
    "YaoQingYeGuiZeShuoMing2": "2. Во время проведения акции Ваш друг должен быть зарегистрирован именно по ссылке которой Вы поделились, а так же разместить заказ.",
    "YaoQingYeGuiZeShuoMing3": "3. За каждого приглашенного и успешно зарегистрированного друга, который разместит заказ, Вы получите скидочный купон на сумму ₽20000.",
    "YaoQingYeGuiZeShuoMing4": "4. После того как Ваш приглашенный друг проведет регистрацию на платформе, Вы получите скидочных купон на сумму ₽20000. Но данный купон активируется и его можно будет использовать только после того, как Ваш друг разместит заказ.",
    "YaoQingYeGuiZeShuoMing5": "5. Купон будет начислен автоматически в \"Мои купоны\" в личном кабинете.",
    "YaoQingYeGuiZeShuoMing6": "6. Вы можете посмотреть свои купоны в разделе “Мои купоны”. Срок действия купонов - 180 дней.",
    "YaoQingYeGuiZeShuoMing7": "7. По всем вопросам касающимся данной акции Вы можете обратиться в службу поддержки сайта. Право интерпретации акции полностью принадлежит ESSAONE.",
    "YiJiJiangLi": "Награда первого уровня",
    "ErJiJiangLi": "Награда второго уровня",
    "HaoYouZhuCeChengGongKeDe": "Можно получить после регистрации друга",
    "HaoYouWanChengShouBiDingDanKeDe": "Можно получить после того как друг разместит первый заказ",
    "ZanWuShuJu": "Нет данных",
    "QuShiYong": "Использовать",
    "BuKeShiYong": "Не возможно применить",
    "SuiFei": "Сумма НДС",
    "YouHuiQuanZheGou": "Купон/Скидка",
    "YiShiYongZuiYouZuHe": "Использован самый выгодный купон",
    "XuanZeZuiYouZuHe": "Выбрать самый выгодный купон",
    "ChongXinXuanZeQiTaYouHuiQuan": "Выбрать другой купон",
    "QuanBuShangPinKeYong": "Действует на все товары",
    "ZhiDingLeiMuKeYong": "Действует на определенную категорию",
    "ZhiDingPinPaiKeYong": "Действует на все товары конкретного бренда",
    "ZhiDingShangPinKeYong": "Действует на товары из «ограниченного предложения»",
    "YouYouHuiQuanKeYong": "Есть применимые купоны",
    "NiYouNZhangYouHuiQuanKeYong": "{0} купонов",
    "JinTianGuoQi": "Срок действия истекает сегодня",
    "HaiShengNTian": "Осталось {0} дней",
    "HuoQuYouHuiQuan": "Получить купон на скидку",
    "FaXianYiGeHaoWangZhanessaone2": "Рекомендую отличный сайт по закупкам из Китая, минимальный заказ - всего 1 коробка! Перейдите по ссылке для регистрации и получите специальное предложение для новых пользователей!",
    "XinRenTeHui": "Cпециальное предложение для новых пользователей",
    "ShouDanJiKeShiYong": "Можно применить к первому заказу",
    "ShouDanWanChengHou": "Купон будет получен после оформления первого заказа",
    "LingQuanHouNTianNeiYouXiao": "Срок действия истекает через {0} день.",
    "YiPaiWan": "Отправлено",
    "DingDanZhengZaiJiSuanZhong": "Заказ обрабатывается, это может занять несколько минут, пожалуйста ожидайте.",
    "totalDdpTaxesCost": "Включая НДС",
    "ChaKanYouHuiQuan": "Информация о купоне",
    "YiZhuCe": "уже зарегистрировались",
    "Ren": "пользователей",
    "WuShiYongMenKanZuiDuo": "На заказы до {0}",
    "WuShiYongXianZhi": "Нет ограничений по использованию",
    "RuHeYaoQing": "Как пригласить",
    "CongZhongGuoFaHuoJiaGeHan2": "Доставка из Китая: таможенная очистка, логистические расходы, а так же {0} импортной таможенной пошлины уже включены в цену",
    "ZanWeiShengXiao": "Пока не действителен",
    "YaoQingYongHuMingXi": "Детали приглашения",
    "DianZiYouJian": "E-mail",
    "JiangLiJinE": "Сумма комиссии",
    "RenZhengZhuangTai": "Статус",
    "RenZhengZhong": "Ожидание подтверждения",
    "RenZhengChengGong": "Подтверждено",
    "RenZhengShiBai": "Отклонено",
    "WoDeYaoQingJiangLi": "Процент от продаж",
    "LeiJiYaoQingYongHuShu": "Количество приглашенных пользователей",
    "RenZhengTongGuoShu": "Kоличество подтвержденных клиентов ",
    "TiCheng": "Сумма комиссии",
    "ShouYeBiaoTi2": "ESSA - цифровая платформа для глобальной торговли",
    "YongHuXingWei1": "За последние 30 дней",
    "YongHuXingWei2": "За последние 60 дней",
    "YongHuXingWei3": "За последние 90 дней",
    "YongHuXingWei4": "Все",
    "MeiYaoQing1WeiHaoYouZhuCeJiKeHuo2": "Пригласите Вашего друга (не конкурента) и поделитесь с ним наградой!<br>Каждый, кто пригласит друга к регистрации и размещению первого заказа получит скидочный купон на сумму ₽20000, а его пригашенный друг так же получит набор купонов на общую сумму ₽40000.",
    "NiKeHuoDe": "Ваша награда",
    "HaoYouWanChengShouBiDingDanKeYong": "Вы получите скидочный купон, после регистрации друга.Воспользоваться купоном можно после того, как Ваш друг разместит заказ",
    "HaoYouKeDe": "Награда друга",
    "HaoYouZhuCeChengGongKeHuoDe": "После успешной регистрации Ваш друг сможет получить набор купонов на общую сумму ₽40000.",
    "NiKeDeYiZhangDaiJiHuoJuan": "После успешной регистрации друга, Вы сможете получить скидочный купон на сумму ₽20000, но воспользоваться после того, как Ваш друг разместит заказ.",
    "HaoYouZhuCeDeDaiJiHuoYouHuiJuan": "После регистрации друга, Вы получаете пока неактивированный купон.",
    "YiXiaDan": "Заказ оформлен",
    "YiZhuCeWeiXiaDan": "Уже зарегистрировался, но не разместил заказ",
    "HaoYouXiaDanYouHuiJuanKeYong": "Купоном можно воспользоваться, после того как друг разместит заказ.",
    "YiJiHuo": "Активированные купоны",
    "DaiJiHuo": "Ожидание активации купона",
    "YiJiHuoYouHuiJuan": "Активированные купоны",
    "RenZhengBuTongGuoYuanYin": "Нецелевой клиент",
    "DaiJiHuoYouHuiJuan": "Ожидание активации купона",
    "YongHuXingWei": "Информация о действиях пользователя",
    "TuiGuangDeKeHuSuoYouYiWan1": "Комиссия со всех подтвержденных регистраций",
    "TuiGuangDeKeHuBenZiRanYue1": "Комиссия с подтвержденных регистраций в этом месяце",
    "TuiGuangDeKeHuSuoYouYiJin1": "Ожидаемая комиссия с зарегистрированных, но еще неподтвержденных пользователей",
    "YaoQingHaoYouXinXiE": "1. Вы можете скопировать ссылку приглашения, и поделиться ей с друзьями в соц.сетях, или отправить по эл.почте.",
    "YaoQingHaoYouXinXiF": "Комиссия за приглашенного пользователя будет получена только в том случае, если пользователь зарегистрировался перейдя по вашей пригласительной ссылке или ввел ваш пригласительный код при регистрации.",
    "YaoQingHaoYouXinXiG": "Комиссия высчитывается с учетом всех клиентов который зарегистрировались  на площадке и были подтверждены.",
    "YaoQingHaoYouXinXiH": "Информацию о всех приглашенных клиентах можно просмотреть во вкладке \"Процент от продаж\", если приглашенный пользователь не отображается в списке, пожалуйста, обратитесь в центр поддержки essaone.",
    "KeHuXinXi": "Информация о клиенте",
    "DianZiYouXiang": "Email",
    "FenXiaoShang": "Дистрибьютор",
    "FenXiaoShangLeiXing": "Тип дистрибьютора",
    "KeHuGenJinXinXi": "Информация о клиенте",
    "LianXiRenZhiWu": "Должность",
    "GongSiLeiXing": "Тип компании",
    "JingYingLeiMu": "Основные категории",
    "NianXiaoShouE": "Годовой оборот компании",
    "XianXiaMenDianShuLiang": "Кол-во магазинов оффлайн",
    "ZaiShouSKUShu": "Количество SKU",
    "GenJinRenYuan": "Менеджер",
    "ShouCiGenJin": "Первый заказ",
    "QuanBuYongHu": "Все клиенты",
    "YiGenJinYongHu": "Клиенты, с которыми уже связались",
    "XinYongHu": "Новые клиенты",
    "GongSiMingChengLianXiFangShi": "Номер клиента/Наименование компании/Контактные данные",
    "QingXuanZeQuDao": "Выберите источник",
    "QingXuanZeFenXiaoShang": "Выберите дилера",
    "QingXuanZeGenJinRen": "Выберите менеджера",
    "YongHuDeGongSiMingChengHeChengShiXinXi": "Название компании и город",
    "YongHuDeLianXiYouXiangHeShouJiHaoMa": "Электронная почта и номер мобильного телефона пользователя",
    "ZhuCeQuDao": "Источник",
    "YongHuDeZhuCeQuDaoLaiYuanHeFenXiaoShangXinXi": "Источник регистрации и информация дистрибьютора",
    "GenJinRen": "Менеджер",
    "GenJin": "Связаться",
    "QingXuanZeZhuangTai": "Выберите статус",
    "GangWei": "Должность",
    "YiGenJinKeHu": "Кол-во клиентов",
    "ZhangHaoZhuangTai": "Состояние аккаунта",
    "TingYong": "Деактивировано",
    "XinZengKeHuXinXi": "Добавить информацию",
    "BianJiKeHuXinXi": "Редактировать данные",
    "QingShuRuYuanGongXingMing": "Пожалуйста, введите имя сотрудника",
    "QingSheZhiYuanGongDengLuZhangHao": "Пожалуйста, создайте учетную запись",
    "DengLuZhangHao": "Номер аккаунта",
    "DengLuMiMa": "Пароль",
    "QingSheZhiYuanGongDengLuMiMa": "Пожалуйста, установите пароль для входа в аккаунт",
    "QingXuanZeGangWei": "Выберите должность",
    "QingSheZhiYuanGongLianXiDianHua": "Пожалуйста, введите контактный номер сотрудника",
    "ShiFouQiYongGaiZhangHao": "Активировать аккаунт?",
    "XinZengYuanGong": "Добавить сотрудника",
    "ShiFouTingYongGaiZhangHao": "Деактивировать аккаунт?",
    "QingShuRuYuanGongZhangHuXinMiMa": "Введите новый пароль сотрудника",
    "MuBiaoYongHu": "Целевой клиент",
    "GuanLiHouTai": "Система управления",
    "KeHuLieBiao": "Клиент",
    "KeHuXinXiBuChong": "Добавить информацию о клиенте",
    "FeiMuBiaoYongHu": "Нецелевой клиент",
    "QingShuRuGongSiWangZhi": "Пожалуйста, введите ссылка на сайт",
    "QingShuRuKeHuLianXiRen": "Введите контактную информацию клиента",
    "QingShuRuZhengQueDeLianXiDianHua": "Пожалуйста, введите правильные контакты",
    "QingTianXieMenDianShuLiang": "Укажите кол-во магазинов",
    "QingXuanZeGenJinRenYuan": "Выберите менеджера",
    "QingXuanZeGongSiLeiXing": "Выберите тип компании",
    "QingXuanZeJingYingLeiMu": "Выберите основные категории",
    "QingXuanZeLianXiRenZhiWu": "Выберите должность",
    "QingXuanZeNianDuXiaoShouE": "Выберите годовой оборот компании",
    "QingXuanZeZaiShouSKUShu": "Выберете кол-во продаваемых SKU",
    "QuDao": "Источник",
    "ShiFouMuBiaoKeHu": "Является ли клиент целевым для ESSAONE",
    "TuiGuangFangShi": "Канал продвижения",
    "YongHuGenJin": "Неотслеживаемые клиенты",
    "YuanGongZhangHaoGuanLi": "Управление учетными записями",
    "ZhangHaoXiangQing": "Информация о клиенте",
    "YouYeWuYuanZhengZaiGenJin": "Другой менеджер уже проводит работу, пожалуйста, не проводите операцию повторно!",
    "QingShuRuZhangHao": "Введите логин",
    "LiJiDengLu": "Войти",
    "EGuoYunYingPingTai": "Операционная платформа ESSAONE",
    "BuShiLingShouKeHu": "На площадке пока не предоставлены товары основной категории клиента.",
    "BuShiBenGuoYongHu": "Клиент не из РФ.",
    "QingShuRuYongHuMing": "Пожалуйста, введите логин",
    "QingShuRuMiMa": "Пожалуйста, введите пароль",
    "QingShuRuShuiWuHao": "Пожалуйста, введите ИНН",
    "QingShuRuYingYeZhiZhao": "Пожалуйста, введите номер бизнес-лицензии",
    "NinCaoZuoTaiKuaiLeQingTin": "Действие выполнено слишком быстро, передохните!",
    "DaoChuShuJuShaiXuan": "Фильтр экспортируемых данных",
    "QingShuRuCaiGouShangBianMaHuoMingCheng": "Введите номер клиента или название компании",
    "KeHuShuJu": "Поведенческая информация о клиенте",
    "ZuiJinJiaGouShiJian": "Последнее добавление в корзину",
    "JiaGouKuanShu": "Кол-во товара в корзине",
    "ZuiJinFangWenShiJian": "Последнее посещение",
    "LeiJiDingDanShu": "Общее кол-во заказов",
    "ZuiJinXiaDanShiJian": "Время размещения последнего заказа",
    "CaiGouShangHangWeiShuJu": "Поведенческая информация о клиенте",
    "JiaRuShiJian": "Время заказа",
    "QingShuRuJiGuiDanHaoHuoGuiHao": "Введите номер инвойса или номер контейнера",
    "DengLuRenShu": "Кол-во регистраций",
    "XinKeHuChengJiaoRenShu": "Кол-во новых клиентов, разместивших заказы",
    "ZongChengJiaoRenShu": "Общее кол-во клиентов, разместивших заказы",
    "WeiChengJiaoKeHu": "Клиенты, не совершившие сделку",
    "YiChengJiaoDeKeHu": "Клиенты, совершившие сделку",
    "KeHuLeiXing": "Тип клиента",
    "JiaGouShangPinShu": "Кол-во товара в корзине",
    "KeXiaDanShangPinShu": "Кол-во товаров, готовых к размещению",
    "WeiZhiFuDingJinDingDanShu": "Кол-во заказов ожидающих оплату депозита",
    "JinNianCaiGouZongJinE": "Общая сумма покупки в этом году",
    "JinNianDingDanShu": "Общее кол-во заказов в этом году",
    "WeiZhiFuWeiKuanDingDanShu": "Кол-во заказов ожидающих оплату закрыв. платежа",
    "LeiJiCaiGouZongJinE": "Общая сумма закупок",
    "ShouCiChengJiaoShiJian": "Дата первой сделки",
    "ZuiJinChengJiaoShiJian": "Дата последней сделки",
    "QingShuRuDingDanBianMaHuoShangPinBianMa": "Введите номер заказа или артикул товара",
    "ShuJuTongJi": "Статистика данных",
    "CaiGouShang": "Номер клиента",
    "MaiJiaBaoZhang": "Гарантия покупателя",
    "MaiGuiBiPei": "Гарантия оптимальной цены",
    "WanDaoBiPei": "Гарантия поставки",
    "PoSunBiPei": "Гарантия качества",
    "ZhengGuiQingGuan": "Официально",
    "XinKeYouHui": "Акции для новых клиентов",
    "GouWuCheGaiShangPinZaiXunPanZhong": "В корзине уже есть этот товар!",
    "YiGengXinWeiGongChangZuiXinTuiJianJia": "Обновлено до последней рекомендованной цены фабрики.",
    "GongChangYouHaoTuiJian": "У фабрики есть рекомендация для Вас!",
    "JiaGeYouXiaoQi": "Срок действия цены",
    "TuiJianLiYou": "Причина рекомендации",
    "JiaRuXuanYangChi": "Добавить в корзину",
    "PaiYiPaiTiXingShangXin": "Пригласить завод к выпуску новинки.",
    "JinQiYiTiXingShangXin": "Недавно уже было приглашено к выпуску новинки.",
    "ChaKanGongChangDongTai": "Вы можете зайти в \"Мои подписки\", чтобы узнать новые обновления фабрик",
    "JiaRuXuanYangChiChengGong": "Успешный вход в корзину образцов",
    "JiaRuGouWuCheChengGong": "Товар добавлен в корзину",
    "GuanZhuGongChangDongTai": "Последние обновления с фабрик",
    "CLAIM_DAMAGE_001": "Сумма ежедневного возврата была рассчитана неверно",
    "CLAIM_DAMAGE_002": "Ошибка в расчете общей суммы возврата",
    "CLAIM_DAMAGE_003": "Компенсация не может превышать 10% от общей стоимости заказа",
    "CLAIM_DAMAGE_004": "Цена сделки не была дороже, чем цена покупки из других каналов",
    "CLAIM_DAMAGE_005": "Разница в цене после согласования не может быть меньше 0",
    "CLAIM_DAMAGE_006": "Общее количество неверно",
    "CLAIM_DAMAGE_007": "Общая сумма возврата неверна",
    "ShangPinZaiDaiGongChangQueRenZuiXinJiaZhong": "Товары из корзины образцов ожидают подтверждения последней цены от фабрики.",
    "WuTuiJianShangPin": "Нет рекомендованных товаров",
    "HenBaoQianNinDeDingDanBiYuQi": "Мы сожалеем! Ваш заказ поступил на {0} дней позже, чем ожидалось, и вы имеете право на компенсацию в размере {1} .",
    "ShenQingWanDaoBiPei": "Подать заявку на гарантию поставки",
    "ShiFouShenQingSuoPei": "Подать заявку на компенсацию?",
    "ShenQingSuoPei": "Подать заявку на компенсацию",
    "NinDeDingDanBiYuQiWanDaoLe": "Ваш заказ прибыл на {0} дней позже ожидаемого срока, и вы имеете право на компенсацию в размере {1} .",
    "PoSun": "Товар поврежден",
    "MaiGui": "Купил дороже",
    "TiJiaoShenQing": "Отправить заявку",
    "ShenHe": "Проверка",
    "SuoPeiJieGuo": "Результат рассмотрения претензии",
    "ChanPinWenTi": "Возникшая проблема",
    "QingXuanZeChanPinWenTi": "Выберите проблему с товаром",
    "QingTiGongYouXiaoZhengMing": "Пожалуйста, предоставьте действительное доказательство (Для проверки)",
    "GongHuoQuDao": "Канал поставки",
    "QingTianXieGongHuoQuDao": "Введите канал поставки",
    "GongHuoJiaGe": "Цена поставки",
    "QingTianXieGongHuoJiaGe": "Введите цену поставки",
    "QingTianXieZhengQueDeGongHuoJiaGe": "Введите действительную цену поставки",
    "ShangChuanPingZheng": "Загрузите доказательства",
    "ZhiChiTuPianShiPinWenDang": "Поддерживает загрузку фото/видео/документа в (mp4,flv,jpeg,jpg,png,bmp,doc,docx,xls,xlsx,pdf) форматах, размер файла не должен превышать 20МБ, можно загрузить не более 5-ти файлов",
    "TianXieShuoMing": "Заполните пояснение",
    "QingTianXieShuoMing": "Введите пояснение!",
    "JianYiBuChongGengXiangXiDe": "Рекомендуем добавить более подробное описание проблемы, это поможет платформе быстрее и лучше решить Ваш вопрос!",
    "LianXiRenXinXi": "Контактное лицо",
    "QingTianXieZhengQueYouXiao": "Заполните правильную и действительную контактную информацию. При необходимости мы свяжемся с Вами по телефону, чтобы решить Ваш вопрос",
    "SuoPeiShenQingJiLu": "Учет заявок на компенсацию",
    "DingDanWanDaoTianShu": "Количество дней задержки заказа",
    "YuJiPeiChangJinE": "Примерная сумма компенсации",
    "TiJiaoChengGongQingNaiXinDengDai": "Заявка подана, ожидайте",
    "ShenHeJieGuoJiangYu7GeGong": "Результат проверки будет готов в течение 7 рабочих дней, пожалуйста, не забудьте проверить почту!",
    "FanHuiDingDanXiangQing": "Вернуться к деталям заказа",
    "ShenQingXinXi": "Информация о заявке",
    "LeiXing": "Тип",
    "ShouHouDanHao": "Номер заявки",
    "CheXiaoShenQing": "Отменить заявку",
    "PingZheng": "Доказательства",
    "NinDeSuoPeiZhengZaiShen": "Ваше заявление находится на рассмотрении, пожалуйста, ожидайте. Результаты проверки будут готовы в течение 15 рабочих дней",
    "ShenHeTongGuoYiHuoPei": "Проверка пройдена, компенсация получена. Сумма компенсации {0}",
    "NinDePeiChangKuanYiTui": "Сумму компенсации уже начислили Вам на баланс. Пожалуйста, проверьте через <a href=\"/member/funds-detail\">Подробности счета</a>",
    "ShenHeBuTongGuo": "Заявка не одобрена",
    "ShenHeZhong": "Ожидание проверки",
    "ShiBaiYuanYin": "Причина ошибки",
    "DengDaiPingTaiShenHeChuLi": "Ожидание обработки заявки",
    "NiSuoTiJiaoDeXinXiZhengZai": "Информация, которую вы предоставили, ожидает рассмотрения и обработки платформой, и будет подтверждена в течение 7 рабочих дней. Пожалуйста, не забудьте проверить почту!.",
    "ShenQingYiCheXiao": "Заявка отменена!",
    "NinYiCheXiaoCiCiSuoPeiShenQing": "Вы отменили данную заявку. Если ваша проблема не будет решена, Вы можете подать заявку повторно в течение срока действия",
    "TuiKuanDanJiaPCS": "Возврат за единицу товара/штук",
    "ShiJiQueShaoSunHuaiShuLiang": "Количество сломанных/недостающих позиций",
    "ZongTuiKuanJinE": "Общая сумма компенсации",
    "JieGuoShuoMing": "Пояснение к результату",
    "XieShangHouChaJia": "Разница в цене после согласования",
    "ZongShuLiang": "Общее количество",
    "TuiKuanJinE": "Сумма компенсации",
    "QingShuRuChaJia": "Введите разницу в цене",
    "QingShuRuShiJiQueShaoSunHuaiShuLiang": "Введите точное количество сломанных/недостающих позиций",
    "QingShuRuZongTuiKuanJinE": "Введите общую сумму возврата",
    "ShouHouGuanLi": "Управление послепродажным обслуживанием",
    "ShouHouXiangQing": "Подробная информация",
    "KeHuShenQing": "Заявка клиента",
    "ShenHeChuLi": "Процесс проверки",
    "ShouHouBianHao": "Номер заявки",
    "ShenQingKeHu": "Клиенты",
    "JuTiWenTi": "Конкретный вопрос",
    "ShenQingShuoMing": "Пояснение заявки",
    "ChaJia": "Разница в цене",
    "ZongChaJia": "Общая сумма разницы в цене",
    "ChengNuoDaoHuoShiJian": "Расчетное время прибытия",
    "RuKuQueRenShiJian": "Время для подтверждения прибытия на склад",
    "WanDaoTianShu": "Количество дней задержки",
    "YuJiTuiKuanJinE": "Примерная сумма компенсации",
    "LaiKuanDengJi": "Реестр входящих платежей",
    "JinQiLaiKuan": "Последние входящие платежи",
    "ChaKanLaiKuanJiLu": "Посмотреть учет входящих платежей",
    "YinHangLiuShuiHao": "Банковский серийный номер",
    "DaoKuanRiQi": "Дата поступления на расчет. счет",
    "ShiJiDaoZhangJinE": "Фактически полученная сумма",
    "DengJiRen": "Регистрант",
    "FuKuanFangShi": "Способ оплаты",
    "LaiKuanXiangQing": "Детали входящих платежей",
    "KeHuBianMa": "Номер клиента",
    "KeHuMingCheng": "Клиент",
    "QingShuRuCaiGouShangBianMa": "Введите номер клиента",
    "XuanZeKeHu": "Выберите клиента",
    "KeHu": "Клиент",
    "QingXuanZeDaoKuanRiQi": "Выберите дату поступления на расчет. счет",
    "QingShuRuYinHangLiuShuiHao": "Введите банковский серийный номер",
    "QingXuanZeFuKuanFangShi": "Выберите способ оплаты",
    "DaoZhangJinE": "Сумма поступления на расчет. счет",
    "QingShuRuDaoZhangJinE": "Введите сумму поступления на расчет. счет",
    "QingShuRuBeiZhuXinXi": "Введите примечание",
    "LaiKuanJiLu": "Учет входящих платежей",
    "QingQueRenLuRuDeDaoZhangJinEShiFouZhengQue": "Пожалуйста, подтвердите, что сумма, зачисленная на счет, верна",
    "QingShuRuTianShu": "Введите количество дней",
    "PeiChangJinEZuiGaoBuChaoHuoWuJinEDe": "Сумма компенсации не может превышать более {0}% от суммы заказа",
    "ChuHuoDan": "Накладная",
    "JiGuiDanHao": "Номер инвойса",
    "HuoGuiXinXi": "Информация о контейнере",
    "GuiHao": "Номер контейнера",
    "CaiWuGuanLi": "Управление финансами",
    "XiaoShouShuJu": "Статистика продаж",
    "ShouHouSuoPei": "Рекламации",
    "DingDanShu": "Приказ",
    "KeHuShu": "клиент",
    "FenXiaoShangTiCheng": "Комиссии дилеров",
    "FenXiaoShangXingMing": "ФИО дилера",
    "ZongGong": "Итого",
    "YiZhiFuWeiKuan": "Закрывающий платеж уже оплачен",
    "QingShuRuKeHuBianMaHuoShangBinBianMa": "Введите номер клиента или артикул",
    "QingShuRuPODanHao": "Введите номер заказа",
    "QingShuRuShouHouDanHao": "Введите номер заявки",
    "ChaXun": "Поиск",
    "SuoPeiFuWuLeiXing": "Тип гарантии",
    "FuWuLeiXing": "Тип услуги",
    "ChuLiRen": "Исполнитель",
    "YingShouWeiKuan": "Остаток к получению",
    "WeiChuLi": "Не обработано",
    "YiChuLi": "Обработано",
    "QingXuanZeDingDanZhuangTai": "Выберите статус заказа",
    "ChuLiZhuangTai": "Статус обработки",
    "ZhiFuWeiKuanShiJian": "Дата оплаты закрывающего платежа",
    "TiChengBiLi": "Процент комиссии",
    "EXWZongJia": "Общая цена EXW",
    "QuanXianSheZhi": "Настройки прав доступа",
    "QingXuanZeTuiKuanZhuangTai": "Выберите статус возврата",
    "TuiKuanZhuangTai": "Статус возврата",
    "TuiKuanShuJuTongJi": "Статистика возврата средств",
    "DaiTuiKuan": "Ожидание компенсации",
    "YiTuiKuan": "Компенсировано",
    "ChuLiShiJian": "Время обработки",
    "QuChuLi": "Перейти",
    "ShaoHouZaiChuLi": "Обработать позже",
    "QingQueRenGaiBiTuiKuanXianXiaYiWanChengDengJi": "Убедитесь, что данный возврат внесен в отчёт регистра",
    "QingShuRuFenXiaoShangMingCheng": "Введите ФИО дилера",
    "DingDanQingDan": "Список товаров в заказе",
    "RuKuDengJi": "Учет поступлений на склад",
    "QueRenHuoWuRuKuShiJian": "Подтвердите время поступления товара на склад",
    "RuKuShiJian": "Время прихода на склад",
    "ShenHeJieGuo": "Результат проверки",
    "ShenHeTongGuo": "Заявка одобрена",
    "QianZaiCaiGouShang1": "Наглядное сравнение цен в одном email.",
    "QianZaiCaiGouShang2": "Нам есть чем удивить!",
    "QianZaiCaiGouShang3": "Тут вы можете оставить свои контакты и мы свяжемся с Вами в ближайшее время.",
    "QianZaiCaiGouShang4": "Отправить",
    "QianZaiCaiGouShang5": "Заказать обратный звонок",
    "QianZaiCaiGouShang6": "Введите Ваш номер телефона, привязанный к WhatsApp/Telegram",
    "ShangChuanBaoJiaLogo": "上传报价LOGO",
    "QianZaiCaiGouShang7": "Введите логин",
    "QingShuRuShenHeJieGuo": "Введите результат проверки",
    "GangGangBoFang": " только что проиграли",
    "XuanPin": "Добавить в корзину",
    "YiYouGuanZhu": "{0}Подписчиков",
    "GouWuCheYiYouWaiXiang": "Сейчас в корзине имеется {0} шт. {0} арт. Заменить количество на прежнее?",
    "QuanXianXinXi": "Информация о полномочиях",
    "ShiJiQueShao/SunHuaiDeShuLiangBuNengDaYuXiaDanShuLiang": "Фактическое недостающее/поврежденное кол-во товара не может быть больше, чем заказанное кол-во товара",
    "MaiGuiTuiKuan": "Компенсация по Гарантии оптимальной цены",
    "WanDaoTuiKuan": "Компенсация за задержку поставки",
    "PoSunTuiKuan": "Компенсация по Гарантии качества",
    "QingShangChuanPingZheng": "Загрузите доказательства",
    "QiTaGongHuoShangJiaGe": "Цена у других поставщиков",
    "DingDanYiWanDaoNTianYu": "Заказ был задержан на {0} дней, ориентировочная сумма компенсации {1}",
    "ShenHeTongGuoDengDaiPeiFu": "Заявка одобрена, ожидайте компенсацию",
    "NinDePeiChangKuanJiangZaiXiaYiGeGong": "Ваша компенсация будет зачислена на Ваш баланс в течение 1 рабочего деня в размере {0}",
    "QingShuRuKeHuBianMa": "Введите номер клиента",
    "PoSuiBiPei": "Гарантия качества",
    "BuZhiChiGaiGeShiShangChuan": "Загрузка в этом формате в настоящее время не поддерживается",
    "HuoWuJinE": "Сумма оплаты за товары",
    "PeiFuBiLi": "Коэффициент компенсации",
    "ZongGongNGeXiangMu": "Всего {0} разделов",
    "DingDanWanDaoShiJianChaoGhuNian": "Заказы, задержанные менее чем на 20-ть дней, не компенсируются",
    "NinDePeiChangKuanJiangZaiXiaYiGeGong2": "Ваша компенсация {0} будет зачислена на Ваш кошелек на следующий рабочий день после оплаты закрывающего платежа",
    "CLAIM_DAMAGE_120": "Проверка не может быть одобрена, потому что товар был отменен по причине лицензии или во время формирования заказа,",
    "DaiRuKu": "Ожидание поступления на склад",
    "YiRuKu": "Принято на склад",
    "QingShuRuDingDanHao": "Введите номер заказа",
    "XiaoShouTongJiBiao": "Статистика продаж",
    "CLAIM_DAMAGE_100": "Заказа не существует",
    "CLAIM_DAMAGE_101": "Заявка на компенсацию уже подана. Пожалуйста, не повторяйте заявку",
    "CLAIM_DAMAGE_102": "К сожалению, Ваш срок подачи заявки истек",
    "CLAIM_DAMAGE_103": "Данный заказ еще не был Вам отгружен со склада. Заявка не может быть оформлена раньше приёма товара.",
    "CLAIM_DAMAGE_104": "Срок задержки поставки заказа менее 20-ти дней",
    "CLAIM_DAMAGE_105": "Поле \"Доказательства\" не может быть пустым",
    "CLAIM_DAMAGE_106": "Максимальное кол-во доказательств 5 шт.",
    "CLAIM_DAMAGE_107": "Поле \"Пояснение\" не может быть пустым. Максимальное кол-во букв 600",
    "CLAIM_DAMAGE_108": "Поле \"Контактное лицо\" не может быть пустым",
    "CLAIM_DAMAGE_109": "Контактный телефон не может быть пустым",
    "CLAIM_DAMAGE_110": "Цена у другого канала закупки должна быть больше 0 и меньше цены товара за 1 шт.",
    "CLAIM_DAMAGE_111": "Кол-во сломанного товара привысило общее кол-во товара",
    "CLAIM_DAMAGE_112": "Недопустимые параметры для проблем с товаром",
    "CLAIM_DAMAGE_113": "Статус заказа не находится на рассмотрении",
    "CLAIM_DAMAGE_114": "Ошибка операции",
    "CLAIM_DAMAGE_115": "Недопустимый параметр типа обслуживания",
    "CLAIM_DAMAGE_116": "Заказ обработан. Пожалуйста, не повторяйте операцию",
    "CLAIM_DAMAGE_117": "Заявка на компенсацию отклонена",
    "CLAIM_DAMAGE_118": "Пожалуйста, оплатите депозит прежде чем подать заявку на компенсацию по Гарантии оптимальной цены",
    "CLAIM_DAMAGE_119": "Пожалуйста, оплатите закрывающий платеж прежде чем подавать заявку на компенсацию по \"Гарантии качества\"",
    "ShenQingYiShiXiao": "Заявка недействительна",
    "NinDeShenQinYinShangPinQuXiao": "По причине отмены товара, Ваша заявка на компенсацию по Гарантии оптимальной цены недействительна",
    "DaiShenHe": "Ожидание проверки",
    "YiShenHe": "Рассмотрено",
    "ZhuangGuiShiJian": "Время загрузки в контейнер",
    "ZhaoShangPinJieShao": "汇聚<b>30000+</b>澄海义乌工厂的<b>150万</b>商品，找商品、找工厂、找品牌！一键上传图片，极速识图搜索",
    "KanXinPinJieShao": "看新品，来宜采！每日<b>1000+</b>新品上线，玩具、餐具、文具、节庆用品，各类新品等你来挑",
    "XuanBaoKuanJieShao": "水枪、泡泡、积木、机器人...行业最新最热商品，<b>每周不定时更新</b>，带你掌握流行趋势！",
    "DaoBaoJiaJieShao": "选样池商品可批量导出报价单：英汉俄多语言可选，自行设置加价率，商品信息全，带公司Logo，导出就能直接发给客户做推荐用！",
    "QuXuanYangChi": "去选样池",
    "QuXuanBaoKuan": "去选爆款",
    "QuKanXinPin": "去看新品",
    "QuZhaoYang": "去找样",
    "KanXinPin": "Новинки",
    "zhaoGongChang/PinPai": "Бренды",
    "ShiPinXuanPin": "Видео с фабрик",
    "XuanBaoKuan": "选爆款",
    "DaoBaoJia": "导报价",
    "YiXiangKeCai": "От 1 коробки",
    "GuoNeiZhuanGong": "внутренних продаж",
    "MeiZhouBaoKuan": "Лучшее на этой неделе",
    "XinQiTe": "Специальные новинки",
    "CaiNiXiHuan": "Возможно вам понравится",
    "DingBu": "топ",
    "QuanBuJiaRuXuanPinChi": "Добавить все в корзину образцов",
    "PiLiangXuanPin": "Выбор сыпучих материалов",
    "QuXiaoPiLiang": "取消批量",
    "JiaRuXuanPinChi": "Добавить в корзину образцов",
    "QingXuanZeLeiMuHouZaiJinXingShaiXuan": "Для начала выберите категорию, и затем выберите нужный фильтр",
    "ShiWuYuanReXiao": "Все по 15RMB",
    "GaiYeMianShangPinYiQuanBuJiaRuXuanPinChi": "该页面暂无可加购的商品",
    "QingXianXuanPin": "请先选品",
    "RenQiBaoPin": "Популярные товары, новинки в режиме реального времени",
    "PingJiaZhuanChang": "Специальные предложения по низким ценам ждут вас",
    "ChaoJiXinPin": "Инновационные подборки, которые нельзя пропустить",
    "JingXuanPinPai": "Рекомендации популярных брендов",
    "YinYiQingHeCaiGouWangJiYingXiang": "Недавняя нехватка международных мощностей не позволила организовать логистику в соответствии с графиком.",
    "WuLiuYanQiTiXing": "Совет : для скорейшего производства и отгрузки товара, проверьте всю информацию и оплатите заказ как можно скорее.",
    "ChaKanGuiZe": "Посмотреть правила",
    "DDPStatus40": "Оплата депозита прошла успешно. Ваш заказ планируется к производству. Пожалуйста, следите за уведомлениями о неполадках с заказом",
    "DDPStatus41": "Заказ уже изготовлен и ожидает контроля качества",
    "DDPStatus110": "Закрывающий платёж успешно оплачен, заказ завершён",
    "DDPStatus90": "Ваш заказ отправлен и находится на пути в <D/>",
    "DDPStatus100": "Ваш заказ находится в <D/> Пожалуйста, оплатите закрывающий платёж перед забором заказа.",
    "DDPStatus105": "Ваш заказ уже поступил на <D/> склад, ожидается отгрузка товара",
    "WuLiuXinXi": "Логистическая информация",
    "WuLiuYanQiTiShi": "Недавняя нехватка международных мощностей не позволила организовать логистику в соответствии с графиком, и ожидается, что доставка будет отложена {0} (Первоначальное время: {1})",
    "YiYouHuiN": "С учетом скидки {0}",
    "JiXuChouDan": "Продолжить заказ",
    "ZhaiGouNKeYouHui": "При покупке на {0} скидка {1}",
    "ShangPinBiaoQian": "Тэг товара",
    "NPaiHangBanDiNMin": "{0} рейтинговый список, {1}-е место",
    "NCaiGouBanDan": "{0} ТОП закупок",
    "JinXuanHaoHuoYiWangDaJin": "Лучшие товары в одном месте",
    "ZhaoGongChang": "Найти фабрику",
    "ChongZhi": "Сбросить",
    "QuanBuJieGuo": "Все результаты",
    "NinKeYi": "Вы можете",
    "SKUPinMing": "Наименование SKU",
    "GuanJianZi": "Ключевое слово",
    "ShangJiaRiQi": "Время поступления в продажу",
    "XiaoShouMOQ": "MOQ",
    "BaoZhuangTiJi": "Объем упаковки",
    "Tian": "День",
    "GongChangChanDiQuYu": "Место производства",
    "RenZhengBiaoZhun": "Стандарт сертификации",
    "MeiZhaoDaoNiXiangYaoDeShangPin": "Не нашли нужный товар? Оставьте информацию о товаре или бренде.",
    "ShangPinTeZhengBiaoTi": "Вы можете указать ссылки на товар, данные о поставщиках, характеристики товара, количество деталей и другую информацию, которая поможет найти лучшие условия.",
    "ShuRuNinXiangZhaoDeShangPinTeZheng": "Введите характеристики товара, который Вы ищете",
    "YouXiangBiaoTi": "Введите Вашу почту. Мы сообщим вам о результатах по электронной почте.",
    "ShuRuNinDeYouXiang": "Введите Вашу почту",
    "TuXingYanZhengBiaoTi": "код подтверждения",
    "ShuRuYanZhengMa": "Введите код подтверждения",
    "MeiYouZhaoDaoNinXiangYaoDeShangPinMa": "Не нашли нужный товар?",
    "ShouManQiangGuangLe": "Товар распродан",
    "KuCunBuZu": "Нет в наличии",
    "GaiShangPingXianGouXXiang": "Данный товар в наличии {0} короб.",
    "NinZhangHaoBuFuHeTiaoJian": "Текущая акция доступна только для определенных пользователей, Ваш аккаунт не соответствует требованиям",
    "GaiHuoDongJinXianYouHuiYiDanNinYiXiaDan": "Предложение ограничено одним заказом, Вы уже разместили заказ",
    "GaiHuoDongZhiNengXuanGouXKuanMeiKuanXianGouXXaing": "Данная акция ограничена {0} моделями, каждая модель ограничена {0} короб.",
    "HuoDongYiJieJieSuQingShuaXinYeMian": "Мероприятие в текущем городе закончилось, проверьте описание правил или обновите страницу",
    "NinXuanGouDeShangPingYiQuanBuQiangGuangXiaCiQingZaoDianXiaDan": "Выбранные Вами товары были распроданы, пожалуйста, в следующий раз размещайте заказ пораньше!",
    "NCaiGouBanDan2": "{0}ТОП популярных товаров",
    "JinXuanHaoHuoYiWangDaJin2": "Лучшие товары в одном месте",
    "ReMenSouSuo": "Популярные запросы",
    "MeiYouZhaoDaoXiangGuanShangPin": "Не нашли похожие товары",
    "HuoZheTianXieFanKuiBiaoDan": "Или заполните форму обратной связи",
    "FanKuiGeiKeFu": "Обратиться в Службу поддержки",
    "GaoJiSouSuo": "Расширенный поиск",
    "ShangJiaShiJianShengXu": "Добавленное время ▲",
    "ShangJiaShiJianJinDaoYuan": "По новинкам",
    "GaoJi": "Расширенный",
    "MeiZhaoDaoXiangGuanGongChang": "Похожие фабрики не найдены",
    "NiKeYi": "Вы можете",
    "BenDingDanDe3GeZiDingDanYiDaoHuo": "В настоящее время {0} заказов ожидают оплаты, пожалуйста, оплатите их до получения заказа.",
    "YouHuiYiQiangGuang": "Товар распродан",
    "HuoDongShengYuYouHui": "Оставшиеся скидки на мероприятия",
    "MeiKuanXianZhi": "Лимит на одно изделие",
    "YiYouHui": "Со скидкой",
    "QuJieSuan": "Перейти к оформлению",
    "YiQiangGuang": "Нет в наличии",
    "BuyGoodsTipTitle": "Данных товаров уже нет в наличии. Исключить товары и перейти к оформлению заказа?",
    "NinYouWeiZhiFuDeXinYongHuDingDan": "У вас есть неоплаченные заказы для новых пользователей",
    "QingXianJiaGouShangPin": "Пожалуйста, сначала добавьте товары в корзину",
    "KuCunYouXianJinKuaiXiaDan": "Товар в наличии ограничен, пожалуйста, разместите заказ как можно скорее",
    "ChuKuGuanLi": "Заказы на доставку",
    "DaiChuKu": "Ждет отгрузки со склада",
    "YiChuKu": "Уже отправлен",
    "KeHuBianHao": "Номер клиента",
    "ShouHuoRenXingMing": "ФИО получателя",
    "ShouHuoRenShouJi": "Контактный телефон получателя",
    "DingDanHao": "Номер заказа",
    "PiLiangChuKu": "Отгрузка со склада партией",
    "ChuKuShiJian": "Время отгрузки со склада",
    "CaoZuoRen": "Оператор",
    "ChuKuXiangQing": "Детали отгрузки",
    "QueRenChuKu": "Подтвердить прием товара",
    "AnPaiChuHuo": "Организовать отгрузку",
    "ChuHuo": "Отгрузка со склада",
    "ShengYuZhiFuShiJian": "Оставшееся время оплаты",
    "MeiZhaoDaoXiangGuanShangPin": "Похожие товары не найдены",
    "JiangBenYeShangPinPiLiangJiaRuXuanYangChi": "Добавить все товары на странице в корзину",
    "QuXiaoQuanXuan": "Отменить все",
    "TuiChuPiLiangXuanPin": "Выйти из оптового выбора",
    "JiJiangShouQing": "Скоро будет распродан",
    "KuCun": "В наличии",
    "XinYongHuTeJiaXianHuo": "Товар в наличии по специальной цене",
    "YiJieSuan": "Перейти к оформлению",
    "XinYongHuYouHuiZhuanXiang": "Купоны на скидку",
    "DaiZhiFuQuanKuan": "Ожидание полной оплаты",
    "DinDanJinE": "Сумма заказа",
    "QuanKuan": "Полная оплата",
    "ZhuangTaiShuoMin1": "ESSAONE организует для вас доставку сразу же после полной оплаты.",
    "ZhuangTaiShuoMin2": "Пожалуйста, заберите ваш заказ с нашего склада в Москве в течение 3 дней после оплаты.",
    "ZhuangTaiShuoMin3": "Доставка завершена, заказ выполнен",
    "QuanKuanHeJiN": "Общая полная сумма",
    "SouSuoGongChang": "Поиск поставщиков",
    "YuJiFaHuoShiJian": "Дата забора со склада",
    "KeHuQuXiaoDengJi": "Регистр отмен клиентов",
    "XinZengDengJi": "Добавить",
    "DengJiShiJian": "Время создания",
    "DingDanDanHao": "Номер заказа",
    "DengJiDanHao": "Нет.",
    "DanHao": "Номер",
    "GuanLianDanHao": "Номер заказа",
    "JiXuJieSuan": "Продолжить",
    "CaiGouJia": "Покупная цена",
    "DengJiXinXi": "Регистрационная информация",
    "ZhengChangDengJi": "В хорошем состоянии",
    "PoSunDengJi": "Поврежденные",
    "KeHuQuXiaoDengJiXiangQing": "Подробности",
    "DingDanChuKuXiangQing": "Детали заказа",
    "ShengChengDengJiDan": "Подтвердить",
    "YuanDingDanJinE": "Начальная сумма заказа",
    "GaiHuoDongZhiNengXuanGouXKuanZuiDuoGouMaiXXaing": "Для мероприятия можно приобрести до {0} предметов, {1} внешнюю коробку",
    "QingXianShuRuDingDanHaoChaXun": "Пожалуйста, введите номер заказа для поиска",
    "QingXuanZeQuXiaoYuanYin2": "Пожалуйста, укажите причину отмены",
    "WoMenJiangZaiShouDaoNinDeDing": "3. Заказы будут обработаны только после оплаты",
    "PiLiangChuHuo": "Оптовая поставка",
    "QueRenSuoXuanDingDan": "Подтверждение выбранных {0} заказов",
    "YingFuJinEZongJi": "Платежи",
    "DingDanYuanJia": "Сумма заказа",
    "DengJiZongXiangShuBuNengDaYuDingDanShangPinShu": "Общее кол-во регистрируемых товаров не может быть больше кол-ва товара в заказе",
    "XinZengChengGong": "Добавлено",
    "GaiHuoDongYiJieShu": "Акция закончилась",
    "ChuKu": "Отгрузка",
    "KuCunChaXun": "Поиск товара на складе",
    "GongSiKuCun": "Складское наличие",
    "KeHuKuCun": "Товар клиента на складе",
    "ShangPinZongJi": "Общее кол-во товара",
    "ShangPinZongKuCun": "Общее кол-во товара на складе",
    "ZhengChangKuCun": "Не поврежденные товары",
    "PoSunKuCun": "Поврежденный товар на складе",
    "KeYongKuCun": "Доступный товар на складе",
    "ShengYuKuCun": "Остатки на складе",
    "ZongKuCun": "Общее кол-во товара на складе",
    "ZhengChangXiangShu": "Кол-во не поврежденных товаров",
    "PoSunXiangShu": "Кол-во поврежденных позиций",
    "ShangPinKuanChu": "Кол-во позиций",
    "DingDanXiangQing": "информацию о заказе",
    "ShangPinXiangShu": "Кол-во коробок",
    "NEWBORN_ZONE_006": "Поиск по данному заказу не производится",
    "NEWBORN_ZONE_007": "Этот заказ был зарегистрирован",
    "YiChengGongTiJiaoDingDanQingJiShiZhiFu": "Заказ создан успешно, пожалуйста, оплатите сейчас",
    "GongNXiang": "Всего {0} коробок",
    "MeiKuanXianGou": "Каждая позиция ограничена",
    "ChuKuChengGong": "Успех судоходства",
    "NEWBORN_ZONE_001": "Отмена не может быть произведена до того, как товар не будет принят на склад",
    "NEWBORN_ZONE_002": "Количество отмененных деталей заказа PO (нормальных + нарушенных) не может быть больше, чем общее количество деталей PO",
    "NEWBORN_ZONE_003": "Количество отмененных деталей PO-заказа (нормальный + сломанный) не может быть больше, чем количество блокировки склада",
    "NEWBORN_ZONE_004": "Полная сумма действующего заказа не оплачена, и запись не может быть зарегистрирована.",
    "NEWBORN_ZONE_005": "Введите кол-во коробок отменяемых позиций",
    "ZhiShaoTianXieYiGeShangPinDengJi": "Введите как минимум 1 товар",
    "HeJiYingShouKuan": "Итого к оплате",
    "DingDanJinE": "сумма заказа",
    "DaiShouKuanJinE": "Ожидается к оплате",
    "ZuiJinCuiKuan": "Последние записи",
    "JiLuCuiKuanShiJian": "Ввести время напоминания об оплате",
    "YiXuanZhuanXiangShangPin": "Избранные продукты для мероприятий",
    "QingTianXieYaoQuXiaoShangPinDeXiangShu": "Введите кол-во отмененных коробок",
    "LaoRenGuiZe": "<p>Действующие клиенты -  это пользователи, которые уже ранее размещали заказы на платформе ESSAONE.</p> <p>Все действующие клиенты могут участвовать в “Супер дне” каждый месяц.</p> <p>Все действующие клиенты в месяц могут закупить 5 экспортных коробов товара по специальной цене. Количество позиций и количество оформлений заказа не ограничено.</p> <p>Все товары из специального предложения находятся в наличии на складе, количество товара ограничено.</p> <p>Оплата должна быть произведена в течение 3 дней после оформления заказа на товары из специального предложение. Если оплата не была произведена, то система автоматически отменит заказ.</p> <p>Купоны не могут быть использованы на товары специального предложения.</p>",
    "GouMaiShuLiang": "Кол-во для закупки",
    "LaXinGuiZe": "<p>1.Предложение доступно только для пользователей, которые зарегистрировались на платформе, но еще не размещали заказ.</p> <p>2.Каждый пользователь может получить купоны на скидку или приобрести товар из специального ценового предложения только 1 раз.</p> <p>3.Если пользователь выбрал вариант с купонами на скидку, то он больше не может товар приобрести товар из специального ценового предложения.</p> <p>4.Новый пользователь может закупить не более 3 товаров из специального ценового предложения за один раз, кол-во каждого товара ограничено одним экспортным коробом.</p> <p>5.Все товары из специального ценового предложения находятся в наличии на складе, количество ограничено.</p> <p>6.Оплата должна быть произведена в течение 3 дней после оформления заказа на товары из специального ценового предложение. Если оплата не была произведена, то система автоматически отменит заказ.</p> <p>7.Считается, что пользователь совершил 1 покупку с момента отравления заказа, независимо от того, был ли заказ в конечном итоге отменен.</p> <p>8.Купоны не могут быть использованы на товары специального предложения.</p>",
    "XinRenGuiZe": "<p>1.Предложение доступно только для пользователей, которые зарегистрировались на платформе, но еще не размещали заказ.</p> <p>2.Каждый пользователь может получить купоны на скидку или приобрести товар из специального ценового предложения только 1 раз.</p> <p>3.Если пользователь выбрал вариант с купонами на скидку, то он больше не может товар приобрести товар из специального ценового предложения.</p> <p>4.Новый пользователь может закупить не более 3 товаров из специального ценового предложения за один раз, кол-во каждого товара ограничено одним экспортным коробом.</p> <p>5.Все товары из специального ценового предложения находятся в наличии на складе, количество ограничено.</p> <p>6.Оплата должна быть произведена в течение 3 дней после оформления заказа на товары из специального ценового предложение. Если оплата не была произведена, то система автоматически отменит заказ.</p> <p>7.Считается, что пользователь совершил 1 покупку с момента отравления заказа, независимо от того, был ли заказ в конечном итоге отменен.</p> <p>8.Купоны не могут быть использованы на товары специального предложения.</p>",
    "JiaGeShengXu": "Сортировать по цене от низкой к высокой",
    "JiaGeJiangXu": "Сортировать по цене от высокой к низкой",
    "HuoQiShengXu": "По Дата поставки",
    "HuoQiJiangXu": "Дата поставки ▼",
    "NEWBORN_ZONE_008": "Пожалуйста, свяжитесь с администратором, если есть исключение из обработки",
    "CanShengTuiKuan": "Возврат",
    "CangKuGuanLi": "Управление складом",
    "ChuKuDan": "Отгрузки",
    "ChuKuWuLiuXinXi": "Отслеживание отгрузок",
    "CuiWeiKuan": "Напоминание об оплате",
    "QuXiaoDengJi": "Регистр отмен",
    "ZhuanGuanShiJian": "Транзитное время",
    "TiJiaoHouNinDeDingDanJiaGeJiangShouDaoJiaGeBaoHuYu2": "2. Пожалуйста, оплатите заказ в течение 3-х дней, иначе заказ автоматически отменится",
    "RenQiShengXu": "Редко выбирают",
    "RenQiJiangXu": "Популярное",
    "GouWuCheWuShangPinKeXiaDan": "Нет товаров в корзине, невозможно оформить заказ",
    "YiTuiKuanBingGengXinDingDanJine": "Заказ вызвал возврат средств, и сумма была обновлена",
    "GongXiHuoDe": "Поздравления с получением",
    "PinPaiZhuanShuYouHuiQuan": "Эксклюзивные купоны на бренд",
    "LingYongChengGong": "Успешно использован",
    "LingYongShiBai": "Запрос не прошел, попробуйте еще раз",
    "LingYong": "Получать",
    "YiLingYong": "Получено",
    "YiLingWan": "Законченный",
    "YiZiDongShiYongZuiYouYouHuiQuan": "Самый лучший купон был использован автоматически, и сумма скидки будет вычтена при окончательной оплате.",
    "ChaKanQuanBuYouHuiQuan": "Посмотреть все купоны",
    "DingDanHeJi": "Итого по заказу",
    "YouHuiQuanGuiZeShuoMing": "Правил купонов",
    "HuoKuanHeJi": "Итого",
    "XinYongHuZhuCeLuoDiYeShuoMing1": "Новые пользователи регистрируются, чтобы получить 6 купонов (на общую сумму 1500 долларов США)",
    "XinYongHuZhuCeLuoDiYeShuoMing2": "Покупка товаров для оформления заказа",
    "XinYongHuZhuCeLuoDiYeShuoMing3": "Вы можете использовать купон, если соответствуете условиям использования купона, а сумма скидки будет автоматически рассчитана в конце заказа.",
    "XinYongHuZhuCeLuoDiYeShuoMing4": "Для одного заказа можно использовать только один купон",
    "HaiChaJiKeShiYongYouHuiJuanJian": "Если у вас еще есть {0}, вы можете использовать купон для уменьшения {1}",
    "ShangPinJinE": "Итого по товарам",
    "KeYouHui": "Ожидается скидка",
    "ZhiDingKeYong": "Указанный тип контейнера доступен",
    "DangQianDingDanYiShiYongManXiangZheYuJiKeYouHui": "{0} был использован для текущего заказа, скидка {2} для заказов на сумму более {1}, ожидается, что скидки составят {3}",
    "DangQianDingDanYiShiYongManJianYuJiKeYouHui": "В текущем заказе использовано {0}, полное {1} минус {2}, ожидается, что на него будет действовать скидка {3}",
    "HaiChaJiKeShiYongYouHuiJuanXiangZhe": "Вы можете использовать купон для получения скидки {1}, если у вас еще есть {0}",
    "XinShouZhiYin1": "Политика конфиденциальности и защиты информации ESSA",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong1": "Основные правила применения скидочного купона:",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong2": "1. На платформе ESSAONE проводятся специальные акции в которых можно получить скидочные купоны, такие купоны можно будет использовать только на платформе ESSA.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong3": "2.На данный момент существуют два вида купонов: Скидочный купон и денежный купон.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong4": "3. Как получить купон: 1) После регистрации на платформе, 2) После авторизации на платформе, 3) После оформления заказа 4) За участие в акциях;",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong5": "4. Для каждого заказа можно использовать только один купон, каждый из купонов можно использовать только один раз. Внимательно ознакомьтесь с инструкцией по применению купона во время проведения акции.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong6": "5. Если Ваш заказ был полностью отменен, то купон будет возвращен.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong7": "6. Купоны нельзя обменять, продать или передать другому пользователю.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong8": "Правила использования купона:",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong9": "1.Купон на все товары: Купоны можно использовать на все товары предоставленные на платформе без каких-либо пользовательских, товарных и территориальных ограничений. Купон можно использовать, если стоимость заказа соответсвует требованиям купона. На каждый заказ можно использовать только один купон, сумма скидки будет вычтена из общей стоимости заказа.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong10": "2. Купон на определеную категорию: данный купон можно использовать только на покупку товара из определенной категории. На каждый заказ можно использовать только один купон, сумма скидки будет вычтена из общей стоимости заказа.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong11": "Например: На категорию «Детские игрушки» есть скидка 5%, значит купон можно \tиспользовать только если в Вашем заказе присутствует товар из категории «Детские игрушки» и общая стоимость этого товара соответсвует требованиям купона.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong12": "3. Купон на товар из «ограниченного предложения»: Данный купон можно использовать только на покупку товара из определенного списка. На каждый заказ можно использовать только один купон, сумма скидки будет вычтена из общей стоимости товара из «ограниченного предложения» в заказе.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong13": "Например: скидку на покупку товара из «ограниченного предложения» на 1000$ можно использовать только в том случае, если в Вашем заказе присутствует товар из «ограниченного предложения» и общая стоимость этого товара соответсвует требованиям купона.",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong14": "4. Подарочный купон нового клиента: Данный купон могут использовать только новые клиенты платформы ESSA. Новые клиенты это те клиенты, которые еще не оформляли заказ на платформе. Купон можно использовать, если стоимость заказа соответсвует требованиям купона.",
    "DingDanShangPinYinNiDeTiaoZheng": "Из-за вашей настройки продукт заказа ( отказ, перекинуть товар в ПО до другое ПО,  больше не удовлетворяет использование купонов. Пожалуйста делаете дозаказ или перекинуть туда товары в другой ПО, для выполнения условий купона.",
    "YouHuiQu": "Купон",
    "WeiManZuTiaoJian": "Условия использования не соблюдены",
    "sili1": "广东**贸易有限公司成立于1989年，是一家专注于**产品外贸的企业，公司设立于**地区，实力雄厚，积累了众多优质海外客户，长期耕耘**地区市场，拥有**个专业外语员工，获得客户多次优秀评价。",
    "sili2": "本公司已经营3年，积累众多优质客户，订单多。2021年度，向奥**钻玩具工厂下了一个大单，10款商品，金额超过10万元； 同时与某某工厂、某某工厂进行深度合作。",
    "ReMaiDanPin": "Горячие хиты",
    "YiLingQuChengGongQingWuChongFuLingQu": "Получен. Пожалуйста, не повторяйте действие снова",
    "ZhiDingNGePinPaiKeYong": "Указывать {0} доступные бренды",
    "DangQianDingDanYiShiYongManXiangZheYuJiKeYouHui_NEW": "В текущем заказе использовался купон, встречайте {0}, получите скидку {1}, ожидается экономия {2}.",
    "DangQianDingDanYiShiYongManJianYuJiKeYouHui_NEW": "В текущем заказе использовался купон, встречайте {0}, можно уменьшить на {1}, ожидается экономия {2}.",
    "ZaiMaiKeYouHuiJinE": "Купите еще {0} и получите скидку {1}",
    "HaiChaTiJiJiKeShiYongYouHuiJuanJian": "Не хватает объем {0}, потом вы можете использовать купон для уменьшения {1}",
    "HaiChaTiJiJiKeShiYongYouHuiJuanXiangZhe": "Не хватает объем {0}, потом вы можете использовать купон для скидку {1}",
    "HeTongZhuangTai": "Статус договора",
    "ChaKanHeTong": "Посмотреть договор",
    "JieShuHeTong": "Расторгнуть договор",
    "HeTongBianJi": "Редактировать договор:",
    "QianDingRiQi": "Дата подписания",
    "HeTongWenJian": "Файл договора",
    "DianJiHuoJiangWenJianTuoZhuaiDaoZheLiShangChuan": "Нажмите или перетащите сюда файлы для загрузки",
    "ZhiChiKuoZhanMing": "Поддерживаемые форматы файлов",
    "ShuRuSouSuo": "Ввести поиск:",
    "FuKuanPingZheng": "Счет на оплату",
    "WeiFuKuanPingZheng": "Неоплаченные счета",
    "YiFuKuanPingZheng": "Оплаченные счета",
    "PingZhengLeiXing": "Тип документа",
    "YingFuZongJinE": "Итоговая сумма к оплате",
    "FuKuanPingZhengShengChengShiJian": "Время формирования счета на оплату",
    "ChaKanFuKuanPingZheng": "Посмотреть счет на оплату",
    "ShouKuanShouJu": "Счет на оплату",
    "ZanWuWenJian": "Нет файла",
    "QingShuRuPODanHaoHuoZheJiGuiDanHao": "Введите номер заказа или номер контейнера",
    "XinZengHeTong": "Добавить договор",
    "HeTongQiXian": "Срок договора",
    "HeTongJieShuRiZi": "Дата расторжения договора",
    "HeTongBianMa": "Номер договора",
    "HeTongYiCunZai": "Договор уже есть",
    "HeTongGuanLi": "Договор",
    "WangZhanDiTu": "Карта сайта",
    "XinWenZhongXin": "Полезная информация",
    "WeiWanShanWuFaJiaGou": "未完善无法加购",
    "ZheGeGongChangHenJiuMeiShang": "这个工厂很久没上新品了。",
    "Jin3TianYongHuHangWei": "Поведение пользователя за последние 3 дня",
    "Jin3TianDengLuTianShu": "Дни входа в площадку за последние 3 дня",
    "Jin3TianLiuLanXiangQingShangPinKuanShu": "Просмотр детализации количества товаров за последние 3 дня",
    "Jin3TianJiaGouKuanShu": "Количества добавленых товаров в корзину за последние 3 дня",
    "QuanBuXinWen": "Все новости",
    "ShangYiPian": "Предыдущий",
    "XiaYiPian": "Следующий",
    "30TianMianFeiCangChu": "30 дней бесплатного складского хранения",
    "YiChangHaoShiPaiXu": "По времени",
    "YiChangShangPinShu": "Кол-во позиций с неполадками",
    "ChaKanYiChang": "Посмотреть",
    "YiChangShiJian": "Дата возникновения неполадок",
    "YiChangHaoShi": "Прошло времени",
    "QianZaiKeHuDengJiDanChuangBiaoTi": "Зарегистрируйтесь и получите 1500 USD",
    "BaoGuanTieZhiGuanLi": "Таможенное  оформление",
    "QinQuanQueRen": "Подтверждение авторских прав",
    "QinQuanShenHe": "Подтверждение проверки АП",
    "TianXieHaiGuanBianMa": "Введите Код ТН ВЭД ЕАЭС",
    "ZhengShuShenHe": "Доп проверка СС к товарам",
    "SheZhiTieZhiPinPai": "Подготовка стикеров",
    "WuZhengShuGuanLi": "Товары без сертификатов",
    "DingDanTiJiaoShiZhang": "Bремя ожидания (ч:мин)",
    "ShangPinShu": "Кол-во позиций",
    "HaiGuanBianMa": "Код ТН ВЭД ЕАЭС",
    "ShangChuan2": "загрузка",
    "BaoGuanPinMingJinDuGenZong": "Процесс подготовки стикеров",
    "DingDanShiJian": "Время заказа",
    "YouZhengShu": "Есть сертификат",
    "WuZhengShu": "Нет сертификата",
    "certificateEncoding": "Номер сертификата",
    "ZuiJinShenHeShiJian": "Последние время рассмотрения",
    "ShangYiJiShenHeRen": "Передать предыдущему менеджеру",
    "ShenHeShiJian": "Время рассмотрения",
    "TieZhiMoBan": "Тип стикера",
    "PinMing": "Рус. Наименование на платформе",
    "TieZhiPinMing": "Наименование в стикере",
    "QingTianXieWuZhengShuShuoMing": "Заполните пояснение",
    "XuanZeTieZhiMoBan": "Выберите тип стикера",
    "ChaKanYingWenPinMing": "Посмотреть Англ. наименование",
    "ChaKanEWenPinMing": "Название на русском",
    "WuZhengShuShangPin": "Товары без сертификатов",
    "ShenHeRen": "Подтвердившее лицо",
    "ShangPinJiangYuHouGuXiaoCaiGou": "Товары будут отменены через <b>{0}</b>",
    "DangQianJieDian": "Статус",
    "DangQianChuLiRen": "Менеджер",
    "LiKaiDangQianYeHouSuoBianJiDeShuJuJiangBuKeHuiFu": "Данные, отредактированные после выхода с текущей страницы, не будут восстановлены",
    "DaiChuLi": "В процессе подтверждения",
    "ZhengChang": "Подтвердить товар",
    "QinQuan": "Нарушение авторских прав",
    "ShangYiGe": "Следующий",
    "XiaYiGe": "Предыдущий",
    "BuQinQuan": "Нет нарушений",
    "QueRenXiaYiGe": "Нарушение авторских прав",
    "XiaYiDan": " Следующий лист",
    "GaiDingDanQuanBuShangPinYiChuLi": "Все товары в этом заказе были обработаны",
    "QingTianXieWeiShuDeHaiGuanBianMa": "Пожалуйста, введите {0} - значный таможенный код",
    "NaShuiRenDengJiDaiMa": "КПП",
    "YinHangDaiMa": "№ корреспондентского счета",
    "ZuiJinChuLiShiJian": "Последнее время обработки",
    "LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu": "После выхода с текущей страницы отредактированные данные не будут восстановлены",
    "QinQuanShangPinShu": "Количество товаров с нарушением",
    "QingQueRenShiFouDuiXuanZeDeShangPinQuXiaoCaiGou": "Пожалуйста, подтвердите отмену выбранного товара",
    "QingXuanZeShangPinHouZaiDaoChu": "Пожалуйста, выберите товары для экспорта",
    "DangQianWuKeXiaZaiShangPin": "Невозможно скачать товары без сертификата",
    "ShangPinPiPeiShiBai": "Сопоставление товаров не удалось, пожалуйста, проверьте изменения и попробуйте снова.",
    "ShangChuanChuLiJieGuo": "Загрузка результатов обработки",
    "WenJianGeShiBuZhengQue": "Данный формат файлов не поддерживается",
    "QingXuanZeShangPinHouZaiXiaZai": "Пожалуйста, выберите товары перед загрузкой",
    "QingTianXieZhengShuBianMa": "Пожалуйста, введите код сертификата",
    "WeiShu": "Количество",
    "QueRenJieGuo": "Результат проверки",
    "SuoShuLeiMu": "Категории продуктов",
    "QinQuanQueRen2": "Проверка на нарушение авторских прав",
    "TuCaoYiXia": "吐槽一下",
    "ShangShiShiJian": "Дата выпуска",
    "ChuHuoDanGuanLi": "Управление деливери-ордером",
    "YuJiChuHuoDingDan": "Ожидаемая отгрузка",
    "YiChuHuoDingDan": "Отгружено",
    "ZongTiJiM3": "Общий объём m³",
    "XiaZaiLiuMianTu": "Скачать фото с 6 сторон",
    "ChaKanTieZhiPaiBanTu": "Посмотреть фото верстки стикеров",
    "XiaZaiZhiJianTuPian": "Скачать фото товаров для проверки перед погрузкой",
    "BaoZhuangLiuMianTu": "Фото упаковки с 6 сторон 10",
    "ZhuangGuiFaYunShiJian": "Время загрузки в контейнер",
    "ChaKanZhuangGuiTuPian": "Посмотерть фото погрузки",
    "YiChuHuoDingDanYouDaiQueRenDeSuiCheDan": "есть инвойс из заказов с погруженными товарами ждущий подтверждения, скачайте инвойс для подтверждения как можно скорее.",
    "ChuangJianYu": "Создано",
    "QueRenSuiCheDan": "Подтвердить инвойс",
    "ZhongXinShangChuan": "перезагрузить",
    "YuZhuangXiangDan": "Предварительный УЛ",
    "XuanZeBaoBiaoMoBan": "Выбрать шаблон отчета",
    "DingDanGuanLi": "Заказы",
    "KeHuGuanLi": "Управление клиентами",
    "ZanWeiShangChuan": "Пока не загружено",
    "ChuHuoHouQuXiao": "Отмена после погрузки",
    "Jin7TianYouBianHuaDingDan": "Измененные заказы за последние 7 дней",
    "YiChuHuoDingDanYiQueRenSuiCheDan": "Инвойс подтвердили",
    "ChuHuoHouQuXiaoShangPin": "Отмененные позиции после погрузки",
    "DDPStatus101": "Закрывающий платеж уже оплачен",
    "DDPStatus102": "На складе, ожидается окончательная оплата",
    "SuiCheDanQRueRenHouJiangWuFaZaiCiSiuGai": "После подтверждения Инвойса нельзя скорректировать его. Таможенные формальности будут в соответствии с подтвержденным Инвойсом",
    "KeHuGouWuChe": "Корзина клиента",
    "KeHuDingDan": "Заказы клиента",
    "ZongGongNKuanNXiang": "Всего {0} товаров，{1} коробок",
    "DaiTiHuo": "Ожидается отгрузка товара",
    "YuJiChuHuoDingDanXiangQing": "Подробности ожидаемых заказов к погрузке",
    "CLAIM_DAMAGE_012": "После выполнения трансферных операций при пересечении границы, заказы будут зарегистрированы на складе",
    "ShangPinBianMa2": "Код товара",
    "Jin3TianYouBianHuaDingDan": "Измененные заказы за последние 3 дня",
    "PODingDan": "Номер PO",
    "WanChengShiJian": "Время завершения",
    "YuJiChuHuoShiJian": "Ориентировочная дата загрузки",
    "DaiQueRenSuiCheDan": "Ожидается подтверждение Инвойса",
    "YiChuHuoDingDanXiangQing": "Подробности",
    "QingShuRuJiGuiDanHaoHuoKeHuBianHao": "Введите номер инвойса или номер клиента",
    "ShangPinShengChanYaoQiu": "Требования к производству",
    "DingDanTieZhiXinXi": "Информация о стикере",
    "TieZhiPaiBan": "Макет стикера",
    "GongZhangTieZhiPaiBanTu": "Всего {0} изображений макета стикера",
    "XiaZaiPaiBanTu": "Скачать макет",
    "PaiBanYouWenTi": "Проблема с набором текста",
    "QueRenWuWu": "Подтвердите правильность",
    "MiaoShuNiDeWenTi": "Опишите вашу проблему",
    "QuanBuYiJianCha": "Проверка завершена, подтверждаете?",
    "ShangPinDanDuTieZhi": "Товар имеет индивидуальный стикер,  стоимость стикера оплачивается отдельно",
    "MaTouYaoQiu": "Отметить требования",
    "MiaoShuPaiBanCunZaiWenTi": "Существует проблема с макетом описания",
    "ZanBuSheZhi": "Еще не установлено",
    "QueRenBianGeng": "Подтвердить изменения",
    "BeiZhuDingDanGeXingHuaYaoQiu": "Пояснения к требованиям к персонализации заказа",
    "GongChangJiangAnZhaoNinDeYaoQiuGenJinShengChan": "Например: технические характеристики батареи, требования к упаковке и т.д. Требования к упаковке и другие меры предосторожности, касающиеся производственного процесса товара, фабрика будет следить за производством в соответствии с Вашими требованиями",
    "TeBieYaoQiu": "Особые требования к документации, контролю качества и загрузке контейнера",
    "ShangPinQingDan": "Перечень товаров",
    "QingZaiTianNeiZhiFuDingJin": "Пожалуйста, оплатите депозит в течение {0} дней и подтвердите заказ.",
    "ShangChuanWenJianYaoQiu": "Поддерживает {0}, максимальная поддерживает {1}",
    "PaiBanYouWenTiYiFanKui": "Существует проблема с набором текста: была дана обратная связь",
    "CHANGE_SALE_PO_ITEM_PRODUCT_REQUIRE_ERROR": "Заказ находится в производстве, если вам нужно внести изменения, пожалуйста, свяжитесь с продавцом",
    "GongNZhangTieZhiPaiBanTu": "Всего {0} изображений макета стикера.",
    "ShanɡPinShenɡChanYaoQiu": "Требования к производству",
    "HuoQuZiXun": "Получить консультацию",
    "LiuXiaNiDeLianXiFangShi": "Оставьте свои контактные данные, чтобы мы смогли выслать вам подборку лучших товаров.",
    "YiXiangCaiGouXiangShu": "Количество коробок",
    "QiWangJiaGe": "Ожидаемая цена",
    "BiGongChangBaoJiaJiangJia": "Цена снижена на {0} по сравнению с заводской ценой",
    "ChaKanDianHua": "Проверить телефон",
    "ZhongXinHuoQu": "Повторно получить",
    "JinTianQianBoDaYouXiao": "今天{0}前拨打有效",
    "YiChaoShiShiXiao": "Время действия истекло",
    "Zhuan": "转",
    "YinSiHao": "Личный номер",
    "ZhuCeESSAONEBiaoTi": "Регистрация",
    "DuanXinYanZhengMa": "Код из SMS",
    "QingShuRuDuanXinYanZhengMa": "Введите код из SMS",
    "TianXieGengDuo": "Показать больше",
    "GongSiXinXiZhiYongYuYanZheng": "Информация о компании используется только в целях проверки, ваши данные в безопасности",
    "LianXiZaiXianKeFu": "Связаться со службой поддержки",
    "QingShuRuDianZiYouJian": "Пожалуйста, введите электронную почту",
    "QingXuanZeQuYu": "Страна",
    "DiYuGongChangZuiXiaoCaiGouShuLiang": "Количество коробок в вашем заказе меньше, чем требует производитель, он может не принять ваш заказ.",
    "DiYuMOQ": "Меньше, чем необходимый MOQ",
    "ZhengZaiXiangGongChangQueRenShengChanYaoQiu": "Требования к производству подтверждаются заводом,  вы сможете разместить заказ после того, как завод подтвердит его",
    "NiDeZhangHuShangWeiRenZheng": "Вы не можете разместить заказ, так как ваш аккаунт не прошел аутентификацию",
    "MaShangQuWanShan": "Заполните данные прямо сейчас",
    "XuYaoBangZhuMa": "Нужна помощь?",
    "RuGuoNiYouRenHeWenTiXuYaoBanZhu": "Если у вас возникли вопросы и вам нужна помощь, оставьте свой номер телефона, и мы свяжемся с вами и ответим на ваши вопросы",
    "ZhaoBuDaoShangPin": "Не можете найти товар?",
    "LiuXiaNiDeDianHua": "Оставьте свой номер телефона, и служба поддержки свяжется с вами, чтобы помочь решить вашу проблему, или позвоните нам 8-800-550-3301",
    "YiTuSouSuo": "Визуальный поиск",
    "ChaKanGongChang": "Посмотреть завод",
    "GaiShangPinYouShengChanJiaoFu": "Этот товар был произведен и доставлен компанией {0}",
    "2ZhouNianHuoDongGuiZe": "1. Время проведения: с 11 мая 2022 года по 11 июня 2022 года. <br /> 2. Все зарегистрированные пользователи на ESSAONE (новые и существующие пользователи) имеют право участвовать в этой акции. <br /> 3. Каждый пользователь может воспользоваться скидкой 3,3% только один раз в течение периода акции, т.е. скидку можно применить только к 1 заказу. Скидка не может быть применена к акционным товарам и не суммируется с другими акциями и купонами. <br /> 4. Если в период проведения акции накопленная сумма, уплаченная за заказ, достигнет требуемой суммы, 12 июня наш сайт предложит дополнительный купон на наибольшую скидку тем, кто соответствует усливиям. <br /> 1）Накопление фактической суммы платежа. <br /> <span style=\"margin-left:24px\">• Если сумма всех ваших заказов за период проведения акции составила:</span> <br /> <span style=\"margin-left:24px\">• более 100 000 рублей, вы получаете купон номиналом 2000 рублей.</span>   <br /> <span style=\"margin-left:24px\">• более 500 000 рублей, вы получаете купон номиналом 6000 рублей.</span>   <br /> <span style=\"margin-left:24px\">• более 1 000 000 рублей, вы получаете купон номиналом 10 000 рублей. </span> <br /> 2）Один покупатель может получить только один купон. Купоны действуют при покупке от 20 000 рублей. <br /> 3）Купон будет действителен с 12 июня по 12 июля 2022 г. и истечет после этого периода. <br /> 5. Полученные купоны можно посмотреть в личном кабинете, в разделе «Мои купоны».  <br /> 6. По любым вопросам, связанным с акцией, можно обратиться в онлайн-службу поддержки клиентов. Право интерпретировать событие принадлежит ESSAONE.",
    "DingDanXiangGuanYaoQiu": "Требование к заказу",
    "NiKeYiChangShiJiaRuGouWuCheDingGouYiXiang": "Вы можете добавить позицию в корзину и заказать одну коробку.",
    "MiMaTiShi": "Требования к паролю",
    "ZiMuYuShuZiZhuHe": "Сочетание букв и цифр, а не только цифр.",
    "ZiShaoNGeZiFu": "Не менее {0} символов",
    "YanZhengYouJianYiFaSongDaoYouXiang2": "Письмо со ссылкой для подтверждения отправлено на почту {0} для завершения регистрации.",
    "DianJiJiangTongBu": "Нажав на кнопку (Мне нужна цитата), вы одновременно сообщите торговой компании, что хотите купить товар и количество, которое вы хотите купить.",
    "WoYaoXunJia": "Мне нужна цитата",
    "QuanBuXunJia": "Запрос предложения для всех продуктов",
    "DaoChuTuPian": "Скачать изображения продукции",
    "ShangPinShuLiang": "Количество продуктов",
    "TuiJianZhuTiMingCheng": "Поиск по названию темы",
    "QingShuRuFangWenMiMa": "Введите код доступа",
    "FanHuiLiShiLieBiao": "Назад к списку",
    "XiaoShou": "консультант по продажам",
    "TongZhiChengGong": "Отправлено успешно",
    "YiGaoZhiMaoYiGongSi": "Продавец-консультант был проинформирован о товаре и количестве приобретенного товара.",
    "WoDeTuiGuang": "Мои привлеченные клиенты",
    "TuiGuangYaoQingJiaoCheng": "Обучающий курс по привлечению клиентов",
    "ZhangHuZiLiaoWeiWanShan": "Данные учетной записи не заполнены, вы не можете привлекать клиентов.",
    "LiJiQuWanShanZhuanQuTiCheng": "Заполните учетную запись, чтобы получать вознаграждение",
    "TuiGuangKeHuNaTiCheng": "Привлекайте и мотивируйте клиентов к заказу на сайте ESSAONE.Получайте денежное вознаграждение за каждый заказ",
    "TuiGuangKeHuNaTiChengJieShaoNeiRong": "Привлекайте клиентов в различных регионах России, география не имеет значение и получайте гарантированное вознаграждение за каждый заказ.Развивайте электронную коммерцию вместе с ESSAONE — получайте реальный доход",
    "FaSongNiDeZhuanShuLianJieGeiKeHu": "Отправьте клиентам вашу уникальную ссылку",
    "ShouJiDuanFenXiang": "Поделиться по телефону",
    "KeHuZhuCeShiTianXieNiDeYaoQingMa": "Клиентам необходимо ввести ваш рекомендуемый код приглашения при регистрации",
    "FaZhanFenXiaoShangNaTiCheng": "Получите вознаграждение за развитие дилерской сети",
    "FaZhanFenXiaoShangNaTiChengJieShaoNeiRong": "Условия получения вознаграждения за развитие дилерской сети",
    "ChaKanFenXiaoShang": "Просмотреть дилера",
    "XinZengFenXiaoShang": "Добавить дилера",
    "QingXianWanShanZiLiaoQuBuChong": "Сначала заполните профиль, перейти к заполнению >>",
    "MoRenNiDeShouJiHaoMa": "Подтвердите номер телефона",
    "BenZhouYuJiShouRu": "Прогнозируемый доход за неделю",
    "YaoQingKeHuShouRu": "Вознаграждение за привлечение клиентов",
    "XiaJiFenXiaoShangYaoQingKeHuHuoDeShouRu": "Вознаграждение за привлечение клиентов дилерами нижнего уровня",
    "DaiJieSuan": "К выплате",
    "LeiJiYiJieSuan": "Всего выпплачено",
    "BianJiZhangHaoXinXi": "Редактировать данные учетной записи",
    "ShiYongShouJiSaoMiao": "Отсканируйте код, поделитесь вашей ссылкой для регистрации",
    "ChaKanJiaoCheng": "Посмотреть обучающий курс",
    "FaSongYaoQingLianJieYaoQingKeHuZhuCe": "Отправьте ссылку-приглашение, Вы получите вознаграждение после регистрации клиента и подтверждения аккаунта системой. Кроме того, Вы можете развивать дилерскую сеть нижнего уровня и также получать вознаграждение.",
    "MeiZhouSanQianShenQingDeTiXianShenQing": "Заявки на выплату вознаграждений, поданные до среды текущей недели, будут перечислены Вам к следующей среде. В случае праздников возможны задержки. Если у Вас есть вопросы, пожалуйста, обратитесь в службу поддержки клиентов.",
    "YaoQingHaoYouXinXiI": "Привлеченные Вами новые клиенты будут привязаны к Вашему аккаунту только в том случае, если они зарегистрируются по Вашей уникальной ссылке либо введут Ваш код приглашения при регистрации - только таким образом Вы сможете получить вознаграждение за успешную регистрацию новых клиентов.",
    "YaoQingHaoYouXinXiK": "Окончательная сумма вознаграждения, которую Вы получите, зависит от успешной регистрации ваших клиентов и подтверждения их аккаунта",
    "TongGuoYaoQingYouXiaoZhuCeYongHuHuoDeTiCheng": "Получение вознаграждения за приглашение новых клиентов и подтверждение аккаунта",
    "TongGuoYaoQingYouXiaoZhuCeYongHuHuoDeTiChengJieShaoNeiRong": "1. Пригласите друзей зарегистрироваться, и Вы получите бонус в размере 2000 рублей за человека после успешной регистрации и подтверждения данных. 2. Пригласите дистрибьюторов, и они помогут Вам заработать деньги! Дистрибьюторы, чьи клиенты успешно зарегистрируются и подтвердят свои данные, получат вознаграждение в размере 2000 рублей за каждого человека, а Вы получите по 500 рублей.",
    "TongGuoFaZhanFenXiaoShangHuoDeTiCheng": "Получение вознаграждения за развитие дилерской сети",
    "TongGuoFaZhanFenXiaoShangHuoDeTiChengJieShaoNeiRong": "Информация о получении комиссии через развитие дистрибьюторов",
    "JieSuanZhong": "Получение выплаты",
    "YiTiJiaoTiXianShenQingZhengDengDaiPingTaoHuiKuan": "Запрос на получение выплаты направлен, ожидается перечисление средств с платформы",
    "YaoQingDeKeHu": "Привлеченные клиенты",
    "KeHuZhangTai": "Статус клиента",
    "LeiJiYaoQingRenYiRenZhengTongGuoRenHuoDeTiCheng": "Всего привлечено {0} клиентов, количество подтвержденных аккаунтов {1}, вознаграждение {2}.",
    "XiaJiFenXiaoShang": "Дилеры нижнего уровня",
    "CaiGouShangRenZhengZhuangTai": "Статус сертификации покупателя",
    "QingXuanZeCaiGouShangRenZhengZhuangTai": "Пожалуйста, выберите статус сертификации покупателя",
    "YaoQingKeHuShu": "Количество привлеченных клиентов",
    "LeiJiJiangLi": "Кумулятивные премии",
    "Nan": "М",
    "Nu": "Ж",
    "ShiLi": "Пример",
    "QingShuRuDengLuMingZi": "Пожалуйста, введите логин",
    "ShouRuMingXi": "Детализация доходов",
    "TiXianMingXi": "Детализация выплат",
    "TiXianXianJin": "Сумма выплат",
    "YinHangKaXinXi2": "Данные банковской карты",
    "YinHangKaXinXiShuoMing": "Пожалуйста, правдиво заполните данные вашей банковской карты. Вознаграждение будет перечислено на этот банковский счет.",
    "XiuGaiDengLuMiMa": "Изменить пароль для входа",
    "QueRenTiXian": "Подтвердить выплату",
    "RuGuoYouWuQingJiShiGengXin": "Если данные не верны, пожалуйста, обновите",
    "QuXiuGai": "Изменить",
    "QuBuChong": "Дополнить",
    "HaiMeiYouZhangHuXingXi": "Нет информации об аккаунте",
    "ShouJiDengLuMing": "Мобильный телефон (логин)",
    "ChuShiMiMa": "Пароль для входа в систему",
    "QingXuanZeGuoJia2": "Выберите страну",
    "JiuMiMa": "Старый пароль",
    "LiuKongBuXiuGaiMiMa": "Если поля не будут заполнены, пароль не будет изменен",
    "FuZhiZhangHaoMiMa": "Копировать номер аккаунта и пароль",
    "FenXiangZhangHao": "Поделиться номером аккаунта",
    "ZanWuQuanXianXinZengFenXiaoShang": "Нет права доступа на добавление новых дилеров",
    "ChengGongYaoQingYiGeKeHuHou": "Только после успешного приглашения одного клиента вы можете получить право доступа на добавление дилера.",
    "XinMiMaBuYiZhi": "Новые пароли не совпадают",
    "FenXiaoShangGuanLi": "Управление дилерами",
    "FenXiaoShangJieSuan": "Выплаты дилерам",
    "TiXianShenQingChengGongQingDengDaiPingTaiJieSuen": "Запрос на выплату средств прошел успешно, подождите, пока платформа перечислит средства",
    "ZuiDaZhiChiShangChuanWenJianYaoQiu": "Максиммум {0}, формат {1}",
    "TuiGuangKeHuShu": "Количество привлеченных клиентов",
    "LeiJiYongJin": "Общая сумма комиссии",
    "TuiJianRen": "Приглашения",
    "LeiXingZhuangTai": "Тип и статус",
    "TuiGuangXiangQing": "Данные по привлечению",
    "XiaoShouQuYu": "Регионы продаж",
    "FenXiaoLeiXing": "Категория дилера",
    "ZhangHuZhuangTai": "Статус аккаунта",
    "YiJieSuan2": "К выплате",
    "FenXiaoShangZhangHao": "Номер аккаунта дилера",
    "DaiJieSuanJinE": "Сумма к выплате",
    "HeXiao": "Списать со счета",
    "ShenQingShiJian": "Время подачи",
    "SouSuoLiuShuiHaoFenXiaoShangZhangHaoXinMing": "Поиск по номеру/номеру аккаунта дилера/имени",
    "TuiHuiShiJian": "Время возврата",
    "YiJieSuanJinE": "Выплаченная сумма",
    "JieSuanShiJian": "Время выплаты",
    "TuiHui": "Возврат",
    "QueRenHeXiaoGaiBiDaiJieSuanMa": "Подтвердить отмену непроизведенной выплаты ?",
    "TuiHuiJieSuanShenQing": "Заявка на возврат платежа",
    "QingGouXuanTuiHuiJieSuanShenQingYuanYin": "Пожалуйста, отметьте причину заявки на возврат платежа",
    "JiuFenXiaoShangTongJi": "Статистика старых дилеров",
    "FenXiaoShangTuiGuangXiangQing": "Детали привлечений дилера",
    "FenXiaoShangChengGongYaoQingKeHuLeiJiJiangLiTiShi": "Дилер успешно привлек клиента, вы получаете вознаграждение.",
    "ShengChengFenXiaoShang": "Добавить дилера",
    "ShengChengChengGong": "Добавлено",
    "FenXiaoShangChengGongYaoQingKeHuLeiJiJiangLiTiShi2": "Дилер успешно привлек клиента и получает вознаграждение.",
    "BianJiZiLiao": "Изменить данные",
    "XiaJiTuiGuangKeHu": "Привлеченный клиент нижнего уровня",
    "AnChangJianShiJianDaoXu": "В порядке убывания по времени создания",
    "AnTuiGuangKeHuShuDaoXu": "Количество привлеченных клиентов",
    "AnTuiGuangKeHuShuShunXu": "Количество привлеченных клиентов",
    "AnXiaJiFenXiaoShangDaoXu": "Количество дилеров нижнего уровня",
    "AnLeiJiYongJinDaoXu": "В порядке убывания по сумме комиссии",
    "AnLeiJiYongJinShunXu": "В порядке возрастания по сумме комиссии",
    "YaoQingKeHu": "Приглашенные клиенты",
    "YouXiaoKeHu": "Активные клиенты",
    "DengTongShouJiHaoMa": "Номер телефона, указанный при регистрации",
    "QingShangChuanFenXiaoShangDeZhengJianZhaoPian": "Пожалуйста, загрузите фотографию удостоверения личности дилера",
    "FenXiaoShangDeYinHangZhangHuXinXiTiShi": "Реквизиты банковского счета дилера - для получения вознаграждений  дилер должен предоставить корректные реквизиты счета.",
    "MiMaGuiZe": "Пожалуйста, введите 6-20 символов - комбинацию из цифр, букв и знаков",
    "ShiFouYaoTingYongGaiFenXiaoShangMa": "Деактивировать данного дилера?",
    "YiTuiHuiJinE": "Сумма возврата",
    "XiaJiYongHuDingDanHaiMeiChuHuo": "Пользователь нижнего уровня  %s заказ еще не отправлен",
    "FenXiaoShangHaiYouDaiJieSuanJieSuanZhongDeJinE": "У дилера есть суммы к выплате/ожидающие выплаты",
    "TuiHuiYuanYin": "Причина возврата",
    "FenXiaoShangXiangQing": "Информация о дилере",
    "ZiJinZhangHaoYiChang": "Аномалии в счетах фондов",
    "TiXianQingQiuYiChang": "Аномалии в заявках на снятие средств",
    "QingShuRuZhengQueDeXiuGaiQianMiMa": "Пожалуйста, введите правильный старый пароль",
    "FenXiaoShangYouDaiJieSuanJinE": "У дилера есть суммы к выплате/ожидающие выплаты",
    "BianJiFenXiaoShang": "Редактировать агента",
    "FenXiaoShangMingChengZhangHao": "Имя агента / номер аккаунта",
    "MiMaGuiZe2": "Введите 6 - 20 символов",
    "QieHuan": "Переключиться на",
    "TuiJianJiLu": "Рекомендуем",
    "TuiJianXiangQing": "Рекомендуемые детали",
    "YaoQingHaoYouXinXiJ": "Ваша окончательная комиссия зависит от успешной регистрации и сертификации новых клиентов.",
    "QingDengDaiWenJianZhengZaiDaBaoZhong": "Пожалуйста, подождите, файлы упаковываются",
    "JianChaZhiJianTuPian": "Проверьте фотографии",
    "ZhiJianTuPianQueRen": "Подтверждение фотографии контроля качества",
    "BiaoJiCiShangPin": "Отметьте этот пункт",
    "QuanBuZhuangTai2": "Все государства",
    "ZhiJianYouWenTi": "Сомнительный контроль качества",
    "ZhiJianMeiWenTi": "Прохождение контроля качества",
    "ZhiJianDaiChuLi": "Ожидание контроля качества",
    "JinRuXiaYiKuan": "Перейти к следующему пункту",
    "YiBiaoJi": "Отмечено",
    "YouWenTi": "Есть проблема",
    "QuXiaoBiaoJi": "Отменить эту отметку",
    "ChuHuoShiJianiYouGaiBian": "Сроки доставки изменились",
    "ShangYiCi": "До изменения",
    "ShangYiZhang": "Предыдущий",
    "XiaYiZhang": "Следующий",
    "NinLiuLanDeYeMianYiGuoQi": "Срок действия просматриваемой вами страницы истек. Перейти на главную страницу, Откройте для себя больше замечательных игрушек！",
    "WanJuCaiGouXuanZe": "Варианты игрушек для закупок",
    "NiLaiDuiDiFangLe": "Вы пришли в правильное место",
    "ZhuanYePingTai": "Профессиональная платформа",
    "WanJuGengQingSong": "Упростите закупку игрушек",
    "XuanZeGengRongYi": "Сделайте выбор продукта товаров быстрее и проще",
    "ChanPinZhiNengChaZhao": "Продукты можно найти только",
    "YiZhanShiJieJue": "Универсальное решение проблем с выбором",
    "ZhuZhaZhongGuoGongChang": "Более  20 000 аккредитованных китайских фабрик",
    "WanZhengDeChanPinKu": "Самая последний и полный катталог игрушек",
    "ZhuanYeMaiJiaTuiJian": "Рекомендовано профессиональными покупателями",
    "ShiHeNiMenDeChanPin": "Лучший товар для вашего рынка",
    "JiaGeTouMing": "Прозрачность цен",
    "QuanPingTaiJiaGeWei": "Полная стоимость на площадке",
    "GongChangDuLiBaoJia": "Предложение от фабрик",
    "CaiGouDeFuWuChengBen": "Прозрачные расходы на услуги по закупкам",
    "GengHaoDeKongZhiChengBen": "Позволяет лучше контролировать затраты на закупки",
    "GengQingSongDeGouMaiTiYan": "Легкий опыт закупок",
    "YiDuiYiDeZhuanMenFuWu": "Индивидуальное профессиональное обслуживание клиентов",
    "ZhuLiuFuWuJingLi": "100 основных менеджеров для поддержки на разных языках",
    "GenZongDinDanChuLi": "Отслеживайте обработку вашего заказа на протяжении всего процесса",
    "GaoJiCaiGouTuanDui": "Первоклассная команда по закупкам в цепочке поставок",
    "WeiNiTiGongDingZhiHeQiTa": "Предоставить вам настройку OEM и другие",
    "GeXingHuaFuWu": "Индивидуальный сервис",
    "WoMenDeBaoZheng": "Наши гарантии",
    "ChanPinZhiLiangBaoZheng": "Гарантия качества",
    "PingTaiQueBaoAnBiaoZhunPeiChang": "Платформа гарантирует, что фабрика будет соответствовать условиям компенсации за повреждения или недостачу товароы (см. условия компенсации).",
    "HuoWuPeiChangBiaoZhun": "Условия компенсации за груз",
    "JiaoHuoShiJianBaoZheng": "Гарантия сроков поставки",
    "BaoZhengTiaoJian": "Если доставка не может быть осуществлена ​​вовремя, компенсация начнет начисляться через 7 дней просрочки, а затем за каждый день просрочки будет начисляться пеня в размере 0,1% от суммы просроченного заказа. Помимо задержек, вызванными клиентами (такими как задержки в бронировании, запросы клиентов на несвоевременную доставку, несвоевременное получение оплаты и т. д.) и другие задержки, вызванные форс-мажорными обстоятельствами.",
    "FuKuanBaoZhengJin": "Депозит",
    "QueBaoHuoKuanAnQuan": "Мы размещаем заказы и платим только надежным и квалифицированным фабрикам, обеспечивая безопасность ваших платежей.",
    "RuHeGongZuo": "Игра с ESSA",
    "YouXvQiuHuoJiaRu": "Имеете потребность в закупке или просто просомтре на новых товаров",
    "ChaKanTuiJianShangPin": "Приходите на essa, чтобы ознакомиться с рекомендованными продуктами  / рассказывайте своих о своих потребностях",
    "ZhaoDaoHeShiDeShangPin": "Приходите на essa, чтобы ознакомиться с рекомендованными продуктами  / рассказывайте своих о своих потребностях essa найдет для вас наиболее подходящий товар",
    "XuanZeZhiJieCaiGou": "Вы можете выбрать покупку напрямую у essa и подписать договор купли-продажи.",
    "QueRenDinDanLiJiShengChan": "После подтверждения заказа на поставку фабрика немедленно произведет для вас",
    "ZhiJieCaiGou": "ESSA обеспечит вам строгую проверку качества платформы и завершит транзитную партию для Вас.",
    "RuGuoNiYouWenTi": "Если у вас есть вопросы, обращайтесь",
    "DinYueChengGong": "Успешно подписались",
    "YouXiangYouWu": "Заполненный адрес электронной почты неверен, пожалуйста, заполните правильный адрес электронной почты",
    "WhatsAppLianXiRen": "Контакты WhatsApp",
    "DinYue": "Подписаться",
    "HuiYuanZhongXin": "Личный кабинет",
    "KaiShiXuanGou": "Начать делать покупки",
    "WanJuHuiChang": "Зал для игрушек",
    "ShiLiGongChang": "Фабрика качества",
    "WenJu": "Канцелярские товары",
    "TiYuYongPing": "Спортивные товары",
    "JieRiYongPing": "Принадлежности для праздников",
    "RiYongPingHeCanChuJu": "Предметы первой необходимости и кухонные принадлежности",
    "GengDuoXinPin": "Подробнее",
    "RuMenZheKou": "Скидка для новичков",
    "BenRi": "Вчерашние",
    "BenZhou": "На этой неделе",
    "BenYue": "В этом месяце",
    "MiaoZiDongShouQi": "Автоматические закрытие через {0} секунд",
    "TongGuoShiBieTuPianShouSuo": "Поиск товаров по изображению.  Изображение и фон должны быть качественными и четкими.",
    "MeiRiXinPin": "Новинки каждый день",
    "LiaoJieXiangQing": "Смотреть ещё",
    "BaoQingGuanWuLiuMenDaoMen": "Включает таможенную очистку, логистику, услугу \"от двери до двери\" ,",
    "ZongGongKuanXiangShangPinZongJia2": "Всего {0} товаров，{1} коробок",
    "QingTianXieYouXiaoYouXiang": "Требуется подтверждение электронной почты, пожалуйста, введите действительный адрес электронной почты.",
    "WoYiYouZhangHao": "У меня уже есть аккаунт.",
    "QuDengLu": "Вход в систему",
    "QingShuRuMiMaJiShuZhi": "Пожалуйста, введите пароль из 8 цифр или более, включая буквы и цифры",
    "YaoQingMa": "Код купона",
    "ZhengZaiShenHeZhong": "Он находится на рассмотрении, и сотрудники завершат рассмотрение в течение 24 часов.",
    "ShengHeZhong": "Под обзором",
    "WeiRenZhengZhiNengChaKan": "Несертифицированный имеет только 3-дневный доступ к просмотру цен, но не инициирует запрос на фабрику при покупке товара. Сертифицированная система даст вам более полный опыт.",
    "QingTianXieZhenShiShouJi": "Пожалуйста, введите реальный номер мобильного телефона, служба поддержки свяжется с вами по телефону позже для проверки.",
    "QingShuRuShouJiHaoMa": "Номер мобильного телефона",
    "ZhuyYaoXiaoShouQuYu": "Основные рынки сбыта",
    "ZhengGui": "FCL（Полный контейнер）",
    "ZhuYaoCaiGouPinLei": "Основные категории покупок",
    "DiYiShiJianTuiJianXinPin": "Вы можете получать обновления о новых и горячих товарах",
    "XuanZePinLei": "Выберите категорию",
    "QingXuanZeCaiGouPinLei": "Пожалуйста, выберите до пяти категорий покупок",
    "NinTianXieDeDianZiYouXiangYouWu": "Заполненный вами адрес электронной почты неверен.",
    "YaoQingMaWuXiao": "Текущий код приглашения недействителен, пожалуйста, проверьте свой код приглашения",
    "QingTongYiTiaoKuan": "Пожалуйста, прочитайте и выберите, согласны ли вы с вышеуказанными условиями регистрации",
    "QingShuRuLianXiRen": "Пожалуйста, введите имя контакта",
    "QingShuRuNinDeGongSiMing": "Введите название вашей компании",
    "QingXuanZeChuHuoFangShi": "Выберите способ доставки",
    "QingXuanZeGuoJiaHeQuYu": "Выберите регион продаж и страну",
    "QingShuRuNinDeDianZiYouXiang": "Пожалуйста, введите ваш адрес электронной почты",
    "QingShuRuNinDeMiMa": "Пожалуйста, введите пароль",
    "ZhangHaoJiHuoChengGong": "Успешная активация учетной записи",
    "QuRenZheng": "Получить сертификат",
    "YouXiangLianJieShiXiao": "Ссылка для проверки электронной почты больше не доступна",
    "YouXiangYanZhengChongXinZhuCe": "Ссылка для проверки электронной почты действительна в течение 24 часов, пожалуйста, зарегистрируйтесь повторно",
    "QianWangDianZiYouXiang": "Перейдите на свой адрес электронной почты",
    "ChaShouYouJian": "Проверьте свою электронную почту и активируйте свой аккаунт в соответствии с содержанием письма",
    "RuGuoMeiYouShouDaoYouJian": "Если электронное письмо не получено",
    "ZhuCeWanCheng": "Регистрация завершена",
    "FaSongChengGong": "Отправлено успешно",
    "QingJianChaNinTianXieDeXinXi": "Пожалуйста, проверьте заполненную вами информацию",
    "ZhuCeHouChaKanGengDuoJieGuo": "Зарегистрируйтесь, чтобы увидеть больше результатов",
    "MianFeiZhuCeZhangHao": "Создайте учетную запись бесплатно",
    "ZhaoDaoNKuanShangPin": "Найдено {0} предметов",
    "ZhuCeGongSi1": "Дания Импорт и Экспорт Лтд.",
    "ZhuCePinLun1": "Сорсинговые платформы, вертикально ориентированные на категорию игрушек, встречаются очень редко. ESSA, безусловно, самая профессиональная из всех, что я видел. В настоящее время трудно поехать в Китай, и нет возможности посетить шоу-рум. У ESSA есть полный ассортимент продукции, и фотографии очень четкие, что дает нам хорошее решение проблемы выбора продукции и просмотра образцов.",
    "ZhuCeGongSi2": "шаньтоу сай-тек лимитед",
    "ZhuCePinLun2": "Библиотека образцов ESSA очень хорошо укомплектована, и очень легко найти образцы в дороге, войдя в систему с мобильного телефона!",
    "ZhuCeGongSi3": "ALISA TOYS",
    "ZhuCePinLun3": "Мне было приятно работать с ESSA на протяжении многих лет. Я очень положительно отношусь к этой компании. Их команда очень динамична, все очень умны и очень мотивированы. Их идея использовать Интернет для реформирования процесса внешней торговли - это то, что я действительно ценю, и они постепенно делают это сейчас!",
    "ZhuCeGongSi4": "Компания по производству игрушек Shinco",
    "ZhuCePinLun4": "Команда ESSA очень приветлива, платформа очень полная и простая в использовании, поэтому я могу легко найти на ней нужные мне продукты.",
    "RenZhengBuTongGuo": "Аккредитация не утверждена",
    "EWen": "Русский",
    "YingWen": "English",
    "HaiMeiYouZhangHao": "У вас еще нет аккаунта?",
    "WeiRenZhengZhiNengChaKan2": "Несертифицированные покупатели имеют доступ к просмотру цен только на 3 дня, а покупка товаров не инициирует запрос предложения от завода.",
    "HuoDeWanZhengDeTiYan": "Сертифицированные счета получат более полный опыт.",
    "ChangShiChongXinFaSongYouJian": "Если вы не получили его, попробуйте отправить письмо повторно.",
    "YiZhiShouBuDaoQingLianXiKeFu": "Никогда не получали, пожалуйста, свяжитесь со службой поддержки клиентов.",
    "DengLuChengGong": "Вход в систему успешный",
    "RuGuoMeiYouKeYiBuTianXie": "Если нет, вы можете оставить это без внимания",
    "DanJuGuanLi": "Управление документами",
    "SuiCheDan": "Список загрузки грузовиков",
    "BiaoJi": "отметка",
    "ChanPinTiaoMa": "штрих-код",
    "ZhongWenPinMing": "Китайское имя",
    "YinWenPinMing": "Англ. Наименование",
    "ErWenPinMing": "Товар",
    "NeiHe": "Внутренняя коробка",
    "DDPDanJia": "Цена за единицу DDP",
    "DDPZongChengJiaoJia": "Общая сумма DDP",
    "EXWDanJia": "Цена за единицу EXW（CNY）",
    "EXWZongChengJiaoJia": "Общая сумма EXW（CNY）",
    "FOBDanJia": "Цена за единицу FOB（RUB）",
    "FOBZongChengJiaoJia": "Общая сумма FOB（RUB）",
    "XiaDanLuBuHuiLv": "курс рубля при",
    "CIFJiaGe": "цена CIF (CNY)",
    "TieZhiBianHao": "Тип стикера",
    "BanBen": "Версия",
    "ShengChanGuo": "Страны-производители",
    "JianShu": "Кол-во шт",
    "MaoZhong": "Вес",
    "ZhongJia": "Общая стоимость",
    "LiShiJiLu": "История",
    "XiaZaiExcel": "Экспорт в excel",
    "XiaZaiGaiZhangPDF": "Скачать PDF",
    "ShiZhuangGuiRiQi": "Дата загрузки контейнера",
    "FaPiaoHao": "Номер счета-фактуры",
    "HeTongBianHao": "Договор №",
    "JiaoHuoTiaoKuan": "Условия доставки",
    "MaiFang": "Покупатель",
    "MuDiDiGuoJia": "Страна назначения",
    "JiGui": "集柜",
    "MuDiDiCheZhan": "Станция назначения",
    "FaJianRen": "Отправитель / Продавец",
    "TuoYunRen": "Отправитель / Продавец",
    "WeiQueRen": "Не подтверждено",
    "PinPaiReMen": "Популярные товары",
    "TongLeiMuPaiHangBang": "Ранжирование аналогичных товаров",
    "ShangCiBuTongGuo": "В прошлый раз не получилось",
    "GongChangJiaGe": "Заводская цена",
    "ESSAJiaGe": "цена сделки",
    "ZaiYeMianYouShangJiaoKeYiQieHuan": "В правом верхнем углу страницы вы можете переключить метод котировки EXW/FOB.",
    "ChaKanJiaGe": "показать цену",
    "ShangPinJiaGe": "цена товара",
    "ZhangHaoWeiRenZheng": "Если учетная запись не аутентифицирована, фабрику не попросят подтвердить цену.",
    "DengLuHouXianShiJiaGe": "Показать цену после авторизации",
    "GenGongChangZhiJieCaiGou": "Зарегистрируйте бесплатную учетную запись, покупайте напрямую с завода и обновляйте более 2000 новых продуктов каждый день.",
    "KaiPiaoXinXi": "Информация о выставлении счетов",
    "ESSAPingTaiChengNuo": "Платформа ESSA обязуется не предоставлять информацию общественности и соблюдать соглашение о конфиденциальности платформы ESSA.",
    "QueRenHouBuYunXuQieHuan": "Переключение после подтверждения не допускается, поэтому, пожалуйста, выбирайте внимательно! Этот выбор используется только для операций с заказами и не влияет на отображение цены на странице.",
    "QueRenJiaoYiXinXi": "Подтверждение информации о сделке",
    "QueRenSuoXuanJiaoYiBiZhong": "Пожалуйста, подтвердите валюту, выбранную вами для транзакции:",
    "YangPinZhuangXiangDan": "УЛ на образцы",
    "YangPinSuiCheDan": "Инвойс на образцы",
    "YunFeiDan": "Накладная на фрахт",
    "YunFeiHuiKuanDan": "Платежи за логистические расходы",
    "HaiGuanXinHan": "Таможенные письма",
    "JiaGeBiao": "Прейскурант",
    "ShangPinBiao": "Список продуктов",
    "YangPinShangPinBiao": "Техническое описание на образцы",
    "MaiJia": "Продавец",
    "FuWuMiaoShu": "Описание услуг",
    "JiaoHuoYongShi": "Сроки доставки",
    "FaHuoDian": "Пункт отправления",
    "MuDiDian": "Пункт назначения",
    "LuXian": "Маршрут",
    "FuKuanTiaoJian": "Порядок оплаты услуг",
    "OuYaJingJiLianMengLuXianYunFei": "Стоимость услуг по доставке по ЕАЭС",
    "ZongJiYunFe": "Общая стоимость услуг по доставке",
    "YunFeiDanLuXianMiaoShu": "<p>1.в  т/п ЖД ПП {0}：{1} - т/п ЖД ПП（{2} км）;</p> <p>2.по ЕАЭС：т/п ЖД ПП {3}（{4} км）;</p> <p>百分比：</p> <p>КНР -{5}%; РФ - {6}%。</p>",
    "ShangPinYuanChanGuo": "Страна происхождения товара",
    "ZhiZaoShang": "Изготовитель",
    "QingYueDuJiaChaDanJuShuJu": "Пожалуйста, ознакомьтесь с данными контрольного списка, чтобы убедиться, что этот документ в порядке?",
    "HeTongHaoHeRiQi": "Номер и дата контракта",
    "MiaoShu": "Описание",
    "ZongYunFei": "Общая стоимость доставки",
    "YunFeiHuiKuanDanGuiHaoLiZi": "EX:85/003",
    "YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiRu": "EX:ESSA-TR 003 от «26» мая 2022 г.",
    "YunFeiHuiKuanDanRiQiLiZiRu": "EX:«02» Августа 2022 г.",
    "YunFeiHuiKuanDanMiaoShuLiZiRu": "EX:Доставка товара по маршруту1.в т/п ПП Забайкальск: Гуанчжоу – т/п ПП Забайкальск (2652.2 км); 2. по ЕАЭС: т/п ПП Забайкальск – Белый Раст (5125.7 км), контейнер № OOLU8357922, инвойс № RU20220012 от 22.06.2022 на сумму 10,000.00 USD",
    "YunFeiHuiKuanDanZongYunFei": "10,000.00",
    "YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiEn": "EX:ESSA-TR 003 dated May 26, 2022",
    "YunFeiHuiKuanDanRiQiLiZiEn": "EX:«02» August 2022",
    "YunFeiHuiKuanDanMiaoShuLiZiEn": "EX:Delivery of goods along the route 1.to the P/P Zabaikalsk: Guangzhou – P/P Zabaikalsk (2652.2 km); 2. on the EAEU: P/P Zabaikalsk – Beliy Rast (5125.7 km), container no. OOLU8357922, invoice no. RU20220012 dated 22.06.2022 in the amount of 10,000.00 USD",
    "HuiFuCiBanBen": "Восстановление до этой версии",
    "DangQianBanBen": "Текущая версия",
    "PiLiangBianJiEWenPinMing": "Массовое редактирование наименования",
    "PiLiangBianJiYingWenPinMing": "Пакетное редактирование английских имен",
    "WeiQueRenWuFaXiaZaiPdf": "PDF-файлы с гербовыми подписями не могут быть загружены без подтверждения",
    "BianJiYunFeiHuiKuanDan": "Редактирование платежных ведомостей на логистические расходы",
    "BianJiHaiGuanXinHan": "Редактирование таможенных писем",
    "BianJiJiaGeBiao": "Редакционный прейскурант",
    "BianJiShangPinBiao": "Редактирование списка продуктов",
    "BianJiYangPinShangPinBiao": "Редактировать список образцов",
    "JiZhangXiangHuoHao": "Номер груза в контейнере",
    "ZongGeShuZhuangLiang": "Общее количество штук (в упаковке)",
    "DaoHaiGuanGuanKaJianChaZhanYunFei": "Стоимость услуг по доставке в т/п  ЖД ПП {0} :",
    "DiZhi": "Адрес :",
    "DaiQueRenDanJu": "Ожидание подтверждения документов",
    "QueRenDanJu": "Подтвердить документ",
    "MiaoShuNiYaoZhaoDeShangPin": "Опишите предмет, который вы ищете",
    "GaoSuWoMenShangPinDeXinXi": "Расскажите нам о товаре, например, о характеристиках, цвете, материале, указанной марке, требованиях к упаковке и т.д.",
    "ShangChuanWenJianZhiChi": "Загрузка файлов, поддержка изображений/сжатых пакетов/Excel, поддержка одного файла до 200M, до 5 файлов",
    "XuYaoYuTuPianShangPinYiZhi": "Должен соответствовать изображенному продукту",
    "JinZhunFanKui": "Точная обратная связь",
    "JinKeNengDuo": "как можно больше",
    "JinkeNengJinZhunDe": "Рекомендуйте как можно точнее",
    "JiaGeYaoQiu": "Ценовые требования",
    "ChanPinXuYaoYongYouYiXiaZhengShu": "Продукция должна иметь следующие сертификаты",
    "XiaoShouGuoJia": "Страна продажи",
    "QingXuanZeXiaoShouGuoJia": "Пожалуйста, выберите страну продажи",
    "QingMiaoSuNiYaoZhaoDeShangPin": "Пожалуйста, опишите предмет, который вы ищете",
    "KeJieSouLeiShi": "Подобное приемлемо",
    "QingXuanZeZhengShu": "Пожалуйста, выберите сертификат",
    "BuXianZhiShuLiang": "Количество рекомендаций не ограничено, рекомендуйте как можно больше",
    "GengDuoDeYaoQiu": "Дополнительные запросы",
    "GengShaoDeYaoQiu": "Меньше запросов",
    "YiYouZhiLiao": "Информация/изображения уже имеются",
    "ZhengZaiZhaoYang": "Поиск образцов",
    "FanKuiShuLiang": "Количество отзывов",
    "TuiJianDeShangPin": "Рекомендуемые предметы",
    "PiLiangJiaRuGouWuChe": "Добавить в корзину оптом",
    "QueRenYaoQuXiaoZhaoYangQu2": "После отмены вы больше не будете получать рекомендации по продуктам. Отменять ли поиск образцов?",
    "ZhaoYangYouXinDeFanKui": "Ищите новые отзывы",
    "QiTianNeiBuZaiDanChu": "Не показывать в течение 7 дней",
    "QuanBuZhaoYang": "Все записи",
    "TiJiaoNiDeXuQiu": "Поиск товара",
    "TuiJian": "Рекомендуем",
    "LiShiTuiJian": "Исторические рекомендации",
    "TuiJianLiangDian": "Причина рекомендации",
    "JiaRu": "Добавить",
    "XiangZhao": "хочу найти",
    "DengLuHouFaBuZhaoYangXuQu": "После авторизации начните публиковать запросы на поиск образцов",
    "JiaoYiJia": "цена сделки",
    "ZhaoYangJiLu": "Результат поиска",
    "ZhaoYangZhong": "ищу товар",
    "YouXinYangPin": "Есть новые образцы",
    "SouSuoZhaoYangMiaoSu": "Поиск содержания описания",
    "EWenMiaoShu": "Описание на русском языке",
    "HaiYouKuanShangPinMiaoShuWeiWanShan": "Осталось ли {0} пунктов, которые нужно довести до совершенства, продолжаете ли вы подтверждать?",
    "KuanShangPinMiaoShuWeiWanShan": "Было {0} товаров с плохими описаниями",
    "PiLiangBianJiMiaoShu": "Пакетное редактирование Описание",
    "PiLiangBianJiEWenMiaoShu": "Пакетное редактирование Описание",
    "ChanPinYiTingShou": "Недоступно к заказу",
    "ZanWuQuanXianChaKan": "Нет разрешения на просмотр",
    "ZiXunChanPin": "Задать вопрос",
    "NiXiangZiXunShenMeWenTiNe": "Какой вопрос вы хотите задать?",
    "GongChangYiBanHuiZai1GeGongZuoRiNeiHuiFuNi": "Завод обычно отвечает вам в течение 1 рабочего дня. Вы можете перейти в корзину для проверки ответа",
    "QingShuRuNiDeWenTi": "Пожалуйста, введите свой вопрос",
    "FaSongTiWen": "Отправить вопрос",
    "XianShiYuanWen": "показать оригинал",
    "QingXuanZeQinQuanYuanYin": "Пожалуйста, выберите причину нарушения",
    "QinQuanYuanYin": "Причина нарушения",
    "QinQuanQuXiao": "Аннулирование из-за нарушения",
    "DengLuHouShiTuZhaoYang": "Пожалуйста, войдите в систему и начните идентифицировать изображения для поиска продуктов",
    "NeiBuGuiHao": "Внутренний номер контейнера",
    "WuLiuGuiHao": "Номер логистического контейнера",
    "GongChangMOQ": "Минимальный заказ на заводе",
    "KouJianDengJi": "регистрация вычета",
    "JinQiTuiKuan": "Недавняя регистрация вычета",
    "TuiKuanDengJi": "регистрация вычета",
    "QingQueRenLuRuDeKouJianJinEShiFouZhengQue": "Пожалуйста, подтвердите правильность введенной суммы вычета?",
    "SuoYouKouJianJiLu": "Все записи о вычетах",
    "KouJianJinE": "Сумма вычета",
    "QingShuRuKouJianJinE": "Пожалуйста, введите сумму вычета",
    "HuiKuanRiQi": "дата перевода",
    "QingXuanZeHuiKuanRiQi": "Выберите дату перевода",
    "TuiKuanFangShi": "Способ возврата",
    "QingXuanZeTuiKuanFangShi": "Пожалуйста, выберите способ возврата",
    "GaiCaoZuoJiangKouJianKeHuDeYuE": "Это действие приведет к вычету баланса клиента",
    "QuanBuKouJianJiLu": "Все записи о вычетах",
    "KouJianJiLu": "запись о вычете",
    "SouSuoKeHuBianHao": "Поиск по номеру клиента",
    "KeHuYuE": "баланс клиента",
    "BianDongJinE": "Сумма изменена",
    "BianDongHouYuE": "Остаток после изменения",
    "QingXuanZeLeiXing": "Пожалуйста, выберите тип",
    "KeHuZaiDengJiLeiTongYangDeJinE": "Клиент {0} зарегистрировал идентичную сумму {2} в {1}.",
    "ShiFouJiXuDengJi": "Продолжать ли регистрацию",
    "KouJianJinEYiChaoChuKeHuYuE": "Операция не удалась, списанная сумма превысила баланс клиента {0}",
    "ZanWuWuLiuShuJu": "Данные по логистике пока отсутствуют",
    "DangQianKeHuYuE": "Текущий баланс клиента {0}",
    "LianXiWoMen2": "Контакты",
    "PiPeiShangPin": "Сопоставляемые товары",
    "NiYaoZhaoShenMeShangPin": "что ты ищешь",
    "LiuXiaNiDeYouXiang": "оставить свой адрес электронной почты",
    "YiGeQingQiu": "Один запрос, много предложений",
    "QinMiaoSuNiYaoZhaoDe": "Пожалуйста, опишите продукт, который вы ищете, например, название, цвет, материал и т. д.",
    "GongChang": "фабрика",
    "WoMenYiShouDaoNiDeXunJiaQingQiu": "Мы получили ваш запрос на запрос и ответим вам в течение 1-2 рабочих дней, пожалуйста, проверьте свою электронную почту.",
    "XunJia2": "Запрос цены",
    "RuGuoNinYouWenTi": "Если у вас есть вопросы, вы можете обратиться к своему менеджеру по работе с клиентами",
    "XueXi": "Сделать",
    "Zi2006NianYiLai": "с 2006 года",
    "ShiYuChengHai": "ESSA была основана в 2006 году в Чэнхае.",
    "ZhongGuoWanJuHeLiPinZhiDou": "Китайская столица игрушек и подарков",
    "JingGuoDuoNianDeFaZhan": "После многих лет разработки",
    "YiWuGuangZhouHeXiangGang": "Иу, Гуанчжоу и Гонконг",
    "WeiWanJuTiGongCaiGouFuWu": "Оказание услуг по закупке игрушек",
    "TiYuYongPinWenJuRiYongPin": "Спортивные товары, Канцелярские товары, Предметы широкого потребления",
    "YiJiXuDuoQiTaLeiBie": "и многие другие категории",
    "WeiQuanQiuKeHuTiGongDeChanPin": "Товары для клиентов по всему миру",
    "ZhouNianJiNianRi": "Годовщина",
    "ZhouNianJiNianHuoDong": "Юбилейное акция для большой семьи ESSA",
    "GanXieNinFangWen": "Благодарим вас за посещение платформы онлайн-закупок ESSACHINA. Вы можете оставить нам любые комментарии или предложения",
    "WoMenJiangZai24XiaoShiNeiHuiFuNin": "По электронной почте или в службе поддержки клиентов в левом нижнем углу. Мы ответим вам в течение 24 часов.",
    "WoMenHuanYingNinDangDiGongSiGouTong": "Мы также приглашаем Вас пообщаться в наши местные отделения компаниями.",
    "GuangDongESSA": "Guangdong ESSA Technology Co., Ltd.",
    "GuangZhouShiNanShaQu": "Гуанжоу, Nansha District,No. 5 Shuangshan Avenue,",
    "XiangGangFanRongDianZiShangWu": "Hong Kong Prosperity Electronic Commerce Co., Ltd.",
    "XiangGangJiuLongHongKanMaTouWeiDao": "Гонконг, Коулун, Room A37, 9th Floor, Yi Da Industrial Building, 21 Wai Road, Hung Hom Pier",
    "ShanTouShiChengHaiQuGuangYiJieDao": "Шаньтоу, район Чэнхай, No. 01, 1st Floor, Guangfeng Industrial Zone, Dengfeng Road, Guangyi Street",
    "ShanTouESSAGongYingLian": "Shantou ESSA Supply Chain Management Co., Ltd.",
    "YiWuESSAMaoYiYouXianGongSi": "Yiwu ESSA Trading Co., Ltd.",
    "ZheJiangShengYiWuShiFuTianJieDao": "Провинция Чжэцзян, Иу, Room 1708, 17th Floor, International Business Center, No. 399 Yinhai Road, Futian Street",
    "RenShiWoMenDeTuanDui": "Познакомьтесь с нашей командой",
    "YeWuTuanDui": "Операционная группа",
    "CaiGouTuanDui": "Отдел закупок",
    "YunYingTuanDui": "Операционная команда",
    "JiShuTuanDui": "Техническая команда",
    "ZhanTing": "Выставочный зал",
    "CangKu": "склад",
    "YiZhanShiCaiGou": "Шоппинг с одной остановкой",
    "WeiNinTiGongZhuLiuLeiBie": "ESSACHINA.COM предоставляет вам 8 основных категорий. Обширный каталог товаров ESSA содержит 2 миллиона продуктов от более чем 20 000 китайских фабрик, с которыми мы работаем.",
    "WeiNinTiGongHangYeYiXianXinXi": "ESSACHINA.COM предоставляет вам оперативную информацию о новых продуктах в отрасли, чтобы вы не пропустили ни одной новинки с рыночным потенциалом.",
    "ZhaoBuDaoChanPinXiWangTiGongJianYi": "Не можете найти товар или хотите, чтобы ESSA предоставила рекомендации? Нет проблем, мы свяжемся с вами в течение 1 рабочего дня!",
    "GaoXiaoDi": "Эффективный",
    "ESSACongShiWaiMaoHangYeYiYou16Nian": "ESSA работает в сфере внешней торговли уже 16 лет, обслуживая различные типы клиентов, таких как традиционные оптовики, крупные супермаркеты и владельцы торговых марок. Таким образом, мы можем предоставить лучшие предложения и сервисные решения для удовлетворения индивидуальных потребностей покупателей.",
    "ZaiXianPiFaCaiGouPingTai": "Ваша круглосуточная онлайн-платформа для оптовых закупок",
    "TiChuBaoJiaQingQiu": "Вы можете в любое время оставить заявку на расчет стоимости на нашем сайте. ESSA обработает ваш запрос в течение 24 часов.",
    "YouJingZhengLiDeJiaGe": "Конкурентная цена",
    "GongYingShangShiYuanGongChang": "Поставщики ESSACHINA — это 100% фабрики-производители.",
    "ESSADeJiaGeShiTouMingHeGongKaiDe": "Сначала сравните цены, а потом покупайте. Цена на ESSA прозрачна и открыта. Мы также приветствуем сравнение цен на товары, чтобы клиенты ESSA всегда могли получить только конкурентоспособные предложения.",
    "WeiNinTiGongJiaGeTanPanFuWu": "ESSA располагает профессиональной командой для расчетов затрат, которая предоставит Вам услуги по согласованию цен.",
    "JiLeiLeYiZhiHeXinTuanDui": "Накопленный годами опыт в отрасли позволили ESSA сформировать основную команду",
    "TiGongGongYingShangHeZuoHuoBan": "Партнеры-поставщики предлагают скидки клиентам ESSA.",
    "RuHeCongQiTaGongSiZhongTuoYingErChu": "Чем мы отличаемся от других компаний-поставщиков",
    "QueBaoGongChangJiangGenJu": "ESSACHINA гарантирует, что фабрика будет основана на",
    "RuGuoHuoWuSunHuaiHuoQueShao": "Условия компенсации, если товар поврежден или отсутствует.",
    "LiJiFaBuWoDeXuQiuRenWu": "Опубликуйте мою задачу сейчас!",
    "JiaoFuShiJianBaoZheng": "Гарантия сроков поставки",
    "essaDeChengNuo": "ESSACHINA гарантирует сроки доставки вашего товара.Если доставка не может быть осуществлена ​​вовремя, компенсация за просроченные дни будет начислена через 7 дней, а затем штраф в размере 0,1% от суммы просроченного заказа будет отложен еще на 1 день. Помимо задержек, вызванными клиентами (такими как задержки в бронировании, запросы клиентов на несвоевременную доставку, несвоевременное получение оплаты и т. д.) и другие задержки, вызванные форс-мажорными обстоятельствами.",
    "GuanYuESSAUrl": "О сайте essachina.com",
    "GuanYuESSAUrlSub": "Кратко о том, что выделяет essachina.com в торговле игрушками",
    "GuanYuESSASub": "Глубоко в отрасли уже 16 лет, приходите и познакомьтесь с нашей командой! С нетерпением ждем возможности работать с вами!",
    "BangZhuZhongXinSub": "Возникли проблемы с его использованием? Почему бы не посмотреть здесь",
    "BoKe": "Блог",
    "BoKeSub": "Последние новости из индустрии игрушек, которыми делятся передовые сотрудники отрасли на нашей платформе",
    "ESSADeGongZuo": "Понимание ESSA",
    "XinKeShouNianYouHui": "Предложение для нового клиента на первый год.",
    "ZaiYeMianYouShangJiaoKeYiQieHuanDuiBiJia": "Переключите режим расценок EXW/FOB в правом верхнем углу страницы. Текущая цена является эксклюзивной для новых клиентов в течение первого года.  Предложение для нового клиента на первый год.",
    "LaiKuanMingXi": "Детали платежа",
    "KouKuanMingXi": "Детали вычета",
    "KeHuYuEMingXi": "Детали баланса клиента",
    "MaiShouGuanLi": "Менеджер по работе с клиентами",
    "HaiMeiYouKeHuJingLiWeiNiFuWu": "Вас пока не обслуживает менеджер по работе с клиентами",
    "TiaoXuanKeHuJingLi": "Выберите менеджера по работе с клиентами",
    "ShiFouBuXuYaoKeHuJingLiLe": "Есть ли необходимость в  менеджере по работе с клиентами?",
    "ZongHePingFen": "Общая оценка",
    "GeRenTeSe": "Личные характеристики",
    "WoBuXiangYaoKeHuJingLiLe": "Мне больше не нужен менеджер по работе с клиентами",
    "KuHuJingLiYinGeRenYuanYinWuFaJiXiFuWu": "Менеджер по работе с клиентами не может продолжить обслуживание по личным причинам, Вам нужно повторно выбрать менеджера.",
    "KuHuJingLiYinGeRenYuanYinWuFaJiXiFuWu2": "Менеджер по работе с клиентами не может продолжить обслуживание по личным причинам",
    "HenBaoQianGaiKeHuJingLiYiFuWuDuoGeKeHu": "Приносим извинения! Этот менеджер аккаунта обслуживал несколько клиентов и временно не может обслуживать вас. Попробуйте выбрать другого менеджера аккаунта.",
    "XianZaiYouXinKeHuJinLiWeiNiFuWu": "Теперь к вашим услугам -  новый менеджером по работе с клиентами",
    "KeHuJinLiJiangWeiNiTiGongFuWu": "Менеджер по работе с клиентами предоставит вам услугу",
    "WenJianGeShuBuZhengQue": "Количество файлов не может превышать 10",
    "NiQuXiaoLeFuWu": "вы отменили услугу",
    "NiDuiGaiKeHuJingLiPingJiaBuTaiYouHao": "У вас низкая оценка менеджера по работе с клиентами,  хотите ли Вы заменить менеджера, который будет обслуживать вас?",
    "KuHuJingLiQuanChengFuZeGenJin": "Менеджер по работе с клиентами несет ответственность за последующие действия на протяжении всего процесса. Если вас не устраивает работа менеджера, вы можете отказаться от услуги и выбрать нового менеджера.",
    "NinYouJinXinZhongDePoDanWuFaJieBanMaiShou": "У вас есть текущий заказ PO, и вы не можете отменить привязку покупателя",
    "LiShiKeHuJingLi": "Предыдущий менеджер по работе с клиентами",
    "XiangXiZiLiao": "Подробности",
    "XiTongZiDongFenPei": "Автоматически назначается системой",
    "YiXiaKeHuJingLiBuFenPiPei": "см. других менеджеров по работе с клиентами",
    "XiTongWeiNinXuanZeMaiShou": "Подтвердить, чтобы система подобрала для вас клиент-менеджера?",
    "FenPeiChengGong": "Успешное распредение",
    "KeHuJingLiXiangQing": "Сведения о менеджере по работе с клиентами",
    "JiNengTeChang": "Специальный навык",
    "ZhuPinLei": "Основная категория",
    "ShanChangPinLei": "Хорошо разбирается в категориях",
    "WaiMaoCongYeShiChang": "Время работы во внешней торговле",
    "ShiChang": "Рынок",
    "KeHuXiaoShouQuDao": "Каналы продаж клиентов",
    "FuWuKeHuShu": "Количество обслуженных клиентов",
    "XuanZeGaiKeHuJingLi": "Выберите менеджера по работе с клиентами",
    "ShuoLiangJu": "Скажите несколько слов",
    "PingJiaYiXiaKeHuJingLi": "Оценка менеджера по работе с клиентами будет предоставлена ​​платформе только для внутреннего просмотра, наша цель - вовремя обнаружить проблемы и улучшить качество обслуживания",
    "XiTongJiangDuiNiDePingJiaNiMingChuLi": "Ваш отзыв будет обработан анонимно. Надеемся получить ваш честный отзыв, чтобы мы могли предоставить вам лучший сервис!",
    "ChaKanPingJia": "Посмотреть отзывы",
    "PingFenBuNengWeiKong": "Рейтинг не может быть пустым",
    "ShiFouQueRenTiJiaoPingLun": "Подтверждаете ли Вы, что хотите оставить оценку?",
    "QuTiaoXuan": "Выбрать",
    "PingLunChengGong": "Оценка прошла успешно",
    "YiPingJia": "Рейтинг",
    "PingJiaKeHuJingLi": "Оцените менеджера по работе с клиентами",
    "TiJiaoPingJia": "Отправить отзыв",
    "NiYiJingYouKeHuJingLiWeiNiFuWu": "У вас уже есть менеджер по работе с клиентами, выбор нового менеджера по работе с клиентами заменит старого.",
    "MaiShouXiangQing": "Сведения о покупателе",
    "KeHuJingLi": "Менеджер по работе с клиентами",
    "FuWuZhong": "В процессе",
    "QingQianWangRenZheng": "Ваша учетная запись еще не аутентифицирована, вам необходимо пройти аутентификацию, прежде чем вы сможете выбрать менеджера по работе с клиентами.",
    "KeYiKanKanYiXiaBuFenPiPeiDe": "Не удалось найти ни одного клиент-менеджера, точно соответствующего вашим данным, вы можете ознакомиться с наиболее точными совпадениями ниже.",
    "KeHuJingLiQuanChengFuZeGenJin": "Менеджер по работе с клиентами несет ответственность за последующие действия на протяжении всего процесса. Если вас не устраивает работа менеджера, вы можете отказаться от услуги и выбрать нового менеджера.",
    "TiHuan": "Заменить",
    "MianFei": "Бесплатно",
    "KeHuJingLiFuWuZhong": "В обработке клиентским менеджером",
    "KeHuPingTaiJingLi": "Менеджер по работе с клиентами",
    "HaiMeiZhuCe": "Еще не зарегистрирован",
    "ZhuCeChengGong": "Успешная регистрация",
    "DiYiDanZheKouYouHuiTiShi": "Депозит первого заказа -10%",
    "KaiShiCaiGou": "Начните делать покупки",
    "HuoDeJiangLi": "Получить вознаграждение",
    "ShangPinZhanShi": "Витрина продукции",
    "SouSuoShangPinGongChang": "Поиск по продукту / заводу",
    "PinPaiZhuYe": "Дом бренда",
    "ChaKanGouWuCheTiShiM": "<a style=\"color:#fff\" href=\"https://www.essaone.com/cart\">Просмотр корзины, в настоящее время поддерживается только на ПК. https://www.essaone.com/cart</a>",
    "GouWuCheYiYouWaiXiang2": "В корзине уже есть {0} внешних коробка, перезаписывает ли это количество в корзине",
    "JiaGeShuoMing": "Примечания к ценам",
    "ESSAONEJiaGeShuoMingNeiRong": "ESSAONE торгует по цене внешнего блока коробки, другие цены используются только как ориентир стоимости при покупке.",
    "LiRuMouShangPin": "Пример: предмет",
    "ZhanShiXiang": "Дисплейная коробка",
    "ShangYiYe": "Предыдущий",
    "XiaYiYe": "Следующая страница",
    "GongXiNiYiChengGongZhuCe3": "Один из наших менеджеров по работе с клиентами свяжется с вами в течение 48 часов в рабочий день, чтобы помочь вам найти нужный продукт и лучшую скидку.",
    "HuoQuZuiZhunQueZhao": "Как получить более точные результаты поиска по изображению",
    "ShangChuanDeZhaoPian": "Изображения должны быть четкими",
    "ShiYongChunSeBeiJing": "Используйте однотонный фон, чтобы товар выделялся",
    "KeYiQieGeChanPinDe": "Обрежьте и выделите основную часть изображения товара",
    "RuYouBaoZhuang": "Если товар имеет упаковку, попробуйте убрать ее перед поиском.",
    "ShiBieTuPianSouSuoTongKuan": "Используйте распознавание по изображению и ищите те же или похожие товары",
    "ShiYongCtrlV": "Или используйте Ctrl + V / CMD + V, чтобы вставить изображение",
    "KuangXuanZhuTi": "выбрать тему",
    "JieGuoBuZhun": "Неверные результаты?",
    "DianJiKeQieHuanSouSuoTuPian": "Нажмите, чтобы переключить изображение для поиска",
    "QingKongBingChongXinShangChuan": "Удалить всё",
    "HuiYuanShouYe": "Профиль участника",
    "WoDeJiFen": "Мои баллы",
    "YouXiaoDingDan": "Действующие заказы ≥ {0}",
    "LeiJiChengJiaoE": "Общая сумма покупок за период {0}{1} {2}",
    "GouWuXiaDan": "Оформите заказ",
    "ChengWeiHuiYuan": "Станьте участником",
    "XiangShouQuanYi": "Пользуйтесь всеми преимуществами",
    "ShengJiJiangLiJiFen": "Баллы за повышение уровня",
    "DingDanJiangLi": "Процент кэшбека за заказы",
    "ZuiGaoDiKou": "Можно оплатить баллами",
    "WoDeDengJi": "Мой уровень",
    "JiFenMingXi": "Подробности использования баллов",
    "HuoQuJiFen": "Получить баллы",
    "100%WanShanGongSiXinXi": "100% заполнение информации о компании в личном кабинете",
    "QuWanShan": "Перейти к заполнению",
    "GuanZhuGuanFangSheMeiPingTai": "Подписка на наши соцсети",
    "GuanZhuHouJieTuFaSongGeiKeFuShenHeHouJiangLiJiFen": "После подписки пришлите скриншот нашим менеджерам и мы зачислим Вам баллы.",
    "ChaKanShangPinXiangQingYeMian": "Просмотр карточки товара, баллы можно получить только 1 раз в день.",
    "JiaGouShangPin": "Добавление товара в корзину",
    "BaShangPinJiaRuDaoGouWuChe": "Добавьте товар в корзину, начисление баллов за каждый добавленный артикул",
    "QuXuanGou": "Выбрать товары",
    "WanChengDingDan": "Разместите заказ",
    "ShiFuDingDanJinE": "Можно оплатить часть заказа баллами (процент зависит от уровня).",
    "LianXuXiaDan": "Бонус за ежемесячное размещение заказа",
    "DuiBiShangYueXiaDan": "Бонус за заказ в прошлом месяце.",
    "HaiMeiYouJiFenJiLu": "Пока нет истории по баллам",
    "KeDiKouN": "Можно оплатить баллами {0}{1}",
    "YuJiJiJiangDaoZhang": "Ожидается к начислению {0}",
    "ZuiJinNTianJiFenTongJi": "Статистика по баллам за последние {0} дней",
    "WanChengXiaDan": "Размещенные заказы",
    "JiFenZhiFuDingDanShu": "Количество заказов с примененными баллами",
    "JiFenDiKouJieSheng": "Экономия баллами",
    "ZuiJinJiFenMingXi": "Детализация баллов",
    "ChaKanQuanBuMingXi": "Детали",
    "XinZhuCeYongHu": "Новый клиент",
    "DingDanJiangLiJiFen": "Процент кэшбека за заказы",
    "JiFenZuiGaoDiKou": "Можно оплатить баллами",
    "ZhuanShuKeHuFuWu": "Персональное обслуживание клиента",
    "YouXiaoDingDanZhiDeShiXiaDan": "Действующими заказами считаются те, за которые внесен депозит, сумма покупок за период считается как общая сумма действующих заказов.",
    "DengJiJiSuanYuBianGeng": "Расчет и изменение уровней",
    "DengJiJiSuanYuBianGeng1": "1. Уровень участников обновляется каждый месяц 1 числа в 00:00.",
    "DengJiJiSuanYuBianGeng2": "2. Система рассчитывает количество заказов и общую сумму покупок участников за последние 6 месяцев. Если количество заказов и общая сумма покупок за данный период достигают соответствующих значений уровней лояльности, уровень участника будет автоматически повышен или понижен.",
    "DengJiJiSuanYuBianGeng3": "3. Если за 6 месяцев не было произведено ни одного заказа, то уровень участника будет снижен до Уровня 1.",
    "DengJiJiSuanYuBianGeng4": "4. После обновления уровня участник получает все преимущества, соответствующие новому уровню.",
    "HanMeiMei01YueZhuCeZhangHao": "Петя зарегистрировался в январе",
    "HanMeiMei01YueZhuCeZhangHao1": "В январе он сделал заказ и общая сумма покупок составила 50 000 рублей (или более), 1 февраля уровень лояльности Пети повысится до Уровня 3.",
    "HanMeiMei01YueZhuCeZhangHao2": "Если Петя с февраля по июль (в течение 6 месяцев)  больше не совершал заказы или общая сумма заказов составила менее 50 000 рублей, то 1 августа его уровень обновится и понизится до Уровня 1.",
    "HuiYuanYuJiFen": "Участие в программе и баллы",
    "JiFenShiYongHuDingGouHuoWanCheng": "Баллы — это вознаграждение, которое пользователи получают за заказы или выполнение определенных заданий на площадке. Баллы можно использовать при совершении следующего заказа. Российская Федерация—Каждый полученный балл приравнивается к рублю из расчета 1 балл = 1 рубль. Республика Беларусь—30 балл = 1 бел.руб.",
    "SuoYouYongHuDouKeYiCanYuJiFenDe": "Получать баллы могут все пользователи, но использование баллов предусмотрено только для участников программы лояльности. Уровень участника напрямую связан с количеством получаемых баллов. Чем выше уровень, тем больше баллов начисляется и выше процент от заказа, который можно оплатить баллами. За переход на следующий уровень также начисляются баллы.",
    "LiaoJieJiFenGengDuoXinXi": "Узнать больше о баллах",
    "HuiYuanChangJianWenTi": "Частые вопросы",
    "HuiYuanChangJianWenTi1": "1. Как повысить мой уровень?",
    "HuiYuanChangJianWenTi2": "1-го числа каждого месяца система автоматически подсчитывает количество заказов и их общую стоимость за последние 6 месяцев. Если количество заказов и общая сумма в течение 6 месяцев достигли требований более высокого уровня, то уровень будет автоматически обновлен и повышен.",
    "HuiYuanChangJianWenTi3": "2. Может ли уровень понизиться?",
    "HuiYuanChangJianWenTi4": "Да, может. Система автоматически обновляет уровень каждый месяц. Если количество заказов и общая сумма за последние 6 месяцев не соответствуют текущему уровню, то он будет автоматически понижен. В случае если в течение 6 месяцев не было произведено ни одного заказа, то уровень понизится до Уровня 1.",
    "HuiYuanChangJianWenTi5": "3. Как долго сохраняется уровень?",
    "HuiYuanChangJianWenTi6": "Срок действия уровня не ограничен, самый длинный срок действия составляет 6 месяцев. Уровень поддерживается и изменяется в зависимости от активности участника (например, размещенных заказов и оплат по ним) и обновляется каждый месяц.",
    "HuiYuanChangJianWenTi7": "4. Могут ли изменяться преимущества от уровней?",
    "HuiYuanChangJianWenTi8": "Да, преимущества напрямую зависят от уровня участника, чем выше уровень, тем больше преимуществ. Таким образом, преимущества участников могут изменяться в зависимости от уровня.",
    "HuiYuanChangJianWenTi9": "5. Будут ли добавлены новые преимущества?",
    "HuiYuanChangJianWenTi10": "Да, будут. Мы продолжаем совершенствовать нашу программу лояльности чтобы предоставить Вам еще больше преимуществ, следите за нашими обновлениями!",
    "YouXiaoDingDanLeiJiChengJiaoE": "Действующие заказы {0},Общая сумма покупок за период {1}{2}",
    "QuXiaDanChengWeiHuiYuan": "Перейдите  к размещению заказа",
    "DengJiShuJuMeiYue1Ri0DianGengXin": "Уровни обновляются каждый месяц  1 числа.",
    "RuGuoBaoChiDangQianDeChengJiaoLiang": "При поддержании текущей активности в следующем месяце вы достигнете Уровня {0}.",
    "XinKeHuShouCiXiaDanKeXiangShou": "Специальные условия на первый заказ для новых клиентов! Подробнее >>",
    "TaiBangLeNiYiJingManJiLe": "Отлично! Вы стали участником программы лояльности.",
    "GongXiNiXiaYueJiangShengJiDaoN": "Поздравляем! В следующем месяце вы перейдете на Уровень {0}.",
    "ShengJiDaoLvNHaiXuXiaDanNCi": "Для перехода на Уровень {0} необходимо сделать еще <b>{1} заказа</b></span> в этом месяце",
    "ShengJiDaoLvNHaiXuXiaDanN": "Для перехода на Уровень {0} в этом месяце вам еще нужно заказать  на сумму {1} {2}",
    "NiHaiBuShiHuiYuan": "Вы пока не являетесь участником, для начала необходимо сделать <b>{0} (первый) заказ</b>",
    "ESSAONEShouY": "Главная страница ESSAONE",
    "JiFenBianDong": "Изменение",
    "JiFenYuE": "Остаток баллов",
    "DangQianYiXiaDanNCi": "Количество действующих заказов {0}, на сумму {1} {2}",
    "JiFen": "баллов",
    "ShengJiHuiYuanXiangShouGengDuoQuanYi": "Повышайте уровень и получайте больше преимуществ",
    "DingDanJiangLiZuiGaoDiKou": "Кэшбек за заказ {0}, можно оплатить баллами {1}",
    "ZengJia": "Добавить",
    "DangQianJiFen": "Текущий баланс баллов",
    "JiFenXiang": "Тип начисления баллов",
    "QingXuanZeJiFenXiang": "Выберите тип начисления баллов",
    "JiFenGuanLi": "Управление баллами",
    "JiFenZhi": "Соотношение баллов",
    "JiFenTiXiWanShanGongSiXinXiKeYiHuoDeJiFen": "Система баллов, заполните всю информацию о компании чтобы получить баллы.",
    "NinDeDingDanYiTiJiaoQingZ2": "Ваш заказ сформирован, пожалуйста внесите депозит в течение <i>{0}</i> дней для его подтверждения",
    "XuZhiFuDingJin": "Депозит к оплате",
    "JiFenDiKou": "Оплата баллами",
    "DangYueHeQian5Yue": "Общая сумма заказов за полгода (за текущий и предыдущие 5 месяцев)",
    "DangQianJiFenNBenDanWeiKuan": "Текущий баланс баллов {0}, к данному заказу можно применить до {1}  баллов для уменьшения закрывающего платежа на сумму {2} {3}.",
    "ZhiFuWeiKuanShiShiYongJiFen": "При оплате закрывающего платежа использовать баллы для вычета соответствующей суммы.",
    "ShiJiDiKouJiangYiZhiFuWeiKuan": "Внимание: точное количество баллов к списанию, будет известно во время оплаты закрывающего платежа по заказу.",
    "ZhiFuDinDanXianYiZhiChiJiFen": "К заказу можно применить баллы для оплаты депозита, максимальный процент оплаты баллами  составляет 8% от суммы заказа.",
    "QianWangJiFenZhongXin": "Перейти к Разделу бонусов",
    "NDan": "Количество заказов {0}",
    "JiFenChangJianWenTi": "Подробнее о баллов",
    "JiFenChangJianWenTi1": "1. Что такое баллы?",
    "JiFenChangJianWenTi2": "Баллы — это вознаграждение, которое пользователи получают за заказы или выполнение определенных заданий на площадке. Баллы можно использовать при совершении следующего заказа. Российская Федерация—Каждый полученный балл приравнивается к рублю из расчета 1 балл = 1 рубль. Республика Беларусь—30 балл = 1 бел.руб.",
    "JiFenChangJianWenTi3": "2. Как получить баллы?",
    "JiFenChangJianWenTi4": "Участники могут зарабатывать баллы, размещая заказы или выполняя задания, представленные на площадке.",
    "JiFenChangJianWenTi5": "3. Когда будут начислены баллы?",
    "JiFenChangJianWenTi6": "Баллы начисляются в двух ситуациях:",
    "JiFenChangJianWenTi7": "(1) За выполнение заданий, представленных на площадке, баллы начисляются системой автоматически. Эти баллы участники могут использовать сразу после их начисления.",
    "JiFenChangJianWenTi8": "(2) Баллы за размещение заказа. Когда участник только размещает заказ, система начислит баллы в ближайшее время, но до внесения закрывающего платежа они будут недоступны. Баллы за размещенные заказы становятся активными только после выполнения заказа, то есть после внесения закрывающего платежа.",
    "JiFenChangJianWenTi9": "4. Сколько баллов я могу использовать за заказ?",
    "JiFenChangJianWenTi10": "Количество баллов, доступных к использованию в заказе, зависит от уровня участника и от того, сколько баллов у участника имеется в настоящее время.",
    "JiFenChangJianWenTi11": "Максимальная сумма, которую можно оплатить баллами = общая сумма заказа x процент (%) баллов, соответствующий текущему уровню участника. Если при оформлении заказа, имеющееся количество баллов у участника меньше максимальной суммы, которую можно оплатить баллами, то спишется все имеющееся количество баллов.",
    "JiFenChangJianWenTi12": "5. Как использовать баллы?",
    "JiFenChangJianWenTi13": "При оформлении заказа участник самостоятельно выбирает списывать ему баллы или нет. По умолчанию баллы не списываются. Если при оформлении заказа будут применены баллы, то сумма заказа автоматически уменьшится на максимальное количество баллов, которое можно применить, баланс баллов уменьшится соответственно.",
    "JiFenChangJianWenTi14": "6. Можно ли вернуть баллы после использования?",
    "JiFenChangJianWenTi15": "После того, как вы выберете использовать баллы при оплате заказа, их можно будет вернуть только в том случае, если все товары из оформленного заказе будут отменены по причинам, не связанным с клиентом. В остальных случаях возврат баллов не производится.",
    "XuZhiFu": "Ожидается оплата",
    "JiFenKeDiKou": "Можно оплатить баллами",
    "QingGouXuanDingDan": "Пожалуйста, выберите заказ",
    "ShiYongJiFenDiKou": "Использовать {0}  баллов, для оплаты {1}",
    "XiuGaiGongSiXinXiChengGongJiFen": "За заполнение информации о компании вы получаете {0} баллов.",
    "WanChengGaiDingDanYuJiKeYiJiangLiJiFen": "При завершении данного заказа вы получите <b>+{0}</b> баллов",
    "WoMenTiGong30TianMianFeiCangChu": "Мы предоставляем бесплатное 30 дневное хранение товара на складе по его прибытии.",
    "LiuLanShangPinJiFen": "За просмотр товаров на площадке вы получаете {0}баллов.",
    "JiFenChangJianWenTi16": "7. Когда истечет срок действия баллов?",
    "JiFenChangJianWenTi17": "Система удаляет неиспользованные баллы два раза в год.",
    "JiFenChangJianWenTi18": "- 30 июня будут обнулены баллы, не использованные во второй половине предыдущего года. Например, 30 июня 2023 г. будут удалены неиспользованные баллы за период с 1 июля 2022 г. по 31 декабря 2022 г.",
    "JiFenChangJianWenTi19": "- 31 декабря обнуляются неиспользованные баллы за первую половину текущего года. Например, 31 декабря 2023 г. будут удалены неиспользованные баллы с 1 января 2023 г. по 30 июня 2023 г.",
    "JiFenChangJianWenTi20": "8. Использовать баллы могут только участники программы?",
    "JiFenChangJianWenTi21": "Да, только участники могут использовать баллы для окончательной оплаты заказа.",
    "JiFenChangJianWenTi22": "9. Будут ли изменены правила расчета баллов?",
    "JiFenChangJianWenTi23": "Наша платформа вносит изменения в зависимости от скорости развития. В случае необходимости мы скорректируем правила начисления баллов и обязательно предварительно сообщим Вам об этом. Скорректированные новые правила вступят в силу после объявления. Если у Вас остались какие-либо вопросы, пожалуйста, свяжитесь со службой поддержки клиентов для консультации.",
    "JiaRuGouWuCheChengGongJiFen": "Товар добавлен в корзину, начислено {0} баллов",
    "GongXiNiShengJiDao": "Поздравляем с переходом на новый уровень",
    "DuiBuQiShangPinYiTingShou": "Извините, товар {0} снят с производства",
    "XuanZeLiNiZuiJinDeTiHuoCangKu": "Выберите ближайший склад",
    "CangKuDiZhi": "Адрес склада:",
    "ShiHe": "Рекомендуемые области:",
    "HuoWuSongDaoCangKuHou": "При поступлении товара на склад вы можете забрать товар самостоятельно или заказать забор транспортной компанией (оплачивается клиентом).",
    "YouYuYunShuFangShiHeLuTuBuTong": "Из-за различных логистических цепей и территориальных особенностей, смена склада может повлиять на ассортимент и стоимость товара, а также условия доставки.",
    "BaoQingGuanWuLiuMenDaoMenFuWu": "Включает НДС, таможенную пошлину и доставку от производителя в Китае до склада в Москве/Владивосток.",
    "QueRenTiHuoCangKu": "Подтверждение склада",
    "XiaDanFanJiFen": "Кэшбек баллами за каждый заказ",
    "JiFenDangQianHua": "Используйте свои баллы как деньги",
    "ShengJiYouJiangLi": "Награда за повышение уровня",
    "ZhuanShuKeFu1": "Эксклюзивное обслуживание 1 на 1",
    "JuTiQuanYiShiHuiYua": "* Предоставляемые преимущества зависят от уровня участника. Чем выше уровень, тем больше преимуществ. Оставайтесь с нами, чтобы получать больше преимуществ!",
    "JiaoYiChengGong": "Внесите платеж",
    "YiCiDingGouZhongShenHuiYuan": "Один заказ – и вы получите пожизненные преимущества участника",
    "RuHeChengWeiHuiYuan": "Как стать участником",
    "HuiYuanJiFen": "Баллы участника",
    "WanShanXinXiSongJiFen": "Заполните всю информацию о компании в личном кабинете",
    "GuanZhuSheJiaoZhangHaoSongJiFen": "Подпишитесь на наши соцсети",
    "MeiTianLiuLanShangPinSongJiFen": "Просматривайте новые товары каждый день",
    "MeiCiJiaGouSongJiFen": "Добавьте товар в корзину",
    "MeiBiDingDanFanJiFen": "Кэшбек за каждый заказ Кэшбек баллами",
    "MeiYueXiaDanJiangJiFen": "Размещайте заказы ежемесячно",
    "LiaoJieGengDuoJiFenXinXi": "Узнать подробнее о баллов",
    "TeBieShuoMing": "специальное примечание",
    "TeBieShuoMing1": "1. Программа лояльности VIP-клуб ESSAONE вступает в силу с даты публикации информации о системе.",
    "TeBieShuoMing2": "2. Для получения подробной информации о программе лояльности и правилах начисления баллов, вы можете перейти в разделы «{0}» и «{1}» в личном кабинете.",
    "TeBieShuoMing3": "3. Наша площадка может корректировать программу лояльности VIP-клуб ESSAONE и правила начисления баллов в соответствии с развитием площадки, мы обязательно объявим об этом в день, когда правила будут скорректированы. Новые скорректированные правила вступят в силу только после предварительного объявления о них.",
    "TeBieShuoMing4": "4. Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь со службой поддержки для консультации. Право на интерпретацию представленной информации принадлежит ESSAONE.",
    "TeBieShuoMing5": "Добро пожаловать в программу лояльности ESSAONE, зарабатывайте и получайте больше преимуществ вместе с нами!",
    "HuiYuanDengJi": "Уровни участников",
    "LeiJiJiaoYiEWeiQueRen": "* Действующим считается заказ, за который уже внесен депозит. Общая сумма заказа равна общей сумме действующих заказов.",
    "Lv1YaoQiu": "<div><p>1 действующих</p><p>заказа</p></div>",
    "Lv2YaoQiu": "<div><p>3 действующих</p><p>заказа</p></div>",
    "Lv3YaoQiu": "<div><p>Общая сумма заказов</p><p>≥500,000₽</p></div>",
    "Lv4YaoQiu": "<div><p>Общая сумма заказов</p><p>≥1,000,000₽</p></div>",
    "L51YaoQiu": "<div><p>Общая сумма заказов</p><p>≥2,000,000₽</p></div>",
    "Lv6YaoQiu": "<div><p>Общая сумма заказов</p><p>≥3,500,000₽</p></div>",
    "Lv7YaoQiu": "<div><p>Общая сумма заказов</p><p>≥5,000,000₽</p></div>",
    "ChaXunWoDeHuiYuanDengJi": "Посмотреть мой уровень участника",
    "EssaOneVip": "VIP-клуб ESSAONE",
    "CangKuTuiJian1": "Подходит для всех клиентов ЦФО, СЗФО, ЮФО, ПФО, УФО, СКФО",
    "CangKuTuiJian2": "Подходит для всех клиентов СФО, ДвФО.",
    "MskCangKu": "Московская область, Домодедовский район, деревня Шишкино 49",
    "HswCangKu": "690074, Приморский край, г. Владивосток, Первореченский район, ул. Выселковая д. 54 «А»",
    "KouJian": "Вычесть",
    "JiFenXiangYiChaoChuShangXian": "Превышено максимальное количество баллов",
    "JiFenXiangPeiZhiYouWu": "Ошибка в распределении баллов",
    "WoDeHuiYuanDengJi": "Мой уровень членства",
    "NiHaiBuShiHuiYuan2": "Вы пока не являетесь участником.",
    "YaoQingYouLi2": "Получи скидку",
    "ShiFu": "Фактическая оплата",
    "1059PR10027": "Требуется устранение неполадок с заказом",
    "QingXuanZeCangKu": "Пожалуйста, выберите склад",
    "NiDeWenTiDeDaAnKeYiZaiZheLiZhaoDao": "Ответ на ваш вопрос можно найти здесь",
    "ReMenNeiRong": "Информация по разделам",
    "ESSAONEJianJie": "Об ESSAONE",
    "ZhongGuoB2BZaiXianJiaoYiPingTai": "ОПТОВЫЙ КИТАЙСКИЙ МАРКЕТПЛЕЙС",
    "DingGou": "Заказ",
    "FuKuan": "Оплата",
    "QianBaoShiYongZhiNan": "Инструкции по использованию аккаунта",
    "BaoZhang": "Гарантии",
    "JiaGeShiXiaoZhiLiangBaoZhang": "Цены/ Сроков поставки/ Качества",
    "FenXiaoTuiGuang": "Агентская программа",
    "ShouDanZuiGaoYouHui": "Депозит первого заказа 10%!",
    "MeiGeRenDouKeYiTongGuoESSAONEZhengQian!": "Каждый сможет заработать вместе с ESSAONE!",
    "ZhaoBuDaoWenTiDeDaAnMa": "Не нашли ответ на свой вопрос?",
    "ZaiXianLiaoTianGeiWoMenLiuYan": "Отправьте сообщение в онлайн-чате, и мы оперативно ответим.",
    "PingTaiYuHeZuo": "Об ESSAONE и сотрудничестве",
    "ShangPinYuJiaGe": "Продукт и цена",
    "DingGouYuZhiFu": "Заказ и оплата",
    "JiaoFuYuShouHou": "Доставка и послепродажное обслуживание",
    "HelpTab1Question1": "ESSAONE.COM - это сайт! Есть ли юридическое лицо? Где находится?",
    "HelpTab1Question2": "Я никогда не слышал  о площадке и компании, могу ли я Вам доверять?",
    "HelpTab1Question3": "Есть ли у ESSAONE физический офис, склад в Москве?",
    "HelpTab1Question4": "У ESSAONE сертификаты на товары есть?",
    "HelpTab1Question5": "ESSAONE доставлет товары через карго?",
    "HelpTab1Question6": "Где гарантия, что я получу свой заказ?",
    "HelpTab1Answer1": "Площадка ESSAONE.COM принадлежит одноимённой китайской компании GUANDONG ESSA TECHNOLOGY CO., LTD. Главный офис компании находится в г. Гуанчжоу, Китай. На территории РФ все функции по работе с контрагентами выполняет ООО \"ЭССАВАН\", чей офис расположен в г. Москва.",
    "HelpTab1Answer2": "С момента создания площадки ESSAONE прошло 8 лет. Мы являемся одним из ведущих поставщиков товаров для детей в РФ. Мы предоставляем уникальную возможность малому и среднему бизнесу напрямую сотрудничать с китайскими фабриками: получать  более выгодные цены, оригинальные и практичные товары. ESSAONE выступает в качестве дополнительного канала для закупок из Китая.   Вы можете найти товарные новинки, которые раньше не были представлены, а также расширить ассортимент и повысить  Вашу конкурентоспособность на рынке.",
    "HelpTab1Answer3": "Да. Наш офис находится в БП «Румянцево», корпус Б, подъезд 5, этаж 4, офис с табличкой ESSAONE. Данные по складу всегда можно запросить у наших менеджеров.",
    "HelpTab1Answer4": "Да, каждая поставка сопровождается полным пакетом закрывающих документов, в том числе, в обязательном порядке, пакетом соответствующих сертификатов ТР ТС 008/2011.",
    "HelpTab1Answer5": "Нет, мы доставляем  товары  в соответствии с Таможенным Законодательством ЕАЭС: с прохождением процедуры официальной таможенной очистки, уплатой налогов, а также наличием закрывающих документов.",
    "HelpTab1Answer6": "Покупатель подписывает договор поставки с представительством ESSAONE.COM, компанией-резидентом РФ - ООО \"ЭССАВАН\". Соответственно, вся коммерческая деятельность ведётся между двумя субъектами Российской Федерации. Вся деятельность происходит в рамках действующего законодательства РФ.",
    "HelpTab2Question1": "Что входит в стоимость заказа?",
    "HelpTab2Question2": "Цены действительно в рублях?",
    "HelpTab2Question3": "Цена окончательная? Что-то ещё нужно доплачивать?",
    "HelpTab2Question4": "Как быстро найти продукт, который я хочу?",
    "HelpTab2Question5": "Что делать, если не нашел нужный товар на сайте?",
    "HelpTab2Question6": "Что такое 1 коробка? Это 1 штука?",
    "HelpTab2Question7": "Вы можете отправить образец?",
    "HelpTab2Answer1": "<div> <p>Цена за одну экспортную коробку. </p> <p>Доставка из Китая до склада в г. Москва/Владивосток. </p> <p>Таможенное оформление (включая НДС). </p> <p>Сертификаты соответствия ТР ТС. </p> <p>Никаких дополнительных издержек.</p> </div>",
    "HelpTab2Answer2": "Да, все цены представлены в рублях.",
    "HelpTab2Answer3": "Да, цена, указанная на сайте, является окончательной. Доставка товара осуществляется до нашего склада, далее идет самовывоз или доставка транспортной компанией (за счет покупателя).",
    "HelpTab2Answer4": "Поиск товаров расположен в верхней части сайта.  Поиск может быть осуществлен по артикулу, названию товара, категории или по изображению товара.",
    "HelpTab2Answer5": "Перейдите в каталог и нажмите на «Не нашли нужный товар?» , указать ссылки на товар, данные о поставщиках, характеристики товара, количество деталей и другую информацию.Мы сообщим вам о результатах по электронной почте.",
    "HelpTab2Answer6": "Речь идет об экспортной коробке. Количество штук в каждой коробке указано в карточке товара на сайте.",
    "HelpTab2Answer7": "Мы не отправлем образцы.  Все фабрики проходят обязательную проверку на территории Китая. У нас  есть соответствующий отдел контроля качества для проверки товаров перед отправкой.Мы предоставляем гарантии на товар и его транспортировку из Китая до склада в г. Москва.",
    "HelpTab3Question1": "Как оформить заказ?",
    "HelpTab3Question2": "Можно ли заказать несколько штук?",
    "HelpTab3Question3": "Для некоторых товаров минимальный объем составляет 2-3 коробки, можно ли заказать только одну коробку?",
    "HelpTab3Question4": "Как происходит оплата?",
    "HelpTab3Question5": "Вы работаете с отсрочкой платежа?",
    "HelpTab3Question6": "Я сделал заказ, предоплату не вносил, хочу отменить заказ. Как это сделать?",
    "HelpTab3Question7": "Могу ли изменить заказ после предоплаты?",
    "HelpTab3Question8": "Когда я получу заказ после предоплаты?",
    "HelpTab3Question9": "Если я сегодня оплачу, то когда будет отгружен товар из Китая?",
    "HelpTab3Answer1": "Выберите нужные товары на площадке, укажите количество, цвет, размер, добавьте в корзину и дождитесь подтверждения от фабрики, после подтверждения запроса нажмите кнопку \"Перейти к заказу\". На странице заказа заполните Вашу информацию и нажимаете кнопку\"Отправить заказ\".",
    "HelpTab3Answer2": "Нет. Минимальный заказ - одна экспортная коробка.",
    "HelpTab3Answer3": "Можно, после получения подтверждения от фабрики. Для этого Вам необходимо добавить товар в корзину и отправить вопрос фабрике, при получении подтверждения - Вы сможете разместить заказ.",
    "HelpTab3Answer4": "<div> <p>1. Перед оплатой покупатель подписывает договор поставки с представительством ESSAONE.COM в РФ - ООО \"ЭССАВАН\".</p> <p>2. Далее необходимо скачать счет на площадке ESSAONE и произвести безналичную оплату по реквизитам.</p> <p>3. После поступления на расчетный счет, денежные средства будут зачислены в Ваш электронный кошелек в личном кабинете ESSAONE, после чего Вы сможете использовать их для оплаты депозита и закрывающих платежей .</p> </div>",
    "HelpTab3Answer5": "Нет, все заказы передаются в производство толькл после внесения предоплаты. После получения полной оплаты, заказ передается клиенту.",
    "HelpTab3Answer6": "Вы можете отменить заказ перейдя в раздел  “Мои заказы”.",
    "HelpTab3Answer7": "Нет, необходимо внимательно проверить все позиции перед внесением предоплаты.",
    "HelpTab3Answer8": "Заказы подтверждаются после предоплаты, также будет отображаться обновленное расчетное время прибытия.",
    "HelpTab3Answer9": "Это зависит от срока производства и доставки до склада загрузки. На площадке в каждой карточке товара указаны сроки производства, а также ориентировочные сроки поставки.",
    "HelpTab4Question1": "Как осуществляется доставка? Как можно получить товары?",
    "HelpTab4Question2": "Можно ли на сайтe essaone.com  отслеживать статус моего заказа?",
    "HelpTab4Question3": "Какие гарантии?",
    "HelpTab4Question4": "Гарантируется ли качество? Что делать, если не устраивает качество?",
    "HelpTab4Question5": "Какие будут закрывающие документы?",
    "HelpTab4Answer1": "Контейнеры доставляются по 2 маршрутам: скоростными поездами по маршруту Китай – Москва или морская перевозка маршрут Китай –Владивосток. После поступления товара на склад идет самовывоз или забор груза транспортной компанией (оплачивается клиентом).",
    "HelpTab4Answer2": "Можно.  Площадка ESSAONE позволяет просматривать актуальную информацию о процессе заказа онлайн.  Вы можете перейти во вкладку  «Моя учетная запись» - «Мой заказ» в правом верхнем углу на главной странице. На странице списка заказов Вы сможете увидеть текущий статус вашего заказа. При нажатии на статус заказа появится дополнительная информация.",
    "HelpTab4Answer3": "<div> <p>Мы предоставляем гарантии на товар и его транспортировку из Китая до склада в г.Москва/Владивосток.</p> <p>Гарантия оптимальной цены — Купили дешевле - мы вернем разницу</p> <p>Гарантия поставки — Компенсация за задержку поставки</p> <p>Гарантия качества —Компенсация либо возврат полной стоимости</p> </div>",
    "HelpTab4Answer4": "У нас есть  гарантия качества, если возникнут проблемы с качеством, мы компенсируем или вернем  денежные средства исходя из конкретной ситуации.В случае обнаружения брака или недостачи, Вам необходимо составить рекламацию на сайте и приложить соответствующие ФОТО/ВИДЕО подтверждения для рассмотрения и нахождения оптимального решения.",
    "HelpTab4Answer5": "Мы предоставляем следующие документы: УПД и сертификаты в электронном формате, также в УПД будет указан номер ГТД  (Грузовая таможенная декларация) .",
    "PingTaiJiaoYiShuJu": "Данные по транзакциям на платформе",
    "YiZhiFuDingJinDingDanTongJi": "Статистика по заказам с внесенным депозитом",
    "WeiZhiFuDingDanTongJi": "Статистика по неоплаченным заказам",
    "WeiFuKuanJinE": "Сумма, ожидаемая к оплате",
    "WeiFuKuanYongHuShu": "Количество клиентов, не оплативших заказ",
    "BenYueYongHuTongJi": "Статистика по пользователям за месяц",
    "XiaDanKeHu": "Клиенты, оформившие заказ",
    "ZhuCeYouXiaoKeHu": "Действующие зарегистрированные клиенты",
    "DangJi": "За квартал",
    "DangNian": "В этом году",
    "ChengJiaoXinKeHu": "Новые клиенты, оформившие заказ",
    "DaiWanShan": "Ожидает завершения",
    "YiWanShan": "Завершено",
    "ShouSouShangPinBianHao": "Найти по артикулу товара",
    "XinYiPi": "Загрузить еще",
    "ShuXin": "Характеристики",
    "ZhiFuWeiKuan": "Внести окончательную оплату",
    "QingShuRuShangPinPinMin": "Введите название товара",
    "JiaFu": "Поставка товара",
    "YunShuYuPeiSong": "Логистика и доставка",
    "HuiYuanTiXi": "Программа лояльности",
    "JiaRuHuiYuanZunXiangTeQuan": "Станьте участником, получайте преимущества!",
    "HuoWuGenZong": "Отслеживание товара",
    "QuChaXun": "Посмотреть",
    "GengXinShiJian": "Время обновления",
    "TiDanXinXi": "Информация о коносаменте",
    "DianFang": "Телекс-релиз",
    "DianFangDanYuanZheng": "Телекс релиз",
    "KuaiDi": "Быстрая доставка",
    "KuaiDiDanSaoMiaoJian": "Сканированные копии логистики",
    "YiQueRenZengJiaGouMaiXiangShuKeXiaDan": "Подтверждено, увеличьте количество коробок чтобы разместить заказ",
    "ManJianMianQiSongFei": "При заказе от {0} коробок доставка бесплатная {1}",
    "BuManJianGongYingShangXuJiaShouQiSongFei": "При покупке менее {0} коробок поставщик взимает дополнительную плату за доставку в размере {1}. Бесплатная доставка при заказе от {0} коробок",
    "HunPiCaiGou": "Смешанная закупка",
    "YiJiangJia": "Цена снижена",
    "GouMaiXiangShuXiaoYuGongChangYaoQiu": "Количество добавленных коробок меньше заводского требования, ожидание подтверждения фабрики",
    "ShangPinYiShiXiao": "Товар больше не доступен",
    "GaiShangPinYiGuoJiaGeBaoH2": "Срок фиксации цены истек, вы можете снова обратиться к фабрике для подтверждения цены",
    "SouSuoGouWuShangPin": "Поиск товаров",
    "YouHaoTuiJian": "Рекомендации для Вас",
    "JiaGeYouXiaoQiZhi": "Цена зафиксирована до",
    "YiZaiGouWuChe": "Уже добавлено в корзину",
    "GaiGongYingShangDeShangPinBuManJian": "При заказе менее {0} коробок у данного поставщика, будет взиматься плата за доставку в размере {1}",
    "JiXuXiaDanHuiChanShengEWaiDeQiSongFei": "При заказе только этих товаров будет взиматься дополнительная плата за доставку",
    "HanZengZhiShuiFei": "с учетом НДС",
    "QiSongFei": "Стоимость доставки",
    "GaiGongYingShangDeShangPinBuManJian2": "Поставщик взимает плату за доставку в размере {0}. Для бесплатной доставки закажите у этого поставщика от {1} коробок",
    "LianHeDingGou1": "Меньший объем можно заказать на совместной закупке, период ожидания участников закупки {0} дней",
    "LianHeDingGou2": "Участвовать в совместной закупке",
    "GongYingShangHunPinQiYunFeiTiShi": "Оповещение о стоимости доставки при смешенной покупке у производителя",
    "GongYingShangSuoYouChanPin": "Все товары фабрики",
    "ManMianQiSongFei": "от {0} коробок доставка бесплатная",
    "HuanYingDengLuGongZuoTai": "Добро пожаловать в админку",
    "JiFenYuJiKeDiKou": "Ожидается, что баллы могут быть использованы для вычета",
    "HanQiSongFei": "Включая стоимость доставки",
    "PinTuanChengGongHouFanHui": "Баллы можно использовать в качестве залога при участии в совместной закупке. После оплаты денежного депозита, использованные баллы будут возвращены.",
    "JiFenDiYa": "Депозит баллами",
    "JiFenDiKouWeiKuan": "Применение баллов к окончательному платежу",
    "ZengZhiShuiE": "сумма НДС",
    "YiDingGou": "Уже заказано",
    "YiGengShaoZhuangLiangLianHeDingGou": "Заказать меньшее количество можно на совместной закупке. Время ожидания участников составляет {0}  дней. Если наберется достаточно желающих, заказ будет сформирован.",
    "CanYuLianHeDingGou": "Участвовать в совместных закупках",
    "GroupTip": "Чтобы каждый желающий клиент мог присоединиться к совместному заказу, установлено время ожидания в течение 7 дней, если за время действия закупки наберется достаточное количество клиентов, то заказ будет успешно сформирован и отправится фабрике на производство. В противном случае заказ не сформируется. Внесенный депозит или использованные баллы будут возвращены.",
    "ManJianMianQiSongFei2": "от {0} коробок, доставка бесплатная {0}",
    "ChaoJiYouHui": "Уникальные скидки",
    "XinKeHuZhuanXiang": "Только для новых клиентов",
    "XinKeHuZhuanXiangBiaoTi1": "Дарим {0} купона за регистрацию. Воспользуйтесь скидкой 4% на первый заказ!",
    "XinKeHuZhuanXiangFuBiaoTi1": "Купоны выдаются после успешной регистрации и действуют в течение 30 дней.",
    "XinKeHuZhuanXiangBiaoTi2": "Пробный заказ без рисков. Депозит на первый заказ составляет всего {0} от общей суммы!",
    "XinKeHuZhuanXiangFuBiaoTi2": "Данные условия действуют только на первый заказ (кроме заказов по специальному предложению). Каждый новый клиент может воспользоваться предложением только 1 раз.",
    "XinKeHuZhuanXiangBiaoTi3": "После оформления первого заказа вы получите еще {0} купона.",
    "XinKeHuZhuanXiangFuBiaoTi3": "Купоны будут выданы после оплаты депозита за первый заказ и будут действительны в течение 90 дней.",
    "XinKeHuZhuanXiangBiaoTi4": "Сделав первый заказ, в следующем месяце Вы автоматически становитесь участником программы лояльности ESSAONE, закупайтесь с еще большей выгодой!",
    "XinKeHuZhuanXiangFuBiaoTi4": "Заказав однажды – получаете преимущества навсегда. Участники получают больше баллов и заказывают товары со скидками!",
    "MaShangXiaDan": "Воспользуйтесь всеми предложениями, оформите заказ прямо сейчас!",
    "ZhuYiShiXiang": "Примечания:",
    "XinKeHuZhuanXiangZhuYiShiXiangNeiRong": "1. Воспользоваться этим предложением могут только пользователи, которые зарегистрировались на ESSAONE, но еще не разместили первый заказ. <br />2. Купоны не суммируются, в каждом заказе можно использовать только один купон. При оформлении заказа система по умолчанию будет использовать тот, у которого наибольшая сумма скидки, исходя из доступных на данный момент купонов. <br /> 3. Использованные купоны не возвращаются, кроме случая полной отмены заказа по причинам, независящим от клиента. Если отменяется только часть заказа, купон не возвращается.",
    "DiYiBiDingDanBaoZhengJin": "Депозит первого заказа",
    "DingDanJinEBuXian": "без ограничения суммы заказа",
    "YiZeKou": "Оплата баллами",
    "XianShiXiaoShouJia": "Показать цену продажи",
    "XiaoShouJiaGeSheZhi": "Настройка цены продажи",
    "WoDeXiaoShouJia": "Моя цена продажи",
    "MaoLiLv": "Размер валовой прибыли",
    "ZengZhiShuiLv": "Ставка НДС",
    "HaiGuanShuiLv": "Таможенная пошлина",
    "ShaoHouZaiShi": "Попробуйте еще раз позже",
    "MaShangSheZhi": "Установить сейчас",
    "SheZhiWoDeJiaGe": "Установить мою цену",
    "ShiShiYuLanXiaoShouJiaGe": "Предварительный просмотр цены продажи в реальном времени, эта цена видна только вам и не повлияет на цену вашей покупки",
    "XiaoShouJiaGongShi": "Цена реализации = (цена FOB+ морской фрахт/шт. +сбор за таможенное оформление/шт.) × (1 +ставка таможенной пошлины) × (1 +размер валовой прибыли) × (1 +НДС)",
    "GenJuZhongGuoRenMinYinHangDeHuiLvMei24XiaoShiGengXin": "Обновление каждые 24 часа по курсу Народного банка Китая",
    "MeiYuan": "Доллар",
    "HaiYunFei / LuYunFei": "Морской фрахт / Наземный фрахт (долл. США)",
    "ZaiYeMianXianShiWoDeXiaoShouJia": "Показать мою цену продажи на странице",
    "QingGuanFei（HuoDaiFeiYong）": "Сборы за таможенное оформление (экспедиторские расходы) (USD)",
    "YuJiXiaoShouJia": "Предполагаемая цена продажи",
    "QingTianXieWanZhengDeBiTianXiang": "Пожалуйста, заполните все обязательные поля",
    "KaiQiShiShiYuLanWoDeYuJiXiaoShouJia": "Включить предварительный просмотр моей расчетной цены продажи в режиме реального времени",
    "ShiYongJiFenDiKouMaShangShengQian": "Используйте баллы для оплаты, покупайте выгодно",
    "DangQianJiFenKeShiYong": "Баланс баллов {0}, можно использовать {1} баллов для оплаты {2} {3}.",
    "DanQianHuiYuanDengJiZuiDaDiKou": "Ваш уровень лояльности Lv.{0}, можно оплатить баллами до {1}% от суммы заказа.",
    "DingJinBiLi": "Размер депозита",
    "GouXuanDeShangPinHanYouPinTuanShangPin": "Среди выбранных товаров имеются товары, участвующие в Совместной закупке, невозможно задать вопрос",
    "BuManZuGongChangQiDingLiangYaoQiu": "Не соответствует минимальным требованиям фабрики для заказа",
    "PinTuanShangPinBuNengChongXinXunJia": "По товарам, участвующим в Совместной закупке, нельзя повторно отправить запрос цены",
    "JiFenBuZu": "Недостаточно баллов",
    "ShiYongJiFen": "Использовать баллы",
    "YiDingJinDeFangShi": "в качестве депозита",
    "XuDiYaNJiFenChengGongShiBaiFanHui": "Заказ содержит товар с совместной закупки, необходимо внести залог {0} баллов для размещения заказа. В случае если совместная закупка не сформируется или после успешного формирования заказа будет внесен денежный депозит, то примененные баллы будут возвращены.",
    "XuNJiFenJiFenBuZuN": "В заказе имеются товары с совместной закупки, необходимо внести (0) баллов для размещения заказа. Текущий баланс баллов недостаточный {1}, вы можете подтвердить участие в совместном заказе, путем внесения денежного депозита в течение 3 дней.",
    "WoMenJinTiGong30TianMianFeiCangChu": "Пожалуйста, внесите полную оплату как можно скорее, мы предоставляем бесплатное хранение только в течение 30 дней",
    "TiHuoCangKu": "Склад забор товара",
    "DangQianJiFenNBenDanDiYa": "Текущий баланс баллов {0}, для этого заказа необходимо применить {1} баллов",
    "ZanWuFaQueRen": "Пока не ясно",
    "DinDanTongJi": "Статистика заказов",
    "SouSuoKeHuBianHaoHuoMinCheng": "Поиск по номеру или имени клиента",
    "ShengChangZhongDinDan": "Заказы в производстве",
    "DaiFuWeiKuanDinDan": "Ожидается оплата закрывающего платежа",
    "YiTiHuoDinDan": "Забранный заказ",
    "KeHuDeYuE": "Баланс клиента",
    "ShengChanZhongDingDan": "Заказы в производстве",
    "DaiFuWeiKuanDingDan": "Ожидается оплата закрывающего платежа",
    "YiTiHuoDingDan": "Товар получен",
    "ShouDan": "Первый заказ",
    "JiFenMeiXiangKeDiKou": "Баллами можно снизить стоимость каждой коробки на {0}",
    "RuGuoYouSanCuWenJian": "После подтверждения удаления файла, его нельзя будет восстановить или отменить удаление",
    "JiGuiWenJianGuanLi": "Управление документами на контейнеры",
    "ZhiCiWenJianGeShi": "Поддерживаемый формата файла {0}, максимальная размер {1} M",
    "HuanGuiWenJian": "Документы на возврат контейнера",
    "YiHuanGui": "Порожний контейнер сдан",
    "YunDanWenJian": "Отгрузочные документы",
    "QiTaWenJian": "Иные документы",
    "ShangChuanWenJian": "Загрузить документ",
    "DangQianJiFenNBenDanDiYaJiFenBuZhu": "Баланс баллов {0}, для этого заказа необходимо внести залог {1} баллов, текущего баланса баллов недостаточно для залога, пожалуйста, внесите денежный депозит для подтверждения участия.",
    "QueRenShengChanYaoQiuZhon2": "В процессе подтверждения требований к производству, количество не может быть изменено",
    "WoTongYi": "Я согласен",
    "YiZhiFuDingJinDaiChengTuan": "Депозит оплачен, ожидание формирования заказа",
    "GouMaiXiangShuXiaoYuGongChangYaoQiu2": "Завод подтверждает производственные требования и не может изменять количество.",
    "SouSuoKeHuDingDanJiGui": "Поиск клиента / заказа / контейнера",
    "JiFenShuoMing": "Описание баллов",
    "GenJuYongHuZhuYaoShiYongYuYanShuRuJiKe": "Пожалуйста, сообщите клиенту о происхождении этих баллов. Пожалуйста, обратите внимание на использование языка, привычного для клиента.",
    "FaPiaoShangDeBianHao": "№ в инвойсе",
    "HaiGuanDaiMa": "Код ТН ВЭД ЕАЭС",
    "ChanPinMiaoShu": "Описание продукта",
    "ShangBiao": "Товарные знаки",
    "XingHao": "Модель",
    "DaiMaDanWei": "Код ед.изм.",
    "JiLiangDanWei": "Единица измерения",
    "ZongXiangShu": "Общее количество мест",
    "ChengBen": "Стоимость",
    "JiaGeZhuanHuan": "Конвертация цен",
    "YunShuChongXinJiSuan": "Тр-е пересчет",
    "ZengZhiShui(ChongXinJiSuan)": "НДС, пересчет",
    "XuKeZhengWenJian": "Разрешительные документы",
    "ShangChuanTianCong": "Заполнить с помощью excel",
    "FeiYongChongXinJiSuan": "Пошлина, пересчет",
    "YuanYuJiZhuangGuiRiQi": "Исходная ориентировочная дата загрузки",
    "MingSKCangKu": "Минский район, Боровлянский с/с, ул. 40 лет Победы , 19 .",
    "CangKuTuiJian3": "Минский склад обслуживает клиентов во всех регионах Беларуси.",
    "BaiEXinRenYouHuiQuanTiShi1": "Только для новых клиентов",
    "BaiEXinRenYouHuiQuanTiShi2": "Дарим купон на скидку сразу после регистрации. Получите скидку до 5% на первый заказ!",
    "BaiEXinRenYouHuiQuanTiShi3": "Купоны выдаются после успешной регистрации и действуют в течение 30 дней.",
    "MaShangXiaDan2": "Предложение ограничено, заказывайте прямо сейчас!",
    "XinKeHuZhuanXiangZhuYiShiXiangNeiRong2": "1. Данная акция доступна только для новых пользователей, зарегистрированных на ESSAONE с 1 октябрь 2023 года.<br />2. Купоны не суммируются, к одному заказу можно применить только один купон. При оформлении заказа система по умолчанию предложит купон с наибольшей суммой, из всех имеющихся.<br />3. Использованные купоны не возвращаются, кроме случая полной отмены заказа по причинам, независящим от клиента. Если отменяется только часть заказа, купон не возвращается.",
    "BaiEGouWuCheAnNiu": "Заказы принимаются с 1 июня",
    "BaiEMeiYaoQing1WeiHaoYouZhuCeJiKeHuo": "Пригласите Вашего друга (не конкурента) и поделитесь с ним наградой!<br>Каждый, кто пригласит друга к регистрации и размещению первого заказа получит скидочный купон на сумму 750 BYN, а его пригашенный друг так же получит набор купонов.",
    "BaiEHaoYouZhuCeChengGongKeHuoDe": "После успешной регистрации Ваш друг сможет получить набор купонов на общую сумму 750 BYN.",
    "BaiENiKeDeYiZhangDaiJiHuoJuan": "После успешной регистрации друга, Вы сможете получить скидочный купон на сумму 750 BYN, но воспользоваться после того, как Ваш друг разместит заказ.",
    "ZuiJin": "Последнее",
    "GongZuoShiJian": "Время работы",
    "YiChang": "Заказы с изменениями",
    "DingDanXiaoXi": "Сообщения о заказе",
    "SouSuoDingDanBianHao": "Поиск номера заказа",
    "XiaDan": "Оформить заказ",
    "DingDanYiQuXiao": "Заказ отменен",
    "NKuanNXiang": "{0} штук, {1} коробок",
    "YiShangWeiBenDingDanXinXi": "Вышеуказанная информация относится к данному заказу.",
    "DingGouShuLiang": "Количество заказанных товаров",
    "ZengZhiShui": "Налог на добавленную стоимость",
    "JinEHanShui": "Сумма(включая налог)",
    "QingGuanDanHao": "Номер таможенной декларации",
    "SuoYouCangKu": "Все склады",
    "SheZhiQuanXian": "Настройка прав доступа",
    "KeYiShiYongNaXieGongNeng": "Какие функции можно использовать",
    "KeYiCaoZuoNaXieGuoJiaDeShuJu": "Какие данные стран можно обрабатывать",
    "CanYuNaXieRenWuFenPei": "Участие в каких задачах по распределению",
    "MuDiCangKu": "Целевой склад",
    "QueRenRuKu": "Подтверждение поступления на склад",
    "QingGuanDanDanHao": "Номер инвойса",
    "SuoZaiCangKu": "Находится на складе",
    "ShengChengDanJu": "Создать документ",
    "DiaoBo": "Передача",
    "DaiDiaoBo": "Ожидает передачи",
    "DiaoBoZhong": "В процессе передачи",
    "SouSuoPODanHaoHuoKeHuBianHao": "Поиск по номеру заказа или номеру клиента",
    "DangQianCangKu": "Текущий склад",
    "YiDaoDaiChuKu": "Переместить в ожидающие отгрузку",
    "HeJiNGeKeHuNGeDingDan": "Всего клиентов: {0}, заказов: {1}",
    "SouSuoGuoJia": "Поиск страны",
    "PiLiangDiaoBoDeDingDanCangKuShuJuXuYaoYiZhi": "Для заказа массовой отгрузки, данные на складе должны быть согласованы!",
    "QueDingYiDaoDaiChuKu": "Подтвердить перемещение в ожидающие отгрузку",
    "DiaoBoShiJian": "Время перемещения",
    "CheXiaoDiaoBo": "Отменить перемещение",
    "QueDinCheXiaoDiaoBo": "Подтвердить отмену перемещения",
    "RuKu": "Поступление на склад",
    "QueRenDiaoBoRuKu": "Подтверждение поступления перемещенных товаров на склад",
    "RuKuRiQi": "Дата поступления на склад",
    "RuKuChengGong": "Успешное поступление на склад",
    "JiFenZhangHu": "Счет бонусных баллов",
    "WoYaoZhaoYang": "Поиск образца",
    "MiaoShuNiYaoZhaoDeShangPin2": "Опишите продукт, который вы ищете",
    "MiaoShuXuYaoZhaoDeShangPi2": "Пожалуйста, введите описание",
    "YiYouZhiLiao2": "Предоставьте информацию / фотографии",
    "JieZhiRiQi": "Срок",
    "QingXuanZeJieZhiRiQi": "Пожалуйста, выберите срок",
    "NGeGongZuoRi": "{0} рабочих дней",
    "SheDingRenWuBiXuZaiDuoShaoGeGong": "Установите количество рабочих дней, в течение которых задание должно быть выполнено (дней)",
    "JiXuFaBu": "Продолжить публикацию",
    "ZhaoYangRenWuYiFaBuChengGong": "Задание на поиск образца было успешно размещено, вы можете перейти в раздел Мой поиск образца, чтобы просмотреть его.",
    "DangQianZhangHuWeiRenZheng": "Если ваша учетная запись не сертифицирована, вы не получите ответ на задание.",
    "QianWangRenZheng": "Перейти к аутентификации",
    "DangQianZhangHuDaiRenZheng": "Текущая учетная запись находится на стадии сертификации, и задание на поиск образца не получит ответа.",
    "RenWuFenPeiZhong": "Распределение задач",
    "YiGuaQi": "Приостановлено",
    "QingXuanZeYaoCaoZuoDeShuJu": "Пожалуйста, выберите данные",
    "KeHuQianBao": "Кошелек клиента",
    "KeHuDangQianQianBaoSuoShuGuoJia": "Страна, к которой относится текущий кошелек клиента",
    "ZanMeiQueRen": "Не подтверждено",
    "SuoShuGuoJia": "Страна принадлежности",
    "WuQuanXian": "Нет разрешения",
    "ZhangHuGuoJia": "Страна учетной записи",
    "YiChuHuoJiGui": "Контейнер отгружен",
    "YuChuHuoJiGui": "Контейнер в процессе отгрузки",
    "DengLuMing": "Логин",
    "JiFenDuiHuan": "Обмен бонусными баллами",
    "ShangPingZhengShuBianHaoChongFu": "Номер сертификата продукта дублируется",
    "QingShuRuZhengShuBianHao": "Введите номер сертификата / примечание для поиска",
    "YouXiaoQiZhi": "Срок действия до",
    "QingXuanZeShiFouYouShangPinZhengShu": "Выберите, есть ли товарный сертификат",
    "QingXuanZeShangPinZhengShu": "Выберите товарный сертификат",
    "HaiGuanShangPinBiaoMiaoShu": "Описание таможенной товарной таблицы",
    "ShiYongLeiMu": "Применяемая категория",
    "ZhengShuBianHao": "Номер сертификата",
    "ZhengShuBeiZhu": "Примечание к сертификату",
    "ZhengShuWenJian": "Файл сертификата",
    "ZuiDuoShangChuan5Zhang": "Максимум 5 файлов, меньше 10 Мб .pdf, .jpg, .jpeg, .png",
    "QingXuanZeShiFouYouZhengShu": "Выберите, есть ли сертификат",
    "NinShangWeiXuanZeZhengShu": "Вы не выбрали сертификат",
    "WuZhengShuChuHuo": "Сертификат не требуется",
    "ZhengShuGuanLi": "Управление сертификатами",
    "XinZengZhengShu": "Добавление нового сертификата",
    "ShuXing": "Атрибут",
    "SouSuoShangPinBianHao": "Поиск по номеру товара",
    "ZuiDuoZhiNengShangChuan5GeWenJian": "Максимум можно загрузить 5 файлов",
    "ChongXinSheZhiTieZhi": "Переустановить наклейку",
    "HuanYingDengLu": "Добро пожаловать",
    "ZhuCeXinZhangHao": "Регистрация нового аккаунта",
    "PinTuanShuoMing": "Инструкции совместной закупки",
    "HuaGengShaoDeQianCaiGouGengDuoKuanShi": "Приобретайте больше стилей за меньшие деньги.",
    "QuXiaoZhaoYang2": "Отменить поиск образцов",
    "ZhaoDaoDeShangPin": "Найдены продукты",
    "DaoChuQuanBuShangPin": "Экспортировать все продукты",
    "DaoChuSuoXuanShangPin": "Экспортировать выбранные продукты",
    "QuXiaoXuanZe": "Отменить выбор",
    "BuChongZiLiaoTuPian": "Дополнительная информация/изображения",
    "YanQiZhi": "Отложено на {0}",
    "JueDeDangQianJieGuoBuGouManYi": "Неудовлетворенность текущими результатами",
    "BuChongMiaoShu": "Дополнительное описание",
    "QingBuChongMiaoShu": "Пожалуйста, добавьте описание",
    "ShangChuanWenJian2": "Загрузка файлов, поддержка изображений/сжатых пакетов/Excel, поддержка одного файла до 200M, загрузка до 5 файлов",
    "YanQi": "Расширение",
    "QingXuanZeYanChiDuoShaoGeGongZuoRi": "Пожалуйста, выберите, на сколько рабочих дней отложить",
    "YanQiXinXi": "Информация о продлении",
    "RenWuYanQi": "Продление миссии",
    "YanQiChengGong": "Отсрочка успешна!",
    "MeiYouTuiJianShangPin": "Нет рекомендаций по товарам",
    "NTianHouRenWuJieShu": "Задача заканчивается через {0} дней",
    "YiZhaoDao": "Найдено",
    "KuaJingB2BXinPinCaiGouPingTai": "Платформа для закупок новых товаров B2B - Производство в Китае, Игрушки, Товары для спорта и активного образа жизни, Товары для активного отдыха на открытом воздухе, Товары для праздников",
    "XinYongHuMianFeiZhuCeZhangHao": "Бесплатная регистрация моей учетной записи",
    "QingShuRuYouXiang": "Пожалуйста, введите вашу электронную почту",
    "YouXiang2": "э-почта",
    "YiYouZhangHao": "Уже есть аккаунт?",
    "YouXiangYanZhengMa": "Почтовый код",
    "YiFaSong": "Отправлено",
    "QingShuRuYouXiaoDeGongSiMingCheng": "Пожалуйста, введите действительное название компании.",
    "FaQiZhaoYang": "Запрос на поиск товара",
    "TuiJianZhuTiMingCheng2": "Поиск предыдущих рекомендаций",
    "JinTian": "Сегодня",
    "YiZhaoWan": "завершено",
    "HaiGuanGuanQiaTongXingJianChaZhan": "До {0} пункта таможенного оформления: {1} ({2} км)",
    "HangXianMingCheng": "Название маршрута",
    "BuManYiYuanYin": "Причины неудовлетворенности",
    "QingTianXieBuManYiYuanYin": "Пожалуйста, укажите причину неудовлетворенности",
    "JieGuoBuManYi": "Неудовлетворенность результатами",
    "FaQiRenDuiZhaoYangJieGuoBuManYi": "Инициатор не удовлетворен результатами образцов.",
    "KeYuYueTiHuo": "Возможна запись на прием",
    "YiFaHu": "Отправлено",
    "DaiYuYue": "Будет забронировано",
    "YuYueTiHuo": "Запланировать отгрузку",
    "NiZhunBeiRuHeTiHuo": "Выберите способ забора товара со склада",
    "TiJiNZhongLiangN": "объем {0} , вес {1}",
    "NGeDingDan": "{0} заказов",
    "ZiJiYuYueWuLiuGongSiDaoCangKu": "Самостоятельно связаться с логистической компанией, чтобы забрать товар со склада.",
    "ZiTiFangShi": "Способ самовывоза",
    "GeRenZiTi": "Самовывоз",
    "ZiJiKaiCheQianWangCangKu": "Доехать до склада самостоятельно.",
    "ShiYongWoMenHeZuoDeWuLiuGongSi": "Выберите рекомендованную нами логистическую компанию",
    "QianWangTiHuoShiJian": "Перейти к времени отгрузки товара",
    "LianXiRenXingMing": "ФИО контактного лица",
    "WuLiuGongSiMingZi": "Название транспортной компании",
    "ShangPinShiFouXuYaoDaMuJia": "Необходима ли дополнительная защитная упаковка?",
    "DaMuJiaTiShi": "Укажите необходимость дополнительной защитной упаковки груза исходя из характера вашего груза (например, обрешетка). В зависимости от того, будет обрешетка или нет, возможно увеличение объема/веса груза и стоимости доставки соответственно.",
    "XuYaoDaMuJia": "Необходима дополнительная защитная упаковка",
    "MeiGeMuJiaFeiYongTiShi": "Укажите требования к дополнительной упаковке.",
    "QuanBuBuXuYao": "Ничего не нужно",
    "YinWuLiuHuoSunZiJiChengDan": "Обращаем Ваше внимание, что ESSAONE предоставляет доставку только до склада. Мы не несем ответственности за возможные повреждения при дальнейшей транспортировке товара.",
    "XuanZeWuLiuGongSi": "Выберите ТК из предоставленного списка",
    "WuFaJiaZaiDiTuZuJian": "Невозможно загрузить компонент карты",
    "PiLiangYuYue": "Пакетное бронирование",
    "PiLiangYuYueTiHuo": "Запланировать массовую отгрузку товара",
    "YuXiaMianDingDanYiQiTiHuo": "Забрать вместе с заказом ниже",
    "DingDanSongZhi": "Заказ доставляется по адресу",
    "PinTuanShengYuShiJian": "Время действия совместной закупки",
    "ZanBuYuYue": "Без бронирования",
    "YiXiaDingDanYiRuKu": "Данные заказы поступили на склад, пожалуйста, назначьте отгрузку товара как можно скорее",
    "YiXiaDingDanYiZhiFuWeiKuan": "Данные заказы оплачены и находятся в пути. Ориентировочная дата прибытия {0}, хотите ли запланировать совместную отгрузку товара?",
    "XuanZeDingDan": "Выберите заказ",
    "TiJiaoYuYue": "Отправить заявку",
    "RuKuTingCangTiShi": "Бесплатный период хранения в течение {0} дней, по истечении срока взымается дополнительная плата в размере {1}/м³/день.",
    "ChaKanDingDan": "Просмотреть заказ",
    "WoMenHeZuoDeWuLiuGongSiYou": "Мы сотрудничаем со следующими транспортными компаниями",
    "GenJuNiDeDingDan": "В соответствии с Вашим заказом, могут подойти следующие транспортные компании",
    "ZiJiDaoCangKuTiHuoMianFei": "Забрать товар со склада самостоятельно, бесплатно",
    "WuLiuGongSiXinXi": "Информация о транспортной компании",
    "ZiJiLianXiDiSanFangWuLiuGongSiDaoCangKuTiHuo": "Обратитесь в стороннюю транспортную компанию, чтобы забрать товар со склада",
    "WuLiuDanHao": "Номер отправления",
    "WuLiuGongSiLianXiBuShangKeYiLianXiYiXiaRenYuan": "Если не удалось связаться с транспортной компанией, Вы можете обратиться по следующим контактам",
    "ShiYongPingTaiZhiDingDeWuLiuGongSi": "Для большего удобства и экономии, используйте транспортную компанию, предложенную площадкой!",
    "HuoSunFeiYongXieYi": "Соглашения об ответственности сторон",
    "PoSunZiFuXieYi": "Соглашения об ответственности сторон",
    "DaMuJiaTiShi2": "При отказе от обрешетки хрупкого товара, ответственность за целостность груза несет клиент.",
    "HuoSunFeiYongXieYiNeiRong": "1. Поставщик (ООО «Эссаван») обязуется доставить товар на склад транспортной компании, указанной Покупателем при оформлении заявки, и передать его логистической компании для транспортировки в согласованное время. <br />2. Поставщик не оказывает услуг по дополнительной защитной упаковке товара, не участвует в оплате за упаковку и не берет на себя ответственность за упаковку. Поставщик информирует транспортную компанию, назначенную Покупателем, о необходимости дополнительной защитной упаковки товара в соответствии с заявкой заказа транспортной компании. <br />3. Если Покупатель не запрашивает дополнительную защитную упаковку для товара, то в случае гибели, повреждения, порчи, загрязнения и т.д. во время транспортировки Покупатель несет возникшие экономические потери или ведет переговоры с логистической компанией для решения проблемы сам. Поставщик не несет ответственности за какую-либо компенсацию.",
    "BuTongYi": "Не согласен(-на)",
    "XuanZeShouHuoDiZhi": "Выберите адрес доставки",
    "ZuiZhongYiWuLiuGongiShouFeiWeiZhun": "Указанная стоимость является ориентировочной, окончательная стоимость рассчитывается транспортной компанией и является приоритетной",
    "WuLiuFaChuRiQi": "Дата отправки",
    "ShiYongSongHuoFuWu": "Воспользоваться услугой доставки до терминала транспортной компании",
    "QingXuanZeDingDan": "Выберите заказ",
    "ZhunBeiYuYueDeDingDan": "Заказы, готовые к приему",
    "CangKuGongZuoShiJian": "Время работы склада",
    "TiHuoDan": "Транспортная накладная",
    "TiHuoXinXi": "Информация о заборе груза",
    "QuXiaoYuYue": "Отменить бронь",
    "YiWanChengTiHuo": "Забор груза завершен",
    "ZaiCiYuYue": "Записаться на другую встречу",
    "TiHuoFangShi": "Способ забор груза",
    "MianFeiTingCangQi": "Срок бесплатного хранения на складе",
    "KaiShiShouFeiYiChanShengNTianFeiYong": "Началось платное хранение, начислится стоимость хранения за {0} дней",
    "RuKuTingCangTiShi2": "с {0} по {1}. За {2} м³ взимается плата за хранение {3} ({4} руб./м³/день)",
    "NZhiN": "с {0} по {1}",
    "RuKuTingCangTiShi3": "бесплатное хранение до {0}, далее будет взиматься плата {1} рублей за каждый день хранения.",
    "XuSongChe": "Требуется поставка на логистический склад",
    "YiTiHuo": "Груз забран",
    "QuanBuLeiXing": "Все виды",
    "MianFeiTingCangZhi": "Бесплатное хранение до",
    "TiHuoShiJianShengYu": "Осталось {0} дней для отгрузки товара, после этого времени начнет взиматься плата за хранение товара на складе",
    "YiChanShengNTianFeiYong": "Было понесено {0} дней расходов на хранение",
    "QingGuanDengJi": "Регистрация для таможенного оформления",
    "QingGuanZhuangTai": "Статус таможенного оформления",
    "KaiShiQingGuan": "Началось таможенное оформление",
    "QingGuanWanCheng": "Таможенная очистка завершена",
    "QingGuanBeiChaGui": "Проводится таможенный досмотр контейнера",
    "GengXinQingGuanXinXi": "Обновленная информация о таможенной очистке",
    "YiDaDao": "Arrived",
    "WuLiuGenJin": "Обновления в логистике",
    "GengXinWuLiuXinXi": "Обновление информации о логистике",
    "GengXin": "Обновить",
    "JiGuiJuLiCangKu": "Расстояние до склада",
    "WuLiuXinXiGuanLi": "Управление логистической информацией",
    "ZhiChiSouSuoFuWuChengShiWuLiuGongSi": "Поиск города/транспортной компании",
    "WuLiuGongSi": "Логистическая компания",
    "FuGaiChengShi": "Охватываемые города",
    "XinZengWuLiuGongSi": "Добавить новую транспортную компанию",
    "BianJiWuLiuGongSi": "Изменить транспортную компанию",
    "WuLiuGongSiMingCheng": "Название транспортной компании",
    "LianXiRenMinCheng": "Контактное лицо",
    "LianXiRenDianHua": "Телефон для связи",
    "ChePaiHao": "Номер машины",
    "SiJiXingMing": "ФИО водителя",
    "QueRenWuLiuGongSi": "Подтверждение транспортной компании",
    "ESSAONETiGongMianFeiSongCheFuWu": "Каждую среду ESSAONE предоставляет бесплатную доставку товара от склада до терминала ТК (Мейджиктранс, ПЭК или КИТ). Если Вы хотите воспользоваться данной услугой, то планируйте отгрузки на среду.",
    "XinZengLianXiRen": "Добавить контактное лицо",
    "ShanChuHouBuYingXiangYiTuiJianDeDingDan": "Пожалуйста, подтвердите, что Вы хотите удалить данную транспортную компанию. Ее удаление не повлияет на рекомендуемые заказы?",
    "DangQianJiGuiYouBuTongCangKuDeDingDan": "В данном контейнере находятся заказы для разных складов",
    "QingXuanZeQingGuanZhuangTai": "Выберите статус таможенного оформления",
    "KaiShiQingGuanHouCaiNengCaoZuoQingGuanWanCheng": "Таможенное оформление может быть завершено только после начала таможенного оформления",
    "XinZengJiLuChengGong": "Запись успешно добавлена",
    "QingShuRuJuLiCangKuGongLiShu": "Пожалуйста, укажите расстояние до склада в километрах",
    "QingGuanJiLu": "Записи о таможенном оформлении",
    "JiGuiYiQingGuanWanCheng": "Контейнер прошел таможенную очистку",
    "YiQingGuanWeiRuKu": "Таможенная очистка пройдена, ожидается поступление на склад",
    "WuLiuTuiJian": "Рекомендация по логистике",
    "YiGuoZhongGuoBianJingNTian": "Прошел через границу Китая {0} дней",
    "TiJiZhongLiang": "Объем и вес",
    "BuNengChongFuKaiShiQingGuan": "Таможенное оформление не может быть начато повторно",
    "ChuHuoFangShi": "Способ отгрузки",
    "TuiJianWuLiuGongSi": "Рекомендуемая транспортная компания",
    "TianXieYuJiWuLiuFeiYong": "Заполните прогнозируемую стоимость логистики для 1 м³ ({0})",
    "YiTuiJian": "Рекомендовано",
    "WeiTuiJian": "Не рекомендовано",
    "QingXuanZeWuLiuGongSi": "Выберите транспортную компанию",
    "QingShuRuDaYuLingDeShuZi": "Пожалуйста, введите число больше 0, возможно указать до сотых",
    "HuoWuDaoNiSuoZaiChengShiWuLiuFeiYong": "Товар прибывает в Ваш город ({0}), ориентировочная стоимость доставки {1}",
    "SongZhiNiZhiDingShouHuoDiZhi": "Доставка по указанному адресу",
    "FeiYongWeiZhiFu": "Оплата не получена",
    "XinZengJiLu": "Новая запись",
    "QinShuRuYouXiangYanZhengMa": "Пожалуйста, введите код подтверждения по электронной почте",
    "MeiZhaoDaoJieGuo": "Нет результатов.",
    "WuLiuGongSiGuanWang": "Официальный сайт логистической компании",
    "JiSuanWuLiuFeiYongQingZhuanDao": "Для расчета логистических затрат, пожалуйста, перейдите по ссылке",
    "ChengGongGengXinNTiaoShuJuNTiaoShiBai": "Успешно обновлено {0} данных, {1} не удалось.",
    "XuanZeDiZhi": "Выберите адрес",
    "XinZengHouWuFaXiuGaiQingQueRen": "Невозможно изменить после добавления, пожалуйста, подтвердите",
    "MeiYouGaiChengShiShiPeiDeWuLiu": "Нет подходящей логистической компании для этого города.",
    "YuYueXinXi": "Информация о бронировании",
    "TuiJianWuLiu": "Рекомендуемые логистические компании",
    "HeZuoWuLiu": "Транспортная Компания",
    "GenJuNiSuoZaiChengShiKeNengHeShi": "Ваше местонахождение влияет на удобство",
    "TongYiPiCiYuYueZhiNengXuanZeTongYiGeMuDiCangKu": "Для одного и того же заказа партии может быть выбран только один склад назначения.",
    "JiSuanCuoWUJinEWei0": "Ошибка вычисления, сумма равна 0.",
    "YiZhiFuGuoFeiYongBuNengQuXiao": "Бронирование не может быть отменено после оплаты взноса.",
    "GongSiMingChengYiCunZai": "Название компании уже существует",
    "YiJingQingGuangWanCheng": "Завершение таможенного оформления",
    "QingWuChongFuDengJi": "Пожалуйста, не регистрируйтесь повторно.",
    "CunZaiWeiZhiDeTingCangFeiYong": "Заказ имеет неоплаченные складские расходы и не может быть отправлен.",
    "YiCunZaiYuYueBuXuYaoJiXuTuiJian": "Существующие назначения не требуют дополнительных направлений.",
    "RuKuTingCangTiShi4": "с {0} по {1}. За {2} м³ взимается плата за хранение {3} ({4} руб./м³/день). Пожалуйста, запланируйте забор как можно скорее.",
    "QingXuanZeRenWu": "Пожалуйста, выберите задачу",
    "PeiSongFuWuZhiNengYuYueZhouSan": "Доставка осуществляется только по средам.",
    "DingDanYiJingYuYue": "Заказ был забронирован, пожалуйста, перейдите к списку получаемых товаров для оформления отправки",
    "XiaoShouJiaGongShi2": "Моя цена продажи = FOB-цена + Морская перевозка + Расходы по таможенному оформлению + Таможенная пошлина + Наценка",
    "QingKong": "Очистить",
    "XiaoShouJiaGongShi3": "Цена продажи = (FOB-цена + морские перевозки/шт. + расходы по таможенному оформлению/шт.) × (1 + ставка таможенной пошлины) × (1 + наценка) × (1 + налог на добавленную стоимость)",
    "XianShiDeBiZhong": "Отображаемая валюта",
    "XiuGaiBiZhong": "Изменить валюту",
    "XiuGaiXiaoShouGuoJia": "Изменить страну продажи",
    "ZuiHouGenJinShiJian": "Время последней модификации",
    "ChaKanGongChang2": "Больше товаров",
    "GengDuoChanPin": "Все товары категории",
    "GenJinXinXi": "Информация о клиенте",
    "QinShuRuGenJinXinXi": "Пожалуйста, укажите дополнительную информацию",
    "GenJinJiLu": "Добавить комментарий",
    "ShuiWuHao2": "ИНН",
    "ShouJiHao": "Номер телефона",
    "FaSongShiJian": "Время отправки",
    "YouXiaoZhi": "Действителен до",
    "TongGongChangChanPin": "Товары из того же завода",
    "QiTaPinPaiXiangSiChanPin": "Похожие продукты других брендов",
    "LiJiHuoQuBaoJia": "Получить цитату сейчас",
    "ZuiZao12XiaoShiNeiDaFu": "Ответим в течение 12 часов, как можно раньше",
    "ZhiJieCongYuanTouWeiNinXuanZeZuiZhunQueDeChanPin": "ESSA непосредственно выбирает наиболее точные продукты прямо из источника.",
    "ShouYeXunJiaBiaoTi": "Получить запрос цен",
    "SouSuoTuPianTongKuanChanPin": "Поиск продуктов, соответствующих изображению.",
    "1080MSG0001": "Проверка кода подтверждения не пройдена.",
    "1080MSG0002": "Неверный номер телефона",
    "1063MSG0004": "Неверный или отсутствующий код звонка страны",
    "1080MSG0003": " Код проверки не работает, пожалуйста, получите его снова ",
    "ZhiFuShiBai": "Ошибка оплаты",
    "DaBaoYaoQiu": "Требования к упаковке",
    "CLAIM_DAMAGE_130": "Заказ еще не поступил на склад, поэтому невозможно начать процесс компенсации",
    "SuoPeiYouHuiJuanShiBai": "Не удалось получить компенсационный купон.",
    "ChuangJianYouHuiJuanShiBai": "Не удалось создать купон.",
    "XieShangZhongXuYaoBuTongYiJiLuCaiNengGuanBi": "Для закрытия переговоров требуется запись о несогласии.",
    "CLAIM_DAMAGE_131": "Для этого товара нет претензионного количества.",
    "CLAIM_DAMAGE_132": "Этот товар либо не в наличии, либо уже был отправлен, поэтому невозможно начать процедуру возврата или послепродажного обслуживания.",
    "YiXiaShangPinYiPoSun": "Следующие товары имеют повреждения",
    "YiXiaShangPinMaiGuiLiao": "Следующие товары были куплены дороже",
    "PoSunShuLiang": "Кол-во сломанного товара",
    "TianXiePoSunChanPinShuLiangQingLiuYiDanWei": "Укажите количество поврежденных товаров. Пожалуйста, обратите внимание на единицу измерения",
    "BuChongXinXi": "Дополнить",
    "MiaoShuChanPinPoSunQingKuang": "Пожалуйста, детально опишите поломки и загрузите соответствующие фотографии (на фотографиях должны быть четко видны изделие и поломка).",
    "SuoPeiFangShi": "Способ компенсации",
    "ShouXuMaFanXuYaoTianXieFuZaDeShenQingBiaoGe": "Процедура оформления претензии на возврат денежных требует заполнения форм на возврат. Необходимо заполнить заявку в соответствии с требованиями и дождаться подтверждения бухгалтерией для осуществления возврата..",
    "XiaZaiShenQingBiaoGe": "Скачать форму заявки",
    "ShouXuJianDanShenHeTongGuoHou": "Процесс получения купона очень прост. После одобрения заявки в Ваш личный кабинет будет отправлен купон на ту же сумму, купон можно применить для компенсации до 50% от суммы заказа.",
    "ShangChuanShenQingBiao": "Загрузить форму заявки",
    "WenDang": "Файлы",
    "KeSuoPeiShuLiang": "Претензионного количества  {0}",
    "LiShiYiShenQingPeiFuLe": "Список одобренных претензий",
    "FanHuiDingDan": "Вернуться к деталям заказа",
    "SuoPeiXiangQing": "Подробная информация",
    "PeiChangJiangTongGuoYouHuiQuanFaFangDaoNiZhangHu": "Компенсация выдается клиенту путем направления денежного купона на ту же сумму компенсации,  действительно в течение {0}  дней. При подаче заявления считается, что  Вы согласны со способом компенсации.",
    "PeiChangFangShi": "Способ компенсации",
    "YouHuiQuanKeYiDieJiaShiYong": "Купоны можно совмещать и применять к заказу, при этом может быть вычтено до 50% от суммы заказа.",
    "LingQuWanDaoPeiFuYouHuiQuan": "Получите компенсацию в виде купона за задержку поставки",
    "SuoPeiChengGong": "Компенсация завершена успешно",
    "WanDaoSuoPeiChengGongMiaoShu": "Описание компенсации за задержку поставки",
    "ShouHou": "Рекламации",
    "JingPingTaJianChaFaXianNiDeHuoWuPoSun": "При проверке на площадке обнаружено, что Ваш товар поврежден. Был  предложен способ компенсации. Пожалуйста, своевременно обработайте запрос.",
    "ShangPinYiPoSun": "Товар поврежден",
    "ShangPinMaiGuiLiao": "Товар куплен дороже",
    "ShiFouYaoCheXiaoSuoPeiShenQing": "Хотите отменить заявку на рекламацию?",
    "ShouHouTuiKuan": "Сумма компенсации",
    "KeHuFaQi": "По инициативе клиента",
    "CangKuFaQi": "Инициируется складом",
    "FaQiShouHouTuiKuan": "Запросить возврат",
    "DangQianShangPinYi PCSJiaGeWeiZhun": "В настоящее момент, исходя из цены товара за штуку, цена ESSAONE: {0} / шт.",
    "ShouHouTuiKuanChanPinShuLiang": "Претензионного количества",
    "KeHuGouMaiGongN": "Общее количество заказов клиента {0}",
    "GaiBuFenHuoWuKeHuBuYaoLeXuYaoTuiKuan": "Клиент отказался от части товара и запросил возврат денежных средств.",
    "QueRenPoSunQingKuang": "Подтвердите повреждение (всего {0})",
    "ZhengChangChanPin": "Товар в нормальном состоянии",
    "PoSunChanPin": "Поврежденный товар",
    "ZhengChangChanPinJiangZiDongZhuanKuCunShangPin": "Товары в нормальном состоянии будут автоматически перенесены в раздел складского учета и преобразованы в один короб,",
    "ShouHouFangAn": "Рекламации программа",
    "ShouHouTuiKuanYiXianJinFangShiTuiGeiKeHu": "Выплата компенсации путем перевода денежных средств, дождитесь пока клиент загрузит заявление для осуществления перевода.",
    "ShouHouTuiKuanYiYouHuiQuanFangShiTuiGeiKeHu": "Выдать купон клиенту для компенсации, свыше {0}  снижается на {1}",
    "TiJiaoChengGongQingDengDaiKeHuChuLi": "Успешно отправлено, пожалуйста, дождитесь обработки заявки клиентом",
    "YiChuHuoJiGuiDanLieBiao": "Контейнер отгружен список",
    "GuanBiPeiChang": "Закрыть рекламацию",
    "ShiFouYaoGuanBiSuoPeiShenQing": "Хотите ли закрыть заявку на рекламацию?",
    "PeiShenChuLi": "Обработка рекламации",
    "ShouQuanPeiShen": "Согласен",
    "ZongPeiChangJiaZhiJinE": "Общая сумма компенсации",
    "QingShuRuJieGuoShuoMing": "Введите пояснение к результату.",
    "JuLiShangCiChuLiYiDengDaiNTian": "Ожидание {0} дней с момента последней обработки",
    "KeHuFaQiLieBiao": "Список рекламаций клиента",
    "CangKuFaQiLieBiao": "Список рекламаций на складе",
    "QueRenYiJingHuiKuanGeiKeHuJiangSuoPeiDanBiaoShiWeiYiHuiKuan": "Подтвердить возврат денежных средств клиенту и отметить претензию как разрешенную?",
    "ZongShouHouTuiKuan": "Общая сумма компенсации",
    "PeiFuJinE": "Сумма компенсации",
    "QingShuRuJiaCha": "Пожалуйста, укажите разницу в цене",
    "QingShuRuJinE": "Введите общую сумму возврата",
    "TiaoZhengShouHouTuiKuan": "Изменение суммы компенсации",
    "DengDaiKeHuChuLi": "В процессе подтверждения",
    "QingXuanZeShouHouYuanYin": "Пожалуйста, выберите причину",
    "ShouHouYuanYin": "Причины послепродажного обслуживания",
    "ShouHouChanPinShuLiang": "Претензионного количества",
    "DaiHuKuan": "Ожидается перечисление средств",
    "QuanBuLeiXin": "Все виды",
    "PiLiangChuLi": "Групповая обработка",
    "YiHuiKuanDaoNiTianXieDeYinHan": "Денежные средства уже были переведены на указанный вами банковский счет, пожалуйста, проверьте банковские реквизиты!",
    "YiPeiFuJiaZhiNDeYouHuiQuan": "Купоны на сумму {0}, действительны в течение {1} дней, пожалуйста, используйте их своевременно.",
    "YouWenTiChanPinShuLiangN": "Количество товара {0} {1}, купон на сумму {2} в качестве компенсации, срок действия составляет {3} дня. Пожалуйста, используйте купон своевременно.",
    "YouWenTiChanPinShuLiangN1": "Количество товара {0} {1}, купон на сумму {2} в качестве компенсации,  действителен в течение {3} дней.",
    "FaQiPeiChangFangAn": "Предложить способ компенсации",
    "YiTongYiPeiChang": "Подтверждение компенсации",
    "YiHuiKuan": "Оплачено",
    "YiTongGuoXianJin": "Денежные средства уже были переведены на указанный вами банковский счет {0}. [Пожалуйста, обратите внимание на банковские реквизиты!",
    "XieShangLiShi": "История",
    "TongYiPeiChangFanAn": "Я согласен",
    "ShangChuanXianJinShenQinBiao": "Загрузить форму заявки",
    "XiaZaiShenQinBiaoGe": "Скачать форму заявки",
    "ShangChuanTip": "Поддерживает загрузку документа в (xls,xlsx,pdf) форматах, размер файла не должен превышать 20МБ.",
    "ShenQinPeiChang": "Подать заявку на компенсацию",
    "ShangChuanTip2": "Поддерживает загрузку фото/видео/документа в (mp4,flv,jpeg,jpg,png,bmp,doc,docx,xls,xlsx,pdf) форматах, размер файла не должен превышать 20МБ, можно загрузить не более 5-ти файлов.",
    "ChengGongGengXinNTiaoShuJuNTiaoShiBai2": "На текущий момент было выполнено {0} частей обработки данных, из которых {1} успешно завершена.",
    "YouWenTiChanPinShuLiangN2": "Количество товаров к возмещению {0} {1}, компенсация {2} выплачивается переводом на р/с. Пожалуйста, загрузите форму заявки для компенсации.",
    "YouWenTiChanPinShuLiangN3": "Количество бракованного товара {0} {1}, компенсация уже была произведена переводом денежных средств {2}, пожалуйста, проверьте правильность заполнения банковских реквизитов.",
    "GaiShangPinYiJingWuKeSuoPeiShuLiang": "Для этого товара нет претензионного количества.",
    "DangQianShangPinYiQuanBuQuXiaoDengJi": "Данный товар в заказе был отменен, пожалуйста <span class=\"color-blue\">закройте запрос на рекламацию</span>",
    "ChePaiHaoMa": "Номер машины",
    "TianXieLianXiXinXi": "Заполните контактную информацию",
    "ShouJianRenQuanMing": "Ф.И.О Получателя",
    "ShuiWuHaoHuZhaoXinXi": "ИНН/Паспортные данные",
    "ShouJianRenSuoZaiChengShi": "Город Получателя",
    "YunShuGongSiZhongDianZhan": "Адрес терминала",
    "ChengShiJiaoHuoDiZhi": "Адрес доставки по городу",
    "ShuiWuHaoHuZhaoXinXiTiShi": "Заполнять ИНН компании (если получатель юр лицо) и паспортные данные клиента (если получатель физическое лицо).",
    "QingShuRuChengShiMinCheng": "Пожалуйста, введите название города",
    "QingZhuMingSuoXuDeYunShuGongSiZhongDianZhan": "Указывать нужный терминал ТК",
    "SongHuoShangMen": "Доставка до двери клиент",
    "ShangChuanChuHuoZhaoPianWenJianTiShi": "Поддерживает загрузку фото/видео в (mp4,flv,jpeg,jpg,png,bmp,zip) форматах, размер файла не должен превышать 50МБ, можно загрузить не более 20-ти файлов.",
    "ShangChuanChuHuoZhaoPian": "Загрузить фото",
    "IntroduceBanner1": "Платформа прямых заводских поставок в Китае",
    "IntroduceBanner2": "О сайте ESSACHINA.COM",
    "IntroduceBanner3": "Мы обслуживаем более 720 покупателей по всему миру, помогая им эффективно и по выгодным ценам приобретать понравившиеся товары на китайских фабриках.",
    "GongChangTuiJianTiDaiKuan": "Замена товара, рекомендованная производителем",
    "GongChangYouHaoTuiJian2": "Есть новое рекомендуемое {0} товар(ов).",
    "FangYangZhanTing": "Зал для размещения образцов",
    "ZaiBaiDuDiTuChaKan": "Просмотреть на карте Baidu",
    "AnShouZiMuShaiXuan": "Отфильтровать по первой букве",
    "BuXian": "Все",
    "TanWei": "Торговое место",
    "DianJiFuZhiDiZhi": "Нажмите для копирования адреса",
    "DianJiFuZhiDiZhiDianHuaHaoMa": "Нажмите для копирования номера телефона",
    "BianJiZhengShu": "Изменить сертификата",
    "JiaGeBaoKuoZengZhiShuiTiShi": "Цена включает НДС, таможенную пошлину и доставку от производителя в Китае до склада Поставщика.",
    "MianFeiDinYueESSA": "Бесплатная подписка на месячник продукции ESSA",
    "QinXuanZeGanXinQuDeChanPinLeiMu": "Пожалуйста, выберите интересующую вас категорию товара",
    "BuZaiTiShi": "Больше не показывать",
    "QueRenDinYue": "Подтвердить подписку",
    "DangQianYouXiangYiZhuCe": "Текущий почтовый ящик уже был зарегистрирован, пожалуйста, перейдите для входа в систему",
    "ChanPinYueKan": "Продуктовый ежемесячный",
    "DenLuChaKanJiaGe": "Пожалуйста, войдите в систему, чтобы увидеть цены",
    "YueKan": "Ежемесячно",
    "SuoXuanRiQiYChaoGuoMianFeiTingCangQi": "Пожалуйста, обратите внимание, что выбранная дата превысила срок бесплатного хранения (период бесплатного хранения до {0}), и будет взиматься плата за хранение в размере около {1}",
    "WeiZhiFuBuYunXuChuKu": "Не оплачено, запрет на вывоз товара со склада",
    "JianMianFeiYong": "Снижение расходов",
    "TiaoZhengDingDan": "Скорректировать заказ",
    "QuanMian": "Полностью бесплатно",
    "GouXuanDeDingDanBaoLiu": "Отмеченные галочкой заказы сохранены, для того, чтобы получить неотмеченные товары, их требуется забронировать вторично",
    "YiQuanMianFeiYong": "Полностью бесплатно",
    "ShiFouYaoQuanMian": "Платить не нужно?",
    "ShiFouYaoYouHuiJinE": "Хотите получить скидку?",
    "QingShuRuYouHuiJinE": "Пожалуйста, введите сумму скидки",
    "QueDingYaoTiaoZhengDingDan": "Вы уверены, что хотите изменить заказ?",
    "ZhongGuoZhiDaDingDan": "Доставка от производителя",
    "QingLianXiKeFuWanChengFuKuan": "Пожалуйста, обратитесь в службу поддержки, чтобы завершить платёж",
    "QingXuanZeYaoQuXiaoDeShangPin": "Пожалуйста, выберите товары для отмены",
    "YuJiDaoGang": "Ориентировочная дата доставки",
    "QueDingYaoQuXiaoShangPinMa": "Вы уверены, что хотите отменить этот товар?",
    "ZhengDanQuXiao": "Отменить все",
    "HeJiQuXiao": "Полная отмена",
    "QingXuanZeDingDanFuKuanFangShi": "Пожалуйста, выберите способ оплаты заказа",
    "QingXuanZeDingDanFuKuanKaHao": "Пожалуйста, введите номер платежной карты",
    "KeYongEDu": "Доступный лимит",
    "ChaoChuKeFanWei": "Превышение доступного лимита",
    "ZhiFuXinXi": "Платёжная информация",
    "QueDingShiJian": "Установить сроки",
    "YiGuoNTian": "Прошло {0} дней",
    "LeiJiDing": "Итого",
    "ZhongGuoZhiFaDingDan": "Доставка от производителя",
    "SuoXuanXinXiShiFouYiJingYuKeHuQueRenGuo": "Была ли выбранная информация подтверждена клиентом?",
    "ESSAChanPinYueKan": "Ежемесячный продукт ESSA",
    "MeiYueJinXuanYouZhiChanPin": "Ежемесячная подборка высококачественных товаров в помощь для Вашей закупки",
    "DingYueYueKan": "Подписаться на ежемесячный журнал",
    "ShangPinQinQuan": "Нарушение авторских прав",
    "YiTianJia": "Добавлено",
    "MskCangKu2": "Склад 2：рабочий посёлок Ленинские горки, Зелёное шоссе 4. стр 1. Склад #35 ООО «Игрувер.ру»",
    "ChanPinYiQinQuan": "Нарушение авторских прав",
    "QueRenDingDanChengGong": "Успешное подтверждение заказа.",
    "YiZhengDanQuXiao": "Заказ полностью отменен",
    "KeHuBuYaoLe": "Клиенту это не нужно.",
    "ZhongGuoZhiFa": "Доставка от производителя",
    "YouXiaoQi": "Срок действия",
    "KeJieSouTuiJianXiangShiKuan": "Приемлемые рекомендации для аналогичных моделей",
    "QinShuRuDaBaoYaoQiu": "Пожалуйста, укажите требования к упаковке",
    "JianDan": "Простой режим",
    "SheZhiWoDeXiaoShouJia": "Установить мою цену продажи",
    "XiaoShouJiaGongShi4": "Моя цена продажи = Цена FOB × Надбавка за FOB × Маржа прибыли",
    "XiaoShouJiaGongShi5": "Цена продажи = Цена FOB × (1 + Ставка надбавки за FOB) × (1 + Ставка маржи прибыли)",
    "LiRun": "Прибыль",
    "FOBJiaJia": "Надбавка за FOB",
    "HuoBi": "Валюта",
    "GongZuoRi": "Рабочие дни",
    "ZhaoYangShenYuShiJianBuBaoHanZhouMo": "Осталось времени на поиск образцов (без учета выходных)",
    "DuoShaoGeGongZuoRiNeiXuHuiFu": "Сколько рабочих дней для ответа",
    "YiJianFaBu1": "Опубликовать одним кликом",
    "YiJianFaBu2": "Много запросов из разных источников? Загружайте одним кликом и быстро осуществляйте поиск цен!",
    "ZhuanYeTuiJian1": "Профессиональная рекомендация",
    "ZhuanYeTuiJian2": "Распознавание информации о потребности, точные рекомендации подходящих продуктов",
    "YiJianJiaGou1": "Покупка одним кликом",
    "YiJianJiaGou2": "Оптовая закупка высококачественных товаров, экономия времени и эффективность",
    "ZhongGuoZhiFaShangPin": "Товары из раздела Доставка от производителя",
    "ZhongGuoZhiFaShangPinTiShi1": "Доставка от производителя, без предоставления инвойса и документов для таможенного оформления",
    "ZhongGuoZhiFaShangPinTiShi2": "Товары из раздела Доставка от производителя, без предоставления инвойса и документов для таможенного оформления, в случае отказа от покупки данного товара нажмите \"Закрыть\" в Настройках",
    "ChanPinZanBuXiaoShou": "Продукт пока не выставлен на продажу",
    "TuiKuanMingXi": "Детали возврата",
    "DaiTuiKuanJinE": "Сумма к возврату",
    "QueRenFaHuoFangShi": "Подтвердите способ доставки",
    "LiangZhongFaHuoFangShi": "Два способа доставки",
    "QuanBuShangPinZhongGuoZhiFa": "Все товары из раздела Доставка от производителя",
    "LiangZhongFaHuoFangShiDeXiangXiShuoMing": "Если в заказе присутствует часть товара из раздела Доставка от производителя, то применяется два способа перевозки - DDP для одной части товара и Доставка от производителя для другой.",
    "RuGuoXiaDanShangPinBaoHanLeZhongGuoZhiFaDeChanPin": "Если заказ содержит товары из раздела Доставка от производителя, эта часть товара пройдет проверку на платформе и затем с вами свяжутся для подтверждения. При оформлении заказа, пожалуйста, проверьте правильность адреса электронной почты и номера телефона.",
    "QuanBuShangPinCaiYongZhongGuoZhiFaFangShiFaChu": "Для всех товаров осуществляется Доставка от производителя",
    "BuTiGongFaPiaoHeQingGuanWenJian": "Без предоставления инвойса и документов для таможенного оформления",
    "DangQianXiaDanShangPinBaoHanLeZhongGuoZhiFaDeChanPin": "Текущий заказ включает товары из раздела Доставка от производителя. После подтверждения заказа для этой части товара не сможет быть предоставлен инвойс и соответствующие документы для таможенного оформления. Вы будете уведомлены после разделения заказа. Вы согласны с данными действиями?",
    "QueDingYaoShiYong": "Вы уверены, что хотите использовать {0}?",
    "TuiKuanQueRen": "Подтверждение возврата",
    "DaiTuiKuanQueRen": "Ожидание подтверждения возврата",
    "QueRenXinXi": "Подтвердить информацию",
    "TuiKuanChanShengShiJian": "Сроки возврата",
    "QueRenYiTuiKuan": "Подтвердить возврат",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi": "Для текущего заказа клиенту требуется Доставка от производителя, пожалуйста, обратите внимание на правильность шаблона стикера.",
    "KeHuYaoQiuZhiFa": "Клиентом запрашивается прямая поставка",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi2": "Для текущего заказа клиентом заявлена Доставка от производителя, может быть предоставлено на рассмотрение",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi3": "Текущий заказ включает товары из раздела Доставка от производителя. После подтверждения заказа для этой части товара не сможет быть предоставлен инвойс и соответствующие документы для таможенного оформления. Вы будете уведомлены после разделения заказа. Вы согласны с данными действиями?",
    "JieShouBingJiXuS": "Принять и продолжить ({0}s)",
    "JieShouBingJiXu": "Принять и продолжить",
    "GongZuoTaiZhuYe": "Главная",
    "XuanPinChi": "Пул товаров",
    "WoDeKeHu": "Мои клиенты",
    "TuiJianBaoJiaDan": "Предложения",
    "KeFu": "Служба поддержки",
    "HuoDongZhuanQu": "Деятельность",
    "KeHuDeZhaoYang": "Образцы клиента",
    "GongGongKeHuChi": "Общий пул клиентов",
    "ZhangHuXinXiSheZhi": "Настройки аккаунта",
    "PingTai": "Платформа",
    "KeHuZhuYe": "Информация о клиенте",
    "KeHuDongTai": "Обновления клиента",
    "WeiWanShan": "Незавершенный",
    "BangDingKeHuDaoGaiFenXiaoShangMingXia": "Привязка клиента к имени агента, эта операция изменит первоначальную принадлежность клиента",
    "ShangChuanShiBai2": "Скачивание неудалось!",
    "ZhengShuGuaKao": "Прикрепление сертификата",
    "ZhengShuGuaKaoGuiZe": "Правила прикрепления сертификата",
    "GuaKaoZunXunXianPiPei": "Прикрепление сертификата осуществляется сначала в порядке сопоставления, а затем в порядке исключения. Как только товарный продукт попадает под правило исключения, он помечается как \"без сертификата\".",
    "PiPeiGuiZe": "Правила сопоставления",
    "TianJiaGuiZe": "Добавить правило",
    "DuoGeGuiZeShiYongHuoDeGuanXi": "В нескольких правилах используется связь \"или\", и попадание в одно правило является совпадением с",
    "PiPeiDeShangPinShiYongYiXiaHaiGuanBianMa": "К сопоставляемым товарам применяются следующие коды ТН ВЭД",
    "YiXingYiGeHaiGuanBianMa": "Один код ТН ВЭД в строке, состоящий из 10 знаков -заглавных и строчных латинских букв или цифр",
    "QingShuRuHaiGuanBianMa": "Пожалуйста, введите таможенный код товара",
    "QingShuRuZhengQueDeHaiGuanBianMa": "Пожалуйста, введите правильный таможенный код",
    "PaiChuGuiZe": "Правило об исключении",
    "PaiChuDiaoZhiDingShangPinBianHao": "Исключить указанный номер товара",
    "YiXingYiGeBianHao": "По одному номеру в строке",
    "ShiFouQueDingBaoCun": "Вы уверены, что хотите сохранить?",
    "FuZhiPiPeiGuiZeChengGong": "Скопировать правило сопоставления{0} успешно",
    "FuZhiPaiChuGuiZeChengGong": "Копировать правило об исключении{0} успешно",
    "ShiFouYaoShanChuTiaoJian": "Хотите удалить этот пункт?",
    "ShangPinShuYuYiXiaLeiMu": "Товарный продукт относится к следующим категориям:",
    "QingXuanZeLeiMu": "Пожалуйста, выберите категорию",
    "QieFuHeYiXiaShangPinShuXing": "Соответствие следующим товарным атрибутам (в случае смены категории, пожалуйста, проверяйте условия атрибута)",
    "DianJiQieHuanTiaoJianZuHeFangShi": "Нажмите, чтобы переключить метод комбинирования условий",
    "Qie": "Далее",
    "TianJiaTiaoJian": "Добавить пункты",
    "ZhengShuXiangQing": "Детали сертификата",
    "ZhengShuXuanZe": "Выбрать категорию",
    "GuiZeLeiMuYuZhengShuLeiMuBuPiPei": "Категория регламента не соответствует категории сертификата, пожалуйста, проверьте перед сохранением.",
    "FeiYongDan": "Список расходов",
    "ChaoShiNTian": "Время ожидания {0} дней",
    "ShenNTian": "Осталось {0} дней",
    "ZuiWanQueRen": "Последнее подтверждение",
    "QinHeShiXinXiHouQueRenFeiYongDan": "Пожалуйста, проверьте информацию и подтвердите список расходов. Подтверждение приведет к поступлению средств. В случае сомнений проконсультируйтесь с вашим торговым представителем.",
    "WoDeFeiYongDan": "Моя расходная накладная",
    "XinFaPiao": "Экспорт счетов",
    "XinFaPiaoPCS": "Экспорт счетов штук",
    "DaoChuShiBai": "Ошибка экспорта",
    "FaPiaoXuCaiWuQueRenHouZaiDaoChu": "Пожалуйста, свяжитесь с менеджером клиента, чтобы подтвердить счет - фактуру, прежде чем экспортировать. ",
    "ChuLiTuiKua": "Обработка возврата",
    "QingQueDingYaoRuHeChuLiTuiKuan": "Пожалуйста, подтвердите способ получения компенсации",
    "XianXiaHuiKuanGeiKeHu": "Офлайн-перевод денежных средств клиенту",
    "TuiHuiKeHuQianBao": "Возврат в кошелек клиента",
    "YaoQingMaYiCunZai": "Код приглашения уже существует. Пожалуйста, отредактируйте заново.",
    "FenXiaoShangZhongXin": "Личный кабинет агента",
    "FenXiaoShangShouYe": "Страница агента",
    "YuJiShouRu": "Прогнозируемый доход",
    "ZiJiYaoQingKeHu": "Мои приглашенные клиенты",
    "JinNianYaoQingMuBiao": "Цель по количеству привлечений на этот год",
    "XiaDanXinYongHu": "Новые пользователи, разместившие заказ",
    "JinNianChengJiaoXinKeHu": "Новые клиенты, заключившие сделку в этом году",
    "XiaJiFenXiaoShangGongXian": "Доход подчиненного агента",
    "FuZhiLianJie": "Скопировать ссылку",
    "SaoMaFenXiang": "Отсканируйте код, чтобы поделиться",
    "FenXiangHaiBao": "Поделиться баннером",
    "QingShuRuYaoQingMa": "Пожалуйста, введите пригласительный код из четырех цифр",
    "XiuGaiYaoQingMa": "Изменить пригласительный код",
    "LeiJiYaoQLeiJiYaoQingNRenXiaDanNRen": "Количество приглашенных человек - {0} , разместивших заказ - {1}",
    "SouSuoKeHuMinChengBianHao": "Поиск по имени/номеру клиента",
    "YaoQingShiJian": "Время приглашения",
    "LeiJiDingDanTiCheng": "Общая сумма комиссии с заказа",
    "YiBiaoPan": "Панель управления",
    "DingDanTiChengTiShi": "Агентская комиссия за предыдущий месяц выплачивается 10 числа каждого месяца (например, 10 февраля выплачивается комиссия за 1~31 января).",
    "HeTongYiDaoQiHouDeDingDanJiangBuZaiChanShengShouYi": "Срок действия контракта истек. Таким образом, для заказов после {0} комиссия начисляться не будет.",
    "DingDanTiCheng": "Комиссия с заказа",
    "SouSuoDingDanHao": "Поиск номера заказа",
    "HuiKuanXianJin": "Перевести агентскую комиссию",
    "NNianYueYiWanJie": "{0} Завершено",
    "NNianYueTiChengYiHuiKuan": "{0} Комиссия переведена",
    "KeHuYiBiaoPan": "Клиентская панель",
    "SouTu": "Поиск по картинке",
    "HeTongYouXiaoQiZhi": "Срок действия договора с {0} до {1}",
    "MoRenShiNiDeShouJiHao": "По умолчанию используется номер вашего мобильного телефона",
    "MiMaGuiZe3": "Введите 8-16 символов, комбинацию цифр и букв",
    "BianJiZhangHao": "Редактировать учетную запись",
    "DingDanFenXiaoShang": "Агент заказа",
    "XinZengDingDanTiChengFenXiaoShang": "Агентская комиссия за новые заказы",
    "XinZengZhuCeTiChengFenXiaoShang": "Агентская комиссия за новые регистрации на сайте",
    "HeTongXinXi": "Информация о договоре",
    "HeTongFuJian": "Приложение к договору",
    "GuoJiaDiQu2": "Страна",
    "MoRenShiShouJiHao": "Использовать номер телефона по умолчанию",
    "QingShuRuYouXiaoQi": "Пожалуйста, введите срок действия",
    "ShangChuanWenJianTiShi": "Поддерживаются форматы jpg/png/Word/Excel/PDF, загрузка файлов до 10 МБ, максимум 5 файлов",
    "KeHuXiaDan": "Заказы клиента",
    "XiaJiYongHu": "Подчиненные пользователи",
    "JinNianChengJiaoMuBiao": "Цель по обороту на текущий год",
    "YiChengJiaoJinE": "Сумма сделки",
    "AnQuanTiShi": "Советы по безопасности",
    "ShouCiDengLuQingXiuGaMiMaHouJiXu": "При первом входе в систему, пожалуйста, измените пароль и затем продолжите",
    "QingShuRuXinMiMa": "Пожалуйста, введите новый пароль",
    "QingZaiCiShuRuXinMiMa": "Пожалуйста, подтвердите новый пароль",
    "MiMaGuiZe4": "Пароль должен состоять из букв и цифр и содержать от 8 до 16 знаков.",
    "FenXiangDao": "Поделиться",
    "XiaZaiHaiBaoFenXiang": "Скачать и поделиться баннером",
    "YuJiShouRuBaoHanJinXingZhongDingDanTiShi": "Общий предварительный расчет комиссии включает [прогнозируемую комиссию по заказам в работе] + [комиссию по заказам, выполненным в течение месяца].",
    "ShangYueTiChengTiShi": "Комиссия за предыдущий месяц будет начисляться 1-го числа каждого месяца, а выплачиваться 10-го. В случае выходных или праздничных дней выплата будет отложена.",
    "JianGeShangYiCiDengLuNTian": "{0} дней с момента последнего входа в систему",
    "JianGeShangYiCiDengLuNone": "Интервал между последними входами в систему -",
    "ESSAONEFenXiaoShangDaiLiYaoQingYeBiaoTi": "Агентская программа от ESSAONE",
    "ESSAONEFenXiaoJieShaoYu1": "Привлекайте и мотивируйте клиентов к заказу на сайте ESSAONE",
    "ESSAONEFenXiaoJieShaoYu2": "Получайте денежное вознаграждение за каждый заказ",
    "ESSAONEFenXiaoJieShaoYu3": "Привлекайте клиентов в различных регионах России,",
    "ESSAONEFenXiaoJieShaoYu4": "география не имеет значение и получайте гарантированное вознаграждение за каждый заказ.",
    "ESSAONEFenXiaoJieShaoYu5": "Кто мы?",
    "ESSAONEFenXiaoJieShaoYu6": "ESSAONE – крупная онлайн площадка для юридических лиц и  индивидуальных предпринимателей, закупающих товар напрямую  у производителей со всеми сопроводительными услугами.",
    "ESSAONEFenXiaoJieShaoYu7": "Что вам предстоит?",
    "ESSAONEFenXiaoJieShaoYu8": "Поиск потенциальных клиентов в регионах России",
    "ESSAONEFenXiaoJieShaoYu9": "Предложение клиенту категорий товаров, представленных  на ESSAONE",
    "ESSAONEFenXiaoJieShaoYu10": "Мы предлагаем:",
    "ESSAONEFenXiaoJieShaoYu11": "Удобный интерфейс для отслеживание ваших показателей и суммы вознаграждения",
    "ESSAONEFenXiaoJieShaoYu12": "Дополнительные обучающие и рекламные материалы",
    "ESSAONEFenXiaoJieShaoYu13": "Кто может быть агентом?",
    "ESSAONEFenXiaoJieShaoYu14HTML": "<li>Вы являетесь индивидуальным предпринимателем? </li>  <li>Хотите получать дополнительный доход?</li>  <li>Готовы активно работать с потенциальными клиентами? </li>  <li>Нацелены на привлечение и развитие новых клиентов? </li>  <li>Работа по официальному договору</li>",
    "QinXuanZeYaoGengHuanDeMaiShou": "Пожалуйста, выберите покупателя, которого вы хотите заменить",
    "FaSongZiXun": "Отправить запрос",
    "YiZiXun": "Консультация завершена",
    "JiXuZiXun": "В процессе консультации",
    "WeiHuiFu": "Нет ответа",
    "GongChangYouFanKui": "Фабрика предоставляет обратную связь",
    "GouMaiXiangShuShaoYuGongChangYaoQiu": "Количество коробов в заказе не достает до минимума, требуемого фабрикой",
    "XunJiaZhongZanWuFaGengGaiShuLiang": "В процессе запрашивания цены, в данный момент невозможно изменить количество",
    "ZengJiaGouMaiXiangShuKeXiaDan": "Увеличьте число коробов, чтобы сделать заказ",
    "FenXiaoShangZhiNengChaKanShouCang": "Только агенты могут просматривать избранное",
    "ChangAnTuPianKeBaoCunDaoXiangCe": "Нажмите и удерживайте изображение, чтобы сохранить в альбом",
    "XiaZaiBaoGao": "Скачать отчет",
    "MeiYueJinTiGongShangYueJieSuanQiDeZhiXingQingKuangBaoGao": "Ежемесячные отчеты о производительности предоставляются только за расчетный период предыдущего месяца",
    "ESSAONEFenXiaoJieShaoYu15": "Развивайте электронную коммерцию вместе с ESSAONE — получайте реальный доход",
    "MingZi2": "Имя",
    "YouJian": "почта",
    "XiangQingQingZhiDianLianXiWoMenHuoDianZiYouJian": "Для подробностей свяжитесь с нами по телефону  или электронной почте:",
    "ESSAONEFenXiaoJieShaoYu16": "Развивайте электронную коммерцию вместе с ESSAONE — получайте реальный доход",
    "PeiXunZhiChi": "Поддержка обучения",
    "ESSAONEFenXiaoPeiXunZhiChiBiaoTi": "Знакомство с компанией",
    "ESSAONEFenXiaoPeiXunZhiChiBiaoTi2": "Агентская программа",
    "TongYiGeKeHuWuFaChongFuBangDingTongYiGeMaiShou": "Один и тот же клиент не может быть привязан к одному и тому же покупателю несколько раз",
    "FufilmentKey": "Фулфилмент для маркетплейсов",
    "TongGuoXinFuWuTuoZhanNinDeYeWu": "Pазвивайте ваш бизнес с новой услугой",
    "XinDeKeHuJingLiShenQingWeiNiFuWu": "Новый менеджер по работе с клиентами хочет обслуживать вас.",
    "ShenQing": "Заявление",
    "ZhaoYangYouXinDeHuiFu": "Найти образец с новым ответом",
    "ZaiZengJiaYiWeiKeHuJingLi": "Добавить еще одного менеджера по работе с клиентами",
    "BangDingKeHu": "Привязать клиента",
    "DingDanShouRu": "Доход от заказа",
    "ShuJuYiFaShengBianDongQingShuaXinYeMian": "Произошло изменение данных, пожалуйста, обновите страницу",
    "XiaZaiYongJinBaoGao": "Скачать отчет о комиссии",
    "YunFeiBaoJiaDan": "Стоимость грузоперевозки",
    "HuanYingNi": "Добро пожаловать!",
    "XinDeKeHuJinLiWeiNiTiGongFuWu": "Вам будет доступен новый менеджер аккаунта!\t Сменить покупателя",
    "GengHuanMaiShou": "Сменить покупателя",
    "TuiJianXin": "рекомендательное письмо",
    "WoDeKeHuJinLi": "Мой менеджер по работе с клиентами",
    "QianWanGouWuCheChaKan": "Перейти в корзину",
    "NiKeYiXuanZeBuTongDeKeHuJinLiGengJinXunJia": "Вы можете выбрать другого менеджера, который будет следить за вашим запросом.",
    "YiQieHuanKeHuJinLiGenJin": "Сменные менеджеры по работе с клиентами",
    "NiDeZhaoYangJiangYouYiXiaKeHuJinLiGengJin": "Ваш запрос будет обработан следующими менеджерами.",
    "JieChuFuWu": "Отменить услуга",
    "QuanXian": "Привилегии",
    "TiHuanNaWeiXianYouKeHuJinLi": "Замена существующего менеджера по работе с клиентами",
    "ShenQinDeKeHuJinLi": "Запрошенный менеджер",
    "XuanZeDeKeHuJinLi": "Выбранный менеджер",
    "XunJiaZhong": "Запрос в процессе",
    "YiJuJueLeGaiKeHuJinLiDeShenQing": "Заявка этого менеджера была отклонена",
    "GaiKeHuJinLiDeShenQinYiJinShiXiaoGuoQi": "Срок действия заявки данного менеджера по работе с клиентами истек/истек",
    "GaiXiaoShouJinLiShenQinWeiNiFuWu": "Этот менеджер по продажам подал заявку, чтобы обслужить вас, и хочет обслужить вас лучше.",
    "JuJue": "Отклонено",
    "XuanZeKeHuJinLiChengGong": "Выбор менеджера по работе с клиентами для достижения успеха",
    "XinDeKeHuJINLi": "Новый менеджер по работе с клиентами",
    "TiHuanDeKeHuJinLi": "Замененный менеджер по работе с клиентами",
    "ShangPinYiZaiHaoHuoJuZhon": "Товар готов к пополнению в контейнере {0}, заказ {1}, пожалуйста, сначала удалите его из контейнера и пула пополнения.",
    "WoZiJi": "Я сам",
    "ZuiShaiXuanZeYiGeZhangHao": "Выберите хотя бы одну учетную запись",
    "NShangPinKeYiPinGui": "Товар {0}m³ доступен для объединения в пул\t Импорт успешен",
    "DaoRuChengGong": "Импорт успешен",
    "ChaKanQiTaZhangHaoDeShuJu": "Просмотр данных других счетов (только просмотр)",
    "MaoShouYiJingBangDing": "Пожалуйста, не повторяйте операцию, если вы уже связали покупателей.",
    "WeiBangDingMaiShou": "Ни один покупатель не связан, пожалуйста, свяжите покупателя первым.",
    "BangDingDeMaiShouShuLiangChaoXinaZhi": "Связанные покупатели превышают лимит",
    "LingQuDaoNinDeJiFenZhangHu": "Получено на ваш счет баллов, можно использовать для снижения стоимости заказа или обмена на подарки.",
    "XuanPinJiangLiNJiFen": "Награда {0} баллов",
    "ShiYongZhiNan": "Руководство по использованию",
    "DingDanYuZhaoYang": "Заказ и образцы",
    "GongSiZiChan": "Корпоративные активы",
    "GeRenZiChan": "Личные активы",
    "JinGongGeRenChaKan": "Только для личного использования",
    "GouWuQuan": "Купоны",
    "SiRenChaKan": "Личное просмотр",
    "MingTianJiangYouNJiFenDaoQi": "Завтра истекут баллы в размере {0}. У баллов есть {1} дней с момента получения.",
    "NiHaiMeiYouJiFen": "У вас пока нет баллов.",
    "GongSiQiTaZhangHaoYuZhuZhangHaoJunWuFaChaKanTiShi": "Ни один другой аккаунт компании, включая основной, не может видеть ваши купоны и обмененные товары. Купоны можно использовать при оформлении заказа, обменивая их на баллы, срок действия купонов - 5 год.",
    "DuiHuanShangPin": "Обмен товаров",
    "DuiHuanHouNiZhuanShuXiaoShouJingLiHuiZhuDongLianXiNi": "Товары обычно доставляются по указанному адресу в течение 30 дней. После обмена менеджер свяжется с вами, так что пожалуйста, ждите доставку. Некоторые товары могут быть недоступны для доставки в ваш регион, но вы можете выбрать самовывоз из Китая или обменять товар на другой подарок.",
    "QiTaLiPinQingLianXiKeHuJingLi": "Для других подарков, свяжитесь с вашим менеджером",
    "LianXi": "Контакты",
    "XinZhengYiWei": "Добавить нового",
    "QinXuanZeTiHuanDeKeHuJinLi": "Пожалуйста, выберите менеджера для замены",
    "FuWuZhongDeKeHuJinLiQinXuanZeShiFou": "Менеджер, который уже обслуживает, пожалуйста, выберите, заменить или добавить",
    "ZhuDongShenQinDeKeHuJinLi": "Менеджер, подавший заявку самостоятельно",
    "QueRenYaoJuJueGaiKeHuJinLiZheCiDeShenQin": "Подтвердите отказ от заявки этого менеджера",
    "JiFenQAWenTi1": "Как получить баллы?",
    "JiFenQANeiRong1": "Нажмите «Добавить запрос», чтобы добавить товары в корзину или выполнить поиск продуктов через «Инициировать поиск образцов» рядом с полем поиска, у вас будет вероятность получить баллы. Добавление до 20 товаров в корзину ежедневно обязательно принесет вам баллы.",
    "JiFenQAWenTi2": "Можно ли получать баллы ежедневно?",
    "JiFenQANeiRong2": "Баллы можно получать за выбор/образцы продукции каждый день. Добавьте 100 продуктов в корзину, чтобы заработать до 5000 баллов.",
    "JiFenQAWenTi3": "Как использовать баллы?",
    "JiFenQANeiRong3": "Баллы можно использовать для снижения стоимости заказа или обмена на купоны для получения подарков при оформлении заказа. Максимальный размер скидки/обмена составляет 1% от стоимости заказа.",
    "JiFenQAWenTi4": "Срок действия баллов",
    "JiFenQANeiRong4": "Срок действия - 60 дней с момента получения. Если баллы не используются в течение срока действия, они автоматически аннулируются. Успешно использованные баллы будут полностью возвращены в случае отмены заказа по причине завода.",
    "GouWuQuanQAWenTi1": "Как получить купоны? Когда они начинают действовать?",
    "GouWuQuanQANeiRong1": "Для обмена баллов на купоны используйте их при оформлении заказа. Купоны начнут действовать при отправке заказа.",
    "GouWuQuanQAWenTi2": "Как использовать купоны?",
    "GouWuQuanQANeiRong2": "Перейдите на страницу купонов в личном кабинете, убедитесь в наличии купонов. При наличии средств на счету вы можете непосредственно обменять их на товары.'",
    "GouWuQuanQAWenTi3": "Срок действия купонов",
    "GouWuQuanQANeiRong3": "В течение 5 лет с даты вступления в силу. Если не использовать в течение срока действия, купоны автоматически станут недействительными.",
    "GouWuQuanQAWenTi4": "Как получить обменные подарки?'",
    "GouWuQuanQANeiRong4": "После обмена подарков ваш менеджер свяжется с вами, чтобы организовать доставку. Пожалуйста, обсудите все свои требования с вашим менеджером.",
    "ZuiHouGengXin": "Последнее обновление",
    "FaQiZhaoYangChengGong": "Запрос на образцы успешно создан!",
    "WoDeJiFenHeGouWuQuan": "Мои баллы и купоны.",
    "MingTianJiangYouNJiFenDaoQi2": "Баллы действительны в течение {0} дней с момента их начисления. Каждый день вы можете зарабатывать очки за добавление запросов.",
    "ZiJiTiaoXuan": "Выберите сейчас",
    "YouXiuKeHuJinLiJunJinGuoShenHe": "Лучшие менеджеры по работе с клиентами проходят проверку",
    "BuTongDeBaoJiaZuHeYingXiangShangPinJiaGe": "Различные комбинации котировок влияют на цену товара, нажмите на настройки",
    "QingQueRenYiXiaXinXi": "Пожалуйста, подтвердите следующую информацию",
    "SheZhiBaoJiaZuHe": "Установить комбинацию цен",
    "KeXiaDanShangPin": "Товары, которые можно заказать",
    "QuanBuXuanBenYe": "Нет на этой странице",
    "QuanXuanBenYe": "Выберите все",
    "PiLiang": "Размер партии",
    "YiXuanNKuanNXiangZongJiN": "Выбрано {0}Модель, {1}Кейс, Всего {2}",
    "QingXianXuanZeYaoXiaDanDeShangPin": "Пожалуйста, выберите продукт, который вы хотите заказать первым",
    "DangQianXuanLeNGeKeHuJingLi": "В настоящее время выбрано {0} менеджеров по работе с клиентами, пожалуйста, выберите только одного, чтобы продолжить заказ.",
    "ChaoGuoZuiDaPiLiangCaoZuoTiaoShuN": "Превышено максимальное количество пакетных операций: {0}",
    "QingXuanZeBaoJiaFangShi": "Пожалуйста, выберите метод расчета",
    "QingXuanZeChuHuoCang": "Пожалуйста, выберите склад отгрузки",
    "QingXuanZeXiaShuiGang": "Пожалуйста, выберите порт разгрузки",
    "QingXuanZeHuoGui": "Пожалуйста, выберите контейнер",
    "YiXiaBaoJiaZuHeKeSuiShiZaiGouWu": "Следующие комбинации могут быть установлены на странице корзины в любое время.",
    "JiaoYiBiZhongYiDanQueRenHou": "Валюта сделки после подтверждения не может быть изменена, если вам необходимо изменить валюту сделки, пожалуйста, свяжитесь со службой поддержки.",
    "QingXuanZeJiaoYiBiZhong": "Пожалуйста, выберите валюту сделки",
    "XuYaoYiQiXiaDanWeiHuo": "Если вам нужно заказать хвостовые товары вместе, пожалуйста, нажмите",
    "TianJiaWeiHuo": "Добавить хвостовые товары",
    "ZhuYaoCaiZhi": "Основной материал",
    "QinXuanZeJiaoYiBiZhong": "Пожалуйста, выберите валюту сделки",
    "DangQianGongYinShangQiSongLiangNWaiXiang": "Текущее начальное количество поставщика {0} во внешнем поле, пожалуйста, отметьте больше товаров или увеличьте количество",
    "JiaoHuoRiQi": "Дата доставки",
    "DingDanMeiYouShuJuFanHuiGouWuCheZhongXinXiaDan": "Данные для текущего заказа отсутствуют, пожалуйста, вернитесь в корзину, чтобы оформить новый заказ.",
    "DingDanShuJuYiJingBianDongQingShuaXinHou": "Данные текущего заказа были изменены, пожалуйста, обновите, проверьте информацию и повторно отправьте заказ.",
    "BuFenShangPinBuManZu": "Если вы продолжите отправлять выбранный в данный момент товар, он будет пропущен по следующим причинам:",
    "QuanBuShangPinBuManZu": "В настоящее время выбранный для заказа товар, нет товаров, чтобы удовлетворить требования заказа, причины следующие:",
    "DingGouLiangDiYuMoqYaoQiu": "Количество заказа меньше, чем требование MOQ",
    "JiXuTiJiao": "Продолжить отправку",
    "ShangPinBuManZuGongChangDeQiSongLiang": "Товар не соответствует начальному количеству поставки.",
    "ShangPinBuManZuGongChangDeMOQYaoQiu": "Товар не соответствует требованиям фабрики по MOQ.",
    "DangQianPiLiangCaoZuoZhong": "В текущей пакетной операции есть товары, которые были пропущены для обработки по следующим причинам:",
    "XunJiaZhongDiShangPinBuNeng": "Товар в запросе не может быть повторно запрошен.",
    "JiaBaoNeiShangPinBuNengChong": "Товар в ценовой гарантии не может быть указан повторно.",
    "CanYuHuoDongDeShangPinBuNeng": "Товар, участвующий в событии, не может быть запрошен.",
    "ShiXiaoShangPinBuNengXunJia": "Недействительные товары не могут быть запрошены.",
    "ShangPinBeiXiTongSuoDing": "Товар был заблокирован системой и в данный момент не может быть использован, пожалуйста, подождите, пока система освободит его.",
    "ZhongGuoGongChang": "Kитайских фабрик",
    "PinPaiShangPinFenLei": "Товарная категория фабрики",
    "1001CT1001": "Я не могу добавить товар в корзину",
    "CanJianXiangXiBiaoZhun": "См. подробные критерии",
    "LiaoJieDuoKeHuJinLiJiZhi": "Понимание механизма работы нескольких менеджеров",
    "DangQianJiaGouDeShangPinJiang": "За текущей покупкой будет следить выбранный менеджер, вы можете переключать менеджеров, если они вас не устраивают, вы можете сменить их в любое время.",
    "ShangPinYouYiXiaKeHuJinLiGenJin": "Элементы будут отслеживаться следующими менеджерами по работе с клиентами",
    "DangQianHaiMeiYouKeHuJinLi": "В настоящее время менеджеров по работе с клиентами нет, вы можете выбрать до двух менеджеров по работе с клиентами, которые будут оказывать услуги одновременно, и можете сменить их в любое время.",
    "JingJinFuWuTiYan": "Улучшение качества обслуживания: инновации бизнес-модели TWO TO ONE",
    "WeiLeTiShengPingTaiDeFuWuHeCaiGouDeTiYan": "Для того чтобы улучшить качество обслуживания и опыт покупок, платформа запустила режим TWO TO ONE account manager, вы можете иметь двух менеджеров, которые будут помогать вам в покупках и пользоваться более подробным обслуживанием, или вы можете оставить одного менеджера, который будет обслуживать вас.",
    "JingZhunDuiJie": "Точный подбор персонала",
    "DangCaiGouBuTongDeChanPinXianShi": "При покупке разных товарных позиций вы можете выбрать двух менеджеров для покупки разных товаров.",
    "TiGaoTiYan": "Улучшить опыт",
    "TiYanBuTongYeWuJingLiDeFuWu": "Ощутите сервис разных менеджеров по работе с клиентами, сравните скорость и качество обработки требований и, наконец, передайте заказ тому, кто вам нужен. Здоровая конкуренция между ними значительно повысит уровень вашего обслуживания.",
    "JiangDiFengXian": "Снижение рисков",
    "JiangDiZhiJieGengHuanYeWu": "Снижайте риски при смене менеджера по работе с клиентами напрямую, не нужно передавать информацию о требованиях к заказу новому менеджеру, так как вся информация хранится в нашей CRM, чтобы ваши покупательские привычки не были забыты!",
    "DingDanBaoZhang": "Гарантия заказа",
    "ZaiYouWeiWanChengDeDingDanShi": "Временное отсутствие одного из менеджеров (командировка, отпуск или болезнь) не повлияет на скорость обработки заявок и выполнения заказов. Кроме того, в случае незавершенных заказов, после выбора нового менеджера, первоначальный ответственный менеджер будет продолжать следить за выполнением заказа до его завершения.",
    "CaoZuoZhiNan": "Операционные рекомендации",
    "XuanZeJingLi": "Выбор менеджеров",
    "JinRuYeWuJingLiYeMianDianJi": "Войдите на страницу \"Менеджер по работе с клиентами\" и нажмите кнопку \"+\", чтобы добавить нового менеджера по работе с клиентами; нажмите кнопку \"Управление\", чтобы заменить выбранного менеджера по работе с клиентами.",
    "YeWuJingLiGouWuChe": "Корзина менеджера по работе с клиентами",
    "XuanZeLeLiangWeiJingLiShi": "Если выбраны два менеджера, две корзины соответствуют разным менеджерам, и они отслеживают свои корзины по отдельности.",
    "GouWuCheQieHuan": "Переключение корзин",
    "JiaGouShangPinQian": "Перед добавлением товара выберите соответствующего менеджера в правом верхнем углу, который будет следить за вами. Два менеджера могут быть выбраны одновременно",
    "YueFenChengJiaoFenBuTu": "Диаграмма распределения транзакций по месяцам",
    "YiShenQingDengDaiKeHuQueRenZhong": "Заявка подана, ожидается подтверждение клиента.",
    "ShenQingXiangQing": "Детали приложения",
    "WoYiLiaoJieQuTiaoXuanKeHuJinLi": "Я понял, перейдите к выбору менеджера по работе с клиентами",
    "NiYiZhuDongFangQiGengJinGaiKeHu": "Вы добровольно отказались от сопровождения этого клиента, ожидая, пока будет проведено разделение. Клиент перешел в полупубличный статус, его могут отслеживать другие менеджеры по продажам.",
    "KeHuYiJinRuBanGongKaiZhuangTai": "Клиент перешел в полупубличный статус, и его могут отслеживать другие менеджеры по продажам.",
    "YeJiZuZhang": "Руководитель группы эффективности",
    "GengHuanKeHuJinLiChengGong": "Замена менеджера по работе с клиентами прошла успешно!",
    "DangQianZiLiaoWanShanDu": "Текущая степень завершенности информации {0}, завершение информации поможет улучшить имидж и доверие фабрики к вам",
    "BuFenShuYuGuanJianXinXiWeiBaoZhangNinDeXinXiZhengQueXing": "Некоторые относятся к ключевой информации для обеспечения правильности вашей информации. После изменения ключевой информации она должна быть снова рассмотрена, прежде чем она вступит в силу. Ключевые элементы информации будут перечислены при подаче измене",
    "GongSiJianJieShiLiXingXiang": "Профиль компании/сила/изображение",
    "WanShanGongSiDeJieShao": "Улучшение представления о компании может подтвердить вашу силу и надежность, помогая фабрике открывать больше разрешений и предоставлять вам больше информации о продукции",
    "WaiMaoZhuGongQuYuHeCiYaoQuYuYouChongFuDe": "Есть дубликаты в основных и вторичных зонах внешней торговли",
    "ZhuGongQuYuYiNianZiRanNianZhiYunXuXiuGaiYiCi": "Основная область может быть изменена только один раз в год (календарный год), и последнее время изменения было",
    "TiJiaoShiBaiQingShaoHouChongShi": "Ошибка отправки, пожалуйста, повторите попытку позже!",
    "YouZhuYuZengJiaGongChangDuiNiDeXinRen": "Помогает увеличить доверие фабрики к вам",
    "DaoChuBaoJiaDanShiKeYiZhanShiNiGongSilogo": "При экспорте котировок вы можете отображать логотип вашей компании",
    "ShangChuanLogo2": "Загрузить логотип цитаты",
    "ZhuGongShiChang": "Основной рынок",
    "ZhiChiDuoXuan": "Поддерживает множественный выбор",
    "QinXuanZeZhuGongShiChang": "Пожалуйста, выберите основной рынок",
    "WaiMaoZhuGongQuYu": "Основная зона внешней торговли",
    "DanXuan": "Одиночный выбор",
    "QinXuanZeWaiMaoZhuGongQuYu": "Пожалуйста, выберите основную зону внешней торговли",
    "CiYaoQuYu": "Вторичная область",
    "ZuiDuoZhiNengXuanZeNGe": "Вы можете выбрать только до {0}",
    "QingTianXieGongSiDiZhi": "Пожалуйста, укажите адрес компании",
    "QuWanShanGongSiJianJie": "Перейдите, чтобы заполнить профиль компании",
    "GongSiJianJie": "Профиль компании",
    "GongSiJianJieTiShi": "Пожалуйста, представьте компанию, фабрика может увидеть это введение, лучшее введение всегда создает хорошее впечатление. Максимум 800 символов.",
    "QinXuanZeGongSiNianYingShouGuiMo": "Пожалуйста, выберите годовой объем доходов компании",
    "GongSiNianYingShouGuiMo": "Годовой объем доходов компании",
    "GongSiRenYuanGuiMo": "Размер персонала компании",
    "QinXuanZeGongSiRenYuanGuiMo": "Пожалуйста, выберите размер персонала компании",
    "GongSiHeZuoGuoDeHuoBan": "Партнеры, с которыми сотрудничала компания / крупные сделки, которые заключила компания",
    "GongSiXingXiang": "Изображение компании",
    "TuWenBingMaoZhanXianGongSiShiLi": "Графически продемонстрируйте силу компании, изображения поддерживают форматы jpg/png/gif, до 6 изображений.",
    "QingShangChuanYongHuTouXiang": "Пожалуйста, загрузите аватар пользователя",
    "QingTianXieZhenShiXingMing": "Пожалуйста, укажите свое настоящее имя",
    "QingShangChuanShenFenZhengBeiMian": "Пожалуйста, загрузите обратную сторону вашего удостоверения личности",
    "QingShangChuanShenFenZhengZhengMian": "Пожалуйста, загрузите лицевую сторону вашего удостоверения личности",
    "QingXuanZeShanChangYuYanBingQieZuiDuoXuanZeSanGe": "Пожалуйста, выберите владение языками...",
    "QingXuanZeShanChangShiChangBingQieZuiDuoXuanZeLiangGe": "Пожалуйста, выберите владение рынками...",
    "QingTianXieWaiMaoCongYeShiChangBingQieBuNengWei0": "Пожалуйста, укажите продолжительность опыта внешней торговли...",
    "QingXuanZeShanChangKeHuLeiXing": "Пожалуйста, выберите типы клиентов...",
    "QingXuanZeYiGeZhuYaoPinLei": "Пожалуйста, выберите основную категорию",
    "QingXuanZeCiYaoPinLeiBingQieZuiDuoXuanZeLiangGe": "Пожалуйста, выберите дополнительные категории...",
    "QingZuiShaoWanShanYiMenYuYanDeGeRenTeChang": "Пожалуйста, укажите хотя бы одно личное владение языком",
    "BuFenYuYanXinXiYiTianXieDanWeiTianXieWanQuan": "Некоторая информация о языках заполнена, но не полностью",
    "GengHuanTouXiang": "Сменить аватар",
    "ShouJiZhangHaoMing": "Мобильный телефон (имя аккаунта)",
    "YuanGongDaiHao": "Код сотрудника",
    "ZhenShiXingMing": "Настоящее имя",
    "ShuRuZhenShiXingMing": "Введите ваше настоящее имя",
    "ShangChuanShenFenZheng": "Загрузите удостоверение личности",
    "YongYuRenZhengHeHouXuQianDingHeTongXieYi": "Используется для аутентификации и последующего подписания контрактов...",
    "ZhiChiTuPianGeShi": "Поддерживаемые форматы изображений",
    "GuoHuiMian": "Гербовая сторона",
    "RenMianXiang": "Лицевая сторона",
    "QingShuRuWhatsApp": "Пожалуйста, введите WhatsApp",
    "WeiXinWeChat": "WeChat",
    "QingShuRuWeiXinWeChat": "Пожалуйста, введите WeChat",
    "ShanChangYuYan": "Владение языками",
    "ZuiDuoNGe": "До {0}",
    "QingXuanZeShanChangYuYan": "Выберите уровень владения языком",
    "ShanChangShiChang": "Рынок экспертизы",
    "QingXuanZeShanChangShiChang": "Выберите рынок экспертизы",
    "QingShuRuWaiMaoCongYeShiChang": "Введите стаж работы в сфере внешней торговли",
    "ShanChangKeHuLeiXing": "Предпочтительные типы клиентов",
    "ShanChangZhuYaoPinLei": "Экспертиза основных категорий продуктов",
    "QingXuanZeShanChangZhuYaoPinLei": "Выберите основные категории продуктов",
    "HaiShanChangQiTaPinLei": "Другие категории продуктов",
    "QingXuanZeShanChangQiTaPinLei": "Выберите другие категории продуктов",
    "GeRenTeChangJianJie": "Введение в личную специализацию",
    "ZhiShaoWanShanYiZhongWaiYuZiLiao": "Совершенствование информации хотя бы на одном иностранном языке",
    "XinZengQiTaYuZhongJieShao": "Добавить введение на другом языке",
    "WaiYuMingNiCheng": "Имя на иностранном языке (псевдоним)",
    "ShuRuDuiYingYuYanDeXingMing": "Введите соответствующее имя на языке",
    "JianDuanJieShaoZiJiDeLiangDian": "Краткое вступление о ваших основных моментах, рекомендуется не более 240 символов.",
    "JieShaoZiJiGuoWangDeYiXieChengGongAnLi": "Представьте прошлые успешные кейсы и отзывы клиентов",
    "YiJuHuaLiangDian": "Основное предложение",
    "YuYanNengLi": "Знание языка",
    "FuWuTaiDu": "Отношение к обслуживанию",
    "FanKuiXiaoLU": "Эффективность обратной связи",
    "JieJueWenTi": "Решение проблем",
    "ShiFouQueRenTiJiao": "Подтвердить отправку",
    "QingGenJuZiShenShiJiQingKuangJinXingPingJia": "Оцените, пожалуйста, в соответствии с вашей реальной ситуацией",
    "NXing": "{0} Звёзд",
    "ZiWoPingJia": "Самооценка",
    "GengXinTouXiang": "Обновить аватар",
    "ShangChuanZhenShiGaoQingTouXiangLiKeHuXinRenGengJinYiBu": "Загрузите реальный аватар высокого качества, чтобы завоевать дополнительное доверие клиентов!",
    "TuiJianShangChuanZhengFangXing1BiLiDeTouXiang": "Рекомендуется загрузить квадратный аватар с соотношением 1:1",
    "ZanWuHuoDong": "Нет текущих мероприятий",
    "NKuanJiaRuXuanPinChi": "{0} товаров добавлено в пул выбора",
    "JiaRuXuanPin": "Добавить в выбор",
    "YiXuanPin": "Выбранные товары",
    "WeiWanShanWuFaXuanPin": "Неполный, нельзя выбрать товары",
    "JiaGeGengXin": "Цены обновлены",
    "WoDeBaoJiaDan": "Мой список цен",
    "SouSuoBiaoTi": "Поиск по названию",
    "WeiChaKan": "Непросмотрено",
    "KeHuChaKan": "Просмотрено клиентом",
    "KeHuJiaGou": "Клиент добавлен в корзину",
    "FenXiangLianJieGeiKeHu": "Поделиться ссылкой с клиентом",
    "FangWenMiMa": "Пароль доступа",
    "WuFangWenMiMa": "Нет пароля доступа",
    "YiChongXinJiaRuXuanPinChi": "Повторно добавлено в пул выбора",
    "QingQianWangXuanPinChiChaKanShangPin": "Пожалуйста, перейдите в пул выбора, чтобы посмотреть товары",
    "WeiTianXieMiaoShu": "Описание не заполнено",
    "YiJiaGou": "Добавлено в корзину",
    "LaoBan": "Босс",
    "FuZhiFenXiang": "Копировать ссылку",
    "ChongXinJiaRuXuanPinChi": "Повторное добавление в пул выбора",
    "BianJiZhuTi": "Редактировать тему",
    "MeiYouGengDuoLe": "Больше нет",
    "ShanChuBaoJiaDanKeHuJiangBuNengZaiFangWenCiBaoJiaDan": "Удалить квоту, клиент больше не сможет получить доступ к этой квоте, удаление нельзя отменить, продолжить?",
    "GengXinChengGong": "Обновление успешно",
    "QingTianXieBaoJiaDanZhuTi": "Пожалуйста, заполните тему квоты",
    "BaoJiaDanZhuTi": "Тема квоты",
    "ShangPinChaKanShenQing": "Запрос на просмотр товаров",
    "YiTiJiaoShenQingQingDengDaiGongChangShenHe": "Заявка отправлена, пожалуйста, дождитесь проверки фабрики",
    "YuanYin": "Причина",
    "ChongXinShenQing": "Повторно подать заявку",
    "MaiShouShenQingZhongWuFaJiaGou": "Заявка покупателя в процессе, нельзя добавить в корзину",
    "BaoJiaDanXiangQing": "Детали квоты",
    "JiaGouChengGong": "Добавлено в корзину успешно",
    "KeHuFuWuFei": "Плата за обслуживание клиентов",
    "KeHuJiaJiaLU": "Надбавка клиента",
    "ZaiXianFenXiang": "Онлайн-поделиться",
    "KeHuYouYiXiang": "У клиента есть намерение",
    "SouSuoShangPinHuoHao": "Поиск товара/артикула",
    "GongChangRangLiJia": "Цена скидки фабрики",
    "ZiDingYiBaoJia": "Индивидуальная квота",
    "YiXiangNXiang": "Намерение {0} коробок",
    "ZanWuSouSuoShangPin": "Товары не найдены",
    "QianBoDaYouXiao": "Предыдущий звонок эффективен",
    "YuLanBaoJiaDan": "Просмотр квоты",
    "GongChangMingCheng": "Название фабрики",
    "YuLanMoShiXiaWuFaXunJia": "Запрос недоступен в режиме предварительного просмотра",
    "YuLanMoShiXiaDaoChuBaoJiaDan": "Экспорт квоты недоступен в режиме предварительного просмотра",
    "DangQianChuYuYuLanMoShiXunJiaAnNiuWuFaCaoZuo": "Кнопка запроса отключена в режиме предварительного просмотра",
    "YuLanMoShiXiaWuFaDaoChuTuPian": "Экспорт изображений недоступен в режиме предварительного просмотра",
    "SouSuoShangPinBianHaoHuoHao": "Поиск товара/артикула",
    "XunJiaShiBaiQingShaoHouChangShi": "Запрос не удался, попробуйте позже!",
    "ShangPinBaoZhuang": "Упаковка товара",
    "YuLanMoShiXiaWuFaXiuGaiQiDingLiang": "Минимальное количество заказа нельзя изменить в режиме предварительного просмотра",
    "NiLaiWanLeFenXiangDeBaoJiaDanYiJingBeiQuXiaoLe": "Вы опоздали, распределенная квота была отменена",
    "TaRenTuiJian": "Рекомендовано другими",
    "YiXuanNKuan": "Выбрано {0} товаров",
    "SheZhiFenZu": "Установить группу",
    "DaoChuSuoXuanShangPinTuPian": "Экспорт выбранных изображений товаров",
    "DaoChuGaiBanShenQingBiao": "Экспорт формы заявки на изменение",
    "NKuanShangPinJiaGeWeiGengXinDaoZuiXinJia": "Цены на {0} товаров не обновлены до последних",
    "ChongXinXunZuiXinJia": "Повторно запросить последнюю цену",
    "DaoChuBaoJiaDanWuKeHu": "Экспорт квоты (без клиентов)",
    "NKuan": "{0} товаров",
    "ChaKanLiShiDaoChu": "Просмотреть историю экспорта",
    "FanHuiXuanPinChi": "Вернуться в пул выбора",
    "SheZhiBingDaoChuBaoJiaDan": "Установить и экспортировать квоту",
    "YiJiaWoMenHuiDuiGongChangZhanShiNinDeXinXi": "При торговле мы покажем вашу информацию фабрике для получения более выгодных цен",
    "BiGongChangBaoJiaN": "Ниже заводской цены на {0}",
    "JiangJiaN": "Снижение цены на {0}",
    "PiLiangCaoZuo": "Массовая операция",
    "ZiDingXiangShuHeQiWangJiaGeXiangGongChangFaQiYiJia": "Переговоры с фабрикой по количеству и ожидаемым ценам",
    "YiFaQiZhiNengYaJia": "Инициирован интеллектуальный торг",
    "FaQiZhiNengYaJiaShiBaiQingShaoHouChongShi": "Инициализация интеллектуального торга не удалась, пожалуйста, повторите попытку позже!",
    "ZiDongXiangGongChangFaQiXunJiaBingYaJia": "Автоматически запрашивать и торговаться с фабрикой",
    "QingChuChengGong": "Очистка успешна",
    "QingChuShiBaiQingShaoHouChongShi": "Очистка не удалась, пожалуйста, попробуйте еще раз позже.",
    "GongChangYuanJia": "Оригинальная цена завода",
    "HuLüeGongChangBaoJiaYiZiJiBaoJiaZhanShiGeiKeHu": "Игнорировать цену фабрики и показывать свою цену клиенту",
    "ShanChuShiBaiQingShaoHouChongShi": "Ошибка удаления, пожалуйста, попробуйте позже!",
    "JiaRuXuanPinChiChengGong": "Успешно добавлено в пул выбора",
    "JiaRuXuanPinChiShiBai": "Не удалось добавить в пул выбора",
    "30Tian": "30 дней",
    "GeiNiTuiJianQiTaXiangSiShangPin": "Рекомендуем вам другие похожие товары",
    "NXiang": "{0} коробок",
    "NTian": "{0} дней",
    "QingXuanZeFenZu": "Пожалуйста, выберите группу",
    "WanZhuanXuanPinChiXiaoLUJiaBei": "Владение пулом выбора, удвоение эффективности",
    "XiaoLUJiaBei": "Двойная эффективность",
    "ShangPinFenZu": "Группировка товаров",
    "ZiDongZuiXinJia": "Автоматическое обновление цен",
    "JiaJiaYuLan": "Предварительный просмотр наценки",
    "ZhiNengYaJia": "Интеллектуальное торговое дело",
    "ZiZhuYiJia": "Независимые переговоры",
    "ZaiXianBaoJiaDan": "Онлайн-квота",
    "KeHuChaKanBaoJiaDan": "Просмотр квоты клиентом",
    "LiShiBaoJiaDan": "Исторические квоты",
    "LingHuoChaKanXuanPinChiShangPin": "Гибкий просмотр товаров из пула выбора, можно просматривать по классификации поставщика или группе, управление товарами в корзине становится более понятным и ясным;",
    "DuoChongShaiXuanShangPin": "Множественная фильтрация товаров: по \"времени присоединения\", \"диапазону котировок\", \"статусу запроса\", \"категории товара\" и другим множественным измерениям, статус приобретенных товаров понятен и понятен;",
    "KeHuGuanLiWeiLeFangBianGuanLiKeHu": "Управление клиентами: Для удобства управления клиентами вы можете добавлять информацию о клиентах, включая код клиента, клиентский никнейм, валюту квотации, язык квотации, метод квотации, распределение прибыли от запросов, назначение продавцов и другую ин",
    "FenZuGongNengShangXianLa": "Функция группировки в сети, которая может повысить эффективность управления товарами, попробуйте сейчас!",
    "XinZengFenZuJieShao": "[Новая группа]: Метод 1: Выберите товар для добавления в пул выбора, щелкните \"Новая группа\", вы можете настраивать название новой группы, выберите созданную группу ниже, а затем присоединитесь к указанной группе; Метод 2: Щелкните \"Новая группа\" непосред",
    "SouSuoFenZuJieShao": "[Поиск группы]: Когда групп слишком много, можно использовать функцию поиска, чтобы найти группы, а затем присоединиться к выбору",
    "ShanChuFenZuJieShao": "[Удалить группу]: После деталей группы или поиска группы нажмите \"X\", чтобы удалить группу, и товары в группе также будут удалены, используйте это осторожно!",
    "ZiDongZuiXinJiaNinTiaoXuanShangPinJiaGouDaoXuanPinChiZhiHou": "Автоматическая последняя цена: После выбора товаров для добавления в пул выбора система автоматически отправит информацию о продукте на фабрику. Фабрика подтвердит и ответит на последнюю цену продукта как можно скорее. Попробуйте добавить его в корзину се",
    "JiaJiaYuLanYiJianGeiShangPinSheZhiJiaJia": "Предварительный просмотр наценки: Установите наценку на товары одним нажатием, и просмотрите цену после наценки в Интернете. Попробуйте сейчас!",
    "ZhiNengYaJiaJieShao": "Интеллектуальная торговля: Система автоматически ведет переговоры до исторически самой низкой цены на основе исторически зарегистрированных цен поставщиков. Попробуйте сейчас!",
    "ZiZhuYiJiaZhiMaoYiShangGenGongChangQuYiJia": "Независимое соглашение: Торговцы ведут переговоры с заводами",
    "XuanPinChiZaiXianBaoJiaDanJieShao": "Онлайн-квота, быстрое и эффективное сотрудничество: Выберите товары из корзины, добавьте новых клиентов для совместного использования или выберите существующих, заполните заголовок квоты, рекомендации, определите шаблоны квот и информацию для отображения,",
    "XuanPinChiKeHuChaKanBaoJiaDanJieShao": "Просмотр квот клиентами, мгновенная обратная связь о намерениях по продуктам: Клиенты открывают общую ссылку, вводят пароль, указанный в общей ссылке, и могут просматривать квоту, обеспечивая мгновенную обратную связь о намерениях по продуктам.",
    "XuanPinChiGuanLiLiShiBaoJiaDanJieShao": "Управление историческими квотами: Исторические квоты позволяют видеть все детали квот, рекомендованных указанным клиентам в истории, облегчая торговцам копирование и обмен историческими квотами, просмотр деталей, предварительный просмотр содержимого квот ",
    "QingChuFenZuChengGong": "Успешное удаление группы!",
    "QingChuFenZuShiBaiQingShaoHouChongShi": "Ошибка при очистке группы, пожалуйста, попробуйте позже!",
    "ShanChuZiDingYiBaoJiaChengGong": "Успешное удаление пользовательской квоты!",
    "ShanChuZiDingYiBaoJiaShiBaiQingShaoHouChongShi": "Не удалось удалить пользовательскую квоту, пожалуйста, попробуйте позже!",
    "WuFenZu": "Без группы",
    "XunJiaWanCheng": "Запрос завершен",
    "DengDaiGongChangHuiFuYuJiNGeGongZuoRi": "Ожидание ответа от завода, примерно {0} рабочих дней",
    "GongChangHuiFuMOQ": "Ответ завода: MOQ",
    "FenZu": "Группа",
    "DaiGongChangQueRenZuiXinJiaGe": "Ожидание подтверждения последних цен заводом",
    "QingZhengQueDeJiaJiaLUZuiDuoBaoLiuLiangWeiXiaoShu": "Пожалуйста, введите действительную наценку, с не более чем двумя знаками после запятой и от 0 до 1000!",
    "KuaiSuYuLanJiaGeHouDeJiaGe": "Цена после быстрого предварительного просмотра не влияет на конечную цену экспортируемой квоты",
    "QingTianXieJiaJiaLU": "Пожалуйста, введите наценку",
    "GuiLing": "Сброс",
    "QingZhengQueDeFOBFeiYongZuiDuoBaoLiuSiWeiXiaoShu": "Пожалуйста, введите действительную стоимость FOB, с не более чем четырьмя знаками после запятой",
    "QingTianXieMeiYuanDuiHuanRenMinBiHuiLU": "Пожалуйста, введите курс обмена доллара США на юань",
    "QingZhengQueDeMeiYuanDuiHuanRenMinBiHuiLU": "Пожалуйста, введите действительный курс обмена доллара США на юань, с не более чем четырьмя знаками после запятой",
    "MeiYuanDuiHuanRenMinBiHuiLU": "Курс обмена доллара США на юань",
    "LianJie": "Ссылка",
    "YuLan": "Предпросмотр",
    "JiaoYiXinXi": "Информация о транзакции",
    "FuZhiDuanLian": "Копировать короткую ссылку",
    "DaoChuBaoBiao": "Экспорт отчета",
    "DaoChuChengGong": "Экспорт успешен",
    "DaoChuChengGongZaiXianFenXiangGengGaoXiao": "Экспорт успешен, онлайн-поделиться более эффективно",
    "RuYouFangWenMiMaJiuShiKeHuDaiHao": "Если есть пароль доступа, это код клиента. Вы можете перейти в раздел \"История цитат\", чтобы просмотреть историю экспорта.",
    "HanYu": "Китайский",
    "YingYu": "Английский",
    "EYu": "Русский",
    "EXWBiaoZhunBaoJiaGuiZe": "Стандартные правила котировки EXW",
    "ShangPinChanDiWeiShanTouShiZuHeBaoJia": "Когда место происхождения товара - Шаньтоу: Шаньтоу (склад отправки) - Шаньтоу (порт отправки) - 40HQ (контейнер) комбинированная цитата",
    "ShangPinChanDiWeiGuangZhouShiZuHeBaoJia": "Когда место происхождения товара - Гуанчжоу: Гуанчжоу (склад отправки) - Гуанчжоу (порт отправки) - 40HQ (контейнер) комбинированная цитата",
    "ShangPinChanDiWeiYiWuShiZuHeBaoJia": "Когда место происхождения товара - Иу: Иу (склад отправки) - Нинбо (порт отправки) - 40HQ (контейнер) комбинированная цитата",
    "ZhuYiXiaDanShiRuoGuiZiChuHuoCang": "Примечание: Изменения в складе отправки, порте отправки и типе контейнера при размещении заказа могут повлиять на средний расход FOB товаров и привести к дополнительным расходам на короткие расстояния (когда склад отправки не находится в том же районе, чт",
    "DaoChuZhong": "Экспорт",
    "FOBBaoJiaGenJuXuanZeDeChuHuoQuYu": "Цитата FOB: Рассчитывается на основе выбранной области отправки, порта отправки и типа контейнера; Цитата DDP: Рассчитывается на основе стандартной области отправки, порта отправки и типа контейнера выбранного маршрута",
    "QingXuanZeChuHuoCangXiaShuiGangHeHuoGui": "Пожалуйста, выберите склад отправки, порт отправки и контейнер",
    "QingXuanZeHangXian": "Пожалуйста, выберите маршрут",
    "XuanZeJunTanFuWuFeiLUHeBiZhong": "Пожалуйста, выберите ставку обслуживания и валюту для усреднения",
    "JunTanFuWuFeiLU": "Ставка обслуживания",
    "FenZuFangShi": "Способ группировки",
    "PaiXuFangShi": "Метод сортировки",
    "ShengXu": "Возрастающий порядок",
    "BaoJiaDanWei": "Единица котировки",
    "DanGe": "Один",
    "ZhongBao": "Средний пакет",
    "DanGePCSRuGuoShangPinYiGeBaoZhuangZhongHanYouDuoGePCS": "Один PCS: Если в одном пакете несколько PCS, расчет производится по одному PCS, например, если в дисплейном ящике несколько PCS, расчет производится по одному PCS",
    "ZhongBaoRuGuoShangPinYiGeBaoZhuangZhongHanYouDuoGePCS": "Средний пакет: Если в одном пакете несколько PCS, расчет производится по всему среднему пакету, например, если в дисплейном ящике несколько PCS, расчет производится по одному дисплейному ящику",
    "TongYongDaYin": "Универсальная печать",
    "ChongXinXunJiaShiBaiQingShaoHouChongShi": "Повторный запрос не удался, пожалуйста, попробуйте позже!",
    "QueDingChongXinXunJiaXuanZhongDeShangPin": "Подтвердите повторный запрос для выбранных товаров",
    "QingXuanZeBaoZhuangYuYan": "Пожалуйста, выберите язык упаковки",
    "QingXuanZeTuiJianRen": "Пожалуйста, выберите рекомендателя",
    "QingXuanZeTuiJianZhuTi": "Пожалуйста, выберите тему рекомендации",
    "ShangPinLeiMu": "Категория товара",
    "SouSuoShangPinBianHaoHuoHaoGongYingShangMingZi": "Поиск товара/номера/артикула/имени поставщика",
    "AnGongYingShang": "По поставщику",
    "AnFenZu": "Группировать по",
    "ZhuYiHeBingDaoXinFenZuDeShangPinJiangCongYuanFenZuYiChu": "Примечание: Товары, объединенные в новую группу, будут удалены из оригинальной группы",
    "XuanZeYiYouFenZuHuoShuRuKeTianJiaXinFenZu": "Выберите существующую группу или введите для добавления новой группы",
    "QingTianXiefobFeiYong": "Пожалуйста, укажите стоимость FOB",
    "QingXuanZeShuRuHuiLU": "Пожалуйста, выберите ввод курса обмена",
    "QingXuanZeYuYan": "Пожалуйста, выберите язык",
    "QingShuRuJiaJiaLU": "Пожалуйста, введите коэффициент наценки",
    "BaoJiaDanShiLi": "Пример котировки",
    "WanShanGongSiXinXi": "Заполните информацию о компании",
    "GeiBaoJiaDanQiGeMingZi": "Дайте котировке имя для удобного управления историческими экспортами и отображения при просмотре онлайн-клиентов",
    "KeHuZaiXianLiuLanBaoJiaDanShi": "Когда клиенты просматривают котировку онлайн, она отображается и автоматически переводится в соответствии с языком клиента.",
    "KeHuChaKanShiKeZiZhuQieHuan": "Клиенты могут самостоятельно переключаться при просмотре. Текущая настройка - это режим отображения по умолчанию",
    "LieBiaoXingShi": "Формат списка",
    "XinXiDuo": "Больше информации",
    "TuPianDa": "Большие изображения",
    "GuDingHuiLU": "Фиксированный курс обмена",
    "QingShuRuGuDingHuiLU": "Пожалуйста, введите фиксированный курс обмена",
    "QingTianXieZhengQueDeHuiLU": "Пожалуйста, введите правильный курс обмена",
    "PingTaiHuiLU": "Курс обмена платформы",
    "MeiRiGengXin": "Ежедневное обновление",
    "QingTianXieZhengQueDeJiaJiaLU": "Пожалуйста, введите правильный коэффициент наценки",
    "QingShuRuF0B": "Пожалуйста, введите F0B",
    "QingTianXieZhengQueFOBFeiYong": "Пожалуйста, укажите правильную стоимость FOB",
    "GongChangXinXi": "Информация о фабрике",
    "BuBaoHanGongChangHuoHao": "Не включает номер товара фабрики",
    "DaoChuDeBaoJiaDanBuBaoHanGongChangHuoHao": "Экспортируемая котировка не включает номер товара фабрики",
    "ShanChuYiDaoChu": "Удалить экспортированный",
    "DaoChuDeShangPinZiDongShanChu": "Экспортированные товары автоматически удаляются",
    "DaoChuBaoJiaDanHouShanChuYiDaoChuShangPin": "После экспорта котировки удалите экспортированные товары",
    "ZhiNengXuanZeTongLeiXingKeHuPingTaiHuoSiYou": "Можно выбрать только клиентов того же типа (платформа или частное)",
    "NianChuHuoN": "Годовая отгрузка {0}",
    "BaoJiaDanJiangGenJuKeHuDangAnYuSheZhiJieShengChengDuiYingYuYan": "Выберите клиента, и котировка будет сгенерирована непосредственно в соответствии с профилем клиента с соответствующим языком, валютой, коэффициентом наценки и т. д. Если клиент не выбран, вы можете настроить язык, валюту, коэффициент наценки самостоятельн",
    "XinZengKeHu": "Добавить клиента",
    "SouSuoKeHuMingChengYouXiangBeiZhu": "Поиск имени клиента/электронной почты/примечания",
    "QuanBuSiYou": "Все частные",
    "QuanBuPingTai": "Все платформы",
    "ZanWuKeHuXinXi": "Нет информации о клиентах",
    "JianLiKeHuXinXiTiShi": "Создание информации о клиентах для удобства экспорта котировок, запросов и переговоров о ценах",
    "NiDeKeHuXinXiJiangDeDaoYinSiBaoHu": "Будьте уверены, что ваша информация о клиентах будет охраняться конфиденциально",
    "LiJiTianJia": "Добавить сразу",
    "YiXuanKeHu": "Выбранные клиенты",
    "YiXiaShangPinWeiWanChengXunJia": "Следующие товары не были запрошены",
    "XunJiaChengGong": "Запрос успешен",
    "WanShanKeHuXinXi": "Заполните информацию о клиенте",
    "QingWanShanYiXiaXinXiZaiJinXingPinGuiXiaDanCaoZuo": "Пожалуйста, заполните следующую информацию перед размещением заказа на контейнер",
    "WanShanKeHuDeGongSiMingCheng": "Укажите полное наименование компании клиента",
    "ShangChuanXiaoShouHeTongHou": "После загрузки продажного договора",
    "QueDingYaoTiJiaoPiLiangXunJiaMa": "Вы уверены, что хотите отправить пакетные запросы?",
    "NKuanZongTiJiNZongJiN": "{0} наименований, общий объем {1}, всего {2}",
    "QueDingShanChuSuoYouXuanZhongDeShangPin": "Вы уверены, что хотите удалить все выбранные товары?",
    "GongChangGeiDeChengJiaoJia": "Цена сделки, предложенная фабрикой",
    "QingShuRuDaYu0DeJinE": "Пожалуйста, введите сумму больше {0}",
    "QueDingYaoShanChuZiDingYiJiaGeMa": "Вы уверены, что хотите удалить настраиваемую цену?",
    "ShanChuZiDingYiJiaGe": "Удалить настраиваемую цену",
    "GeiKeHuDeChengJiaoJia": "Цена сделки для клиента",
    "GongChangDeCaiGouJia": "Цена закупки от завода",
    "LiRunLU": "Маржа",
    "JiaRuGouWuCheShiBai": "Добавление в корзину не удалось",
    "YiJiaZhong": "В процессе переговоров",
    "XunJiaJiaGeYiGuoQi": "Цена запроса устарела (заказ на основе измененной цены)",
    "JiaGeYiGuoQiXiaDanXuChongXinQueRen": "Цена устарела, заказ требует повторного подтверждения",
    "YiGaiJia": "Цена изменена",
    "FuLiRun": "Отрицательная прибыль",
    "YiZhangN": "Увеличено на {0}",
    "YiJiangN": "Уменьшено на {0}",
    "GongChangHuiFu": "Ответ от завода",
    "GeiKeHuChengJiaoJia": "Цена сделки для клиента",
    "YiJia": "Торговля",
    "XiuGaiJiaGe": "Изменить цену",
    "QingZhuYiYouBuFenGaiJiaShangPinShiFuLiRun": "Обратите внимание: некоторые измененные товары имеют отрицательную прибыль.",
    "ShaiXuanFuLiRunShangPin": "Фильтрация товаров с отрицательной прибылью",
    "QueDingYaoShanChuZiDingYiBaoJiaMa": "Вы уверены, что хотите удалить настраиваемую цену?",
    "RenGongGaiJia": "Ручное изменение цены",
    "XunQianChuLiGongChangHuiFuHouGengXin": "Обновление после обработки ответов от завода перед запросом",
    "YouXiaoQiZhi1": "Действительно до {0}",
    "ShengNTian": "Осталось {0} дней",
    "YiXiangChengJiaoJia": "Предполагаемая цена сделки",
    "QingXianChuLiGongChangHuiFu": "Пожалуйста, сначала обработайте ответ от завода",
    "HanXunJiaLiRun": "Включает прибыль от запроса",
    "HaiMeiYouShangPin": "Пока нет товаров",
    "XuanPinDaoChuZhuanShuNiDeZaiXianBaoJiaDan": "Выберите товары, экспортируйте вашу эксклюзивную онлайн-цитату",
    "ZhiChiXianShangFenXiangGengFangBianKuaiJieKeHuHaiKeYiZhiJieFanKui": "Поддерживает онлайн-поделиться, более удобно и эффективно, клиенты также могут давать прямую обратную связь",
    "MaShangQuXuanPin": "Перейти к выбору товаров сейчас",
    "QuanXuanPingTaiKeHu": "Выбрать всех клиентов платформы",
    "QuanXuanSiYouKeHu": "Выбрать всех частных клиентов",
    "NKuanShangPinYiJiaRuTuiJianChi2": "{0} товаров добавлены в пул выбора и добавлены в группу",
    "TianJiaFenZu": "Добавить группу",
    "ShanChuFenZu": "Удалить группу",
    "NiQueDingYaoShanChuNFenZu": "Вы уверены, что хотите удалить группу {0}?",
    "XiuGaiFenZuChengGong": "Успешное изменение группы",
    "ShuRuFenZuMingChengBiTianZuiChangNGeZi": "Введите название группы (обязательно), до {0} символов",
    "XinZengFenZu": "Добавить новую группу",
    "QingXuanZeYiGeFenZuFangBianKuaiJieShaiXuan": "Пожалуйста, выберите группу для удобной и быстрой фильтрации",
    "SouSuoFenZuMingZi": "Поиск по названию группы",
    "ZanBuShiYongFenZu": "Временно не использовать группы",
    "XiTongYiZiDongGenGongChangXunZuiXinJiaGe": "Система автоматически запросила у завода последние цены",
    "YiTianJiaFenZu": "Группа добавлена",
    "XiuGaiFenZu": "Изменить группу",
    "KeHuChi": "Пул клиентов",
    "ShengYuKaiFaQuanYi": "Оставшиеся права на развитие",
    "WeiYouGenJin": "Нет последующего",
    "YiYouGenJin": "Уже следовали",
    "DangQianKeHuYiYouXiaoShouJingLiGenJin": "В настоящее время у клиента уже есть менеджер по продажам, который следит за ним, но вы все равно можете подать заявку на последующий контакт. Как только клиент примет вашу заявку, вы будете ответственны за взаимодействие с клиентом.",
    "ShenQingGuo": "Заявлено",
    "ShangPinTiCheng": "Комиссия за товар",
    "XiaoShouE": "Сумма продаж",
    "XiaoShouGuiMo": "Масштаб продаж",
    "QuNianChengJiao": "Прошлогодние сделки",
    "JinNTianXuanKuan": "Выбор за последние {0} дней",
    "NWanYuan": "{0} десятков тысяч юаней",
    "ShengYuMuBiao": "Оставшаяся цель",
    "JinNianWeiWanChengMuBiao￥NHaiChaN%": "Эта годовая невыполненная цель ¥{0} все еще не хватает {1}%",
    "JieShouYuJiNengZhuan": "Ожидаемая прибыль при взятии",
    "ChaXunShiBai": "Учетная запись не активирована. Пожалуйста, сначала активируйте аккаунт",
    "DaiQueRenShengChanYaoQiu": "Ожидание подтверждения производственных требований",
    "DaiQueRenPaiBanTu": "Ожидание подтверждения макета",
    "DaiSheTieMai": "Ожидание наклейки",
    "DingJinYuQi": "Просроченный депозит",
    "HuoKuanYuQi": "Просроченная оплата",
    "NYue": "{0} месяц",
    "NNianYueFenChengJiaoFenBuTu": "Диаграмма распределения сделок за {0} год и месяц",
    "DangQianKaiFaKeHuQuanYiShuLiangShengYuN": "В настоящее время осталось N прав на развитие клиентов",
    "ShiFouJiXuKaiFaGaiKeHu": "Хотите продолжить развитие этого клиента?",
    "QingXianWanShan/QueRenKeHuJiDuMuBiao": "Пожалуйста, сначала выполните/подтвердите квартальные цели клиента",
    "KeHuGongGongChi": "Общий пул клиентов",
    "DaiKaiFaKeHuXiangQing": "Подробности о клиентах, ожидающих развития",
    "YiYouKeHuJingLiGenJin": "Уже обслуживается менеджером по продажам",
    "YeWuDengJi": "Бизнес-класс",
    "CaiGouGuiMo": "Масштаб закупок",
    "MoRenCaiGou": "По умолчанию закупка",
    "GongSiGuanWang": "Веб-сайт компании",
    "ShangYiCiXuanPin": "Последний выбор",
    "ShangYiCiTuiJian": "Последнее рекомендация",
    "ShangYiCiDengLu": "Последний вход",
    "JinNTianXuanPin": "Выбор за последние {0} дней",
    "ShengYuNianDuMuBiao（HaiChaN%)": "Оставшаяся годовая цель (еще не хватает {0}%)",
    "JiSuanFangShi": "Способ расчета",
    "JiaoYiHuiLv": "Обменный курс",
    "DanBaoFangShi": "Способ гарантии",
    "FanDianLv": "Ставка возврата",
    "ZhengDan2": "Весь заказ",
    "JunTan": "Средний",
    "WeiQiYong": "Не активировано",
    "JiaoYiTiaoKuan": "Условия сделки",
    "YiShenQingDengDaiQueRenZhong": "Уже подано, ожидается подтверждение",
    "ShenQingGenJin": "Заявка на последующее обращение",
    "TongXun": "Связь",
    "ZuiJinDengLuShiJian": "Последнее время входа",
    "DengLuCiShu": "Частота входа",
    "XuanPinShu": "Количество выборов",
    "ChaKanShangPinShu": "Количество просмотренных товаров",
    "ZhaoYangShu": "Количество запросов на образцы",
    "TianXieGengDuoZiLiao": "Заполнить больше информации",
    "ShouQiGengDuoZiLiao": "Свернуть больше информации",
    "NinTiJiaoXinXiYiChang": "Ваша отправленная информация нестандартна",
    "KeHuDaiHao": "Код клиента",
    "BaoJiaBiZhong": "Валюта предложения",
    "BaoJiaDanYuYan": "Язык предложения",
    "KeHuDingJinFangShi": "Способ оплаты задатка клиента",
    "XunJiaXiangGuan": "Связанный с запросом",
    "XunJiaLiRunZai": "Прибыль от запроса в",
    "NeiZhiJieRangLiGeiKeHuChaoChuBuFenLiRunZaiFenPei": "Прямые скидки клиентам, избыточная прибыль на перераспределение",
    "XunJiaLiRunFenPei": "Распределение прибыли от запроса",
    "GeiKeHuQiTaBaoLiu": "Клиенту, остальное резервируется",
    "BianJiKeHuLiRunFenPeiShiLi": "Пример: устанавливаются 5% и 20%, товарные котировки 10, запрос 9, прибыль по запросу 10%, затем 5% непосредственно заказчику (10*5%=5), избыточная часть распределяется 20% заказчику (5*20%=1), итого 5+1 заказчику, остальные 4 сохраняются как собственная ",
    "XunJiaZhangJiaShenHe": "Проверка повышения цен при запросе",
    "BuXuYaoShenHe": "Аудит не требуется",
    "XuYaoShenHe": "Требуется аудит",
    "DangYiCaiCaiGouZhongXinXunJiaHouDeJiaGeBiXunJiaQianGaoShi": "Если цена после запроса центра закупок ESSA выше, чем цена до запроса, выберите «Не требуется проверка», если дальнейшие переговоры не требуются. Если после запроса необходимо провести переговоры с заводом, выберите «Требуется проверка».",
    "MoRenGeiGongChangXunJiaDeYiXiangCaiGouXiangShu": "По умолчанию количество намерений покупки для запроса фабрики",
    "MoRenCaiGouXiangShu": "Количество покупок по умолчанию",
    "WanJuCaiGouGuiMo": "Масштаб закупок игрушек",
    "QingXuanZeCaiGouGuiMo": "Пожалуйста, выберите размер покупки",
    "QingXuanZeXiaoShouGuiMo": "Пожалуйста, выберите масштаб продаж",
    "KeHuZhuYingLeiMu": "Основная категория клиента",
    "QingXuanZeZhuYingLeiMu": "Пожалуйста, выберите основные категории",
    "XiTongJiangGenJuNiDeKeHuZhuYingLeiMuZhiNengTuiJianXiangGuanShangPin": "Система будет интеллектуально рекомендовать связанные продукты на основе основной категории вашего клиента, что облегчит выбор",
    "DanGuiDingJinBiLi": "Отношение депозита за один контейнер",
    "DanGuiDingJiaBiLi": "Отношение цены за один контейнер",
    "CaiGouShangDangQianDeKeYongZiJin": "Доступные средства покупателя",
    "MeiJin": "Доллар США",
    "RenMinBi": "Китайский юань",
    "ShiYongZhuangTai": "Статус использования",
    "DaiTiaoZhengBaoZhengJinJinE": "Ожидает корректировки суммы депозита",
    "DanBaoDaiKuanEDu": "Лимит гарантированного кредита",
    "ZhangHuGuDingBaoZhengJin": "Фиксированный депозит на счете",
    "DanGuiGuDingDingJin": "Фиксированный депозит за один контейнер",
    "DengJi": "Уровень",
    "MeiJinEDu": "Сумма в долларах США",
    "RenMinBiEDu": "Сумма в китайских юанях",
    "GuiXing": "Тип контейнера",
    "FOBFeiYong：": "FOB стоимость:",
    "DengLuShiJian": "Время входа",
    "JianGeShangYiCiDengLu": "Интервал с последнего входа",
    "XiaDanXiangShu": "Количество заказанных единиц",
    "JiQiFanYi": "Машинный перевод",
    "FuZhiGuanJianZi": "Копировать ключевые слова",
    "KeHuJin60TianWeiFangWenPingTai": "Клиент не посещал платформу в последние 60 дней",
    "QingXuanZeZhangHao": "Пожалуйста, выберите аккаунт",
    "Jin60TianGuiJi": "Траектория за последние 60 дней",
    "LiShiSouTu": "История поиска изображений",
    "XiaDanShangPin": "Заказанные товары",
    "ShenHeZhuangTai": "Статус проверки",
    "XuanZeLianXiRen": "Выбрать контакт",
    "GenJinLeiXing": "Тип ведения переговоров",
    "QingXuanZeGenJinLeiXing": "Пожалуйста, выберите тип переговоров",
    "ShangChuanJieTuHuoBaoJiaDan": "Загрузить скриншот или котировку",
    "JieTuShiLi": "Пример скриншота (скриншот электронного письма, должен содержать информацию об отправителе xxx; котировка должна содержать xxxx...)",
    "GenJinWenJianShangChuan": "Поддерживается загрузка изображений, word, excel, pdf. Максимум 10 файлов, каждый файл ограничен размером 10 мб",
    "QingShangChuanJieTuHuoBaoJiaDan": "Пожалуйста, загрузите скриншот или котировку",
    "YouJianJieTuShiLi：XuYaoBaoHan": "Пример скриншота электронной почты: должен содержать xxxxxxxx",
    "BaoJiaDanJieTuShiLi：XuYaoBaoHan": "Пример скриншота котировки: должен содержать xxxxxxxx",
    "QingXuanZeLianXiRenZhangHao": "Пожалуйста, выберите аккаунт контакта",
    "QingXianSheZhiJiDuMuBiaoHou": "Пожалуйста, установите квартальные цели перед продолжением",
    "QueRenShiFouBuZaiFuWuCiKeHu": "Подтвердите, хотите ли вы больше не обслуживать этого клиента? После отвязки, если клиент не обслуживается другими менеджерами по продажам, вы все равно можете быть связаны при необходимости, но это не займет вашу квоту клиентов.",
    "JieBangChengGong": "Успешное отвязывание",
    "KeHuPODaiBan": "Ожидающие заказы клиента",
    "GenJinDengJi": "Регистрация переговоров",
    "LianXiRenGuanLi": "Управление контактами",
    "XiaoShouHeTong": "Контракт на продажу",
    "TieZhiZiLiao": "Информация о наклейках",
    "MaiTouZiLiao": "Информация о маркировке",
    "WenTiSheZhi": "Настройка проблемы",
    "ShengChanYaoQiuSheZhi": "Настройка требований к производству",
    "WuLiuChuanWuZiLiao": "Информация о логистике и доставке",
    "NianDuMuBiaoJinE": "Годовая целевая сумма",
    "NianDuDingHuoJinE": "Годовая сумма заказа",
    "NianDuChuHuoJinE": "Годовая сумма доставки",
    "NianDuWanChengBiLi": "Годовая процентная доля завершения",
    "NianDuJinE": "Годовая сумма",
    "JiDuMuBiaoJinE": "Квартальная целевая сумма",
    "JiDuDingHuoJinE": "Квартальная сумма заказа",
    "YueDuMuBiaoJinE": "Месячная целевая сумма",
    "YueDuDingHuoJinE": "Месячная сумма заказа",
    "JiDu/YueDuJinE": "Квартальная/Месячная сумма",
    "LaoZiBuXiangFuWuTA": "Я не хочу служить ему/ей",
    "WoYiJingSheZhi": "Я уже установил это",
    "ShenQingZhong": "В заявке",
    "ZuiJinDengLu": "Последний вход",
    "ZuiJinCaoZuo": "Последняя операция",
    "FengXianZhi": "Значение риска",
    "BianJiCaiGouGenJinFenZu": "Редактировать группу ведения закупок",
    "XinZengCaiGouGenJinFenZu": "Добавить группу ведения закупок",
    "WeiXuanZeCaiGouFenZu": "Группа закупок не выбрана",
    "ZhuYe": "Главная страница",
    "DongTai": "Динамика",
    "DengLuPingTai": "Вход на платформу",
    "TiJiaoGouWuChe": "Отправить корзину",
    "SheZhiTieZhi": "Установить наклейки",
    "NinMeiYouCaoZuoQuanXian": "У вас нет прав на выполнение операции",
    "RenZhengRiQi": "Дата аутентификации",
    "ZhuCeRiQi": "Дата регистрации",
    "QuanBuGuoJia": "Все страны",
    "QingXuanZeYeWuYuan": "Пожалуйста, выберите менеджера по продажам",
    "SouSuoKeHuMingZi/BeiZhu/YouXiang": "Поиск имени клиента/заметки/электронной почты",
    "QuanBuYeWuYuan": "Все менеджеры по продажам",
    "SouSuoKeHuDaiHao/NiCheng": "Поиск клиентского кода/никнейма",
    "QingXuanZeYaoShanChuDeKeHu": "Пожалуйста, выберите клиента для удаления",
    "LiJiXinZeng": "Добавить немедленно",
    "JianLiKeHuXinXi": "Создание информации о клиенте облегчит экспорт котировок и даст возможность вести переговоры о ценах. Будьте уверены, ваша информация о клиентах будет защищена.",
    "GenDanYuanGong": "Сотрудник по ведению документации",
    "CaiGouGenJinXiaoZu": "Группа ведения закупок",
    "QingXianXuanZeGongYingLianFenZu": "Пожалуйста, сначала выберите группу поставщиков, чтобы последующие запросы могли быть предоставлены с соответствующими группами поставщиков.",
    "QingXuanZeYouXiaoQi": "Пожалуйста, выберите срок действия",
    "ShangChuanHeTong": "Загрузить контракт",
    "QingShangChuanHeTong": "Пожалуйста, загрузите контракт",
    "HeTongWenJianShangChuan": "Поддерживается загрузка изображений, PDF. Поддерживается до 10 файлов, каждый файл размером до 50 МБ",
    "KeHuGongSiXinXi": "Информация о компании клиента",
    "YinHangXinXi": "Банковская информация",
    "HeTongHeZuoYaoQiuBeiZhu": "Примечания к требованиям по сотрудничеству в контракте",
    "ChuanWu": "Доставка",
    "CaiWu": "Финансы",
    "YaoQiuBeiZhu": "Примечания к требованиям",
    "GenDan": "Выполнитель заказов",
    "QCCangKu": "Контроль качества, Склад",
    "YeWu": "Продавец",
    "WoSiQianYueZhuTi": "Наша контрагентская сторона",
    "QingXuanZeGongSi": "Пожалуйста, выберите компанию",
    "BianJiHeTong": "Редактировать контракт",
    "FuKuanTiaoJianShuoMing": "Объяснение условий оплаты",
    "KaiFaQuanYiShuoMing": "Объяснение прав на развитие",
    "KaiFaQuanYiShuoMing1": "Каждый менеджер по продажам может вести разработку 50 клиентов, с которыми не были заключены сделки, включая новых клиентов, которые ранее не оформляли заказы, и клиентов, которые не оформляли новые заказы более 365 дней. Когда менеджер по продажам ведет ",
    "ChengJiaoKeHuShuLiang": "Количество клиентов-сделок",
    "KaiFaQuanYi": "Права на развитие",
    "KaiFaQuanYiShuoMing2": "Интересы развития: 10 (минимум 10 интересов на задней обложке)",
    "QuanYiFanHai": "Возврат прав:",
    "KaiFaQuanYiShuoMing3": "1. Если менеджер по продажам добровольно отвязывает клиента или клиент, который не завершил транзакцию, активно отвязывает, система восполнит соответствующую квоту прав на развитие;",
    "KaiFaQuanYiShuoMing4": "2. Если клиент-сделка активно отвязывает менеджера по продажам, будет восполнена только одна квота;",
    "KaiFaQuanYiShuoMing5": "3. Если оценка менеджера по продажам не пройдена, система не восполнит квоту;",
    "KaiFaQuanYiShuoMing6": "4. В любом случае клиенты, отвязанные сверх квоты, не будут восполнены.",
    "PingTaiKeHu": "Клиенты платформы",
    "SiYouKeHu": "Частные клиенты",
    "GongNTiaoJiLu": "Всего записей: {0}",
    "XinKe": "Новые клиенты",
    "NianDuXiaoShou": "Годовая выручка",
    "JiDuMuBiao": "Квартальная цель",
    "FengXianYuJing": "Предупреждение о риске",
    "XiTongKaoHeWeiDu": "Показатели системной оценки",
    "XiTongJianKongDaoYouFengXianShi": "Когда система обнаруживает риски, их необходимо оперативно решать, иначе клиенты могут быть переданы другим менеджерам по бизнесу",
    "WoDeDaiBan": "Мои задачи",
    "KuanXiangCuiShou": "Взыскание задолженности",
    "PODanDaiQueRen": "Ожидание подтверждения PO",
    "DaiShenHeXunJiaRenWu": "Ожидание проверки задачи по запросу",
    "DaiQueRenTieZhiPaiBan": "Ожидание подтверждения макета наклейки",
    "DaiSheZhiTieZhiMaiTou": "Ожидание установки наклеек и ярлыков",
    "DaiShenHeJieDanYiChang": "Ожидание проверки исключения при приемке заказа",
    "ChuanWuZiLiao": "Документы по доставке",
    "ChuanWuYiChang": "Ошибка доставки",
    "DaiQueRenFeiYongDan": "Ожидание подтверждения расходов",
    "ZhouRi": "Воскресенье",
    "ZhouYi": "Понедельник",
    "ZhouEr": "Вторник",
    "ZhouSan": "Среда",
    "ZhouSi": "Четверг",
    "ZhouWu": "Пятница",
    "ZhouLiu": "Суббота",
    "HanXinKeShouDan": "С новым клиентом первый заказ",
    "ChengJiao": "Завершено",
    "Ji": "Срочно",
    "DaiYeWuQueRen": "Ожидает подтверждения от бизнеса",
    "DaiKeHuQueRen": "Ожидает подтверждения от клиента",
    "YiChaoShi": "Просрочено",
    "ShangPinBianHaoNBuCunZai": "Номер товара {0} не существует",
    "XiuGaiFeiYongDan": "Изменить счет на расходы",
    "XinZengFeiYongDan": "Добавить счет на расходы",
    "QingShuRuZhengQueDeFeiYongChengBen": "Пожалуйста, введите правильную стоимость, (0.01-999999999) с максимум двумя знаками после запятой!",
    "QingXuanZeKeHu": "Пожалуйста, выберите клиента",
    "QingXuanZeFeiYongXiangMu": "Пожалуйста, выберите статью расходов",
    "FeiYongChengBen": "Стоимость расходов",
    "MoRenKeHuBiZhong": "Валюта по умолчанию для клиента, подлежащая валюте ПО после указания",
    "QingTianXieFeiYongChengBen": "Пожалуйста, заполните стоимость",
    "ZhiDingPOShouQu": "Указать сбор ПО",
    "DangQianBuZhiDingPO": "Не указано ПО, в соответствии с правилами системы",
    "ZaiZhiDingPOWanChengFeiYongShouQu": "Сбор стоимости завершен с указанным ПО",
    "QingShuRuPODan": "Пожалуйста, введите номер ПО",
    "NKuanShangPin": "N позиций",
    "QueRenFeiYongDanWenJianShangChuan": "Поддерживаются изображения, максимальный размер файла 10 Мб, максимум 4 файла",
    "FuJian": "Вложение",
    "KeHuBeiZhu": "Примечание клиента",
    "GaiBeiZhuJiangBeiKeHuKanDao": "Это примечание будет видно клиенту, пожалуйста, напишите его на языке клиента",
    "QingShuRuBeiZhu": "Пожалуйста, введите примечание",
    "QueRenBuXiangKeHuShouQu": "Подтвердить, что не взимать плату с клиента?",
    "QueRenShanChuGaiFeiYongDan？": "Подтвердить удаление этого счета на расходы?",
    "YouBianGeng": "Изменения",
    "ShiFouZhiDingPOShouQu": "Указано ли ПО для сбора?",
    "XiangKeHuShiShou": "Собрано у клиента",
    "BaoCunJiangGengXinFeiYongDanXinXi": "Сохранение обновит информацию о счете на расходы и может изменить его статус. Если фактически собранная сумма по счету на расходы ниже его стоимости, это повлияет на валовую прибыль ПО.",
    "RuGuoFeiYongDanShiShouDiYuChengBen": "Если сумма возврата меньше, чем затраты, это повлияет на валовую прибыль ДО",
    "ShiShouJinE": "Фактическая сумма сбора",
    "MoRenAnPODanHuiLvJiSuan": "Расчет по курсу ПО, ориентировочная цена",
    "QingTianXieShiShouJinE": "Пожалуйста, введите фактическую сумму сбора",
    "BeiZhuGeiKeHu": "Примечание для клиента",
    "QueRenXiangKeHuShouQu": "Подтвердить взимание с клиента",
    "BuXiangKeHuShouQu": "Не взимать с клиента",
    "ChaKanBianGeng": "Просмотр изменений",
    "WuQuanXianXiuGaiQiTaJueSeFaQiFeiYongDan": "Нет прав на изменение счетов на расходы, запущенных другими ролями",
    "KeHuYiQueRen": "Клиент подтвержден",
    "QueRenShuoMing": "Подтвердить инструкции",
    "FeiYongDanXiangQing": "Подробности счета на расходы",
    "HeJiNZhangFeiYongDanGongN": "Всего счетов на расходы {0}, общее количество {1}",
    "DaiKeHuQueRenFeiYongDan": "Клиент подтверждает счет на расходы",
    "DaiKeHuQueRenFeiYongChengGong": "Счет на расходы клиента успешно подтвержден!",
    "DaiKeHuQueRenFeiYongDanWenJianShangChuan": "Загрузить подтверждение",
    "ShangChuanQueRenPingZheng": "Пожалуйста, загрузите подтверждение",
    "QingShangChuanQueRenPingZheng": "Инструкции подтверждения",
    "QingTianXieBeiZhu": "Пожалуйста, введите примечание",
    "QingXuanZePODan": "Пожалуйста, выберите ПО!",
    "ZhiDingPOJiangBuGenSuiShangPinHuoXiTongGuiZe": "Указанное ПО не будет следовать за правилами продукта или системы, только для сбора стоимости при завершении указанного ПО",
    "ShuRuPODanHaoChaXun": "Введите номер ПО для запроса",
    "ChengSeXiangBiaoShiDuiBiShangYiCiYouXiuGai": "Текущее (Оранжевый цвет указывает на изменения по сравнению с предыдущим разом)",
    "ShuLiangKuan": "Количество (шт.)",
    "费用单合计": "Общая сумма счета на расходы",
    "无PO费用": "Расходы без ПО",
    "有变更": "Изменения",
    "XiangKeHuShouQu": "Сбор с клиента",
    "GuDingHuiLvBuNengWeiKong": "Фиксированный курс обмена не может быть пустым",
    "QingXuanZeGangKouHeTianXieFOBFeiYong": "Пожалуйста, выберите порт и заполните стоимость FOB",
    "QingXuanZeGangKou": "Пожалуйста, выберите порт",
    "FOBFeiYongBuNengWeiKong": "Стоимость FOB не может быть пустой",
    "QingZhiShaoBaoLiuYiGeXiaShuiGang": "Пожалуйста, оставьте хотя бы один порт",
    "MoRen40HQGuiXing": "По умолчанию тип контейнера 40HQ, когда выбрано несколько портов, цена за единицу устанавливается по умолчанию для первого порта",
    "TianJiaXiaShuiGang": "Добавить порт",
    "KeHuDaiHaoBuNengWeiKong": "Код клиента не может быть пустым",
    "QingShiYongZiMuHuoShuZiZuoWeiDaiHao": "Пожалуйста, используйте буквы или цифры в качестве кода",
    "TianXieKeHuDeDaiHao/BianHao": "Введите код/номер клиента (английские или цифры)",
    "KeHuChaKanBaoJiaDanXuYaoShuRuDaiHao": "Клиенты должны ввести код для просмотра котировки, обеспечивая конфиденциальность котировок",
    "KeHuNiCheng": "Псевдоним клиента",
    "TianXieKeHuDeNiCheng": "Введите псевдоним клиента",
    "GuDingHuiLv": "Фиксированный курс обмена",
    "ShouDongSheZhiHuiLv": "Ручная установка обменного курса",
    "QingShuRuGuDingHuiLv": "Пожалуйста, введите фиксированный курс",
    "BaoJiaDanJiaJiaLv": "Наценка на котировку",
    "FenPeiYeWuYuan": "Назначить менеджера по продажам",
    "GengDuoZiLiao": "Дополнительная информация",
    "RuDiYuShangPinMOQYiMOQShuLiangXunJia": "Количество товаров по умолчанию при запросе в фабрику, например, запрос с минимальным количеством заказа товара, если оно ниже, чем минимальное количество заказа товара",
    "MoRenYaJiaBiLi": "Стандартное соотношение торговли",
    "XiangGongChangXunJiaShiZiDongAnCiBiLiJinXingYaJia": "Автоматическое торговое сокращение с этим коэффициентом при запросе в фабрику",
    "XinZengZhaoYang": "Добавить запрос на образцы",
    "SouSuoKeHuBianHao/YouXiang": "Поиск номера клиента/электронной почты",
    "ZhaoYangFenXi": "Анализ образцов",
    "FangAn/BaoJia": "Предложение/Котировка",
    "KeHuYouJiaGou": "У клиента есть дополнительные покупки",
    "WuXiao": "Недействительный",
    "FuZhiShiBai": "Копирование не удалось",
    "BenYueShengYuCuiBanCiShuNCi": "Осталось напоминаний о срочности на этот месяц {0} раз, хотите ли вы использовать срочное напоминание?",
    "CuiBanChengGong": "Напоминание успешно отправлено!",
    "BenYueShengYuCuiBanCiShu0Ci": "Нет оставшихся срочных напоминаний на этот месяц, нельзя ускорить.",
    "QuXiaoRenWuHouJiangBuZaiShouDaoHuiFu": "После отмены задачи вы больше не получите ответов. Вы уверены, что хотите отменить?",
    "KeHuDeZhaoYangXiangQing": "Подробности запроса образцов для клиента",
    "QuXiaoRenWu": "Отменить задачу",
    "JiaJiCuiBan": "Срочное напоминание",
    "ZhaoYangPingZheng": "Образцы сертификат",
    "WeiShangChuan": "Не загружено",
    "ShangPinShuoMing": "Описание продукта",
    "LiRuGongNeng": "Например, назначение, цвет, материал, указанный бренд, требования к упаковке и т.д.",
    "FuZhiShuoMing": "Инструкции копирования",
    "KeHuPianHao": "Предпочтение клиента",
    "KeJieShouLeiSi": "Принять аналогичное",
    "ZhiKanYiJiaGou": "Показать только дополнительные",
    "RenWuidGeShiZhengQue": "Формат ID задачи правильный!",
    "GongZuoTai": "Рабочий стол",
    "KeHuZhaoYangJiLu": "Записи образцов для клиента",
    "RenWuID": "ID задачи",
    "YouJiaGou": "Есть дополнительная покупка",
    "DaiKeHuFaQiZhaoYang": "Запрос образца, инициированный клиентом",
    "XuanZeZhangHao": "Выберите учетную запись",
    "FaBuZhaoYangWenJianShangChuan1": "Загрузите снимки экрана электронной почты/чата в качестве доказательства реального запроса образца клиента",
    "FaBuZhaoYangWenJianShangChuan2": "Загрузить файлы, поддержка изображений/архивов/Excel, один файл поддерживает до 200 МБ, максимум 5 файлов",
    "QingXuanZeShangChuanYouJianHuoZheLiaoTianJieTu": "Пожалуйста, выберите загрузку снимков экрана электронной почты или чата",
    "MiaoShuYaoZhaoDeShangPin": "Опишите желаемые продукты",
    "ShuoShuiKeHuDeYiXiePianHao": "Расскажите нам о предпочтениях клиента, чтобы получить более точные и подходящие продукты",
    "TiGongZiLiao/TuPian": "Предоставьте документы/изображения",
    "FaBuZhaoYangWenJianShangChuan3": "Загрузить файлы, поддержка изображений/архивов/Excel, один файл поддерживает до 200 МБ, максимум 100 файлов",
    "KeJieShouTuiJianXiangSiKuan": "Принять рекомендованные аналогичные продукты",
    "ChaiJieRenWu": "Разбить задачу",
    "BianJiFenZu": "Редактировать группу",
    "FenZuMing": "Название группы",
    "QingShuRuFenZuMing": "Пожалуйста, введите название группы",
    "FenZuWenJianShangChuan": "Загрузить файлы, поддержка изображений, максимум 5 изображений",
    "QueRenShanChuGaiFenZu": "Подтвердить удаление этой группы?",
    "ZanBuFenZu": "Пока не группировано",
    "XuanZeYiGeFenZu": "Выберите группу",
    "MeiYouTuPian": "Нет изображений",
    "SouSuoFenZu": "Поиск групп",
    "ZhuanWeiWuXiaoXuQiu": "Преобразовать в недействительный запрос",
    "TianXieYuanYin": "Укажите причину",
    "QingTianXieLiYou": "Пожалуйста, укажите причину",
    "YiDengNTian": "Ожидается уже {0} дней",
    "RenWuDaiFenJie": "Задача ожидает разрешения",
    "JiJiaJiChu": "Основа расчета",
    "ShengYuNTianJieShuJieZhiZhiN": "Осталось {0} дней, до {1}",
    "BuChongShangPin": "Дополнительные товары",
    "BuManYi": "Недовольны",
    "TuiJianDangQianZuiDuoHuiFuNKuan": "Рекомендуется максимум {0} предметов",
    "YiXuanPinNKuanRenWuZhiYunXuTuiJianNKuan": "Выбрано {0} товаров, задача позволяет рекомендовать только {1} товаров, лишние товары будут проигнорированы. Продолжить рекомендацию?",
    "YiXuanShangPin": "Выбранные товары",
    "WeiTuiJianNKuan": "Не рекомендуется {0} товаров",
    "ChongFuDeShangPinHuiFuKeHuShiXiTongHuiZiDongQuZhong": "При повторном ответе клиенту с повторяющимися товарами система автоматически удалит дубликаты",
    "JiaRuChengGong": "Успешное присоединение",
    "PinPai/GongYingShang": "Бренд/Поставщик",
    "KeBanShangPin": "Номенклатура клиента",
    "YiQuanBuHuiFuKeHu": "Все клиенты получили ответ",
    "YiHuiFuKeHu": "Клиенты получили ответ",
    "BiaoJiYiQuanBuHuiFuKeHu": "Отметить, что все клиенты получили ответ",
    "BiaoJiYiHuiFu": "Отметить как полученный ответ",
    "YouXinDeBuChong": "Новые дополнения",
    "EXWBiaoZhunBaoJiaGuiZeWenBen": "Стандартные правила котировки EXW<br/>\nКотировки, в которых склад отгрузки является местом происхождения товара<br/>\nСтандартные правила котировки FOB<br/>\nЕсли местом происхождения товара является Шаньтоу: Шаньтоу (склад отправления)-Шаньтоу (порт отправ",
    "ShangPinChuHuoCangMoRenWeiShangPinChanDi": "Место отгрузки товара по умолчанию - место происхождения товара",
    "ZhiDingShangPinBaoJiaFangShiDaoBaoJiaDan": "Указанный способ ценообразования товара экспортируется в коммерческое предложение",
    "GenJuXuanZeDeChuHuoQuYu": "FOB ценообразование: рассчитывается на основе выбранного района отправки, порта назначения и типа контейнера; DDP ценообразование: рассчитывается на основе стандартного места отправки, порта назначения и типа контейнера по выбранному маршруту",
    "ShangPinChuHuoJiangAnSuoXuanChuHuoCang": "Отгрузка товара будет оцениваться в соответствии с выбранным местом отгрузки, портом назначения и типом контейнера, что может повлиять на распределение FOB затрат и привести к возникновению местного транспортного сбора",
    "XiaDanShiRuoGuiZiChuHuoCang": "Внимание: изменение места отправки, порта назначения и типа контейнера при заказе может повлиять на распределение FOB стоимости и привести к возникновению местных транспортных расходов (при условии, что место отгрузки и место происхождения не находятся в ",
    "XuanZeMuBanHeYuYan": "Выберите шаблон и язык",
    "DanGePCS": "Один экземпляр",
    "ShangPinChanDi": "Place of Origin",
    "GuoJiaBuNengWeiKong": "Country cannot be empty",
    "DingJinCuiShou": "Взыскание задатка",
    "WeiKuanCuiShou": "Сбор платежей по оставшейся сумме",
    "ChuHuoKuanXiangYiChangCuiShou": "Взыскание необычных платежей за отгрузку",
    "WeiKuanCaiWuRenGongCuiShou": "Ручной финансовый сбор остаточной суммы",
    "BenDanDingJinYiJingShenQingChaoXin": "Депозит для этого заказа был продлен",
    "ZuiWanQueRenShiJian": "Последний срок подтверждения",
    "YiYuQiNTian": "Просрочено на {0} дней",
    "JiangHuiYanQiChuHuo": "Доставка будет задержана",
    "ShiJiZhuangGuiShiJian": "Фактическое время загрузки контейнера",
    "HuoGuiYiDaoGang": "Контейнер прибыл в порт",
    "HuoGuiHaiYouNTianDaoDaGangKou": "Контейнер прибудет в порт через {0} дней",
    "WeiAnShiShouKuanJiangYingXiangKeHuTiGui": "Несвоевременная оплата повлияет на получение клиентом контейнера",
    "KaiChuanShiJian": "Время отправления",
    "HaiXuZhiFuDingJin": "Депозит все еще нужен",
    "HaiXuZhiFuWeiKuan": "Осталась оплата остаточной суммы (включая другие расходы)",
    "YuJiXuZhiFuWeiKuan": "Предполагаемая оставшаяся оплата (включая другие расходы)",
    "GeQuYuZhongQingDouXuanZeYiZuGenDanRenYuan": "В каждом регионе выберите группу специалистов по сопровождению",
    "XiuGaiCaiGouGenJinFenZu": "Изменить группу сопровождения по закупкам",
    "XunJiaKeFu": "Служба поддержки запросов",
    "JieDanKeFu": "Служба поддержки приема заказов",
    "GenDanKeFu": "Служба поддержки сопровождения",
    "YiGenJinKeHuShu": "Количество клиентов, с которыми связались",
    "XunJiaHuiFu": "Ответ на запрос",
    "KeHuXuQiuGuanLi": "Управление потребностями клиентов",
    "KeHuYiJingJinRuBanGongKaiZhuangTai": "Клиент уже находится в полуоткрытом состоянии и может быть обслужен другими менеджерами по продажам",
    "BianJiDingCangQiTaShouHuoRenXinXi": "Редактировать информацию о другом получателе для бронирования",
    "XinZengDingCangQiTaShouHuoRenXinXi": "Добавить информацию о другом получателе для бронирования",
    "DangDingCangShouHuoRenYuHeTongMaiFangBuYiZhiShi": "Если получатель бронирования отличается от покупателя в договоре, требуется вспомогательное подтверждение, такое как электронные письма или соглашения",
    "ShuRuGongSiMingCheng": "Введите название компании",
    "ZhengMingWenJian": "Документы подтверждения",
    "ShouHuoRenTuPianShangChuan": "Поддерживается загрузка изображений, файлов Word, Excel, PDF. Поддерживается до 10 файлов, каждый файл не более 50 МБ",
    "QingTianXieHuoDaiLianXiRenXinXi": "Пожалуйста, заполните информацию о контактном лице экспедитора",
    "QingShuRuZhengQueDeQQ": "Пожалуйста, введите правильный QQ",
    "QingShuRuZhengQueDeYouXiang": "Пожалуйста, введите правильный адрес электронной почты",
    "BianJiHuoDaiLianXiRen": "Редактировать контактное лицо экспедитора",
    "XinZengHuoDaiLianXiRen": "Добавить контактное лицо экспедитора",
    "BianJiHuoDaiXinXi": "Редактировать информацию об экспедиторе",
    "XinZengHuoDaiXinXi": "Добавить информацию об экспедиторе",
    "GuoNeiHuoDai": "Внутренний экспедитор",
    "HuoDaiGongSi": "Компания экспедитор",
    "QingShuRuHuoDaiGongSiMingCheng": "Пожалуйста, введите название компании экспедитора",
    "ShuRuHuoDaiGongSiMingCheng": "Введите название компании экспедитора",
    "HuoDaiGongSiDiZhi": "Адрес компании экспедитора",
    "ShuRuHuoDaiGongSiDiZhi": "Введите адрес компании экспедитора",
    "GuoNeiHuoDaiLianXiRen": "Контактное лицо внутреннего экспедитора (необходимо как минимум одно)",
    "ZhiShaoYouYiGeGuoNeiHuoDaiLianXiRen": "Необходимо как минимум одно контактное лицо внутреннего экспедитора",
    "QingShuRuZhengQueDeEmail": "Пожалуйста, введите правильный адрес электронной почты",
    "BianJiTongZhiRenXinXi": "Редактировать информацию о получателе уведомлений",
    "XinZengTongZhiRenXinXi": "Добавить информацию о получателе уведомлений",
    "QingZuiShaoGouXuanYiGeDingDan": "Пожалуйста, выберите хотя бы один заказ",
    "DanGeDaoChu": "Экспорт одиночно",
    "ChuanWuZiLiaoMuBanDaoChu": "Экспорт шаблона документации по доставке",
    "YiChaoShiNTian": "Просрочено {0} дней",
    "ChaoShiNTianJiangWuFaDingCang": "Превышение {0} дней не позволит заказать",
    "HuiYanQiChuHuo": "Отгрузка будет задержана",
    "ZuiWanChuLiShiJian": "Последний срок обработки",
    "YuZhuangGuiRiQi": "Дата предварительной загрузки",
    "MaiFang1": "Продавец 1",
    "QueRenYiJingJianChaSuoYouDeChuanWuZiLiao": "Подтвердите, что все документы по доставке были проверены? После подтверждения любые изменения могут повлиять на бронирование и отправку.",
    "BianGengChuanWuZiLiaoKeNengYingXiangDingCangDingChe": "Изменение документов по доставке может повлиять на бронирование и отправку, пожалуйста, изменяйте информацию осторожно.",
    "HeTongXinXiWeiWanShan": "Информация о контракте не завершена. Пожалуйста, перейдите на домашнюю страницу клиента - Продажа контрактов, чтобы завершить информацию о контракте перед продолжением.",
    "ChuanWuDaiBan": "Ожидающие задачи по доставке",
    "GengXinChuanWuZiLiao": "Обновление информации о доставке",
    "QueRenChuanWuZiLiao": "Подтвердить документы по доставке",
    "DaoRuTianChong": "Импорт и заполнение",
    "ShouQuanDiaoHuo": "Авторизовать доставку груза",
    "YunShuFangShi": "Способ транспортировки",
    "HuoDaiXinXi": "Информация о грузовом экспедиторе",
    "GuoNei": "Внутренний",
    "JingWai": "Зарубежный",
    "QingXuanZeYiGeHuoDai": "Пожалуйста, выберите грузового экспедитора",
    "RuXuZhiDingLianXiRenQingZaiYiXiaLianXiRenZhongJinXingZhiDing": "Если вам нужно указать контактное лицо, пожалуйста, укажите его среди следующих контактов, и отдел доставки свяжется с указанным контактным лицом",
    "QingXuanZeXiaoShouHeTong": "Пожалуйста, выберите договор продаж",
    "FaHuoRenXinXi": "Информация о грузоотправителе",
    "QingXuanZeYiGeFaHuoRen": "Пожалуйста, выберите грузоотправителя",
    "DingCangShouHuoRen": "Получатель заказа",
    "QingXuanZeYiGeShouHuoRen": "Пожалуйста, выберите получателя",
    "TongZhiFang": "Уведомитель",
    "QingXuanZeYiGeTongZhiFang": "Пожалуйста, выберите уведомителя",
    "QingXuanZeYunShuFangShi": "Пожалуйста, выберите способ транспортировки",
    "HaiYun": "Морской транспорт",
    "TieLu": "Железнодорожный транспорт",
    "KongYun": "Воздушный транспорт",
    "QiYun": "Автомобильный транспорт",
    "ChuDanFangShi": "Тип транспортной накладной",
    "TiDanLeiXing": "Тип транспортной накладной",
    "QingXuanZeTiDanLeiXing": "Пожалуйста, выберите тип транспортной накладной",
    "GangKouXinXi": "Информация о порту",
    "MuDiGang": "Порт назначения",
    "GuoJia-ZhiChiShuRuShaiXuan": "Страна - Поддержка фильтрации по вводу",
    "QingTianXieMuDiGang": "Пожалуйста, укажите порт назначения",
    "MuDiDi": "Пункт назначения",
    "QingShuRuMuDiDiChengShiMingCheng": "Пожалуйста, введите название города назначения",
    "ZhiDingTiDanPinMing": "Указать наименование груза в транспортной накладной",
    "BuZhiDing": "Не указано",
    "ZhiDing": "Указано",
    "QingShuRuZhiDingDePinMing": "Пожалуйста, введите указанное наименование груза",
    "ZhiDingDePinMing": "Указанное наименование груза",
    "HuoWuMiaoShu": "Описание груза",
    "BaoKuoDanBuXianYuHuoWuPinMing": "Включает, но не ограничивается наименованиями груза, транзитными условиями и требованиями клиента. Если не заполнено, отдел доставки классифицирует наименование груза",
    "QingXianChuLiZaiTiJiao": "Пожалуйста, сначала обработайте, а затем отправьте",
    "QingXianChuLiWanChengZaiTiJiao": "Пожалуйста, сначала обработайте, а затем отправьте",
    "YuanChuHuoQuYu": "Исходная зона доставки",
    "YuanBaoJiaFangShi": "Исходный метод расчета",
    "YuanXiaShuiGang": "Исходный порт погрузки",
    "YuanHuoGuiLeiXing": "Исходный тип контейнера",
    "XinChuHuoQuYu": "Новая зона доставки",
    "XinBaoJiaFangShi": "Новый метод расчета",
    "XinHuoGuiLeiXing": "Новый тип контейнера",
    "XinXiaShuiGang": "Новый порт погрузки",
    "TiaoZheng": "Коррекция",
    "ChuanWuFeiYongYiChang": "Аномалия стоимости доставки",
    "ChuanWuDingCangQiTaFuJiaZongFeiYong": "Общие дополнительные сборы за бронирование доставки",
    "FuJiaHuoDaiFeiYong": "Дополнительные сборы за экспедирование грузов",
    "FeiYongShuoMing": "Описание сбора",
    "WoSiQuanBuChengDan": "Наша компания берет на себя все",
    "KeHuChengDan": "Клиент берет на себя",
    "WoSiChengDan": "Наша компания берет на себя",
    "WoSiChengDanBuFenJiangHuiYingXiangXiaoShouLiRunJiSuan": "Примечание: доля ответственности нашей компании повлияет на расчет прибыли от продаж",
    "QueRenShanChuHuoDaiXinXi": "Подтвердить удаление информации о грузовом агенте?",
    "ShiFouYaoShanChuShouHuoRenXinXi": "Хотите удалить информацию о получателе?",
    "ShiFouYaoShanChuTongZhiRenXinXi": "Хотите удалить информацию о сообщающем?",
    "WuLiuChuanWuZiLiaoGuanLi": "Управление логистической и судовой документацией",
    "XinZengHuoDai": "Добавить грузового агента",
    "TongZhiRenXinXi": "Информация о сообщающем",
    "XinZengTongZhiRen": "Добавить сообщающего",
    "DaiQueRenChuanWuZiLiao": "Ожидающая подтверждение документация по судоходству",
    "ChuanQiBianDong": "Изменение расписания доставки",
    "PODanHuoHaoYanQiShangPinYiChuLi": "Задержанные товары в заказе PO были обработаны, дополнительное пополнение не требуется на данный момент",
    "ChuLiChengGong": "Успешно обработано",
    "DingCangYiChangChuLi": "Обработка аномалий в заказе",
    "QuDiaoBuHuo": "Перейти к пополнению",
    "ChuLiYiChang": "Обработать аномалии",
    "HuoHaoYanQi": "Задержка товара",
    "ShouHuoKuanXiangYiChang": "Аномальная оплата поступления",
    "ZhuangGuiKuanXiangYiChang": "Аномальная оплата контейнера",
    "AnYuanShouHuoShiJian": "Согласно исходному времени поступления",
    "XiuGaiShouHuoShiJian": "Изменить время поступления",
    "XiuGaiShouHuoShiJianZhi": "Изменить время получения на (последнее время получения для этого заказа {0})",
    "AnYuanYuZhuangGuiShiJian": "Согласно исходному времени загрузки контейнера",
    "DiaoBu/QuXiaoShangPin": "Изменить/Отменить товары",
    "JieShouXinYuZhuangGuiShiJian": "Принять новое время загрузки контейнера",
    "KuanXiangYiDaoAnYuanYuZhuangGui": "Поступление средств, согласно исходному времени загрузки контейнера",
    "ChaoXinChuHuoAnYuanYuZhuangGui": "Экспресс-доставка, согласно исходному времени загрузки контейнера",
    "YanQiZhuangGui": "Задержка загрузки контейнера",
    "XuanZeRiQi": "Выбрать дату",
    "ChuLi": "Обработать",
    "YuZhuangGui": "Предварительная загрузка",
    "Dai2KeHuQueRen": "Подтверждение от имени клиента",
    "YuJiYouFengXian": "Могут быть риски",
    "YouFengXian": "Есть риски",
    "ShuiHao": "налоговый идентификационный номер",
    "MuBiao": "Цели",
    "ShiJi": "текущая ситуация",
    "JiDuWanChengBiLi": "Ежеквартальный процент выполнения",
    "JiDuJinE": "Квартальная сумма",
    "NQianYuan": "{0}K",
    "PinTaiZhangHao": "Учетная запись на платформе",
    "WuZhangHao": "Нет учетной записи",
    "XinBieWeiWanShan": "Пол не указан",
    "QiTaLianXiFangShi": "Другой контакт",
    "Jin30TianDengLuTianShu": "Дни входа в систему за последние 30 дней",
    "DangQianKaiFaKeHuQuanYiShuLiangShengYu": "В настоящее время количество оставшихся прав клиента {0}",
    "YiFaSongShenQingKeYiQianWang": "Вы можете перейти в раздел [Мои клиенты], чтобы проверить",
    "ShenQingXinNeiRongBuNengWeiKong": "Содержание письма-заявки не может быть пустым",
    "QingXuanZeNiDeKeHuMuBiao": "Пожалуйста, выберите целевого клиента",
    "QingXuanZeShiFouFaSongYouJian": "Пожалуйста, выберите, отправлять ли письмо по электронной почте или нет",
    "FaSongShenQing": "Отправить запрос",
    "XiTongFaYouJian": "Система отправляет письмо",
    "XiTongBuYaoFaYouJian": "Система не отправляет письма, я отправлю их сам.",
    "YuLanYouJian": "Предварительный просмотр письма",
    "FuZhiYouJianHTML": "Скопировать HTML",
    "RuGuoYaoZiJiFaSongYouJian": "Если вы хотите отправить письмо самостоятельно, скопируйте HTML-файл письма и вставьте его в редактор писем (вид HTML).",
    "WoYaoTiShengKeHuMuBiao": "Я хочу улучшить цели моего клиента (несколько вариантов)",
    "TiShengXiaoShouE": "Увеличить продажи",
    "TiGaoKeHuDengLuCiShu": "Увеличьте количество логинов клиентов",
    "ZengJiaKeHuZiZhuXuanPin": "Увеличить количество самостоятельного выбора клиентов",
    "ZengJiaShangPinTuiJianCiShu": "Увеличьте количество рекомендаций по товарам",
    "FaSongYouJian": "Отправить письмо",
    "RuGuoXuanZeZiJiFaSongYouJian": "Если вы решили отправить письмо самостоятельно, пожалуйста, скопируйте HTML и отредактируйте содержимое после отправки заявки.",
    "QingTianXieShenQingTuiJianXin": "Пожалуйста, заполните рекомендательное письмо, покажите, что ваша специальность с большей вероятностью будет принята клиентом, пожалуйста, обратите внимание на язык клиента",
    "KeHuGenJin": "Последующая работа с клиентами",
    "QingXuanZeJieBangDeKeHu": "Пожалуйста, выберите клиента, которого вы хотите отвязать.",
    "NiXuYaoWanChengYiXiaCaoZuo": "Вам необходимо выполнить следующие операции",
    "DaiJieBangKeHu": "Клиенты, которые должны быть отвязаны",
    "YiXiaKeHuChuYuWuDingDanGenJinZhuangTai": "Следующие клиенты находятся в статусе отсутствия выполнения заказов, и их можно безопасно отвязать, пожалуйста, выберите клиента, которого нужно отвязать.",
    "JieChuBangDingNGeKeHu": "Отвязать {0} клиентов",
    "DaiSheZhiCaiGouFenZu": "Настройка групп закупок в ожидании",
    "YiXiaKeHuWuCaiGouZu": "Следующие клиенты не имеют групп закупок, необходимо установить все группы закупок, прежде чем приступать к работе с верстаком.",
    "QingJieBangNGeKeHuHouJiXuCaoZuo": "Текущее количество привязанных клиентов превысило указанное количество интересов, пожалуйста, отвяжите {0} клиентов, чтобы продолжить операцию.",
    "BuBaoHanGongChangLianXiFangShi": "Контактная информация завода не включена",
    "QuanBuYeJiZuZhang": "Все руководители групп производительности",
    "QingXuanZeYeJiZuZhang": "Пожалуйста, выберите руководителя группы производительности",
    "DaoChuDeBaoJiaDanBuBaoHanGongChangLianXiFangShi": "В экспортируемом коммерческом предложении отсутствует контактная информация завода",
    "PiLiangSheZhiFenZu": "Группировка пакетных настроек",
    "TuPianXingShi": "Форма изображения",
    "MoRenPaiBanFangShi": "Макет по умолчанию",
    "ChongXinJiaRuXuanPin": "Повторное участие в отборе",
    "PingTai1": "Платформа 1",
    "TianJiaDaoFenZu": "Представлено подгруппе",
    "ZanBuJiaRu": "пока что не присоединяйтесь",
    "XiaoShouShiChang": "рынок сбыта",
    "WuMuBiao": "Нет цели",
    "QuanBuZuZhang": "Все руководители групп",
    "LianXiKeFu2": "Связаться со службой поддержки",
    "YiCaiShouYe": "Главная страница ESSA",
    "GuanZhuYiCai": "Следить за ESSA",
    "APPXiaZai": "Скачать приложение",
    "WeiXinSaoYiSaoTianJiaKeFu": "Сканировать для добавления службы поддержки",
    "APPLiuLanGengBianJie": "Просмотр на приложении более удобен",
    "GongChangRuZhu": "Въезд на завод",
    "WoDeYiCai": "Мой ESSA",
    "ZhanDianQuYu": "Район сайта",
    "ShangPinPinLei": "Категории товаров",
    "JiaGe（Yuan）": "Цена (RMB)",
    "MOQ（WaiXiang）": "MOQ (коробка)",
    "HuoQi (Tian)": "Срок производства (дней)",
    "WaiXiangTiJi (m3)": "Объем внешней коробка (м³)",
    "BaoZhuangTiJi (m3)": "Объем упаковки (м³)",
    "QingXuanZeBaoZhuangLeiXing": "Пожалуйста, выберите тип упаковки",
    "QingXuanZeRenZhengBiaoZhun": "Пожалуйста, выберите стандарт сертификации",
    "GongChangDaQuan": "Бренды",
    "ZhanTingTuiJian": "Выставочный зал",
    "HuanYingNin": "Добро пожаловать",
    "MianFeiZhuCeMianFeiShiYong": "Бесплатная регистрация, бесплатное пробное использование",
    "GongChangShangXin": "Новые горизонты фабрик",
    "ChaKanXinPin": "Подробнее",
    "XuanPinDongTai": "Обновления выбора товаров",
    "HaoGongChang": "Хорошие заводы",
    "BaiYuanGaoXingJiaBiHaoHuoGaoLiRunDanPinJinZaiYiCai": "Товары с высоким соотношением цены и качества и высокими прибылями доступны на ESSA",
    "ChaKanQuanBuGongChang": "Просмотреть все заводы",
    "YouZhiGongChang": "Хороший завод",
    "ZhuYing": "Основные товары",
    "GongChangTuiJianHaoHuoXunZhaoShangJiJinZaiQiZhong": "Рекомендации завода, поиск бизнес-возможностей, все здесь",
    "SouSuoZhaoShangPin": "Поиск товаров",
    "ShiTuZhaoShangPin": "Распознавание изображений для продуктов",
    "LeiMuZhaoShangPin": "Поиск товаров по категориям",
    "DaoChuShangPinZiLiao": "Экспорт информации о продукте",
    "FaZhanLiShi": "История развития",
    "PingTaiShiLi": "Сила платформы",
    "ChanPinTeSe": "Особенности продукта",
    "QiYeWeiXin": "Корпоративный WeChat",
    "FuWuShiJian": "Часы обслуживания",
    "LianXiKeFu3": "Связаться со службой поддержки",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSEO_T": "Рекомендации лидеров продаж ESSABUY для {0}",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSEO_KW": "Рекомендации ESSABUY для {0}, лидеры продаж {1}",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSE_DS": "На ESSABUY на основе поведения пользователей при выборе составляется горячий список популярных продуктов в разделе игрушек, предоставляя пользователям реальные рекомендации по продуктам",
    "YiCaiXuanPinYiXiangChuHuoSEO_T": "Оптовая продажа \"One Box Fast Delivery\" - Страница {0} - ESSABUY",
    "YiCaiXuanPinYiXiangChuHuoSEO_KW": "Один коробок доступен для покупки на ESSABUY",
    "YiCaiXuanPinYiXiangChuHuoSEO3_DS": "На ESSABUY найдите качественных производителей, известные заводы, ведущих поставщиков, сильных продавцов, более 3 миллионов популярных продуктов по выгодным ценам для оптовой продажи клиентам в пяти крупнейших регионах мира: Игрушки, Спортивные товары, Канцелярские товары, Праздничные товары, Детские автомобили на открытом воздухе, Товары для младенцев и Посуда, поддерживая онлайн-выбор продуктов, запросы и экспорт котировочных листов на компьютере и в приложении для рекомендации клиентам",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_T": "Оптовая продажа в зоне внутренних продаж - Страница {0} - ESSABUY",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_KW": "Зона внутренних продаж на ESSABUY",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_DS": "На ESSABUY найдите качественных производителей, известные заводы, ведущих поставщиков, сильных продавцов, более 3 миллионов популярных продуктов по выгодным ценам для оптовой продажи клиентам в пяти крупнейших регионах мира: Игрушки, Спортивные товары, Канцелярские товары, Праздничные товары, Детские автомобили на открытом воздухе, Товары для младенцев и Посуда, поддерживая онлайн-выбор продуктов, запросы и экспорт котировочных листов на компьютере и в приложении для рекомендации клиентам",
    "YiCaiXuanPinXinPinSEO_T": "{0} Оптовые производители - {1} Оптовая площадка - {2} Оптовый сайт с первоисточником_ESSABUY",
    "YiCaiXuanPinXinPinSEO_T2": "{0} Оптовые производители - {1} Оптовая площадка - {2} Оптовый сайт с первоисточником_ESSABUY_Страница {3}",
    "YiCaiXuanPinXinPinSEO_T3": "Оптовые производители образовательных игрушек_Оптовая площадка образовательных игрушек_Оптовый сайт с первоисточником образовательных игрушек_ESSABUY",
    "YiCaiXuanPinXinPinSEO_T4": "Заголовок нового продукта на странице ESSABUY 4: Оптовые производители образовательных игрушек_Оптовая площадка образовательных игрушек_Оптовый сайт с первоисточником образовательных игрушек_ESSABUY_Страница {0}",
    "YiCaiXuanPinXinPinSEO_KW": "Оптовый сайт с первоисточником игрушек, Сайт оптовой продажи образовательных игрушек, Оптовые производители образовательных игрушек, Оптовая площадка образовательных игрушек, Оп",
    "YiCaiXuanPinXinPinSEO_DS": "Ежедневно обновляющийся в реальном времени веб-сайт ESSA Wholesale Educational Toys предоставляет детальные параметры, текущие котировки и динамику цен новых игрушек, что является важным справочным материалом для трейдеров при рекомендации новых товаров закупщикам.",
    "YiCaiXuanPinLeiMuSEO_T": "{0}-{1}Оптовая-{2}Весь завод прямой продажи [Новейшее предложение|Одна коробка быстрая доставка]_ESSABUY",
    "YiCaiXuanPinLeiMuSEO_T2": "{0}-{1}Оптовая продажа{2}Весь завод прямой продажи [Последнее предложение|Быстрая отправка в коробке]_Страница {3}ESSABUY",
    "YiCaiXuanPinLeiMuSEO_DS": "Найдено {0} продуктов на ESSABUY. Здесь представлены последние цены, специальные акции, поставщики и связанные изображения для {1}.",
    "DiNYe": "Страница {0}",
    "ShenQingChaKan": "Подать заявку на просмотр",
    "ZhangHaoWeiRenZheng2": "Учетная запись не аутентифицирована",
    "QuanBuLianXiRen": "Все контакты",
    "GouWuCheBaoJiaDan": "Корзина (Квотировка)",
    "FaBuXinZhaoYang": "Опубликовать новый образец",
    "ChaKanCiKuanShangPinXiangQing": "Посмотреть детали этого продукта",
    "JiaRuXuanYangChiYiShiGongChangZuiJinGengXinJiaGe": "Добавлено в выборку, последняя цена завода обновлена",
    "JiaRuXuanYangChiChengGong2": "Успешно добавлено в выборку, система автоматически запросила последнюю цену у завода",
    "XuanYangChiYiYouCiShangPin": "Этот товар уже есть в выборке, последняя цена завода обновлена",
    "XuanYangChiYiYouCiShangPin2": "Этот товар уже есть в выборке, система автоматически запросила последнюю цену у завода",
    "JiaGeGengXinJiaRuXuanPinChiZiDongXunZuiXinJia": "Цены обновляются и добавляются в пул выбора для автоматического запроса последней цены.",
    "GengXinJiaGe": "Обновление цен",
    "XuanYangChiZhongYiCunZaiCiShangPin": "Этот продукт уже существует в пуле образцов",
    "GongChangJianJie": "Профиль завода",
    "ChaKanLiShiZuJi": "Посмотреть исторические следы",
    "WanShanZiLiao": "Улучшить информацию",
    "BaoHuShangPinShenQingChaK": "Защищенный вид приложения продукта",
    "ShuJuYinQing": "Data Engine",
    "YiDaCheng": "Достигший VIP",
    "JiJiangDaCheng": "Скоро будет VIP",
    "NCiDengLu": "{0}+логины",
    "NKuanXuanPin": "{0}Выбор",
    "NKuanXunJia": "{0}Запрос статьи",
    "NCiDengLuTianYouDengLuSuan": "{0}Входы (1 вход в систему за 1 день считается за 1 вход)",
    "QingShuRuXuYaoSouSuoDeNei": "Пожалуйста, введите содержимое, которое вы хотите найти",
    "DaYin": "Распечатать",
    "ShangPinTiWen": "Вопросы о продукции",
    "FaPiaoXuCaiWuQueRenHouZaiDaoChu2": "Счета-фактуры должны быть подтверждены финансовым отделом перед экспортом.",
    "FaPiaoZhongBao": "Счета-фактуры (средние упаковки)",
    "FaPiaoPcs": "Счет-фактура (штук)",
    "TieZhiDeZhiZuoXuYaoYiDingChengBen": "Производство наклеек требует определенных затрат, стоимость наклеек определяется количеством товаров в контейнере.",
    "DingDanCaoZuoXuYaoRenGongChengBen": "Работа с заказом требует трудозатрат, стоимость услуги зависит от количества товаров в контейнере.",
    "TongYiESSAXieZhuDiaoHuo": "Согласны, что ESSA поможет в передаче товара",
    "BuTongYiXuYaoTongZhiWo": "Не согласен, необходимо уведомить меня",
    "XiaDanHouHuoPinZaiShengChanGuoChengZhong": "После оформления заказа возможны задержки в сроках производства по различным причинам. Чтобы избежать задержек в отправке контейнера из-за отдельных товаров, разрешаете ли вы ESSA провести замену товаров в соответствии с производственным графиком и уведомить вас? (Объяснение: если задержка по одному из товаров влияет на срок отправки контейнера, ESSA может заменить часть товаров между контейнерами, чтобы соблюсти запланированные сроки).",
    "TieZhiHeMaiTou": "Наклейки и маркировка",
    "XiuGaiDingDanYaoQiu": "Изменение требований к заказу",
    "DiaoHuo": "Корректировка товаров",
    "BianGengChuanWuZiLiao": "изменение информации о доставке",
    "QueRenQuXiaoGaiShangPin": "Подтверждение отмены товара?",
    "JuYouBanQuanZhengYi": "Спор об авторских правах",
    "XiaDanRiQi": "Дата заказа",
    "CaiGouDeShangPin": "Приобретенный товар",
    "YouTiWen": "Задать вопрос",
    "YouGongChangFanKui": "Есть отзывы о фабрике",
    "QuXiaoDeShangPin": "Отмененные товары",
    "BuManGuiChuHuo": "Не отправлено из шкафа",
    "QueDingQuXiaoGaiDingDan": "Вы уверены, что хотите отменить этот заказ?",
    "BuManGuiKeYiDiaoRuShangPin": "Шкафы не заполнены, вы можете переносить предметы или пополнять их запасы",
    "ShouQiQuanBu": "Собрать все",
    "XianShiQuanBu": "Показать все",
    "BuManGuiChuHuoChengGong": "Отправка из шкафа прошла успешно!",
    "QueRenBuManGuiChuHuo": "Подтвердить доставку без контейнера?",
    "SouSuoShangPinBianHaoHuoGongChangHuoHao": "Поиск по номеру товара или заводскому номеру",
    "YiYuQiNTianWeiZhiFuDingJin": "Внимание:Депозит просрочен на {0} дней, пожалуйста, свяжитесь с клиентом как можно скорее.",
    "YiYuQiKuanXianQiNei": "Внимание:Он был просрочен (в течение льготного периода), пожалуйста, свяжитесь с покупателем, чтобы оплатить депозит как можно скорее",
    "CaiGouShangDeGuDingBaoZhengJinHaiKeDanBaoHuoKuanEDu": "Примечание: фиксированный депозит покупателя также может гарантировать сумму оплаты {0}, пожалуйста, свяжитесь с покупателем, чтобы подтвердить PO как можно скорее, чтобы избежать задержки даты доставки.",
    "CaiGouShangDeHaiKeDanBaoHuoKuan": "Примечание: Фиксированный депозит покупателя также может гарантировать оплату {0}, что недостаточно, чтобы гарантировать этот заказ, пожалуйста, свяжитесь с покупателем, чтобы увеличить сумму гарантии.",
    "CaiGouShangDangQianWeiMianDingJinKeHu": "Примечание: Покупатель является бездепозитный клиент, пожалуйста, подтвердите PO непосредственно.",
    "CaiGouShangDeKeYongZiJinZuGouZhiFuGaiBiDingDanDingJin": "Примечание: Доступные средства покупателя достаточно, чтобы оплатить депозит {0}, пожалуйста, подтвердите PO как можно скорее, чтобы избежать влияния на производство.",
    "DangQianKeYongZiJinBuZuZhiFuBenDanDingJin": "Примечание: текущие доступные средства недостаточны для оплаты депозита этого заказа {0}, пожалуйста, свяжитесь с покупателем, чтобы увеличить доступные средства, как можно скорее завершить выплату депозита, чтобы не повлиять на производство",
    "ZhangHuBaoZhengJinJinEBuZu": "Внимание:Сумма депозита на счете недостаточна, все еще необходимо выделить {0} на депозит, пожалуйста, завершите выделение как можно скорее, чтобы не повлиять на гарантию.",
    "DingDanYiTiJiaoQingZhiFuDingJin": "Внимание:Заказ был отправлен, пожалуйста, оплатите депозит.",
    "QingZaiChuHuoQianZhiFuDingJinN": "Внимание:Пожалуйста, оплатите депозит {0} перед отправкой.",
    "GaiDingDanHaiXuZhiFuDingJinN": "Внимание:Заказ также необходимо оплатить депозит {0}.",
    "CaiGouShangDangQianWeiMianDingJinKeHu2": "Внимание:Покупатель в настоящее время является бездепозитным клиентом, пожалуйста, свяжитесь с покупателем для подтверждения PO.",
    "CaiGouShangDeDingDanYiTiJiao": "Внимание:Заказ покупателя был представлен, пожалуйста, свяжитесь с покупателем, чтобы оплатить депозит как можно скорее, чтобы не повлиять на производство завода.",
    "CaiGouShangDeDingJinYiZhiFu": "Внимание:Депозит покупателя был оплачен, пожалуйста, свяжитесь с покупателем, чтобы подтвердить заказ как можно скорее, чтобы не повлиять на производство фабрики.",
    "CaiGouShangDeDingDanShangPinJiJiangWanChengShengChan": "Внимание:Заказ покупателя находится на стадии завершения производства, пожалуйста, свяжитесь с покупателем, чтобы оплатить товар как можно скорее, чтобы не задерживать дату прибытия в Гонконг.",
    "CaiGouShangDeDingDanShangPinYiJingZhuangGuiFaWangMuDiChengShi": "Внимание:Заказанные товары были погружены и отправлены в город назначения, пожалуйста, свяжитесь с покупателем, чтобы оплатить окончательный платеж как можно скорее.",
    "YiTiJiaoDingDanNTianWeiTiGongTieMaiXinXiDe": "Внимание:Заказ был представлен {0} дней, за {1} дней без предоставления информации наклейки, время отгрузки будет основано на наклейку, чтобы обеспечить время, чтобы быть отложены.",
    "QingShuRuXuYaoSouSuoDeNeiRong": "Пожалуйста, введите содержимое, которое необходимо найти",
    "QuanBuYuanGong": "Все сотрудники",
    "KeHuZhuDongTianJia": "Дополнения по инициативе клиента",
    "ZuiJinGenJin": "Последние последующие действия",
    "MoRenPaiXu": "Сортировка по умолчанию",
    "LiShiKeHu": "Исторические клиенты",
    "QingXuanZeXiaoShouQuYu": "Пожалуйста, выберите область продаж",
    "ShengYuMuBiaoJinE": "Оставшаяся целевая сумма",
    "JinNTianXuanPinShuLiang": "Количество товаров, выбранных за последние {0} дней",
    "ZuiHouZhaoYangShiJian": "Время поиска последней выборки",
    "XiTongKaoHe": "Оценка системы",
    "SheZhiCaiGouFenZu": "Настройка группы закупок",
    "JiaZaiZhong": "загрузка",
    "JinTianGenJinGuo": "Проследил за этим сегодня.",
    "NTianQianGenJinGuo": "{0} Просмотрено несколько дней назад.",
    "QingXuanZeChanDiQuYu": "Пожалуйста, выберите регион происхождения",
    "GongChangHuoHao（KeHu）": "Заводской номер склада (клиент)",
    "WeiQueRenDingDanHuoZheKongDingDanCaiNengQuXiao": "Отмена возможна только в том случае, если PO не подтверждено или PO пустое",
    "WeiQueRenDingDanDeShangPinCaiNengQuXiao": "Вы можете отменить заказ, только если вы не подтвердили PO",
    "QingShuRuXuSouSuoDeNeiRon": "Пожалуйста, введите содержимое, которое необходимо найти",
    "ChaKanCaiGouShangQianKuan": "Просмотреть разбивку суммы, причитающейся покупателю",
    "ZhuWeiXiangKeHuShouQuWeiT": "Примечание: \"+\" взимается с клиента, \"-\" возвращается клиенту.",
    "BenDanYingShouFeiYongMing": "Распределение платы за этот законопроект",
    "BenDanHeJiDaiZhiFu": "Итого по данному заказу к оплате",
    "ShangPinBianHaoShangPinMi": "Номер продукта, название продукта, номер продукта с завода, номер заказа клиента и другие ключевые слова",
    "QuXiaoZiDongTiaoZhuan": "Отмена автоматического перехода",
    "ZhongBo": "воспроизведение",
    "YuZhuangJuRiQiBianGengJiL": "Запись изменения даты для предварительно собранных шкафов",
    "ShiFouYiSheZhiPinMing": "Установлено ли название продукта",
    "ShiFouManJu": "Заполнен ли шкаф",
    "ShiFouYiChang": "Необычно",
    "ShiFouDingJinYuQi": "Депозит просрочен",
    "ShiFouHuoKuanYuQi": "Несвоевременная оплата товаров",
    "ShiFouXianShang": "Онлайн-документ",
    "YuQiTianShu": "Дни просрочки",
    "QueRenShengChanYaoQiu": "Подтверждение производственных требований",
    "EssaoneLianXiWoMenSEO_BiaoTi": "Контакты",
    "EssaoneLianXiWoMenSEO_MiaoShu": "Контакты компании ESSAONE",
    "EssaoneLianXiWoMenSEO_H1": "Контакты",
    "DingDanWeiZhiFuWeiKuanBuYunXuChuKu": "%s Товары, за которые не был внесен остаток стоимости по заказу, не могут быть отпущены со склада.",
    "DaoChuTuPianYiBianHaoMing": "Экспорт изображения SKU, названного по номеру SKU",
    "XuanZeBaoBiaoYuYan": "Выбор языка отчета",
    "BaoBiaoDaYin": "Печать отчета",
    "QingXuanZeTuPianGuiGe": "Пожалуйста, выберите спецификацию изображения",
    "YuanTu": "Оригинальное изображение",
    "QingShuRuShangPinBianHaoH": "Пожалуйста, введите номер товара или заводской номер",
    "TeBieYaoQiu2": "Специальный запрос",
    "HongShengJiuBianHao2": "Предыдущий номер Hongsheng",
    "QuXiaoJiLu": "Отменить запись",
    "YeWuYuan": "Менеджер аккаунта",
    "DingDanHouTaiChuLiZhong": "Заказ обрабатывается в фоновом режиме",
    "BianGengYuZhuangJuRiQi": "Изменить дату предварительной загрузки",
    "YuanZhuangJuShiJian": "Первоначальное время загрузки",
    "DangQianZhuangJuShiJian": "Текущее время загрузки",
    "XinZhuangJuShiJian": "Новое время загрузки",
    "QingXuanZeXinZhuangJuShiJ": "Пожалуйста, выберите новое время погрузки",
    "BianGengYuanYin": "Причина изменения",
    "QingXuanZeBianGengYuanYin": "Пожалуйста, выберите причину изменения",
    "QingShuRuBianGengYuanYinB": "Пожалуйста, введите причину изменения",
    "DuanTu": "Короткое расстояние",
    "SouSuoDingDanHao/ShangPinBianHao": "Поиск по номеру заказа/номерам товаров",
    "QuQueRen": "Перейти к подтверждению",
    "DaiQueRenChuHuo": "Ожидается подтверждение отгрузки",
    "FaHuoQueRen": "Подтверждение отгрузки",
    "ShiFouYaoQuBuChongChuanWuN": "Хотите ли вы дополнить лист с информацией об отправке № {0}",
    "QueRenChuHuoXinXi": "Подтвердите информацию о доставке",
    "DingCang": "Бронирование",
    "XuanZeWoSiDingCangShiHouX": "Когда вы выбираете способ бронирования, вам необходимо загрузить информацию о доставке для последующих заказов.",
    "QingXuanZeDingCang": "Пожалуйста, выберите способ бронирования доставки",
    "WoSiDingCang": "Мы бронируем доставку",
    "BuDingCang": "Без бронирования",
    "YiHeShiQueRenYiShangXinXi": "Вышеуказанная информация была проверена и подтверждена, подтвердите отправку",
    "DingDanZhengZaiChuLiDiaoH": "Заказ обрабатывается для передачи, пожалуйста, обработайте его позже",
    "ZanWuChaKanQuanXian": "Нет разрешения на просмотр",
    "POZhuangTai": "Статус заказа По",
    "XuHao": "Серийный номер",
    "BianGengRen": "Персонал, внесший изменения",
    "BianGengShiJian": "Время изменения",
    "BianGengLeiXing": "Тип изменения",
    "XinYuJiDaoGangRiQi": "Новая ожидаемая дата прибытия",
    "QuXiaoShuLiang": "Количество аннулирования",
    "SouSuoShangPinBianHaoMing": "Поиск Артикул Номер / Название",
    "DingDanShangPinQuXiaoJiLu": "Запись об аннулировании заказа",
    "KuaiDiDanSaoMiaoJian2": "Отсканированная копия заказа курьера",
    "KuaiDiHao": "Номер курьера",
    "DianFangBianMa": "Код электрического разряда",
    "KuaiDiGongSi": "Курьерская компания",
    "ZhiJianDan": "Лист проверки качества",
    "DingDanJinEXinXi": "Информация о сумме заказа",
    "ZhangHuYuE": "Баланс счета",
    "ShangPinZongJia": "Общая цена продукта",
    "KeYongDanBaoHuoKuanEDu": "Доступная гарантийная сумма",
    "ESSAZhuYiShiXiangNotCn": "Примечания ESSA",
    "ESSAZhuYiShiXiangNotCnBeiZhu": "Вы можете заполнить свой заказ, требования к контролю качества и производству товаров после завершения загрузки и размещения комбинации требований непроизводственного процесса.",
    "ESSAZhuYiShiXiangCn": "Примечания ESSA",
    "ESSAZhuYiShiXiangCnBeiZhu": "Пожалуйста, заполните на китайском языке",
    "QiTaShengChanYaoQiuNotCn": "Другие требования к производству",
    "QiTaShengChanYaoQiuNotCnBeiZhu": "Чтобы клиент видел, вы для вышеуказанного заказа производственные требования и другие дополнения, вы можете заполнить, например: все товары с батареями должны быть разобраны батареи",
    "QiTaShengChanYaoQiuCn": "Другие производственные требования",
    "QiTaShengChanYaoQiuCnBeiZhu": "В соответствии с требованиями завода, пожалуйста, используйте китайский язык для заполнения производственных требований.",
    "GeXingYaoQiuNotCn": "Индивидуальные требования",
    "GeXingYaoQiuCn": "Индивидуальные требования",
    "GeXingYaoQiuNotCnBeiZhu": "Вы можете заполнить некоторые индивидуальные производственные требования для данного заказа, например, в каком положении должна быть наклеена наклейка на товар.",
    "GeXingYaoQiuCnBeiZhu": "Вы можете заполнить некоторые индивидуальные производственные требования для данного заказа, например, в каком положении должна быть наклеена наклейка на товар.",
    "ShiFouRangKeHuQueRenPO": "Должен ли клиент подтвердить заказ.",
    "ShiFouRangKeHuQueRenPOTiShi1": "Если у клиента есть баллы, купоны, после отправки заказа нужно ли ему подтверждать заказ?",
    "ShiFouRangKeHuQueRenPOTiShi2": "Если клиент использует баллы/купоны, это не повлияет на вашу прибыль.",
    "TuiSongGeiKeHuQueRen": "Отправка клиенту для подтверждения",
    "BuTuiSong": "Нет",
    "QingShuRuKeHuDingDanHao": "Пожалуйста, введите номер заказа клиента",
    "FanHuiGouWuChe": "Вернуться в корзину",
    "SheZhiKeHuDingDanHao": "Установить номер заказа клиента",
    "LaiYuan": "Источник",
    "ChengJiaoDanJia": "Цена за единицу транзакции",
    "PiLiangSheZhi": "Настройка партии",
    "SouSuoShangPinBianHaoGongChangHuoHao": "Поиск по номеру товара/заводскому номеру склада",
    "NGe": "{0}шт",
    "QingXuanZeHeTongXinXi": "Пожалуйста, выберите информацию о контракте",
    "SuoYouKeHuDeDingDan": "Все заказы клиентов",
    "QuanBuDingDan": "Все заказы",
    "DaiQueRenPO": "Ожидающие подтверждения заказа",
    "HuoQiYuQi": "Просроченные",
    "ZhuangGuiZhong": "Загрузка",
    "7TianNei": "В течение 7 дней",
    "NYueNei": "В течение{0}месяцев",
    "NYueHou": "После {0} месяцев",
    "SouSuoDingDanHaoShangPinBianHao": "Поиск номера заказа/номера товара",
    "PODanXinXi": "Информация о заказе",
    "KeYongDanBaoEDu": "Доступная гарантийная сумма",
    "ESSABUY_ResultPageType8": "Основываясь на хорошей кредитоспособности покупателя, ESSA предоставила кредит в размере {0}, который будет использован для временной оплаты депозита по данному заказу.",
    "ESSABUY_ResultPageType1": "Сумма фиксированной гарантии текущего счета недостаточна, пожалуйста, направьте средства в маржу как можно скорее, чтобы избежать теневых гарантийных ордеров. Также необходимо внести {0} в маржу счета.",
    "ESSABUY_ResultPageType2": "На фиксированном депозите покупателя также доступна гарантийная сумма (0}, которой недостаточно для обеспечения данного заказа.",
    "ESSABUY_ResultPageType3": "Сумма фиксированной маржи на текущем счете достаточна для гарантии данного ордера, пожалуйста, нажмите кнопку Подтвердить. После подтверждения заказа вы можете войти в список заказов покупателя, чтобы проверить ход выполнения заказа.",
    "ESSABUY_ResultPageType4": "Пожалуйста, подтвердите заказ, чтобы не повлиять на заводское производство. Чтобы не повлиять на отгрузку заказа, пожалуйста, сообщите покупателю, чтобы он оплатил депозит:{0} перед отгрузкой.",
    "ESSABUY_ResultPageType5": "Если средств на вашем счету достаточно для оплаты депозита по данному заказу, пожалуйста, завершите оплату депозита как можно скорее.",
    "ESSABUY_ResultPageType6": "Если имеющихся на счету покупателя средств недостаточно для оплаты депозита, пожалуйста, свяжитесь с ним как можно скорее, чтобы увеличить имеющиеся средства.",
    "ESSABUY_ResultPageType7": "Для этого заказа депозит не требуется, пожалуйста, подтвердите PO напрямую.",
    "ESSABUY_ConfimTips_1": "Подтверждение оплаты будет вычтено из доступных средств (0} в качестве депозита для этого заказа, после оплаты депозита доступные средства на счету покупателя:{1}.",
    "ESSABUY_ConfimTips_2": "Подтверждение оплаты вычтет (0} из доступных средств в качестве депозита для этого заказа, после оплаты депозита на счету покупателя останутся свободные средства:{1}.ESSA выделила сумму {2} для этого заказа, чтобы временно покрыть оплату депозита, но на самом деле необходимо оплатить депозит:{3}, который необходимо оплатить перед оплатой окончательного платежа за этот заказ.",
    "ChaKanKeHuZiJinXinXi": "Просмотр информации о средствах клиента",
    "ChaKanBaoZhengJinXinXi": "Просмотреть информацию о депозите",
    "ESSABUY_SubmitTips_1": "Извините, заказ был подтвержден {0}! Через 2 секунды перейдите на страницу деталей заказа!",
    "ESSABUY_SubmitTips_2": "Подтвердите заказ успешно, отдел закупок организует фабрику для производства как можно скорее! Через 2 с он будет закрыт автоматически, и вы можете войти на страницу деталей заказа PO, чтобы проверить ход производства.",
    "KeHuZiJinXinXi": "Информация о фонде клиента",
    "GuDingBaoZhengJinXinXi": "Информация о фиксированной марже",
    "ZhangHuBaoZhengJin": "Маржа счета",
    "GuDingDingJinEDu": "Сумма фиксированного депозита",
    "DanBaoHuoKuanEDu2": "Гарантированная сумма платежа",
    "MeiYuanGuDingDingJin": "USD Фиксированный депозит",
    "RenMinBiGuDingDingJin": "Юань Фиксированный депозит",
    "GongChangShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi": "Требования к фабричному производству Китайский и иностранный языки должны быть установлены одновременно",
    "ESSAZhuYiShiXiangZhongWenHeWaiWenBiXuTongShiSheZhi": "ESSA Notes должны быть настроены как на китайском, так и на иностранном языках.",
    "ShangPinShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi": "Китайский и иностранный языки должны быть установлены одновременно для требований товарного производства.",
    "ShangPinShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi2": "Китайский и иностранный язык должны быть установлены одновременно для производства товаров, текущие данные недействительны/текущие данные не будут сохранены.",
    "DingDanShengChanYaoQiu": "Требования к производству заказа",
    "WuPOFeiYong": "Нет расходов на PO",
    "FeiYongDanHeJi": "Общие расходы",
    "JinTianXuGenJin": "Необходимо выполнить сегодня",
    "YeWuJinTianXuGenJin": "Менеджеру по работе с клиентами необходимо выполнить сегодня",
    "XiaCiGenJinNeiRong": "Следующая последующая работа",
    "XiaCiGenJinN": "Следующие последующие действия {0}",
    "WuWeiHuoShangPin": "Никаких вопросов в последнюю минуту",
    "NTianHou": "{0} дней спустя",
    "GenJinLiShi": "История последующего наблюдения",
    "XiaCiGenJin": "Следующая последующая работа",
    "FenPeiDeRenWu": "Назначенные задания",
    "XinZengGenJin": "Добавить последующее наблюдение",
    "XinZengGenJinDengJi": "Добавить регистрацию для последующих действий",
    "DaiQueRenPI": "ИП должен быть подтвержден",
    "ZiJinZhangHu": "Счет финансирования",
    "KuanXuanZongJi": "Всего вариантов оплаты",
    "KeZiYouZhiPei": "Дискреционный",
    "YiDongJie": "Замороженные",
    "ChuHuoHouHuiKouJianDuiYin": "Гарантия депозита для отгрузки заказа, соответствующий депозит будет списан после отгрузки",
    "YingFuKuan": "Кредиторская задолженность",
    "XinYongBaoZhengJinEDu": "Лимит кредитной маржи",
    "DingDanChuHuoHouTuiHaiEDu": "Вычеты после отгрузки заказов",
    "YiSuoDing": "Заблокированный",
    "YongYuDingDanDeDingJinDan": "Используется для обеспечения депозита за заказ, заблокированной суммы кредитной маржи. После оплаты депозита по ордеру соответствующая заблокированная кредитная линия освобождается.",
    "DingDanFuKuanHouTuiHaiEDu": "Возвращаемый кредит при отгрузке заказа",
    "HuanChongYinYinXingHuoHui": "Буфер для проблем, вызванных банком или обменным курсом",
    "YiDongJieMingXi": "Заблокированные данные",
    "XinYongEDuMingXi": "Детали кредитного лимита",
    "SouSuoJinE": "Сумма поиска",
    "SouSuoDingDanHaoFeiYongDa": "Номер заказа на поиск / номер расходной накладной",
    "LaiKuanHeJi": "Всего входящих платежей",
    "YingFuKuanHeJi": "Итого Кредиторская задолженность",
    "YiFuKuan": "Оплачено",
    "QianKuan": "Задолженность",
    "WeiFenPei": "Нераспределенная",
    "KeDanBaoDeHuoKuan": "Гарантированный платеж (￥)",
    "QiChuYuE": "Начальный баланс",
    "LaiKuan": "Входящий платеж",
    "LaiKuanFang": "Входящие платежи",
    "SuoYouWeiChuHuoDingDan": "Все неотправленные заказы",
    "YiChuHuo": "Отгруженные",
    "ZhiFuDingDanDingJin": "Депозит оплачен",
    "ZhiFuDingDanWeiKuan": "Оплата окончательного платежа",
    "ZhiFuDingDanQiTaFeiYong": "Оплата других расходов по заказу",
    "NGeDingDanYiZhiFuN": "{0} Оплаченные заказы {1}",
    "HaiQianN": "Все еще должен {0}",
    "TiJiaoDingDanSuoDingDingJ": "Отправить заказ, заблокировать депозит",
    "ChuHuoKouJianBaoZhengJin": "Вычет депозита за отгрузку",
    "SuoDingEDu": "Заблокированная сумма",
    "YiTuiHai": "Возвращено",
    "ChuangJianRiQi": "Дата создания",
    "XuanZeGenJinLianXiRen": "Выберите контакт для последующих действий",
    "ShangChuanFuJian": "Загрузить вложение",
    "KuanXianQiNei": "В течение льготного периода",
    "NTianYiShang": "Более {0} дней",
    "NGeYingFuYiZhiFuN": "{0}платежи, оплачено {1}",
    "NGeYingFu": "{0} кредиторская задолженность",
    "GenJinShuoMing": "Инструкции по выполнению",
    "MeiYouKeDaoChuDeShangPin": "Нет экспортируемых товаров",
    "ZiJiGenJin": "Выполнить самостоятельно",
    "YeWuGenJin": "Менеджер по работе с клиентами",
    "XiaCiGenJinRiQi": "Дата следующего последующего действия",
    "XiaCiGenJinNeiRongBeiWang": "Памятка о содержании следующего последующего действия",
    "XuanZeYaoGenJinDeYeWuYuan": "Выберите менеджера по работе с клиентами, с которым необходимо связаться, поддержка множественного выбора (обязательно)",
    "NDeDingDan": "Заказ от {0}",
    "QingXuanZeGenJinLianXiRen": "Пожалуйста, выберите контактное лицо для последующих действий",
    "QingShuRuGenJinShuoMing": "Пожалуйста, введите инструкции по последующим действиям",
    "ChuHuo1": "Отгрузки",
    "GaiBuFenEDuNiKeJiXuYongYu": "Доступно = кредитная маржа - блокировка, которую вы можете использовать для обеспечения вашего заказа.",
    "KeYongZhangHuZongJiBaoZhe": "Доступно = общая сумма счета - депозит, который вы можете использовать по своему усмотрению",
    "KeDanBaoHuoKuanZongE": "Общее количество товаров, которые могут быть гарантированы",
    "ShengYuKeYongDanBaoEDu": "Оставшаяся доступная сумма гарантии",
    "GaiBiDingDanSuoXuHuoKuanD": "Требуемая гарантия оплаты для данного заказа",
    "KeDing": "Номер заказа клиента",
    "ZhuangXiangShangPinQingDa": "Список предметов, которые необходимо упаковать в коробку",
    "WaiXiangZhang": "Внешняя коробка - длина",
    "WaiXiangKuan": "Внешняя коробка-ширина",
    "WaiXiangGao": "Высота внешней коробка",
    "NeiXiangShu": "Внутренние коробки",
    "Essaone_PingTaiYinSiZhengCe": "Политика конфиденциальности",
    "NinYouDingDanZaiDanBaoZho": "У вас есть гарантийный заказ, пожалуйста, обработайте его первым!",
    "ShenQingChaoXin": "Запрос на получение средств сверх кредитного лимита",
    "ChuLiChaoXinShenQing": "Обработка запроса на получение средств сверх кредитного лимита",
    "ChaEShuMu": "Разница",
    "QingShuRuChaEShuMu": "Пожалуйста, введите сумму разницы",
    "YuJiHaiKuanRiQi": "Предполагаемая дата погашения",
    "QingXuanZeYuJiHaiKuanRiQi": "Пожалуйста, выберите предполагаемую дату погашения",
    "ShenQingYuanYin": "Причина подачи заявки",
    "QingShuRuShenQingYuanYin": "Укажите причину подачи заявки",
    "QingShuRuBuTongGuoYuanYin": "Укажите причину отказа (обязательно)",
    "ShenHeYiJian": "Аудиторское заключение",
    "TongGuo": "Пройден",
    "BuTongGuo": "Не прошел",
    "DaiChuLiChaoXinShenQing": "Ожидает рассмотрения запрос на средства, превышающие кредитный лимит",
    "QueDingXiuGaiDingDanYaoQi": "Подтвердить/изменить запрос на заказ",
    "YiShenQingChaoXinDengDaiS": "Были запрошены средства, превышающие кредитный лимит, и они ожидают рассмотрения.",
    "ShangCiShenHeBuTongGuo": "Последнее рассмотрение не состоялось",
    "DingDanXuYaoZhiFuDingJin": "Требуется депозит {0}",
    "DingDanXuYaoZhiFuWeiKuan": "Требуется окончательная оплата {0}",
    "QingTianXieShenHeYiJian": "Пожалуйста, заполните комментарии к отзыву",
    "QingShuRuBuTongGuoYuanYin2": "Пожалуйста, укажите причину отказа",
    "DingJinTuiHai": "Возврат депозита",
    "QueRenBuManJuChuHuo2": "Подтверждение неконтейнерного груза",
    "WaiXiangTiJiAndMaoZhong": "Объем и вес брутто внешней коробка",
    "ChaKanHeTongXinXi": "Просмотреть информацию о контракте",
    "MeiZhiChanPinDouXuYaoTieTieZhi": "Для каждого товара требуются наклейки",
    "YuZhuangJuRiQi": "Дата предварительной загрузки",
    "DaiSheZhi": "Будет установлено",
    "YuJiZhuangGuiShiJian": "Расчетное время погрузки",
    "QingShuRuZhengQueDeChaESh": "Пожалуйста, введите правильную сумму разницы",
    "ChaEShuMuBuNengDaYuFeiYon": "Количество разниц не может быть больше суммы затрат",
    "XinZengKeHuXinXi1": "Добавить информацию о клиенте",
    "BianJiKeHuXinXi1": "Редактировать информацию о клиенте",
    "DingDanDaiChuLi": "Заказ в процессе оформления",
    "ShenQingChaoXinJiLu": "Применять для записей, превышающих сумму кредита",
    "ZhiChiDanGeWenJianBuNengC": "Поддержка {0}, один файл не может превышать {1}M, максимальная поддержка {2} файлов",
    "ShenHeXiangQing": "Обзор деталей",
    "GouWuQuanKeDuiHuanLiPin": "Ваучеры можно обменять на подарки",
    "MaShangShengQian": "Сохранить сейчас",
    "DiKouDuiHuan": "50% скидка, 50% выкуп",
    "QuanBuDuiHuanGouWuQuan": "Выкупить все ваучеры",
    "JiFenContent4": "Текущий баланс баллов 0, пожалуйста, получите баллы перед использованием.",
    "JiFenContent1": "Текущий баланс баллов {0}, используйте {1} баллов, 50% за кредит заказа {2} за купон для покупок {3} (депозитный купон для покупок).",
    "JiFenTip1": "50% кредит, 50% выкуп: До {0}% от суммы заказа за один заказ, из которых {1}% будет использовано для кредита заказа, а {2}% будет выкуплено в качестве купонов для покупок.",
    "JiFenContent2": "Текущий баланс баллов {0}, используйте {1} баллов для погашения всех ваучеров {2}.",
    "JiFenTip2": "Выкупить все ваучеры: до {0}% от стоимости заказа можно выкупить в виде ваучеров за каждый заказ.",
    "JiFenContent3": "Текущий баланс баллов {0}, баллы не будут использоваться для этого заказа. Однако баллы не являются действительными навсегда, поэтому рекомендуется использовать их своевременно.",
    "PingJia": "Оценить",
    "FaBiaoPingLun": "Опубликовать комментарий",
    "ChaKanWoDeGouWuQuan": "Посмотреть мои ваучеры",
    "BenDingDanPingJiaHouKeJia": "Награда {0} купоном за покупки после оценки этого заказа",
    "BenDingDanPingJiaJiangLiG": "Вознаградить {0} купоном за этот заказ",
    "PingJiaChengGong": "Успех оценки",
    "WoDeGouWuQuan": "Мои ваучеры",
    "GouWuQuanMingXi": "Детали ваучера для покупок",
    "QueRenDuiHuan": "Подтвердить выкуп",
    "YiDanQueRenDuiHuanHouJian": "После подтверждения выкупа ваучера он не может быть отменен, пожалуйста, подтвердите информацию перед выкупом. Ваш эксклюзивный менеджер по продажам свяжется с вами после выкупа, и ваучер будет доставлен на указанный вами адрес в течение 30 дней, пожалуйста, дождитесь получения.",
    "DuiHuanChengGong": "Успешное погашение",
    "DuiHuanShiBaiGouWuQuanBuZ": "Выкуп не удался, недостаточно ваучеров",
    "JiaRuShiJian2": "Присоединился к",
    "1001GP0019": "Информация о продукте не существует",
    "DuiHuanJiaZhiYiChaoGuoNin": "Выкупная стоимость превысила баланс ваучера",
    "YongJiuShanChuDingDanXinX": "Удалить информацию о заказе навсегда",
    "ShanChuDingDanJiLu": "Удалить историю заказов",
    "GouWuQuanDingDan": "Заказы по ваучерам",
    "FaHuo": "Отправка",
    "ChaKanFaHuoXinXi": "Посмотреть информацию о доставке",
    "BuTuiKuanYiZaiQiTaRenWuTu": "Отказ в возврате",
    "ChuFaDi": "Место отправления",
    "YunFeiFuKuanDan": "Счет на доставку",
    "YunFeiZongJi": "Итоговая стоимость доставки",
    "YunFeiDanShangWeiSheZhi": "Счет на доставку еще не сформирован",
    "AnXinPin": "По новинкам",
    "AnJiaGe": "По цене",
    "AnHuoQi": "По дате доставки",
    "QingXuanZeShiFouRangKeHuQ": "Пожалуйста, выберите, нужно ли давать клиенту возможность подтвердить ДО",
    "YiXuanTiaoJian": "Выбранные условия",
    "JiJiangDaoZhangGouWuQuan": "Ваучер для покупок {0} скоро появится",
    "FaHuoXinXi": "Информация о доставке",
    "FaHuoDanPingZheng": "Ваучер на отправку",
    "TuPianDanGeWenJianBuNengC": "Изображение jpeg,jpg,png,bmp, отдельный файл не может превышать {0}m, максимум {1} листов",
    "BuNengQuanBuPingJiaXing": "Не могу оценить все 5 звезд",
    "KeHuShiYongLeYouHui": "Клиент использовал скидку",
    "JiFenContent5": "Текущий баланс баллов {0}",
    "QingShangChuanFaHuoDanPin": "Пожалуйста, загрузите накладную",
    "JinNTianChaKanShangPin": "Просмотр товаров за последние {0} дней",
    "YongJiuShanChuDingDanXinX2": "Информация о заказе удалена навсегда, но товар по-прежнему отправлен",
    "QingXuanZeShiFouShiYongJi": "Пожалуйста, выберите, хотите ли вы использовать свои баллы или нет.",
    "YouHuiDeJinEYiJunTanDaoSh": "Сумма скидки уже добавлена к цене единицы товара.",
    "DengDaiKeHuQueRenShiFouSh": "Ждем, когда клиенты подтвердят, будут ли они использовать купоны или баллы. Пожалуйста, будьте внимательны при подтверждении PO, после подтверждения PO клиент не сможет использовать купон или баллы снова.",
    "BuHuoChiShangPin": "Товары для пополнения запасов",
    "DingDanShuJuYiJingBianDongQingShuaXinHou1": "1. вы слишком долго находились на странице, и товар, для которого вы отправляете заказ, изменился. <br />2. отправленный товар содержит аномалии или не соответствует требованиям для размещения заказа: количество заказа не соответствует начальному количеству поставки на фабрике, количество заказа не достигает MOQ.<br />3. Пожалуйста, обновите и проверьте товар заново, или вернитесь в корзину, чтобы повторно отправить заказ.<br />",
    "ZhengJuPaiDan": "Заказ целого шкафа",
    "RuXiGuanAnJiJuXiaDanKeXua": "Если вы привыкли к комплектации шкафа заказом, вы можете выбрать [Планирование всего шкафа].",
    "PinJuZhiNengCaoZuoZiJiZha": "Шкаф бассейна может работать только с собственным аккаунтом для добавления покупки товаров!",
    "ShuXiDeGongNeng": "Привет, знакомая функция!",
    "RuXiGuanAnZhengJuXiaDanKe": "Если вы привыкли заказывать целыми шкафами, вы можете выбрать [планирование целых шкафов] для оформления заказа. Если заказывается большое количество товара, а затем рассматривается возможность загрузки шкафа отгрузкой, рекомендуется заказывать напрямую.",
    "DingDanDeShangPinZhuanXia": "%s от %s заказанных товаров будут возвращены как имеющиеся на складе.",
    "DingDanDeShangPinZhuanZai": "%s от %s заказанных товаров будут возвращены как находящиеся в пути.",
    "XiaDanDuiHuanGouWuQuan": "Разместите заказ на ESSA, чтобы обменять на подарочные купоны.",
    "XiaDanDiKouJinE": "Разместите заказ на ESSA, чтобы вычесть сумму заказа.",
    "NTianQian": "{0} дней назад",
    "NJiFenJiJiangZaiNGuoQiQing": "{0} баллов обнулятся {1}. Пожалуйста, используйте баллы вовремя!",
    "WenJianMingMingGeShi": "Формат именования файлов",
    "GongChangMingChengShangPi": "Заводское название_Продукт №.",
    "TuPianDaXiao": "размер изображения",
    "ShangPinBianHao2": "Номер продукта",
    "XiuGaiBaoJiaDanXinXi": "Изменить информацию о предложении",
    "NiHaiMeiYouTianXieGaiKeHu": "Вы не заполнили аналитический отчет по клиенту, клиент будет отвязан, если вы не заполните отчет после установленного срока.",
    "TianXieFenXiBaoGao": "Заполнить отчет об анализе",
    "XiuGaiFenXiBaoGao": "Изменить аналитический отчет",
    "XinZengFenXiBaoGao": "Добавить отчет об анализе",
    "ShangYiNianDuChengJiaoFen": "Распределение сделок за предыдущий год",
    "XianYouMuBiao": "Существующая цель",
    "PingGuDeMuBiao": "Оцененные цели",
    "TuiJianPinLv": "Частота рекомендаций",
    "DingJiaCeLve": "Стратегия ценообразования",
    "QingShuRuTuiJianPinLvShiL": "Укажите частоту рекомендаций, например: 3 раза в месяц.",
    "DiYiJiDu": "Первый квартал",
    "DiErJiDu": "Второй квартал",
    "DiSanJiDu": "Третий квартал",
    "DiSiJiDu": "Четвертый квартал",
    "QingShuRuDingJiaCeLveShiL": "Пожалуйста, введите стратегию ценообразования, например: клиент горячие модели не увеличивать цену, другой плюс 8 пунктов; клиент спрос на больше изменений, цена, чтобы оставить место, рекомендуется добавить 15 пунктов.",
    "XuanPinCeLve": "Стратегия выбора продукта",
    "QingShuRuXuanPinCeLveShiL": "Пожалуйста, введите стратегию выбора продукта. Обратитесь к следующим измерениям: 1, основной толчок небольшой категории, упаковка, ценовой ориентир. 2, основной тип выбора товара, такие как: новые продукты, экономически эффективные, поиск альтернативных товаров, функциональность, новизна упаковки, цена карты и т.д. 3, основной толчок одного продукта, или основной толчок серии. 4, количество каждого толчка продукта.",
    "JiaoYiTiaoJianCeLve": "Стратегия торговых условий",
    "QingShuRuJiaoYiTiaoJianCe": "Пожалуйста, введите торговые условия стратегии, например: клиент в настоящее время все поставщики поддерживают клиента период счета, необходимо напрямую говорить о периоде поддержки счета; клиент в настоящее время работают вместе находятся в форме 30% депозит, может быть сделано непосредственно перед отгрузкой 30%, чтобы дать клиенту средства более чем за месяц времени для оборота.",
    "ZhuanHuaZhouQiMuBiao": "Цель цикла конверсии",
    "QingShuRuZhuanHuaZhouQiMu": "Укажите цель цикла конверсии, например, один месяц, два месяца, шесть месяцев.",
    "KeHuGuanZhuDengJi": "Уровень внимания к клиенту",
    "QingShuRuKeHuGuanZhuDengJ": "Пожалуйста, введите уровень внимания клиента",
    "TiJiaoFenXiBaoGao": "Представление аналитических материалов",
    "JinNianDuMuBiao": "Цель на этот год",
    "RuGuoLinJinNianMoYunXuTia": "Если близится конец года, можно указать 0",
    "JunTanDaoJiDuMuBiao": "Распределить по квартальным целям",
    "RuGuoLinJinJiDuMoYunXuTia": "Если близится конец квартала, можно указать 0",
    "ZanMeiLiShiMuBiao": "Пока нет исторических целей",
    "NianDuMuBiao": "Годовая цель",
    "YiGuoBuYongTian": "Истек, не нужно заполнять",
    "QingShuRuJinNianDuMuBiao": "Пожалуйста, введите цель на этот год",
    "ZhaoYangYiBanHuiZaiTianNe": "Обработка запроса на поиск товара занимает до 5 дней. Пожалуйста, не забудьте посмотреть результат запроса.",
    "ZhengMian": "Лицевая сторона",
    "QingShangChuanZhengMian": "Пожалуйста загрузите лицевую сторону товара",
    "BeiMian": "Задняя сторона",
    "QingShangChuanBeiMian": "Пожалуйста загрузите заднюю сторону товара",
    "QingShuRuMiaoShuLiRuGongN": "Пожалуйста, заполните описание. (например: функции, цвета, материал, бренд, упаковка, сайт товара и т.п.)",
    "BiXuYuTuPianShangPinYiZhi": "Товар должен полностью соответствовать фотографии",
    "BiXuDaiShangPinZhengShu": "Нужен сертификат соответствия на товар",
    "ShangPinJiaGeBuChaoGuo": "Цена товара не превышает",
    "ZhiShaoShangChuanYiZhangT": "Необходимо по крайней мере загрузить одну фотографию или заполнить описание",
    "ShangChuanShangPinTuPian": "Загрузить фотографию товара",
    "RenWuWanCheng": "Задача выполнена",
    "YouZhaoDao": "Найдено",
    "QueRenChuHuoChengGong": "Подтвердите отправку",
    "YuJiCaiGouLiang": "Количество, планируемое к закупке",
    "QingTianXieYuJiCaiGouLian": "Пожалуйста, заполните количество, планируемое к закупке",
    "NianDuMuBiaoYuJiDuMuBiaoJ": "Сумма годовых и квартальных целей не совпадает",
    "YouXiangXiaoYanChengGong": "Проверка электронной почты прошла успешно",
    "YouChengJiao": "Совершена сделка",
    "ZhongYaoXiaoXi": "Важное сообщение",
    "ShengNTianTianXieKeHuKaiFa": "Осталось {0} дней для заполнения отчета о развитии клиента, в случае просрочки клиент будет отвязан",
    "QuTianXie": "Перейти к заполнению",
    "ShangWeiSheZhiXiaoShouHeT": "Договор на продажу еще не установлен",
    "NiYiZhuDongFangQiGenJinGa": "Вы добровольно отказались от сопровождения этого клиента, ожидается отмена привязки. Клиент теперь находится в полупубличном состоянии и может быть отслежен другими менеджерами по продажам.",
    "YiShenQingGenJinKeHuDengD": "Запрос на сопровождение клиента подан, ожидается подтверждение клиента.",
    "KeHuShuJuGaiLan": "Обзор данных клиента",
    "GengDuoDongTaiXinXiQingQi": "Для получения дополнительной информации, пожалуйста, посетите {0}",
    "MuBiaoWanCheng": "Цель достигнута",
    "NianDuMuBiaoQingKuang": "Состояние годовой цели",
    "NianDuDingHuo": "Годовые заказы",
    "XiaoShouQuDaoXiangXiXinXi": "Подробная информация о каналах сбыта",
    "ZhuCeCaiGouPinLei": "Зарегистрированные категории закупок",
    "RenZhengCaiGouPinLei": "Сертифицированные категории закупок",
    "CaiGouPinLv": "Частота закупок",
    "DanKuanCaiGouXiangShu": "Количество коробок на одну покупку",
    "YingYuJiaoLiu": "Общение на английском языке",
    "QingGuanFangShi": "Метод таможенного оформления",
    "HaiGuanJinKouGuiMo": "Масштаб таможенного импорта",
    "Hui": "Будет",
    "BuHui": "Не будет",
    "HuiGuan": "Без таможенного оформления",
    "BaiGuan": "Официальное таможенное оформление",
    "YiNianZaiZhongGuoDeJinKou": "Годовой объем импорта в Китае",
    "GongSiQiTaZhuTi": "Другие подразделения компании",
    "GongSiDianMianShuLiang": "Количество магазинов компании",
    "GongSiDianMianZhanTingFen": "Города с магазинами/выставочными залами компании",
    "ZanWeiWanShan": "Еще не завершено",
    "GongSiBanGongDaLouZhanTin": "Изображения офисного здания/выставочного зала/магазина компании",
    "ShangPinJieGou": "Структура товара",
    "ChanPinDangCi": "Класс продукта",
    "BaoZhuangLeiXingXiHuan": "Предпочтительный тип упаковки",
    "TianJiaTuPian": "Добавить изображение",
    "KeHuPinPai": "Бренд клиента",
    "ZhuYaoXiaoShouChengShiDia": "Основной город продаж/адрес магазина",
    "BanGongDiZhi": "Адрес офиса",
    "KeHuTouXiangHuoHeYing": "Аватар клиента или групповое фото",
    "ZuiXinBeiZhu": "Последние примечания",
    "ChaKanQuanBuBeiZhu": "Просмотреть все примечания",
    "XunJiaYuJiaoYi": "Запрос цены и сделка",
    "ShouQu": "Взимать",
    "BuShouQu": "Не взимать",
    "ChongDan": "Продвигать заказ",
    "BuChongDan": "Не продвигать заказ",
    "ZhongSuanJiaGeChongDan": "Пересчитать цену (для продвижения заказа)",
    "XinKeShouNianYouHuiJiYouH": "Скидка для новых клиентов в первый год (и время окончания скидки)",
    "JieShu": "Конец",
    "HeTong": "Контракт",
    "YouXiao": "Действительный",
    "ShanChuHouBuKeHuiFuShiFou": "Удаление необратимо, вы уверены, что хотите удалить?",
    "XiuGaiXinXi": "Изменить информацию",
    "ZhuZhangHao": "Основная учетная запись",
    "ZiZhangHao": "Дополнительная учетная запись",
    "ZhuYingCaiGouLeiMu": "Основные категории закупок",
    "MingPian": "Визитная карточка",
    "QingTianXieYouXiang": "Пожалуйста, введите адрес электронной почты",
    "XinZengLianXiFangShi": "Добавить новый контакт",
    "XiuGaiLianXiFangShi": "Изменить контакт",
    "SheZhiGaiZhangHaoWeiZhuZh": "Установка этой учетной записи как основной заменит существующую основную учетную запись",
    "XuanZeShuLiangYiChaoGuoGe": "Количество выбранных позиций превышает 5, пожалуйста, уберите часть выбора, чтобы продолжить",
    "NinTianXieDeYouXiangYouWu": "Введенный вами адрес электронной почты неверен",
    "SheZhiWeiZhuZhangHaoDangQ": "Установить как основную учетную запись, текущая учетная запись не активна",
    "SheZhiWeiZhuZhangHao": "Установить как основную учетную запись",
    "YouXiangZhenWeiWeiZhi": "Подлинность электронной почты неизвестна",
    "YouXiangYiYanZheng": "Электронная почта проверена",
    "YouTianXieXiuGaiWuTianXie": "Если заполнено, изменить; если нет, не изменять",
    "QingXuanZeCaiGouLeiMu": "Пожалуйста, выберите категорию закупок",
    "DaiChuLiGouWuQuanDingDan": "Заказы на обработку ваучеров в ожидании",
    "NTiJiaoDengDaiZhuGuanShenH": "{0} подано, ожидается проверка начальника",
    "YiShenHeTongGuoXiuGaiJian": "Одобрено. Изменения будут пересмотрены.",
    "ShouJiHaoChongFu": "Номер телефона дублируется",
    "ZhangHaoChongFu": "Учетная запись дублируется",
    "YiShenQingGenJinChaKanXia": "Запрошены последующие действия, просмотрите подробности",
    "ZhaoYangRenWuYouGengXin": "Обновления в разделе \"Запрос на поиск товара\"",
    "ShangPinJingLiYiGengXinZh": "Менеджер уже обновил информацию по поиску товара. Пожалуйста, посмотрите!",
    "QingWanShanWeiTianXieDeSh": "Пожалуйста, заполните незаполненную информацию о социальных сетях",
    "ShangPinJieGouPinLeiShuLi": "Максимальное количество категорий в структуре продукта - 5, пожалуйста, проверьте выбранные вами категории.",
    "QingWanShanKeHuXiangXiXin": "Пожалуйста, заполните информацию о клиенте",
    "LianXiKeHuJingLi": "Связаться с менеджером по товару",
    "GongSiSheMeiXinXiZhongFu": "Информация о компании в социальных сетях продублирована",
    "YiFenXiXuQiuPinLeiJingLiZ": "Ваш запрос уже обработан, категорийный менеджер уже ищет товар",
    "QiTaLianXiFangShiZhongFu": "Прочая контактная информация продублирована",
    "WeiNiZhaoDaoDeYangPinGong": "Для вас найдено {0} товаров",
    "BianJiGongSiXinXi": "Редактировать информацию о компании",
    "YouXinHuiFu": "У вас новое сообщение",
    "QingXuanZeGongSiLeiXingYu": "Пожалуйста, выберите тип компании (исходный канал)",
    "ZhangHuWeiTongGuoPingTaiR": "Учетная запись пока не подтверждена, функция \"Запрос на поиск товара\" пока недоступна. Пожалуйста, дождитесь подтверждения учетной записи",
    "QingTianXieGongSiQiTaZhuT": "Пожалуйста, укажите другие подразделения компании",
    "LianXiShangPinJingLi": "Связаться с менеджером по товару",
    "QingXuanZeZhuCeCaiGouPinL": "Пожалуйста, выберите зарегистрированную категорию закупок",
    "RenZhengZhuYaoCaiGouPinLe": "Сертифицированная основная категория закупок",
    "QingXuanZeRenZhengZhuYaoC": "Пожалуйста, выберите сертифицированную категорию закупок",
    "ZhengJu": "FCL（Полный контейнер）",
    "HuiYingYu": "Говорит по-английски",
    "BuHuiYingYu": "Не говорит по-английски",
    "TuPianShiPinDanGeWenJianB": "Изображения/видео (mp4, flv, jpeg, jpg, png, bmp), один файл не должен превышать 20М, максимум 10 файлов",
    "KeHuShangPinJieGou": "Структура товаров клиента",
    "QingMiaoShuPinLeiDeJiaGeQ": "Пожалуйста, опишите ценовой диапазон категории, укажите валюту",
    "QingMiaoShuPinLeiDeChanPi": "Пожалуйста, опишите класс продукта категории",
    "PinPaiZhuYingLeiMu": "Основная категория бренда",
    "QingXuanZeKeHuPinPaiLeiMu": "Пожалуйста, выберите категорию бренда клиента",
    "PinPaiBeiZhu": "Примечания к бренду",
    "GongSiSheMei": "Социальные сети компании",
    "KeHuTouXiangHeYingXiangPi": "Аватар клиента/групповое фото",
    "BiXuYuTuPianYiZhi": "товар должен полностью совпадать с изображением",
    "BiXuDaiZhengShu": "нужен сертификат соответствия",
    "YuJiCaiGou": "планируется к закупке {0} штук",
    "DiYu": "Менее, чем {0}",
    "XunJiaSheZhi": "Настройки запроса",
    "QingShuRuFanDianLv": "Пожалуйста, введите ставку скидки",
    "BuQiYong": "Не включено",
    "ShiFouZhongSuanJiaGeChong": "Нужно ли пересчитывать цену (список доработок)",
    "XianZhiZhiNengXiuGaiHouXu": "Ограничение 3%-15%, необходимо провести аудит после изменения.",
    "KeHuDingDanDuiGongChangDe": "Количество расчетных дней для заказов клиентов на фабрики, если вы заполняете запрос, FO заказы на получение заказов и т.д. будет в соответствии с реализацией этого расчетного периода, что повлияет на время фабрики, чтобы попросить деньги, чтобы изменить заказ.",
    "GongChangZhangQi": "Период учета завода",
    "YuKeHuJieSuanDeZhangQiTia": "Количество дней для урегулирования счета с клиентом, которое влияет на дату погашения дебиторской задолженности клиента и т. д.",
    "KeHuZhangQi": "Расчетный период клиента",
    "DangYiCaiCaiGouZhongXinXu": "Если цена после запроса центра закупок ESSA выше, чем цена до запроса, выберите «Не требуется проверка», если дальнейшие переговоры не требуются. Если после запроса необходимо провести переговоры с заводом, выберите «Требуется проверка».",
    "RenMinBiJiaoYi": "Операция в юанях",
    "MeiYuanJiaoYi": "Транзакция в долларах США",
    "QingTianXieZhangQiXinXi": "Пожалуйста, заполните информацию о расчетном периоде",
    "QingXuanZeFanDianLv": "Пожалуйста, выберите ставку возврата",
    "XiuGaiXunJiaHeJiaoYiXinXi": "Изменить информацию о запросе и транзакции",
    "QianWanChengHuiFu": "времени до получения ответа осталось: {0}",
    "DangJiMuBiaoQingKuang": "Статус квартальной цели",
    "DangJiMuBiao": "Сезонная цель",
    "DangJiDingHuo": "Сезонный заказ",
    "GuanLiHeTong": "Договор с руководством",
    "PinLeiJingLiZhengZaiWeiNi": "Категорийный менеджер уже ищет товар",
    "BaoQianWoMenMeiYouZhaoDao": "К сожалению, мы не нашли подходящий товар",
    "YiQuanBuZhaoWanGongZhaoDa": "{0} поиск полностью завершен, всего найдено {1} результатов",
    "YouGengXinGongZhaoDaoKuan": "есть обновления {0}, всего найдено {1} результатов",
    "QingWanShanWeiTianXieDeQi": "Пожалуйста, заполните незаполненную другую контактную информацию",
    "QingQueRenZhangHaoXinXiDe": "Пожалуйста, убедитесь, что номер мобильного телефона в информации о счете заполнен?",
    "QingXianXuanZeRenZhengCai": "Пожалуйста, сначала выберите сертифицированную категорию покупки",
    "YuanYouMuBiao": "Исходная цель",
    "WeiShengXiao": "Не вступило в силу",
    "ZhangHaoLianXiRenXinXi": "Учетная запись/контактная информация",
    "FenXiBaoGao": "Аналитический отчет",
    "GongGongChi": "Общий пул",
    "KeHuXiangQing": "Информация о клиенте",
    "TianXieDeBeiZhuBuNengWeiK": "Заметка не может быть пустой",
    "QuanBuBeiZhu": "Все заметки",
    "TianJiaBeiZhu": "Добавить заметку",
    "ShiFouShanChuGaiBeiZhu": "Удалить эту заметку?",
    "ShangChuanPinPai": "Загрузить логотип бренда",
    "WanChengBiLi": "Уровень выполнения",
    "PiLiangJiaRuXuanPinChi": "Массовое добавление в пул отбора",
    "DaiShenHeFenXiBaoGao": "Проверка аналитического отчета",
    "ChanPinDangCiShiZhiKeHuSu": "Уровень продукции относится к качеству и рыночному позиционированию продаваемых клиентом товаров. Вы можете оценить уровень, учитывая такие факторы, как материалы, технологии, известность бренда и целевой рынок.",
    "HeTongeffectiveTimeMsg": "Контракт должен быть в пределах срока действия, чтобы выбрать и связать с соответствующим контрактом при подаче заказа. Обратите внимание на срок действия.",
    "HeTongcompanyNameMsg": "При использовании счетов-фактур и других документов заполняйте их правильно, чтобы это не помешало использованию.",
    "HeTongcontactNameMsg": "При использовании счетов-фактур и других документов заполняйте их правильно, чтобы это не помешало использованию.",
    "HeTongmobileMsg": "При использовании счетов-фактур и других документов заполняйте их правильно, чтобы это не помешало использованию.",
    "HeTongcompanyAddressMsg": "При использовании счетов-фактур и других документов заполняйте их правильно, чтобы это не помешало использованию.",
    "ShenQingRen": "Соискатель",
    "JiJiangLiuShiKeHu": "Скоро будут потеряны",
    "YiLiuShiKeHu": "Потерянные покупатели",
    "HeTongbankInfoMsg": "При использовании счетов-фактур и других документов заполняйте их правильно, чтобы это не помешало использованию.",
    "HeTongbankAccountMsg": "При использовании счетов-фактур и других документов заполняйте их правильно, чтобы это не помешало использованию.",
    "HeTongswiftCodeMsg": "При использовании счетов-фактур и других документов заполняйте их правильно, чтобы это не помешало использованию.",
    "HeTongpayConditionRemarkMsg": "Этот раздел будет отображаться в разделе «Условия оплаты» в счете-фактуре. Пожалуйста, заполните правильно.",
    "HeTongshippingRemarkMsg": "Если у клиента есть требования к сотрудничеству по загрузке контейнеров и сопутствующей логистике, укажите подробности и сообщите в логистический отдел. Полученная информация о доставке будет отображать напоминания.",
    "HeTongfinRemarkMsg": "Примечания к требованиям финансового сотрудничества",
    "HeTongpurchaseRemarkMsg": "Если у клиента есть требования к сотрудничеству по загрузке контейнеров и сопутствующей логистике, укажите подробности и сообщите в логистический отдел. Полученная информация о доставке будет отображать напоминания.",
    "HeTongdocumentaryRemarkMsg": "Если требования клиента к закупкам и производству требуют особого внимания и уведомления отдела закупок, укажите подробности. Соответствующие интерфейсы заказов на заводе и отслеживания заказов будут отображать напоминания.",
    "HeTongwarehouseRemarkMsg": "Если у клиента есть особые требования к сотрудничеству по проверке качества и приемке, укажите подробности и сообщите в отдел складирования. Система будет отображать напоминания в отслеживании заказов и списке приемки.",
    "HeTongcustomerServiceRemarkMsg": "Для замечаний по сотрудничеству с клиентами, которые должны быть рассмотрены бизнесом/покупателем, укажите детали.",
    "HeTongsigningCompanyIdMsg": "Подписывающая сторона нашей компании используется во многих местах, таких как таможенная декларация, доставка и финансовые счета. Пожалуйста, выберите точно.",
    "ShangPinJingLiHuiFuLeXinD": "Появилась новая информация о товаре",
    "ZuiHouJiaGouShiJian": "Время последней покупки",
    "ZuiHouGenJinMaiShou": "Последний последующий покупатель",
    "YiLiuShi": "Переработанный",
    "JiJiangLiuShi": "Скоро будет отменен",
    "LiuShiShiJian": "Потеряно время",
    "QuShenHe": "Пройти аудит",
    "HeTongpaymentTypeMsg": "Прочтите и отобразите способ расчета в информации о транзакции клиента",
    "HeTongfileListMsg": "Приложение к контракту",
    "SouSuoKeHuMingZiBianMaYou": "Поиск имени/кода/электронной почты покупателя",
    "HeTongcodeMsg": "Код контракта",
    "ShangJiDuWanCheng": "Завершено в прошлом квартале",
    "YiNianZhongGuoJinKouE": "Стоимость импорта в Китай за год",
    "QingShuRuCaiGouPinLv": "Пожалуйста, укажите частоту покупок",
    "NiKeYiChangShiShiYongJiao": "Вы можете попробовать использовать несколько ключевых слов или разные ключевые слова, а также воспользоваться функцией \"Поиск товара\"",
    "QingTianXieZhenShiYuJiCai": "Пожалуйста заполните количество товара, планируемое к закупке. Если разница между планируемым к закупке и фактически заканным количеством товара будет слишком большой, это может повлиять на цену, минимальное количество товара для заказа и др. факторы",
    "DaiGenJin": "Необходимо выполнить",
    "BieRenGenJin": "Выполнение другими",
    "WoDeGenJin": "Мои последующие действия",
    "RenWuBianHao": "Номер задачи",
    "DaiTianXieFenXiBaoGao": "Аналитический отчет должен быть заполнен",
    "WeiTianXieBaoGao": "Отчет не заполнен",
    "YiYuQi": "Просрочено",
    "ShengTianTianXieKeHuFenXi": "Осталось {0} дней для заполнения отчета об анализе клиента, несвоевременное заполнение приведет к отмене привязки клиента",
    "SouSuoKeHuMingZiYouXiang": "Поиск имени/электронной почты клиента",
    "NianDuMuBiaoBuKeDaYuJiDuM": "Годовая цель не может быть больше {0}, квартальная сумма целей не может быть больше {0}.",
    "LianXiKeHu": "Связаться с клиентом",
    "KeHuFenXiBaoGaoTianXieYuQ": "Отчет об анализе клиента просрочен и переведен в слабый переплет.",
    "ZhuGuanDaiBan": "Руководитель должен сделать",
    "ChangYongYuYan": "Общий язык",
    "WoYaoGenJin": "Я хочу проследить",
    "ZhaoYangRenWu": "Образец задания на поиск",
    "GenJinChengGong": "Последующий успех",
    "TuPianDanGeWenJianBuNeng2": "Изображение jpeg,jpg,png,bmp, размер одного файла не должен превышать 10M.",
    "JiJiangShengChengDingDan": "Заказы будут сформированы в ближайшее время",
    "JiaoYiXinXiYiXiuGaiDengDa": "Информация о транзакции была изменена, ожидает рассмотрения.",
    "FuWuFeiLvDingJinFangShiXi": "Информация о тарифе обслуживания и способе пополнения счета была изменена и должна быть проверена руководителем, прежде чем она вступит в силу.",
    "DaiShenHeJiaoYiXinXi": "Информация о транзакции, находящейся на рассмотрении",
    "TianXieBuTongGuoYuanYin": "Укажите причину отказа",
    "QueRenBianGengXinXi": "Подтвердить изменения в информации",
    "YiTongGuo": "Одобрено",
    "ShenHeJiaoYiXinXiBianGeng": "Проверка изменений информации о транзакции",
    "BuTongGuoYuanYin": "Причина отказа",
    "GaiCheng": "исправить",
    "img_upload_400": "Размер изображения должен быть >= 100px, <= 4096px, и меньше 4MB",
    "img_upload_403": "Операция слишком частая, попробуйте позже.",
    "KaiTongESSAONE": "Открыть привилегии ESSAONE",
    "YiShenQing": "заявка подана",
    "WeiShenQing": "еще не подана заявка",
    "YiKaiTong": "доступ разрешен",
    "WeiKaiTong": "нет прав доступа",
    "DDPJiaGe": "Цена \"под ключ\"",
    "KeHuKeXiangYouHuiXinTuoCh": "Скидки для клиентов",
    "JiaRuTuiJian": "Рекомендуем",
    "DaiLiShangZiYuanShangDaiB": "Дела агента и поставщика ресурсов",
    "NiLeiJiTuiJianKuanShangPi": "Из подобранных для клиента {0} товаров, клиент выбрал {1} товаров. Конверсия {2}%",
    "TiaoXuanShangPin": "Выбрать товары",
    "JuLiFaBuYiDengDaiTian": "до публикации осталось {0} дней",
    "ZhaoDaoKuanKeHuJiaGouKuan": "Найдено {0} товаров, клиент добавил в корзину {1} товаров",
    "ZhaoYangShengYuTian": "Для поиска товара осталось {0} дней",
    "KeHuMeiYouLiuYan": "Клиент не оставлял сообщения",
    "KeHuYouXinLiuYanQingLiuYi": "Клиент оставил новое сообщение, посмотрите!",
    "KeHuYouLiuYan": "клиент написал сообщение",
    "ZhaoYangRenWuChi": "Поисковые задания",
    "DangQianRenWuGenJin": "Отслеживание задач",
    "ShangPinBanQuan": "Авторское право на товар",
    "YiChuXuanPin": "Удалить товары",
    "ZhiDingShangPinKeYong2": "Доступно для заказа выбранного товара {0}",
    "QingKongXuanPin": "Полностью удалить",
    "XuanPinZhuangTai": "Выбор товара",
    "PinLeiJingLi": "Менеджером по товару",
    "DangQianYouHuiQuanBuYunXu": "Текущий купон нельзя использовать вместе с баллами",
    "XuYaoGenJinRenWuHouCaiNen": "Работу можно продолжить после выбора задачи",
    "NDeZhaoYang": "{0} товаров",
    "QueRenMiMa": "Подтвердите пароль",
    "TianJiaYuanGongZhangHao": "Добавить учетную запись сотрудника",
    "ZhaoYangGuanLi": "Управление \"Запросом на поиск товара\"",
    "DangQianShangPin": "Артикул",
    "XiaDanZuiGaoKeXiangZheKou": "Максимальная скидка при оформлении заказа составляет 5%",
    "NHouYiYouHuiQuanXingShiFaF": "После того, как {}, вам может быть отправлен купон. Пожалуйста, проверьте в разделе \"Мои купоны\"",
    "YiDaoGangRiQi": "Дата прибытия в порт",
    "TuiJianChengGong": "Сформирована подборка",
    "YiChuChengGong": "Удаление завершено",
    "FaJianRenMaiJia": "Отправитель/ Продавец",
    "QingZhuCeDengLuZhangHaoHo": "Пожалуйста, зарегистрируйтесь и войдите в систему для использования",
    "YiCaiXuanPinXiaoQi": "ESSABUY-платформа обслуживания клиентов",
    "ZhuXiaoZhangHao": "Деактивировать аккаунт",
    "BaoHuShangPinChaKanShenQi": "Защита приложения для просмотра продуктов",
    "ZhuZhangHaoQingSheZhiQiTa": "Пожалуйста, установите другую учетную запись сотрудника как основную учетную запись BOSS перед деактивацией основной учетной записи.",
    "QianWangYuanGongZhangHaoG": "Перейти к управлению учетными записями сотрудников",
    "YuanGongTouXiang": "Аватар сотрудника",
    "MoRenMiMaShiYuanGongDianH": "Пароль по умолчанию - номер телефона сотрудника",
    "YongHuLeiXing": "Тип пользователя",
    "LaXinYeWu": "Продвижение нового бизнеса",
    "LaShengYeWu": "Продвижение бизнеса",
    "MaiShou": "Покупатель",
    "PuTongYongHu": "Обычный пользователь",
    "QingXuanZeYongHuLeiXing": "Пожалуйста, выберите тип пользователя",
    "MaiShouDengJi": "Уровень покупателя",
    "QingXuanZeMaiShouDengJi": "Пожалуйста, выберите уровень покупателя",
    "KaiFaKeHuShu": "Количество разработанных клиентов",
    "QingTianXieKaiFaKeHuShu": "Пожалуйста, введите количество разработанных клиентов",
    "QingTianXieDaYuHuoDengYuD": "Пожалуйста, введите целое число большее или равное 0",
    "NRiLiuLanShangPinShu": "{0} дней просмотра продуктов",
    "QingWanShanDanJuDingJinBi": "Пожалуйста, укажите соотношение депозита для одного шкафа",
    "QingWanShanDingJinZhiFuSh": "Пожалуйста, укажите время оплаты депозита",
    "ZhuGongShiChangHeZhuGongQ": "Пожалуйста, обратите внимание: основной рынок и основную область можно изменять только один раз в год",
    "WoYiQingChu": "Я понимаю",
    "YiNianZiRanNianZhiYunXuXi": "Пожалуйста, обратите внимание: допускается только одно изменение в год (календарный год)",
    "ShangCiXiuGai": "Последнее изменение",
    "ShuJuYinQingJiangGenJuNiS": "Двигатель данных будет отображать данные на основе выбранного вами рынка и области.",
    "ZhenShiZhunQueTianXieZhuG": "Заполните основную рыночную и областную информацию точно, чтобы получить точные рекомендации по продуктам, поддерживаются множественные выборы",
    "PCS": "Штук",
    "YouJiHuiYingDeYouHuiQuan": "Есть возможность получить купон на 5% скидку",
    "MeiZhouYiGengXin": "Обновляется каждый понедельник",
    "QuYuShuJuQingBao": "Разведка данных по области (последние 4 недели)",
    "XiuGaiZhuGongQuYu": "Изменить основную область",
    "XuanPinPinLeiTop": "Топ-10 категорий выбора",
    "XunPanPinLeiTop": "Топ-5 категорий запросов",
    "JinTianNeiMaoYiShangYiJia": "Топ-5 категорий с наибольшим количеством торговых запросов за последние 30 дней",
    "ShangXinPinLeiTop": "Топ-10 новых категорий продуктов",
    "JinTianNeiPingTaiShangXin": "Топ-10 категорий с наибольшим количеством новых продуктов на платформе за последние 30 дней",
    "ReMaiGongYingShangTop": "Топ-6 самых продаваемых поставщиков",
    "JinTianNeiPingTaiShangJia": "Топ-6 заводов с наибольшим количеством добавленных товаров за последние 30 дней",
    "JinKeChaKanQingBaoChiHuoY": "Только VIP могут просматривать, пожалуйста, оставайтесь активными, чтобы перейти на VIP",
    "LeiJiDengLuNTianShuTianYiS": "Количество накопленных дней входа более {0} дней",
    "XuanPinNKuanHuoXunJiaNKuan": "Выберите {0} товаров или запросите более {1} товаров",
    "YiCaiXuanPinShuJuYinQingK": "Система данных ESSABUY позволяет просматривать тенденции выбора покупателей в вашей основной сфере деятельности и получать представление о возможностях рынка.",
    "WeiXinSaoYiSaoMianFeiJieS": "Сканируйте QR-код, чтобы бесплатно разблокировать последние цены на товары",
    "XianShiFuLiSaoMaLingDuJia": "Ограниченное по времени предложение, отсканируйте код, чтобы получить эксклюзивный список новых товаров",
    "MianFeiLingZhangShangPinG": "Бесплатно, получите 200 изображений товаров в высоком разрешении",
    "MianFeiJieSuoShangPinZuiX": "Бесплатно, разблокируйте последние цены на товары",
    "MianFeiLingZhangShangPinG2": "Бесплатно, получите 200 изображений товаров в высоком разрешении",
    "DangQianCunZaiWeiShenHeJiLuWuFaChongFuTianJiaJiLu": "В настоящее время существуют необработанные записи, нельзя добавлять дублирующиеся записи",
    "ZiChanHeXinYong": "Активы и кредит",
    "ShuBaiJiaZhiMingMaoYiGong": "Используется сотнями известных торговых компаний",
    "YaoZhaoShenMe": "Что вы ищете?",
    "QingJianDanShuoMingYaoZha": "Пожалуйста, кратко опишите, что вы ищете",
    "ZhiChiTuPianDanWenJianZui": "Поддерживает изображения, максимальный размер файла 10Мб, можно загрузить до 5 файлов",
    "GengXiangXiDeShangPinXinX": "Более подробная информация о продукте, такая как функции, цвета, материалы, указанные бренды, требования к упаковке и т.д.",
    "ZuiDi": "Самый низкий",
    "ZuiGao": "Самый высокий",
    "ZhaoYangFaBuHouTianJieZhi": "Образец будет закрыт через {0} дней после публикации, и вы можете получить ответ от завода через 30 минут.",
    "LeJieXinYongTiXi": "Понимание кредитной системы ESSA",
    "XinYongFenShu": "Кредитный балл",
    "XinYongTiXiShuoMing": "Описание кредитной системы",
    "ZuiJinMeiYouBianDong": "Без последних изменений",
    "ZuiJinBianDong": "Последние изменения",
    "ZhangQiTianShu": "Дни расчетного периода",
    "ZhangQiLiXiJiSuanFangShi": "Метод расчета процентов",
    "ZhangQiJiSuanBiaoZhun": "Критерии расчета за отчетный период",
    "OAEDu": "Лимит ОА",
    "ShenQingOA": "Подать заявку на ОА",
    "XinYongDaDaoFenKeShenQing": "Кредитная оценка {0} может быть применена",
    "YiManZu": "Выполнено",
    "ChaKanOAXiangQing": "Просмотреть сведения об ОА",
    "ShenQingTiShengEDu": "Подать заявку на увеличение кредитного лимита",
    "NTianNeiBuShiYongXuZhongXi": "Подайте повторную заявку, если кредит не использован в течение { 0 } дней.",
    "ZhuGuanShenHeZhong": "Руководитель проверяет",
    "CaiWuShenHeZhong": "Финансовый аудит в процессе",
    "ZhuGuanShenHeBuTongGuo": "Аудиторская проверка не пройдена",
    "CaiWuShenHeBuTongGuo": "Финансовый аудит не прошел",
    "WeiKaiTongESSAONE": "Открытые привилегии в ESSAONE",
    "XinYongFen": "Кредитный балл",
    "XinYongFenMingXi": "Информация о кредитном скоре",
    "XunJiaXinXi": "Информация о запросе",
    "ShiYongYouHui": "Воспользоваться предложением",
    "RenZhengHouCaoZuo": "Операция после аутентификации",
    "WeiJiHuo": "Не активирована",
    "JiHuo": "Активировано",
    "ShiFouQueRenJiHuo": "Подтвердить активацию или нет",
    "FeiKeHuBuNengBangDing": "Клиенты, не являющиеся членами ESSAONE, не могут привязать",
    "JiangChanShengPeiChangBin": "Компенсация будет понесена и кредитная оценка будет вычтена {0}",
    "TiXing": "Напоминание",
    "YiXiaQingKuangQuXiaoShang": "Компенсация будет взиматься за отмену в следующих случаях",
    "WuXuPeiChang": "К счастью, компенсация за эту отмену не предусмотрена, так как продукт не был произведен.",
    "DangQianXuPeiChangHeJi": "В настоящее время необходимо компенсировать {0}%, всего {1}",
    "JiangChanShengYiZhangFeiY": "Будет сгенерирована квитанция для начисления соответствующего сбора, пожалуйста, обратите внимание на своевременное взыскание.",
    "QuXiaoXiangShuBuNengQuanB": "Количество полей отмены не может быть равно 0.",
    "FanKuiXiaoLv": "Эффективность проблемы обратной связи",
    "ShenHeZhongBuNengXiuGaiFu": "Информация о транзакции была изменена, ожидает аудита (тариф обслуживания и метод депозита не могут быть изменены во время аудита).",
    "XiuGaiJiaoYiXinXiShenHeBu": "Изменение информации о транзакции, аудит не прошел",
    "ShenQingOA2": "Подать заявку на OA",
    "ChaKanFeiYongDan": "Просмотр квитанции об оплате",
    "MoRenJieSuanFangShi": "Метод выставления счетов по умолчанию",
    "FuWuFeiLvZhiWei": "Значение ставки обслуживания составляет 3~15",
    "DangQianXuPeiChangHeJi2": "Требуется компенсация {0}%, итого {1}",
    "QueDingQuXiaoShangPin": "Определите отмену продукта",
    "ZhangQiFeiYongJiSuanFangS": "Метод расчета платы за выставление счета",
    "XinYongNFenYiDaBiaoKeShenQ": "Кредитная оценка {0} достигнута, вы можете подать заявку на OA settlement.",
    "XinYongNFen": "Начислите {0} баллов",
    "DengDaiShenHeZhong": "Ожидает рассмотрения",
    "ShangCiShenQingBuTongGuo": "Последняя заявка не прошла",
    "QueDingBuZaiTiShi": "Да, я уверен, что не требуется больше уведомлений.",
    "ZhuangGuiWanChengHouQuXiaoTongKuanShangPinZhiNengCaoZuoYiCi": "Аннулирование одного и того же продукта после загрузки допускается один раз.",
    "HuoKuanYiHeXiaoBuNengQuXiaoShangPin": "Вы не можете аннулировать продукт после списания платежа",
    "ESSAONEWangZhanJieShaoH1": "ОПТОВЫЙ КИТАЙСКИЙ МАРКЕТПЛЕЙС<br />от 1-го короба напрямую с фабрик «под ключ»",
    "ESSAONEWangZhanJieShao2": "Новый опыт закупок из Китая для малого и среднего бизнеса !",
    "ESSAONEWangZhanJieShao1": "Как это работает",
    "ESSAONEWangZhanJieShao3": "Готовое решение для мелкооптовых закупок",
    "ESSAONEWangZhanJieShao4": "Цена с доставкой \"под ключ\"",
    "ESSAONEWangZhanJieShao5": "Надежные гарантии сервиса",
    "ESSAONEWangZhanJieShao6": "Множество сервисов в одном месте",
    "ESSAONEWangZhanJieShao7": "Процесс работы с ESSAONE",
    "ESSAONEWangZhanJieShao8": "Информация о событиях и отзывы клиентов",
    "QingGouXuanXuYaoBuHuoDeSh": "Отметьте товары, которые необходимо пополнить",
    "ShenQingHeZuoFangShi": "Заявление на сотрудничество с ОА",
    "ZhuGuanShenHe": "Обзор руководителя",
    "CaiWuShenHe": "Финансовый аудит",
    "KeHuZhuCeHao": "Регистрационный номер клиента",
    "KeHuGongSiMingCheng": "Название компании клиента",
    "KeHuGongSiDiZhi": "Адрес компании клиента",
    "ShenQingEDu": "Сумма заявки",
    "ZhangQiFeiLv": "Ставка за расчетный период",
    "ShenQingZhangQi": "Заявка Расчетный период",
    "DaiShenHeShenQing": "Ожидается проверка заявки в ОА-системе",
    "GongChangJieDanHouQuXiaoS": "Если фабрика аннулирует товар после получения заказа, потребуется определенная процентная компенсация, и за каждое списание будет вычтено 1 кредитное очко, а кредитное очко будет восстановлено после выплаты клиентом компенсации.",
    "GongChangYiJieDanHuoWuZhe": "Если завод уже подтвердил заказ, и товар находится в процессе производства, то отмена заказа требует компенсации в размере 10% от общей суммы товара в заказе.",
    "HuoWuShengChanWanBiShiQuX": "При аннулировании заказа, когда товар закончен производством, выплачивается 30% от общей суммы товара в заказе.",
    "HuoWuYiRuKuDengDaiZhuangJ": "При отмене заказа, когда товар поступил на склад и ожидает погрузки, выплачивается 50% от общей суммы товара в заказе.",
    "HuoWuZhuangJuWanChengHouQ": "Если товар отменен после погрузки, выплачивается 100% от общей суммы заказа.",
    "ChengShiDeBiaoZhi": "Честный знак",
    "GuoJiaTiXi": "Национальная система",
    "ShuZiBiaoJi": "цифровой маркировки",
    "ShiELuoSiShiChangShangZui": "Маяк——самая популярная и самая доступная платформа развития бизнеса на маркетплейсах в России.",
    "MianFeiKuoZhanGongNeng": "Бесплатные возможности расширения",
    "YiZhongJianDanDeFangFaKeY": "Простой способ быстро проанализировать данные по объемам продаж, количеству заказов, изменению цен + мониторинг остатков в реальном времени в разрезе складов, процент выкупа товаров по категориям, возможность следить за рекламным аукционом и рекламными ставками конкурентов.",
    "FuFeiJiHuaTiGongEWaiDeGon": "В платных тарифах доступны дополнительные инструменты для увеличения прибыли.",
    "DuiYuNeiXieZhengZaiXunZha": "Для тех, кто ищет нишу",
    "QianFenWeiNaXieLeiBieZaiL": "<li>В каких категориях есть деньги?</li>             <li>Насколько в нише легко запустить новый товар?</li>             <li>В каких категориях спрос превышает предложение?</li>             <li>Топ-1000 успешных товаров на ВБ</li>             <li>В каких категориях поставщики не справляются?</li>",
    "DuiYuNeiXieYiJingYuShiCha": "Для тех, кто уже работает с маркетплейсами",
    "JiangChanPinTuiXiangDingF": "<li>Выводите товары в Топ</li>             <li>Автоматизируйте расчёт поставок</li>             <li>Внутренняя и внешняя аналитика</li>             <li>SEO - оптимизация</li>             <li>Мониторинг позиций</li>             <li>Управления рекламным кабинетом и рекламными ставками</li>             <li>Возможность интеграции с 1С</li>             <li>Данные внешней аналитики с 2020</li>",
    "RenZhengHouKeXuanPinHeHuo": "Вы можете выбрать продукцию и получить информацию о фабрике после аутентификации",
    "DengLuRenZhengHouKeChaKan": "Вход для просмотра контактной информации после аутентификации",
    "SouSuoKeHuMingChengBianHa": "Поиск имени клиента/клиентского номера/телефона",
    "QuanBuXinKeHu": "Все новые клиенты",
    "WeiYongHuTiGongDeLiWuTian": "Для пользователей подарок- 3 дня доступа к тестовому тарифу Маяка по ссылке:",
    "QingXuanZeZhangQiTianShu": "Пожалуйста, выберите количество дней расчетного периода",
    "QingShuRuKeHuZhuCeHao": "Пожалуйста, введите регистрационный номер клиента",
    "QingShuRuGongSiMingCheng": "Пожалуйста, введите название вашей компании",
    "QingShuRuKeHuGongSiDiZhi": "Пожалуйста, введите адрес компании клиента",
    "QingShuRuShenQingEDu": "Введите сумму заявки",
    "QingXuanZeZhangQiLiXiJiSu": "Пожалуйста, выберите метод начисления процентов за расчетный период",
    "QingXuanZeZhangQiJiSuanBi": "Пожалуйста, выберите стандарт расчета расчетного периода",
    "QingShuRuZhengQueDeShenQi": "Пожалуйста, введите правильную сумму для применения, (0.01-100000000000) с сохранением до двух знаков после запятой!",
    "XinYongFenJiangGenJuDingD": "Кредитный балл будет меняться в зависимости от выполнения заказа.",
    "ShiYongJieSuanShiZaiHuoWu": "При использовании DP/TT-расчетов: 1 балл будет добавлен к кредитному баллу, если оплата произведена до прибытия товара и заблаговременно. Если оплата не производится более 7 дней после прибытия товара или наступления срока платежа (в зависимости от того, что наступит позже), будет снят 1 балл.",
    "ShiYongJieSuanShiZaiZhang": "При использовании OA-расчета: 1 балл будет добавлен к кредитному баллу за досрочную оплату товара до наступления расчетного периода. Если оплата не произведена по истечении 7 дней расчетного периода, будет снят 1 балл.",
    "ShangShuLiangZhongJieSuan": "При обоих вышеуказанных способах расчетов отмена заказа/товаров после того, как фабрика приняла заказ, временно вычитается 1 балл до выплаты компенсации.",
    "XinYongFenJiangGenJuDing": "Кредитная оценка будет изменяться в зависимости от выполнения заказа, начальная оценка составляет 90 баллов.",
    "JiaFenZaiHuoWuDaoGangQian": "Плюсы:1 балл будет добавлен к кредитному баллу, если оплата будет произведена до прибытия товара и заранее.",
    "JianFenRuoZaiHuoWuDaoGang": "Минусы:1. если оплата не произведена более 7 дней после прибытия товара или в установленный срок (в зависимости от того, что наступит позже), будет снят 1 балл; 2. отмена заказа/товара фабрикой после принятия заказа приведет к временному снятию 1 балла до выплаты компенсации.",
    "HeZuoHanYiWoSiXianJiangHu": "Смысл сотрудничества OA: Наша компания сначала отправит товар покупателю, а клиент должен оплатить его в течение оговоренного периода времени после получения товара, при этом клиент имеет максимальную сумму ограничения «кредита», а сумма, на которую может претендовать каждый клиент, будет оцениваться в соответствии с его/ее собственной стоимостью риска.",
    "ShenQingTiaoJianDangKeHuY": "Условия подачи заявки: Когда кредитный рейтинг клиента составляет {0} баллов или выше, он может подать заявку на сотрудничество по условиям OA. После подачи заявки клиенту необходимо поддерживать кредитный рейтинг на уровне {1} баллов или выше, чтобы продолжать пользоваться условиями OA-счета.",
    "ZhangQiFenWeiTianTianTian": "Условия оплаты OA: делятся на {0}. Разные сроки оплаты сопровождаются разными процентными ставками: {1}.",
    "XinYongTiXiYongYuDingQiPi": "Кредитная система ESSACHINA используется для регулярной оценки и обновления кредитоспособности клиента, оценки риска сотрудничества клиента с OA, а также для подачи заявки на аудит периода и суммы выставления счетов OA.",
    "DangKeHuYiChengGongWanChe": "Когда кредитный рейтинг клиента составляет {0} баллов или выше, он может подать заявку на сотрудничество по условиям OA. После подачи заявки клиенту необходимо поддерживать кредитный рейтинг на уровне {1} баллов или выше, чтобы продолжать пользоваться условиями OA-счета.",
    "XinYongFenJiaJianGuiZeRuX": "Правила добавления и вычитания кредитного балла следующие：",
    "KeHuShiYongJieSuanZaiHuoW": "Если клиент осуществляет расчет по DP/TT и оплатит товар до прибытия груза в порт, то его кредитный балл увеличивается на 1 балл. Если оплата не будет произведена в течение 7 дней после даты прибытия груза в порт или даты оплаты (в зависимости от того, какая дата наступает позднее), то будет вычтено 1 балл.",
    "KeHuYiShiYongJieSuanZaiZh": "Клиентам, воспользовавшимся услугой OA settlement и оплатившим товар заранее до наступления расчетного периода, будет добавлен 1 балл к кредитной истории. Если оплата не будет произведена по истечении 7 дней расчетного периода, будет снят 1 балл.",
    "CiWaiZaiShangShuLiangZhon": "Кроме того, при обоих вышеуказанных способах расчетов, отмена заказа/товаров после того, как фабрика приняла заказ, временно вычитается 1 балл до тех пор, пока клиент не выплатит компенсацию.",
    "XinKeHu": "Зарегистрированный клиент",
    "ZuiJinFangWen": "в последнее время спрашивал",
    "JieDuan": "Период",
    "DaiChuBuLianXi": "Первый контакт",
    "BaoChiDuiHua": "Продолжать диалог",
    "ChengJiaoShiXian": "Депозит оплачен",
    "ChengJiaoWeiShiXian": "Cделка не состоялась",
    "PiFuEDu": "Утвержденная сумма",
    "PiFuZhangQiTianShu": "Количество дней для утверждения",
    "1059PR10001": "ошибка параметров",
    "QingXuanZeKeHuJieDuan": "пожалуйста, выберите период взаимодействия с клиентом",
    "XiaZaiDuiZhangDan": "Скачать выписку",
    "YongYuDingDanChuHuoDeDing": "Гарантия депозита для отправки заказа",
    "CaiWuShenHeTongGuo": "Одобрено финансовым отделом",
    "ZhuGuanShenHeTongGuoDengD": "Одобрено руководителем, ожидается финансовый аудит",
    "JiangChanShengYiZhangFeiYyicaiguoji": "Будет выставлен счет, и вам необходимо оплатить соответствующие расходы, пожалуйста, будьте внимательны и своевременно обращайтесь к менеджеру по работе с клиентами для оплаты.",
    "GenJinKeHu": "сближение с клиентом",
    "GongChangJieDanHouQuXiaoSyicaiguoji": "Если фабрика отменяет товар после получения заказа, требуется определенный процент компенсации, и за каждый расход будет вычтено 1 кредитное очко, а вычтенное кредитное очко будет восстановлено после выплаты компенсации.",
    "DianJiChaKan": "Нажмите для просмотра",
    "GenJuQuXiaoShangPinPeiChangGuiZeKeHuXuZhiFuPeiChangKuan": "{0} Товар {1} Компенсация должна быть выплачена в соответствии с правилами компенсации за аннулирование товара",
    "BenCiGenJinNeiRong": "содержание коммуникации с клиентом в этот раз",
    "AnGongSiFeiYongDanZhiDuGu": "В соответствии с требованиями к управлению системой расходных ордеров компании, расходные ордера позже времени загрузки не могут быть инициированы.",
    "ShenQingBuTongGuo": "Заявка не утверждена",
    "ZhengZaiDengDaiShenHe": "В ожидании обзора",
    "FeiMuBiaoKeHu": "нецелевые клиенты",
    "QingXuanZeShenHeYiJian": "Пожалуйста, выберите аудиторское заключение",
    "QingTianXieGongChangZhang": "Пожалуйста, заполните период счета завода",
    "AnZhuCeShiJian": "в соответствии с временем регистрации",
    "AnFangWenShiJian": "в соответствии с временем консультации",
    "AnJiaGouShiJian": "в соответствии с временем добавления товаров в корзину",
    "AnGenJinShiJian": "в соответствии со временем сближения",
    "QingShuRuZhengQueDeGongCh": "Пожалуйста, введите правильный период заводского счета",
    "KeHuXinXiWanShan": "дополнить информацию о клиенте",
    "KeHuRenZheng": "клиент подтвержден",
    "KeHuFuHeYiXiaTiaoJianHuiZ": "клиент, удовлетворяющий условиям ниже, автоматически становится целевым клиентом",
    "ShiFouShiFaRenQiYeHtml": "<ul><li>обязательно является юридическим лицом；</li><li>мы работаем с данной категорией</li><li>заказ от одного короба</li></ul>",
    "ShenQingTiShengEDuZhong": "Запрос на увеличение кредитного лимита",
    "QuXiaoDanHao": "Отменить номер заказа",
    "KeHuGenJinJieDuan": "Период сближения с клиентом",
    "BaoChiLianXi": "продолжать диалог",
    "ZhuanDaoXiaYiJieDuanJianGNTian": "до перемещения в следующий период : {0} дней",
    "HaiShengNTianXuYaoDaChengC": "осталось еще {0} дней, надо завершить заказ",
    "CongZhuCeDaoShouDanChengJ": "от регистрации до совершения первого заказа прошло {0} дней",
    "BuZaiGenJin": "не связываться больше",
    "ZanWeiQueRen": "еще не подтверждено",
    "MuBiaoYongHu2": "целевой клиент",
    "EDu": "Лимит",
    "ShiFouFaRenQiYe": "является ли юридическим лицом?",
    "ShiFouXiangQiDing": "Количество заказанных товаров >= 1 короб?",
    "SouSuoKeHuBianMaMingZiYou": "Поиск кода/имени/электронной почты клиента",
    "DingDanZhongShangPinYiQua": "Все товары в заказе были отменены, и залог не может быть внесен повторно.",
    "WoFangQiGaiKeHu": "Я заканчиваю работу с данным клиентом",
    "ShiYongShiJian": "Время использования",
    "ShiYongEDu": "Используемая сумма",
    "YiLaiKuan": "Входящий платеж",
    "OAMingXi": "Детали ОА",
    "ShenQingTiShengOAEDu": "Заявка на увеличение лимита ОА",
    "YiChengJiaoKeHu": "клиент, который уже сделал заказ",
    "ChengZhangKeHu": "Постоянные клиенты",
    "LiuCunKeHu": "Сохраненный клиент",
    "YuLiuShiKeHu": "Клиент скоро будет утерян",
    "ZuiJinXiaDan": "В ближайшее время сделает заказ",
    "KeHuNTianHouLiuShiQingGenJ": "Клиент не был на связи {0} дней. Пожалуйста, свяжитесь с клиентом для завершения заказа.",
    "ZaiYingShouZhangKuanDaoQi": "Проценты не начисляются в течение 5 дней после даты погашения дебиторской задолженности, после 5 дней проценты будут начисляться с даты погашения дебиторской задолженности, Ежедневный процентный сбор за просрочку = Неоплаченная сумма * {0}%.",
    "YuQiHouMeiTianAnJiSuanLiX": "После просрочки, проценты будут начисляться по ставке {0}‰ в день.",
    "KeHuDeXinYongFenBuZuBuNen": "Клиенты, чей кредитный рейтинг менее {0}, не могут использовать метод урегулирования OA, этот заказ будет урегулирован DP(T/T).",
    "JiXuDPJieSuan": "Продолжайте расчет по методу DP",
    "YiQianHeTong": "Уже подписан контракт",
    "QueRenBuZaiGenJin": "подтверждаете, что не нужно больше связываться?",
    "QueRenFangQiGaiKeHu": "подтверждаете отказ от работы с данным клиентом?",
    "BangDingChengGong2": "успешно внесено в систему",
    "ZhangQiLiXiFei": "Проценты за расчетный период",
    "LiXiJiangJunTanDaoShangPi": "Проценты будут распределены поровну на цену единицы товара и взиматься по всей сумме заказа. Если для заказа требуется уплата аванса, то размер процентных платежей равен (общая сумма заказа - аванс) х соответствующая процентная ставка по срок кредитования; если заказ не требует уплаты аванса, то размер процентных платежей равен общей сумме заказа х соответствующая процентная ставка по срок кредитования.",
    "OAZhangQi": "Расчетный период OA",
    "XiuGaiYuYanXuYaoZhongQiCa": "Измененная формулировка вступит в силу только после перезапуска APP",
    "WeiJiaGou": "Покупка не добавляется",
    "ShiFouYaoQieHuanDaoNYuYan": "Следует ли мне перейти на язык {0}?",
    "YuYanJiaGeSheZhi": "Настройка языка и цен",
    "XuanZeQuYu": "Выберите регион",
    "WoDePODan": "Мои заказы",
    "XiaoShouJiaSheZhi": "Установить цену продажи",
    "XiaoShouJiaJiSuanFangShi": "Расчет продажной цены",
    "XianShiBiZhong": "Показать валюту",
    "XiaoShouJia": "Цена продажи",
    "XianShi": "Показать",
    "BuXianShi": "Не показывать",
    "SheZhiXiaoShouJia": "Установить цену продажи",
    "XiuGaiXianShiBiZhong": "Изменить валюту отображения",
    "JiangTongBuXiuGaiNinDeXia": "Информация о стране продажи будет изменена одновременно",
    "PingJiaDingDanFuWu": "оценить сервис заказа",
    "XingQiYi": "Понедельник",
    "XingQiEr": "Вторник",
    "XingQiSan": "Среда",
    "XingQiSi": "Четверг",
    "XingQiWu": "Пятница",
    "XingQiLiu": "Суббота",
    "XingQiRi": "Воскресенье",
    "YiChenShuiNTian": "не выходил на связь {0} дней",
    "YiLiuShiNTian": "Утерянный клиент {0} дней",
    "NiXiuGaiDeXinXiShangWeiBa": "Измененная вами информация не была сохранена, если вы выйдете, изменение не вступит в силу. Вы хотите уйти?",
    "ShengChanZhong": "Незавершенное производство",
    "ZhuangJu": "Загрузка контейнера",
    "DaiPingJia": "Ожидает оценки",
    "FuZeNaXieKeHu": "Отвечает за каких клиентов",
    "SouSuoRenWu": "Поисковая задача",
    "ShouCiZhuCePingTai": "Впервые зарегистрированный на площадке",
    "ShiXiangDaiBan": "Задача к выполнению",
    "TiHuoTiXing": "Напоминание - забрать товар",
    "DaiChuLiSuoPei": "Ожидание возмещения",
    "XinKeManYiDuDiaoCha": "Исследование удовлетворенности новых клиентов",
    "YuLiuShiYongHuManYiDuDiao": "Исследование удовлетворенности клиента, который вот-вот будет утерян",
    "GenJinTiXing": "Напоминание о сближении",
    "DaiChuBuLianXiKeHu": "Первый контакт",
    "KeHuXuanPin": "Товар в корзине",
    "ZhuanHuaLvKanBan": "Модуль \"Конверсия\"",
    "ZhiYouLuoZaiShiJianFanWei": "В статистике могут быть учтены только те данные, которые входят во временной интервал",
    "QuanBuZhuCeQuDao": "Все каналы, через которые приходят регистрации",
    "QuanBuGenJinRen": "Все клиенты, с которыми уже произошло сближение",
    "ShangYue": "Прошлый месяц",
    "XiaDan2": "1-ый заказ",
    "DaiGenJinShiXiang": "Ожидание выполнения задачи",
    "ZhuanHuaLvN": "Конверсия {0}%,",
    "HuoWuZhuiZongChaXun": "Запрос отслеживания груза",
    "QuChaXun2": "Перейти к запросу",
    "ChaKanYuanYin": "Посмотреть причину",
    "ZongJinE": "Общая сумма",
    "YiLianXiGuo": "Уже проинформировали",
    "ZhuCeKeHuDaiBanTiXing": "Зарегистрированный клиент- напоминание о задаче",
    "YiChengJiaoKeHuDaiBanTiXi": "Клиент уже оплатил депозит - напоминание о задаче",
    "TiHuo": "Забрать товары",
    "YiLianXiGuo2": "Уже связывались",
    "ZanWuGenJinNeiRongBeiWang": "Не заполнено никакой информации о клиенте",
    "NYiGuoQiNTian": "{0} Задача не выполнена уже {1} дней",
    "MingTian": "Завтра",
    "ChuanWuYiChangChuLi": "Обработка исключений в доставке",
    "TiJiaoShiJian": "Время подачи",
    "ZiDingYiShengChanYaoQiu": "Индивидуальные требования к производству",
    "ZiDingYiShengChanYaoQiuWaiWen": "Индивидуальные требования к производству",
    "NPCS": "{0} Шт",
    "NWaiXiang": "{0} Коробка",
    "ZhongYaoQingZaiTianNeiTiG": "[Важно] Пожалуйста, предоставьте наклейки в течение {0} дней.",
    "ChaoGuoTianTiGongTieZhiKe": "Предоставление наклеек после {0} дней может повлиять на график производства на фабрике и привести к задержке даты отгрузки. Пожалуйста, предоставьте информацию о наклейках как можно скорее.",
    "QueRenZanBuSheZhiTieZhiMa": "Вы уверены, что хотите продолжить без настройки наклеек?",
    "EssaoneQuanTaoChanPin": "Фулфилмент для маркетплейсов от ESSAONE",
    "WoMenZhengZaiQingTingKeHu": "Мы прислушиваемся к пожеланиям наших клиентов, именно поэтому мы рады сообщить, что ESSAONE запускает услугу фулфилмента. Мы принимаем заявки на получение услуги на почту",
    "NiZaiXunZhaoFuErFeiMenTe": "Это вы в поисках фулфилмента",
    "ZheiYeShiNiDeRuGuoNiBaTa": "Это тоже вы, если передали эту <br /> задачу профессионалам",
    "WoMenYouShenMeJianYi": "Что мы предлагаем?",
    "ZaiShiChangShangJiaoFuCha": "Комплексная подготовка товара к поставке на маркетплейсы Wildberries, Ozon",
    "BaoZhuang2": "Упаковка",
    "BiaoJi2": "Маркировка",
    "XiangHeCangKuJiaoFuDingDa": "Доставка заказов на склад Wildberries и Ozon",
    "WoMenDeYouShi": "Наши преимущества",
    "BuXuYaoZhiFuYunFei": "не нужно платить за доставку товара <br /> от склада до фулфилмента",
    "ShouHuoWuXuFuFei": "не нужно платить за приемку товара",
    "BuXuYaoZhiFuShangPinYanHu": "не нужно платить за визуальную <br /> проверку товара на брак",
    "WuXuZhiFuBaoZhuangHeHuoTu": "не нужно платить за формирование  <br /> короба или паллета",
    "WoMenGanXieWoMenDeKeHu": "Мы ценим наших клиентов!",
    "ZaiDingGouChanPinYongXinD": "Заказывайте товар на ESSAONE и развивайте ваш бизнес с новой услугой!",
    "YanShouHuoWu": "Приемка товара",
    "ShangPinBiaoJi": "Маркировка товара",
    "ChuCunHuoWu": "Хранение товара",
    "DingDanChuLi": "Обработка заказов",
    "HuiKuan2": "Оплата заказа",
    "JiaoHuo2": "Доставка",
    "DingDanBaoZhuang": "Упаковка заказов",
    "XieShang": "Консультация",
    "DeDaoBaoJia": "Получить предложение",
    "ESSAONEWanQuanMianFei": "Все это <span class=\"fw_700\">ESSAONE</span> сделает абсолютно бесплатно!",
    "TiDanHao": "BILL OF LADING NUMBER",
    "TiDanSaoMiaoJian": "BILL OF LADING COPY",
    "QingShuRuShenQingLiYou": "Пожалуйста, введите причину вашего запроса.",
    "TouBaoMaiFangDaiMa": "Код застрахованного покупателя",
    "ShangPinZhengZaiTiJiaoDingDan": "Товар обрабатывается для заказа. Пожалуйста, обновите данные позже и попробуйте снова.",
    "NNianChengJiao": "Продажи в {0} году",
    "ZhanShiHe": "Шоубокс",
    "FeiZhanShiHe": "Упаковка",
    "RuKuNTian": "Товар уже на складе {0} дней",
    "ManYiDuDiaoCha": "Исследование удовлетворенности",
    "ZuiJinJiaGou": "Последнее добавление в корзину",
    "QueRenYiLianXiGuo": "Подтвердить, что уже связались？",
    "MiMaGuiZe5": "Пожалуйста, введите 6-20 символов (латиница или цифры)",
    "ShangPinBianMaJiuBianMaHu": "Код товара, исходный код товара, номер товара",
    "NinWuQuanXianFangWenGaiYe": "У вас нет доступа к этой странице!",
    "ShouHuoQuYu": "Зона получения",
    "DaiBanTiShiDingJinCuiShou": "<p>Пожалуйста, свяжитесь с этим клиентом и напомните об оплате. Сделайте все возможное, чтобы кливремя оплатил депозит. <b>Иначе через 14 дней заказ будет автоматически отменен.</b></p><p>Регламент по напоминаниям:  </p><p>1. Первый раз: на третиент вой день после оформления заказа. </p><p>2. Второй раз: на седьмой день после оформления заказа. </p><p>3. Третий раз: на одиннадцатый день после оформления заказа.</p>",
    "RuKuNTian2": "Товар уже на складе {0} дней, осталось {1} дней бесплатного хранения.",
    "DaiBanTiShiTiHuoTiXing": "<p>Заказ уже полностью оплачен. Напомните этим клиентам, что надо вовремя забрать товар. <b>Подчеркните, что время бесплатного хранения на складе только 30 дней.  </b></p><p>Регламент по напоминаниям: </p><p>1. Первый раз: На второй день после поступления товара на склад.  </p><p>2. Второй раз: На пятнадцатый день после поступления товара на склад. </p><p>3. Третий раз: На 25-ый день после поступления товара на склад.</p>",
    "DaiBanTiShiWeiKuanCuiShou": "<p>Пожалуйста, свяжитесь с этим клиентом и напомните об оплате. Сделайте все возможное, чтобы клиент вовремя оплатил закрывающий платеж и вовремя забрал товар. <b>Бесплатное хранение на складе только 30 дней. </b></p><p>Регламент по напоминаниям:  </p><p>1. Первый раз: на второй день после поступления товара на склад. </p><p>2. Второй раз: на десятый день после поступления заказа на склад.  </p><p>3. Третий день: на двадцатый день после поступления товара на склад.</p>",
    "DaiBanTiShiTiDaiChuLiSuoPei": "<p><b>После того, как клиент подал заявку на рекламацию, ее нужно проверить в течение 15 дней. </b>В соответствии с регламентом по рекламациям сначала решите, нужно ли возмещение в данном случае и примите запрос клиента о возмещении или откажите ему. В особых случаях можно обсудить специальные условия  по рекламации.</p>",
    "DaiBanTiShiDaiChuBuLianXiKeHu": "<p><b>Вам нужно в течении 7 дней позвонить этим клиентам по телефону. </b>Записать содержание первой коммуникации.Заполнить информацию о клиенте. Определить, является ли целевым клиентом. </p>",
    "DaiBanTiShiKeHuXuanPin": "<p>К этим клиентам нужно отнестить внимательнее. <b>Постарайтесь определить, есть ли у клиента намерение сотрудничать. </b>Выясните потребность клиента и побудите его сделать заказ. </p>",
    "DaiBanTiShiXiaDan": "<p>На данном этапе нужно проверить, заключен ли договор с данным клиентом. <b>И проинформировать клиента о том, что нужно оплатить депозит в течении 14 дней.</b></p>",
    "DaiBanTiShiChengJiaoShiBai": "<p>Очень сожалеем, но эти заказы были отменены. <b>Вам нужно разобраться в причине и записать ее в системе. </b></p>",
    "HeJiDingJin": "Итоговый депозит",
    "HeJiWeiKuan": "общая сумма закрывающего платежа",
    "PingJunTingLiuS": "среднее время пребывания {0} день",
    "ZhuanHuaLvPingJunTingLiuS": "Конверсия {0}%,среднее время пребывания {1} день.",
    "RuKuNTian3": "Товар на складе {0} дней, превышено время бесплатного хранения на {1} дней.",
    "ShengChengKongPo": "Создать пустой заказ (PO).",
    "QueRenDingDanChuHuoXinXi": "Подтвердите детали отгрузки заказа!",
    "QueRenHouJiangShengChengY": "После подтверждения будет создан ожидающий консолидации заказ (PO) для планирования и отправки груза.",
    "QueRenShiFouYouWoSiChuanW": "Подтвердите, будет ли судоходный отдел ESSACHINA заниматься бронированием, таможенным оформлением и выпуском документов (для грузов, доставляемых в указанные места, бронирование не требуется).",
    "DiaoChaWenJuan": "Анкета",
    "QuanBuGongChang": "Все фабрики",
    "DengLuHouChaKanGengDuoJie": "Войдите, чтобы увидеть больше",
    "AnTuiJianPaiXu": "Сортировать по рекомендации",
    "AnShangShiShiJianPaiXu": "Сортировать по времени размещения",
    "DaiBanTiShiXinKeHu": "<p>Цель исследования: понять удовлетворенность новых клиентов первым заказом, своевременно выявить проблемы, улучшить обслуживание и избежать потери новых клиентов.И далее продвигайте 2-3-й заказы, которые должны быть достигнуты.</p> <p>Примерный скрипт: </p> <p>Добрый день, ХХХ! Я менеджер службы клиентов ESSAONE. Недавно Вы совершили ваш первый заказ, и мы хотели бы провести опрос об удовлетворенности первым заказом в ESSAONE. Не могли бы вы уделить несколько минут, чтобы ответить на пару  вопросов?  Ваше мнение поможет нам стать лучше. </p> <p>1) Клиент отвечает - ДА Начинайте отвечать на вопросы. </p> <p>2) Клиент отвечает - НЕТ, сейчас занят. Нужно спросить у клиента удобное время для следующего звонка. </p>",
    "DaiBanTiShiYuLiuShiDiaoYan": "<p>Цель исследования: понять причины потери пользователей на платформе, улучшить и решить проблемы, существующие на платформе, избежать последующей потери клиентов.</p> <p>Примерный скрипт: </p> <p>Добрый день, ХХХ! Я сотрудник службы поддержки клиентов площадки ESSAONE. Хотела бы задать вам пару вопросов по удовлетворенности нашей площадкой, не могли бы вы уделить мне несколько минут? Ваше мнение поможет ESSAONE стать лучше. </p> <p>1) Клиент отвечает - ДА Начинаете задавать вопросы. </p> <p>2) Клиент отвечает - НЕТ, сейчас занят. Нужно спросить у клиента удобное время для следующего звонка.</p>",
    "DiYiGeDingDanShiJian": "время первого заказа",
    "DengLuHouChaKanGouWuCheSh": "Войдите, чтобы просмотреть товары в корзине",
    "KeHuDiaoYanJieGuo": "Результат опроса клиента",
    "WenJuanDiaoChaJieGuo": "Результат исследования",
    "XinKeHu2": "Новые клиенты",
    "QingXuanZeWenJuan": "Пожалуйста, выберите анкету",
    "DiaoYanHuoDong": "Исследование",
    "DiYiGeDingDan": "Первый заказ",
    "WenJuanTianXieShiJian": "Время заполнения анкеты",
    "TianXieRen": "Регистрант",
    "ZunJingDeHuoBan": "<div><b>Уважаемый клиент</b>：</div><br /> <div>Благодарим Вас за выбор ESSAONE！Для улучшения и подъема эффективности нашей работы просим Вас объективно ответить на ряд вопросов об опыте закупки на площадке ESSAONE. Мы также будем благодарны вашим рекомендациям по улучшению сервиса. Ваши предложения позволят ESSAONE становиться лучше с каждым днем. </div><br /> <div> Благодарим Вас за поддержку и сотрудничество! </div>",
    "TuiChuBianJi": "Выйти из редактора",
    "LiuLanShangPinJiaRuGouWuC": "Просматривать товары, добавлять в корзину",
    "QieHuanXiaoShouJingLi": "Сменить менеджера по продажам",
    "TianJiaYiWei": "Добавить одного",
    "QieHuanShiBai": "Ошибка при переключении",
    "ShangPinYouYiChangXuYaoNi": "Продукт имеет проблему, вам нужно с этим разобраться. Вы можете принять его или снова договориться о цене.",
    "YuanLaiJiaGe": "Исходная цена",
    "XianJiaGe": "Текущая цена",
    "QueDingJieShouGaiShangPin": "Подтвердить принятие этого продукта?",
    "QingShuRuQiWangJiaGe": "Пожалуйста, введите ожидаемую цену",
    "JiXuZiXunYiJia": "Продолжить консультацию и переговоры",
    "GongChangQueRenShengChanY": "Завод подтверждает требования к производству",
    "YiQueRenKeXiaDan2": "Подтверждено, можно делать заказ",
    "ShiFangJiKeShuaXin": "Освободите для обновления...",
    "ShangPinYiGuoJiaGeBaoHuQi": "Продукт вышел из срока действия защиты цены",
    "WenJuanYiJingTianXieGuo": "Анкету уже заполнял",
    "DiaoChaWenJuanTiJiaoCheng": "Анкета отправлена, спасибо за участие!",
    "DingDanZhengZaiGenJinChuL": "Заказ обрабатывается, пожалуйста, свяжитесь с вашим менеджером по продажам для дальнейших действий.",
    "ZuiJinQueRenShiJian": "Время размещения последнего заказа",
    "ShouDanRuKuShiJian": "Время поступления первого заказа на склад",
    "ShouDanChuKuShiJian": "Время отгрузки первого заказа со склада",
    "WenJuanDiaoChaJieGuoXiang": "<div><i class=\"popRoundNum\">1</i> подтвердить время 1-ого заказа</div> <div><i class=\"popRoundNum\">2</i> время поступления 1-ого заказа на склад</div> <div><i class=\"popRoundNum\">3</i>время отгрузки 1-ого заказа со склада</div>",
    "QingQianWangDuanTiJiaoDin": "Пожалуйста, отправьте заказ через ПК",
    "ZuiJinXiaDanRiQi": "Время размещения последнего заказа",
    "YiSheZhiYaoQiu": "Требования на месте",
    "WeiRenZheng": "Не проверено",
    "ShouJiYanZhengMa": "Код мобильной верификации",
    "DanDuTie": "Товар имеет индивидуальный стикер",
    "ZhengShuLeiXing": "Тип сертификата",
    "ShouZiMu": "Первая буква",
    "ZuiShaoQiDingLiang": "Минимальный заказ",
    "YouShiPin": "Видео",
    "XiaoShouJingLiXiangQing": "Подробности о менеджере по продажам",
    "CiBaoJiaZaiQianYouXiao": "Этот запрос действителен до {0}",
    "ZhuTu": "баннер",
    "DengLuQieRenZhengHouXianS": "Цены отображаются после входа и аутентификации",
    "QuanBuXinXi": "Вся информация",
    "BaoZhuangFenLei": "Категория упаковки",
    "NiXuYaoXianXuanZeYiGeKeHu": "Вам нужно сначала выбрать менеджера по работе с клиентами",
    "ZaiAnYiCiFanHuiTuiChuYing": "Нажмите снова, чтобы выйти из приложения",
    "ZuiJinYiGeDingDan": "Последний заказ",
    "WenJuanDiaoChaJieGuoXiang2": "<div><i class=\"popRoundNum\">1</i> Время размещения последнего заказа</div><div><i class=\"popRoundNum\">2</i> Последняя выгрузка со склада</div> <div><i class=\"popRoundNum\">3</i>Последняя выгрузка со склада</div>",
    "ShouDanQueRenShiJian": "Время первого заказа",
    "ZuiJinRuKuShiJian": "Время последнего поступления на склад",
    "ZuiJinChuKuShiJian": "Последняя выгрузка со склада",
    "ShangYiCiShiYong": "Последнее использование",
    "FaWangNaGeChengShi": "В какой город отправляется?",
    "ShouHuoDianCangKu": "Пункт доставки (склад)",
    "ShanChuDiZhi": "Удалить адрес",
    "ShiFouShanChuDiZhi": "Вы уверены, что хотите удалить адрес?",
    "QingShuRuLianXiRenXingMin": "Пожалуйста, введите имя контакта",
    "FaYunLianXiRen": "Контактное лицо для отправки",
    "QingShuRuFaYunLianXiRen": "Пожалуйста, введите контактное лицо для отправки",
    "FaYunLianXiRenDianHua": "Номер телефона контактного лица",
    "QingShuRuFaYunLianXiRenDi": "Введите номер телефона контактного лица, ответственного за доставку",
    "KeHuBianHaoWuLiuGongSi": "Номер клиента (логистическая компания)",
    "DingDanFeiYong": "Стоимость заказа",
    "YingFu": "К оплате",
    "XuanZeShouHuoRen": "Выберите получателя",
    "WuLiuKeHuBianHao": "Логистика/Номер клиента",
    "SouSuoDingDan": "Поиск заказов",
    "DuanGongNengKaiFaZhongQin": "Функционал для ПК находится в разработке. Пожалуйста, размещайте заказы через приложение ESSACHINA.",
    "HuoHao2": "Товары готовы",
    "YouDingDanYiShengChanWanB": "Некоторые заказы завершены и могут быть отправлены",
    "ChuHuoAnPai": "Организация доставки",
    "DangQianYouYiChangDingDan": "Есть текущие заказы с проблемами, которые нужно срочно обработать",
    "XiaoXi": "Сообщение",
    "WenXinTiShiZaiXiaDanEDuFa": "Напоминание: в пределах лимита заказа отгрузка будет распределена в зависимости от хода производства",
    "TiJiaoDingDanChengGong": "Заказ успешно отправлен",
    "PingTaiYiAnZhaoChuHuoShiJ": "Платформа разделила заказы в зависимости от времени отгрузки",
    "GuanZhuBingShenQing": "подписаться и подать заявление",
    "CaiZhi2": "Материал",
    "DingDanYiChang": "Исключение из заказа",
    "XianHuoQi": "Последняя дата доставки",
    "XianMOQ": "Последний минимальный объем заказа",
    "YiXiaShangPinYouYiChangXu": "Следующие товары имеют проблемы, которые необходимо обработать срочно",
    "ShangPinQuXiao": "Товар отменен",
    "ChaKanZiJinZhangHu": "Просмотреть финансовый счёт",
    "YouDingDanYiChuHuoQingJin": "Заказы были отгружены; пожалуйста, организуйте оплату как можно скорее.",
    "ZiJinZongLan": "Обзор финансов",
    "ZongEDu": "Общий лимит",
    "YiShiYongEDu": "Использованный лимит",
    "HaiKeChuHuo": "Остаток отгрузочного лимита",
    "NiDeEDuYiBuZuChuHuo": "Вашего лимита недостаточно для отгрузки.",
    "ChaKanFuKuanXinXi": "Просмотреть платёжную информацию",
    "HuoHaoDingDan": "Заказа на отгрузку",
    "LaiKuanHouShiFangDuiYingC": "Освобождение соответствующего объёма отгрузки после получения оплаты.",
    "YinXingZhangHao": "Банковский счёт",
    "ZhiFuBaoZhiFu": "Оплата через Alipay",
    "WeiXinZhiFuTianJiaHaoYou": "WeChat Pay (Добавить в WeChat)",
    "XiaLaJiKeShuaXin": "Потяните вниз, чтобы обновить...",
    "DanCiHuoQuDeFuKuanXinXiJi": "Полученная информация о платеже действительна только {0} дней.",
    "KeHuZhaoYang": "Запросом на поиск товара",
    "YiGuiHai": "Возвращено",
    "HaiQian": "Остаток задолженности",
    "PaiZhaoSouTu": "Поиск изображения по фото",
    "ShangPinQuXiaoHuoDiaoChu": "Товар отменён или перемещён",
    "QuanBuNShangPin": "Все {0} товара",
    "XinYuJiChuHuoShiJian": "Новый предполагаемый срок отгрузки",
    "YuanYuJiChuHuoShiJian": "Оригинальное предполагаемое время отгрузки",
    "ChuHuoShiJian2": "Время отгрузки",
    "ShaiXuanYiChangDingDan": "Фильтровать аномальные заказы",
    "ZhongXinFaSongQueRenYouJi": "Повторно отправить письмо для подтверждения",
    "DengDaiZhuZhangHaoQueRen": "Ожидает подтверждения основного аккаунта",
    "XiaoShouJingLi": "Менеджер по работе с клиентами",
    "ZiChanXinYong": "Активы и кредит",
    "ZhaoYangGuanLiGuoWai": "Управление \"Запросом на поиск товара\"",
    "ZhaoYangGuanLiGuoNei": "Управление \"Запросом на поиск товара\"",
    "GuanYuAPP": "О приложении",
    "FuWuTiaoKuan": "Условия обслуживания",
    "YingYongQuanXianShuoMing": "Описание разрешений приложения",
    "XiTongQuanXian": "Системные разрешения",
    "JianCeXinBanBen": "Проверить новую версию",
    "QingXuanZeDengJiRen": "Пожалуйста, выберите заявителя",
    "GongSiYuanGongZhangHao": "Аккаунт сотрудника компании",
    "ZhangHaoRenZhengBuTongGuo": "Не удалось подтвердить аккаунт",
    "ZhangHaoRenZhengZhong": "Аккаунт на проверке",
    "ChaKanRenZhengXinXi": "Просмотр информации о сертификации",
    "QingShuRuSouSuoNeiRong": "Пожалуйста, введите содержимое для поиска",
    "NinYiJingShiZuiXinDeBanBe": "Вы уже используете последнюю версию",
    "SouTuJieGuo": "Результаты поиска",
    "DianJiKeQieHuanSouTuZhuTi": "Нажмите, чтобы переключить объект поиска изображения",
    "ShouDongKuangXuanZhuTi": "Ручной выбор основного объекта",
    "LiKeDengLu": "Войти немедленно",
    "ZhengZaiShangChuan": "Загрузка",
    "XuanZeXiGuanDeYuYan": "Выберите предпочитаемый язык",
    "SheZhiChengGong": "Успешно настроено",
    "YiXuanZeNGeLeiMu": "Выбрано {0} категорий",
    "ZhongXinRenZheng": "Повторная аутентификация",
    "QingDengDaiPingTaiRenZhen": "Пожалуйста, дождитесь подтверждения платформы",
    "AnZhengXiangChuHuo": "Отгрузка полным контейнером",
    "YiXuanZeNGe": "Выбрано {0}",
    "ShangChuanShuiDanXinXi": "Загрузить информацию о платеже",
    "LeJieDingJinMoShi": "Узнайте о модели депозита ESSA",
    "GuDingBaoZhengJinEDu": "Фиксированная гарантийная квота",
    "DingDanChuHuoHouTuiHaiEDu2": "Квота возвращается после отгрузки заказа",
    "LeJieOAEDu": "Узнать о квоте OA",
    "XuanZeKeHuJingLi": "Выбрать менеджера по работе с клиентами",
    "PingTaiMaiShou": "Менеджер по работе с клиентами",
    "GongSiYiCunZaiShiFouYaoJi": "Компания уже существует, хотите ли вы присоединиться к существующей компании?",
    "TongYiJiaGongSiKeYi": "Одна и та же компания может",
    "GongYongDiZhi": "Общий адрес",
    "GongYongZhiFu": "Общий платеж",
    "GongYongHeTong": "Общий контракт",
    "JiaRuYiYouGongSi": "Присоединиться к существующей компании",
    "QingXuanZeLianXiFangShi": "Пожалуйста, выберите способ связи",
    "YuanGongZhangHaoXinXi": "Информация о сотруднике",
    "TianJiaLianXiFangShi": "Добавить контактную информацию",
    "QingTianXieDianZiYouXiang": "Пожалуйста, введите адрес электронной почты",
    "QueRenNinShiZhenRen": "Подтвердите, что вы человек.",
    "XinJianShouHuoRenXinXi": "Добавить новую информацию получателя",
    "XinJianWuLiuGongSiXinXi": "Добавить информацию о логистической компании",
    "DingDanShangPinChuLiZhong": "Заказ обрабатывается, проверьте позже",
    "QingShuRuLianXiFangShi": "Введите контактную информацию",
    "DianJiYanZhengZhenRenJiKe": "Click to verify a real person for access",
    "ZhiShaoBaoHanNGeZiFu": "Должно содержать не менее {0} символов",
    "BaoKuoZiMuHeShuZi": "Включая буквы и цифры",
    "YouHuiQuanMa": "Код купона",
    "QingShuRuYouHuiQuanMa": "Пожалуйста, введите код купона",
    "GongSiXingZhi": "Тип компании",
    "GongSiZhangHaoXinXi": "Информация о корпоративном счете",
    "QingXuanZeYiXiangCaiGouSh": "Пожалуйста, выберите основные категории закупок, не более пяти.",
    "QingXuanZeGongSiXingZhi": "Пожалуйста, выберите тип компании",
    "QingXuanZeQingGuanFangShi": "Пожалуйста, выберите тип растаможки",
    "QingXuanZeZhuYaoXiaoShouQ": "Пожалуйста, выберите основной регион продаж",
    "TiaoGuo": "Пропустить",
    "ZhongGuoPiFaShiChang2": "КИТАЙСКИЙ ОПТОВЫЙ МАРКЕТПЛЕЙС",
    "WoMenZhiZuoPiFaBuZuoLingS": "Мы работаем только с юридическими лицами и индивидуальными предпринимателями. Только оптовая закупка, нет розницы.",
    "XiuGaiShouJiHaoMa": "Изменить номер телефона",
    "XiuGaiDianZiYouXiang": "Изменить адрес электронной почты",
    "QingShuRuDianZiYouXiang": "Пожалуйста, введите ваш адрес электронной почты",
    "XuanZeChengShi": "Выберите регион",
    "XuanZeDiQuYouZhuYuWoMenJi": "Укажите населенный пункт. Это позволит нам рассчитать цены.",
    "QingXuanZeZhuYaoCaiGouPin2": "Пожалуйста, выберите основные категории закупок",
    "GongSiXingZhiWeiShiChangP": "Тип компании - рыночная оптовая торговля, и тип таможенной очистки не может быть \"официальным оформлением\".",
    "ZhangHaoShenQingJiaRuGong": "Заявка на регистрацию в компанию {0}",
    "FaSongShiBai": "Отправка не удалась",
    "GongSiXingZhiZanBuZhiChiX": "Тип компании в данный момент не может быть изменен. Пожалуйста, свяжитесь с службой поддержки, если нужно внести изменения.",
    "QingGuanFangShiZanBuZhiCh": "Тип оформления таможенной очистки в данный момент не может быть изменен. Пожалуйста, свяжитесь с службой поддержки, если нужно внести изменения.",
    "ZhuCeChengGongNiDeZhangHa": "Регистрация завершена! Ваш аккаунт: <a href=\"mailto:{0}\">{0}</a>",
    "WeiBaoZhangYongHuDeZhangH": "<div>1.Чтобы обеспечить безопасность аккаунта клиента и удобство коммуникации, мы отправили вам письмо на электронный адрес. Для подтверждения аккаунта нажмите на ссылку в этом письме. </div> <div>2. Менеджер клиентского сервиса свяжется с вами в течение 48 часов и поможет найти нужный товар по выгодной цене! </div>",
    "ShenMeShiESSAONE2": "Об ESSAONE",
    "XinRenZhuanQu": "Скидка для новичков",
    "QiTaLianXiFangShiBuNengZh": "Другие контактные данные не могут быть дублированы или оставлены пустыми.",
    "ShouCiXiaDanJinXuZhiFuDeD": "Депозит первого заказа 10%!",
    "DianZiYouXiangYongHuZhang": "адрес e-mail/аккаунт пользователя",
    "XiuGaiHuoYanZhengYouXiang": "изменить или подтвердить e-mail",
    "YouXiangYiChengGongJieSho": "Письмо уже доставлено на адрес e-mail, но клиент еще не подтвердил",
    "YouXiangDiZhiWuXiao": "Адрес электронной почты недействителен",
    "YouJianFaSongShiBai": "Ошибка при отправлении письма",
    "WeiZhi": "неизвестно",
    "KeHuYuYan": "язык клиента",
    "NiDeYouXiangYiYanZhengChe": "Ваш адрес e-mail подтвержден!",
    "WoMenChengNuoBuHuiXiangNi": "Мы обещаем не присылать огромное количество писем и будем отправлять Вам только важные новости о работе площадки, проводимых акциях, а также подборки новинок и трендов.",
    "ZhiShaoGeZiFuZiMuYuShuZiZ": "нужно 8 символов (латиница+цифры), только цифры нельзя",
    "SouSuoKeHuMingChengBianHa2": "поиск клиента по имени/номеру/телефону/e-mail",
    "YouXiangYiZhi": "Адрес e-mail не менялся, нужно изменить",
    "YouXiangYiBianGeng": "Адрес e-mail изменен",
    "GaiLianJieYiBieShiYong": "Данная ссылка уже использована",
    "ZiJiGenJinDeKeHuCaiNengQuXiaoGenJin": "Только клиенты, с которыми вы лично взаимодействуете, можете отменить дальнейшее отслеживание.",
    "TuiGuangQuDao": "Каналы регистрации",
    "TuiGuangQuDaoLaiYuan": "Источник",
    "XinYongTiXiJiangGenJuDing": "Кредитная система ESSACHINA будет периодически оценивать и обновлять ваш кредитный статус на основе выполнения заказов. Начальный балл составляет 90 очков.",
    "PingFenLaiYuanYuYeWuJingL": "Оценки основаны на реальных отзывах клиентов, которым оказывал услуги менеджер. Вы можете выбрать менеджера, основываясь на оценках его языковых навыков, отношения к клиентам, времени реакции на проблемы и способности их решать в этих четырех категориях.",
    "EDuYongYuDingDanChuHuoDeD": "OA-кредитный лимит используется в качестве залога для обеспечения отправки заказов, и соответствующий депозит будет вычтен после отгрузки. Доступный лимит = сумма кредитного обеспечения - заблокированная часть. Текущий баланс можно использовать для дальнейшего обеспечения заказов.",
    "ZongHe": "Все категории",
    "QingXuanZeGanXingQuDeLeiM": "Выберите интересующие категории",
    "ShenQingJiaRuGongSi": "Подать заявку на вступление в компанию",
    "XinBanBenShengJi": "Обновление до новой версии",
    "GengXinNeiRong": "Содержание обновления",
    "LiJiGengXin": "Обновить сейчас",
    "ZhengZaiXiaZaiYingYong": "Загрузка",
    "JinDu": "Прогресс",
    "YiMingYongHuZhengZaiShenQ": "Пользователь подает заявку на вступление в вашу компанию",
    "NinKeYiPiZhunHuoJuJueGaiQ": "Вы можете одобрить или отклонить запрос",
    "order_pay_shipment": "Оплата и отправка",
    "order_status_change": "Обновление статуса заказа",
    "order_abnormal": "Уведомление о неисправностях заказа",
    "system_salesman_change": "Изменение консультанта по продажам",
    "system_account_change": "Изменение информации аккаунта",
    "system_other": "Другие системные уведомления",
    "XiaoXiSheZhi": "Настройки сообщений",
    "WeiXinTongHao": "Один и тот же номер в WeChat",
    "WhatsAppTongHao": "Один и тот же номер в WhatsApp",
    "GongNengKaiFaZhong": "Функция в разработке",
    "TiGaoSouTuJingZhunXiaoJiQ": "Повышение точности поиска",
    "ChaKanKeXiaDanDeShangPin": "Просмотр доступных товаров для заказа.",
    "QuLianXi": "Свяжитесь немедленно.",
    "QingLianXiNinDeKeHuJingLi": "Пожалуйста, свяжитесь с вашим менеджером.",
    "NinXianZaiXuYaoCaiGouShan": "Вам нужно приобрести товар сейчас? Пожалуйста, свяжитесь с вашим менеджером для помощи в оформлении заказа.",
    "XiTong": "Система",
    "MeiYouGengDuoShangPin": "Больше нет продуктов",
    "RenGongGaiJiaFuLiRun": "Отрицательная прибыль",
    "1059PR10020": "Дублирование названия покупателя",
    "QingTianXieZhengQueTianSh": "Please fill in the number of days correctly",
    "QingShuRuDaYuDeTianShu": "Please enter a number of days greater than {0}",
    "GaiJiaGeYouXiaoQi": "Price validity period",
    "ZaiQianXiaDanYiGaiJiaGeWe": "Orders placed before {0} will be based on this price",
    "GongChangZhangJiaXianChuL": "Factory price increase",
    "GongChangZhangJiaLeYaoXia": "Factory price increase",
    "GongChangCaiGouJiaXunHou": "Factory‘s price(after inquiry)",
    "GongChangCaiGouJia": "Factory‘s price",
    "RangLiHouCaiGouJia": "Discounted factory price",
    "YongYuJiSuanChengJiaoJia": "Calculate price",
    "XunHouYouZhangJiaXianChuL": "abnormal",
    "XunHou": "after inquiry",
    "XunQian": "before inquiry",
    "GaiJia": "Change price",
    "ChengJiaoJiaZhangJiaHou": "Transaction price",
    "GongChangCaiGouJiaZhangJi": "Factory‘s price",
    "DangAnJia": "Factory’s price",
    "DangNiShiYongShiHuiZaiShi": "При использовании приложения ESSACHINA будет запрашиваться доступ к альбому, камере и хранилищу для поиска товаров через изображения или обновления информации профиля. Разрешить?",
    "PaiZhao": "Сделать фото",
    "CongXiangCeXuanZe": "Выбрать из альбома",
    "QingXianShanChuSuoYouDeZi": "Пожалуйста, отмените все субаккаунты перед отменой основного аккаунта!",
    "QueDingZhuXiaoZhangHao": "Вы уверены, что хотите отменить свой аккаунт?",
    "YiTongZhiKeHu": "Клиенты были уведомлены",
    "TieZhiShenHe": "Проверка стикера",
    "TiJiaoQueRenShiJian": "Время подачи",
    "GaiDingDanShangPinTieZhiY": "Стикеры для товаров по данному заказу уже подтверждены",
    "XiuGaiTieZhi": "исправить стикер",
    "QueRenShiJian": "Время подтверждения",
    "TieZhiMoBan2": "Шаблон стикера",
    "XiuGaiShuoMing": "Пояснения к исправлениям",
    "QingShuRuMiaoShuBenCiYaoX": "请输入描述本次要修改的贴纸内容 – Пожалуйста, введите информацию, которую нужно внести в стикер:",
    "JieTuShuoMing": "Пояснить с помощью скриншота",
    "XiuGaiLeiXing": "Исправить тип",
    "XuanZeShangPinTianXieTeSh": "Выбрать товар и и заполнить производственные характеристики",
    "RuNinDuiDingDanHuoDingDan": "Если есть особые требования к товару, пожалуйста точно их опишите. Возможно, это цвет товара, определенная модель, аксессуары, функции и т.п.",
    "DingDanYaoQiuBeiZhu": "Требования к заказу (примечание)",
    "MeiYouXiuGaiXiang": "Без изменений",
    "QueRen": "Подтвердить",
    "ZhuYiDuiDingDanHuoDingDan": "Обратите внимание: есть особые требования к товару, пожалуйста точно их опишите. Возможно, это цвет товара, определенная модель, аксессуары, функции и т.п.",
    "KeHuDuiDingDanHuoDingDanZ": "У клиента есть особые требования к товару, пожалуйста точно их опишите. Возможно, это цвет товара, определенная модель, аксессуары, функции и т.п.",
    "TianXieYiBaoCunChengGong": "Успешно сохранено",
    "ShengChanZhuangTai": "Статус производства",
    "ZhiDingTiaoXingMa": "Указать штрих-код для товара",
    "YiXiuGaiZaiQueRen": "Изменено и подтверждено",
    "ZhiDingShangPinTiaoXingMa": "Указать штрих-код для товара",
    "QingShuRuMiaoShuLiRuShang": "Пожалуйста, введите описание. Например: цвет товара, модель, сопутствующие функции и др.",
    "DingDanYiJingZaiShengChan": "Данный заказ уже в производстве, добавить новые требования нельзя",
    "ZhiDingShangPinTiaoMa": "Указать штрих - код товара",
    "ShenQingXiaZai": "Запросить скачивание",
    "TuPianKeDaoChu": "Фотографии можно экспортировать",
    "ShenQingXiaZaiZhongQingNa": "Запрос на скачивание обрабатывается, пожалуйста, подождите 1-3 минуты",
    "DaiZhuangJuRenYuanShangCh": "Ожидание загрузки фотографий сотрудниками по погрузке",
    "DaiChuanWuQueRenHouXiaZai": "Скачать после подтверждения отдела судоходства",
    "XiaZaiZhuangXiangDan": "Скачать упаковочный лист",
    "ZhaoYangLeiXing": "Тип поиска образца",
    "GenJuShiJiZhaoYangXuQiuXu": "Выберите тип поиска образца в соответствии с фактическими потребностями.",
    "QingXuanZeZhaoYangLeiXing": "Пожалуйста, выберите тип поиска образца.",
    "KeHuYouTiGongZhaoYangZiLi": "Клиент предоставил материалы для поиска образцов, которые необходимо загрузить, чтобы сохранить исходные данные.",
    "XiaZaiQuanBu": "Скачать всё",
    "YuShangChuan": "{0} загрузил изображение {1}",
    "YiZhaoWang": "Нашли",
    "XiangYouHuaDongTianChongP": "Проверка подлинности с помощью слайд-пазла",
    "DianJiJinRu": "Нажмите для входа",
    "BuGenJin": "Not following up",
    "ShangPinDangAnJia": "Фабричные цены",
    "ChanQianYang": "Пренатальный образец",
    "PiLiangXiaZai": "Загрузка пакетов",
    "FuZhiXiaZaiLianJie": "Копировать загрузить ссылку",
    "PiLiangXiaZaiHouCaiShengC": "после скачивания группы/партии можно будет получить ссылку для копирования",
    "GaiJiaGe": "Изменить цены",
    "ShangChuanPIDan": "Загрузить PI лист",
    "ShangChuanPIWenJian": "Загрузить PI документ",
    "ShangChuanWenJianZhiChiTu": "Загрузить документ, прикрепить изображение/ PDF/Excel",
    "ShuiDan": "Платежный документ",
    "QingShuRuZengZhiShuiLv": "Введите НДС.",
    "AIZhiXuan": "AI-поиск",
    "SiKaoZhong": "Думаю...",
    "FenXiTuiDaoGuoCheng": "Анализ процесса рассуждений",
    "FenXiNinDeXuQiu": "Анализ ваших требований",
    "NinSouSuoDeNeiRong": "Ваш поисковый запрос",
    "SouSuoGuanJianCiTuiJian": "Рекомендуемые ключевые слова для поиска",
    "ShaiXuanTuiJian": "Отфильтрованные рекомендации",
    "NiShiYaoCaiGouDeShangPin": "Товар, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinQiDingLiang": "Минимальный объем заказа на товар, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinBaoZhuangYuYan": "Язык упаковки товара, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinBaoZhuangLeiXing": "Тип упаковки товара, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinHuoQi": "Срок поставки товара, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinJiaGe": "Цена товара, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinBiaoQian": "Этикетка товара, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinCaiZhi": "Материал товара, который вы хотите закупить",
    "NiShiYaoCaiGouDeShangPinZhengShu": "Сертификат товара, который вы хотите закупить",
    "SouSuoShangPinJieGuo": "Сертификат товара, который вы хотите закупить",
    "ShaiXuanYouXiaoXinXi": "Фильтрация релевантной информации",
    "FenXiNinDeXuanPinPianHaoH": "Анализ ваших предпочтений в выборе товаров и фоновой информации",
    "ChengGongZhuCe": "Успешная регистрация",
    "GenJinZhong": "В процессе",
    "GenJinShiBai": "Не договорились",
    "LaiYuanQuDao": "来源渠道",
    "ChengJiaoYiXiangDengJi": "Уровень заинтересованности в регистрации",
    "KeHuLaiYuan": "Откуда поступил клиент",
    "ChengRenYongPin": "Товары для взрослых",
    "QueRenNinDeNianLing": "Подтвердите свой возраст",
    "CiShangPinJinShiYongYuNia": "Данный раздел предназначен только для посетителей, достигших возраста 18 лет!",
    "ShiDeWoYiNianManSui": "Да, мне есть 18 лет",
    "BuShi": "Нет",
    "QingMiaoShuNiDeXuQiu": "Опишите, что вам нужно, например: Игрушки для развития ума, продаваемые через электронную коммерцию",
    "XinKaiHuiHua": "Новый чат",
    "KaoLvZhongZanBuNengXinKai": "Идёт обработка, сейчас нельзя открыть новый диалог",
    "TieZhiTuBiao": "иконка стикера",
    "XuanZeTieZhiTuBiao": "Выбор значка стикера",
    "ShiFouQiangZhiBiaoJi": "«Честный знак»",
    "ShangPinXinXiYouXiuGaiXuZ": "Информация о товаре изменена, требуется повторная подача заявки",
    "QingXuanZeShangPinFenLei": "Пожалуйста, выберите категорию товара",
    "FaqTitle": "Честный Знак — Частые вопросы | ESSAONE",
    "FaqTitleInfo": "Маркировка «под ключ»: получение кодов, печать/нанесение, законное таможенное оформление и передача данных в ЦРПТ через ОФД. Категории: игрушки, велосипеды, одежда и аксессуары для взрослых, часть домашнего текстиля и др. Для клиентов ESSAONE с договором и заказом — оформление и маркировка бесплатно.",
    "FaqIssue1": "Что такое Честный Знак и зачем он нужен при импорте?",
    "FaqAnswer1": "Честный Знак — государственная система маркировки и прослеживаемости (ЦРПТ). Для ряда категорий (одежда/текстиль, игрушки, обувь и др.) маркировка и передача данных обязательны при импорте и продаже.",
    "FaqIssue2": "Какие услуги «под ключ» оказывает ESSAONE?",
    "FaqAnswer2": "Получение кодов → печать/нанесение (маркировка) → законное таможенное оформление → передача данных в ЦРПТ через ОФД → комплект сопроводительных и сверочных документов.",
    "FaqIssue3": "Какие категории сейчас покрываем?",
    "FaqAnswer3": "Игрушки, велосипеды,одежда и аксессуары для взрослых, часть домашнего текстиля (полотенца/фартуки и т.п.); детская одежда и аксессуары — в процессе подключения.",
    "FaqIssue4": "В чём разница между EAC и Честным Знаком?",
    "FaqAnswer4": "EAC отвечает за соответствие техрегламентам (сертификация/декларация), Честный Знак — за маркировку и прослеживаемость. ESSAONE помогает по обоим направлениям.",
    "FaqIssue5": "Где лучше наносить маркировку — в Китае или в России?",
    "FaqAnswer5": "Рекомендуем наносить в Китае на этапе производства и сопровождать груз необходимыми документами для таможни — это обеспечивает сквозную прослеживаемость и ускоряет оформление.",
    "FaqIssue6": "Какие документы и информация нужны от покупателя?",
    "FaqAnswer6": "Реквизиты компании (ИНН/ОГРН) и информация о контактное лицо; для срочных партий — перечень SKU и макеты упаковки (по возможности).",
    "FaqIssue7": "Сроки и стоимость?",
    "FaqAnswer7": "Подготовка обычно 2–5 рабочих дней, маркировка на складе — 1–3 дня. Процедура добавляет сроки и трудозатраты; для клиентов ESSAONE с договором и заказом на платформе оформление и маркировка бесплатны (в пределах согласованных условий).",
    "FaqIssue8": "Как передаются данные в систему?",
    "FaqAnswer8": "Через подключённого оператора/ОФД/ЦРПТ; после передачи доступны подтверждения и сверочные документы в кабинете.",
    "FaqIssue9": "Чем грозит отсутствие обязательной маркировки?",
    "FaqAnswer9": "Штрафами и ограничением оборота товара. Совместная работа с ESSAONE снижает риски и обеспечивает соответствие законодательству.",
    "FaqIssue10": "Как начать?",
    "FaqAnswer10": "Заключите договор с ESSAONE и оформите заказ на платформе (с предоплатой); остальное мы берём на себя.",
    "FaqIssue11": "Контакты",
    "FaqAnswer11": "Tel: 8-800-550-3301 | WhatsApp: +7-925-949-1117 | Telegram: +7-925-703-1115 | Email: service@essaone.com",
    "CaiWuDaiBan": "Финансовые задачи",
    "ZiJinHeXiao": "Списание средств",
    "TuiKuanChuLi": "Обработка возврата",
    "TuiHuiQianBaoJiLu": "История возвратов в кошелёк",
    "YongYuWoMenLianXi": "Написать или позвонить",
    "KeHuZiJinMingXi": "Детализация средств клиента",
    "Jia": "Плюс / Добавить",
    "Jian2": "Минус / Вычесть",
    "QianBaoYuE": "Баланс кошелька",
    "ZanBuTiXian": "Временно не выводить",
    "NiTiJiaoDeTiXianShenQingJ": "Ваша заявка на вывод средств будет переведена в течение 3 рабочих дней после одобрения",
    "XuanZeShouKuanYinXingKa": "Выберите банковскую карту для получения средств",
    "TiXianJinE": "Сумма вывода",
    "DangQianQianBaoQuanBuYuE": "Текущий полный баланс кошелька {0}",
    "QuanBuTiXian": "Вывести всё",
    "XinZengShouKuanYinXingKa": "Добавить новую банковскую карту для получения",
    "TianXieYinXingKaHao": "Введите номер банковской карты",
    "TuiKuanLeiXing": "Тип возврата",
    "ShouKuanXinXi": "Платёжные реквизиты",
    "TuiKuanDengJi2": "Регистрация возврата",
    "DengJiWanCheng": "Регистрация завершена",
    "JiKeHuHuiKuanHouJiangFuKu": "После перевода средств клиенту загрузите платёжное подтверждение в систему для просмотра клиентом.",
    "WanChengDengJi": "Завершить регистрацию",
    "ChaKanQueRen": "Просмотреть и подтвердить",
    "GaoFengXianDingDan": "Заказ высокого риска",
    "RuKuTianShu": "Дней на складе",
    "KeHuBuXiangYaoLe": "Клиент больше не хочет",
    "KeHuHaiYao": "Клиент ещё хочет",
    "KeHuFangQiHuoWu": "Клиент отказывается от товара",
    "KeHuFangQiHuoWuCiCaoZuoJi": "Клиент отказывается от товара. При этом операция не предусматривает возврат средств, а товар переводится в товарные запасы. Подтверждаете ли вы отказ от товара?",
    "HuoQuanGenJin": "Контроль права собственности на товар",
    "DaiFuKuan2": "Ожидает оплаты",
    "KeHuFangQi": "Отказ клиента",
    "QueRenChanPinPoSunQingKua": "Подтвердить состояние повреждения товара",
    "GongNPcs": "Всего {0} шт.",
    "JiangZiDongZhuanKuCunShan": "Будет автоматически переведено в товарные запасы и пересчитано в коробки.",
    "TuiKuanDanZheng": "Документы на возврат",
    "YiPeiChang": "Компенсировано",
    "ZhenDuiPoSunDeQingKuangJi": "Зарегистрируйте случай повреждения. После подачи регистрации сотрудник отдела продаж или службы поддержки согласует с клиентом способ компенсации.",
    "ShuRuPoSunDeShangPinBianM": "Введите код повреждённого товара",
    "PoSunChanPinShuLiangKeHuG": "Количество повреждённых товаров (Клиент купил всего {0} коробок ｜ {1} шт.)",
    "PoSunYuanYin": "Причина повреждения",
    "YiRuKuTian": "На складе уже {0} дней",
    "BuTuiKuan": "Без возврата",
    "XuTuiKuan": "Требуется возврат",
    "YinXing": "Банк",
    "GongSi": "Компания",
    "KaHao": "Номер карты",
    "ZhuCeHouCaiGouLianXiGongC": "Получите оптовые цены из Китая без посредников",
    "ShouKuanGongSi": "Компания-получатель",
    "ZhiNengHuiKuanDaoQianDing": "Перевод возможен только на юрлицо, с которым заключён договор.",
    "QingXianXinZengHeTong": "Сначала добавьте договор",
    "ZiXunGuWen": "Консультация",
    "QingShuRuTiXianJinE": "Введите сумму для вывода",
    "QingXuanZeWenJian": "Выберите файл",
    "GaiBiTuiKuanBuXuYaoTuiKua": "Данный возврат не требует перечисления средств клиенту.",
    "QingQueRenZaiCaiWuXiTongZ": "Пожалуйста, подтвердите, что обработка в финансовой системе завершена.",
    "PoSunChanPinShuLiang": "Количество повреждённых товаров",
    "KeHuGouMaiGongXiang": "Клиент купил всего {0} коробок ｜ {1} шт.",
    "PoSunShangPinShuLiang": "Количество повреждённых товаров",
    "ZhengChangShangPinShuLian": "Количество неповреждённых товаров",
    "PingZhengJiShuoMing": "Подтверждающие документы и пояснения",
    "TiJiaoShouHouChuLi": "Отправить в службу послепродажного обслуживания",
    "PoSunChanPinXiangShu": "Количество коробок с повреждённым товаром",
    "HuiKuanJiaoCheng": "Инструкция по переводу",
    "ShouXuMaFanDengDaiCaiWuSh": "Процедура сложная. Ожидайте перевода после одобрения финансовым отделом.",
    "KeHuBianHaoMingCheng": "Код клиента / Название",
    "PoSunChanPinShuLiangBuNen": "Количество повреждённых товаров не может превышать количество коробок.",
    "WeiHuiKuan": "Не переведено",
    "AnPoSunShuLiangPeiChang": "Компенсация по количеству повреждённых единиц",
    "AnZhengXiangPeiChang": "омпенсация за целую коробку",
    "QingXuanZeShouHouFangAn": "Выберите вариант послепродажного обслуживания",
    "QingXuanZePeiChangChuLi": "Выберите способ обработки компенсации",
    "QingZaiCaiWuXiTongChuLiHo": "Завершите операцию после обработки в финансовой системе. Данный возврат не требует перечисления средств клиенту.",
    "YinXingKaHaoGeShiYouWu": "Неверный формат банковской карты",
    "QingLianXiKeHuChaKanNinHe": "Завершите операцию после обработки в финансовой системе. Данный возврат не требует перечисления средств клиенту.",
    "ShouDan10DingJin": "10% депозит за первый заказ, чем больше покупаешь, тем больше скидок получаешь.",
    "QingShuRuJuHao": "Номер контейнера",
    "KuCunShuLiang": "Количество на складе",
    "QingCangTeMaiJiaGeYouHui": "Очень выгодные цены на распродаже",
    "DingZhiTiaoMa": "Индивидуализация штрих-кода",
    "TiaoXingMaShiYongShuoMing": "Инструкция по настройке штрих-кода",
    "ShangPinTiaoXingMaDingZhi": "Инструкция по настройке штрих-кода",
    "DingZhiTiaoMaJiangTiHuanQ": "Индивидуальные штрих-коды заменят оригинальные штрих-коды продуктов на этикетках таможенного оформления.",
    "DingZhiFuWuPeiZhi": "Настройка услуг по индивидуальному заказу",
    "XuanZeBaoZhuangFuWu": "Выберите услуги упаковки",
    "XiTongJiangGenJuShangPinC": "Система автоматически подберет модель в зависимости от размера товара",
    "DangQianXuanZe": "Текущий выбор",
    "TiaoMaDingZhi": "Индивидуальный штрихкод",
    "DingZhiTiaoMaShuoMing": "Инструкция по заказу индивидуального штрихкода",
    "ShangChuanTiaoMa": "Загрузить штрихкод",
    "ShuRuTiaoMa": "Ввести штрихкод",
    "YiKuanDuoTiaoMa": "SKU с мультиштрихкодом",
    "YunFeiJiaShou": "Доп. за доставку",
    "XiaoHao": "Маленький",
    "ZhongHao": "Средний",
    "DaHao": "Большой",
    "GenJuShangPinPiPeiXuShiYo": "Модель под товар",
    "BaoZhuangFuWu": "Fulfillment",
    "MESSAONEHomeTitle": "Оптовые поставки из Китая, ЕАС и Честный знак под ключ | ESSAONE",
    "MESSAONEHomeDescription": "ESSAONE: прямые поставки из Китая — игрушки/Кухонные товары/канцелярия/детские товары оптом; помощь с Честным знаком и растаможкой.",
    "FufilmentKey2": "Fulfillment-услуги",
    "QiTaYaoQiuShuoMing": "Другие требования / Особые указания",
    "YuGu": "Расчетная стоимость",
    "ShangPinDeFaHuoFangShiShi": "Товар отправляется напрямую из Китая; услуги fulfillment в данный момент недоступны.",
    "ShangPinZengJiaEWaiBaoZhu": "Добавочная упаковка увеличивает объем посылки, что может привести к дополнительному сбору за доставку из-за объемного веса.",
    "RuoNinXuYaoJiangCaiGouDeS": "<div><div class=\"mb_6\">Мы наносим штрих-коды SKU для WB, Ozon и других маркетплейсов до отправки товара из Китая. Берём всю маркировку на себя.</div>  <div class=\"mb_6\">Что нужно от вас:</div> <div class=\"mb_6\">    1.Сформировать штрих-коды в личном кабинете WB/Ozon (PDF / изображение / данные кода).</div> <div class=\"mb_6\">    2.Загрузить файл на платформу ESSAONE.</div>  <div class=\"mb_6\">Как это работает:</div></div> <div class=\"mb_6\">    •\tID-код и код «Честный знак» объединяются в одну наклейку.</div> <div class=\"mb_6\">    •\tПри подключении Fulfillment стикеры наносятся:</div>  <div class=\"mb_6\">— на упаковку товара;</div> <div class=\"mb_6\">— на внешнюю коробку.</div>  <div class=\"mb_6\">Маркировка под ключ — товар поступает в РФ полностью готовым к отгрузке на WB и Ozon, без переклейки и повторной печати.</div>  <div class=\"mb_6\">Важно!</div> <div class=\"mb_6\">Если один SKU имеет разные цвета или модели с разными штрихкодами (микс), необходимо указать соответствие: какой код — к какому товару.</div>",
    "TiaoMaDingZhiShuoMing": "Маркировка и “Честный знак” под ключ",
    "QingGuanTieZhiYangLi": "Образец наклейки для таможенного оформления",
    "BenDanShiYongJiFenDiKou": "По данному заказу списано {0} баллов на сумму {1}",
    "ChaKanPiFaJiaGe": "Проверить оптовые цены заводов",
    "KeHuDuiDingDanHuoDingDanZ2": "Если у клиента есть особые пожелания к заказу или к любому товару в заказе, пожалуйста, четко укажите их. Эти пожелания могут касаться цвета товара, выбора модели, функций аксессуаров и других аспектов.",
    "ShenQingXiaZaiTieZhiWenJi": "Запросить загрузку файла стикеров",
    "TieZhiWenJianShengChengZh": "Создание файла стикеров",
    "TieZhiWenJianKeXiaZai": "Файл стикеров доступен для загрузки",
    "TieZhiWenJian": "Файл стикеров",
    "ZhongXinShengCheng": "Обработка маркировки",
    "ChuLiChengShiBiaoZhiZhong": "Обработка маркировки...",
    "KeHuYouHuiQuan": "Клиентский купон",
    "KeDiKou": "К списанию",
    "NDeJiFen": "Баллы {0}",
    "TieZhiWenJianShengChengSh": "Ошибка создания файла стикеров",
    "HuoQuJiaGe": "Получить цены"
}
 export default lang;